/* 这个文件是 tools/gen-copy.mjs 生成的，不要手改。
   改文案请改 docs/copy/*.yaml，改规则请改 tools/copy-lint/rules.json，然后跑 make generate-copy。 */

import type { Template } from './types.js'

/**
 * 每条模板要哪些变量。render() 的第二个参数就按这张表定型：
 * 漏一个是类型错误，多一个也是（对象字面量的多余属性检查）。
 */
export interface CopyVarMap {
  "account.billing.empty.honest": Record<string, never>
  "account.devices.admin_note": Record<string, never>
  "account.devices.current": Record<string, never>
  "account.devices.empty": Record<string, never>
  "account.devices.heading": Record<string, never>
  "account.devices.hint": Record<string, never>
  "account.devices.last_used": { "when": string }
  "account.devices.method.bootstrap": Record<string, never>
  "account.devices.method.email_code": Record<string, never>
  "account.devices.method.local_ai": Record<string, never>
  "account.devices.method.passkey": Record<string, never>
  "account.devices.method.password": Record<string, never>
  "account.devices.method.recovery_code": Record<string, never>
  "account.devices.method.unknown": Record<string, never>
  "account.devices.name": { "browser": string; "os": string }
  "account.devices.name.os_only": { "os": string }
  "account.devices.name.unknown": Record<string, never>
  "account.devices.revoke.confirm.body": Record<string, never>
  "account.devices.revoke.confirm.title": Record<string, never>
  "account.devices.revoke.cta": Record<string, never>
  "account.devices.revoke.done": Record<string, never>
  "account.devices.revoke.others.cta": Record<string, never>
  "account.devices.revoke.others.done": { "count": string }
  "account.devices.revoke.others.none": Record<string, never>
  "account.devices.revoke.self": Record<string, never>
  "account.devices.signed_in": { "when": string }
  "account.local_ai.copied": Record<string, never>
  "account.local_ai.copy": Record<string, never>
  "account.local_ai.cta": Record<string, never>
  "account.local_ai.error": Record<string, never>
  "account.local_ai.generating": Record<string, never>
  "account.local_ai.heading": Record<string, never>
  "account.local_ai.hint": Record<string, never>
  "account.local_ai.modal.close": Record<string, never>
  "account.local_ai.modal.description": Record<string, never>
  "account.local_ai.modal.title": Record<string, never>
  "account.paths.email_code": Record<string, never>
  "account.paths.heading": Record<string, never>
  "account.paths.passkey": Record<string, never>
  "account.paths.password": Record<string, never>
  "account.paths.recovery_code": Record<string, never>
  "account.paths.unusable": Record<string, never>
  "account.paths.usable": Record<string, never>
  "account.stepup.body": Record<string, never>
  "account.stepup.cancel": Record<string, never>
  "account.stepup.code.label": Record<string, never>
  "account.stepup.code.resend": Record<string, never>
  "account.stepup.code.send": Record<string, never>
  "account.stepup.code.sent": { "email": string }
  "account.stepup.confirm": Record<string, never>
  "account.stepup.method.email_code": Record<string, never>
  "account.stepup.method.password": Record<string, never>
  "account.stepup.no_ticket": Record<string, never>
  "account.stepup.none": Record<string, never>
  "account.stepup.password.label": Record<string, never>
  "account.stepup.switch": Record<string, never>
  "account.stepup.title": Record<string, never>
  "account.stepup.working": Record<string, never>
  "activity.action.copy_link": Record<string, never>
  "activity.action.manage_follow": Record<string, never>
  "activity.action.mark_all_read": Record<string, never>
  "activity.actor.lulu": Record<string, never>
  "activity.actor.system": Record<string, never>
  "activity.catalog.copy": Record<string, never>
  "activity.catalog.scene": Record<string, never>
  "activity.catalog.scene.action": Record<string, never>
  "activity.catalog.scene.all": Record<string, never>
  "activity.catalog.scene.disconnected": Record<string, never>
  "activity.catalog.scene.following": Record<string, never>
  "activity.catalog.scene.omitted": Record<string, never>
  "activity.catalog.scene.recovered": Record<string, never>
  "activity.catalog.scene.search": Record<string, never>
  "activity.catalog.scene.unknown": Record<string, never>
  "activity.catalog.subtitle": Record<string, never>
  "activity.catalog.title": Record<string, never>
  "activity.conn.live": Record<string, never>
  "activity.detail.boundary": Record<string, never>
  "activity.detail.close": Record<string, never>
  "activity.detail.continue_lulu": Record<string, never>
  "activity.detail.evidence": Record<string, never>
  "activity.detail.follow": Record<string, never>
  "activity.detail.go_release": Record<string, never>
  "activity.detail.open_session": Record<string, never>
  "activity.detail.open_source": Record<string, never>
  "activity.detail.result": Record<string, never>
  "activity.detail.sidecar_sub": Record<string, never>
  "activity.detail.stages": Record<string, never>
  "activity.detail.unfollow": Record<string, never>
  "activity.detail.view_evidence": Record<string, never>
  "activity.detail.view_impact": Record<string, never>
  "activity.empty.action": Record<string, never>
  "activity.empty.action.title": Record<string, never>
  "activity.empty.all": Record<string, never>
  "activity.empty.all.hint": Record<string, never>
  "activity.empty.all.title": Record<string, never>
  "activity.empty.following": Record<string, never>
  "activity.empty.following.hint": Record<string, never>
  "activity.empty.following.quiet.hint": Record<string, never>
  "activity.empty.following.quiet.title": Record<string, never>
  "activity.empty.following.title": Record<string, never>
  "activity.empty.go_chat": Record<string, never>
  "activity.empty.go_projects": Record<string, never>
  "activity.empty.important": Record<string, never>
  "activity.empty.important.title": Record<string, never>
  "activity.empty.list_failed": Record<string, never>
  "activity.empty.list_failed.hint": Record<string, never>
  "activity.empty.ops_alerts": Record<string, never>
  "activity.empty.ops_alerts.title": Record<string, never>
  "activity.empty.projects_failed": Record<string, never>
  "activity.empty.retry": Record<string, never>
  "activity.empty.search": Record<string, never>
  "activity.empty.search.clear_all": Record<string, never>
  "activity.empty.search.clear_filters": Record<string, never>
  "activity.empty.search.hint": Record<string, never>
  "activity.empty.search.title": Record<string, never>
  "activity.excluded.held": Record<string, never>
  "activity.excluded.held.desc": Record<string, never>
  "activity.excluded.hint": Record<string, never>
  "activity.excluded.retry": Record<string, never>
  "activity.excluded.retry.desc": Record<string, never>
  "activity.excluded.rollback": Record<string, never>
  "activity.excluded.rollback.desc": Record<string, never>
  "activity.excluded.title": Record<string, never>
  "activity.filter.actor": Record<string, never>
  "activity.filter.clear": Record<string, never>
  "activity.filter.hint.project": Record<string, never>
  "activity.filter.hint.results": { "count": string }
  "activity.filter.open": Record<string, never>
  "activity.filter.search": Record<string, never>
  "activity.filter.search.disconnected": Record<string, never>
  "activity.filter.search.project": Record<string, never>
  "activity.filter.status": Record<string, never>
  "activity.filter.time": Record<string, never>
  "activity.filter.time.earlier": Record<string, never>
  "activity.filter.time.today": Record<string, never>
  "activity.filter.time.week": Record<string, never>
  "activity.filter.time.yesterday": Record<string, never>
  "activity.filter.type": Record<string, never>
  "activity.follow.auto.tag": Record<string, never>
  "activity.follow.auto.title": Record<string, never>
  "activity.follow.manual.tag": Record<string, never>
  "activity.follow.manual.title": Record<string, never>
  "activity.follow.object.agent": Record<string, never>
  "activity.follow.object.project": Record<string, never>
  "activity.follow.object.resource": Record<string, never>
  "activity.follow.object.site": Record<string, never>
  "activity.follow.object.task": Record<string, never>
  "activity.follow.source.assigned": Record<string, never>
  "activity.follow.source.auto": Record<string, never>
  "activity.follow.source.joined": Record<string, never>
  "activity.follow.source.manual": Record<string, never>
  "activity.follow.source.started": Record<string, never>
  "activity.follow.table.foot": Record<string, never>
  "activity.gate.entitlement": Record<string, never>
  "activity.gate.needs_info": Record<string, never>
  "activity.gate.question": Record<string, never>
  "activity.gate.recovery_choice": Record<string, never>
  "activity.gate.red_confirm": Record<string, never>
  "activity.group.decide": { "count": string }
  "activity.group.events": { "count": string }
  "activity.group.locked": Record<string, never>
  "activity.group.long": Record<string, never>
  "activity.group.offline": Record<string, never>
  "activity.group.recovered": Record<string, never>
  "activity.group.recovered.meta": Record<string, never>
  "activity.group.single": Record<string, never>
  "activity.group.threads": { "count": string }
  "activity.group.unclosed": Record<string, never>
  "activity.internal.desc": Record<string, never>
  "activity.internal.title": Record<string, never>
  "activity.kind.activity": Record<string, never>
  "activity.kind.ops_alert": Record<string, never>
  "activity.list.load_more": Record<string, never>
  "activity.list.loading_more": Record<string, never>
  "activity.macos.title": Record<string, never>
  "activity.narrow.order.detail": Record<string, never>
  "activity.narrow.order.detail.desc": Record<string, never>
  "activity.narrow.order.detail.pill": Record<string, never>
  "activity.narrow.order.list": Record<string, never>
  "activity.narrow.order.list.desc": Record<string, never>
  "activity.narrow.order.nav": Record<string, never>
  "activity.narrow.order.nav.desc": Record<string, never>
  "activity.narrow.order.nav.pill": Record<string, never>
  "activity.narrow.order.note": Record<string, never>
  "activity.narrow.order.title": Record<string, never>
  "activity.narrow.sidecar_sub": Record<string, never>
  "activity.offline.note.desc": Record<string, never>
  "activity.offline.note.title": Record<string, never>
  "activity.omitted": { "count": string }
  "activity.ops_alert.acknowledge": Record<string, never>
  "activity.overview.see_all": Record<string, never>
  "activity.page.subtitle": Record<string, never>
  "activity.page.subtitle.narrow": Record<string, never>
  "activity.page.subtitle.project": Record<string, never>
  "activity.page.title": Record<string, never>
  "activity.page.title.project": { "project": string }
  "activity.project.name.event2026": Record<string, never>
  "activity.project.name.npcshop": Record<string, never>
  "activity.project.note.desc": Record<string, never>
  "activity.project.note.overview": Record<string, never>
  "activity.project.note.overview.desc": Record<string, never>
  "activity.project.note.title": Record<string, never>
  "activity.project.note.wont": Record<string, never>
  "activity.project.note.wont.desc": Record<string, never>
  "activity.recover.note.desc": Record<string, never>
  "activity.recover.note.title": Record<string, never>
  "activity.scope.all": Record<string, never>
  "activity.scope.all_projects": Record<string, never>
  "activity.scope.label": Record<string, never>
  "activity.scope.pick": Record<string, never>
  "activity.scope.platform": Record<string, never>
  "activity.scope.project": Record<string, never>
  "activity.search.group": Record<string, never>
  "activity.search.meta": Record<string, never>
  "activity.sha.note.desc": Record<string, never>
  "activity.sha.note.title": Record<string, never>
  "activity.sheet.apply": Record<string, never>
  "activity.sheet.clear": Record<string, never>
  "activity.sheet.count": { "count": string }
  "activity.sheet.current": Record<string, never>
  "activity.sheet.event2026.sub": Record<string, never>
  "activity.sheet.npcshop.sub": Record<string, never>
  "activity.sheet.project_search": Record<string, never>
  "activity.sheet.status.bundle": Record<string, never>
  "activity.sheet.sub": Record<string, never>
  "activity.stages.folded": { "count": string }
  "activity.states.col.mean": Record<string, never>
  "activity.states.col.proof": Record<string, never>
  "activity.states.col.status": Record<string, never>
  "activity.states.col.wrong": Record<string, never>
  "activity.states.label": Record<string, never>
  "activity.states.meta": Record<string, never>
  "activity.states.subtitle": Record<string, never>
  "activity.states.tag": Record<string, never>
  "activity.states.title": Record<string, never>
  "activity.status.awaiting_decision": Record<string, never>
  "activity.status.awaiting_dependency": Record<string, never>
  "activity.status.completed": Record<string, never>
  "activity.status.disconnected": Record<string, never>
  "activity.status.failed": Record<string, never>
  "activity.status.platform_held": Record<string, never>
  "activity.status.platform_held.hint": Record<string, never>
  "activity.status.platform_held.no_resubmit": Record<string, never>
  "activity.status.production_verified": Record<string, never>
  "activity.status.queued": Record<string, never>
  "activity.status.recovering": Record<string, never>
  "activity.status.rollback.executed": Record<string, never>
  "activity.status.rollback.registered": Record<string, never>
  "activity.status.rolled_back": Record<string, never>
  "activity.status.running": Record<string, never>
  "activity.status.unknown": Record<string, never>
  "activity.status.unknown.hint": Record<string, never>
  "activity.stream.disconnected": { "time": string }
  "activity.stream.recovered": { "count": string }
  "activity.stream.recovered.deduped": { "count": string }
  "activity.stream.reset": Record<string, never>
  "activity.summary.conversation.created": { "actor": string; "title": string }
  "activity.summary.conversation.waiting": { "title": string }
  "activity.summary.fast_delivery.production_verified": Record<string, never>
  "activity.summary.host.assigned": { "actor": string; "host": string; "project": string }
  "activity.summary.host.unassigned": { "actor": string; "host": string; "project": string }
  "activity.summary.inspection.completed": Record<string, never>
  "activity.summary.project.archived": { "actor": string; "name": string }
  "activity.summary.project.created": { "actor": string; "name": string }
  "activity.summary.task.completed": { "title": string }
  "activity.summary.task.created": { "actor": string; "title": string }
  "activity.summary.task.failed": { "title": string }
  "activity.summary.task.held": { "title": string }
  "activity.summary.task.running": { "actor": string; "title": string }
  "activity.summary.task.waiting": { "title": string }
  "activity.summary.team.joined": { "actor": string }
  "activity.thread.updates": { "count": string }
  "activity.type.conversation": Record<string, never>
  "activity.type.lulu": Record<string, never>
  "activity.type.project": Record<string, never>
  "activity.type.release": Record<string, never>
  "activity.type.resource": Record<string, never>
  "activity.type.site": Record<string, never>
  "activity.type.task": Record<string, never>
  "activity.type.team": Record<string, never>
  "activity.unclosed": Record<string, never>
  "activity.unclosed.hint": Record<string, never>
  "activity.unread": Record<string, never>
  "activity.unread.count": { "count": string }
  "activity.view.action": Record<string, never>
  "activity.view.action.subtitle": Record<string, never>
  "activity.view.all": Record<string, never>
  "activity.view.following": Record<string, never>
  "activity.view.following.subtitle": Record<string, never>
  "activity.view.important": Record<string, never>
  "activity.view.important.subtitle": Record<string, never>
  "ai_os.action.approve_red": Record<string, never>
  "ai_os.action.cancel": Record<string, never>
  "ai_os.action.create": Record<string, never>
  "ai_os.action.disable_learning": Record<string, never>
  "ai_os.action.retry": Record<string, never>
  "ai_os.action.submit": Record<string, never>
  "ai_os.action.submitted": Record<string, never>
  "ai_os.action.submitting": Record<string, never>
  "ai_os.action.view_evidence": Record<string, never>
  "ai_os.conflict.already_submitted": Record<string, never>
  "ai_os.conflict.changed_elsewhere": Record<string, never>
  "ai_os.conflict.same_key_different_content": Record<string, never>
  "ai_os.empty.evaluations": Record<string, never>
  "ai_os.empty.learning": Record<string, never>
  "ai_os.empty.modules": Record<string, never>
  "ai_os.empty.proposals": Record<string, never>
  "ai_os.error.create_failed": Record<string, never>
  "ai_os.error.detail_failed": Record<string, never>
  "ai_os.error.list_failed": Record<string, never>
  "ai_os.error.missing_evidence": Record<string, never>
  "ai_os.error.missing_rollback": Record<string, never>
  "ai_os.error.missing_user_value": Record<string, never>
  "ai_os.error.module_gone": Record<string, never>
  "ai_os.error.red_needs_click": Record<string, never>
  "ai_os.eval.compare": { "after": string; "before": string }
  "ai_os.eval.degraded": Record<string, never>
  "ai_os.eval.failed": Record<string, never>
  "ai_os.eval.heading": Record<string, never>
  "ai_os.eval.negative_cases": { "count": string }
  "ai_os.eval.negative_cases_failed": { "count": string }
  "ai_os.eval.passed": Record<string, never>
  "ai_os.eval.pending": Record<string, never>
  "ai_os.evidence.candidate": Record<string, never>
  "ai_os.evidence.candidate.detail": Record<string, never>
  "ai_os.evidence.frozen": Record<string, never>
  "ai_os.evidence.heading": Record<string, never>
  "ai_os.evidence.not_enough_to_learn": Record<string, never>
  "ai_os.evidence.preview_verified": Record<string, never>
  "ai_os.evidence.preview_verified.detail": Record<string, never>
  "ai_os.evidence.production_verified": Record<string, never>
  "ai_os.evidence.production_verified.detail": Record<string, never>
  "ai_os.field.acceptance": Record<string, never>
  "ai_os.field.acceptance.hint": Record<string, never>
  "ai_os.field.budget": Record<string, never>
  "ai_os.field.budget.hint": Record<string, never>
  "ai_os.field.forbidden_boundaries": Record<string, never>
  "ai_os.field.goal": Record<string, never>
  "ai_os.field.impact_audience": Record<string, never>
  "ai_os.field.module": Record<string, never>
  "ai_os.field.owner_stream": Record<string, never>
  "ai_os.field.problem_evidence": Record<string, never>
  "ai_os.field.problem_evidence.hint": Record<string, never>
  "ai_os.field.requires_human_click": Record<string, never>
  "ai_os.field.requires_human_click.locked": Record<string, never>
  "ai_os.field.risk_level": Record<string, never>
  "ai_os.field.rollback": Record<string, never>
  "ai_os.field.rollback.hint": Record<string, never>
  "ai_os.field.stop_conditions": Record<string, never>
  "ai_os.field.stop_conditions.hint": Record<string, never>
  "ai_os.field.title": Record<string, never>
  "ai_os.field.user_value": Record<string, never>
  "ai_os.field.user_value.hint": Record<string, never>
  "ai_os.learning.active": Record<string, never>
  "ai_os.learning.disabled": { "reason": string }
  "ai_os.learning.expired_state": Record<string, never>
  "ai_os.learning.expires": { "when": string }
  "ai_os.learning.rolled_back_state": Record<string, never>
  "ai_os.learning.scope": { "where": string }
  "ai_os.loading.detail": Record<string, never>
  "ai_os.loading.evidence": Record<string, never>
  "ai_os.loading.list": Record<string, never>
  "ai_os.loading.submitting": Record<string, never>
  "ai_os.module.heading": Record<string, never>
  "ai_os.module.no_rollback": Record<string, never>
  "ai_os.module.owner": { "name": string; "owner": string }
  "ai_os.module.state.active": Record<string, never>
  "ai_os.module.state.deprecated": Record<string, never>
  "ai_os.module.state.retired": Record<string, never>
  "ai_os.proposal.auto_note": Record<string, never>
  "ai_os.proposal.evaluation_degraded.acceptance": { "module": string; "suite": string }
  "ai_os.proposal.evaluation_degraded.goal": { "module": string; "suite": string }
  "ai_os.proposal.evaluation_degraded.impact_audience": { "module": string }
  "ai_os.proposal.evaluation_degraded.title": { "module": string }
  "ai_os.proposal.evaluation_degraded.user_value": Record<string, never>
  "ai_os.proposal.evaluation_failed.acceptance": { "module": string; "suite": string }
  "ai_os.proposal.evaluation_failed.goal": { "module": string; "suite": string }
  "ai_os.proposal.evaluation_failed.impact_audience": { "module": string }
  "ai_os.proposal.evaluation_failed.title": { "module": string }
  "ai_os.proposal.evaluation_failed.user_value": { "module": string }
  "ai_os.proposal.found_at": { "when": string }
  "ai_os.proposal.impact": { "who": string }
  "ai_os.proposal.no_task_yet": Record<string, never>
  "ai_os.proposal.stop.attempts_exhausted": Record<string, never>
  "ai_os.proposal.stopped_by_budget": Record<string, never>
  "ai_os.proposal.task_link": Record<string, never>
  "ai_os.proposal.uncertain": Record<string, never>
  "ai_os.proposal.why_worth_it": { "benefit": string }
  "ai_os.retry.auto": { "attempt": string }
  "ai_os.retry.blocked_by_red": Record<string, never>
  "ai_os.retry.gave_up": { "attempt": string }
  "ai_os.retry.manual_ok": Record<string, never>
  "ai_os.risk.amber": Record<string, never>
  "ai_os.risk.amber.detail": Record<string, never>
  "ai_os.risk.green": Record<string, never>
  "ai_os.risk.green.detail": Record<string, never>
  "ai_os.risk.over_module_cap": { "name": string }
  "ai_os.risk.red": Record<string, never>
  "ai_os.risk.red.await_click": Record<string, never>
  "ai_os.risk.red.clicked": { "when": string; "who": string }
  "ai_os.risk.red.detail": Record<string, never>
  "ai_os.risk.red.refuse_auto": Record<string, never>
  "ai_os.section.acceptance_heading": Record<string, never>
  "ai_os.section.budget_heading": Record<string, never>
  "ai_os.section.detail_link": Record<string, never>
  "ai_os.section.empty": Record<string, never>
  "ai_os.section.evidence_heading": Record<string, never>
  "ai_os.section.learning_heading": Record<string, never>
  "ai_os.section.learning_subtitle": Record<string, never>
  "ai_os.section.needs_you": { "count": string }
  "ai_os.section.plan_heading": Record<string, never>
  "ai_os.section.rollback_heading": Record<string, never>
  "ai_os.section.subtitle": Record<string, never>
  "ai_os.section.title": Record<string, never>
  "ai_os.stage.accepted": Record<string, never>
  "ai_os.stage.diagnosed": Record<string, never>
  "ai_os.stage.executing": Record<string, never>
  "ai_os.stage.failed": Record<string, never>
  "ai_os.stage.fix_requested": Record<string, never>
  "ai_os.stage.learning_candidate": Record<string, never>
  "ai_os.stage.observed": Record<string, never>
  "ai_os.stage.preview_verified": Record<string, never>
  "ai_os.stage.production_verified": Record<string, never>
  "ai_os.stage.promoted": Record<string, never>
  "ai_os.stage.proposed": Record<string, never>
  "ai_os.stage.releasing": Record<string, never>
  "ai_os.stage.rollback_requested": Record<string, never>
  "ai_os.stage.rolled_back": Record<string, never>
  "alert.affected_unknown": Record<string, never>
  "alert.card.ask": Record<string, never>
  "alert.card.handled": Record<string, never>
  "alert.card.how_fixed": Record<string, never>
  "alert.card.mute_this_kind": Record<string, never>
  "alert.cert_expiring": { "days": string; "domain": string }
  "alert.channel.digest": Record<string, never>
  "alert.channel.none": Record<string, never>
  "alert.channel.phone": Record<string, never>
  "alert.channel.push": Record<string, never>
  "alert.conversation_feed_stuck": { "count": string }
  "alert.conversation_feed_stuck_affected": Record<string, never>
  "alert.deploy_done": Record<string, never>
  "alert.disk_almost_full.affected": { "days": string }
  "alert.disk_almost_full.title": { "host_name": string }
  "alert.disk_cleaned": { "free": string; "size": string }
  "alert.duty.link": Record<string, never>
  "alert.host_down.affected": { "project_name": string; "user_count": string }
  "alert.host_down.affected_unknown": Record<string, never>
  "alert.host_down.title": { "host_name": string }
  "alert.incident.empty": Record<string, never>
  "alert.incident.heading": Record<string, never>
  "alert.incident.meta.asleep": { "duration": string; "when": string }
  "alert.incident.meta.awake": { "duration": string; "when": string }
  "alert.narrow.empty": Record<string, never>
  "alert.narrow.heading": Record<string, never>
  "alert.needs_your_click": Record<string, never>
  "alert.page.subtitle": Record<string, never>
  "alert.page.title": Record<string, never>
  "alert.phone.empty": Record<string, never>
  "alert.phone.hint": Record<string, never>
  "alert.refused_to_touch": Record<string, never>
  "alert.rest_all_good": { "count": string }
  "alert.rule.handled.desc": Record<string, never>
  "alert.rule.handled.title": Record<string, never>
  "alert.rule.needs_you.desc": Record<string, never>
  "alert.rule.needs_you.title": Record<string, never>
  "alert.rule.night_noise.desc": Record<string, never>
  "alert.rule.night_noise.title": Record<string, never>
  "alert.rule.site_down.desc": Record<string, never>
  "alert.rule.site_down.title": Record<string, never>
  "alert.rules.empty": Record<string, never>
  "alert.rules.heading": Record<string, never>
  "alert.rules.stop_calling": Record<string, never>
  "alert.rules.wait_for_digest": Record<string, never>
  "alert.service_recovered": { "minutes": string; "project_name": string }
  "auth.authentication.strong_required": Record<string, never>
  "auth.bootstrap.mode.cta": Record<string, never>
  "auth.bootstrap.token.label": Record<string, never>
  "auth.bootstrap.token.placeholder": Record<string, never>
  "auth.brand.captain.detail": Record<string, never>
  "auth.brand.captain.name": Record<string, never>
  "auth.brand.headline": Record<string, never>
  "auth.brand.portrait_placeholder": Record<string, never>
  "auth.brand.subhead": Record<string, never>
  "auth.brand.vault_note": Record<string, never>
  "auth.brand.wordmark": Record<string, never>
  "auth.code.expired": Record<string, never>
  "auth.code.resend_wait": { "seconds": string }
  "auth.code.sent": { "email": string; "minutes": string }
  "auth.code.wrong": Record<string, never>
  "auth.divider.or": Record<string, never>
  "auth.email_code.cta": Record<string, never>
  "auth.error.mail_from_invalid": Record<string, never>
  "auth.error.mail_invalid": Record<string, never>
  "auth.error.no_mail_channel": Record<string, never>
  "auth.error.passkey_setup_required": Record<string, never>
  "auth.field.code.label": Record<string, never>
  "auth.field.current_password.label": Record<string, never>
  "auth.field.email.label": Record<string, never>
  "auth.field.email.placeholder": Record<string, never>
  "auth.field.new_password.label": Record<string, never>
  "auth.field.password.label": Record<string, never>
  "auth.field.password.placeholder": Record<string, never>
  "auth.field.recovery.label": Record<string, never>
  "auth.first_step.body": Record<string, never>
  "auth.first_step.title": Record<string, never>
  "auth.invited.body": Record<string, never>
  "auth.invited.title": Record<string, never>
  "auth.mail.code.body": { "code": string; "minutes": string }
  "auth.mail.code.subject": { "code": string; "minutes": string }
  "auth.mail.invite.body": { "days": string; "inviter": string; "link": string; "role": string }
  "auth.mail.invite.subject": { "inviter": string; "role": string }
  "auth.mail.stepup.body": { "code": string; "minutes": string }
  "auth.mail.stepup.subject": { "code": string; "minutes": string }
  "auth.no_password.body": Record<string, never>
  "auth.no_password.title": Record<string, never>
  "auth.passkey.cta": Record<string, never>
  "auth.passkey.done": Record<string, never>
  "auth.passkey.failed.already": Record<string, never>
  "auth.passkey.failed.dismissed": Record<string, never>
  "auth.passkey.failed.domain": Record<string, never>
  "auth.passkey.failed.unknown": Record<string, never>
  "auth.passkey.failed.unsupported": Record<string, never>
  "auth.passkey.invite": Record<string, never>
  "auth.passkey.setup_cta": Record<string, never>
  "auth.passkey.unsupported": Record<string, never>
  "auth.password.change.cta": Record<string, never>
  "auth.password.cta": Record<string, never>
  "auth.password.current_invalid": Record<string, never>
  "auth.password.hint": Record<string, never>
  "auth.password.invalid": Record<string, never>
  "auth.password.recent_auth_required": Record<string, never>
  "auth.password.set.cta": Record<string, never>
  "auth.password.updated": Record<string, never>
  "auth.password.weak": Record<string, never>
  "auth.paths.only_consumable": { "left": string }
  "auth.paths.only_one": Record<string, never>
  "auth.paths.recovery_left": { "left": string }
  "auth.point.autonomous.detail": Record<string, never>
  "auth.point.autonomous.title": Record<string, never>
  "auth.point.ssh_once.detail": Record<string, never>
  "auth.point.ssh_once.title": Record<string, never>
  "auth.point.team.detail": Record<string, never>
  "auth.point.team.title": Record<string, never>
  "auth.recovery.cta": Record<string, never>
  "auth.recovery.hint": Record<string, never>
  "auth.recovery.needs_email": Record<string, never>
  "auth.recovery.submit": Record<string, never>
  "auth.recovery_codes.detail": Record<string, never>
  "auth.recovery_codes.heading": Record<string, never>
  "auth.registration.invalid": Record<string, never>
  "auth.signin.cta": Record<string, never>
  "auth.signin.failed": Record<string, never>
  "auth.signin.subtitle": Record<string, never>
  "auth.signin.switch_cta": Record<string, never>
  "auth.signin.switch_hint": Record<string, never>
  "auth.signin.title": Record<string, never>
  "auth.signup.cta": Record<string, never>
  "auth.signup.subtitle": Record<string, never>
  "auth.signup.switch_cta": Record<string, never>
  "auth.signup.switch_hint": Record<string, never>
  "auth.signup.title": Record<string, never>
  "auth.step_up.prompt": Record<string, never>
  "auth.stepup.code.cta": Record<string, never>
  "auth.stepup.code.sent": Record<string, never>
  "auth.stepup.password.cta": Record<string, never>
  "auth.stepup.password.label": Record<string, never>
  "auth.stepup.password.wrong": Record<string, never>
  "bridge.error.scope_insufficient": Record<string, never>
  "bridge.grants.empty": Record<string, never>
  "bridge.grants.heading": Record<string, never>
  "bridge.grants.hint": Record<string, never>
  "bridge.grants.issue": Record<string, never>
  "bridge.grants.revoke": Record<string, never>
  "bridge.tokens.empty": Record<string, never>
  "bridge.tokens.error.idempotency_mismatch": Record<string, never>
  "bridge.tokens.error.invalid": Record<string, never>
  "bridge.tokens.error.scope_forbidden": Record<string, never>
  "bridge.tokens.heading": Record<string, never>
  "bridge.tokens.hint": Record<string, never>
  "bridge.tokens.issue.cta": Record<string, never>
  "bridge.tokens.issue.failed": Record<string, never>
  "bridge.tokens.issue.heading": Record<string, never>
  "bridge.tokens.issue.label": Record<string, never>
  "bridge.tokens.issue.label_example": Record<string, never>
  "bridge.tokens.issue.pending": Record<string, never>
  "bridge.tokens.issue.project": Record<string, never>
  "bridge.tokens.issue.scopes": Record<string, never>
  "bridge.tokens.issue.stepup": Record<string, never>
  "bridge.tokens.issue.ttl": Record<string, never>
  "bridge.tokens.issued.close": Record<string, never>
  "bridge.tokens.issued.copied": Record<string, never>
  "bridge.tokens.issued.copy": Record<string, never>
  "bridge.tokens.issued.heading": Record<string, never>
  "bridge.tokens.issued.hint": Record<string, never>
  "bridge.tokens.issued.replayed": Record<string, never>
  "bridge.tokens.mask": { "prefix": string; "suffix": string }
  "bridge.tokens.revoke": Record<string, never>
  "bridge.tokens.revoke.failed": Record<string, never>
  "bridge.tokens.revoke.stepup": Record<string, never>
  "bridge.tokens.revoke.title": Record<string, never>
  "bridge.tokens.revoking": Record<string, never>
  "bridge.tokens.row.expires": { "date": string }
  "bridge.tokens.row.last_used": { "date": string }
  "bridge.tokens.row.never_expires": Record<string, never>
  "bridge.tokens.row.never_used": Record<string, never>
  "bridge.tokens.scope.access_request": Record<string, never>
  "bridge.tokens.scope.hosts_read": Record<string, never>
  "bridge.tokens.scope.projects_read": Record<string, never>
  "bridge.tokens.show_revoked": Record<string, never>
  "bridge.tokens.status.active": Record<string, never>
  "bridge.tokens.status.expired": Record<string, never>
  "bridge.tokens.status.revoked": Record<string, never>
  "bridge.tokens.ttl.30d": Record<string, never>
  "bridge.tokens.ttl.7d": Record<string, never>
  "bridge.tokens.ttl.90d": Record<string, never>
  "bridge.tokens.ttl.never": Record<string, never>
  "bug_reports.close": Record<string, never>
  "bug_reports.confirm_fix": Record<string, never>
  "bug_reports.disable": Record<string, never>
  "bug_reports.empty": Record<string, never>
  "bug_reports.enable": Record<string, never>
  "bug_reports.enabled": Record<string, never>
  "bug_reports.failed": Record<string, never>
  "bug_reports.filter.all": Record<string, never>
  "bug_reports.loading": Record<string, never>
  "bug_reports.more": Record<string, never>
  "bug_reports.no_description": Record<string, never>
  "bug_reports.resolved_note": Record<string, never>
  "bug_reports.rotate": Record<string, never>
  "bug_reports.screenshot": Record<string, never>
  "bug_reports.state.admin": Record<string, never>
  "bug_reports.state.analyzing": Record<string, never>
  "bug_reports.state.done": Record<string, never>
  "bug_reports.state.fixing": Record<string, never>
  "bug_reports.state.reporter": Record<string, never>
  "bug_reports.subtitle": Record<string, never>
  "bug_reports.title": Record<string, never>
  "chat.brief.active": Record<string, never>
  "chat.brief.empty": Record<string, never>
  "chat.brief.empty_hint": Record<string, never>
  "chat.brief.heading": Record<string, never>
  "chat.brief.note": Record<string, never>
  "chat.brief.waiting": Record<string, never>
  "chat.error.unavailable": Record<string, never>
  "chat.facts.external_verify_hint": Record<string, never>
  "chat.facts.heading": Record<string, never>
  "chat.facts.kind.commit": Record<string, never>
  "chat.facts.kind.deploy": Record<string, never>
  "chat.facts.kind.external_verify": Record<string, never>
  "chat.facts.kind.rollback": Record<string, never>
  "chat.facts.kind.test": Record<string, never>
  "chat.facts.note": Record<string, never>
  "chat.facts.status.failed": Record<string, never>
  "chat.facts.status.none": Record<string, never>
  "chat.facts.status.not_applicable": Record<string, never>
  "chat.facts.status.passed": Record<string, never>
  "chat.facts.status.pending_verify": Record<string, never>
  "chat.facts.status.running": Record<string, never>
  "chat.flywheel.ci_failed": { "agent": string }
  "chat.flywheel.completed": Record<string, never>
  "chat.flywheel.deploy_failed": Record<string, never>
  "chat.flywheel.empty": Record<string, never>
  "chat.flywheel.heading": Record<string, never>
  "chat.flywheel.review_fix_requested": { "agent": string }
  "chat.flywheel.running": { "iteration": string }
  "chat.flywheel.stale": { "since": string }
  "chat.gate.held": { "since": string }
  "chat.input.archived": Record<string, never>
  "chat.input.label": Record<string, never>
  "chat.input.placeholder": Record<string, never>
  "chat.input.send": Record<string, never>
  "chat.list.account_create": Record<string, never>
  "chat.list.account_group": Record<string, never>
  "chat.list.archived": Record<string, never>
  "chat.list.create": Record<string, never>
  "chat.list.empty": Record<string, never>
  "chat.list.group_create": Record<string, never>
  "chat.list.group_less": Record<string, never>
  "chat.list.group_more": { "count": string }
  "chat.list.group_unavailable": Record<string, never>
  "chat.list.mobile_open": Record<string, never>
  "chat.list.nav": Record<string, never>
  "chat.list.waiting": Record<string, never>
  "chat.lulu.receipts.approve": Record<string, never>
  "chat.lulu.receipts.closed": Record<string, never>
  "chat.lulu.receipts.empty": Record<string, never>
  "chat.lulu.receipts.heading": Record<string, never>
  "chat.lulu.receipts.pending": Record<string, never>
  "chat.lulu.receipts.reject": Record<string, never>
  "chat.mention.action": Record<string, never>
  "chat.mention.empty": Record<string, never>
  "chat.mention.hint": Record<string, never>
  "chat.message.empty": Record<string, never>
  "chat.next.developing": Record<string, never>
  "chat.next.fix": Record<string, never>
  "chat.next.live": Record<string, never>
  "chat.next.preview": Record<string, never>
  "chat.next.release": Record<string, never>
  "chat.next.testing": Record<string, never>
  "chat.page.subtitle": Record<string, never>
  "chat.page.title": Record<string, never>
  "chat.panel.collapse": Record<string, never>
  "chat.panel.expand": Record<string, never>
  "chat.panel.mobile_close": Record<string, never>
  "chat.panel.mobile_open": Record<string, never>
  "chat.participant.developer": Record<string, never>
  "chat.participant.human": Record<string, never>
  "chat.participant.reviewer": Record<string, never>
  "chat.participant.steward": Record<string, never>
  "chat.participants.empty": Record<string, never>
  "chat.participants.error": Record<string, never>
  "chat.participants.heading": Record<string, never>
  "chat.phase.developing": Record<string, never>
  "chat.phase.fix": Record<string, never>
  "chat.phase.live": Record<string, never>
  "chat.phase.preview": Record<string, never>
  "chat.phase.release": Record<string, never>
  "chat.phase.testing": Record<string, never>
  "chat.platform.job_failed": Record<string, never>
  "chat.platform.job_succeeded": Record<string, never>
  "chat.receipt.action": Record<string, never>
  "chat.receipt.declared": { "model": string }
  "chat.receipt.degraded": Record<string, never>
  "chat.receipt.platform": { "model": string }
  "chat.schedule.action": Record<string, never>
  "chat.schedule.done": Record<string, never>
  "chat.schedule.executor.auto": { "model": string }
  "chat.schedule.executor.label": Record<string, never>
  "chat.schedule.executor.own_key": Record<string, never>
  "chat.schedule.executor.plan": Record<string, never>
  "chat.schedule.executor.unavailable": Record<string, never>
  "chat.schedule.hint": Record<string, never>
  "chat.schedule.no_project": Record<string, never>
  "chat.task.base_sha": { "sha": string }
  "chat.task.base_sha_pending": Record<string, never>
  "chat.task.project": { "name": string }
  "chat.tasktree.empty": Record<string, never>
  "chat.tasktree.empty_hint": Record<string, never>
  "chat.tasktree.heading": Record<string, never>
  "chat.tasktree.owner_unassigned": Record<string, never>
  "check.backup.failed": { "host": string }
  "check.backup.stale": { "host": string; "hours": string }
  "check.cert.expiring": { "days": string; "domain": string; "host": string }
  "check.disk.almost_full": { "free_percent": string; "host": string; "mount": string }
  "check.disk.will_be_full": { "days": string; "host": string; "mount": string }
  "check.load.high": { "host": string; "per_core": string }
  "check.log.disk_pressure": { "host": string }
  "check.log.nothing_found": Record<string, never>
  "check.log.oom": { "host": string }
  "check.log.port_taken": { "host": string }
  "check.memory.almost_full": { "host": string; "percent": string }
  "check.port.closed": { "host": string; "port": string }
  "check.process.gone": { "host": string; "process": string }
  "code.action.diff": Record<string, never>
  "code.application.current": Record<string, never>
  "code.application.empty": Record<string, never>
  "code.application.open_project": Record<string, never>
  "code.application.partial": Record<string, never>
  "code.application.recent": Record<string, never>
  "code.inspection.detail": Record<string, never>
  "code.inspection.empty": Record<string, never>
  "code.inspection.idle": Record<string, never>
  "code.inspection.repair": Record<string, never>
  "code.inspection.subtitle": Record<string, never>
  "code.overview.active": Record<string, never>
  "code.overview.attention": Record<string, never>
  "code.overview.live": Record<string, never>
  "code.page.subtitle": Record<string, never>
  "code.section.commits": Record<string, never>
  "code.section.commits.hint": Record<string, never>
  "code.section.prs": Record<string, never>
  "code.section.prs.hint": Record<string, never>
  "code.section.repos": Record<string, never>
  "code.tab.applications": Record<string, never>
  "code.tab.inspections": Record<string, never>
  "code.tab.sites": Record<string, never>
  "credential.blast.one_scope": { "scope": string }
  "credential.blast.several": { "count": string; "vendor": string }
  "credential.blast.whole_account": { "vendor": string }
  "credential.derived.also_dies": { "parent": string; "vendor": string }
  "credential.error.blank": Record<string, never>
  "credential.error.forbidden_raw": Record<string, never>
  "credential.error.vendor_missing": Record<string, never>
  "credential.reveal.code_required": Record<string, never>
  "credential.reveal.code_wrong": Record<string, never>
  "credential.reveal.hidden_again": Record<string, never>
  "credential.reveal.reason_required": Record<string, never>
  "credential.revoked": Record<string, never>
  "credential.rotated": Record<string, never>
  "credential.rotation.pending": { "vendor": string }
  "credential.scope.too_wide": Record<string, never>
  "credential.source.leaked_channel": Record<string, never>
  "dashboard.action.add_host": Record<string, never>
  "dashboard.action.nightly_report": Record<string, never>
  "dashboard.attention.ack": Record<string, never>
  "dashboard.attention.detail_cta": Record<string, never>
  "dashboard.attention.rest": { "count": string }
  "dashboard.attention.timeline_cta": Record<string, never>
  "dashboard.greeting.all_well": Record<string, never>
  "dashboard.greeting.detail": { "action_count": string; "attention_count": string; "host_count": string }
  "dashboard.greeting.detail.unreachable": { "count": string }
  "dashboard.greeting.something_burning": Record<string, never>
  "dashboard.last_night.window": { "from": string; "to": string }
  "dashboard.nightly.backed_up": { "count": string }
  "dashboard.nightly.backed_up.detail": { "days": string; "destination": string }
  "dashboard.nightly.cleaned_logs": { "project_name": string; "size": string }
  "dashboard.nightly.cleaned_logs.detail": { "after": string; "before": string }
  "dashboard.nightly.fixed_bug": { "issue": string; "project_name": string }
  "dashboard.nightly.fixed_bug.detail": Record<string, never>
  "dashboard.nightly.patched": { "count": string }
  "dashboard.nightly.patched.detail": Record<string, never>
  "dashboard.nightly.watching": { "project_name": string }
  "dashboard.nightly.watching.detail": Record<string, never>
  "dashboard.project.host_count": { "count": string }
  "dashboard.project.no_domain": Record<string, never>
  "dashboard.running.hint": Record<string, never>
  "dashboard.running.item": { "doing": string; "project": string }
  "dashboard.running.title": Record<string, never>
  "dashboard.section.attention": Record<string, never>
  "dashboard.section.attention.hint": Record<string, never>
  "dashboard.section.last_night": Record<string, never>
  "dashboard.section.projects": Record<string, never>
  "dashboard.section.projects.hint": Record<string, never>
  "dashboard.stat.attention": Record<string, never>
  "dashboard.stat.hosts": Record<string, never>
  "dashboard.stat.hosts.all_online": Record<string, never>
  "dashboard.stat.hosts.unreachable": { "count": string }
  "dashboard.stat.projects": Record<string, never>
  "development_task.action.add_acceptance": Record<string, never>
  "development_task.action.add_context": Record<string, never>
  "development_task.action.cancel": Record<string, never>
  "development_task.action.cancelling": Record<string, never>
  "development_task.action.claim": Record<string, never>
  "development_task.action.claiming": Record<string, never>
  "development_task.action.confirm_cancel": Record<string, never>
  "development_task.action.copied": Record<string, never>
  "development_task.action.copy": Record<string, never>
  "development_task.action.keep": Record<string, never>
  "development_task.action.prepare_repo": Record<string, never>
  "development_task.action.preparing": Record<string, never>
  "development_task.action.remove": Record<string, never>
  "development_task.action.repair": Record<string, never>
  "development_task.action.retry": Record<string, never>
  "development_task.actor.external": Record<string, never>
  "development_task.actor.internal": Record<string, never>
  "development_task.assignee.auto": Record<string, never>
  "development_task.assignee.cannot_execute": Record<string, never>
  "development_task.assignee.local_hint": Record<string, never>
  "development_task.assignee.manual": Record<string, never>
  "development_task.assignee.unavailable": Record<string, never>
  "development_task.cancel.body": Record<string, never>
  "development_task.cancel.title": Record<string, never>
  "development_task.claim.copy": Record<string, never>
  "development_task.claim.endpoint": Record<string, never>
  "development_task.claim.expiry": Record<string, never>
  "development_task.claim.fingerprint": Record<string, never>
  "development_task.claim.subtitle": Record<string, never>
  "development_task.claim.title": Record<string, never>
  "development_task.claim.token": Record<string, never>
  "development_task.claim.username": Record<string, never>
  "development_task.comments.empty": Record<string, never>
  "development_task.comments.failed": Record<string, never>
  "development_task.comments.outcome_exhausted": { "max": string }
  "development_task.comments.outcome_recorded": Record<string, never>
  "development_task.comments.outcome_reopened": Record<string, never>
  "development_task.comments.placeholder": Record<string, never>
  "development_task.comments.rounds": { "max": string; "rounds": string }
  "development_task.comments.submit": Record<string, never>
  "development_task.comments.title": Record<string, never>
  "development_task.context.api_contract": Record<string, never>
  "development_task.context.asset": Record<string, never>
  "development_task.context.code_path": Record<string, never>
  "development_task.context.data_migration": Record<string, never>
  "development_task.context.deployment": Record<string, never>
  "development_task.context.design": Record<string, never>
  "development_task.context.product_doc": Record<string, never>
  "development_task.context.reference": Record<string, never>
  "development_task.context.test_plan": Record<string, never>
  "development_task.context.ui_route": Record<string, never>
  "development_task.create.action": Record<string, never>
  "development_task.create.submit": Record<string, never>
  "development_task.create.submitting": Record<string, never>
  "development_task.create.subtitle": Record<string, never>
  "development_task.create.title": Record<string, never>
  "development_task.detail.live_sha": Record<string, never>
  "development_task.detail.needs_rebase": Record<string, never>
  "development_task.detail.release_id": Record<string, never>
  "development_task.domain.backend": Record<string, never>
  "development_task.domain.data": Record<string, never>
  "development_task.domain.design": Record<string, never>
  "development_task.domain.frontend": Record<string, never>
  "development_task.domain.infra": Record<string, never>
  "development_task.domain.product": Record<string, never>
  "development_task.domain.qa": Record<string, never>
  "development_task.domain.release": Record<string, never>
  "development_task.error.claimed": Record<string, never>
  "development_task.error.prepare_paused": Record<string, never>
  "development_task.error.prepare_retrying": Record<string, never>
  "development_task.error.prepare_select_repo": Record<string, never>
  "development_task.event.attempt_claimed": Record<string, never>
  "development_task.event.attempt_progress": Record<string, never>
  "development_task.event.attempt_state_changed": Record<string, never>
  "development_task.event.task_cancelled": Record<string, never>
  "development_task.event.task_created": Record<string, never>
  "development_task.event.task_state_changed": Record<string, never>
  "development_task.event.updated": Record<string, never>
  "development_task.field.acceptance": Record<string, never>
  "development_task.field.acceptance_hint": Record<string, never>
  "development_task.field.base_sha": Record<string, never>
  "development_task.field.context_digest": Record<string, never>
  "development_task.field.context_kind": Record<string, never>
  "development_task.field.context_locator": Record<string, never>
  "development_task.field.context_title": Record<string, never>
  "development_task.field.executor": Record<string, never>
  "development_task.field.executor_model": Record<string, never>
  "development_task.field.executor_provider": Record<string, never>
  "development_task.field.instructions": Record<string, never>
  "development_task.field.model": Record<string, never>
  "development_task.field.repo": Record<string, never>
  "development_task.field.title": Record<string, never>
  "development_task.hint.claim": Record<string, never>
  "development_task.hint.context": Record<string, never>
  "development_task.hint.copy_failed": Record<string, never>
  "development_task.hint.digest": Record<string, never>
  "development_task.hint.domains": Record<string, never>
  "development_task.hint.draft": Record<string, never>
  "development_task.hint.executor_identity": Record<string, never>
  "development_task.hint.executor_identity_partial": Record<string, never>
  "development_task.hint.model": Record<string, never>
  "development_task.hint.no_context": Record<string, never>
  "development_task.hint.no_recommendation": Record<string, never>
  "development_task.hint.preparing": Record<string, never>
  "development_task.hint.preparing_claim": Record<string, never>
  "development_task.hint.preparing_packet": Record<string, never>
  "development_task.hint.ready": Record<string, never>
  "development_task.hint.request_error": Record<string, never>
  "development_task.hint.timeline_empty": Record<string, never>
  "development_task.hint.timeline_error": Record<string, never>
  "development_task.hint.timeline_loading": Record<string, never>
  "development_task.magic.acceptance": Record<string, never>
  "development_task.magic.claim_error": Record<string, never>
  "development_task.magic.claimed.hint": Record<string, never>
  "development_task.magic.claimed.title": { "executor": string }
  "development_task.magic.claiming": Record<string, never>
  "development_task.magic.copy.action": Record<string, never>
  "development_task.magic.copy.done": Record<string, never>
  "development_task.magic.error.back": Record<string, never>
  "development_task.magic.error.title": Record<string, never>
  "development_task.magic.identity.action": Record<string, never>
  "development_task.magic.identity.capability": Record<string, never>
  "development_task.magic.identity.hint": Record<string, never>
  "development_task.magic.identity.invalid": Record<string, never>
  "development_task.magic.identity.label": Record<string, never>
  "development_task.magic.identity.placeholder": Record<string, never>
  "development_task.magic.identity.title": Record<string, never>
  "development_task.magic.invalid": Record<string, never>
  "development_task.magic.issue.action": Record<string, never>
  "development_task.magic.issue.pending": Record<string, never>
  "development_task.magic.issue.renew": Record<string, never>
  "development_task.magic.issue_error": Record<string, never>
  "development_task.magic.open_error": Record<string, never>
  "development_task.magic.opening": Record<string, never>
  "development_task.magic.panel.hint": Record<string, never>
  "development_task.magic.panel.title": Record<string, never>
  "development_task.magic.prompt": Record<string, never>
  "development_task.magic.public.hint": Record<string, never>
  "development_task.magic.public.title": Record<string, never>
  "development_task.magic.request_error": Record<string, never>
  "development_task.magic.token_missing": Record<string, never>
  "development_task.maintainer.duration.180d": Record<string, never>
  "development_task.maintainer.duration.30d": Record<string, never>
  "development_task.maintainer.duration.90d": Record<string, never>
  "development_task.maintainer.duration.label": Record<string, never>
  "development_task.maintainer.duration.long_term": Record<string, never>
  "development_task.maintainer.error.claimed": Record<string, never>
  "development_task.maintainer.error.expired": Record<string, never>
  "development_task.maintainer.error.key_mismatch": Record<string, never>
  "development_task.maintainer.issue": Record<string, never>
  "development_task.maintainer.label": Record<string, never>
  "development_task.maintainer.panel.hint": Record<string, never>
  "development_task.maintainer.panel.title": Record<string, never>
  "development_task.maintainer.pending": Record<string, never>
  "development_task.maintainer.placeholder": Record<string, never>
  "development_task.maintainer.public.hint": Record<string, never>
  "development_task.maintainer.revoke": Record<string, never>
  "development_task.maintainer.rotate": Record<string, never>
  "development_task.memory.empty": Record<string, never>
  "development_task.memory.kind.comment": Record<string, never>
  "development_task.memory.kind.failed_because": Record<string, never>
  "development_task.memory.kind.note": Record<string, never>
  "development_task.memory.kind.tried": Record<string, never>
  "development_task.memory.title": Record<string, never>
  "development_task.mission.action.open_preview": Record<string, never>
  "development_task.mission.action.publish": Record<string, never>
  "development_task.mission.action.rollback": Record<string, never>
  "development_task.mission.action.unavailable": Record<string, never>
  "development_task.mission.field.integration_sha": Record<string, never>
  "development_task.mission.field.next_step": Record<string, never>
  "development_task.mission.field.owner_sha": Record<string, never>
  "development_task.mission.field.preview_url": Record<string, never>
  "development_task.mission.field.production_sha": Record<string, never>
  "development_task.mission.next.cancelled": Record<string, never>
  "development_task.mission.next.fast_test": Record<string, never>
  "development_task.mission.next.in_development": Record<string, never>
  "development_task.mission.next.live": Record<string, never>
  "development_task.mission.next.live_rollback": Record<string, never>
  "development_task.mission.next.needs_fix": Record<string, never>
  "development_task.mission.next.pending_release": Record<string, never>
  "development_task.mission.next.preview_available": Record<string, never>
  "development_task.mission.next.preview_available_no_url": Record<string, never>
  "development_task.mission.next.publish_failed": Record<string, never>
  "development_task.mission.panel.hint": Record<string, never>
  "development_task.mission.panel.title": Record<string, never>
  "development_task.mission.request.failure": Record<string, never>
  "development_task.mission.request.running": Record<string, never>
  "development_task.mission.request.success": Record<string, never>
  "development_task.mission.status.fast_test": Record<string, never>
  "development_task.mission.status.in_development": Record<string, never>
  "development_task.mission.status.live": Record<string, never>
  "development_task.mission.status.needs_fix": Record<string, never>
  "development_task.mission.status.pending_release": Record<string, never>
  "development_task.mission.status.preview_available": Record<string, never>
  "development_task.mission.unavailable": Record<string, never>
  "development_task.optional.summary": { "contexts": string; "domains": string }
  "development_task.preview.action": Record<string, never>
  "development_task.preview.again": Record<string, never>
  "development_task.preview.blame.access": Record<string, never>
  "development_task.preview.blame.input": Record<string, never>
  "development_task.preview.blame.label": Record<string, never>
  "development_task.preview.blame.offline": Record<string, never>
  "development_task.preview.blame.platform": Record<string, never>
  "development_task.preview.blame.unknown": Record<string, never>
  "development_task.preview.blame.version": Record<string, never>
  "development_task.preview.closed": Record<string, never>
  "development_task.preview.field.owner_tip": Record<string, never>
  "development_task.preview.field.preview_sha": Record<string, never>
  "development_task.preview.field.release_sha": Record<string, never>
  "development_task.preview.panel.hint": Record<string, never>
  "development_task.preview.panel.title": Record<string, never>
  "development_task.preview.pending": Record<string, never>
  "development_task.preview.rollback": Record<string, never>
  "development_task.preview.state.owner_tip": Record<string, never>
  "development_task.preview.state.preview_failed_rolled_back": Record<string, never>
  "development_task.preview.state.preview_ready": Record<string, never>
  "development_task.preview.state.preview_running": Record<string, never>
  "development_task.preview.state.production_verified": Record<string, never>
  "development_task.preview.state.release_requested": Record<string, never>
  "development_task.preview.state.test_candidate": Record<string, never>
  "development_task.preview.view_only": Record<string, never>
  "development_task.preview.waiting": Record<string, never>
  "development_task.redline.what": { "title": string }
  "development_task.remote_ai.invitation.pending_hint": Record<string, never>
  "development_task.remote_ai.invitation.revoke": Record<string, never>
  "development_task.remote_ai.invitation.revoke_confirm": Record<string, never>
  "development_task.remote_ai.invitation.revoke_failed": Record<string, never>
  "development_task.remote_ai.invitation.revoking": Record<string, never>
  "development_task.repo.account_error": Record<string, never>
  "development_task.repo.all_unavailable": Record<string, never>
  "development_task.repo.association_error": Record<string, never>
  "development_task.repo.association_loading": Record<string, never>
  "development_task.repo.candidate_empty_option": { "repo": string }
  "development_task.repo.candidate_label": Record<string, never>
  "development_task.repo.candidate_select": Record<string, never>
  "development_task.repo.candidates_error": Record<string, never>
  "development_task.repo.candidates_unavailable": Record<string, never>
  "development_task.repo.empty_hint": { "count": string }
  "development_task.repo.error": Record<string, never>
  "development_task.repo.link_action": Record<string, never>
  "development_task.repo.link_conflict": Record<string, never>
  "development_task.repo.link_error": Record<string, never>
  "development_task.repo.link_hint": Record<string, never>
  "development_task.repo.link_unavailable": Record<string, never>
  "development_task.repo.linking": Record<string, never>
  "development_task.repo.loading": Record<string, never>
  "development_task.repo.no_candidates": Record<string, never>
  "development_task.repo.none": Record<string, never>
  "development_task.repo.option_unavailable": { "repo": string }
  "development_task.repo.permission": Record<string, never>
  "development_task.repo.refreshing": Record<string, never>
  "development_task.repo.retrying": Record<string, never>
  "development_task.repo.select": Record<string, never>
  "development_task.repo.select_hint": Record<string, never>
  "development_task.repo.single_unavailable": { "repo": string }
  "development_task.section.advanced": Record<string, never>
  "development_task.section.attached": Record<string, never>
  "development_task.section.context": Record<string, never>
  "development_task.section.details": Record<string, never>
  "development_task.section.domains": Record<string, never>
  "development_task.section.executor_identity": Record<string, never>
  "development_task.section.git": Record<string, never>
  "development_task.section.optional": Record<string, never>
  "development_task.section.packet": Record<string, never>
  "development_task.section.recommended": Record<string, never>
  "development_task.section.status": Record<string, never>
  "development_task.section.timeline": Record<string, never>
  "development_task.stage.claimed": { "attempt": string; "title": string }
  "development_task.stage.delivered": { "sha": string; "title": string }
  "development_task.stage.exhausted": { "rounds": string; "title": string }
  "development_task.stage.failed": { "sha": string; "title": string }
  "development_task.stage.verified": { "sha": string; "title": string }
  "development_task.stagecard.cancelled": Record<string, never>
  "development_task.stagecard.ci": Record<string, never>
  "development_task.stagecard.claimed": Record<string, never>
  "development_task.stagecard.decision": Record<string, never>
  "development_task.stagecard.delivered": Record<string, never>
  "development_task.stagecard.failed": Record<string, never>
  "development_task.stagecard.fix_requested": Record<string, never>
  "development_task.stagecard.live": Record<string, never>
  "development_task.stagecard.ready": Record<string, never>
  "development_task.stagecard.reviewing": Record<string, never>
  "development_task.stages.attempt": { "n": string }
  "development_task.stages.empty": Record<string, never>
  "development_task.stages.live_note": Record<string, never>
  "development_task.stages.title": Record<string, never>
  "development_task.stages.total": { "elapsed": string }
  "development_task.state.cancelled": Record<string, never>
  "development_task.state.ci_running": Record<string, never>
  "development_task.state.draft": Record<string, never>
  "development_task.state.failed": Record<string, never>
  "development_task.state.fix_requested": Record<string, never>
  "development_task.state.gating": Record<string, never>
  "development_task.state.pending_approval": Record<string, never>
  "development_task.state.preparing": Record<string, never>
  "development_task.state.ready": Record<string, never>
  "development_task.state.ready_to_claim": Record<string, never>
  "development_task.state.reviewing": Record<string, never>
  "development_task.state.running": Record<string, never>
  "development_task.state.v2_handoff": Record<string, never>
  "development_task.user_state.cancelled": Record<string, never>
  "development_task.user_state.claimable": Record<string, never>
  "development_task.user_state.in_progress": Record<string, never>
  "development_task.user_state.live": Record<string, never>
  "development_task.user_state.needs_action": Record<string, never>
  "duty.cards.heading": Record<string, never>
  "duty.collab.pending": Record<string, never>
  "duty.kind.act": Record<string, never>
  "duty.kind.observe": Record<string, never>
  "duty.page.subtitle": Record<string, never>
  "duty.page.title": Record<string, never>
  "duty.schedule.empty": Record<string, never>
  "duty.schedule.heading": Record<string, never>
  "duty.schedule.source": Record<string, never>
  "duty.toggle.off": Record<string, never>
  "duty.toggle.on": Record<string, never>
  "error.conversation.attachment_bad_type": Record<string, never>
  "error.conversation.attachment_looks_like_key": Record<string, never>
  "error.conversation.attachment_not_claimable": Record<string, never>
  "error.conversation.attachment_too_large": Record<string, never>
  "error.conversation.attachment_too_many": Record<string, never>
  "error.conversation.attachment_type_mismatch": Record<string, never>
  "error.executor_unavailable": Record<string, never>
  "error.forbidden.hosts": Record<string, never>
  "error.generic": Record<string, never>
  "error.job_stalled": { "minutes": string; "step": string }
  "error.memo.attachment_bad_type": Record<string, never>
  "error.memo.attachment_too_large": Record<string, never>
  "error.memo.audio_bad_type": Record<string, never>
  "error.memo.audio_too_large": Record<string, never>
  "error.memo.audio_too_long": Record<string, never>
  "error.memo.password_too_short": Record<string, never>
  "error.memo.password_wrong": Record<string, never>
  "error.memo.unlock_throttled": Record<string, never>
  "error.memo.version_conflict": Record<string, never>
  "error.memo.voice_needs_access": Record<string, never>
  "error.not_found": Record<string, never>
  "error.rate_limited": { "seconds": string }
  "error.read_failed.retry": Record<string, never>
  "error.read_failed.title": Record<string, never>
  "error.step_up_required": Record<string, never>
  "error.unauthorized": Record<string, never>
  "error.upstream_down": { "vendor": string }
  "host.access.credential.kept": Record<string, never>
  "host.access.credential.revoked": Record<string, never>
  "host.access.heading": Record<string, never>
  "host.access.keys.heading": Record<string, never>
  "host.access.keys.ours": Record<string, never>
  "host.access.keys.yours": { "count": string }
  "host.access.keys.yours_none": Record<string, never>
  "host.access.original.keys": { "count": string }
  "host.access.original.none": Record<string, never>
  "host.access.original.password": Record<string, never>
  "host.access.original.unknown": Record<string, never>
  "host.access.original.unknown_reachable": Record<string, never>
  "host.access.ours.checked_at": { "when": string }
  "host.access.ours.status.unknown": Record<string, never>
  "host.access.ours.status.unusable": Record<string, never>
  "host.access.ours.status.usable": Record<string, never>
  "host.access.ours.used_by": Record<string, never>
  "host.access.stale": { "checked_at": string }
  "host.access.yours.checked_at": { "when": string }
  "host.access.yours.never_checked": Record<string, never>
  "host.access.yours.status.unknown": Record<string, never>
  "host.access.yours.status.unusable": Record<string, never>
  "host.access.yours.status.usable": Record<string, never>
  "host.access.yours.used_by": Record<string, never>
  "host.action.connect_myself": Record<string, never>
  "host.action.reconnect": Record<string, never>
  "host.action.temp_key": Record<string, never>
  "host.busy.heading": Record<string, never>
  "host.busy.window": Record<string, never>
  "host.card.activity": Record<string, never>
  "host.card.agent": Record<string, never>
  "host.card.capacity": Record<string, never>
  "host.card.detail": Record<string, never>
  "host.card.more_addresses": { "count": string }
  "host.card.more_workloads": { "count": string }
  "host.card.next": Record<string, never>
  "host.card.uncollected": Record<string, never>
  "host.card.unknown": Record<string, never>
  "host.card.workloads": Record<string, never>
  "host.carve.lives_on": { "parent_name": string }
  "host.carve.parent_spec": { "cores": string; "memory": string }
  "host.carve.shared_fate": { "parent_name": string }
  "host.carve.split_count": { "count": string }
  "host.credential.copy": Record<string, never>
  "host.credential.field.address": Record<string, never>
  "host.credential.field.key": Record<string, never>
  "host.credential.field.user": Record<string, never>
  "host.credential.heading": Record<string, never>
  "host.credential.kept": Record<string, never>
  "host.credential.note": Record<string, never>
  "host.detail.breadcrumb": { "name": string }
  "host.group.assigned": Record<string, never>
  "host.group.available": Record<string, never>
  "host.group.exception": Record<string, never>
  "host.label.behind_nat": Record<string, never>
  "host.label.cannot_go_down": Record<string, never>
  "host.label.daily_backup": { "destination": string; "time": string }
  "host.label.has_database": Record<string, never>
  "host.label.shared_infra": Record<string, never>
  "host.list.col.host": Record<string, never>
  "host.list.col.project": Record<string, never>
  "host.list.col.state": Record<string, never>
  "host.list.col.what": Record<string, never>
  "host.list.col.where": Record<string, never>
  "host.list.decision_hint": Record<string, never>
  "host.list.decision_title": { "count": string }
  "host.list.empty.body": Record<string, never>
  "host.list.empty.title": Record<string, never>
  "host.list.intro": Record<string, never>
  "host.list.intro_ready": Record<string, never>
  "host.list.mixed.body": Record<string, never>
  "host.list.mixed.body_warn": Record<string, never>
  "host.list.mixed.title": Record<string, never>
  "host.list.more": { "count": string }
  "host.list.parent_accept": { "parent_name": string }
  "host.list.parent_reject": Record<string, never>
  "host.list.parent_suggestion": { "parent_name": string }
  "host.list.pool.title": Record<string, never>
  "host.list.project_first.body": Record<string, never>
  "host.list.project_first.cta": Record<string, never>
  "host.list.project_first.title": Record<string, never>
  "host.list.suggestion_accept": { "project_name": string }
  "host.list.suggestion_pick": Record<string, never>
  "host.list.title": Record<string, never>
  "host.list.unassigned_banner": { "count": string }
  "host.list.unassigned_hint": Record<string, never>
  "host.list.unassigned_hint_none": Record<string, never>
  "host.list.unassigned_title": { "count": string }
  "host.location.at_vendor": { "region": string; "vendor": string }
  "host.location.lan": Record<string, never>
  "host.meta.line": { "region": string; "spec": string; "vendor": string }
  "host.meta.managed_days": { "days": string }
  "host.metric.cpu.busy": Record<string, never>
  "host.metric.cpu.idle": Record<string, never>
  "host.metric.cpu.label": Record<string, never>
  "host.metric.cpu.overloaded": Record<string, never>
  "host.metric.disk.filling": Record<string, never>
  "host.metric.disk.full": Record<string, never>
  "host.metric.disk.label": Record<string, never>
  "host.metric.disk.ok": Record<string, never>
  "host.metric.memory.label": Record<string, never>
  "host.metric.memory.ok": Record<string, never>
  "host.metric.memory.tight": Record<string, never>
  "host.occupancy.unassigned": Record<string, never>
  "host.overview.all": Record<string, never>
  "host.overview.assigned": Record<string, never>
  "host.overview.available": Record<string, never>
  "host.overview.exception": Record<string, never>
  "host.overview.pending": Record<string, never>
  "host.probe.disconnected": Record<string, never>
  "host.reach.blocked": Record<string, never>
  "host.reach.credential": Record<string, never>
  "host.reach.fail_streak": { "count": string }
  "host.reach.host_key_changed": Record<string, never>
  "host.reach.never_succeeded": Record<string, never>
  "host.reach.ok": { "when": string }
  "host.reach.stale": { "since": string }
  "host.reach.unknown": Record<string, never>
  "host.recent.heading": Record<string, never>
  "host.recent.today": Record<string, never>
  "host.recent.yesterday": Record<string, never>
  "host.recheck.action": Record<string, never>
  "host.recheck.failed": Record<string, never>
  "host.recheck.running": Record<string, never>
  "host.recheck.still_unknown": Record<string, never>
  "host.reparent.reject": { "parent_recorded_name": string }
  "host.reparent.suggest": { "parent_observed_name": string; "parent_recorded_name": string }
  "host.reparent.suggest.neither": Record<string, never>
  "host.reparent.suggest.observed_only": { "parent_observed_name": string }
  "host.reparent.suggest.recorded_only": { "parent_recorded_name": string }
  "host.status.credential": Record<string, never>
  "host.status.disk_filling": Record<string, never>
  "host.status.error": Record<string, never>
  "host.status.offline": Record<string, never>
  "host.status.onboarding": Record<string, never>
  "host.status.online": Record<string, never>
  "host.status.provisioning": Record<string, never>
  "host.status.reclaimed": Record<string, never>
  "host.summary.backend_and_db": { "project_name": string; "who_uses": string }
  "host.summary.critical_suffix": { "consequence": string }
  "host.summary.frontend": Record<string, never>
  "host.summary.heading": Record<string, never>
  "host.summary.unassigned": Record<string, never>
  "host.workloads.heading": Record<string, never>
  "job.canceled": Record<string, never>
  "job.failed": { "step": string; "title": string }
  "job.resumed": Record<string, never>
  "job.started": { "title": string }
  "job.step.done": { "index": string; "step": string; "title": string; "total": string }
  "job.step.not_started": Record<string, never>
  "job.stopped.budget_used_up": { "limit": string; "used": string }
  "job.stopped.no_progress": { "minutes": string; "step": string }
  "job.stopped.too_long": { "minutes": string; "step": string }
  "job.stopped.too_many_steps": { "steps": string }
  "job.succeeded": { "seconds": string; "title": string }
  "lulu.history.hidden_entry": Record<string, never>
  "lulu.reply.accepted": { "kind": string }
  "lulu.reply.action_pending": { "action": string; "receipt": string }
  "lulu.reply.action_recorded": { "action": string; "receipt": string }
  "lulu.reply.candidate_missing": Record<string, never>
  "lulu.reply.candidate_present": { "sha": string }
  "lulu.reply.mentioned_not_here": { "name": string }
  "lulu.reply.mentioned_someone": Record<string, never>
  "lulu.reply.red_needs_owner": { "owner": string }
  "lulu.reply.task_status": { "attempt": string; "state": string }
  "lulu.reply.watcher_noted": { "owner": string }
  "lulu.reply.watcher_noted_no_owner": Record<string, never>
  "lulu_agents.add": Record<string, never>
  "lulu_agents.autofill": Record<string, never>
  "lulu_agents.autofill_done": { "executor": string; "tags": string }
  "lulu_agents.autofill_done_no_executor": { "tags": string }
  "lulu_agents.autofill_failed": Record<string, never>
  "lulu_agents.autofill_hint": Record<string, never>
  "lulu_agents.autofill_unsure": Record<string, never>
  "lulu_agents.autofill_working": Record<string, never>
  "lulu_agents.cancel": Record<string, never>
  "lulu_agents.col_agent": Record<string, never>
  "lulu_agents.col_executor": Record<string, never>
  "lulu_agents.col_model": Record<string, never>
  "lulu_agents.col_responsibilities": Record<string, never>
  "lulu_agents.col_role": Record<string, never>
  "lulu_agents.col_scope": Record<string, never>
  "lulu_agents.col_state": Record<string, never>
  "lulu_agents.count": { "count": string }
  "lulu_agents.create": Record<string, never>
  "lulu_agents.create_failed": Record<string, never>
  "lulu_agents.dialog_desc": Record<string, never>
  "lulu_agents.dialog_title": Record<string, never>
  "lulu_agents.disable": Record<string, never>
  "lulu_agents.disable_note": Record<string, never>
  "lulu_agents.edit": Record<string, never>
  "lulu_agents.edit_dialog_desc": Record<string, never>
  "lulu_agents.edit_dialog_title": { "name": string }
  "lulu_agents.empty": Record<string, never>
  "lulu_agents.executor_unbound": Record<string, never>
  "lulu_agents.f_name": Record<string, never>
  "lulu_agents.f_name_hint": Record<string, never>
  "lulu_agents.f_responsibilities": Record<string, never>
  "lulu_agents.f_responsibilities_empty": Record<string, never>
  "lulu_agents.f_responsibilities_hint": Record<string, never>
  "lulu_agents.f_role": Record<string, never>
  "lulu_agents.f_role_hint": Record<string, never>
  "lulu_agents.f_scope": Record<string, never>
  "lulu_agents.f_scope_hint": Record<string, never>
  "lulu_agents.identity_note": Record<string, never>
  "lulu_agents.model_disabled": Record<string, never>
  "lulu_agents.model_no_key": Record<string, never>
  "lulu_agents.model_not_callable": Record<string, never>
  "lulu_agents.model_not_implemented": Record<string, never>
  "lulu_agents.model_not_wired": Record<string, never>
  "lulu_agents.model_quota_exhausted": Record<string, never>
  "lulu_agents.model_rate_limited": Record<string, never>
  "lulu_agents.model_unavailable": Record<string, never>
  "lulu_agents.model_unknown": Record<string, never>
  "lulu_agents.model_unlisted": Record<string, never>
  "lulu_agents.model_unset": Record<string, never>
  "lulu_agents.model_unverified": Record<string, never>
  "lulu_agents.resp_architect": Record<string, never>
  "lulu_agents.resp_backend": Record<string, never>
  "lulu_agents.resp_frontend": Record<string, never>
  "lulu_agents.resp_ops": Record<string, never>
  "lulu_agents.resp_product_design": Record<string, never>
  "lulu_agents.resp_qa": Record<string, never>
  "lulu_agents.resp_release": Record<string, never>
  "lulu_agents.resp_research": Record<string, never>
  "lulu_agents.resp_review": Record<string, never>
  "lulu_agents.resp_ui_design": Record<string, never>
  "lulu_agents.save": Record<string, never>
  "lulu_agents.save_failed": Record<string, never>
  "lulu_agents.scope_account": Record<string, never>
  "lulu_agents.scope_project": Record<string, never>
  "lulu_agents.speak.here": { "role": string }
  "lulu_agents.speak.here_no_role": Record<string, never>
  "lulu_agents.speak.need_more": Record<string, never>
  "lulu_agents.speak.not_mine": Record<string, never>
  "lulu_agents.speak.on_it": Record<string, never>
  "lulu_agents.state_available": Record<string, never>
  "lulu_agents.state_disabled": Record<string, never>
  "lulu_agents.sub": Record<string, never>
  "lulu_agents.title": Record<string, never>
  "lulu_agents.unreachable": Record<string, never>
  "lulu_agents.why_body": Record<string, never>
  "lulu_agents.why_heading": Record<string, never>
  "lulu_agents.why_title": Record<string, never>
  "lulu_workbench.attach.action": Record<string, never>
  "lulu_workbench.attach.bad_type": Record<string, never>
  "lulu_workbench.attach.download": Record<string, never>
  "lulu_workbench.attach.failed": Record<string, never>
  "lulu_workbench.attach.kind_image": Record<string, never>
  "lulu_workbench.attach.kind_json": Record<string, never>
  "lulu_workbench.attach.kind_pdf": Record<string, never>
  "lulu_workbench.attach.kind_table": Record<string, never>
  "lulu_workbench.attach.kind_text": Record<string, never>
  "lulu_workbench.attach.kind_zip": Record<string, never>
  "lulu_workbench.attach.remove": Record<string, never>
  "lulu_workbench.attach.retry": Record<string, never>
  "lulu_workbench.attach.too_large": Record<string, never>
  "lulu_workbench.attach.too_many": Record<string, never>
  "lulu_workbench.attach.uploading": Record<string, never>
  "lulu_workbench.attach.wait_upload": Record<string, never>
  "lulu_workbench.attribution.declared": Record<string, never>
  "lulu_workbench.attribution.platform": Record<string, never>
  "lulu_workbench.attribution.self": Record<string, never>
  "lulu_workbench.bind.already": Record<string, never>
  "lulu_workbench.bind.do": { "name": string }
  "lulu_workbench.bind.failed": Record<string, never>
  "lulu_workbench.bind.keep_chatting": Record<string, never>
  "lulu_workbench.bind.kind_code": Record<string, never>
  "lulu_workbench.bind.kind_deploy": Record<string, never>
  "lulu_workbench.bind.kind_resource": Record<string, never>
  "lulu_workbench.bind.needed": { "what": string }
  "lulu_workbench.bind.one_way": Record<string, never>
  "lulu_workbench.bind.pick": Record<string, never>
  "lulu_workbench.bind.skip": Record<string, never>
  "lulu_workbench.blocked.no_eligible_executor": Record<string, never>
  "lulu_workbench.board.auto_start": Record<string, never>
  "lulu_workbench.board.queue_reason": Record<string, never>
  "lulu_workbench.board.undo": Record<string, never>
  "lulu_workbench.board.undo_confirm": Record<string, never>
  "lulu_workbench.board.undo_done": Record<string, never>
  "lulu_workbench.board.undo_failed": Record<string, never>
  "lulu_workbench.chat.new_below": Record<string, never>
  "lulu_workbench.chat.stop": Record<string, never>
  "lulu_workbench.chat.thinking": { "seconds": string }
  "lulu_workbench.chat.thinking_phase": { "phase": string; "seconds": string }
  "lulu_workbench.chat.thinking_tokens": { "phase": string; "seconds": string; "tokens": string }
  "lulu_workbench.composer.key_hint": Record<string, never>
  "lulu_workbench.composer.ph_first": Record<string, never>
  "lulu_workbench.composer.ph_more": Record<string, never>
  "lulu_workbench.composer.ph_offline": Record<string, never>
  "lulu_workbench.composer.ph_project": Record<string, never>
  "lulu_workbench.composer.plan_only_chip": Record<string, never>
  "lulu_workbench.composer.send": Record<string, never>
  "lulu_workbench.composer.send_failed": Record<string, never>
  "lulu_workbench.composer.sending": Record<string, never>
  "lulu_workbench.convfail.draft_kept": Record<string, never>
  "lulu_workbench.convfail.headline": Record<string, never>
  "lulu_workbench.convfail.project_kept": Record<string, never>
  "lulu_workbench.convfail.retry_last_step": Record<string, never>
  "lulu_workbench.convfail.why_no_rollback": Record<string, never>
  "lulu_workbench.convfail.wont_delete": Record<string, never>
  "lulu_workbench.disable.cancel": Record<string, never>
  "lulu_workbench.disable.clean": Record<string, never>
  "lulu_workbench.disable.confirm": Record<string, never>
  "lulu_workbench.disable.conversations_truncated": Record<string, never>
  "lulu_workbench.disable.failed": Record<string, never>
  "lulu_workbench.disable.pending": { "count": string }
  "lulu_workbench.disable.running": { "count": string }
  "lulu_workbench.disable.seats": { "count": string }
  "lulu_workbench.disable.sessions": { "count": string }
  "lulu_workbench.disable.title": { "agent": string }
  "lulu_workbench.empty.desc": Record<string, never>
  "lulu_workbench.empty.foot": Record<string, never>
  "lulu_workbench.empty.s1_d": Record<string, never>
  "lulu_workbench.empty.s1_t": Record<string, never>
  "lulu_workbench.empty.s2_d": Record<string, never>
  "lulu_workbench.empty.s2_t": Record<string, never>
  "lulu_workbench.empty.s3_d": Record<string, never>
  "lulu_workbench.empty.s3_t": Record<string, never>
  "lulu_workbench.empty.s4_d": Record<string, never>
  "lulu_workbench.empty.s4_t": Record<string, never>
  "lulu_workbench.empty.title": Record<string, never>
  "lulu_workbench.evidence.empty": Record<string, never>
  "lulu_workbench.evidence.from_sub": { "agent": string }
  "lulu_workbench.evidence.on_parent": { "item": string }
  "lulu_workbench.evidence.title": Record<string, never>
  "lulu_workbench.folder.empty": Record<string, never>
  "lulu_workbench.folder.git_clean": Record<string, never>
  "lulu_workbench.folder.git_dirty": { "count": string }
  "lulu_workbench.folder.no_permission": Record<string, never>
  "lulu_workbench.folder.not_git": Record<string, never>
  "lulu_workbench.folder.open_settings": Record<string, never>
  "lulu_workbench.folder.pick_another": Record<string, never>
  "lulu_workbench.folder.readonly_promise": Record<string, never>
  "lulu_workbench.folder.stale_fix": Record<string, never>
  "lulu_workbench.folder.stale_not_broken": Record<string, never>
  "lulu_workbench.folder.stale_path": Record<string, never>
  "lulu_workbench.folder.taken": { "project": string }
  "lulu_workbench.folder.taken_why": Record<string, never>
  "lulu_workbench.gap.detail": Record<string, never>
  "lulu_workbench.gap.not_wired": { "what": string }
  "lulu_workbench.gap.unreachable": { "what": string }
  "lulu_workbench.held.dont_resubmit": Record<string, never>
  "lulu_workbench.held.idempotent": Record<string, never>
  "lulu_workbench.held.not_your_fault": Record<string, never>
  "lulu_workbench.held.production_fine": Record<string, never>
  "lulu_workbench.init.blocked_by_prev": Record<string, never>
  "lulu_workbench.init.not_ready_yet": Record<string, never>
  "lulu_workbench.init.same_key": Record<string, never>
  "lulu_workbench.init.stage_conversation": Record<string, never>
  "lulu_workbench.init.stage_project": Record<string, never>
  "lulu_workbench.init.stage_repo": Record<string, never>
  "lulu_workbench.init.state_done": Record<string, never>
  "lulu_workbench.init.state_fail": Record<string, never>
  "lulu_workbench.init.state_none": Record<string, never>
  "lulu_workbench.init.state_running": Record<string, never>
  "lulu_workbench.init.state_wait": Record<string, never>
  "lulu_workbench.item.block": Record<string, never>
  "lulu_workbench.item.closed": Record<string, never>
  "lulu_workbench.item.done": Record<string, never>
  "lulu_workbench.item.fail": Record<string, never>
  "lulu_workbench.item.held": Record<string, never>
  "lulu_workbench.item.none": Record<string, never>
  "lulu_workbench.item.rec": Record<string, never>
  "lulu_workbench.item.run": Record<string, never>
  "lulu_workbench.item.todo": Record<string, never>
  "lulu_workbench.item.unknown": Record<string, never>
  "lulu_workbench.item.wait": Record<string, never>
  "lulu_workbench.launch.direct_k": Record<string, never>
  "lulu_workbench.launch.direct_v": Record<string, never>
  "lulu_workbench.launch.folder_readonly": Record<string, never>
  "lulu_workbench.launch.how_else_k": Record<string, never>
  "lulu_workbench.launch.how_else_v": Record<string, never>
  "lulu_workbench.launch.import_project": Record<string, never>
  "lulu_workbench.launch.loading_desc": Record<string, never>
  "lulu_workbench.launch.loading_title": Record<string, never>
  "lulu_workbench.launch.mac_only_desc": Record<string, never>
  "lulu_workbench.launch.mac_only_title": Record<string, never>
  "lulu_workbench.launch.mode_change_k": Record<string, never>
  "lulu_workbench.launch.mode_change_v": Record<string, never>
  "lulu_workbench.launch.mode_default_k": Record<string, never>
  "lulu_workbench.launch.mode_default_v": Record<string, never>
  "lulu_workbench.launch.mode_desc": Record<string, never>
  "lulu_workbench.launch.mode_not_persisted": Record<string, never>
  "lulu_workbench.launch.mode_solo_k": Record<string, never>
  "lulu_workbench.launch.mode_solo_v": Record<string, never>
  "lulu_workbench.launch.mode_team_k": Record<string, never>
  "lulu_workbench.launch.mode_team_v": Record<string, never>
  "lulu_workbench.launch.mode_title": Record<string, never>
  "lulu_workbench.launch.new_folder": Record<string, never>
  "lulu_workbench.launch.new_project": Record<string, never>
  "lulu_workbench.launch.new_title": Record<string, never>
  "lulu_workbench.launch.path_desc_web": Record<string, never>
  "lulu_workbench.launch.path_title": Record<string, never>
  "lulu_workbench.launch.pick_folder": Record<string, never>
  "lulu_workbench.launch.picked_k": Record<string, never>
  "lulu_workbench.launch.picked_v": Record<string, never>
  "lulu_workbench.launch.read_failed": Record<string, never>
  "lulu_workbench.launch.really_none": Record<string, never>
  "lulu_workbench.launch.recent_foot": Record<string, never>
  "lulu_workbench.launch.recent_meta": Record<string, never>
  "lulu_workbench.launch.recent_title": Record<string, never>
  "lulu_workbench.launch.retry": Record<string, never>
  "lulu_workbench.launch.search_clear": Record<string, never>
  "lulu_workbench.launch.search_create": { "keyword": string }
  "lulu_workbench.launch.search_hint": Record<string, never>
  "lulu_workbench.launch.search_none": { "keyword": string }
  "lulu_workbench.launch.start_failed": Record<string, never>
  "lulu_workbench.launch.start_solo": Record<string, never>
  "lulu_workbench.launch.start_team": Record<string, never>
  "lulu_workbench.launch.starting": Record<string, never>
  "lulu_workbench.launch.sub": Record<string, never>
  "lulu_workbench.launch.title": Record<string, never>
  "lulu_workbench.launch.title_shows_k": Record<string, never>
  "lulu_workbench.launch.title_shows_v": Record<string, never>
  "lulu_workbench.launch.unverified": Record<string, never>
  "lulu_workbench.mention.empty": Record<string, never>
  "lulu_workbench.mention.group_here": Record<string, never>
  "lulu_workbench.mention.group_invite_people": Record<string, never>
  "lulu_workbench.mention.group_library": Record<string, never>
  "lulu_workbench.mention.group_people": Record<string, never>
  "lulu_workbench.mention.join_failed": Record<string, never>
  "lulu_workbench.mention.joining": Record<string, never>
  "lulu_workbench.mention.no_team_change": Record<string, never>
  "lulu_workbench.mention.own_memory": Record<string, never>
  "lulu_workbench.mention.person_hint": Record<string, never>
  "lulu_workbench.mention.sub_excluded": Record<string, never>
  "lulu_workbench.mention.title": Record<string, never>
  "lulu_workbench.model.auto": Record<string, never>
  "lulu_workbench.model.effort_fast": Record<string, never>
  "lulu_workbench.model.effort_max": Record<string, never>
  "lulu_workbench.model.effort_sheet_sub": Record<string, never>
  "lulu_workbench.model.effort_sheet_title": Record<string, never>
  "lulu_workbench.model.effort_standard": Record<string, never>
  "lulu_workbench.model.group_default": Record<string, never>
  "lulu_workbench.model.group_fixed": Record<string, never>
  "lulu_workbench.model.next_message_only": Record<string, never>
  "lulu_workbench.model.picker_sub": Record<string, never>
  "lulu_workbench.model.picker_title": Record<string, never>
  "lulu_workbench.model.pinned": Record<string, never>
  "lulu_workbench.model.reason_expired": Record<string, never>
  "lulu_workbench.model.reason_quota": Record<string, never>
  "lulu_workbench.model.runtime_not_wired": Record<string, never>
  "lulu_workbench.model.scope_note": Record<string, never>
  "lulu_workbench.model.sheet_foot": Record<string, never>
  "lulu_workbench.model.unavailable": { "model": string; "reason": string }
  "lulu_workbench.model.unverified": Record<string, never>
  "lulu_workbench.model.unverified_note": Record<string, never>
  "lulu_workbench.model.wont_switch": Record<string, never>
  "lulu_workbench.people.add_hint": Record<string, never>
  "lulu_workbench.people.cannot_dispatch": Record<string, never>
  "lulu_workbench.people.invite": Record<string, never>
  "lulu_workbench.people.invite_failed": Record<string, never>
  "lulu_workbench.people.invite_none": Record<string, never>
  "lulu_workbench.people.inviting": Record<string, never>
  "lulu_workbench.people.none": Record<string, never>
  "lulu_workbench.people.remove": Record<string, never>
  "lulu_workbench.people.remove_failed": Record<string, never>
  "lulu_workbench.people.removing": Record<string, never>
  "lulu_workbench.people.role.operator": Record<string, never>
  "lulu_workbench.people.role.owner": Record<string, never>
  "lulu_workbench.people.role.unknown": Record<string, never>
  "lulu_workbench.people.role.viewer": Record<string, never>
  "lulu_workbench.people.title": Record<string, never>
  "lulu_workbench.plan.acceptance_label": Record<string, never>
  "lulu_workbench.plan.already": Record<string, never>
  "lulu_workbench.plan.current": { "revision": string }
  "lulu_workbench.plan.failed": Record<string, never>
  "lulu_workbench.plan.headline": Record<string, never>
  "lulu_workbench.plan.none": Record<string, never>
  "lulu_workbench.plan.objective_label": Record<string, never>
  "lulu_workbench.plan.revise": Record<string, never>
  "lulu_workbench.plan.roster_changed": { "now": string; "planned": string }
  "lulu_workbench.plan.same_roster": { "count": string }
  "lulu_workbench.plan.start": Record<string, never>
  "lulu_workbench.presence.last_seen": { "when": string }
  "lulu_workbench.presence.unknown": Record<string, never>
  "lulu_workbench.rail.group_general": Record<string, never>
  "lulu_workbench.rail.new_conversation": Record<string, never>
  "lulu_workbench.rail.recents": Record<string, never>
  "lulu_workbench.recover.catching_up": { "count": string }
  "lulu_workbench.recover.headline": Record<string, never>
  "lulu_workbench.recover.idle": { "who": string }
  "lulu_workbench.recover.nothing_running": Record<string, never>
  "lulu_workbench.recover.what_happened": { "what": string; "who": string }
  "lulu_workbench.red.card_approve": Record<string, never>
  "lulu_workbench.red.card_ask": Record<string, never>
  "lulu_workbench.red.card_ask_seed": Record<string, never>
  "lulu_workbench.red.card_failed": Record<string, never>
  "lulu_workbench.red.card_reject": Record<string, never>
  "lulu_workbench.red.card_settled": Record<string, never>
  "lulu_workbench.red.expired": Record<string, never>
  "lulu_workbench.red.expires_in": { "duration": string }
  "lulu_workbench.red.kind_access_policy": Record<string, never>
  "lulu_workbench.red.kind_data_migration": Record<string, never>
  "lulu_workbench.red.kind_delete_data": Record<string, never>
  "lulu_workbench.red.kind_irreversible_infra": Record<string, never>
  "lulu_workbench.red.kind_spend_money": Record<string, never>
  "lulu_workbench.red.never_for_you": Record<string, never>
  "lulu_workbench.red.q_after": Record<string, never>
  "lulu_workbench.red.q_alternative": Record<string, never>
  "lulu_workbench.red.q_backup": Record<string, never>
  "lulu_workbench.red.q_frozen": Record<string, never>
  "lulu_workbench.red.q_undo": Record<string, never>
  "lulu_workbench.red.q_valid_for": Record<string, never>
  "lulu_workbench.red.q_what": Record<string, never>
  "lulu_workbench.red.q_why": Record<string, never>
  "lulu_workbench.red.recommended": Record<string, never>
  "lulu_workbench.red.scopes_frozen": Record<string, never>
  "lulu_workbench.run.action.cancel": Record<string, never>
  "lulu_workbench.run.action.confirm": Record<string, never>
  "lulu_workbench.run.action.confirm_all": Record<string, never>
  "lulu_workbench.run.action.confirm_one": Record<string, never>
  "lulu_workbench.run.action.confirm_round": Record<string, never>
  "lulu_workbench.run.action.failed": Record<string, never>
  "lulu_workbench.run.action.pause": Record<string, never>
  "lulu_workbench.run.action.resume": Record<string, never>
  "lulu_workbench.run.action.round_already_stopped": Record<string, never>
  "lulu_workbench.run.action.round_failed": Record<string, never>
  "lulu_workbench.run.action.round_stopped": { "count": string }
  "lulu_workbench.run.action.stop": Record<string, never>
  "lulu_workbench.run.action.stop_all": Record<string, never>
  "lulu_workbench.run.action.stop_round": Record<string, never>
  "lulu_workbench.run.check.failed": Record<string, never>
  "lulu_workbench.run.check.passed": Record<string, never>
  "lulu_workbench.run.check.skipped": Record<string, never>
  "lulu_workbench.run.column.agent": Record<string, never>
  "lulu_workbench.run.column.elapsed": Record<string, never>
  "lulu_workbench.run.column.model": Record<string, never>
  "lulu_workbench.run.column.token": Record<string, never>
  "lulu_workbench.run.detail.back": Record<string, never>
  "lulu_workbench.run.detail.evidence": Record<string, never>
  "lulu_workbench.run.detail.responsibility": Record<string, never>
  "lulu_workbench.run.details.open": Record<string, never>
  "lulu_workbench.run.details.unresolved": { "n": string }
  "lulu_workbench.run.duration.minutes": { "n": string }
  "lulu_workbench.run.duration.seconds": { "n": string }
  "lulu_workbench.run.empty": Record<string, never>
  "lulu_workbench.run.footer": Record<string, never>
  "lulu_workbench.run.heading.finished": { "count": string }
  "lulu_workbench.run.meta": { "agents": string; "phases": string }
  "lulu_workbench.run.nothing_to_verify": Record<string, never>
  "lulu_workbench.run.paused": Record<string, never>
  "lulu_workbench.run.phase.count": { "done": string; "total": string }
  "lulu_workbench.run.process.collapsed": { "duration": string; "steps": string }
  "lulu_workbench.run.process.needs_you": Record<string, never>
  "lulu_workbench.run.process.running": Record<string, never>
  "lulu_workbench.run.process.title": Record<string, never>
  "lulu_workbench.run.release.deployed": { "sha": string }
  "lulu_workbench.run.release.deployed_label": Record<string, never>
  "lulu_workbench.run.release.health": Record<string, never>
  "lulu_workbench.run.release.merged": { "sha": string }
  "lulu_workbench.run.release.merged_label": Record<string, never>
  "lulu_workbench.run.release.pending": Record<string, never>
  "lulu_workbench.run.release.production_verified": Record<string, never>
  "lulu_workbench.run.release.rollback": Record<string, never>
  "lulu_workbench.run.release.rolled_back": Record<string, never>
  "lulu_workbench.run.release.rolled_back_label": Record<string, never>
  "lulu_workbench.run.release.smoke": Record<string, never>
  "lulu_workbench.run.section.artifacts": Record<string, never>
  "lulu_workbench.run.section.changes": Record<string, never>
  "lulu_workbench.run.section.checks": Record<string, never>
  "lulu_workbench.run.section.did": Record<string, never>
  "lulu_workbench.run.section.next": Record<string, never>
  "lulu_workbench.run.section.release": Record<string, never>
  "lulu_workbench.run.section.risks": Record<string, never>
  "lulu_workbench.run.sha.copied": Record<string, never>
  "lulu_workbench.run.sha.copy": Record<string, never>
  "lulu_workbench.run.status.cancelled": Record<string, never>
  "lulu_workbench.run.status.completed": Record<string, never>
  "lulu_workbench.run.status.failed": Record<string, never>
  "lulu_workbench.run.status.partial": Record<string, never>
  "lulu_workbench.run.step.agent_completed": Record<string, never>
  "lulu_workbench.run.step.agent_joined": Record<string, never>
  "lulu_workbench.run.step.agent_progress": Record<string, never>
  "lulu_workbench.run.step.agent_recovered": Record<string, never>
  "lulu_workbench.run.step.agent_stopped": Record<string, never>
  "lulu_workbench.run.step.item_cancelled": Record<string, never>
  "lulu_workbench.run.step.item_completed": Record<string, never>
  "lulu_workbench.run.step.item_failed": Record<string, never>
  "lulu_workbench.run.step.item_ready": Record<string, never>
  "lulu_workbench.run.step.item_recovering": Record<string, never>
  "lulu_workbench.run.step.item_running": Record<string, never>
  "lulu_workbench.run.step.item_waiting": Record<string, never>
  "lulu_workbench.run.step.plan_ready": Record<string, never>
  "lulu_workbench.run.step.result_available": Record<string, never>
  "lulu_workbench.run.step.waiting": Record<string, never>
  "lulu_workbench.run.stream.unknown": Record<string, never>
  "lulu_workbench.run.summary.default_title": Record<string, never>
  "lulu_workbench.run.summary.meta": { "agents": string; "done": string; "phases": string }
  "lulu_workbench.run.summary.open": Record<string, never>
  "lulu_workbench.run.unverified": Record<string, never>
  "lulu_workbench.settle.artifact.branch": Record<string, never>
  "lulu_workbench.settle.artifact.commit": Record<string, never>
  "lulu_workbench.settle.artifact.task": Record<string, never>
  "lulu_workbench.settle.headline.cancelled": Record<string, never>
  "lulu_workbench.settle.headline.completed": { "total": string }
  "lulu_workbench.settle.headline.failed": Record<string, never>
  "lulu_workbench.settle.headline.partial": { "done": string; "total": string }
  "lulu_workbench.sidecar.add_agent": Record<string, never>
  "lulu_workbench.sidecar.back_to_chat": Record<string, never>
  "lulu_workbench.sidecar.close": Record<string, never>
  "lulu_workbench.sidecar.keep_state": Record<string, never>
  "lulu_workbench.sidecar.tab_board": Record<string, never>
  "lulu_workbench.sidecar.tab_decisions": Record<string, never>
  "lulu_workbench.sidecar.tab_evidence": Record<string, never>
  "lulu_workbench.sidecar.tab_team": Record<string, never>
  "lulu_workbench.sidecar.title_work": Record<string, never>
  "lulu_workbench.sidecar.width_hint": Record<string, never>
  "lulu_workbench.skills.ago_days": { "n": string }
  "lulu_workbench.skills.ago_hours": { "n": string }
  "lulu_workbench.skills.ago_minutes": { "n": string }
  "lulu_workbench.skills.ago_now": Record<string, never>
  "lulu_workbench.skills.disabled": Record<string, never>
  "lulu_workbench.skills.empty": Record<string, never>
  "lulu_workbench.skills.enabled": Record<string, never>
  "lulu_workbench.skills.last_run": { "state": string; "when": string }
  "lulu_workbench.skills.last_run_failed": Record<string, never>
  "lulu_workbench.skills.last_run_ok": Record<string, never>
  "lulu_workbench.skills.never_ran": Record<string, never>
  "lulu_workbench.skills.section": Record<string, never>
  "lulu_workbench.skills.section_hint": Record<string, never>
  "lulu_workbench.skills.toggle_failed": Record<string, never>
  "lulu_workbench.skills.trigger_daily": { "at": string }
  "lulu_workbench.skills.trigger_say": { "phrase": string }
  "lulu_workbench.slash.effort": { "tier": string }
  "lulu_workbench.slash.effort_hint": Record<string, never>
  "lulu_workbench.slash.empty": Record<string, never>
  "lulu_workbench.slash.keys": Record<string, never>
  "lulu_workbench.slash.new": Record<string, never>
  "lulu_workbench.slash.new_hint": Record<string, never>
  "lulu_workbench.slash.plan_only_hint": Record<string, never>
  "lulu_workbench.slash.plan_only_off": Record<string, never>
  "lulu_workbench.slash.plan_only_on": Record<string, never>
  "lulu_workbench.slash.rename": Record<string, never>
  "lulu_workbench.slash.rename_failed": Record<string, never>
  "lulu_workbench.slash.rename_hint": { "title": string }
  "lulu_workbench.slash.rename_hint_empty": Record<string, never>
  "lulu_workbench.slash.skill_hint": { "utterance": string }
  "lulu_workbench.slash.stop_hint": Record<string, never>
  "lulu_workbench.slash.title": Record<string, never>
  "lulu_workbench.state.blocked": Record<string, never>
  "lulu_workbench.state.completed": Record<string, never>
  "lulu_workbench.state.disconnected": Record<string, never>
  "lulu_workbench.state.discussing": Record<string, never>
  "lulu_workbench.state.failed": Record<string, never>
  "lulu_workbench.state.planning": Record<string, never>
  "lulu_workbench.state.platform_held": Record<string, never>
  "lulu_workbench.state.recovering": Record<string, never>
  "lulu_workbench.state.running": Record<string, never>
  "lulu_workbench.state.unknown": Record<string, never>
  "lulu_workbench.state.waiting_agent": Record<string, never>
  "lulu_workbench.state.waiting_user": Record<string, never>
  "lulu_workbench.sub.auto_named": Record<string, never>
  "lulu_workbench.sub.boundary": Record<string, never>
  "lulu_workbench.sub.elapsed": { "duration": string }
  "lulu_workbench.sub.evidence_on_parent": Record<string, never>
  "lulu_workbench.sub.no_progress_bar": Record<string, never>
  "lulu_workbench.sub.not_member": Record<string, never>
  "lulu_workbench.sub.parent": Record<string, never>
  "lulu_workbench.sub.stop_isolated": { "parent": string }
  "lulu_workbench.sub.team_unchanged": { "count": string }
  "lulu_workbench.subfail.costs_money": Record<string, never>
  "lulu_workbench.subfail.exit_retry": Record<string, never>
  "lulu_workbench.subfail.exit_swap_model": Record<string, never>
  "lulu_workbench.subfail.exit_takeover": Record<string, never>
  "lulu_workbench.subfail.failed": Record<string, never>
  "lulu_workbench.subfail.headline": { "done": string; "failed": string }
  "lulu_workbench.subfail.keep_done": Record<string, never>
  "lulu_workbench.subfail.my_pick": Record<string, never>
  "lulu_workbench.subfail.no_reason_yet": Record<string, never>
  "lulu_workbench.subfail.no_reopen": Record<string, never>
  "lulu_workbench.team.account_only": Record<string, never>
  "lulu_workbench.team.candidate_count": { "count": string }
  "lulu_workbench.team.empty_ok": Record<string, never>
  "lulu_workbench.team.join": Record<string, never>
  "lulu_workbench.team.join_failed": Record<string, never>
  "lulu_workbench.team.joining": Record<string, never>
  "lulu_workbench.team.member_disabled": Record<string, never>
  "lulu_workbench.team.mention_scope": { "count": string }
  "lulu_workbench.team.only_agents": Record<string, never>
  "lulu_workbench.team.remove_no_interrupt": Record<string, never>
  "lulu_workbench.team.try_one": Record<string, never>
  "lulu_workbench.teambar.adjust": Record<string, never>
  "lulu_workbench.teambar.solo": { "agent": string }
  "lulu_workbench.teambar.team": { "count": string; "mode": string }
  "lulu_workbench.title.bound": Record<string, never>
  "lulu_workbench.title.general": Record<string, never>
  "lulu_workbench.title.no_project": Record<string, never>
  "lulu_workbench.title.offline": Record<string, never>
  "lulu_workbench.title.solo": { "agent": string }
  "lulu_workbench.voice.cancel": Record<string, never>
  "lulu_workbench.voice.no_mic": Record<string, never>
  "lulu_workbench.voice.retry": Record<string, never>
  "lulu_workbench.voice.start": Record<string, never>
  "lulu_workbench.voice.stop": Record<string, never>
  "lulu_workbench.voice.transcribing": Record<string, never>
  "lulu_workbench.voice.unsupported": Record<string, never>
  "memo.access.all": Record<string, never>
  "memo.access.audit": Record<string, never>
  "memo.access.default": Record<string, never>
  "memo.access.filter.empty": Record<string, never>
  "memo.access.hidden": Record<string, never>
  "memo.access.label": Record<string, never>
  "memo.ai.change": Record<string, never>
  "memo.ai.default": Record<string, never>
  "memo.ai.default.desc": Record<string, never>
  "memo.ai.hidden": Record<string, never>
  "memo.ai.hidden.desc": Record<string, never>
  "memo.ai.panel.locked": Record<string, never>
  "memo.ai.panel.readable": Record<string, never>
  "memo.ai.panel.undecided": Record<string, never>
  "memo.ai.shared": Record<string, never>
  "memo.ai.shared.scope.global": Record<string, never>
  "memo.ai.shared.scope.global.desc": Record<string, never>
  "memo.ai.shared.scope.project": Record<string, never>
  "memo.ai.shared.scope.project.desc": Record<string, never>
  "memo.ai.toggle.hide": Record<string, never>
  "memo.ai.toggle.show": Record<string, never>
  "memo.archive.archived.at": { "date": string }
  "memo.archive.delete.note": Record<string, never>
  "memo.archive.delete.note.body": Record<string, never>
  "memo.archive.empty": Record<string, never>
  "memo.archive.empty.title": Record<string, never>
  "memo.archive.entry": Record<string, never>
  "memo.archive.notice": Record<string, never>
  "memo.archive.notice.body": Record<string, never>
  "memo.archive.restore": Record<string, never>
  "memo.archive.subtitle": Record<string, never>
  "memo.archive.title": Record<string, never>
  "memo.candidates.badge": Record<string, never>
  "memo.candidates.confirm": Record<string, never>
  "memo.candidates.confirmed": Record<string, never>
  "memo.candidates.desc": Record<string, never>
  "memo.candidates.discard": Record<string, never>
  "memo.candidates.discarded": Record<string, never>
  "memo.candidates.empty": Record<string, never>
  "memo.candidates.heading": Record<string, never>
  "memo.candidates.only_me": Record<string, never>
  "memo.candidates.source": Record<string, never>
  "memo.candidates.why": Record<string, never>
  "memo.capture.hint": Record<string, never>
  "memo.capture.retry": Record<string, never>
  "memo.capture.save": Record<string, never>
  "memo.capture.saving": Record<string, never>
  "memo.capture.tool.clip": Record<string, never>
  "memo.capture.tool.link": Record<string, never>
  "memo.capture.tool.voice": Record<string, never>
  "memo.capture.tool.voice.cancel": Record<string, never>
  "memo.clip.bytes": { "size": string }
  "memo.clip.fail.foot": { "names": string }
  "memo.clip.reject.size": Record<string, never>
  "memo.clip.reject.type": Record<string, never>
  "memo.clip.remove": Record<string, never>
  "memo.clip.state.done": Record<string, never>
  "memo.clip.state.failed": Record<string, never>
  "memo.clip.state.uploading": { "percent": string }
  "memo.clip.state.waiting": Record<string, never>
  "memo.conflict.body": Record<string, never>
  "memo.conflict.foot": Record<string, never>
  "memo.conflict.mine": Record<string, never>
  "memo.conflict.mine.v": Record<string, never>
  "memo.conflict.option.both": Record<string, never>
  "memo.conflict.option.both.desc": Record<string, never>
  "memo.conflict.option.mine": Record<string, never>
  "memo.conflict.option.mine.desc": Record<string, never>
  "memo.conflict.option.server": Record<string, never>
  "memo.conflict.option.server.desc": Record<string, never>
  "memo.conflict.server": Record<string, never>
  "memo.conflict.server.v": Record<string, never>
  "memo.conflict.title": Record<string, never>
  "memo.crumb.project": Record<string, never>
  "memo.detail.actions.archive": Record<string, never>
  "memo.detail.actions.move": Record<string, never>
  "memo.detail.ai": Record<string, never>
  "memo.detail.ai.reads": Record<string, never>
  "memo.detail.ai.reads.none": Record<string, never>
  "memo.detail.cant.read": Record<string, never>
  "memo.detail.edited": { "date": string }
  "memo.detail.files.none": Record<string, never>
  "memo.detail.group.files": Record<string, never>
  "memo.detail.group.relations": Record<string, never>
  "memo.detail.group.scope": Record<string, never>
  "memo.detail.other.projects": Record<string, never>
  "memo.detail.source.none": Record<string, never>
  "memo.detail.voice.title": { "duration": string }
  "memo.detail.where": Record<string, never>
  "memo.detail.where.global": Record<string, never>
  "memo.detail.where.project": { "project": string }
  "memo.detail.written": { "date": string }
  "memo.empty.filter": Record<string, never>
  "memo.empty.from.misc": Record<string, never>
  "memo.empty.global.body": Record<string, never>
  "memo.empty.global.placeholder": Record<string, never>
  "memo.empty.global.title": Record<string, never>
  "memo.empty.project.body": Record<string, never>
  "memo.empty.project.placeholder": Record<string, never>
  "memo.empty.project.title": Record<string, never>
  "memo.error.body": Record<string, never>
  "memo.error.retry": Record<string, never>
  "memo.error.title": Record<string, never>
  "memo.group.earlier": Record<string, never>
  "memo.group.today": Record<string, never>
  "memo.group.week": Record<string, never>
  "memo.group.yesterday": Record<string, never>
  "memo.image.preview": Record<string, never>
  "memo.link.add": Record<string, never>
  "memo.link.invalid": Record<string, never>
  "memo.link.placeholder": Record<string, never>
  "memo.list.fact.files": { "n": string }
  "memo.list.fact.images": { "n": string }
  "memo.list.filter.all": Record<string, never>
  "memo.list.filter.files": Record<string, never>
  "memo.list.filter.lulu": Record<string, never>
  "memo.list.filter.recent": Record<string, never>
  "memo.list.filter.voice": Record<string, never>
  "memo.list.head.find": Record<string, never>
  "memo.list.recent": Record<string, never>
  "memo.list.recent.meta": { "count": string }
  "memo.list.search": Record<string, never>
  "memo.list.search.clear": Record<string, never>
  "memo.list.search.empty": Record<string, never>
  "memo.list.source.file": Record<string, never>
  "memo.list.source.link": Record<string, never>
  "memo.list.source.lulu": Record<string, never>
  "memo.list.source.text": Record<string, never>
  "memo.list.source.voice": Record<string, never>
  "memo.list.this.project": Record<string, never>
  "memo.list.uploads.waiting": Record<string, never>
  "memo.list.voice.no_text": { "duration": string }
  "memo.loading": Record<string, never>
  "memo.loading.note": Record<string, never>
  "memo.lock.desc": Record<string, never>
  "memo.lock.input": Record<string, never>
  "memo.lock.placeholder": Record<string, never>
  "memo.lock.title": Record<string, never>
  "memo.lock.unlock": Record<string, never>
  "memo.mobile.input": Record<string, never>
  "memo.mobile.search.open": Record<string, never>
  "memo.move.confirm": { "project": string }
  "memo.move.confirm.none": Record<string, never>
  "memo.move.desc": { "body": string }
  "memo.move.foot": Record<string, never>
  "memo.move.invalid.body": { "reason": string }
  "memo.move.invalid.title": Record<string, never>
  "memo.move.invalid.wont.1": Record<string, never>
  "memo.move.invalid.wont.2": Record<string, never>
  "memo.move.invalid.wont.3": Record<string, never>
  "memo.move.note": Record<string, never>
  "memo.move.notice": Record<string, never>
  "memo.move.notice.body": Record<string, never>
  "memo.move.pick.other": Record<string, never>
  "memo.move.row.ai": Record<string, never>
  "memo.move.row.ai.v": Record<string, never>
  "memo.move.row.back": Record<string, never>
  "memo.move.row.back.v": Record<string, never>
  "memo.move.row.delete": Record<string, never>
  "memo.move.row.delete.v": Record<string, never>
  "memo.move.row.to": Record<string, never>
  "memo.move.row.who": Record<string, never>
  "memo.move.row.who.v": Record<string, never>
  "memo.move.title": Record<string, never>
  "memo.move.to.misc": Record<string, never>
  "memo.page.back.list": Record<string, never>
  "memo.page.badge.project": Record<string, never>
  "memo.page.notice.global": Record<string, never>
  "memo.page.notice.global.body": Record<string, never>
  "memo.page.notice.project": Record<string, never>
  "memo.page.notice.project.body": Record<string, never>
  "memo.page.subtitle": Record<string, never>
  "memo.page.subtitle.project": Record<string, never>
  "memo.page.title": Record<string, never>
  "memo.page.title.project": { "project": string }
  "memo.page.write": Record<string, never>
  "memo.password.change": Record<string, never>
  "memo.password.confirm.remove": Record<string, never>
  "memo.password.group": Record<string, never>
  "memo.password.input": Record<string, never>
  "memo.password.none": Record<string, never>
  "memo.password.remove": Record<string, never>
  "memo.password.removed": Record<string, never>
  "memo.password.set": Record<string, never>
  "memo.password.set.ok": Record<string, never>
  "memo.queue.dead": Record<string, never>
  "memo.queue.dead.remove": Record<string, never>
  "memo.quick.badge": Record<string, never>
  "memo.quick.composing.note": Record<string, never>
  "memo.quick.desc.global": Record<string, never>
  "memo.quick.desc.project": Record<string, never>
  "memo.quick.foot": Record<string, never>
  "memo.quick.note": Record<string, never>
  "memo.quick.note.project": Record<string, never>
  "memo.quick.title": Record<string, never>
  "memo.quick.title.project": { "project": string }
  "memo.reads.bar.latest": { "read": string; "total": string }
  "memo.reads.bar.none": Record<string, never>
  "memo.reads.scope.global": Record<string, never>
  "memo.reads.scope.host": Record<string, never>
  "memo.reads.scope.project": Record<string, never>
  "memo.save.fail.body": Record<string, never>
  "memo.save.fail.foot": { "reason": string; "time": string }
  "memo.save.fail.title": Record<string, never>
  "memo.save.giveup": Record<string, never>
  "memo.save.offline.foot": Record<string, never>
  "memo.save.why": Record<string, never>
  "memo.save.why.body": Record<string, never>
  "memo.scope.local": Record<string, never>
  "memo.scope.misc": Record<string, never>
  "memo.scope.save.global": Record<string, never>
  "memo.scope.save.global.note": Record<string, never>
  "memo.scope.save.project": { "project": string }
  "memo.scope.save.project.note": Record<string, never>
  "memo.scope.switch.misc": Record<string, never>
  "memo.search.cross": Record<string, never>
  "memo.undo.action": Record<string, never>
  "memo.undo.archived": Record<string, never>
  "memo.undo.failed": Record<string, never>
  "memo.undo.moved": Record<string, never>
  "memo.view.label": Record<string, never>
  "memo.view.list": Record<string, never>
  "memo.view.tiles": Record<string, never>
  "memo.voice.audition": Record<string, never>
  "memo.voice.cancel": Record<string, never>
  "memo.voice.finish": Record<string, never>
  "memo.voice.level.off": Record<string, never>
  "memo.voice.level.on": Record<string, never>
  "memo.voice.no_mic": Record<string, never>
  "memo.voice.record": Record<string, never>
  "memo.voice.rerecord": Record<string, never>
  "memo.voice.save": Record<string, never>
  "memo.voice.saved": Record<string, never>
  "memo.voice.saving": Record<string, never>
  "memo.voice.search.note": Record<string, never>
  "memo.voice.selfwrite": Record<string, never>
  "memo.voice.stop": Record<string, never>
  "memo.voice.transcribing": Record<string, never>
  "memo.voice.transcript.failed": Record<string, never>
  "memo.voice.transcript.failed.body": Record<string, never>
  "memo.voice.unsupported": Record<string, never>
  "memo.when.date": { "d": string; "m": string }
  "memo.when.full": { "d": string; "m": string; "y": string }
  "memo.when.today": { "time": string }
  "memo.when.yesterday": { "time": string }
  "model.application.action.remove": Record<string, never>
  "model.application.action.save": Record<string, never>
  "model.application.override.hint": Record<string, never>
  "model.application.override.label": Record<string, never>
  "model.application.saved": Record<string, never>
  "model.budget.only_one_brain": Record<string, never>
  "model.budget.switch_cheap": { "provider": string }
  "model.degraded.budget_used_up": Record<string, never>
  "model.degraded.no_answer": Record<string, never>
  "model.degraded.secret_in_paste": Record<string, never>
  "model.developer.action.save": Record<string, never>
  "model.developer.heading": Record<string, never>
  "model.developer.hint": Record<string, never>
  "model.developer.model.auto.detail": Record<string, never>
  "model.developer.model.auto.name": Record<string, never>
  "model.developer.model.deepseek.detail": Record<string, never>
  "model.developer.model.deepseek.name": Record<string, never>
  "model.developer.model.doubao.detail": Record<string, never>
  "model.developer.model.doubao.name": Record<string, never>
  "model.developer.model.kimi.detail": Record<string, never>
  "model.developer.model.kimi.name": Record<string, never>
  "model.developer.provider.plan": Record<string, never>
  "model.developer.recommended": Record<string, never>
  "model.developer.saved": Record<string, never>
  "model.generator.action.save_global": Record<string, never>
  "model.generator.heading": Record<string, never>
  "model.generator.hint": Record<string, never>
  "model.generator.model.doubao.badge": Record<string, never>
  "model.generator.model.doubao.detail": Record<string, never>
  "model.generator.model.doubao.name": Record<string, never>
  "model.generator.model.flash.badge": Record<string, never>
  "model.generator.model.flash.detail": Record<string, never>
  "model.generator.model.flash.name": Record<string, never>
  "model.generator.model.glm.badge": Record<string, never>
  "model.generator.model.glm.detail": Record<string, never>
  "model.generator.model.glm.name": Record<string, never>
  "model.generator.saved": Record<string, never>
  "model.not_connected": Record<string, never>
  "model.provider.plan": Record<string, never>
  "model.reviewer.action.remove_override": Record<string, never>
  "model.reviewer.action.save_global": Record<string, never>
  "model.reviewer.action.save_project": Record<string, never>
  "model.reviewer.action.saving": Record<string, never>
  "model.reviewer.capability.heading": Record<string, never>
  "model.reviewer.effective.label": Record<string, never>
  "model.reviewer.global.heading": Record<string, never>
  "model.reviewer.global.hint": Record<string, never>
  "model.reviewer.model.flash.badge": Record<string, never>
  "model.reviewer.model.flash.detail": Record<string, never>
  "model.reviewer.model.flash.name": Record<string, never>
  "model.reviewer.model.pro.badge": Record<string, never>
  "model.reviewer.model.pro.detail": Record<string, never>
  "model.reviewer.model.pro.name": Record<string, never>
  "model.reviewer.override.hint": Record<string, never>
  "model.reviewer.override.label": Record<string, never>
  "model.reviewer.page.subtitle": Record<string, never>
  "model.reviewer.project.empty": Record<string, never>
  "model.reviewer.project.heading": Record<string, never>
  "model.reviewer.project.hint": Record<string, never>
  "model.reviewer.project.select": Record<string, never>
  "model.reviewer.removed": Record<string, never>
  "model.reviewer.saved": Record<string, never>
  "model.reviewer.source.global": Record<string, never>
  "model.reviewer.source.project": Record<string, never>
  "model.route.developer.deepseek_fallback": Record<string, never>
  "model.route.developer.fix_bug": Record<string, never>
  "model.route.developer.read_repo": Record<string, never>
  "model.route.steward.ark_selected": Record<string, never>
  "model.route.steward.deepseek_selected": Record<string, never>
  "model.steward.action.save": Record<string, never>
  "model.steward.effective.label": Record<string, never>
  "model.steward.heading": Record<string, never>
  "model.steward.hint": Record<string, never>
  "model.steward.model.deepseek.badge": Record<string, never>
  "model.steward.model.deepseek.detail": Record<string, never>
  "model.steward.model.deepseek.name": Record<string, never>
  "model.steward.model.doubao.badge": Record<string, never>
  "model.steward.model.doubao.detail": Record<string, never>
  "model.steward.model.doubao.name": Record<string, never>
  "model.steward.provider.ark": Record<string, never>
  "model.steward.revision": { "revision": string }
  "model.steward.saved": Record<string, never>
  "model.steward.source.global": Record<string, never>
  "model.vendor_not_open": { "vendor": string }
  "model_configuration.access_token_label": Record<string, never>
  "model_configuration.action_target": { "action": string; "name": string }
  "model_configuration.add_and_test": Record<string, never>
  "model_configuration.add_model": Record<string, never>
  "model_configuration.advanced_label": Record<string, never>
  "model_configuration.agent_capabilities_resources": Record<string, never>
  "model_configuration.agent_count": { "count": string }
  "model_configuration.agent_settings_title": Record<string, never>
  "model_configuration.api_key_label": Record<string, never>
  "model_configuration.api_key_placeholder": Record<string, never>
  "model_configuration.api_key_replace_hint": Record<string, never>
  "model_configuration.api_url_label": Record<string, never>
  "model_configuration.app_id_label": Record<string, never>
  "model_configuration.app_id_placeholder": Record<string, never>
  "model_configuration.assist.entry": Record<string, never>
  "model_configuration.assist.hint": Record<string, never>
  "model_configuration.assist.no_base_url": Record<string, never>
  "model_configuration.assist.no_model_id": Record<string, never>
  "model_configuration.assist.nothing": Record<string, never>
  "model_configuration.assist.reasoning": Record<string, never>
  "model_configuration.assist.secret_seen": Record<string, never>
  "model_configuration.assist.unknown_provider": Record<string, never>
  "model_configuration.avatar_select_aria": { "avatar": string }
  "model_configuration.binding_picker_add_select": Record<string, never>
  "model_configuration.binding_picker_catalog_hint": Record<string, never>
  "model_configuration.binding_picker_configure_provider": Record<string, never>
  "model_configuration.binding_picker_connection_label": Record<string, never>
  "model_configuration.binding_picker_connection_placeholder": Record<string, never>
  "model_configuration.binding_picker_connections": Record<string, never>
  "model_configuration.binding_picker_empty_connections": Record<string, never>
  "model_configuration.binding_picker_empty_profiles": Record<string, never>
  "model_configuration.binding_picker_mode": Record<string, never>
  "model_configuration.binding_picker_profiles": Record<string, never>
  "model_configuration.binding_picker_provider_label": Record<string, never>
  "model_configuration.binding_picker_provider_placeholder": Record<string, never>
  "model_configuration.binding_picker_provider_unconfigured": { "provider": string }
  "model_configuration.binding_picker_runtime_hint": Record<string, never>
  "model_configuration.binding_picker_select_existing": Record<string, never>
  "model_configuration.binding_picker_supported_models": Record<string, never>
  "model_configuration.binding_picker_testing": Record<string, never>
  "model_configuration.catalog_loaded": Record<string, never>
  "model_configuration.choose_supported_model": Record<string, never>
  "model_configuration.col_actions": Record<string, never>
  "model_configuration.col_key": Record<string, never>
  "model_configuration.col_model": Record<string, never>
  "model_configuration.col_provider": Record<string, never>
  "model_configuration.col_reasoning": Record<string, never>
  "model_configuration.col_scope": Record<string, never>
  "model_configuration.col_status": Record<string, never>
  "model_configuration.col_tokens": Record<string, never>
  "model_configuration.col_url": Record<string, never>
  "model_configuration.col_vision": Record<string, never>
  "model_configuration.configure_credential_action": Record<string, never>
  "model_configuration.connection_default_name": { "provider": string }
  "model_configuration.connection_details_action": Record<string, never>
  "model_configuration.connection_failed": Record<string, never>
  "model_configuration.connection_key_required_for_discovery": Record<string, never>
  "model_configuration.connection_ready": Record<string, never>
  "model_configuration.connection_settings_action": Record<string, never>
  "model_configuration.connection_shared_notice": { "count": string }
  "model_configuration.credential_configured": { "mask": string }
  "model_configuration.credential_configured_at": { "mask": string; "time": string }
  "model_configuration.credential_first_save_hint": Record<string, never>
  "model_configuration.credential_rotation_hint": { "mask": string }
  "model_configuration.custom_access": Record<string, never>
  "model_configuration.delete_model": Record<string, never>
  "model_configuration.description_label": Record<string, never>
  "model_configuration.direct_connections_advanced": Record<string, never>
  "model_configuration.direct_connections_hint": Record<string, never>
  "model_configuration.disable_model": Record<string, never>
  "model_configuration.discovery_empty": Record<string, never>
  "model_configuration.discovery_manual_only_hint": Record<string, never>
  "model_configuration.discovery_metadata_hint": Record<string, never>
  "model_configuration.discovery_not_supported": Record<string, never>
  "model_configuration.display_name_label": Record<string, never>
  "model_configuration.edit_model": Record<string, never>
  "model_configuration.edit_model_information": Record<string, never>
  "model_configuration.empty_model_library": Record<string, never>
  "model_configuration.empty_model_library_hint": Record<string, never>
  "model_configuration.enable_model": Record<string, never>
  "model_configuration.explicit_model": { "model": string }
  "model_configuration.failure_auth": Record<string, never>
  "model_configuration.failure_incompatible": Record<string, never>
  "model_configuration.failure_model_not_found": Record<string, never>
  "model_configuration.failure_network": Record<string, never>
  "model_configuration.failure_quota_exhausted": Record<string, never>
  "model_configuration.failure_rate_limited": Record<string, never>
  "model_configuration.fetch_models": Record<string, never>
  "model_configuration.fetch_models_again": Record<string, never>
  "model_configuration.filter_aria": { "label": string }
  "model_configuration.finish_agent_information": Record<string, never>
  "model_configuration.form_required": Record<string, never>
  "model_configuration.gateway_address": Record<string, never>
  "model_configuration.gateway_key": Record<string, never>
  "model_configuration.gateway_key_rotation": Record<string, never>
  "model_configuration.gateway_model_source": { "source": string }
  "model_configuration.gateway_models_empty": Record<string, never>
  "model_configuration.gateway_models_loading": Record<string, never>
  "model_configuration.gateway_recommended": Record<string, never>
  "model_configuration.gateway_summary": Record<string, never>
  "model_configuration.impact_agents": Record<string, never>
  "model_configuration.impact_blocked": Record<string, never>
  "model_configuration.impact_clear": Record<string, never>
  "model_configuration.impact_description": Record<string, never>
  "model_configuration.impact_loading": Record<string, never>
  "model_configuration.impact_system_bindings": Record<string, never>
  "model_configuration.load_catalog_models": Record<string, never>
  "model_configuration.load_supported_models": Record<string, never>
  "model_configuration.manual_model_toggle": Record<string, never>
  "model_configuration.max_input_label": Record<string, never>
  "model_configuration.max_output_label": Record<string, never>
  "model_configuration.model_connection_settings_hint": Record<string, never>
  "model_configuration.model_count": { "count": string }
  "model_configuration.model_edit_action": Record<string, never>
  "model_configuration.model_id_label": Record<string, never>
  "model_configuration.model_library_subtitle": Record<string, never>
  "model_configuration.model_library_title": Record<string, never>
  "model_configuration.model_list_heading": Record<string, never>
  "model_configuration.model_saved_test_failed": Record<string, never>
  "model_configuration.modify_agent_information": Record<string, never>
  "model_configuration.module_default_model_aria": { "module": string }
  "model_configuration.no_value": Record<string, never>
  "model_configuration.open_connection_settings": Record<string, never>
  "model_configuration.platform_auto_detected": Record<string, never>
  "model_configuration.platform_connection_hint": Record<string, never>
  "model_configuration.platform_credential_label": Record<string, never>
  "model_configuration.platform_credential_summary": Record<string, never>
  "model_configuration.platform_managed": Record<string, never>
  "model_configuration.platform_model_hint": Record<string, never>
  "model_configuration.platform_name_hint": Record<string, never>
  "model_configuration.platform_status_sync": Record<string, never>
  "model_configuration.project_scope": Record<string, never>
  "model_configuration.project_scope_named": { "project": string }
  "model_configuration.protocol_label": Record<string, never>
  "model_configuration.provider_access": Record<string, never>
  "model_configuration.provider_label": Record<string, never>
  "model_configuration.reasoning_capability_label": Record<string, never>
  "model_configuration.reasoning_default_hint": Record<string, never>
  "model_configuration.reasoning_default_label": Record<string, never>
  "model_configuration.reasoning_label": Record<string, never>
  "model_configuration.reasoning_unsupported_hint": Record<string, never>
  "model_configuration.refresh_supported_models": Record<string, never>
  "model_configuration.reload_catalog_models": Record<string, never>
  "model_configuration.required_fields": Record<string, never>
  "model_configuration.retire_no_replacement": Record<string, never>
  "model_configuration.retire_pause": Record<string, never>
  "model_configuration.retire_pause_hint": Record<string, never>
  "model_configuration.retire_replace": Record<string, never>
  "model_configuration.retire_replace_hint": Record<string, never>
  "model_configuration.retire_replacement_label": Record<string, never>
  "model_configuration.retire_replacement_placeholder": Record<string, never>
  "model_configuration.retire_strategy": Record<string, never>
  "model_configuration.save_and_test": Record<string, never>
  "model_configuration.save_and_test_model": Record<string, never>
  "model_configuration.scope_account": Record<string, never>
  "model_configuration.scope_project": Record<string, never>
  "model_configuration.select_model_label": Record<string, never>
  "model_configuration.speech_not_testable": Record<string, never>
  "model_configuration.status_available": Record<string, never>
  "model_configuration.status_disabled": Record<string, never>
  "model_configuration.status_quota_exhausted": Record<string, never>
  "model_configuration.status_rate_limited": Record<string, never>
  "model_configuration.status_unavailable": Record<string, never>
  "model_configuration.status_unverified": Record<string, never>
  "model_configuration.supported_model_hint": Record<string, never>
  "model_configuration.supported_model_label": Record<string, never>
  "model_configuration.supported_model_placeholder": Record<string, never>
  "model_configuration.system_default_model": { "module": string }
  "model_configuration.test_failed_keep_editing": Record<string, never>
  "model_configuration.test_model": Record<string, never>
  "model_configuration.testing_model": Record<string, never>
  "model_configuration.ui_001": Record<string, never>
  "model_configuration.ui_002": Record<string, never>
  "model_configuration.ui_003": Record<string, never>
  "model_configuration.ui_004": Record<string, never>
  "model_configuration.ui_005": Record<string, never>
  "model_configuration.ui_006": Record<string, never>
  "model_configuration.ui_007": Record<string, never>
  "model_configuration.ui_008": Record<string, never>
  "model_configuration.ui_009": Record<string, never>
  "model_configuration.ui_010": Record<string, never>
  "model_configuration.ui_011": Record<string, never>
  "model_configuration.ui_012": Record<string, never>
  "model_configuration.ui_013": Record<string, never>
  "model_configuration.ui_014": Record<string, never>
  "model_configuration.ui_015": Record<string, never>
  "model_configuration.ui_016": Record<string, never>
  "model_configuration.ui_017": Record<string, never>
  "model_configuration.ui_018": Record<string, never>
  "model_configuration.ui_019": Record<string, never>
  "model_configuration.ui_020": Record<string, never>
  "model_configuration.ui_021": Record<string, never>
  "model_configuration.ui_022": Record<string, never>
  "model_configuration.ui_023": Record<string, never>
  "model_configuration.ui_024": Record<string, never>
  "model_configuration.ui_025": Record<string, never>
  "model_configuration.ui_026": Record<string, never>
  "model_configuration.ui_027": Record<string, never>
  "model_configuration.ui_028": Record<string, never>
  "model_configuration.ui_029": Record<string, never>
  "model_configuration.ui_030": Record<string, never>
  "model_configuration.ui_031": Record<string, never>
  "model_configuration.ui_032": Record<string, never>
  "model_configuration.ui_033": Record<string, never>
  "model_configuration.ui_034": Record<string, never>
  "model_configuration.ui_035": Record<string, never>
  "model_configuration.ui_036": Record<string, never>
  "model_configuration.ui_037": Record<string, never>
  "model_configuration.ui_038": Record<string, never>
  "model_configuration.ui_039": Record<string, never>
  "model_configuration.ui_040": Record<string, never>
  "model_configuration.ui_041": Record<string, never>
  "model_configuration.ui_042": Record<string, never>
  "model_configuration.ui_043": Record<string, never>
  "model_configuration.ui_044": Record<string, never>
  "model_configuration.ui_045": Record<string, never>
  "model_configuration.ui_046": Record<string, never>
  "model_configuration.ui_047": Record<string, never>
  "model_configuration.ui_048": Record<string, never>
  "model_configuration.ui_049": Record<string, never>
  "model_configuration.ui_050": Record<string, never>
  "model_configuration.ui_051": Record<string, never>
  "model_configuration.ui_052": Record<string, never>
  "model_configuration.ui_053": Record<string, never>
  "model_configuration.ui_054": Record<string, never>
  "model_configuration.ui_055": Record<string, never>
  "model_configuration.ui_056": Record<string, never>
  "model_configuration.ui_057": Record<string, never>
  "model_configuration.ui_058": Record<string, never>
  "model_configuration.ui_059": Record<string, never>
  "model_configuration.ui_060": Record<string, never>
  "model_configuration.ui_061": Record<string, never>
  "model_configuration.ui_062": Record<string, never>
  "model_configuration.ui_063": Record<string, never>
  "model_configuration.ui_064": Record<string, never>
  "model_configuration.ui_065": Record<string, never>
  "model_configuration.ui_066": Record<string, never>
  "model_configuration.ui_067": Record<string, never>
  "model_configuration.ui_068": Record<string, never>
  "model_configuration.ui_069": Record<string, never>
  "model_configuration.ui_070": Record<string, never>
  "model_configuration.ui_071": Record<string, never>
  "model_configuration.ui_072": Record<string, never>
  "model_configuration.ui_073": Record<string, never>
  "model_configuration.ui_074": Record<string, never>
  "model_configuration.ui_075": Record<string, never>
  "model_configuration.ui_076": Record<string, never>
  "model_configuration.ui_077": Record<string, never>
  "model_configuration.ui_078": Record<string, never>
  "model_configuration.ui_079": Record<string, never>
  "model_configuration.ui_080": Record<string, never>
  "model_configuration.ui_081": Record<string, never>
  "model_configuration.ui_082": Record<string, never>
  "model_configuration.ui_083": Record<string, never>
  "model_configuration.ui_084": Record<string, never>
  "model_configuration.ui_085": Record<string, never>
  "model_configuration.ui_086": Record<string, never>
  "model_configuration.ui_087": Record<string, never>
  "model_configuration.ui_088": Record<string, never>
  "model_configuration.ui_089": Record<string, never>
  "model_configuration.ui_090": Record<string, never>
  "model_configuration.ui_091": Record<string, never>
  "model_configuration.ui_092": Record<string, never>
  "model_configuration.ui_093": Record<string, never>
  "model_configuration.ui_094": Record<string, never>
  "model_configuration.ui_095": Record<string, never>
  "model_configuration.ui_096": Record<string, never>
  "model_configuration.ui_097": Record<string, never>
  "model_configuration.ui_098": Record<string, never>
  "model_configuration.ui_099": Record<string, never>
  "model_configuration.ui_100": Record<string, never>
  "model_configuration.ui_101": Record<string, never>
  "model_configuration.ui_102": Record<string, never>
  "model_configuration.ui_103": Record<string, never>
  "model_configuration.ui_104": Record<string, never>
  "model_configuration.ui_105": Record<string, never>
  "model_configuration.ui_106": Record<string, never>
  "model_configuration.ui_107": Record<string, never>
  "model_configuration.ui_108": Record<string, never>
  "model_configuration.ui_109": Record<string, never>
  "model_configuration.ui_110": Record<string, never>
  "model_configuration.ui_111": Record<string, never>
  "model_configuration.ui_112": Record<string, never>
  "model_configuration.ui_113": Record<string, never>
  "model_configuration.ui_114": Record<string, never>
  "model_configuration.ui_115": Record<string, never>
  "model_configuration.ui_116": Record<string, never>
  "model_configuration.ui_117": Record<string, never>
  "model_configuration.ui_118": Record<string, never>
  "model_configuration.ui_119": Record<string, never>
  "model_configuration.ui_120": Record<string, never>
  "model_configuration.ui_121": Record<string, never>
  "model_configuration.ui_122": Record<string, never>
  "model_configuration.ui_123": Record<string, never>
  "model_configuration.ui_124": Record<string, never>
  "model_configuration.ui_125": Record<string, never>
  "model_configuration.ui_126": Record<string, never>
  "model_configuration.ui_127": Record<string, never>
  "model_configuration.ui_128": Record<string, never>
  "model_configuration.ui_129": Record<string, never>
  "model_configuration.ui_130": Record<string, never>
  "model_configuration.ui_131": Record<string, never>
  "model_configuration.ui_132": Record<string, never>
  "model_configuration.ui_133": Record<string, never>
  "model_configuration.ui_134": Record<string, never>
  "model_configuration.ui_135": Record<string, never>
  "model_configuration.ui_136": Record<string, never>
  "model_configuration.ui_137": Record<string, never>
  "model_configuration.ui_138": Record<string, never>
  "model_configuration.ui_139": Record<string, never>
  "model_configuration.ui_140": Record<string, never>
  "model_configuration.ui_141": Record<string, never>
  "model_configuration.ui_142": Record<string, never>
  "model_configuration.ui_143": Record<string, never>
  "model_configuration.ui_144": Record<string, never>
  "model_configuration.ui_145": Record<string, never>
  "model_configuration.ui_146": Record<string, never>
  "model_configuration.ui_147": Record<string, never>
  "model_configuration.ui_148": Record<string, never>
  "model_configuration.ui_149": Record<string, never>
  "model_configuration.ui_150": Record<string, never>
  "model_configuration.ui_151": Record<string, never>
  "model_configuration.ui_152": Record<string, never>
  "model_configuration.ui_153": Record<string, never>
  "model_configuration.ui_154": Record<string, never>
  "model_configuration.ui_155": Record<string, never>
  "model_configuration.ui_156": Record<string, never>
  "model_configuration.ui_157": Record<string, never>
  "model_configuration.ui_158": Record<string, never>
  "model_configuration.ui_159": Record<string, never>
  "model_configuration.ui_160": Record<string, never>
  "model_configuration.ui_161": Record<string, never>
  "model_configuration.ui_162": Record<string, never>
  "model_configuration.ui_163": Record<string, never>
  "model_configuration.ui_164": Record<string, never>
  "model_configuration.ui_165": Record<string, never>
  "model_configuration.ui_166": Record<string, never>
  "model_configuration.ui_167": Record<string, never>
  "model_configuration.ui_168": Record<string, never>
  "model_configuration.ui_169": Record<string, never>
  "model_configuration.ui_170": Record<string, never>
  "model_configuration.ui_171": Record<string, never>
  "model_configuration.ui_172": Record<string, never>
  "model_configuration.ui_173": Record<string, never>
  "model_configuration.ui_174": Record<string, never>
  "model_configuration.ui_175": Record<string, never>
  "model_configuration.ui_176": Record<string, never>
  "model_configuration.ui_177": Record<string, never>
  "model_configuration.ui_178": Record<string, never>
  "model_configuration.ui_179": Record<string, never>
  "model_configuration.ui_180": Record<string, never>
  "model_configuration.ui_181": Record<string, never>
  "model_configuration.ui_182": Record<string, never>
  "model_configuration.ui_183": Record<string, never>
  "model_configuration.ui_184": Record<string, never>
  "model_configuration.ui_185": Record<string, never>
  "model_configuration.ui_186": Record<string, never>
  "model_configuration.ui_187": Record<string, never>
  "model_configuration.ui_188": Record<string, never>
  "model_configuration.ui_189": Record<string, never>
  "model_configuration.ui_190": Record<string, never>
  "model_configuration.ui_191": Record<string, never>
  "model_configuration.ui_192": Record<string, never>
  "model_configuration.ui_193": Record<string, never>
  "model_configuration.ui_194": Record<string, never>
  "model_configuration.ui_195": Record<string, never>
  "model_configuration.ui_196": Record<string, never>
  "model_configuration.ui_197": Record<string, never>
  "model_configuration.ui_198": Record<string, never>
  "model_configuration.ui_199": Record<string, never>
  "model_configuration.ui_200": Record<string, never>
  "model_configuration.ui_201": Record<string, never>
  "model_configuration.ui_202": Record<string, never>
  "model_configuration.ui_203": Record<string, never>
  "model_configuration.ui_204": Record<string, never>
  "model_configuration.ui_205": Record<string, never>
  "model_configuration.ui_206": Record<string, never>
  "model_configuration.ui_207": Record<string, never>
  "model_configuration.ui_208": Record<string, never>
  "model_configuration.ui_209": Record<string, never>
  "model_configuration.ui_210": Record<string, never>
  "model_configuration.ui_211": Record<string, never>
  "model_configuration.ui_212": Record<string, never>
  "model_configuration.ui_213": Record<string, never>
  "model_configuration.ui_214": Record<string, never>
  "model_configuration.ui_215": Record<string, never>
  "model_configuration.ui_216": Record<string, never>
  "model_configuration.ui_217": Record<string, never>
  "model_configuration.ui_218": Record<string, never>
  "model_configuration.ui_219": Record<string, never>
  "model_configuration.ui_220": Record<string, never>
  "model_configuration.ui_221": Record<string, never>
  "model_configuration.ui_222": Record<string, never>
  "model_configuration.ui_223": Record<string, never>
  "model_configuration.ui_224": Record<string, never>
  "model_configuration.ui_225": Record<string, never>
  "model_configuration.ui_226": Record<string, never>
  "model_configuration.ui_227": Record<string, never>
  "model_configuration.ui_228": Record<string, never>
  "model_configuration.ui_229": Record<string, never>
  "model_configuration.ui_230": Record<string, never>
  "model_configuration.ui_231": Record<string, never>
  "model_configuration.ui_232": Record<string, never>
  "model_configuration.ui_233": Record<string, never>
  "model_configuration.ui_234": Record<string, never>
  "model_configuration.ui_235": Record<string, never>
  "model_configuration.ui_236": Record<string, never>
  "model_configuration.ui_237": Record<string, never>
  "model_configuration.ui_238": Record<string, never>
  "model_configuration.ui_239": Record<string, never>
  "model_configuration.ui_240": Record<string, never>
  "model_configuration.ui_241": Record<string, never>
  "model_configuration.ui_242": Record<string, never>
  "model_configuration.ui_243": Record<string, never>
  "model_configuration.ui_244": Record<string, never>
  "model_configuration.ui_245": Record<string, never>
  "model_configuration.ui_246": Record<string, never>
  "model_configuration.ui_247": Record<string, never>
  "model_configuration.ui_248": Record<string, never>
  "model_configuration.ui_249": Record<string, never>
  "model_configuration.ui_250": Record<string, never>
  "model_configuration.ui_251": Record<string, never>
  "model_configuration.ui_252": Record<string, never>
  "model_configuration.ui_253": Record<string, never>
  "model_configuration.ui_254": Record<string, never>
  "model_configuration.unknown_value": Record<string, never>
  "model_configuration.vision_label": Record<string, never>
  "model_configuration.yes_value": Record<string, never>
  "model_library.add_connection": Record<string, never>
  "model_library.add_model": Record<string, never>
  "model_library.api_key": Record<string, never>
  "model_library.base_url": Record<string, never>
  "model_library.cancel": Record<string, never>
  "model_library.connection_disabled": Record<string, never>
  "model_library.connection_enabled": Record<string, never>
  "model_library.connection_name": Record<string, never>
  "model_library.connection_name_placeholder": Record<string, never>
  "model_library.connections": Record<string, never>
  "model_library.create": Record<string, never>
  "model_library.empty_connections": Record<string, never>
  "model_library.empty_models": Record<string, never>
  "model_library.form_error": Record<string, never>
  "model_library.key_hint": Record<string, never>
  "model_library.model_disabled": Record<string, never>
  "model_library.model_enabled": Record<string, never>
  "model_library.model_id": Record<string, never>
  "model_library.model_id_placeholder": Record<string, never>
  "model_library.model_name": Record<string, never>
  "model_library.model_name_placeholder": Record<string, never>
  "model_library.models": Record<string, never>
  "model_library.platform.ark_connection": Record<string, never>
  "model_library.platform.ark_monthly_connection": Record<string, never>
  "model_library.platform.deepseek_connection": Record<string, never>
  "model_library.platform.model_ark_code": Record<string, never>
  "model_library.platform.model_deepseek_flash": Record<string, never>
  "model_library.platform.model_doubao": Record<string, never>
  "model_library.platform.model_doubao_speech_mini": Record<string, never>
  "model_library.platform.model_glm": Record<string, never>
  "model_library.platform.model_kimi": Record<string, never>
  "model_library.platform.model_seed_asr_file": Record<string, never>
  "model_library.platform.model_seed_asr_stream": Record<string, never>
  "model_library.platform.openspeech_connection": Record<string, never>
  "model_library.probe": Record<string, never>
  "model_library.probe_error": Record<string, never>
  "model_library.probe_hint": Record<string, never>
  "model_library.protocol": Record<string, never>
  "model_library.protocol.anthropic": Record<string, never>
  "model_library.protocol.bedrock": Record<string, never>
  "model_library.protocol.openai": Record<string, never>
  "model_library.provider": Record<string, never>
  "model_library.provider_hint": Record<string, never>
  "model_library.save_error": Record<string, never>
  "model_library.scope.account": Record<string, never>
  "model_library.status.disabled": Record<string, never>
  "model_library.status.failed": Record<string, never>
  "model_library.status.unverified": Record<string, never>
  "model_library.status.verified": Record<string, never>
  "model_library.subtitle": Record<string, never>
  "model_library.title": Record<string, never>
  "model_runtime.agent.backend": Record<string, never>
  "model_runtime.agent.design": Record<string, never>
  "model_runtime.agent.frontend": Record<string, never>
  "model_runtime.agent.ops": Record<string, never>
  "model_runtime.agent.product": Record<string, never>
  "model_runtime.agent.project": Record<string, never>
  "model_runtime.agent.review": Record<string, never>
  "model_runtime.agent.test": Record<string, never>
  "model_runtime.module.code_review_description": Record<string, never>
  "model_runtime.module.code_review_name": Record<string, never>
  "model_runtime.module.code_review_note": Record<string, never>
  "model_runtime.module.conversation_memory_description": Record<string, never>
  "model_runtime.module.conversation_memory_name": Record<string, never>
  "model_runtime.module.conversation_memory_note": Record<string, never>
  "model_runtime.module.development_orchestration_description": Record<string, never>
  "model_runtime.module.development_orchestration_name": Record<string, never>
  "model_runtime.module.development_orchestration_note": Record<string, never>
  "model_runtime.module.document_content_description": Record<string, never>
  "model_runtime.module.document_content_name": Record<string, never>
  "model_runtime.module.document_content_note": Record<string, never>
  "model_runtime.module.lulu_reasoning_description": Record<string, never>
  "model_runtime.module.lulu_reasoning_name": Record<string, never>
  "model_runtime.module.lulu_reasoning_not_usable": Record<string, never>
  "model_runtime.module.lulu_reasoning_not_wired": Record<string, never>
  "model_runtime.module.lulu_reasoning_note": Record<string, never>
  "model_runtime.module.multimodal_description": Record<string, never>
  "model_runtime.module.multimodal_name": Record<string, never>
  "model_runtime.module.multimodal_note": Record<string, never>
  "model_runtime.module.patch_generation_description": Record<string, never>
  "model_runtime.module.patch_generation_name": Record<string, never>
  "model_runtime.module.patch_generation_note": Record<string, never>
  "model_runtime.module.product_inspection_description": Record<string, never>
  "model_runtime.module.product_inspection_name": Record<string, never>
  "model_runtime.module.product_inspection_note": Record<string, never>
  "model_runtime.module.task_planning_description": Record<string, never>
  "model_runtime.module.task_planning_name": Record<string, never>
  "model_runtime.module.task_planning_not_wired": Record<string, never>
  "model_runtime.module.task_planning_note": Record<string, never>
  "model_runtime.provider.agent_plan_catalog_hint": Record<string, never>
  "model_runtime.provider.api_key": Record<string, never>
  "model_runtime.provider.api_key_manual_models": Record<string, never>
  "model_runtime.provider.bedrock_auth_hint": Record<string, never>
  "model_runtime.provider.bedrock_base_hint": Record<string, never>
  "model_runtime.provider.custom_hint": Record<string, never>
  "model_runtime.provider.custom_name": Record<string, never>
  "model_runtime.provider.huawei_hint": Record<string, never>
  "model_runtime.provider.huawei_name": Record<string, never>
  "model_runtime.provider.manual_catalog_hint": Record<string, never>
  "model_runtime.provider.plan_catalog_hint": Record<string, never>
  "model_runtime.provider.public_catalog_hint": Record<string, never>
  "model_runtime.provider.tencent_hint": Record<string, never>
  "model_runtime.provider.tencent_name": Record<string, never>
  "model_runtime.provider.tencent_token_plan_hint": Record<string, never>
  "model_runtime.provider.tencent_token_plan_name": Record<string, never>
  "model_runtime.provider.tencent_tokenhub_hint": Record<string, never>
  "model_runtime.provider.tencent_tokenhub_name": Record<string, never>
  "model_runtime.provider.volcengine_agent_plan_hint": Record<string, never>
  "model_runtime.provider.volcengine_agent_plan_name": Record<string, never>
  "model_runtime.provider.volcengine_coding_plan_hint": Record<string, never>
  "model_runtime.provider.volcengine_coding_plan_name": Record<string, never>
  "model_runtime.provider.volcengine_hint": Record<string, never>
  "model_runtime.provider.volcengine_name": Record<string, never>
  "model_runtime.provider.volcengine_openspeech_hint": Record<string, never>
  "model_runtime.provider.volcengine_openspeech_name": Record<string, never>
  "model_runtime.provider.zhipu_coding_plan_hint": Record<string, never>
  "model_runtime.provider.zhipu_coding_plan_name": Record<string, never>
  "model_runtime.provider.zhipu_hint": Record<string, never>
  "model_runtime.provider.zhipu_name": Record<string, never>
  "nav.account": Record<string, never>
  "nav.account.appearance": Record<string, never>
  "nav.account.appearance.follow": Record<string, never>
  "nav.account.billing": Record<string, never>
  "nav.account.lang": Record<string, never>
  "nav.account.logout": Record<string, never>
  "nav.account.me": Record<string, never>
  "nav.account.mobile.account": Record<string, never>
  "nav.account.mobile.lang": Record<string, never>
  "nav.account.mobile.prefs": Record<string, never>
  "nav.account.session": { "method": string; "time": string }
  "nav.account.session.password": Record<string, never>
  "nav.account.settings": Record<string, never>
  "nav.account.shortcuts": Record<string, never>
  "nav.account.shortcuts.hint": Record<string, never>
  "nav.account.team": Record<string, never>
  "nav.account.team.hint": { "n": string }
  "nav.alert": Record<string, never>
  "nav.auth": Record<string, never>
  "nav.bridge": Record<string, never>
  "nav.bug_reports": Record<string, never>
  "nav.chat": Record<string, never>
  "nav.code": Record<string, never>
  "nav.common.loading": Record<string, never>
  "nav.dash": Record<string, never>
  "nav.duty": Record<string, never>
  "nav.hosts": Record<string, never>
  "nav.inbox.alert.open": { "count": string }
  "nav.inbox.approval": { "count": string }
  "nav.inbox.empty": Record<string, never>
  "nav.inbox.title": Record<string, never>
  "nav.inbox.view.all": Record<string, never>
  "nav.memo": Record<string, never>
  "nav.models": Record<string, never>
  "nav.more": Record<string, never>
  "nav.more.group.modules": Record<string, never>
  "nav.new_session": Record<string, never>
  "nav.notification": Record<string, never>
  "nav.onboard": Record<string, never>
  "nav.project": Record<string, never>
  "nav.project.loading": Record<string, never>
  "nav.project_tabs": Record<string, never>
  "nav.ptab.activity": Record<string, never>
  "nav.ptab.chat": Record<string, never>
  "nav.ptab.env": Record<string, never>
  "nav.ptab.memo": Record<string, never>
  "nav.ptab.overview": Record<string, never>
  "nav.ptab.release": Record<string, never>
  "nav.ptab.resources": Record<string, never>
  "nav.ptab.tasks": Record<string, never>
  "nav.search.everything": Record<string, never>
  "nav.search.group.hosts": Record<string, never>
  "nav.search.group.memos": Record<string, never>
  "nav.search.group.projects": Record<string, never>
  "nav.search.group.timeline": Record<string, never>
  "nav.search.hint": Record<string, never>
  "nav.search.hint.all": Record<string, never>
  "nav.search.none": Record<string, never>
  "nav.search.placeholder": Record<string, never>
  "nav.sec": Record<string, never>
  "nav.server": Record<string, never>
  "nav.shortcuts.group.global": Record<string, never>
  "nav.shortcuts.group.memo": Record<string, never>
  "nav.shortcuts.yield.note": Record<string, never>
  "nav.skills": Record<string, never>
  "nav.status.idle": Record<string, never>
  "nav.status.running": { "count": string }
  "nav.status.unknown": Record<string, never>
  "nav.team": Record<string, never>
  "nav.theme.current": Record<string, never>
  "nav.theme.dark": Record<string, never>
  "nav.theme.light": Record<string, never>
  "nav.theme.quick.hint": Record<string, never>
  "nav.theme.switch": Record<string, never>
  "nav.timeline": Record<string, never>
  "nav.today.card.night": Record<string, never>
  "nav.today.card.night.body": { "failed": string; "rolled": string; "succeeded": string }
  "nav.today.card.running": Record<string, never>
  "nav.today.card.waiting": Record<string, never>
  "nav.today.count.items": { "count": string }
  "nav.today.empty.running": Record<string, never>
  "nav.today.empty.waiting": Record<string, never>
  "nav.today.error.title": Record<string, never>
  "nav.today.freshness": { "time": string }
  "nav.today.link.alerts": Record<string, never>
  "nav.today.link.all_activity": Record<string, never>
  "nav.today.link.inbox": Record<string, never>
  "nav.today.link.night": Record<string, never>
  "nav.today.link.timeline": Record<string, never>
  "nav.today.overview.all": Record<string, never>
  "nav.today.overview.night": { "succeeded": string }
  "nav.today.overview.night.failed": { "failed": string }
  "nav.today.overview.running": { "count": string }
  "nav.today.overview.waiting": { "count": string }
  "nav.today.page.title": Record<string, never>
  "nav.today.waiting.headline": { "count": string }
  "nav.vendor": Record<string, never>
  "onboarding.action.start": Record<string, never>
  "onboarding.error.auth_failed": Record<string, never>
  "onboarding.error.host_key_changed": Record<string, never>
  "onboarding.error.key_passphrase": Record<string, never>
  "onboarding.error.key_unreadable": Record<string, never>
  "onboarding.error.no_credential": Record<string, never>
  "onboarding.error.port_closed": { "address": string; "port": string }
  "onboarding.error.refused": { "address": string }
  "onboarding.error.timeout": { "address": string; "seconds": string }
  "onboarding.guess.confirm": Record<string, never>
  "onboarding.guess.heading": Record<string, never>
  "onboarding.guess.name": { "project_name": string; "role": string }
  "onboarding.guess.reason": { "container_count": string; "database": string; "domain": string }
  "onboarding.guess.rename": Record<string, never>
  "onboarding.guess.unknown": Record<string, never>
  "onboarding.missing.address": Record<string, never>
  "onboarding.missing.secret": Record<string, never>
  "onboarding.missing.username": Record<string, never>
  "onboarding.page.subtitle": Record<string, never>
  "onboarding.page.title": Record<string, never>
  "onboarding.passphrase.placeholder": Record<string, never>
  "onboarding.paste.note": Record<string, never>
  "onboarding.paste.placeholder": Record<string, never>
  "onboarding.probe.connect.detail": { "cpu_cores": string; "distro": string; "mem_gb": string }
  "onboarding.probe.connect.done": Record<string, never>
  "onboarding.probe.fingerprint.detail": { "workload_names": string }
  "onboarding.probe.fingerprint.done": { "container_count": string }
  "onboarding.probe.heading": Record<string, never>
  "onboarding.probe.install_agent.detail": { "agent_version": string; "seconds": string }
  "onboarding.probe.install_agent.running": Record<string, never>
  "onboarding.probe.security_check.detail": { "port": string }
  "onboarding.probe.security_check.narrowed": { "port": string }
  "onboarding.probe.takeover_key.detail": Record<string, never>
  "onboarding.probe.takeover_key.done": Record<string, never>
  "onboarding.step.hands_off.body": Record<string, never>
  "onboarding.step.hands_off.title": Record<string, never>
  "onboarding.step.identify.body": Record<string, never>
  "onboarding.step.identify.title": Record<string, never>
  "onboarding.step.paste.title": Record<string, never>
  "onboarding.takeover.extra_lines_removed": { "backup": string; "count": string }
  "ops_backup.drill.confirm.body": Record<string, never>
  "ops_backup.drill.confirm.title": Record<string, never>
  "ops_backup.drill.cta": Record<string, never>
  "ops_backup.drill.database": { "database": string }
  "ops_backup.drill.explain": Record<string, never>
  "ops_backup.drill.heading": Record<string, never>
  "ops_backup.drill.last.success": { "snapshot": string; "when": string }
  "ops_backup.drill.none": Record<string, never>
  "ops_backup.drill.not_restorable": Record<string, never>
  "ops_backup.executor.missing": Record<string, never>
  "ops_backup.executor.ok": { "when": string }
  "ops_backup.executor.queued_but_offline": Record<string, never>
  "ops_backup.executor.stale": { "when": string }
  "ops_backup.failure.checksum_mismatch": Record<string, never>
  "ops_backup.failure.disk_full": Record<string, never>
  "ops_backup.failure.dump_failed": Record<string, never>
  "ops_backup.failure.locked": Record<string, never>
  "ops_backup.failure.restore_failed": Record<string, never>
  "ops_backup.failure.unknown": { "code": string }
  "ops_backup.history.by": { "who": string }
  "ops_backup.history.by.schedule": Record<string, never>
  "ops_backup.history.empty": Record<string, never>
  "ops_backup.history.heading": Record<string, never>
  "ops_backup.history.kind.backup": Record<string, never>
  "ops_backup.history.kind.restore_drill": Record<string, never>
  "ops_backup.history.status.failed": Record<string, never>
  "ops_backup.history.status.queued": Record<string, never>
  "ops_backup.history.status.running": Record<string, never>
  "ops_backup.history.status.succeeded": Record<string, never>
  "ops_backup.history.stepup": Record<string, never>
  "ops_backup.history.took": { "seconds": string }
  "ops_backup.last.failure": { "when": string }
  "ops_backup.last.failure.none": Record<string, never>
  "ops_backup.last.success": { "when": string }
  "ops_backup.last.success.none": Record<string, never>
  "ops_backup.page.subtitle": Record<string, never>
  "ops_backup.page.title": Record<string, never>
  "ops_backup.plan.destination": { "destination": string }
  "ops_backup.plan.heading": Record<string, never>
  "ops_backup.plan.next": { "when": string }
  "ops_backup.plan.next.unknown": Record<string, never>
  "ops_backup.plan.none": Record<string, never>
  "ops_backup.plan.reported": { "when": string }
  "ops_backup.plan.retention": { "days": string }
  "ops_backup.plan.schedule": { "schedule": string }
  "ops_backup.run.busy": Record<string, never>
  "ops_backup.run.cta": Record<string, never>
  "ops_backup.run.forbidden": Record<string, never>
  "ops_backup.run.queued": Record<string, never>
  "ops_backup.snapshot.size": { "size": string }
  "ops_backup.state.heading": Record<string, never>
  "ops_backup.state.idle": Record<string, never>
  "ops_backup.state.queued": Record<string, never>
  "ops_backup.state.running": { "when": string }
  "ops_backup.state.running.drill": { "when": string }
  "pjhub.action.create": Record<string, never>
  "pjhub.action.retry": Record<string, never>
  "pjhub.builtin": Record<string, never>
  "pjhub.col.activity": Record<string, never>
  "pjhub.col.env": Record<string, never>
  "pjhub.col.health": Record<string, never>
  "pjhub.col.name": Record<string, never>
  "pjhub.col.recent_release": Record<string, never>
  "pjhub.col.recent_task": Record<string, never>
  "pjhub.col.resource": Record<string, never>
  "pjhub.empty.body": Record<string, never>
  "pjhub.empty.title": Record<string, never>
  "pjhub.error.body": Record<string, never>
  "pjhub.error.title": Record<string, never>
  "pjhub.filter.all": Record<string, never>
  "pjhub.filter.empty": Record<string, never>
  "pjhub.filter.needs_attention": Record<string, never>
  "pjhub.filter.unverified": Record<string, never>
  "pjhub.loading.hint": Record<string, never>
  "pjhub.loading.title": Record<string, never>
  "pjhub.new.name": Record<string, never>
  "pjhub.new.slug": Record<string, never>
  "pjhub.new.submitting": Record<string, never>
  "pjhub.new.subtitle": Record<string, never>
  "pjhub.new.title": Record<string, never>
  "pjhub.notice.missing_fields.body": Record<string, never>
  "pjhub.notice.not_switcher.body": Record<string, never>
  "pjhub.notice.not_switcher.title": Record<string, never>
  "pjhub.notice.unverified.body": Record<string, never>
  "pjhub.notice.unverified.title": Record<string, never>
  "pjhub.notice.unverified.why": Record<string, never>
  "pjhub.resource.has": Record<string, never>
  "pjhub.resource.none": Record<string, never>
  "pjhub.search.placeholder": Record<string, never>
  "pjhub.sort.hint": Record<string, never>
  "pjhub.stat.healthy": Record<string, never>
  "pjhub.stat.needs_attention": Record<string, never>
  "pjhub.stat.projects": Record<string, never>
  "pjhub.stat.running_releases": Record<string, never>
  "pjhub.stat.running_tasks": Record<string, never>
  "pjhub.subtitle": Record<string, never>
  "pjhub.subtitle.unverified": Record<string, never>
  "pjhub.title": Record<string, never>
  "pjhub.value.unverified": Record<string, never>
  "pjshell.capacity.cpu": Record<string, never>
  "pjshell.capacity.disk": Record<string, never>
  "pjshell.capacity.expiry": Record<string, never>
  "pjshell.capacity.host": Record<string, never>
  "pjshell.capacity.memory": Record<string, never>
  "pjshell.chat.attach": Record<string, never>
  "pjshell.chat.attach.blocked": Record<string, never>
  "pjshell.chat.can.assign": Record<string, never>
  "pjshell.chat.can.assign.body": Record<string, never>
  "pjshell.chat.can.auto": Record<string, never>
  "pjshell.chat.can.auto.body": Record<string, never>
  "pjshell.chat.can.send": Record<string, never>
  "pjshell.chat.can.send.body": Record<string, never>
  "pjshell.chat.can.status": Record<string, never>
  "pjshell.chat.can.status.body": Record<string, never>
  "pjshell.chat.can.title": Record<string, never>
  "pjshell.chat.can.value": Record<string, never>
  "pjshell.chat.cannot.manage": Record<string, never>
  "pjshell.chat.cannot.manage.body": Record<string, never>
  "pjshell.chat.cannot.orch": Record<string, never>
  "pjshell.chat.cannot.orch.body": Record<string, never>
  "pjshell.chat.cannot.other": Record<string, never>
  "pjshell.chat.cannot.other.body": Record<string, never>
  "pjshell.chat.cannot.switcher": Record<string, never>
  "pjshell.chat.cannot.switcher.body": Record<string, never>
  "pjshell.chat.cannot.title": Record<string, never>
  "pjshell.chat.cannot.value": Record<string, never>
  "pjshell.chat.context": { "name": string }
  "pjshell.chat.current": Record<string, never>
  "pjshell.chat.open_full": Record<string, never>
  "pjshell.chat.placeholder": Record<string, never>
  "pjshell.chat.split": Record<string, never>
  "pjshell.chat.subtitle": Record<string, never>
  "pjshell.chat.voice.blocked": Record<string, never>
  "pjshell.env.address": Record<string, never>
  "pjshell.env.certificate.stored": Record<string, never>
  "pjshell.env.col.cert": Record<string, never>
  "pjshell.env.col.expiry": Record<string, never>
  "pjshell.env.col.point": Record<string, never>
  "pjshell.env.col.resolve": Record<string, never>
  "pjshell.env.col.state": Record<string, never>
  "pjshell.env.configure": Record<string, never>
  "pjshell.env.configure.body": Record<string, never>
  "pjshell.env.configure.domain": Record<string, never>
  "pjshell.env.configure.done": Record<string, never>
  "pjshell.env.configure.files": Record<string, never>
  "pjshell.env.configure.files_hint": Record<string, never>
  "pjshell.env.configure.machine": Record<string, never>
  "pjshell.env.configure.pick": Record<string, never>
  "pjshell.env.configure.pick_folder": Record<string, never>
  "pjshell.env.configure.ready": Record<string, never>
  "pjshell.env.configure.submit": Record<string, never>
  "pjshell.env.configure.target": Record<string, never>
  "pjshell.env.configure.title": Record<string, never>
  "pjshell.env.domain.registered": Record<string, never>
  "pjshell.env.domain.verified": Record<string, never>
  "pjshell.env.domain.waiting": Record<string, never>
  "pjshell.env.domains": Record<string, never>
  "pjshell.env.group": Record<string, never>
  "pjshell.env.machine": Record<string, never>
  "pjshell.env.no_bundle": Record<string, never>
  "pjshell.env.open": Record<string, never>
  "pjshell.env.probe": Record<string, never>
  "pjshell.env.production": Record<string, never>
  "pjshell.env.production.title": Record<string, never>
  "pjshell.env.promote": Record<string, never>
  "pjshell.env.promote.body": Record<string, never>
  "pjshell.env.promote.note": Record<string, never>
  "pjshell.env.promote.title": Record<string, never>
  "pjshell.env.rollback": Record<string, never>
  "pjshell.env.status.failed": Record<string, never>
  "pjshell.env.status.ready": Record<string, never>
  "pjshell.env.status.rolled_back": Record<string, never>
  "pjshell.env.subtitle": Record<string, never>
  "pjshell.env.test": Record<string, never>
  "pjshell.env.test.title": Record<string, never>
  "pjshell.env.version": Record<string, never>
  "pjshell.env.when": Record<string, never>
  "pjshell.env.who": Record<string, never>
  "pjshell.fact.uncollected": Record<string, never>
  "pjshell.fact.unconfigured": Record<string, never>
  "pjshell.fact.unknown": Record<string, never>
  "pjshell.memo.empty": Record<string, never>
  "pjshell.memo.voice.blocked": Record<string, never>
  "pjshell.overview.capacity": Record<string, never>
  "pjshell.overview.card.entry": Record<string, never>
  "pjshell.overview.card.lives": Record<string, never>
  "pjshell.overview.card.publish": Record<string, never>
  "pjshell.overview.decide": { "count": string }
  "pjshell.overview.decide.action": Record<string, never>
  "pjshell.overview.decide.body": Record<string, never>
  "pjshell.overview.env": Record<string, never>
  "pjshell.overview.events": Record<string, never>
  "pjshell.overview.feed": Record<string, never>
  "pjshell.overview.feed.note": Record<string, never>
  "pjshell.overview.go_env": Record<string, never>
  "pjshell.overview.go_release": Record<string, never>
  "pjshell.overview.go_resources": Record<string, never>
  "pjshell.overview.go_tasks": Record<string, never>
  "pjshell.overview.health": Record<string, never>
  "pjshell.overview.last_release": Record<string, never>
  "pjshell.overview.live.note": Record<string, never>
  "pjshell.overview.live_version": Record<string, never>
  "pjshell.overview.no_resource_issue": Record<string, never>
  "pjshell.overview.now": Record<string, never>
  "pjshell.overview.release": Record<string, never>
  "pjshell.overview.resource_issues": Record<string, never>
  "pjshell.overview.subtitle": Record<string, never>
  "pjshell.overview.takeover": Record<string, never>
  "pjshell.overview.tasks": Record<string, never>
  "pjshell.overview.watch": Record<string, never>
  "pjshell.overview.working": Record<string, never>
  "pjshell.overview.working.empty": Record<string, never>
  "pjshell.overview.working.note": Record<string, never>
  "pjshell.pending_item": Record<string, never>
  "pjshell.readiness.agent_only": Record<string, never>
  "pjshell.readiness.awaiting_heartbeat": Record<string, never>
  "pjshell.readiness.check_failed": Record<string, never>
  "pjshell.readiness.complete": Record<string, never>
  "pjshell.readiness.continue": Record<string, never>
  "pjshell.readiness.details": Record<string, never>
  "pjshell.readiness.execution": Record<string, never>
  "pjshell.readiness.execution_failed": Record<string, never>
  "pjshell.readiness.heartbeat": Record<string, never>
  "pjshell.readiness.install_failed": Record<string, never>
  "pjshell.readiness.install_timeout": Record<string, never>
  "pjshell.readiness.installer_unavailable": Record<string, never>
  "pjshell.readiness.pending": Record<string, never>
  "pjshell.readiness.ready": Record<string, never>
  "pjshell.readiness.registered": Record<string, never>
  "pjshell.readiness.running": Record<string, never>
  "pjshell.readiness.scope": Record<string, never>
  "pjshell.readiness.ssh_unavailable": Record<string, never>
  "pjshell.readiness.validity": Record<string, never>
  "pjshell.readiness.verify": Record<string, never>
  "pjshell.readiness.waiting": Record<string, never>
  "pjshell.release.app": Record<string, never>
  "pjshell.release.checking": Record<string, never>
  "pjshell.release.col.actions": Record<string, never>
  "pjshell.release.col.last": Record<string, never>
  "pjshell.release.col.name": Record<string, never>
  "pjshell.release.col.size": Record<string, never>
  "pjshell.release.col.status": Record<string, never>
  "pjshell.release.col.url": Record<string, never>
  "pjshell.release.col.version": Record<string, never>
  "pjshell.release.drop": Record<string, never>
  "pjshell.release.drop.choose": Record<string, never>
  "pjshell.release.drop.empty": Record<string, never>
  "pjshell.release.drop.hint": { "slug": string }
  "pjshell.release.drop.new_site": Record<string, never>
  "pjshell.release.duration": Record<string, never>
  "pjshell.release.failed": Record<string, never>
  "pjshell.release.live": Record<string, never>
  "pjshell.release.live_now": { "version": string }
  "pjshell.release.none": Record<string, never>
  "pjshell.release.open": Record<string, never>
  "pjshell.release.previous": Record<string, never>
  "pjshell.release.primary_now": { "slug": string; "version": string }
  "pjshell.release.progress": Record<string, never>
  "pjshell.release.publishing": Record<string, never>
  "pjshell.release.replace": Record<string, never>
  "pjshell.release.rollbacks": Record<string, never>
  "pjshell.release.see_failure": Record<string, never>
  "pjshell.release.sites": Record<string, never>
  "pjshell.release.static": Record<string, never>
  "pjshell.release.step.check": Record<string, never>
  "pjshell.release.step.live.note": Record<string, never>
  "pjshell.release.step.publish": Record<string, never>
  "pjshell.release.step.verify": Record<string, never>
  "pjshell.release.step.verify.note": Record<string, never>
  "pjshell.release.steps": Record<string, never>
  "pjshell.release.subtitle": Record<string, never>
  "pjshell.release.today": Record<string, never>
  "pjshell.release.verifying": Record<string, never>
  "pjshell.release.verifying.public": Record<string, never>
  "pjshell.release.version": Record<string, never>
  "pjshell.release.what": Record<string, never>
  "pjshell.release.who": Record<string, never>
  "pjshell.release.who_when": { "duration": string; "when": string; "who": string }
  "pjshell.resource.add_one": Record<string, never>
  "pjshell.resource.address": Record<string, never>
  "pjshell.resource.assign_idle": Record<string, never>
  "pjshell.resource.assign_to_project": Record<string, never>
  "pjshell.resource.cert": Record<string, never>
  "pjshell.resource.col.actions": Record<string, never>
  "pjshell.resource.col.capacity": Record<string, never>
  "pjshell.resource.col.cert": Record<string, never>
  "pjshell.resource.col.entry": Record<string, never>
  "pjshell.resource.col.env": Record<string, never>
  "pjshell.resource.col.expiry": Record<string, never>
  "pjshell.resource.col.host": Record<string, never>
  "pjshell.resource.col.owner": Record<string, never>
  "pjshell.resource.col.point": Record<string, never>
  "pjshell.resource.col.spec": Record<string, never>
  "pjshell.resource.col.type": Record<string, never>
  "pjshell.resource.col.vendor": Record<string, never>
  "pjshell.resource.domain": Record<string, never>
  "pjshell.resource.domains": Record<string, never>
  "pjshell.resource.empty.body": Record<string, never>
  "pjshell.resource.empty.title": Record<string, never>
  "pjshell.resource.exclusive": Record<string, never>
  "pjshell.resource.go_cert": Record<string, never>
  "pjshell.resource.go_dns": Record<string, never>
  "pjshell.resource.network": Record<string, never>
  "pjshell.resource.physical": Record<string, never>
  "pjshell.resource.pool": Record<string, never>
  "pjshell.resource.shared": Record<string, never>
  "pjshell.resource.split": Record<string, never>
  "pjshell.resource.storage": Record<string, never>
  "pjshell.resource.subtitle": Record<string, never>
  "pjshell.resource.title": Record<string, never>
  "pjshell.resource.unassign": Record<string, never>
  "pjshell.resource.unassign.body": Record<string, never>
  "pjshell.resource.unassign.confirm": Record<string, never>
  "pjshell.resource.unassign.last_prod": Record<string, never>
  "pjshell.resource.unassign.title": { "project_name": string }
  "pjshell.resource.vendor": Record<string, never>
  "pjshell.takeover.none": Record<string, never>
  "pjshell.task.col.elapsed": Record<string, never>
  "pjshell.task.col.files": Record<string, never>
  "pjshell.task.col.name": Record<string, never>
  "pjshell.task.col.source": Record<string, never>
  "pjshell.task.col.state": Record<string, never>
  "pjshell.task.col.who": Record<string, never>
  "pjshell.task.elapsed": { "elapsed": string }
  "pjshell.task.empty": Record<string, never>
  "pjshell.task.filter.all": Record<string, never>
  "pjshell.task.filter.assignee": Record<string, never>
  "pjshell.task.filter.assignee.placeholder": Record<string, never>
  "pjshell.task.filter.decide": Record<string, never>
  "pjshell.task.filter.done": Record<string, never>
  "pjshell.task.filter.failed": Record<string, never>
  "pjshell.task.filter.running": Record<string, never>
  "pjshell.task.filter.updated": Record<string, never>
  "pjshell.task.filter.updated.any": Record<string, never>
  "pjshell.task.filter.updated.hour": Record<string, never>
  "pjshell.task.filter.updated.today": Record<string, never>
  "pjshell.task.filter.updated.week": Record<string, never>
  "pjshell.task.search.placeholder": Record<string, never>
  "pjshell.task.sort.hint": Record<string, never>
  "pjshell.task.source.lulu": Record<string, never>
  "pjshell.task.source.user": Record<string, never>
  "pjshell.task.stale": Record<string, never>
  "pjshell.task.subtitle": Record<string, never>
  "pjshell.task.write": Record<string, never>
  "pjshell.unverified": Record<string, never>
  "project.action.add_new_host": Record<string, never>
  "project.action.all_records": Record<string, never>
  "project.action.assign_host": Record<string, never>
  "project.action.create": Record<string, never>
  "project.action.open_public_entry": Record<string, never>
  "project.archived": Record<string, never>
  "project.assign.idle_empty": Record<string, never>
  "project.assign.idle_heading": Record<string, never>
  "project.assign.idle_loading": Record<string, never>
  "project.builtin.public_infra.name": Record<string, never>
  "project.builtin.public_infra.summary": Record<string, never>
  "project.detail.breadcrumb": { "name": string }
  "project.empty.no_host": Record<string, never>
  "project.empty.no_host.detail": Record<string, never>
  "project.env.promote.no_digest": Record<string, never>
  "project.env.promote.not_verified": Record<string, never>
  "project.env.promote.wrong_kind": Record<string, never>
  "project.env.rollback.no_target": Record<string, never>
  "project.error.builtin_undeletable": Record<string, never>
  "project.error.host_exclusive": Record<string, never>
  "project.error.name_blank": Record<string, never>
  "project.error.slug_taken": { "slug": string }
  "project.feed.empty": Record<string, never>
  "project.feed.loading": Record<string, never>
  "project.health.all_good": Record<string, never>
  "project.health.host_trouble": Record<string, never>
  "project.health.label": Record<string, never>
  "project.health.publish_failed": Record<string, never>
  "project.list.empty.body": Record<string, never>
  "project.list.empty.title": Record<string, never>
  "project.local_vs_platform.heading": Record<string, never>
  "project.local_vs_platform.how_you_know": Record<string, never>
  "project.local_vs_platform.pending_count": { "count": string }
  "project.local_vs_platform.tag": Record<string, never>
  "project.mixed_tenancy_warning": { "other_project": string }
  "project.restored": Record<string, never>
  "project.section.feed": Record<string, never>
  "project.section.public_entry": Record<string, never>
  "project.section.tasks": Record<string, never>
  "project.section.where_it_lives": Record<string, never>
  "project.summary.ai_written_hint": Record<string, never>
  "project_import.action.approve": Record<string, never>
  "project_import.action.start": Record<string, never>
  "project_import.action.unlink": Record<string, never>
  "project_import.approve.hint": Record<string, never>
  "project_import.approve.no_selectable": Record<string, never>
  "project_import.approve.submitting": Record<string, never>
  "project_import.approve.vendor_usage": Record<string, never>
  "project_import.assignee.assigning": Record<string, never>
  "project_import.assignee.create_one_time": Record<string, never>
  "project_import.assignee.import_identity_name": { "short_id": string }
  "project_import.assignee.import_only_prompt": { "invite_url": string; "redeem_url": string; "token": string }
  "project_import.assignee.one_time_hint": Record<string, never>
  "project_import.assignee.one_time_title": Record<string, never>
  "project_import.assignee.regenerate_one_time": Record<string, never>
  "project_import.assignee.source_locked": Record<string, never>
  "project_import.card.audit": Record<string, never>
  "project_import.card.open": Record<string, never>
  "project_import.card.source_label": Record<string, never>
  "project_import.card.title": Record<string, never>
  "project_import.card.unavailable": Record<string, never>
  "project_import.conflict.deployment_ref": Record<string, never>
  "project_import.conflict.domain_vendor": Record<string, never>
  "project_import.conflict.host": Record<string, never>
  "project_import.conflict.ownership_subject": Record<string, never>
  "project_import.conflict.project": Record<string, never>
  "project_import.conflict.repository": Record<string, never>
  "project_import.conflict.subscription": Record<string, never>
  "project_import.conflict.subscription_due": Record<string, never>
  "project_import.conflict.subscription_vendor": Record<string, never>
  "project_import.conflict.vendor": Record<string, never>
  "project_import.deployment.derived": Record<string, never>
  "project_import.domain.no_record": Record<string, never>
  "project_import.error.conflict_selected": Record<string, never>
  "project_import.error.extra_fields": Record<string, never>
  "project_import.error.host_missing": Record<string, never>
  "project_import.error.idempotency_mismatch": Record<string, never>
  "project_import.error.not_ready": Record<string, never>
  "project_import.error.not_reviewed": Record<string, never>
  "project_import.error.nothing_linked": Record<string, never>
  "project_import.error.nothing_selected": Record<string, never>
  "project_import.error.reissue_conflict": Record<string, never>
  "project_import.error.secrets": Record<string, never>
  "project_import.error.source_not_resendable": Record<string, never>
  "project_import.error.token_expired": Record<string, never>
  "project_import.error.token_used": Record<string, never>
  "project_import.error.unknown_schema": Record<string, never>
  "project_import.error.vendor_conflict": Record<string, never>
  "project_import.evidence.ai_declared": Record<string, never>
  "project_import.evidence.conflict": Record<string, never>
  "project_import.evidence.inventory_matched": Record<string, never>
  "project_import.evidence.missing": Record<string, never>
  "project_import.evidence.platform_verified": Record<string, never>
  "project_import.grades.title": Record<string, never>
  "project_import.idle.not_reusable": Record<string, never>
  "project_import.kind.deployment": Record<string, never>
  "project_import.kind.domain": Record<string, never>
  "project_import.kind.endpoint": Record<string, never>
  "project_import.kind.host": Record<string, never>
  "project_import.kind.ownership": Record<string, never>
  "project_import.kind.project": Record<string, never>
  "project_import.kind.repository": Record<string, never>
  "project_import.kind.subscription": Record<string, never>
  "project_import.kind.unknown": Record<string, never>
  "project_import.kind.vendor": Record<string, never>
  "project_import.links.before_ledger": Record<string, never>
  "project_import.links.created_entity_conditional": Record<string, never>
  "project_import.links.empty": Record<string, never>
  "project_import.links.pre_existing": Record<string, never>
  "project_import.links.released": Record<string, never>
  "project_import.links.title": Record<string, never>
  "project_import.ownership.dashboard_account": Record<string, never>
  "project_import.ownership.deploy_history": Record<string, never>
  "project_import.ownership.derived": Record<string, never>
  "project_import.ownership.dns_record": Record<string, never>
  "project_import.ownership.other": Record<string, never>
  "project_import.ownership.repo_write": Record<string, never>
  "project_import.ownership.ssh_login": Record<string, never>
  "project_import.package.reissue": Record<string, never>
  "project_import.package.reissue_hint": Record<string, never>
  "project_import.package.reissuing": Record<string, never>
  "project_import.project.seed_summary": Record<string, never>
  "project_import.prompt.body": Record<string, never>
  "project_import.prompt.copied": Record<string, never>
  "project_import.prompt.copy": Record<string, never>
  "project_import.prompt.copy_failed": Record<string, never>
  "project_import.prompt.hidden": Record<string, never>
  "project_import.prompt.once": Record<string, never>
  "project_import.prompt.path_label": Record<string, never>
  "project_import.prompt.title": Record<string, never>
  "project_import.prompt.token_label": Record<string, never>
  "project_import.renewal.due": { "due": string; "vendor": string }
  "project_import.renewal.none": Record<string, never>
  "project_import.renewal.today": Record<string, never>
  "project_import.review.empty": Record<string, never>
  "project_import.review.title": Record<string, never>
  "project_import.review.waiting": Record<string, never>
  "project_import.source.awaiting": Record<string, never>
  "project_import.source.awaiting_assignee": Record<string, never>
  "project_import.source.candidate": Record<string, never>
  "project_import.source.claimed_hint": { "time": string }
  "project_import.source.imported": Record<string, never>
  "project_import.source.importing": Record<string, never>
  "project_import.source.needs_rebase": Record<string, never>
  "project_import.source.repository": Record<string, never>
  "project_import.source.resend_hint": Record<string, never>
  "project_import.source.retry": Record<string, never>
  "project_import.source.retrying": Record<string, never>
  "project_import.source.setup_failed": Record<string, never>
  "project_import.source.status_unavailable": Record<string, never>
  "project_import.source.title": Record<string, never>
  "project_import.status.approved": Record<string, never>
  "project_import.status.awaiting_package": Record<string, never>
  "project_import.status.reviewed": Record<string, never>
  "project_import.subscription.no_due": Record<string, never>
  "project_import.summary.counts": { "conflict": string; "matched": string; "missing": string; "verified": string }
  "project_import.unlink.hint": Record<string, never>
  "project_import.unlink.submitting": Record<string, never>
  "project_import.wizard.draft_ready": Record<string, never>
  "project_import.wizard.name": Record<string, never>
  "project_import.wizard.submit": Record<string, never>
  "project_import.wizard.submitting": Record<string, never>
  "project_import.wizard.subtitle": Record<string, never>
  "project_import.wizard.title": Record<string, never>
  "remedy.backup.check_job": { "host": string }
  "remedy.cert.renew": { "days": string; "domain": string; "host": string }
  "remedy.disk.clean_docker": { "host": string }
  "remedy.disk.clean_old_logs": { "host": string; "mount": string }
  "remedy.disk.look_at_big_files": { "host": string; "mount": string }
  "remedy.load.look_at_top": { "host": string }
  "remedy.no_suggestion": { "what": string }
  "remedy.port.check_listener": { "host": string; "port": string }
  "remedy.process.restart": { "host": string; "process": string }
  "repo.conflict.clear": Record<string, never>
  "repo.conflict.deferred": { "file": string }
  "repo.gate.blocked.our_environment": Record<string, never>
  "repo.gate.blocked.platform_stopped": Record<string, never>
  "repo.gate.deployed": Record<string, never>
  "repo.gate.held": Record<string, never>
  "repo.gate.needs_you": Record<string, never>
  "repo.gate.passed": Record<string, never>
  "repo.gate.pending": Record<string, never>
  "repo.gate.redline.hit": { "what": string }
  "repo.gate.redline.no_tests": { "what": string }
  "repo.gate.rejected": Record<string, never>
  "repo.gate.rejected.plain": { "reason": string }
  "repo.gate.rejected.secret": { "location": string; "what": string }
  "repo.gate.rejected.size": { "files": string; "lines": string }
  "repo.gate.rejected.spread": { "modules": string }
  "repo.gate.rejected.tests": { "failed": string }
  "repo.gate.rejected.tests_unknown_count": Record<string, never>
  "repo.npcmd.branch_line": { "branch": string; "what": string }
  "repo.npcmd.intro": Record<string, never>
  "repo.npcmd.never_touch_main": Record<string, never>
  "repo.npcmd.online_unknown": Record<string, never>
  "repo.npcmd.online_version": { "version": string }
  "repo.npcmd.pending_count": { "count": string }
  "repo.npcmd.pending_none": Record<string, never>
  "repo.npcmd.title": Record<string, never>
  "repo.npcmd.touched_files": Record<string, never>
  "repo.push.accepted": Record<string, never>
  "repo.push.branch_rejected": { "branch": string; "suggestion": string }
  "repo.push.delete_rejected": Record<string, never>
  "repo.push.forward_conflict": Record<string, never>
  "repo.push.forward_rejected": Record<string, never>
  "repo.push.forwarded": { "branch": string }
  "repo.push.held_no_remote": Record<string, never>
  "repo.push.ref_rejected": Record<string, never>
  "repo.push.tag_rejected": Record<string, never>
  "repo.redline.credentials": Record<string, never>
  "repo.redline.data_delete": Record<string, never>
  "repo.redline.money": Record<string, never>
  "repo.redline.permission": Record<string, never>
  "sec.clean": Record<string, never>
  "sec.count.fixed": Record<string, never>
  "sec.count.must_fix": Record<string, never>
  "sec.count.when_free": Record<string, never>
  "sec.empty": Record<string, never>
  "sec.level.fixed": Record<string, never>
  "sec.level.must_fix": Record<string, never>
  "sec.level.when_free": Record<string, never>
  "sec.no_firewall.explanation": Record<string, never>
  "sec.no_firewall.suggestion": Record<string, never>
  "sec.no_firewall.title": Record<string, never>
  "sec.page.subtitle": Record<string, never>
  "sec.page.title": Record<string, never>
  "sec.password_login_enabled.explanation": Record<string, never>
  "sec.password_login_enabled.suggestion": Record<string, never>
  "sec.password_login_enabled.title": Record<string, never>
  "sec.pending_security_updates.explanation": Record<string, never>
  "sec.pending_security_updates.suggestion": Record<string, never>
  "sec.pending_security_updates.title": { "count": string }
  "sec.risk.model_unsure": Record<string, never>
  "sec.root_password_login.explanation": Record<string, never>
  "sec.root_password_login.suggestion": Record<string, never>
  "sec.root_password_login.title": Record<string, never>
  "sec.score.label": Record<string, never>
  "sec.ssh_open_to_world.explanation": { "port": string }
  "sec.ssh_open_to_world.suggestion": Record<string, never>
  "sec.ssh_open_to_world.title": Record<string, never>
  "split.action.preview": Record<string, never>
  "split.action.preview_only": Record<string, never>
  "split.capacity.reason.child_host": Record<string, never>
  "split.capacity.reason.has_capacity": Record<string, never>
  "split.capacity.reason.incomplete": Record<string, never>
  "split.capacity.reason.unknown_carvable": Record<string, never>
  "split.card.body": Record<string, never>
  "split.card.title": Record<string, never>
  "split.exposure.domain": Record<string, never>
  "split.exposure.internal_only": Record<string, never>
  "split.exposure.ip_port": Record<string, never>
  "split.model.degraded.rule": Record<string, never>
  "split.name.backend": { "project_name": string }
  "split.name.database": { "project_name": string }
  "split.name.default_project": Record<string, never>
  "split.name.spare": Record<string, never>
  "split.plan.cannot": { "reason": string }
  "split.plan.headline": { "count": string }
  "split.plan.why_not_more": { "reserve_disk": string; "reserve_memory": string }
  "split.posture.balanced": Record<string, never>
  "split.posture.conservative": Record<string, never>
  "split.posture.dense": Record<string, never>
  "split.posture.heading": Record<string, never>
  "split.posture.minimal": Record<string, never>
  "split.preview.provenance.by_ai": { "date": string }
  "split.preview.provenance.by_rule": { "date": string }
  "split.preview.provenance.heading": Record<string, never>
  "split.reason.capacity": { "count": string }
  "split.reason.no_context": Record<string, never>
  "split.reason.project_count": { "project_count": string }
  "split.requirement.placeholder": Record<string, never>
  "split.runtime.kvm.database": Record<string, never>
  "split.runtime.lxc.default": Record<string, never>
  "split.size.lt_one_g": Record<string, never>
  "split.size.some": Record<string, never>
  "split.slice.reason.database": Record<string, never>
  "split.slice.reason.project": { "project_name": string }
  "split.slice.reason.spare": Record<string, never>
  "split.state.empty": Record<string, never>
  "split.state.pending": Record<string, never>
  "split.validation.accepted": Record<string, never>
  "split.validation.adjusted": Record<string, never>
  "split.validation.rejected": Record<string, never>
  "split_exec.blocked.busy": Record<string, never>
  "split_exec.blocked.no_executor": Record<string, never>
  "split_exec.blocked.plan_rejected": Record<string, never>
  "split_exec.blocked.plan_stale": Record<string, never>
  "split_exec.cause.carve_slice": { "slice_name": string }
  "split_exec.confirm.red": Record<string, never>
  "split_exec.undo.manual": { "instance_name": string }
  "static_site.account.empty": Record<string, never>
  "static_site.account.loading": Record<string, never>
  "static_site.create.slug_invalid": Record<string, never>
  "static_site.create.slug_label": Record<string, never>
  "static_site.create.slug_placeholder": Record<string, never>
  "static_site.create.submit": Record<string, never>
  "static_site.create.title_label": Record<string, never>
  "static_site.create.title_placeholder": Record<string, never>
  "static_site.drop.busy": Record<string, never>
  "static_site.drop.done": Record<string, never>
  "static_site.drop.hint": Record<string, never>
  "static_site.drop.label": Record<string, never>
  "static_site.drop.update_label": Record<string, never>
  "static_site.empty": Record<string, never>
  "static_site.live.active": { "version_no": string; "when": string }
  "static_site.live.failed": Record<string, never>
  "static_site.live.none": Record<string, never>
  "static_site.live.pending": Record<string, never>
  "static_site.live.superseded": Record<string, never>
  "static_site.live.title": Record<string, never>
  "static_site.loading": Record<string, never>
  "static_site.name.label": Record<string, never>
  "static_site.name.save": Record<string, never>
  "static_site.name.saved": Record<string, never>
  "static_site.name.url_is_fixed": Record<string, never>
  "static_site.preview.again": Record<string, never>
  "static_site.preview.expired": Record<string, never>
  "static_site.preview.expires_at": { "when": string }
  "static_site.preview.failed": Record<string, never>
  "static_site.preview.hint": Record<string, never>
  "static_site.preview.none": Record<string, never>
  "static_site.preview.open": Record<string, never>
  "static_site.preview.revoke": Record<string, never>
  "static_site.preview.revoked": Record<string, never>
  "static_site.preview.title": Record<string, never>
  "static_site.publish.action": Record<string, never>
  "static_site.publish.approval_ask": Record<string, never>
  "static_site.publish.approval_asking": Record<string, never>
  "static_site.publish.approval_expired": Record<string, never>
  "static_site.publish.approval_got": { "until": string }
  "static_site.publish.approval_hint": Record<string, never>
  "static_site.publish.approval_label": Record<string, never>
  "static_site.publish.approval_not_a_grant": Record<string, never>
  "static_site.publish.busy": Record<string, never>
  "static_site.publish.reason_label": Record<string, never>
  "static_site.publish.reason_placeholder": Record<string, never>
  "static_site.receipt.artifact": { "digest": string }
  "static_site.receipt.health_failed": Record<string, never>
  "static_site.receipt.health_passed": Record<string, never>
  "static_site.receipt.health_pending": Record<string, never>
  "static_site.receipt.health_unknown": Record<string, never>
  "static_site.receipt.rollback_none": Record<string, never>
  "static_site.receipt.rollback_to": { "version_no": string }
  "static_site.receipt.toggle": Record<string, never>
  "static_site.rollback.action": Record<string, never>
  "static_site.rollback.busy": Record<string, never>
  "static_site.section.hint": Record<string, never>
  "static_site.section.title": Record<string, never>
  "static_site.status.active": Record<string, never>
  "static_site.status.offlined": Record<string, never>
  "static_site.status.suspended": Record<string, never>
  "static_site.upload.busy": Record<string, never>
  "static_site.upload.done_with_preview": { "version_no": string }
  "static_site.upload.hint": Record<string, never>
  "static_site.upload.label": Record<string, never>
  "static_site.url_hint": Record<string, never>
  "static_site.versions.empty": Record<string, never>
  "static_site.versions.row": { "size": string; "version_no": string }
  "static_site.versions.title": Record<string, never>
  "steward.brief.action.go_to_plan": Record<string, never>
  "steward.brief.action.ignore": Record<string, never>
  "steward.brief.action.later": Record<string, never>
  "steward.brief.action.mute": Record<string, never>
  "steward.brief.action.schedule": Record<string, never>
  "steward.brief.action.why": Record<string, never>
  "steward.brief.already_today": Record<string, never>
  "steward.brief.context_read": Record<string, never>
  "steward.brief.decided.ignore": Record<string, never>
  "steward.brief.decided.later": Record<string, never>
  "steward.brief.decided.mute": Record<string, never>
  "steward.brief.decided.scheduled": Record<string, never>
  "steward.brief.decisions": { "count": string }
  "steward.brief.decisions_none": Record<string, never>
  "steward.brief.decisions_stale": { "count": string }
  "steward.brief.finding_line": { "count": string; "summary": string }
  "steward.brief.findings_head": Record<string, never>
  "steward.brief.findings_none": Record<string, never>
  "steward.brief.footer": Record<string, never>
  "steward.brief.headline": Record<string, never>
  "steward.brief.inspection_skipped": { "count": string }
  "steward.brief.item.count": { "count": string }
  "steward.brief.item.finding": Record<string, never>
  "steward.brief.item.proposal": Record<string, never>
  "steward.brief.memory_candidates": { "count": string }
  "steward.brief.mentions_of_you": { "count": string }
  "steward.brief.proposal_line": { "title": string }
  "steward.brief.proposal_posted": { "title": string }
  "steward.brief.proposals_head": Record<string, never>
  "steward.brief.proposals_none": Record<string, never>
  "steward.brief.releases": { "failed": string; "pending": string; "verified": string }
  "steward.brief.releases_none": Record<string, never>
  "steward.brief.schedule_request": { "title": string }
  "steward.brief.scheduled": Record<string, never>
  "steward.chat.acceptance": Record<string, never>
  "steward.chat.account_scope_only": Record<string, never>
  "steward.chat.degraded": { "count": string }
  "steward.chat.model_auth_hold": Record<string, never>
  "steward.chat.model_down_hold": Record<string, never>
  "steward.chat.needs_you": { "count": string }
  "steward.chat.no_one_free": { "count": string }
  "steward.chat.paused_hold": { "count": string }
  "steward.chat.plan_only": { "count": string }
  "steward.chat.plan_only_asked": { "count": string }
  "steward.chat.plan_unavailable": Record<string, never>
  "steward.chat.start_failed": { "count": string }
  "steward.chat.started": { "count": string }
  "steward.chat.started_partial": { "count": string }
  "steward.chat.working": { "count": string }
  "steward.finding.acceptance": { "summary": string }
  "steward.finding.context_read": Record<string, never>
  "steward.finding.none": Record<string, never>
  "steward.finding.objective": { "summary": string }
  "steward.finding.restate": { "summary": string }
  "steward.item.title": { "objective": string; "role": string }
  "steward.memory.todo_summary": { "objective": string }
  "steward.memory.todo_why": Record<string, never>
  "steward.reason.green_auto": Record<string, never>
  "steward.reason.invalid_permission": Record<string, never>
  "steward.reason.invalid_request": Record<string, never>
  "steward.reason.observe_only": Record<string, never>
  "steward.reason.read_only": Record<string, never>
  "steward.reason.red_action": Record<string, never>
  "steward.reason.rollback_bounded_auto": Record<string, never>
  "steward.reason.suggest_only": Record<string, never>
  "steward.reason.yellow_not_authorized": Record<string, never>
  "steward.remote_ai.card_hint": Record<string, never>
  "steward.remote_ai.card_title": Record<string, never>
  "steward.remote_ai.copy_link": Record<string, never>
  "steward.remote_ai.copy_link_done": Record<string, never>
  "steward.remote_ai.copy_prompt": Record<string, never>
  "steward.remote_ai.copy_prompt_done": Record<string, never>
  "steward.remote_ai.dont_close": Record<string, never>
  "steward.remote_ai.duration_180d": Record<string, never>
  "steward.remote_ai.duration_30d": Record<string, never>
  "steward.remote_ai.duration_90d": Record<string, never>
  "steward.remote_ai.duration_long_term": Record<string, never>
  "steward.remote_ai.edit": Record<string, never>
  "steward.remote_ai.failed": Record<string, never>
  "steward.remote_ai.field_duration": Record<string, never>
  "steward.remote_ai.field_model": Record<string, never>
  "steward.remote_ai.field_name": Record<string, never>
  "steward.remote_ai.field_provider": Record<string, never>
  "steward.remote_ai.issue": Record<string, never>
  "steward.remote_ai.issuing": Record<string, never>
  "steward.remote_ai.link_label": Record<string, never>
  "steward.remote_ai.once": Record<string, never>
  "steward.remote_ai.prompt_label": Record<string, never>
  "steward.role.backend": Record<string, never>
  "steward.role.frontend": Record<string, never>
  "steward.role.qa": Record<string, never>
  "steward.role.release": Record<string, never>
  "steward.role.research": Record<string, never>
  "steward.role.reviewer": Record<string, never>
  "steward.role.steward": Record<string, never>
  "steward.run.compose_failed": Record<string, never>
  "steward.run.step.stopped_cancelled": Record<string, never>
  "steward.run.step.stopped_clock": Record<string, never>
  "steward.run.step.stopped_steps": Record<string, never>
  "steward.run.step.stopped_tokens": Record<string, never>
  "steward.run.stopped.cancelled": Record<string, never>
  "steward.run.stopped.limit": Record<string, never>
  "steward.skill.deepinspect.step.read_findings": Record<string, never>
  "steward.skill.deepinspect.step.report": Record<string, never>
  "steward.skill.deepinspect.what": Record<string, never>
  "steward.skill.disabled": Record<string, never>
  "steward.skill.diskforecast.step.extrapolate": Record<string, never>
  "steward.skill.diskforecast.step.take_samples": Record<string, never>
  "steward.skill.diskforecast.what": Record<string, never>
  "steward.skill.every.hours": { "n": string }
  "steward.skill.every.minutes": { "n": string }
  "steward.skill.every.seconds": { "n": string }
  "steward.skill.finding_to_task.name": Record<string, never>
  "steward.skill.logsniff.step.pick_template": Record<string, never>
  "steward.skill.logsniff.step.scan_rules": Record<string, never>
  "steward.skill.logsniff.what": Record<string, never>
  "steward.skill.morning_brief.name": Record<string, never>
  "steward.skill.pulse.step.confirm": Record<string, never>
  "steward.skill.pulse.step.read_findings": Record<string, never>
  "steward.skill.pulse.what": Record<string, never>
  "steward.skill.trigger.daily_dawn": { "hour": string }
  "steward.skill.trigger.every": { "every": string }
  "steward.smalltalk.acknowledged": Record<string, never>
  "steward.smalltalk.done.create_project": Record<string, never>
  "steward.smalltalk.done.list_projects": Record<string, never>
  "steward.smalltalk.done.other": Record<string, never>
  "steward.smalltalk.done.web_search": Record<string, never>
  "steward.smalltalk.failed.create_project": Record<string, never>
  "steward.smalltalk.failed.list_projects": Record<string, never>
  "steward.smalltalk.failed.other": Record<string, never>
  "steward.smalltalk.failed.web_search": Record<string, never>
  "steward.smalltalk.greeting": Record<string, never>
  "steward.smalltalk.project_chat": Record<string, never>
  "steward.smalltalk.project_ready": { "name": string }
  "steward.smalltalk.project_work": Record<string, never>
  "steward.smalltalk.thought": { "thought": string }
  "steward.smalltalk.unclear": Record<string, never>
  "steward.smalltalk.what_can_you_do": Record<string, never>
  "steward.smalltalk.work_needs_project": Record<string, never>
  "steward.smalltalk.working.create_project": Record<string, never>
  "steward.smalltalk.working.inspection": Record<string, never>
  "steward.smalltalk.working.list_projects": Record<string, never>
  "steward.smalltalk.working.remote_ai_invite": Record<string, never>
  "steward.smalltalk.working.remote_ai_status": Record<string, never>
  "steward.smalltalk.working.think": Record<string, never>
  "steward.smalltalk.working.web_search": Record<string, never>
  "team.action.edit": Record<string, never>
  "team.action.invite": Record<string, never>
  "team.empty": Record<string, never>
  "team.error.forbidden": Record<string, never>
  "team.error.last_owner": Record<string, never>
  "team.error.not_in_project": Record<string, never>
  "team.error.owner_only": Record<string, never>
  "team.invite.dialog.cancel": Record<string, never>
  "team.invite.dialog.email": Record<string, never>
  "team.invite.dialog.email.hint": Record<string, never>
  "team.invite.dialog.password": Record<string, never>
  "team.invite.dialog.password.why": Record<string, never>
  "team.invite.dialog.projects": Record<string, never>
  "team.invite.dialog.role": Record<string, never>
  "team.invite.dialog.submit": Record<string, never>
  "team.invite.dialog.title": Record<string, never>
  "team.invite.disabled.why": Record<string, never>
  "team.invite.done": Record<string, never>
  "team.invite.form.cancel": Record<string, never>
  "team.invite.form.email": Record<string, never>
  "team.invite.form.projects": Record<string, never>
  "team.invite.form.projects_hint": Record<string, never>
  "team.invite.form.role": Record<string, never>
  "team.invite.form.submit": Record<string, never>
  "team.invite.form.title": Record<string, never>
  "team.invite.invalid": Record<string, never>
  "team.invite.label": Record<string, never>
  "team.invite.link": Record<string, never>
  "team.invite.link.hint": Record<string, never>
  "team.invite.link.title": Record<string, never>
  "team.invite.link_copied": Record<string, never>
  "team.invite.link_copy": Record<string, never>
  "team.invite.link_manual": Record<string, never>
  "team.invite.needs_projects": Record<string, never>
  "team.invite.no_cap": Record<string, never>
  "team.invite.pending.empty": Record<string, never>
  "team.invite.pending.expires": { "days": string }
  "team.invite.pending.revoke": Record<string, never>
  "team.invite.pending.title": Record<string, never>
  "team.invite.redeem.go": Record<string, never>
  "team.invite.redeem.joined": { "role": string }
  "team.invite.redeem.need_login": Record<string, never>
  "team.invite.redeem.title": Record<string, never>
  "team.invite.revoked": Record<string, never>
  "team.invite.sent": { "days": string; "email": string }
  "team.invite.stepup": Record<string, never>
  "team.invite.taken": Record<string, never>
  "team.invites.expires": { "date": string }
  "team.invites.heading": Record<string, never>
  "team.invites.hint": Record<string, never>
  "team.invites.revoke": Record<string, never>
  "team.member.dialog.cancel": Record<string, never>
  "team.member.dialog.projects": Record<string, never>
  "team.member.dialog.projects_hint": Record<string, never>
  "team.member.dialog.role": Record<string, never>
  "team.member.dialog.stepup": Record<string, never>
  "team.member.dialog.submit": Record<string, never>
  "team.member.dialog.title": { "name": string }
  "team.member.edit": Record<string, never>
  "team.member.saved": Record<string, never>
  "team.page.subtitle": Record<string, never>
  "team.page.title": Record<string, never>
  "team.projects.no_match": { "q": string }
  "team.projects.none_yet": Record<string, never>
  "team.projects.owner_sees_all": Record<string, never>
  "team.projects.pick_all": Record<string, never>
  "team.projects.pick_none": Record<string, never>
  "team.projects.picked": { "picked": string; "total": string }
  "team.projects.search": Record<string, never>
  "team.role.operator": Record<string, never>
  "team.role.operator.desc": Record<string, never>
  "team.role.owner": Record<string, never>
  "team.role.owner.desc": Record<string, never>
  "team.role.viewer": Record<string, never>
  "team.role.viewer.desc": Record<string, never>
  "team.roles.heading": Record<string, never>
  "team.roles.hint": Record<string, never>
  "team.table.person": Record<string, never>
  "team.table.role": Record<string, never>
  "team.table.scope": Record<string, never>
  "timeline.action.approve": Record<string, never>
  "timeline.action.detail": Record<string, never>
  "timeline.action.not_ready": Record<string, never>
  "timeline.action.out_of_bounds": Record<string, never>
  "timeline.action.undo": Record<string, never>
  "timeline.approve.confirm.body": Record<string, never>
  "timeline.approve.confirm.title": Record<string, never>
  "timeline.approve.done": Record<string, never>
  "timeline.approve.forbidden": Record<string, never>
  "timeline.detail.checks": Record<string, never>
  "timeline.detail.commands": Record<string, never>
  "timeline.detail.exit_failed": Record<string, never>
  "timeline.detail.exit_ok": Record<string, never>
  "timeline.detail.output": Record<string, never>
  "timeline.detail.snapshot": Record<string, never>
  "timeline.empty": Record<string, never>
  "timeline.filter.all": Record<string, never>
  "timeline.filter.changed": Record<string, never>
  "timeline.filter.troubled": Record<string, never>
  "timeline.page.subtitle": Record<string, never>
  "timeline.page.title": Record<string, never>
  "timeline.stamp.yesterday": Record<string, never>
  "timeline.state.rolled_back": Record<string, never>
  "timeline.state.undone": Record<string, never>
  "timeline.tag.acted": Record<string, never>
  "timeline.tag.code_changed": Record<string, never>
  "timeline.tag.deployed": Record<string, never>
  "timeline.tag.noted": Record<string, never>
  "timeline.tag.routine": Record<string, never>
  "timeline.tag.trouble": Record<string, never>
  "timeline.undo.cost.restart": Record<string, never>
  "timeline.undo.done": Record<string, never>
  "timeline.undo.done_with_restart": { "seconds": string }
  "timeline.undo.not_undoable": { "why": string }
  "ui.cancel": Record<string, never>
  "ui.close": Record<string, never>
  "ui.edit": Record<string, never>
  "ui.navigation": Record<string, never>
  "ui.not_ready": Record<string, never>
  "ui.stale_build.action": Record<string, never>
  "ui.stale_build.notice": Record<string, never>
  "vendor.action.edit_scope": Record<string, never>
  "vendor.action.remove_project_scope": { "project": string }
  "vendor.action.remove_public_scope": Record<string, never>
  "vendor.action.remove_scope": Record<string, never>
  "vendor.action.save_project_scope": Record<string, never>
  "vendor.action.save_public_scope": Record<string, never>
  "vendor.auto_renew_on": Record<string, never>
  "vendor.cap.broken": { "capability": string; "vendor": string }
  "vendor.cap.needs_you": { "action": string; "vendor": string }
  "vendor.cap.not_enabled": { "capability": string; "vendor": string }
  "vendor.cap.unverified": { "capability": string; "vendor": string }
  "vendor.capability.acme_dns01": Record<string, never>
  "vendor.capability.ai": Record<string, never>
  "vendor.capability.cdn": Record<string, never>
  "vendor.capability.compute": Record<string, never>
  "vendor.capability.dns": Record<string, never>
  "vendor.capability.email": Record<string, never>
  "vendor.capability.git": Record<string, never>
  "vendor.capability.object_storage": Record<string, never>
  "vendor.capability.other": Record<string, never>
  "vendor.capability.registrar": Record<string, never>
  "vendor.card.monthly_cost": Record<string, never>
  "vendor.card.scope": Record<string, never>
  "vendor.card.secret": Record<string, never>
  "vendor.card.secret_kept": Record<string, never>
  "vendor.card.usage": Record<string, never>
  "vendor.detail.account": Record<string, never>
  "vendor.detail.account_hint": Record<string, never>
  "vendor.detail.account_section": Record<string, never>
  "vendor.detail.console_url": Record<string, never>
  "vendor.detail.mfa": Record<string, never>
  "vendor.detail.password": Record<string, never>
  "vendor.detail.peek": Record<string, never>
  "vendor.detail.secrets_section": Record<string, never>
  "vendor.due_soon": { "days": string; "vendor": string }
  "vendor.empty": Record<string, never>
  "vendor.error.bad_kind": Record<string, never>
  "vendor.error.bad_project_link_scope": Record<string, never>
  "vendor.error.name_blank": Record<string, never>
  "vendor.error.slug_taken": { "slug": string }
  "vendor.error.usage_note_blank": Record<string, never>
  "vendor.overdue": { "vendor": string }
  "vendor.page.subtitle": Record<string, never>
  "vendor.page.title": Record<string, never>
  "vendor.scope.editor.current": Record<string, never>
  "vendor.scope.editor.project": Record<string, never>
  "vendor.scope.editor.project_note": Record<string, never>
  "vendor.scope.editor.public_note": Record<string, never>
  "vendor.scope.editor.title": Record<string, never>
  "vendor.scope.public": Record<string, never>
}

/** 全部模板 id。不在这个联合类型里的字符串传不进 render()。 */
export type CopyId = keyof CopyVarMap

/** 不带变量的模板 id。render() 对它们可以只传一个参数。 */
export type VarlessCopyId =
  | "account.billing.empty.honest"
  | "account.devices.admin_note"
  | "account.devices.current"
  | "account.devices.empty"
  | "account.devices.heading"
  | "account.devices.hint"
  | "account.devices.method.bootstrap"
  | "account.devices.method.email_code"
  | "account.devices.method.local_ai"
  | "account.devices.method.passkey"
  | "account.devices.method.password"
  | "account.devices.method.recovery_code"
  | "account.devices.method.unknown"
  | "account.devices.name.unknown"
  | "account.devices.revoke.confirm.body"
  | "account.devices.revoke.confirm.title"
  | "account.devices.revoke.cta"
  | "account.devices.revoke.done"
  | "account.devices.revoke.others.cta"
  | "account.devices.revoke.others.none"
  | "account.devices.revoke.self"
  | "account.local_ai.copied"
  | "account.local_ai.copy"
  | "account.local_ai.cta"
  | "account.local_ai.error"
  | "account.local_ai.generating"
  | "account.local_ai.heading"
  | "account.local_ai.hint"
  | "account.local_ai.modal.close"
  | "account.local_ai.modal.description"
  | "account.local_ai.modal.title"
  | "account.paths.email_code"
  | "account.paths.heading"
  | "account.paths.passkey"
  | "account.paths.password"
  | "account.paths.recovery_code"
  | "account.paths.unusable"
  | "account.paths.usable"
  | "account.stepup.body"
  | "account.stepup.cancel"
  | "account.stepup.code.label"
  | "account.stepup.code.resend"
  | "account.stepup.code.send"
  | "account.stepup.confirm"
  | "account.stepup.method.email_code"
  | "account.stepup.method.password"
  | "account.stepup.no_ticket"
  | "account.stepup.none"
  | "account.stepup.password.label"
  | "account.stepup.switch"
  | "account.stepup.title"
  | "account.stepup.working"
  | "activity.action.copy_link"
  | "activity.action.manage_follow"
  | "activity.action.mark_all_read"
  | "activity.actor.lulu"
  | "activity.actor.system"
  | "activity.catalog.copy"
  | "activity.catalog.scene"
  | "activity.catalog.scene.action"
  | "activity.catalog.scene.all"
  | "activity.catalog.scene.disconnected"
  | "activity.catalog.scene.following"
  | "activity.catalog.scene.omitted"
  | "activity.catalog.scene.recovered"
  | "activity.catalog.scene.search"
  | "activity.catalog.scene.unknown"
  | "activity.catalog.subtitle"
  | "activity.catalog.title"
  | "activity.conn.live"
  | "activity.detail.boundary"
  | "activity.detail.close"
  | "activity.detail.continue_lulu"
  | "activity.detail.evidence"
  | "activity.detail.follow"
  | "activity.detail.go_release"
  | "activity.detail.open_session"
  | "activity.detail.open_source"
  | "activity.detail.result"
  | "activity.detail.sidecar_sub"
  | "activity.detail.stages"
  | "activity.detail.unfollow"
  | "activity.detail.view_evidence"
  | "activity.detail.view_impact"
  | "activity.empty.action"
  | "activity.empty.action.title"
  | "activity.empty.all"
  | "activity.empty.all.hint"
  | "activity.empty.all.title"
  | "activity.empty.following"
  | "activity.empty.following.hint"
  | "activity.empty.following.quiet.hint"
  | "activity.empty.following.quiet.title"
  | "activity.empty.following.title"
  | "activity.empty.go_chat"
  | "activity.empty.go_projects"
  | "activity.empty.important"
  | "activity.empty.important.title"
  | "activity.empty.list_failed"
  | "activity.empty.list_failed.hint"
  | "activity.empty.ops_alerts"
  | "activity.empty.ops_alerts.title"
  | "activity.empty.projects_failed"
  | "activity.empty.retry"
  | "activity.empty.search"
  | "activity.empty.search.clear_all"
  | "activity.empty.search.clear_filters"
  | "activity.empty.search.hint"
  | "activity.empty.search.title"
  | "activity.excluded.held"
  | "activity.excluded.held.desc"
  | "activity.excluded.hint"
  | "activity.excluded.retry"
  | "activity.excluded.retry.desc"
  | "activity.excluded.rollback"
  | "activity.excluded.rollback.desc"
  | "activity.excluded.title"
  | "activity.filter.actor"
  | "activity.filter.clear"
  | "activity.filter.hint.project"
  | "activity.filter.open"
  | "activity.filter.search"
  | "activity.filter.search.disconnected"
  | "activity.filter.search.project"
  | "activity.filter.status"
  | "activity.filter.time"
  | "activity.filter.time.earlier"
  | "activity.filter.time.today"
  | "activity.filter.time.week"
  | "activity.filter.time.yesterday"
  | "activity.filter.type"
  | "activity.follow.auto.tag"
  | "activity.follow.auto.title"
  | "activity.follow.manual.tag"
  | "activity.follow.manual.title"
  | "activity.follow.object.agent"
  | "activity.follow.object.project"
  | "activity.follow.object.resource"
  | "activity.follow.object.site"
  | "activity.follow.object.task"
  | "activity.follow.source.assigned"
  | "activity.follow.source.auto"
  | "activity.follow.source.joined"
  | "activity.follow.source.manual"
  | "activity.follow.source.started"
  | "activity.follow.table.foot"
  | "activity.gate.entitlement"
  | "activity.gate.needs_info"
  | "activity.gate.question"
  | "activity.gate.recovery_choice"
  | "activity.gate.red_confirm"
  | "activity.group.locked"
  | "activity.group.long"
  | "activity.group.offline"
  | "activity.group.recovered"
  | "activity.group.recovered.meta"
  | "activity.group.single"
  | "activity.group.unclosed"
  | "activity.internal.desc"
  | "activity.internal.title"
  | "activity.kind.activity"
  | "activity.kind.ops_alert"
  | "activity.list.load_more"
  | "activity.list.loading_more"
  | "activity.macos.title"
  | "activity.narrow.order.detail"
  | "activity.narrow.order.detail.desc"
  | "activity.narrow.order.detail.pill"
  | "activity.narrow.order.list"
  | "activity.narrow.order.list.desc"
  | "activity.narrow.order.nav"
  | "activity.narrow.order.nav.desc"
  | "activity.narrow.order.nav.pill"
  | "activity.narrow.order.note"
  | "activity.narrow.order.title"
  | "activity.narrow.sidecar_sub"
  | "activity.offline.note.desc"
  | "activity.offline.note.title"
  | "activity.ops_alert.acknowledge"
  | "activity.overview.see_all"
  | "activity.page.subtitle"
  | "activity.page.subtitle.narrow"
  | "activity.page.subtitle.project"
  | "activity.page.title"
  | "activity.project.name.event2026"
  | "activity.project.name.npcshop"
  | "activity.project.note.desc"
  | "activity.project.note.overview"
  | "activity.project.note.overview.desc"
  | "activity.project.note.title"
  | "activity.project.note.wont"
  | "activity.project.note.wont.desc"
  | "activity.recover.note.desc"
  | "activity.recover.note.title"
  | "activity.scope.all"
  | "activity.scope.all_projects"
  | "activity.scope.label"
  | "activity.scope.pick"
  | "activity.scope.platform"
  | "activity.scope.project"
  | "activity.search.group"
  | "activity.search.meta"
  | "activity.sha.note.desc"
  | "activity.sha.note.title"
  | "activity.sheet.apply"
  | "activity.sheet.clear"
  | "activity.sheet.current"
  | "activity.sheet.event2026.sub"
  | "activity.sheet.npcshop.sub"
  | "activity.sheet.project_search"
  | "activity.sheet.status.bundle"
  | "activity.sheet.sub"
  | "activity.states.col.mean"
  | "activity.states.col.proof"
  | "activity.states.col.status"
  | "activity.states.col.wrong"
  | "activity.states.label"
  | "activity.states.meta"
  | "activity.states.subtitle"
  | "activity.states.tag"
  | "activity.states.title"
  | "activity.status.awaiting_decision"
  | "activity.status.awaiting_dependency"
  | "activity.status.completed"
  | "activity.status.disconnected"
  | "activity.status.failed"
  | "activity.status.platform_held"
  | "activity.status.platform_held.hint"
  | "activity.status.platform_held.no_resubmit"
  | "activity.status.production_verified"
  | "activity.status.queued"
  | "activity.status.recovering"
  | "activity.status.rollback.executed"
  | "activity.status.rollback.registered"
  | "activity.status.rolled_back"
  | "activity.status.running"
  | "activity.status.unknown"
  | "activity.status.unknown.hint"
  | "activity.stream.reset"
  | "activity.summary.fast_delivery.production_verified"
  | "activity.summary.inspection.completed"
  | "activity.type.conversation"
  | "activity.type.lulu"
  | "activity.type.project"
  | "activity.type.release"
  | "activity.type.resource"
  | "activity.type.site"
  | "activity.type.task"
  | "activity.type.team"
  | "activity.unclosed"
  | "activity.unclosed.hint"
  | "activity.unread"
  | "activity.view.action"
  | "activity.view.action.subtitle"
  | "activity.view.all"
  | "activity.view.following"
  | "activity.view.following.subtitle"
  | "activity.view.important"
  | "activity.view.important.subtitle"
  | "ai_os.action.approve_red"
  | "ai_os.action.cancel"
  | "ai_os.action.create"
  | "ai_os.action.disable_learning"
  | "ai_os.action.retry"
  | "ai_os.action.submit"
  | "ai_os.action.submitted"
  | "ai_os.action.submitting"
  | "ai_os.action.view_evidence"
  | "ai_os.conflict.already_submitted"
  | "ai_os.conflict.changed_elsewhere"
  | "ai_os.conflict.same_key_different_content"
  | "ai_os.empty.evaluations"
  | "ai_os.empty.learning"
  | "ai_os.empty.modules"
  | "ai_os.empty.proposals"
  | "ai_os.error.create_failed"
  | "ai_os.error.detail_failed"
  | "ai_os.error.list_failed"
  | "ai_os.error.missing_evidence"
  | "ai_os.error.missing_rollback"
  | "ai_os.error.missing_user_value"
  | "ai_os.error.module_gone"
  | "ai_os.error.red_needs_click"
  | "ai_os.eval.degraded"
  | "ai_os.eval.failed"
  | "ai_os.eval.heading"
  | "ai_os.eval.passed"
  | "ai_os.eval.pending"
  | "ai_os.evidence.candidate"
  | "ai_os.evidence.candidate.detail"
  | "ai_os.evidence.frozen"
  | "ai_os.evidence.heading"
  | "ai_os.evidence.not_enough_to_learn"
  | "ai_os.evidence.preview_verified"
  | "ai_os.evidence.preview_verified.detail"
  | "ai_os.evidence.production_verified"
  | "ai_os.evidence.production_verified.detail"
  | "ai_os.field.acceptance"
  | "ai_os.field.acceptance.hint"
  | "ai_os.field.budget"
  | "ai_os.field.budget.hint"
  | "ai_os.field.forbidden_boundaries"
  | "ai_os.field.goal"
  | "ai_os.field.impact_audience"
  | "ai_os.field.module"
  | "ai_os.field.owner_stream"
  | "ai_os.field.problem_evidence"
  | "ai_os.field.problem_evidence.hint"
  | "ai_os.field.requires_human_click"
  | "ai_os.field.requires_human_click.locked"
  | "ai_os.field.risk_level"
  | "ai_os.field.rollback"
  | "ai_os.field.rollback.hint"
  | "ai_os.field.stop_conditions"
  | "ai_os.field.stop_conditions.hint"
  | "ai_os.field.title"
  | "ai_os.field.user_value"
  | "ai_os.field.user_value.hint"
  | "ai_os.learning.active"
  | "ai_os.learning.expired_state"
  | "ai_os.learning.rolled_back_state"
  | "ai_os.loading.detail"
  | "ai_os.loading.evidence"
  | "ai_os.loading.list"
  | "ai_os.loading.submitting"
  | "ai_os.module.heading"
  | "ai_os.module.no_rollback"
  | "ai_os.module.state.active"
  | "ai_os.module.state.deprecated"
  | "ai_os.module.state.retired"
  | "ai_os.proposal.auto_note"
  | "ai_os.proposal.evaluation_degraded.user_value"
  | "ai_os.proposal.no_task_yet"
  | "ai_os.proposal.stop.attempts_exhausted"
  | "ai_os.proposal.stopped_by_budget"
  | "ai_os.proposal.task_link"
  | "ai_os.proposal.uncertain"
  | "ai_os.retry.blocked_by_red"
  | "ai_os.retry.manual_ok"
  | "ai_os.risk.amber"
  | "ai_os.risk.amber.detail"
  | "ai_os.risk.green"
  | "ai_os.risk.green.detail"
  | "ai_os.risk.red"
  | "ai_os.risk.red.await_click"
  | "ai_os.risk.red.detail"
  | "ai_os.risk.red.refuse_auto"
  | "ai_os.section.acceptance_heading"
  | "ai_os.section.budget_heading"
  | "ai_os.section.detail_link"
  | "ai_os.section.empty"
  | "ai_os.section.evidence_heading"
  | "ai_os.section.learning_heading"
  | "ai_os.section.learning_subtitle"
  | "ai_os.section.plan_heading"
  | "ai_os.section.rollback_heading"
  | "ai_os.section.subtitle"
  | "ai_os.section.title"
  | "ai_os.stage.accepted"
  | "ai_os.stage.diagnosed"
  | "ai_os.stage.executing"
  | "ai_os.stage.failed"
  | "ai_os.stage.fix_requested"
  | "ai_os.stage.learning_candidate"
  | "ai_os.stage.observed"
  | "ai_os.stage.preview_verified"
  | "ai_os.stage.production_verified"
  | "ai_os.stage.promoted"
  | "ai_os.stage.proposed"
  | "ai_os.stage.releasing"
  | "ai_os.stage.rollback_requested"
  | "ai_os.stage.rolled_back"
  | "alert.affected_unknown"
  | "alert.card.ask"
  | "alert.card.handled"
  | "alert.card.how_fixed"
  | "alert.card.mute_this_kind"
  | "alert.channel.digest"
  | "alert.channel.none"
  | "alert.channel.phone"
  | "alert.channel.push"
  | "alert.conversation_feed_stuck_affected"
  | "alert.deploy_done"
  | "alert.duty.link"
  | "alert.host_down.affected_unknown"
  | "alert.incident.empty"
  | "alert.incident.heading"
  | "alert.narrow.empty"
  | "alert.narrow.heading"
  | "alert.needs_your_click"
  | "alert.page.subtitle"
  | "alert.page.title"
  | "alert.phone.empty"
  | "alert.phone.hint"
  | "alert.refused_to_touch"
  | "alert.rule.handled.desc"
  | "alert.rule.handled.title"
  | "alert.rule.needs_you.desc"
  | "alert.rule.needs_you.title"
  | "alert.rule.night_noise.desc"
  | "alert.rule.night_noise.title"
  | "alert.rule.site_down.desc"
  | "alert.rule.site_down.title"
  | "alert.rules.empty"
  | "alert.rules.heading"
  | "alert.rules.stop_calling"
  | "alert.rules.wait_for_digest"
  | "auth.authentication.strong_required"
  | "auth.bootstrap.mode.cta"
  | "auth.bootstrap.token.label"
  | "auth.bootstrap.token.placeholder"
  | "auth.brand.captain.detail"
  | "auth.brand.captain.name"
  | "auth.brand.headline"
  | "auth.brand.portrait_placeholder"
  | "auth.brand.subhead"
  | "auth.brand.vault_note"
  | "auth.brand.wordmark"
  | "auth.code.expired"
  | "auth.code.wrong"
  | "auth.divider.or"
  | "auth.email_code.cta"
  | "auth.error.mail_from_invalid"
  | "auth.error.mail_invalid"
  | "auth.error.no_mail_channel"
  | "auth.error.passkey_setup_required"
  | "auth.field.code.label"
  | "auth.field.current_password.label"
  | "auth.field.email.label"
  | "auth.field.email.placeholder"
  | "auth.field.new_password.label"
  | "auth.field.password.label"
  | "auth.field.password.placeholder"
  | "auth.field.recovery.label"
  | "auth.first_step.body"
  | "auth.first_step.title"
  | "auth.invited.body"
  | "auth.invited.title"
  | "auth.no_password.body"
  | "auth.no_password.title"
  | "auth.passkey.cta"
  | "auth.passkey.done"
  | "auth.passkey.failed.already"
  | "auth.passkey.failed.dismissed"
  | "auth.passkey.failed.domain"
  | "auth.passkey.failed.unknown"
  | "auth.passkey.failed.unsupported"
  | "auth.passkey.invite"
  | "auth.passkey.setup_cta"
  | "auth.passkey.unsupported"
  | "auth.password.change.cta"
  | "auth.password.cta"
  | "auth.password.current_invalid"
  | "auth.password.hint"
  | "auth.password.invalid"
  | "auth.password.recent_auth_required"
  | "auth.password.set.cta"
  | "auth.password.updated"
  | "auth.password.weak"
  | "auth.paths.only_one"
  | "auth.point.autonomous.detail"
  | "auth.point.autonomous.title"
  | "auth.point.ssh_once.detail"
  | "auth.point.ssh_once.title"
  | "auth.point.team.detail"
  | "auth.point.team.title"
  | "auth.recovery.cta"
  | "auth.recovery.hint"
  | "auth.recovery.needs_email"
  | "auth.recovery.submit"
  | "auth.recovery_codes.detail"
  | "auth.recovery_codes.heading"
  | "auth.registration.invalid"
  | "auth.signin.cta"
  | "auth.signin.failed"
  | "auth.signin.subtitle"
  | "auth.signin.switch_cta"
  | "auth.signin.switch_hint"
  | "auth.signin.title"
  | "auth.signup.cta"
  | "auth.signup.subtitle"
  | "auth.signup.switch_cta"
  | "auth.signup.switch_hint"
  | "auth.signup.title"
  | "auth.step_up.prompt"
  | "auth.stepup.code.cta"
  | "auth.stepup.code.sent"
  | "auth.stepup.password.cta"
  | "auth.stepup.password.label"
  | "auth.stepup.password.wrong"
  | "bridge.error.scope_insufficient"
  | "bridge.grants.empty"
  | "bridge.grants.heading"
  | "bridge.grants.hint"
  | "bridge.grants.issue"
  | "bridge.grants.revoke"
  | "bridge.tokens.empty"
  | "bridge.tokens.error.idempotency_mismatch"
  | "bridge.tokens.error.invalid"
  | "bridge.tokens.error.scope_forbidden"
  | "bridge.tokens.heading"
  | "bridge.tokens.hint"
  | "bridge.tokens.issue.cta"
  | "bridge.tokens.issue.failed"
  | "bridge.tokens.issue.heading"
  | "bridge.tokens.issue.label"
  | "bridge.tokens.issue.label_example"
  | "bridge.tokens.issue.pending"
  | "bridge.tokens.issue.project"
  | "bridge.tokens.issue.scopes"
  | "bridge.tokens.issue.stepup"
  | "bridge.tokens.issue.ttl"
  | "bridge.tokens.issued.close"
  | "bridge.tokens.issued.copied"
  | "bridge.tokens.issued.copy"
  | "bridge.tokens.issued.heading"
  | "bridge.tokens.issued.hint"
  | "bridge.tokens.issued.replayed"
  | "bridge.tokens.revoke"
  | "bridge.tokens.revoke.failed"
  | "bridge.tokens.revoke.stepup"
  | "bridge.tokens.revoke.title"
  | "bridge.tokens.revoking"
  | "bridge.tokens.row.never_expires"
  | "bridge.tokens.row.never_used"
  | "bridge.tokens.scope.access_request"
  | "bridge.tokens.scope.hosts_read"
  | "bridge.tokens.scope.projects_read"
  | "bridge.tokens.show_revoked"
  | "bridge.tokens.status.active"
  | "bridge.tokens.status.expired"
  | "bridge.tokens.status.revoked"
  | "bridge.tokens.ttl.30d"
  | "bridge.tokens.ttl.7d"
  | "bridge.tokens.ttl.90d"
  | "bridge.tokens.ttl.never"
  | "bug_reports.close"
  | "bug_reports.confirm_fix"
  | "bug_reports.disable"
  | "bug_reports.empty"
  | "bug_reports.enable"
  | "bug_reports.enabled"
  | "bug_reports.failed"
  | "bug_reports.filter.all"
  | "bug_reports.loading"
  | "bug_reports.more"
  | "bug_reports.no_description"
  | "bug_reports.resolved_note"
  | "bug_reports.rotate"
  | "bug_reports.screenshot"
  | "bug_reports.state.admin"
  | "bug_reports.state.analyzing"
  | "bug_reports.state.done"
  | "bug_reports.state.fixing"
  | "bug_reports.state.reporter"
  | "bug_reports.subtitle"
  | "bug_reports.title"
  | "chat.brief.active"
  | "chat.brief.empty"
  | "chat.brief.empty_hint"
  | "chat.brief.heading"
  | "chat.brief.note"
  | "chat.brief.waiting"
  | "chat.error.unavailable"
  | "chat.facts.external_verify_hint"
  | "chat.facts.heading"
  | "chat.facts.kind.commit"
  | "chat.facts.kind.deploy"
  | "chat.facts.kind.external_verify"
  | "chat.facts.kind.rollback"
  | "chat.facts.kind.test"
  | "chat.facts.note"
  | "chat.facts.status.failed"
  | "chat.facts.status.none"
  | "chat.facts.status.not_applicable"
  | "chat.facts.status.passed"
  | "chat.facts.status.pending_verify"
  | "chat.facts.status.running"
  | "chat.flywheel.completed"
  | "chat.flywheel.deploy_failed"
  | "chat.flywheel.empty"
  | "chat.flywheel.heading"
  | "chat.input.archived"
  | "chat.input.label"
  | "chat.input.placeholder"
  | "chat.input.send"
  | "chat.list.account_create"
  | "chat.list.account_group"
  | "chat.list.archived"
  | "chat.list.create"
  | "chat.list.empty"
  | "chat.list.group_create"
  | "chat.list.group_less"
  | "chat.list.group_unavailable"
  | "chat.list.mobile_open"
  | "chat.list.nav"
  | "chat.list.waiting"
  | "chat.lulu.receipts.approve"
  | "chat.lulu.receipts.closed"
  | "chat.lulu.receipts.empty"
  | "chat.lulu.receipts.heading"
  | "chat.lulu.receipts.pending"
  | "chat.lulu.receipts.reject"
  | "chat.mention.action"
  | "chat.mention.empty"
  | "chat.mention.hint"
  | "chat.message.empty"
  | "chat.next.developing"
  | "chat.next.fix"
  | "chat.next.live"
  | "chat.next.preview"
  | "chat.next.release"
  | "chat.next.testing"
  | "chat.page.subtitle"
  | "chat.page.title"
  | "chat.panel.collapse"
  | "chat.panel.expand"
  | "chat.panel.mobile_close"
  | "chat.panel.mobile_open"
  | "chat.participant.developer"
  | "chat.participant.human"
  | "chat.participant.reviewer"
  | "chat.participant.steward"
  | "chat.participants.empty"
  | "chat.participants.error"
  | "chat.participants.heading"
  | "chat.phase.developing"
  | "chat.phase.fix"
  | "chat.phase.live"
  | "chat.phase.preview"
  | "chat.phase.release"
  | "chat.phase.testing"
  | "chat.platform.job_failed"
  | "chat.platform.job_succeeded"
  | "chat.receipt.action"
  | "chat.receipt.degraded"
  | "chat.schedule.action"
  | "chat.schedule.done"
  | "chat.schedule.executor.label"
  | "chat.schedule.executor.own_key"
  | "chat.schedule.executor.plan"
  | "chat.schedule.executor.unavailable"
  | "chat.schedule.hint"
  | "chat.schedule.no_project"
  | "chat.task.base_sha_pending"
  | "chat.tasktree.empty"
  | "chat.tasktree.empty_hint"
  | "chat.tasktree.heading"
  | "chat.tasktree.owner_unassigned"
  | "check.log.nothing_found"
  | "code.action.diff"
  | "code.application.current"
  | "code.application.empty"
  | "code.application.open_project"
  | "code.application.partial"
  | "code.application.recent"
  | "code.inspection.detail"
  | "code.inspection.empty"
  | "code.inspection.idle"
  | "code.inspection.repair"
  | "code.inspection.subtitle"
  | "code.overview.active"
  | "code.overview.attention"
  | "code.overview.live"
  | "code.page.subtitle"
  | "code.section.commits"
  | "code.section.commits.hint"
  | "code.section.prs"
  | "code.section.prs.hint"
  | "code.section.repos"
  | "code.tab.applications"
  | "code.tab.inspections"
  | "code.tab.sites"
  | "credential.error.blank"
  | "credential.error.forbidden_raw"
  | "credential.error.vendor_missing"
  | "credential.reveal.code_required"
  | "credential.reveal.code_wrong"
  | "credential.reveal.hidden_again"
  | "credential.reveal.reason_required"
  | "credential.revoked"
  | "credential.rotated"
  | "credential.scope.too_wide"
  | "credential.source.leaked_channel"
  | "dashboard.action.add_host"
  | "dashboard.action.nightly_report"
  | "dashboard.attention.ack"
  | "dashboard.attention.detail_cta"
  | "dashboard.attention.timeline_cta"
  | "dashboard.greeting.all_well"
  | "dashboard.greeting.something_burning"
  | "dashboard.nightly.fixed_bug.detail"
  | "dashboard.nightly.patched.detail"
  | "dashboard.nightly.watching.detail"
  | "dashboard.project.no_domain"
  | "dashboard.running.hint"
  | "dashboard.running.title"
  | "dashboard.section.attention"
  | "dashboard.section.attention.hint"
  | "dashboard.section.last_night"
  | "dashboard.section.projects"
  | "dashboard.section.projects.hint"
  | "dashboard.stat.attention"
  | "dashboard.stat.hosts"
  | "dashboard.stat.hosts.all_online"
  | "dashboard.stat.projects"
  | "development_task.action.add_acceptance"
  | "development_task.action.add_context"
  | "development_task.action.cancel"
  | "development_task.action.cancelling"
  | "development_task.action.claim"
  | "development_task.action.claiming"
  | "development_task.action.confirm_cancel"
  | "development_task.action.copied"
  | "development_task.action.copy"
  | "development_task.action.keep"
  | "development_task.action.prepare_repo"
  | "development_task.action.preparing"
  | "development_task.action.remove"
  | "development_task.action.repair"
  | "development_task.action.retry"
  | "development_task.actor.external"
  | "development_task.actor.internal"
  | "development_task.assignee.auto"
  | "development_task.assignee.cannot_execute"
  | "development_task.assignee.local_hint"
  | "development_task.assignee.manual"
  | "development_task.assignee.unavailable"
  | "development_task.cancel.body"
  | "development_task.cancel.title"
  | "development_task.claim.copy"
  | "development_task.claim.endpoint"
  | "development_task.claim.expiry"
  | "development_task.claim.fingerprint"
  | "development_task.claim.subtitle"
  | "development_task.claim.title"
  | "development_task.claim.token"
  | "development_task.claim.username"
  | "development_task.comments.empty"
  | "development_task.comments.failed"
  | "development_task.comments.outcome_recorded"
  | "development_task.comments.outcome_reopened"
  | "development_task.comments.placeholder"
  | "development_task.comments.submit"
  | "development_task.comments.title"
  | "development_task.context.api_contract"
  | "development_task.context.asset"
  | "development_task.context.code_path"
  | "development_task.context.data_migration"
  | "development_task.context.deployment"
  | "development_task.context.design"
  | "development_task.context.product_doc"
  | "development_task.context.reference"
  | "development_task.context.test_plan"
  | "development_task.context.ui_route"
  | "development_task.create.action"
  | "development_task.create.submit"
  | "development_task.create.submitting"
  | "development_task.create.subtitle"
  | "development_task.create.title"
  | "development_task.detail.live_sha"
  | "development_task.detail.needs_rebase"
  | "development_task.detail.release_id"
  | "development_task.domain.backend"
  | "development_task.domain.data"
  | "development_task.domain.design"
  | "development_task.domain.frontend"
  | "development_task.domain.infra"
  | "development_task.domain.product"
  | "development_task.domain.qa"
  | "development_task.domain.release"
  | "development_task.error.claimed"
  | "development_task.error.prepare_paused"
  | "development_task.error.prepare_retrying"
  | "development_task.error.prepare_select_repo"
  | "development_task.event.attempt_claimed"
  | "development_task.event.attempt_progress"
  | "development_task.event.attempt_state_changed"
  | "development_task.event.task_cancelled"
  | "development_task.event.task_created"
  | "development_task.event.task_state_changed"
  | "development_task.event.updated"
  | "development_task.field.acceptance"
  | "development_task.field.acceptance_hint"
  | "development_task.field.base_sha"
  | "development_task.field.context_digest"
  | "development_task.field.context_kind"
  | "development_task.field.context_locator"
  | "development_task.field.context_title"
  | "development_task.field.executor"
  | "development_task.field.executor_model"
  | "development_task.field.executor_provider"
  | "development_task.field.instructions"
  | "development_task.field.model"
  | "development_task.field.repo"
  | "development_task.field.title"
  | "development_task.hint.claim"
  | "development_task.hint.context"
  | "development_task.hint.copy_failed"
  | "development_task.hint.digest"
  | "development_task.hint.domains"
  | "development_task.hint.draft"
  | "development_task.hint.executor_identity"
  | "development_task.hint.executor_identity_partial"
  | "development_task.hint.model"
  | "development_task.hint.no_context"
  | "development_task.hint.no_recommendation"
  | "development_task.hint.preparing"
  | "development_task.hint.preparing_claim"
  | "development_task.hint.preparing_packet"
  | "development_task.hint.ready"
  | "development_task.hint.request_error"
  | "development_task.hint.timeline_empty"
  | "development_task.hint.timeline_error"
  | "development_task.hint.timeline_loading"
  | "development_task.magic.acceptance"
  | "development_task.magic.claim_error"
  | "development_task.magic.claimed.hint"
  | "development_task.magic.claiming"
  | "development_task.magic.copy.action"
  | "development_task.magic.copy.done"
  | "development_task.magic.error.back"
  | "development_task.magic.error.title"
  | "development_task.magic.identity.action"
  | "development_task.magic.identity.capability"
  | "development_task.magic.identity.hint"
  | "development_task.magic.identity.invalid"
  | "development_task.magic.identity.label"
  | "development_task.magic.identity.placeholder"
  | "development_task.magic.identity.title"
  | "development_task.magic.invalid"
  | "development_task.magic.issue.action"
  | "development_task.magic.issue.pending"
  | "development_task.magic.issue.renew"
  | "development_task.magic.issue_error"
  | "development_task.magic.open_error"
  | "development_task.magic.opening"
  | "development_task.magic.panel.hint"
  | "development_task.magic.panel.title"
  | "development_task.magic.prompt"
  | "development_task.magic.public.hint"
  | "development_task.magic.public.title"
  | "development_task.magic.request_error"
  | "development_task.magic.token_missing"
  | "development_task.maintainer.duration.180d"
  | "development_task.maintainer.duration.30d"
  | "development_task.maintainer.duration.90d"
  | "development_task.maintainer.duration.label"
  | "development_task.maintainer.duration.long_term"
  | "development_task.maintainer.error.claimed"
  | "development_task.maintainer.error.expired"
  | "development_task.maintainer.error.key_mismatch"
  | "development_task.maintainer.issue"
  | "development_task.maintainer.label"
  | "development_task.maintainer.panel.hint"
  | "development_task.maintainer.panel.title"
  | "development_task.maintainer.pending"
  | "development_task.maintainer.placeholder"
  | "development_task.maintainer.public.hint"
  | "development_task.maintainer.revoke"
  | "development_task.maintainer.rotate"
  | "development_task.memory.empty"
  | "development_task.memory.kind.comment"
  | "development_task.memory.kind.failed_because"
  | "development_task.memory.kind.note"
  | "development_task.memory.kind.tried"
  | "development_task.memory.title"
  | "development_task.mission.action.open_preview"
  | "development_task.mission.action.publish"
  | "development_task.mission.action.rollback"
  | "development_task.mission.action.unavailable"
  | "development_task.mission.field.integration_sha"
  | "development_task.mission.field.next_step"
  | "development_task.mission.field.owner_sha"
  | "development_task.mission.field.preview_url"
  | "development_task.mission.field.production_sha"
  | "development_task.mission.next.cancelled"
  | "development_task.mission.next.fast_test"
  | "development_task.mission.next.in_development"
  | "development_task.mission.next.live"
  | "development_task.mission.next.live_rollback"
  | "development_task.mission.next.needs_fix"
  | "development_task.mission.next.pending_release"
  | "development_task.mission.next.preview_available"
  | "development_task.mission.next.preview_available_no_url"
  | "development_task.mission.next.publish_failed"
  | "development_task.mission.panel.hint"
  | "development_task.mission.panel.title"
  | "development_task.mission.request.failure"
  | "development_task.mission.request.running"
  | "development_task.mission.request.success"
  | "development_task.mission.status.fast_test"
  | "development_task.mission.status.in_development"
  | "development_task.mission.status.live"
  | "development_task.mission.status.needs_fix"
  | "development_task.mission.status.pending_release"
  | "development_task.mission.status.preview_available"
  | "development_task.mission.unavailable"
  | "development_task.preview.action"
  | "development_task.preview.again"
  | "development_task.preview.blame.access"
  | "development_task.preview.blame.input"
  | "development_task.preview.blame.label"
  | "development_task.preview.blame.offline"
  | "development_task.preview.blame.platform"
  | "development_task.preview.blame.unknown"
  | "development_task.preview.blame.version"
  | "development_task.preview.closed"
  | "development_task.preview.field.owner_tip"
  | "development_task.preview.field.preview_sha"
  | "development_task.preview.field.release_sha"
  | "development_task.preview.panel.hint"
  | "development_task.preview.panel.title"
  | "development_task.preview.pending"
  | "development_task.preview.rollback"
  | "development_task.preview.state.owner_tip"
  | "development_task.preview.state.preview_failed_rolled_back"
  | "development_task.preview.state.preview_ready"
  | "development_task.preview.state.preview_running"
  | "development_task.preview.state.production_verified"
  | "development_task.preview.state.release_requested"
  | "development_task.preview.state.test_candidate"
  | "development_task.preview.view_only"
  | "development_task.preview.waiting"
  | "development_task.remote_ai.invitation.pending_hint"
  | "development_task.remote_ai.invitation.revoke"
  | "development_task.remote_ai.invitation.revoke_confirm"
  | "development_task.remote_ai.invitation.revoke_failed"
  | "development_task.remote_ai.invitation.revoking"
  | "development_task.repo.account_error"
  | "development_task.repo.all_unavailable"
  | "development_task.repo.association_error"
  | "development_task.repo.association_loading"
  | "development_task.repo.candidate_label"
  | "development_task.repo.candidate_select"
  | "development_task.repo.candidates_error"
  | "development_task.repo.candidates_unavailable"
  | "development_task.repo.error"
  | "development_task.repo.link_action"
  | "development_task.repo.link_conflict"
  | "development_task.repo.link_error"
  | "development_task.repo.link_hint"
  | "development_task.repo.link_unavailable"
  | "development_task.repo.linking"
  | "development_task.repo.loading"
  | "development_task.repo.no_candidates"
  | "development_task.repo.none"
  | "development_task.repo.permission"
  | "development_task.repo.refreshing"
  | "development_task.repo.retrying"
  | "development_task.repo.select"
  | "development_task.repo.select_hint"
  | "development_task.section.advanced"
  | "development_task.section.attached"
  | "development_task.section.context"
  | "development_task.section.details"
  | "development_task.section.domains"
  | "development_task.section.executor_identity"
  | "development_task.section.git"
  | "development_task.section.optional"
  | "development_task.section.packet"
  | "development_task.section.recommended"
  | "development_task.section.status"
  | "development_task.section.timeline"
  | "development_task.stagecard.cancelled"
  | "development_task.stagecard.ci"
  | "development_task.stagecard.claimed"
  | "development_task.stagecard.decision"
  | "development_task.stagecard.delivered"
  | "development_task.stagecard.failed"
  | "development_task.stagecard.fix_requested"
  | "development_task.stagecard.live"
  | "development_task.stagecard.ready"
  | "development_task.stagecard.reviewing"
  | "development_task.stages.empty"
  | "development_task.stages.live_note"
  | "development_task.stages.title"
  | "development_task.state.cancelled"
  | "development_task.state.ci_running"
  | "development_task.state.draft"
  | "development_task.state.failed"
  | "development_task.state.fix_requested"
  | "development_task.state.gating"
  | "development_task.state.pending_approval"
  | "development_task.state.preparing"
  | "development_task.state.ready"
  | "development_task.state.ready_to_claim"
  | "development_task.state.reviewing"
  | "development_task.state.running"
  | "development_task.state.v2_handoff"
  | "development_task.user_state.cancelled"
  | "development_task.user_state.claimable"
  | "development_task.user_state.in_progress"
  | "development_task.user_state.live"
  | "development_task.user_state.needs_action"
  | "duty.cards.heading"
  | "duty.collab.pending"
  | "duty.kind.act"
  | "duty.kind.observe"
  | "duty.page.subtitle"
  | "duty.page.title"
  | "duty.schedule.empty"
  | "duty.schedule.heading"
  | "duty.schedule.source"
  | "duty.toggle.off"
  | "duty.toggle.on"
  | "error.conversation.attachment_bad_type"
  | "error.conversation.attachment_looks_like_key"
  | "error.conversation.attachment_not_claimable"
  | "error.conversation.attachment_too_large"
  | "error.conversation.attachment_too_many"
  | "error.conversation.attachment_type_mismatch"
  | "error.executor_unavailable"
  | "error.forbidden.hosts"
  | "error.generic"
  | "error.memo.attachment_bad_type"
  | "error.memo.attachment_too_large"
  | "error.memo.audio_bad_type"
  | "error.memo.audio_too_large"
  | "error.memo.audio_too_long"
  | "error.memo.password_too_short"
  | "error.memo.password_wrong"
  | "error.memo.unlock_throttled"
  | "error.memo.version_conflict"
  | "error.memo.voice_needs_access"
  | "error.not_found"
  | "error.read_failed.retry"
  | "error.read_failed.title"
  | "error.step_up_required"
  | "error.unauthorized"
  | "host.access.credential.kept"
  | "host.access.credential.revoked"
  | "host.access.heading"
  | "host.access.keys.heading"
  | "host.access.keys.ours"
  | "host.access.keys.yours_none"
  | "host.access.original.none"
  | "host.access.original.password"
  | "host.access.original.unknown"
  | "host.access.original.unknown_reachable"
  | "host.access.ours.status.unknown"
  | "host.access.ours.status.unusable"
  | "host.access.ours.status.usable"
  | "host.access.ours.used_by"
  | "host.access.yours.never_checked"
  | "host.access.yours.status.unknown"
  | "host.access.yours.status.unusable"
  | "host.access.yours.status.usable"
  | "host.access.yours.used_by"
  | "host.action.connect_myself"
  | "host.action.reconnect"
  | "host.action.temp_key"
  | "host.busy.heading"
  | "host.busy.window"
  | "host.card.activity"
  | "host.card.agent"
  | "host.card.capacity"
  | "host.card.detail"
  | "host.card.next"
  | "host.card.uncollected"
  | "host.card.unknown"
  | "host.card.workloads"
  | "host.credential.copy"
  | "host.credential.field.address"
  | "host.credential.field.key"
  | "host.credential.field.user"
  | "host.credential.heading"
  | "host.credential.kept"
  | "host.credential.note"
  | "host.group.assigned"
  | "host.group.available"
  | "host.group.exception"
  | "host.label.behind_nat"
  | "host.label.cannot_go_down"
  | "host.label.has_database"
  | "host.label.shared_infra"
  | "host.list.col.host"
  | "host.list.col.project"
  | "host.list.col.state"
  | "host.list.col.what"
  | "host.list.col.where"
  | "host.list.decision_hint"
  | "host.list.empty.body"
  | "host.list.empty.title"
  | "host.list.intro"
  | "host.list.intro_ready"
  | "host.list.mixed.body"
  | "host.list.mixed.body_warn"
  | "host.list.mixed.title"
  | "host.list.parent_reject"
  | "host.list.pool.title"
  | "host.list.project_first.body"
  | "host.list.project_first.cta"
  | "host.list.project_first.title"
  | "host.list.suggestion_pick"
  | "host.list.title"
  | "host.list.unassigned_hint"
  | "host.list.unassigned_hint_none"
  | "host.location.lan"
  | "host.metric.cpu.busy"
  | "host.metric.cpu.idle"
  | "host.metric.cpu.label"
  | "host.metric.cpu.overloaded"
  | "host.metric.disk.filling"
  | "host.metric.disk.full"
  | "host.metric.disk.label"
  | "host.metric.disk.ok"
  | "host.metric.memory.label"
  | "host.metric.memory.ok"
  | "host.metric.memory.tight"
  | "host.occupancy.unassigned"
  | "host.overview.all"
  | "host.overview.assigned"
  | "host.overview.available"
  | "host.overview.exception"
  | "host.overview.pending"
  | "host.probe.disconnected"
  | "host.reach.blocked"
  | "host.reach.credential"
  | "host.reach.host_key_changed"
  | "host.reach.never_succeeded"
  | "host.reach.unknown"
  | "host.recent.heading"
  | "host.recent.today"
  | "host.recent.yesterday"
  | "host.recheck.action"
  | "host.recheck.failed"
  | "host.recheck.running"
  | "host.recheck.still_unknown"
  | "host.reparent.suggest.neither"
  | "host.status.credential"
  | "host.status.disk_filling"
  | "host.status.error"
  | "host.status.offline"
  | "host.status.onboarding"
  | "host.status.online"
  | "host.status.provisioning"
  | "host.status.reclaimed"
  | "host.summary.frontend"
  | "host.summary.heading"
  | "host.summary.unassigned"
  | "host.workloads.heading"
  | "job.canceled"
  | "job.resumed"
  | "job.step.not_started"
  | "lulu.history.hidden_entry"
  | "lulu.reply.candidate_missing"
  | "lulu.reply.mentioned_someone"
  | "lulu.reply.watcher_noted_no_owner"
  | "lulu_agents.add"
  | "lulu_agents.autofill"
  | "lulu_agents.autofill_failed"
  | "lulu_agents.autofill_hint"
  | "lulu_agents.autofill_unsure"
  | "lulu_agents.autofill_working"
  | "lulu_agents.cancel"
  | "lulu_agents.col_agent"
  | "lulu_agents.col_executor"
  | "lulu_agents.col_model"
  | "lulu_agents.col_responsibilities"
  | "lulu_agents.col_role"
  | "lulu_agents.col_scope"
  | "lulu_agents.col_state"
  | "lulu_agents.create"
  | "lulu_agents.create_failed"
  | "lulu_agents.dialog_desc"
  | "lulu_agents.dialog_title"
  | "lulu_agents.disable"
  | "lulu_agents.disable_note"
  | "lulu_agents.edit"
  | "lulu_agents.edit_dialog_desc"
  | "lulu_agents.empty"
  | "lulu_agents.executor_unbound"
  | "lulu_agents.f_name"
  | "lulu_agents.f_name_hint"
  | "lulu_agents.f_responsibilities"
  | "lulu_agents.f_responsibilities_empty"
  | "lulu_agents.f_responsibilities_hint"
  | "lulu_agents.f_role"
  | "lulu_agents.f_role_hint"
  | "lulu_agents.f_scope"
  | "lulu_agents.f_scope_hint"
  | "lulu_agents.identity_note"
  | "lulu_agents.model_disabled"
  | "lulu_agents.model_no_key"
  | "lulu_agents.model_not_callable"
  | "lulu_agents.model_not_implemented"
  | "lulu_agents.model_not_wired"
  | "lulu_agents.model_quota_exhausted"
  | "lulu_agents.model_rate_limited"
  | "lulu_agents.model_unavailable"
  | "lulu_agents.model_unknown"
  | "lulu_agents.model_unlisted"
  | "lulu_agents.model_unset"
  | "lulu_agents.model_unverified"
  | "lulu_agents.resp_architect"
  | "lulu_agents.resp_backend"
  | "lulu_agents.resp_frontend"
  | "lulu_agents.resp_ops"
  | "lulu_agents.resp_product_design"
  | "lulu_agents.resp_qa"
  | "lulu_agents.resp_release"
  | "lulu_agents.resp_research"
  | "lulu_agents.resp_review"
  | "lulu_agents.resp_ui_design"
  | "lulu_agents.save"
  | "lulu_agents.save_failed"
  | "lulu_agents.scope_account"
  | "lulu_agents.scope_project"
  | "lulu_agents.speak.here_no_role"
  | "lulu_agents.speak.need_more"
  | "lulu_agents.speak.not_mine"
  | "lulu_agents.speak.on_it"
  | "lulu_agents.state_available"
  | "lulu_agents.state_disabled"
  | "lulu_agents.sub"
  | "lulu_agents.title"
  | "lulu_agents.unreachable"
  | "lulu_agents.why_body"
  | "lulu_agents.why_heading"
  | "lulu_agents.why_title"
  | "lulu_workbench.attach.action"
  | "lulu_workbench.attach.bad_type"
  | "lulu_workbench.attach.download"
  | "lulu_workbench.attach.failed"
  | "lulu_workbench.attach.kind_image"
  | "lulu_workbench.attach.kind_json"
  | "lulu_workbench.attach.kind_pdf"
  | "lulu_workbench.attach.kind_table"
  | "lulu_workbench.attach.kind_text"
  | "lulu_workbench.attach.kind_zip"
  | "lulu_workbench.attach.remove"
  | "lulu_workbench.attach.retry"
  | "lulu_workbench.attach.too_large"
  | "lulu_workbench.attach.too_many"
  | "lulu_workbench.attach.uploading"
  | "lulu_workbench.attach.wait_upload"
  | "lulu_workbench.attribution.declared"
  | "lulu_workbench.attribution.platform"
  | "lulu_workbench.attribution.self"
  | "lulu_workbench.bind.already"
  | "lulu_workbench.bind.failed"
  | "lulu_workbench.bind.keep_chatting"
  | "lulu_workbench.bind.kind_code"
  | "lulu_workbench.bind.kind_deploy"
  | "lulu_workbench.bind.kind_resource"
  | "lulu_workbench.bind.one_way"
  | "lulu_workbench.bind.pick"
  | "lulu_workbench.bind.skip"
  | "lulu_workbench.blocked.no_eligible_executor"
  | "lulu_workbench.board.auto_start"
  | "lulu_workbench.board.queue_reason"
  | "lulu_workbench.board.undo"
  | "lulu_workbench.board.undo_confirm"
  | "lulu_workbench.board.undo_done"
  | "lulu_workbench.board.undo_failed"
  | "lulu_workbench.chat.new_below"
  | "lulu_workbench.chat.stop"
  | "lulu_workbench.composer.key_hint"
  | "lulu_workbench.composer.ph_first"
  | "lulu_workbench.composer.ph_more"
  | "lulu_workbench.composer.ph_offline"
  | "lulu_workbench.composer.ph_project"
  | "lulu_workbench.composer.plan_only_chip"
  | "lulu_workbench.composer.send"
  | "lulu_workbench.composer.send_failed"
  | "lulu_workbench.composer.sending"
  | "lulu_workbench.convfail.draft_kept"
  | "lulu_workbench.convfail.headline"
  | "lulu_workbench.convfail.project_kept"
  | "lulu_workbench.convfail.retry_last_step"
  | "lulu_workbench.convfail.why_no_rollback"
  | "lulu_workbench.convfail.wont_delete"
  | "lulu_workbench.disable.cancel"
  | "lulu_workbench.disable.clean"
  | "lulu_workbench.disable.confirm"
  | "lulu_workbench.disable.conversations_truncated"
  | "lulu_workbench.disable.failed"
  | "lulu_workbench.empty.desc"
  | "lulu_workbench.empty.foot"
  | "lulu_workbench.empty.s1_d"
  | "lulu_workbench.empty.s1_t"
  | "lulu_workbench.empty.s2_d"
  | "lulu_workbench.empty.s2_t"
  | "lulu_workbench.empty.s3_d"
  | "lulu_workbench.empty.s3_t"
  | "lulu_workbench.empty.s4_d"
  | "lulu_workbench.empty.s4_t"
  | "lulu_workbench.empty.title"
  | "lulu_workbench.evidence.empty"
  | "lulu_workbench.evidence.title"
  | "lulu_workbench.folder.empty"
  | "lulu_workbench.folder.git_clean"
  | "lulu_workbench.folder.no_permission"
  | "lulu_workbench.folder.not_git"
  | "lulu_workbench.folder.open_settings"
  | "lulu_workbench.folder.pick_another"
  | "lulu_workbench.folder.readonly_promise"
  | "lulu_workbench.folder.stale_fix"
  | "lulu_workbench.folder.stale_not_broken"
  | "lulu_workbench.folder.stale_path"
  | "lulu_workbench.folder.taken_why"
  | "lulu_workbench.gap.detail"
  | "lulu_workbench.held.dont_resubmit"
  | "lulu_workbench.held.idempotent"
  | "lulu_workbench.held.not_your_fault"
  | "lulu_workbench.held.production_fine"
  | "lulu_workbench.init.blocked_by_prev"
  | "lulu_workbench.init.not_ready_yet"
  | "lulu_workbench.init.same_key"
  | "lulu_workbench.init.stage_conversation"
  | "lulu_workbench.init.stage_project"
  | "lulu_workbench.init.stage_repo"
  | "lulu_workbench.init.state_done"
  | "lulu_workbench.init.state_fail"
  | "lulu_workbench.init.state_none"
  | "lulu_workbench.init.state_running"
  | "lulu_workbench.init.state_wait"
  | "lulu_workbench.item.block"
  | "lulu_workbench.item.closed"
  | "lulu_workbench.item.done"
  | "lulu_workbench.item.fail"
  | "lulu_workbench.item.held"
  | "lulu_workbench.item.none"
  | "lulu_workbench.item.rec"
  | "lulu_workbench.item.run"
  | "lulu_workbench.item.todo"
  | "lulu_workbench.item.unknown"
  | "lulu_workbench.item.wait"
  | "lulu_workbench.launch.direct_k"
  | "lulu_workbench.launch.direct_v"
  | "lulu_workbench.launch.folder_readonly"
  | "lulu_workbench.launch.how_else_k"
  | "lulu_workbench.launch.how_else_v"
  | "lulu_workbench.launch.import_project"
  | "lulu_workbench.launch.loading_desc"
  | "lulu_workbench.launch.loading_title"
  | "lulu_workbench.launch.mac_only_desc"
  | "lulu_workbench.launch.mac_only_title"
  | "lulu_workbench.launch.mode_change_k"
  | "lulu_workbench.launch.mode_change_v"
  | "lulu_workbench.launch.mode_default_k"
  | "lulu_workbench.launch.mode_default_v"
  | "lulu_workbench.launch.mode_desc"
  | "lulu_workbench.launch.mode_not_persisted"
  | "lulu_workbench.launch.mode_solo_k"
  | "lulu_workbench.launch.mode_solo_v"
  | "lulu_workbench.launch.mode_team_k"
  | "lulu_workbench.launch.mode_team_v"
  | "lulu_workbench.launch.mode_title"
  | "lulu_workbench.launch.new_folder"
  | "lulu_workbench.launch.new_project"
  | "lulu_workbench.launch.new_title"
  | "lulu_workbench.launch.path_desc_web"
  | "lulu_workbench.launch.path_title"
  | "lulu_workbench.launch.pick_folder"
  | "lulu_workbench.launch.picked_k"
  | "lulu_workbench.launch.picked_v"
  | "lulu_workbench.launch.read_failed"
  | "lulu_workbench.launch.really_none"
  | "lulu_workbench.launch.recent_foot"
  | "lulu_workbench.launch.recent_meta"
  | "lulu_workbench.launch.recent_title"
  | "lulu_workbench.launch.retry"
  | "lulu_workbench.launch.search_clear"
  | "lulu_workbench.launch.search_hint"
  | "lulu_workbench.launch.start_failed"
  | "lulu_workbench.launch.start_solo"
  | "lulu_workbench.launch.start_team"
  | "lulu_workbench.launch.starting"
  | "lulu_workbench.launch.sub"
  | "lulu_workbench.launch.title"
  | "lulu_workbench.launch.title_shows_k"
  | "lulu_workbench.launch.title_shows_v"
  | "lulu_workbench.launch.unverified"
  | "lulu_workbench.mention.empty"
  | "lulu_workbench.mention.group_here"
  | "lulu_workbench.mention.group_invite_people"
  | "lulu_workbench.mention.group_library"
  | "lulu_workbench.mention.group_people"
  | "lulu_workbench.mention.join_failed"
  | "lulu_workbench.mention.joining"
  | "lulu_workbench.mention.no_team_change"
  | "lulu_workbench.mention.own_memory"
  | "lulu_workbench.mention.person_hint"
  | "lulu_workbench.mention.sub_excluded"
  | "lulu_workbench.mention.title"
  | "lulu_workbench.model.auto"
  | "lulu_workbench.model.effort_fast"
  | "lulu_workbench.model.effort_max"
  | "lulu_workbench.model.effort_sheet_sub"
  | "lulu_workbench.model.effort_sheet_title"
  | "lulu_workbench.model.effort_standard"
  | "lulu_workbench.model.group_default"
  | "lulu_workbench.model.group_fixed"
  | "lulu_workbench.model.next_message_only"
  | "lulu_workbench.model.picker_sub"
  | "lulu_workbench.model.picker_title"
  | "lulu_workbench.model.pinned"
  | "lulu_workbench.model.reason_expired"
  | "lulu_workbench.model.reason_quota"
  | "lulu_workbench.model.runtime_not_wired"
  | "lulu_workbench.model.scope_note"
  | "lulu_workbench.model.sheet_foot"
  | "lulu_workbench.model.unverified"
  | "lulu_workbench.model.unverified_note"
  | "lulu_workbench.model.wont_switch"
  | "lulu_workbench.people.add_hint"
  | "lulu_workbench.people.cannot_dispatch"
  | "lulu_workbench.people.invite"
  | "lulu_workbench.people.invite_failed"
  | "lulu_workbench.people.invite_none"
  | "lulu_workbench.people.inviting"
  | "lulu_workbench.people.none"
  | "lulu_workbench.people.remove"
  | "lulu_workbench.people.remove_failed"
  | "lulu_workbench.people.removing"
  | "lulu_workbench.people.role.operator"
  | "lulu_workbench.people.role.owner"
  | "lulu_workbench.people.role.unknown"
  | "lulu_workbench.people.role.viewer"
  | "lulu_workbench.people.title"
  | "lulu_workbench.plan.acceptance_label"
  | "lulu_workbench.plan.already"
  | "lulu_workbench.plan.failed"
  | "lulu_workbench.plan.headline"
  | "lulu_workbench.plan.none"
  | "lulu_workbench.plan.objective_label"
  | "lulu_workbench.plan.revise"
  | "lulu_workbench.plan.start"
  | "lulu_workbench.presence.unknown"
  | "lulu_workbench.rail.group_general"
  | "lulu_workbench.rail.new_conversation"
  | "lulu_workbench.rail.recents"
  | "lulu_workbench.recover.headline"
  | "lulu_workbench.recover.nothing_running"
  | "lulu_workbench.red.card_approve"
  | "lulu_workbench.red.card_ask"
  | "lulu_workbench.red.card_ask_seed"
  | "lulu_workbench.red.card_failed"
  | "lulu_workbench.red.card_reject"
  | "lulu_workbench.red.card_settled"
  | "lulu_workbench.red.expired"
  | "lulu_workbench.red.kind_access_policy"
  | "lulu_workbench.red.kind_data_migration"
  | "lulu_workbench.red.kind_delete_data"
  | "lulu_workbench.red.kind_irreversible_infra"
  | "lulu_workbench.red.kind_spend_money"
  | "lulu_workbench.red.never_for_you"
  | "lulu_workbench.red.q_after"
  | "lulu_workbench.red.q_alternative"
  | "lulu_workbench.red.q_backup"
  | "lulu_workbench.red.q_frozen"
  | "lulu_workbench.red.q_undo"
  | "lulu_workbench.red.q_valid_for"
  | "lulu_workbench.red.q_what"
  | "lulu_workbench.red.q_why"
  | "lulu_workbench.red.recommended"
  | "lulu_workbench.red.scopes_frozen"
  | "lulu_workbench.run.action.cancel"
  | "lulu_workbench.run.action.confirm"
  | "lulu_workbench.run.action.confirm_all"
  | "lulu_workbench.run.action.confirm_one"
  | "lulu_workbench.run.action.confirm_round"
  | "lulu_workbench.run.action.failed"
  | "lulu_workbench.run.action.pause"
  | "lulu_workbench.run.action.resume"
  | "lulu_workbench.run.action.round_already_stopped"
  | "lulu_workbench.run.action.round_failed"
  | "lulu_workbench.run.action.stop"
  | "lulu_workbench.run.action.stop_all"
  | "lulu_workbench.run.action.stop_round"
  | "lulu_workbench.run.check.failed"
  | "lulu_workbench.run.check.passed"
  | "lulu_workbench.run.check.skipped"
  | "lulu_workbench.run.column.agent"
  | "lulu_workbench.run.column.elapsed"
  | "lulu_workbench.run.column.model"
  | "lulu_workbench.run.column.token"
  | "lulu_workbench.run.detail.back"
  | "lulu_workbench.run.detail.evidence"
  | "lulu_workbench.run.detail.responsibility"
  | "lulu_workbench.run.details.open"
  | "lulu_workbench.run.empty"
  | "lulu_workbench.run.footer"
  | "lulu_workbench.run.nothing_to_verify"
  | "lulu_workbench.run.paused"
  | "lulu_workbench.run.process.needs_you"
  | "lulu_workbench.run.process.running"
  | "lulu_workbench.run.process.title"
  | "lulu_workbench.run.release.deployed_label"
  | "lulu_workbench.run.release.health"
  | "lulu_workbench.run.release.merged_label"
  | "lulu_workbench.run.release.pending"
  | "lulu_workbench.run.release.production_verified"
  | "lulu_workbench.run.release.rollback"
  | "lulu_workbench.run.release.rolled_back"
  | "lulu_workbench.run.release.rolled_back_label"
  | "lulu_workbench.run.release.smoke"
  | "lulu_workbench.run.section.artifacts"
  | "lulu_workbench.run.section.changes"
  | "lulu_workbench.run.section.checks"
  | "lulu_workbench.run.section.did"
  | "lulu_workbench.run.section.next"
  | "lulu_workbench.run.section.release"
  | "lulu_workbench.run.section.risks"
  | "lulu_workbench.run.sha.copied"
  | "lulu_workbench.run.sha.copy"
  | "lulu_workbench.run.status.cancelled"
  | "lulu_workbench.run.status.completed"
  | "lulu_workbench.run.status.failed"
  | "lulu_workbench.run.status.partial"
  | "lulu_workbench.run.step.agent_completed"
  | "lulu_workbench.run.step.agent_joined"
  | "lulu_workbench.run.step.agent_progress"
  | "lulu_workbench.run.step.agent_recovered"
  | "lulu_workbench.run.step.agent_stopped"
  | "lulu_workbench.run.step.item_cancelled"
  | "lulu_workbench.run.step.item_completed"
  | "lulu_workbench.run.step.item_failed"
  | "lulu_workbench.run.step.item_ready"
  | "lulu_workbench.run.step.item_recovering"
  | "lulu_workbench.run.step.item_running"
  | "lulu_workbench.run.step.item_waiting"
  | "lulu_workbench.run.step.plan_ready"
  | "lulu_workbench.run.step.result_available"
  | "lulu_workbench.run.step.waiting"
  | "lulu_workbench.run.stream.unknown"
  | "lulu_workbench.run.summary.default_title"
  | "lulu_workbench.run.summary.open"
  | "lulu_workbench.run.unverified"
  | "lulu_workbench.settle.artifact.branch"
  | "lulu_workbench.settle.artifact.commit"
  | "lulu_workbench.settle.artifact.task"
  | "lulu_workbench.settle.headline.cancelled"
  | "lulu_workbench.settle.headline.failed"
  | "lulu_workbench.sidecar.add_agent"
  | "lulu_workbench.sidecar.back_to_chat"
  | "lulu_workbench.sidecar.close"
  | "lulu_workbench.sidecar.keep_state"
  | "lulu_workbench.sidecar.tab_board"
  | "lulu_workbench.sidecar.tab_decisions"
  | "lulu_workbench.sidecar.tab_evidence"
  | "lulu_workbench.sidecar.tab_team"
  | "lulu_workbench.sidecar.title_work"
  | "lulu_workbench.sidecar.width_hint"
  | "lulu_workbench.skills.ago_now"
  | "lulu_workbench.skills.disabled"
  | "lulu_workbench.skills.empty"
  | "lulu_workbench.skills.enabled"
  | "lulu_workbench.skills.last_run_failed"
  | "lulu_workbench.skills.last_run_ok"
  | "lulu_workbench.skills.never_ran"
  | "lulu_workbench.skills.section"
  | "lulu_workbench.skills.section_hint"
  | "lulu_workbench.skills.toggle_failed"
  | "lulu_workbench.slash.effort_hint"
  | "lulu_workbench.slash.empty"
  | "lulu_workbench.slash.keys"
  | "lulu_workbench.slash.new"
  | "lulu_workbench.slash.new_hint"
  | "lulu_workbench.slash.plan_only_hint"
  | "lulu_workbench.slash.plan_only_off"
  | "lulu_workbench.slash.plan_only_on"
  | "lulu_workbench.slash.rename"
  | "lulu_workbench.slash.rename_failed"
  | "lulu_workbench.slash.rename_hint_empty"
  | "lulu_workbench.slash.stop_hint"
  | "lulu_workbench.slash.title"
  | "lulu_workbench.state.blocked"
  | "lulu_workbench.state.completed"
  | "lulu_workbench.state.disconnected"
  | "lulu_workbench.state.discussing"
  | "lulu_workbench.state.failed"
  | "lulu_workbench.state.planning"
  | "lulu_workbench.state.platform_held"
  | "lulu_workbench.state.recovering"
  | "lulu_workbench.state.running"
  | "lulu_workbench.state.unknown"
  | "lulu_workbench.state.waiting_agent"
  | "lulu_workbench.state.waiting_user"
  | "lulu_workbench.sub.auto_named"
  | "lulu_workbench.sub.boundary"
  | "lulu_workbench.sub.evidence_on_parent"
  | "lulu_workbench.sub.no_progress_bar"
  | "lulu_workbench.sub.not_member"
  | "lulu_workbench.sub.parent"
  | "lulu_workbench.subfail.costs_money"
  | "lulu_workbench.subfail.exit_retry"
  | "lulu_workbench.subfail.exit_swap_model"
  | "lulu_workbench.subfail.exit_takeover"
  | "lulu_workbench.subfail.failed"
  | "lulu_workbench.subfail.keep_done"
  | "lulu_workbench.subfail.my_pick"
  | "lulu_workbench.subfail.no_reason_yet"
  | "lulu_workbench.subfail.no_reopen"
  | "lulu_workbench.team.account_only"
  | "lulu_workbench.team.empty_ok"
  | "lulu_workbench.team.join"
  | "lulu_workbench.team.join_failed"
  | "lulu_workbench.team.joining"
  | "lulu_workbench.team.member_disabled"
  | "lulu_workbench.team.only_agents"
  | "lulu_workbench.team.remove_no_interrupt"
  | "lulu_workbench.team.try_one"
  | "lulu_workbench.teambar.adjust"
  | "lulu_workbench.title.bound"
  | "lulu_workbench.title.general"
  | "lulu_workbench.title.no_project"
  | "lulu_workbench.title.offline"
  | "lulu_workbench.voice.cancel"
  | "lulu_workbench.voice.no_mic"
  | "lulu_workbench.voice.retry"
  | "lulu_workbench.voice.start"
  | "lulu_workbench.voice.stop"
  | "lulu_workbench.voice.transcribing"
  | "lulu_workbench.voice.unsupported"
  | "memo.access.all"
  | "memo.access.audit"
  | "memo.access.default"
  | "memo.access.filter.empty"
  | "memo.access.hidden"
  | "memo.access.label"
  | "memo.ai.change"
  | "memo.ai.default"
  | "memo.ai.default.desc"
  | "memo.ai.hidden"
  | "memo.ai.hidden.desc"
  | "memo.ai.panel.locked"
  | "memo.ai.panel.readable"
  | "memo.ai.panel.undecided"
  | "memo.ai.shared"
  | "memo.ai.shared.scope.global"
  | "memo.ai.shared.scope.global.desc"
  | "memo.ai.shared.scope.project"
  | "memo.ai.shared.scope.project.desc"
  | "memo.ai.toggle.hide"
  | "memo.ai.toggle.show"
  | "memo.archive.delete.note"
  | "memo.archive.delete.note.body"
  | "memo.archive.empty"
  | "memo.archive.empty.title"
  | "memo.archive.entry"
  | "memo.archive.notice"
  | "memo.archive.notice.body"
  | "memo.archive.restore"
  | "memo.archive.subtitle"
  | "memo.archive.title"
  | "memo.candidates.badge"
  | "memo.candidates.confirm"
  | "memo.candidates.confirmed"
  | "memo.candidates.desc"
  | "memo.candidates.discard"
  | "memo.candidates.discarded"
  | "memo.candidates.empty"
  | "memo.candidates.heading"
  | "memo.candidates.only_me"
  | "memo.candidates.source"
  | "memo.candidates.why"
  | "memo.capture.hint"
  | "memo.capture.retry"
  | "memo.capture.save"
  | "memo.capture.saving"
  | "memo.capture.tool.clip"
  | "memo.capture.tool.link"
  | "memo.capture.tool.voice"
  | "memo.capture.tool.voice.cancel"
  | "memo.clip.reject.size"
  | "memo.clip.reject.type"
  | "memo.clip.remove"
  | "memo.clip.state.done"
  | "memo.clip.state.failed"
  | "memo.clip.state.waiting"
  | "memo.conflict.body"
  | "memo.conflict.foot"
  | "memo.conflict.mine"
  | "memo.conflict.mine.v"
  | "memo.conflict.option.both"
  | "memo.conflict.option.both.desc"
  | "memo.conflict.option.mine"
  | "memo.conflict.option.mine.desc"
  | "memo.conflict.option.server"
  | "memo.conflict.option.server.desc"
  | "memo.conflict.server"
  | "memo.conflict.server.v"
  | "memo.conflict.title"
  | "memo.crumb.project"
  | "memo.detail.actions.archive"
  | "memo.detail.actions.move"
  | "memo.detail.ai"
  | "memo.detail.ai.reads"
  | "memo.detail.ai.reads.none"
  | "memo.detail.cant.read"
  | "memo.detail.files.none"
  | "memo.detail.group.files"
  | "memo.detail.group.relations"
  | "memo.detail.group.scope"
  | "memo.detail.other.projects"
  | "memo.detail.source.none"
  | "memo.detail.where"
  | "memo.detail.where.global"
  | "memo.empty.filter"
  | "memo.empty.from.misc"
  | "memo.empty.global.body"
  | "memo.empty.global.placeholder"
  | "memo.empty.global.title"
  | "memo.empty.project.body"
  | "memo.empty.project.placeholder"
  | "memo.empty.project.title"
  | "memo.error.body"
  | "memo.error.retry"
  | "memo.error.title"
  | "memo.group.earlier"
  | "memo.group.today"
  | "memo.group.week"
  | "memo.group.yesterday"
  | "memo.image.preview"
  | "memo.link.add"
  | "memo.link.invalid"
  | "memo.link.placeholder"
  | "memo.list.filter.all"
  | "memo.list.filter.files"
  | "memo.list.filter.lulu"
  | "memo.list.filter.recent"
  | "memo.list.filter.voice"
  | "memo.list.head.find"
  | "memo.list.recent"
  | "memo.list.search"
  | "memo.list.search.clear"
  | "memo.list.search.empty"
  | "memo.list.source.file"
  | "memo.list.source.link"
  | "memo.list.source.lulu"
  | "memo.list.source.text"
  | "memo.list.source.voice"
  | "memo.list.this.project"
  | "memo.list.uploads.waiting"
  | "memo.loading"
  | "memo.loading.note"
  | "memo.lock.desc"
  | "memo.lock.input"
  | "memo.lock.placeholder"
  | "memo.lock.title"
  | "memo.lock.unlock"
  | "memo.mobile.input"
  | "memo.mobile.search.open"
  | "memo.move.confirm.none"
  | "memo.move.foot"
  | "memo.move.invalid.title"
  | "memo.move.invalid.wont.1"
  | "memo.move.invalid.wont.2"
  | "memo.move.invalid.wont.3"
  | "memo.move.note"
  | "memo.move.notice"
  | "memo.move.notice.body"
  | "memo.move.pick.other"
  | "memo.move.row.ai"
  | "memo.move.row.ai.v"
  | "memo.move.row.back"
  | "memo.move.row.back.v"
  | "memo.move.row.delete"
  | "memo.move.row.delete.v"
  | "memo.move.row.to"
  | "memo.move.row.who"
  | "memo.move.row.who.v"
  | "memo.move.title"
  | "memo.move.to.misc"
  | "memo.page.back.list"
  | "memo.page.badge.project"
  | "memo.page.notice.global"
  | "memo.page.notice.global.body"
  | "memo.page.notice.project"
  | "memo.page.notice.project.body"
  | "memo.page.subtitle"
  | "memo.page.subtitle.project"
  | "memo.page.title"
  | "memo.page.write"
  | "memo.password.change"
  | "memo.password.confirm.remove"
  | "memo.password.group"
  | "memo.password.input"
  | "memo.password.none"
  | "memo.password.remove"
  | "memo.password.removed"
  | "memo.password.set"
  | "memo.password.set.ok"
  | "memo.queue.dead"
  | "memo.queue.dead.remove"
  | "memo.quick.badge"
  | "memo.quick.composing.note"
  | "memo.quick.desc.global"
  | "memo.quick.desc.project"
  | "memo.quick.foot"
  | "memo.quick.note"
  | "memo.quick.note.project"
  | "memo.quick.title"
  | "memo.reads.bar.none"
  | "memo.reads.scope.global"
  | "memo.reads.scope.host"
  | "memo.reads.scope.project"
  | "memo.save.fail.body"
  | "memo.save.fail.title"
  | "memo.save.giveup"
  | "memo.save.offline.foot"
  | "memo.save.why"
  | "memo.save.why.body"
  | "memo.scope.local"
  | "memo.scope.misc"
  | "memo.scope.save.global"
  | "memo.scope.save.global.note"
  | "memo.scope.save.project.note"
  | "memo.scope.switch.misc"
  | "memo.search.cross"
  | "memo.undo.action"
  | "memo.undo.archived"
  | "memo.undo.failed"
  | "memo.undo.moved"
  | "memo.view.label"
  | "memo.view.list"
  | "memo.view.tiles"
  | "memo.voice.audition"
  | "memo.voice.cancel"
  | "memo.voice.finish"
  | "memo.voice.level.off"
  | "memo.voice.level.on"
  | "memo.voice.no_mic"
  | "memo.voice.record"
  | "memo.voice.rerecord"
  | "memo.voice.save"
  | "memo.voice.saved"
  | "memo.voice.saving"
  | "memo.voice.search.note"
  | "memo.voice.selfwrite"
  | "memo.voice.stop"
  | "memo.voice.transcribing"
  | "memo.voice.transcript.failed"
  | "memo.voice.transcript.failed.body"
  | "memo.voice.unsupported"
  | "model.application.action.remove"
  | "model.application.action.save"
  | "model.application.override.hint"
  | "model.application.override.label"
  | "model.application.saved"
  | "model.budget.only_one_brain"
  | "model.degraded.budget_used_up"
  | "model.degraded.no_answer"
  | "model.degraded.secret_in_paste"
  | "model.developer.action.save"
  | "model.developer.heading"
  | "model.developer.hint"
  | "model.developer.model.auto.detail"
  | "model.developer.model.auto.name"
  | "model.developer.model.deepseek.detail"
  | "model.developer.model.deepseek.name"
  | "model.developer.model.doubao.detail"
  | "model.developer.model.doubao.name"
  | "model.developer.model.kimi.detail"
  | "model.developer.model.kimi.name"
  | "model.developer.provider.plan"
  | "model.developer.recommended"
  | "model.developer.saved"
  | "model.generator.action.save_global"
  | "model.generator.heading"
  | "model.generator.hint"
  | "model.generator.model.doubao.badge"
  | "model.generator.model.doubao.detail"
  | "model.generator.model.doubao.name"
  | "model.generator.model.flash.badge"
  | "model.generator.model.flash.detail"
  | "model.generator.model.flash.name"
  | "model.generator.model.glm.badge"
  | "model.generator.model.glm.detail"
  | "model.generator.model.glm.name"
  | "model.generator.saved"
  | "model.not_connected"
  | "model.provider.plan"
  | "model.reviewer.action.remove_override"
  | "model.reviewer.action.save_global"
  | "model.reviewer.action.save_project"
  | "model.reviewer.action.saving"
  | "model.reviewer.capability.heading"
  | "model.reviewer.effective.label"
  | "model.reviewer.global.heading"
  | "model.reviewer.global.hint"
  | "model.reviewer.model.flash.badge"
  | "model.reviewer.model.flash.detail"
  | "model.reviewer.model.flash.name"
  | "model.reviewer.model.pro.badge"
  | "model.reviewer.model.pro.detail"
  | "model.reviewer.model.pro.name"
  | "model.reviewer.override.hint"
  | "model.reviewer.override.label"
  | "model.reviewer.page.subtitle"
  | "model.reviewer.project.empty"
  | "model.reviewer.project.heading"
  | "model.reviewer.project.hint"
  | "model.reviewer.project.select"
  | "model.reviewer.removed"
  | "model.reviewer.saved"
  | "model.reviewer.source.global"
  | "model.reviewer.source.project"
  | "model.route.developer.deepseek_fallback"
  | "model.route.developer.fix_bug"
  | "model.route.developer.read_repo"
  | "model.route.steward.ark_selected"
  | "model.route.steward.deepseek_selected"
  | "model.steward.action.save"
  | "model.steward.effective.label"
  | "model.steward.heading"
  | "model.steward.hint"
  | "model.steward.model.deepseek.badge"
  | "model.steward.model.deepseek.detail"
  | "model.steward.model.deepseek.name"
  | "model.steward.model.doubao.badge"
  | "model.steward.model.doubao.detail"
  | "model.steward.model.doubao.name"
  | "model.steward.provider.ark"
  | "model.steward.saved"
  | "model.steward.source.global"
  | "model_configuration.access_token_label"
  | "model_configuration.add_and_test"
  | "model_configuration.add_model"
  | "model_configuration.advanced_label"
  | "model_configuration.agent_capabilities_resources"
  | "model_configuration.agent_settings_title"
  | "model_configuration.api_key_label"
  | "model_configuration.api_key_placeholder"
  | "model_configuration.api_key_replace_hint"
  | "model_configuration.api_url_label"
  | "model_configuration.app_id_label"
  | "model_configuration.app_id_placeholder"
  | "model_configuration.assist.entry"
  | "model_configuration.assist.hint"
  | "model_configuration.assist.no_base_url"
  | "model_configuration.assist.no_model_id"
  | "model_configuration.assist.nothing"
  | "model_configuration.assist.reasoning"
  | "model_configuration.assist.secret_seen"
  | "model_configuration.assist.unknown_provider"
  | "model_configuration.binding_picker_add_select"
  | "model_configuration.binding_picker_catalog_hint"
  | "model_configuration.binding_picker_configure_provider"
  | "model_configuration.binding_picker_connection_label"
  | "model_configuration.binding_picker_connection_placeholder"
  | "model_configuration.binding_picker_connections"
  | "model_configuration.binding_picker_empty_connections"
  | "model_configuration.binding_picker_empty_profiles"
  | "model_configuration.binding_picker_mode"
  | "model_configuration.binding_picker_profiles"
  | "model_configuration.binding_picker_provider_label"
  | "model_configuration.binding_picker_provider_placeholder"
  | "model_configuration.binding_picker_runtime_hint"
  | "model_configuration.binding_picker_select_existing"
  | "model_configuration.binding_picker_supported_models"
  | "model_configuration.binding_picker_testing"
  | "model_configuration.catalog_loaded"
  | "model_configuration.choose_supported_model"
  | "model_configuration.col_actions"
  | "model_configuration.col_key"
  | "model_configuration.col_model"
  | "model_configuration.col_provider"
  | "model_configuration.col_reasoning"
  | "model_configuration.col_scope"
  | "model_configuration.col_status"
  | "model_configuration.col_tokens"
  | "model_configuration.col_url"
  | "model_configuration.col_vision"
  | "model_configuration.configure_credential_action"
  | "model_configuration.connection_details_action"
  | "model_configuration.connection_failed"
  | "model_configuration.connection_key_required_for_discovery"
  | "model_configuration.connection_ready"
  | "model_configuration.connection_settings_action"
  | "model_configuration.credential_first_save_hint"
  | "model_configuration.custom_access"
  | "model_configuration.delete_model"
  | "model_configuration.description_label"
  | "model_configuration.direct_connections_advanced"
  | "model_configuration.direct_connections_hint"
  | "model_configuration.disable_model"
  | "model_configuration.discovery_empty"
  | "model_configuration.discovery_manual_only_hint"
  | "model_configuration.discovery_metadata_hint"
  | "model_configuration.discovery_not_supported"
  | "model_configuration.display_name_label"
  | "model_configuration.edit_model"
  | "model_configuration.edit_model_information"
  | "model_configuration.empty_model_library"
  | "model_configuration.empty_model_library_hint"
  | "model_configuration.enable_model"
  | "model_configuration.failure_auth"
  | "model_configuration.failure_incompatible"
  | "model_configuration.failure_model_not_found"
  | "model_configuration.failure_network"
  | "model_configuration.failure_quota_exhausted"
  | "model_configuration.failure_rate_limited"
  | "model_configuration.fetch_models"
  | "model_configuration.fetch_models_again"
  | "model_configuration.finish_agent_information"
  | "model_configuration.form_required"
  | "model_configuration.gateway_address"
  | "model_configuration.gateway_key"
  | "model_configuration.gateway_key_rotation"
  | "model_configuration.gateway_models_empty"
  | "model_configuration.gateway_models_loading"
  | "model_configuration.gateway_recommended"
  | "model_configuration.gateway_summary"
  | "model_configuration.impact_agents"
  | "model_configuration.impact_blocked"
  | "model_configuration.impact_clear"
  | "model_configuration.impact_description"
  | "model_configuration.impact_loading"
  | "model_configuration.impact_system_bindings"
  | "model_configuration.load_catalog_models"
  | "model_configuration.load_supported_models"
  | "model_configuration.manual_model_toggle"
  | "model_configuration.max_input_label"
  | "model_configuration.max_output_label"
  | "model_configuration.model_connection_settings_hint"
  | "model_configuration.model_edit_action"
  | "model_configuration.model_id_label"
  | "model_configuration.model_library_subtitle"
  | "model_configuration.model_library_title"
  | "model_configuration.model_list_heading"
  | "model_configuration.model_saved_test_failed"
  | "model_configuration.modify_agent_information"
  | "model_configuration.no_value"
  | "model_configuration.open_connection_settings"
  | "model_configuration.platform_auto_detected"
  | "model_configuration.platform_connection_hint"
  | "model_configuration.platform_credential_label"
  | "model_configuration.platform_credential_summary"
  | "model_configuration.platform_managed"
  | "model_configuration.platform_model_hint"
  | "model_configuration.platform_name_hint"
  | "model_configuration.platform_status_sync"
  | "model_configuration.project_scope"
  | "model_configuration.protocol_label"
  | "model_configuration.provider_access"
  | "model_configuration.provider_label"
  | "model_configuration.reasoning_capability_label"
  | "model_configuration.reasoning_default_hint"
  | "model_configuration.reasoning_default_label"
  | "model_configuration.reasoning_label"
  | "model_configuration.reasoning_unsupported_hint"
  | "model_configuration.refresh_supported_models"
  | "model_configuration.reload_catalog_models"
  | "model_configuration.required_fields"
  | "model_configuration.retire_no_replacement"
  | "model_configuration.retire_pause"
  | "model_configuration.retire_pause_hint"
  | "model_configuration.retire_replace"
  | "model_configuration.retire_replace_hint"
  | "model_configuration.retire_replacement_label"
  | "model_configuration.retire_replacement_placeholder"
  | "model_configuration.retire_strategy"
  | "model_configuration.save_and_test"
  | "model_configuration.save_and_test_model"
  | "model_configuration.scope_account"
  | "model_configuration.scope_project"
  | "model_configuration.select_model_label"
  | "model_configuration.speech_not_testable"
  | "model_configuration.status_available"
  | "model_configuration.status_disabled"
  | "model_configuration.status_quota_exhausted"
  | "model_configuration.status_rate_limited"
  | "model_configuration.status_unavailable"
  | "model_configuration.status_unverified"
  | "model_configuration.supported_model_hint"
  | "model_configuration.supported_model_label"
  | "model_configuration.supported_model_placeholder"
  | "model_configuration.test_failed_keep_editing"
  | "model_configuration.test_model"
  | "model_configuration.testing_model"
  | "model_configuration.ui_001"
  | "model_configuration.ui_002"
  | "model_configuration.ui_003"
  | "model_configuration.ui_004"
  | "model_configuration.ui_005"
  | "model_configuration.ui_006"
  | "model_configuration.ui_007"
  | "model_configuration.ui_008"
  | "model_configuration.ui_009"
  | "model_configuration.ui_010"
  | "model_configuration.ui_011"
  | "model_configuration.ui_012"
  | "model_configuration.ui_013"
  | "model_configuration.ui_014"
  | "model_configuration.ui_015"
  | "model_configuration.ui_016"
  | "model_configuration.ui_017"
  | "model_configuration.ui_018"
  | "model_configuration.ui_019"
  | "model_configuration.ui_020"
  | "model_configuration.ui_021"
  | "model_configuration.ui_022"
  | "model_configuration.ui_023"
  | "model_configuration.ui_024"
  | "model_configuration.ui_025"
  | "model_configuration.ui_026"
  | "model_configuration.ui_027"
  | "model_configuration.ui_028"
  | "model_configuration.ui_029"
  | "model_configuration.ui_030"
  | "model_configuration.ui_031"
  | "model_configuration.ui_032"
  | "model_configuration.ui_033"
  | "model_configuration.ui_034"
  | "model_configuration.ui_035"
  | "model_configuration.ui_036"
  | "model_configuration.ui_037"
  | "model_configuration.ui_038"
  | "model_configuration.ui_039"
  | "model_configuration.ui_040"
  | "model_configuration.ui_041"
  | "model_configuration.ui_042"
  | "model_configuration.ui_043"
  | "model_configuration.ui_044"
  | "model_configuration.ui_045"
  | "model_configuration.ui_046"
  | "model_configuration.ui_047"
  | "model_configuration.ui_048"
  | "model_configuration.ui_049"
  | "model_configuration.ui_050"
  | "model_configuration.ui_051"
  | "model_configuration.ui_052"
  | "model_configuration.ui_053"
  | "model_configuration.ui_054"
  | "model_configuration.ui_055"
  | "model_configuration.ui_056"
  | "model_configuration.ui_057"
  | "model_configuration.ui_058"
  | "model_configuration.ui_059"
  | "model_configuration.ui_060"
  | "model_configuration.ui_061"
  | "model_configuration.ui_062"
  | "model_configuration.ui_063"
  | "model_configuration.ui_064"
  | "model_configuration.ui_065"
  | "model_configuration.ui_066"
  | "model_configuration.ui_067"
  | "model_configuration.ui_068"
  | "model_configuration.ui_069"
  | "model_configuration.ui_070"
  | "model_configuration.ui_071"
  | "model_configuration.ui_072"
  | "model_configuration.ui_073"
  | "model_configuration.ui_074"
  | "model_configuration.ui_075"
  | "model_configuration.ui_076"
  | "model_configuration.ui_077"
  | "model_configuration.ui_078"
  | "model_configuration.ui_079"
  | "model_configuration.ui_080"
  | "model_configuration.ui_081"
  | "model_configuration.ui_082"
  | "model_configuration.ui_083"
  | "model_configuration.ui_084"
  | "model_configuration.ui_085"
  | "model_configuration.ui_086"
  | "model_configuration.ui_087"
  | "model_configuration.ui_088"
  | "model_configuration.ui_089"
  | "model_configuration.ui_090"
  | "model_configuration.ui_091"
  | "model_configuration.ui_092"
  | "model_configuration.ui_093"
  | "model_configuration.ui_094"
  | "model_configuration.ui_095"
  | "model_configuration.ui_096"
  | "model_configuration.ui_097"
  | "model_configuration.ui_098"
  | "model_configuration.ui_099"
  | "model_configuration.ui_100"
  | "model_configuration.ui_101"
  | "model_configuration.ui_102"
  | "model_configuration.ui_103"
  | "model_configuration.ui_104"
  | "model_configuration.ui_105"
  | "model_configuration.ui_106"
  | "model_configuration.ui_107"
  | "model_configuration.ui_108"
  | "model_configuration.ui_109"
  | "model_configuration.ui_110"
  | "model_configuration.ui_111"
  | "model_configuration.ui_112"
  | "model_configuration.ui_113"
  | "model_configuration.ui_114"
  | "model_configuration.ui_115"
  | "model_configuration.ui_116"
  | "model_configuration.ui_117"
  | "model_configuration.ui_118"
  | "model_configuration.ui_119"
  | "model_configuration.ui_120"
  | "model_configuration.ui_121"
  | "model_configuration.ui_122"
  | "model_configuration.ui_123"
  | "model_configuration.ui_124"
  | "model_configuration.ui_125"
  | "model_configuration.ui_126"
  | "model_configuration.ui_127"
  | "model_configuration.ui_128"
  | "model_configuration.ui_129"
  | "model_configuration.ui_130"
  | "model_configuration.ui_131"
  | "model_configuration.ui_132"
  | "model_configuration.ui_133"
  | "model_configuration.ui_134"
  | "model_configuration.ui_135"
  | "model_configuration.ui_136"
  | "model_configuration.ui_137"
  | "model_configuration.ui_138"
  | "model_configuration.ui_139"
  | "model_configuration.ui_140"
  | "model_configuration.ui_141"
  | "model_configuration.ui_142"
  | "model_configuration.ui_143"
  | "model_configuration.ui_144"
  | "model_configuration.ui_145"
  | "model_configuration.ui_146"
  | "model_configuration.ui_147"
  | "model_configuration.ui_148"
  | "model_configuration.ui_149"
  | "model_configuration.ui_150"
  | "model_configuration.ui_151"
  | "model_configuration.ui_152"
  | "model_configuration.ui_153"
  | "model_configuration.ui_154"
  | "model_configuration.ui_155"
  | "model_configuration.ui_156"
  | "model_configuration.ui_157"
  | "model_configuration.ui_158"
  | "model_configuration.ui_159"
  | "model_configuration.ui_160"
  | "model_configuration.ui_161"
  | "model_configuration.ui_162"
  | "model_configuration.ui_163"
  | "model_configuration.ui_164"
  | "model_configuration.ui_165"
  | "model_configuration.ui_166"
  | "model_configuration.ui_167"
  | "model_configuration.ui_168"
  | "model_configuration.ui_169"
  | "model_configuration.ui_170"
  | "model_configuration.ui_171"
  | "model_configuration.ui_172"
  | "model_configuration.ui_173"
  | "model_configuration.ui_174"
  | "model_configuration.ui_175"
  | "model_configuration.ui_176"
  | "model_configuration.ui_177"
  | "model_configuration.ui_178"
  | "model_configuration.ui_179"
  | "model_configuration.ui_180"
  | "model_configuration.ui_181"
  | "model_configuration.ui_182"
  | "model_configuration.ui_183"
  | "model_configuration.ui_184"
  | "model_configuration.ui_185"
  | "model_configuration.ui_186"
  | "model_configuration.ui_187"
  | "model_configuration.ui_188"
  | "model_configuration.ui_189"
  | "model_configuration.ui_190"
  | "model_configuration.ui_191"
  | "model_configuration.ui_192"
  | "model_configuration.ui_193"
  | "model_configuration.ui_194"
  | "model_configuration.ui_195"
  | "model_configuration.ui_196"
  | "model_configuration.ui_197"
  | "model_configuration.ui_198"
  | "model_configuration.ui_199"
  | "model_configuration.ui_200"
  | "model_configuration.ui_201"
  | "model_configuration.ui_202"
  | "model_configuration.ui_203"
  | "model_configuration.ui_204"
  | "model_configuration.ui_205"
  | "model_configuration.ui_206"
  | "model_configuration.ui_207"
  | "model_configuration.ui_208"
  | "model_configuration.ui_209"
  | "model_configuration.ui_210"
  | "model_configuration.ui_211"
  | "model_configuration.ui_212"
  | "model_configuration.ui_213"
  | "model_configuration.ui_214"
  | "model_configuration.ui_215"
  | "model_configuration.ui_216"
  | "model_configuration.ui_217"
  | "model_configuration.ui_218"
  | "model_configuration.ui_219"
  | "model_configuration.ui_220"
  | "model_configuration.ui_221"
  | "model_configuration.ui_222"
  | "model_configuration.ui_223"
  | "model_configuration.ui_224"
  | "model_configuration.ui_225"
  | "model_configuration.ui_226"
  | "model_configuration.ui_227"
  | "model_configuration.ui_228"
  | "model_configuration.ui_229"
  | "model_configuration.ui_230"
  | "model_configuration.ui_231"
  | "model_configuration.ui_232"
  | "model_configuration.ui_233"
  | "model_configuration.ui_234"
  | "model_configuration.ui_235"
  | "model_configuration.ui_236"
  | "model_configuration.ui_237"
  | "model_configuration.ui_238"
  | "model_configuration.ui_239"
  | "model_configuration.ui_240"
  | "model_configuration.ui_241"
  | "model_configuration.ui_242"
  | "model_configuration.ui_243"
  | "model_configuration.ui_244"
  | "model_configuration.ui_245"
  | "model_configuration.ui_246"
  | "model_configuration.ui_247"
  | "model_configuration.ui_248"
  | "model_configuration.ui_249"
  | "model_configuration.ui_250"
  | "model_configuration.ui_251"
  | "model_configuration.ui_252"
  | "model_configuration.ui_253"
  | "model_configuration.ui_254"
  | "model_configuration.unknown_value"
  | "model_configuration.vision_label"
  | "model_configuration.yes_value"
  | "model_library.add_connection"
  | "model_library.add_model"
  | "model_library.api_key"
  | "model_library.base_url"
  | "model_library.cancel"
  | "model_library.connection_disabled"
  | "model_library.connection_enabled"
  | "model_library.connection_name"
  | "model_library.connection_name_placeholder"
  | "model_library.connections"
  | "model_library.create"
  | "model_library.empty_connections"
  | "model_library.empty_models"
  | "model_library.form_error"
  | "model_library.key_hint"
  | "model_library.model_disabled"
  | "model_library.model_enabled"
  | "model_library.model_id"
  | "model_library.model_id_placeholder"
  | "model_library.model_name"
  | "model_library.model_name_placeholder"
  | "model_library.models"
  | "model_library.platform.ark_connection"
  | "model_library.platform.ark_monthly_connection"
  | "model_library.platform.deepseek_connection"
  | "model_library.platform.model_ark_code"
  | "model_library.platform.model_deepseek_flash"
  | "model_library.platform.model_doubao"
  | "model_library.platform.model_doubao_speech_mini"
  | "model_library.platform.model_glm"
  | "model_library.platform.model_kimi"
  | "model_library.platform.model_seed_asr_file"
  | "model_library.platform.model_seed_asr_stream"
  | "model_library.platform.openspeech_connection"
  | "model_library.probe"
  | "model_library.probe_error"
  | "model_library.probe_hint"
  | "model_library.protocol"
  | "model_library.protocol.anthropic"
  | "model_library.protocol.bedrock"
  | "model_library.protocol.openai"
  | "model_library.provider"
  | "model_library.provider_hint"
  | "model_library.save_error"
  | "model_library.scope.account"
  | "model_library.status.disabled"
  | "model_library.status.failed"
  | "model_library.status.unverified"
  | "model_library.status.verified"
  | "model_library.subtitle"
  | "model_library.title"
  | "model_runtime.agent.backend"
  | "model_runtime.agent.design"
  | "model_runtime.agent.frontend"
  | "model_runtime.agent.ops"
  | "model_runtime.agent.product"
  | "model_runtime.agent.project"
  | "model_runtime.agent.review"
  | "model_runtime.agent.test"
  | "model_runtime.module.code_review_description"
  | "model_runtime.module.code_review_name"
  | "model_runtime.module.code_review_note"
  | "model_runtime.module.conversation_memory_description"
  | "model_runtime.module.conversation_memory_name"
  | "model_runtime.module.conversation_memory_note"
  | "model_runtime.module.development_orchestration_description"
  | "model_runtime.module.development_orchestration_name"
  | "model_runtime.module.development_orchestration_note"
  | "model_runtime.module.document_content_description"
  | "model_runtime.module.document_content_name"
  | "model_runtime.module.document_content_note"
  | "model_runtime.module.lulu_reasoning_description"
  | "model_runtime.module.lulu_reasoning_name"
  | "model_runtime.module.lulu_reasoning_not_usable"
  | "model_runtime.module.lulu_reasoning_not_wired"
  | "model_runtime.module.lulu_reasoning_note"
  | "model_runtime.module.multimodal_description"
  | "model_runtime.module.multimodal_name"
  | "model_runtime.module.multimodal_note"
  | "model_runtime.module.patch_generation_description"
  | "model_runtime.module.patch_generation_name"
  | "model_runtime.module.patch_generation_note"
  | "model_runtime.module.product_inspection_description"
  | "model_runtime.module.product_inspection_name"
  | "model_runtime.module.product_inspection_note"
  | "model_runtime.module.task_planning_description"
  | "model_runtime.module.task_planning_name"
  | "model_runtime.module.task_planning_not_wired"
  | "model_runtime.module.task_planning_note"
  | "model_runtime.provider.agent_plan_catalog_hint"
  | "model_runtime.provider.api_key"
  | "model_runtime.provider.api_key_manual_models"
  | "model_runtime.provider.bedrock_auth_hint"
  | "model_runtime.provider.bedrock_base_hint"
  | "model_runtime.provider.custom_hint"
  | "model_runtime.provider.custom_name"
  | "model_runtime.provider.huawei_hint"
  | "model_runtime.provider.huawei_name"
  | "model_runtime.provider.manual_catalog_hint"
  | "model_runtime.provider.plan_catalog_hint"
  | "model_runtime.provider.public_catalog_hint"
  | "model_runtime.provider.tencent_hint"
  | "model_runtime.provider.tencent_name"
  | "model_runtime.provider.tencent_token_plan_hint"
  | "model_runtime.provider.tencent_token_plan_name"
  | "model_runtime.provider.tencent_tokenhub_hint"
  | "model_runtime.provider.tencent_tokenhub_name"
  | "model_runtime.provider.volcengine_agent_plan_hint"
  | "model_runtime.provider.volcengine_agent_plan_name"
  | "model_runtime.provider.volcengine_coding_plan_hint"
  | "model_runtime.provider.volcengine_coding_plan_name"
  | "model_runtime.provider.volcengine_hint"
  | "model_runtime.provider.volcengine_name"
  | "model_runtime.provider.volcengine_openspeech_hint"
  | "model_runtime.provider.volcengine_openspeech_name"
  | "model_runtime.provider.zhipu_coding_plan_hint"
  | "model_runtime.provider.zhipu_coding_plan_name"
  | "model_runtime.provider.zhipu_hint"
  | "model_runtime.provider.zhipu_name"
  | "nav.account"
  | "nav.account.appearance"
  | "nav.account.appearance.follow"
  | "nav.account.billing"
  | "nav.account.lang"
  | "nav.account.logout"
  | "nav.account.me"
  | "nav.account.mobile.account"
  | "nav.account.mobile.lang"
  | "nav.account.mobile.prefs"
  | "nav.account.session.password"
  | "nav.account.settings"
  | "nav.account.shortcuts"
  | "nav.account.shortcuts.hint"
  | "nav.account.team"
  | "nav.alert"
  | "nav.auth"
  | "nav.bridge"
  | "nav.bug_reports"
  | "nav.chat"
  | "nav.code"
  | "nav.common.loading"
  | "nav.dash"
  | "nav.duty"
  | "nav.hosts"
  | "nav.inbox.empty"
  | "nav.inbox.title"
  | "nav.inbox.view.all"
  | "nav.memo"
  | "nav.models"
  | "nav.more"
  | "nav.more.group.modules"
  | "nav.new_session"
  | "nav.notification"
  | "nav.onboard"
  | "nav.project"
  | "nav.project.loading"
  | "nav.project_tabs"
  | "nav.ptab.activity"
  | "nav.ptab.chat"
  | "nav.ptab.env"
  | "nav.ptab.memo"
  | "nav.ptab.overview"
  | "nav.ptab.release"
  | "nav.ptab.resources"
  | "nav.ptab.tasks"
  | "nav.search.everything"
  | "nav.search.group.hosts"
  | "nav.search.group.memos"
  | "nav.search.group.projects"
  | "nav.search.group.timeline"
  | "nav.search.hint"
  | "nav.search.hint.all"
  | "nav.search.none"
  | "nav.search.placeholder"
  | "nav.sec"
  | "nav.server"
  | "nav.shortcuts.group.global"
  | "nav.shortcuts.group.memo"
  | "nav.shortcuts.yield.note"
  | "nav.skills"
  | "nav.status.idle"
  | "nav.status.unknown"
  | "nav.team"
  | "nav.theme.current"
  | "nav.theme.dark"
  | "nav.theme.light"
  | "nav.theme.quick.hint"
  | "nav.theme.switch"
  | "nav.timeline"
  | "nav.today.card.night"
  | "nav.today.card.running"
  | "nav.today.card.waiting"
  | "nav.today.empty.running"
  | "nav.today.empty.waiting"
  | "nav.today.error.title"
  | "nav.today.link.alerts"
  | "nav.today.link.all_activity"
  | "nav.today.link.inbox"
  | "nav.today.link.night"
  | "nav.today.link.timeline"
  | "nav.today.overview.all"
  | "nav.today.page.title"
  | "nav.vendor"
  | "onboarding.action.start"
  | "onboarding.error.auth_failed"
  | "onboarding.error.host_key_changed"
  | "onboarding.error.key_passphrase"
  | "onboarding.error.key_unreadable"
  | "onboarding.error.no_credential"
  | "onboarding.guess.confirm"
  | "onboarding.guess.heading"
  | "onboarding.guess.rename"
  | "onboarding.guess.unknown"
  | "onboarding.missing.address"
  | "onboarding.missing.secret"
  | "onboarding.missing.username"
  | "onboarding.page.subtitle"
  | "onboarding.page.title"
  | "onboarding.passphrase.placeholder"
  | "onboarding.paste.note"
  | "onboarding.paste.placeholder"
  | "onboarding.probe.connect.done"
  | "onboarding.probe.heading"
  | "onboarding.probe.install_agent.running"
  | "onboarding.probe.takeover_key.detail"
  | "onboarding.probe.takeover_key.done"
  | "onboarding.step.hands_off.body"
  | "onboarding.step.hands_off.title"
  | "onboarding.step.identify.body"
  | "onboarding.step.identify.title"
  | "onboarding.step.paste.title"
  | "ops_backup.drill.confirm.body"
  | "ops_backup.drill.confirm.title"
  | "ops_backup.drill.cta"
  | "ops_backup.drill.explain"
  | "ops_backup.drill.heading"
  | "ops_backup.drill.none"
  | "ops_backup.drill.not_restorable"
  | "ops_backup.executor.missing"
  | "ops_backup.executor.queued_but_offline"
  | "ops_backup.failure.checksum_mismatch"
  | "ops_backup.failure.disk_full"
  | "ops_backup.failure.dump_failed"
  | "ops_backup.failure.locked"
  | "ops_backup.failure.restore_failed"
  | "ops_backup.history.by.schedule"
  | "ops_backup.history.empty"
  | "ops_backup.history.heading"
  | "ops_backup.history.kind.backup"
  | "ops_backup.history.kind.restore_drill"
  | "ops_backup.history.status.failed"
  | "ops_backup.history.status.queued"
  | "ops_backup.history.status.running"
  | "ops_backup.history.status.succeeded"
  | "ops_backup.history.stepup"
  | "ops_backup.last.failure.none"
  | "ops_backup.last.success.none"
  | "ops_backup.page.subtitle"
  | "ops_backup.page.title"
  | "ops_backup.plan.heading"
  | "ops_backup.plan.next.unknown"
  | "ops_backup.plan.none"
  | "ops_backup.run.busy"
  | "ops_backup.run.cta"
  | "ops_backup.run.forbidden"
  | "ops_backup.run.queued"
  | "ops_backup.state.heading"
  | "ops_backup.state.idle"
  | "ops_backup.state.queued"
  | "pjhub.action.create"
  | "pjhub.action.retry"
  | "pjhub.builtin"
  | "pjhub.col.activity"
  | "pjhub.col.env"
  | "pjhub.col.health"
  | "pjhub.col.name"
  | "pjhub.col.recent_release"
  | "pjhub.col.recent_task"
  | "pjhub.col.resource"
  | "pjhub.empty.body"
  | "pjhub.empty.title"
  | "pjhub.error.body"
  | "pjhub.error.title"
  | "pjhub.filter.all"
  | "pjhub.filter.empty"
  | "pjhub.filter.needs_attention"
  | "pjhub.filter.unverified"
  | "pjhub.loading.hint"
  | "pjhub.loading.title"
  | "pjhub.new.name"
  | "pjhub.new.slug"
  | "pjhub.new.submitting"
  | "pjhub.new.subtitle"
  | "pjhub.new.title"
  | "pjhub.notice.missing_fields.body"
  | "pjhub.notice.not_switcher.body"
  | "pjhub.notice.not_switcher.title"
  | "pjhub.notice.unverified.body"
  | "pjhub.notice.unverified.title"
  | "pjhub.notice.unverified.why"
  | "pjhub.resource.has"
  | "pjhub.resource.none"
  | "pjhub.search.placeholder"
  | "pjhub.sort.hint"
  | "pjhub.stat.healthy"
  | "pjhub.stat.needs_attention"
  | "pjhub.stat.projects"
  | "pjhub.stat.running_releases"
  | "pjhub.stat.running_tasks"
  | "pjhub.subtitle"
  | "pjhub.subtitle.unverified"
  | "pjhub.title"
  | "pjhub.value.unverified"
  | "pjshell.capacity.cpu"
  | "pjshell.capacity.disk"
  | "pjshell.capacity.expiry"
  | "pjshell.capacity.host"
  | "pjshell.capacity.memory"
  | "pjshell.chat.attach"
  | "pjshell.chat.attach.blocked"
  | "pjshell.chat.can.assign"
  | "pjshell.chat.can.assign.body"
  | "pjshell.chat.can.auto"
  | "pjshell.chat.can.auto.body"
  | "pjshell.chat.can.send"
  | "pjshell.chat.can.send.body"
  | "pjshell.chat.can.status"
  | "pjshell.chat.can.status.body"
  | "pjshell.chat.can.title"
  | "pjshell.chat.can.value"
  | "pjshell.chat.cannot.manage"
  | "pjshell.chat.cannot.manage.body"
  | "pjshell.chat.cannot.orch"
  | "pjshell.chat.cannot.orch.body"
  | "pjshell.chat.cannot.other"
  | "pjshell.chat.cannot.other.body"
  | "pjshell.chat.cannot.switcher"
  | "pjshell.chat.cannot.switcher.body"
  | "pjshell.chat.cannot.title"
  | "pjshell.chat.cannot.value"
  | "pjshell.chat.current"
  | "pjshell.chat.open_full"
  | "pjshell.chat.placeholder"
  | "pjshell.chat.split"
  | "pjshell.chat.subtitle"
  | "pjshell.chat.voice.blocked"
  | "pjshell.env.address"
  | "pjshell.env.certificate.stored"
  | "pjshell.env.col.cert"
  | "pjshell.env.col.expiry"
  | "pjshell.env.col.point"
  | "pjshell.env.col.resolve"
  | "pjshell.env.col.state"
  | "pjshell.env.configure"
  | "pjshell.env.configure.body"
  | "pjshell.env.configure.domain"
  | "pjshell.env.configure.done"
  | "pjshell.env.configure.files"
  | "pjshell.env.configure.files_hint"
  | "pjshell.env.configure.machine"
  | "pjshell.env.configure.pick"
  | "pjshell.env.configure.pick_folder"
  | "pjshell.env.configure.ready"
  | "pjshell.env.configure.submit"
  | "pjshell.env.configure.target"
  | "pjshell.env.configure.title"
  | "pjshell.env.domain.registered"
  | "pjshell.env.domain.verified"
  | "pjshell.env.domain.waiting"
  | "pjshell.env.domains"
  | "pjshell.env.group"
  | "pjshell.env.machine"
  | "pjshell.env.no_bundle"
  | "pjshell.env.open"
  | "pjshell.env.probe"
  | "pjshell.env.production"
  | "pjshell.env.production.title"
  | "pjshell.env.promote"
  | "pjshell.env.promote.body"
  | "pjshell.env.promote.note"
  | "pjshell.env.promote.title"
  | "pjshell.env.rollback"
  | "pjshell.env.status.failed"
  | "pjshell.env.status.ready"
  | "pjshell.env.status.rolled_back"
  | "pjshell.env.subtitle"
  | "pjshell.env.test"
  | "pjshell.env.test.title"
  | "pjshell.env.version"
  | "pjshell.env.when"
  | "pjshell.env.who"
  | "pjshell.fact.uncollected"
  | "pjshell.fact.unconfigured"
  | "pjshell.fact.unknown"
  | "pjshell.memo.empty"
  | "pjshell.memo.voice.blocked"
  | "pjshell.overview.capacity"
  | "pjshell.overview.card.entry"
  | "pjshell.overview.card.lives"
  | "pjshell.overview.card.publish"
  | "pjshell.overview.decide.action"
  | "pjshell.overview.decide.body"
  | "pjshell.overview.env"
  | "pjshell.overview.events"
  | "pjshell.overview.feed"
  | "pjshell.overview.feed.note"
  | "pjshell.overview.go_env"
  | "pjshell.overview.go_release"
  | "pjshell.overview.go_resources"
  | "pjshell.overview.go_tasks"
  | "pjshell.overview.health"
  | "pjshell.overview.last_release"
  | "pjshell.overview.live.note"
  | "pjshell.overview.live_version"
  | "pjshell.overview.no_resource_issue"
  | "pjshell.overview.now"
  | "pjshell.overview.release"
  | "pjshell.overview.resource_issues"
  | "pjshell.overview.subtitle"
  | "pjshell.overview.takeover"
  | "pjshell.overview.tasks"
  | "pjshell.overview.watch"
  | "pjshell.overview.working"
  | "pjshell.overview.working.empty"
  | "pjshell.overview.working.note"
  | "pjshell.pending_item"
  | "pjshell.readiness.agent_only"
  | "pjshell.readiness.awaiting_heartbeat"
  | "pjshell.readiness.check_failed"
  | "pjshell.readiness.complete"
  | "pjshell.readiness.continue"
  | "pjshell.readiness.details"
  | "pjshell.readiness.execution"
  | "pjshell.readiness.execution_failed"
  | "pjshell.readiness.heartbeat"
  | "pjshell.readiness.install_failed"
  | "pjshell.readiness.install_timeout"
  | "pjshell.readiness.installer_unavailable"
  | "pjshell.readiness.pending"
  | "pjshell.readiness.ready"
  | "pjshell.readiness.registered"
  | "pjshell.readiness.running"
  | "pjshell.readiness.scope"
  | "pjshell.readiness.ssh_unavailable"
  | "pjshell.readiness.validity"
  | "pjshell.readiness.verify"
  | "pjshell.readiness.waiting"
  | "pjshell.release.app"
  | "pjshell.release.checking"
  | "pjshell.release.col.actions"
  | "pjshell.release.col.last"
  | "pjshell.release.col.name"
  | "pjshell.release.col.size"
  | "pjshell.release.col.status"
  | "pjshell.release.col.url"
  | "pjshell.release.col.version"
  | "pjshell.release.drop"
  | "pjshell.release.drop.choose"
  | "pjshell.release.drop.empty"
  | "pjshell.release.drop.new_site"
  | "pjshell.release.duration"
  | "pjshell.release.failed"
  | "pjshell.release.live"
  | "pjshell.release.none"
  | "pjshell.release.open"
  | "pjshell.release.previous"
  | "pjshell.release.progress"
  | "pjshell.release.publishing"
  | "pjshell.release.replace"
  | "pjshell.release.rollbacks"
  | "pjshell.release.see_failure"
  | "pjshell.release.sites"
  | "pjshell.release.static"
  | "pjshell.release.step.check"
  | "pjshell.release.step.live.note"
  | "pjshell.release.step.publish"
  | "pjshell.release.step.verify"
  | "pjshell.release.step.verify.note"
  | "pjshell.release.steps"
  | "pjshell.release.subtitle"
  | "pjshell.release.today"
  | "pjshell.release.verifying"
  | "pjshell.release.verifying.public"
  | "pjshell.release.version"
  | "pjshell.release.what"
  | "pjshell.release.who"
  | "pjshell.resource.add_one"
  | "pjshell.resource.address"
  | "pjshell.resource.assign_idle"
  | "pjshell.resource.assign_to_project"
  | "pjshell.resource.cert"
  | "pjshell.resource.col.actions"
  | "pjshell.resource.col.capacity"
  | "pjshell.resource.col.cert"
  | "pjshell.resource.col.entry"
  | "pjshell.resource.col.env"
  | "pjshell.resource.col.expiry"
  | "pjshell.resource.col.host"
  | "pjshell.resource.col.owner"
  | "pjshell.resource.col.point"
  | "pjshell.resource.col.spec"
  | "pjshell.resource.col.type"
  | "pjshell.resource.col.vendor"
  | "pjshell.resource.domain"
  | "pjshell.resource.domains"
  | "pjshell.resource.empty.body"
  | "pjshell.resource.empty.title"
  | "pjshell.resource.exclusive"
  | "pjshell.resource.go_cert"
  | "pjshell.resource.go_dns"
  | "pjshell.resource.network"
  | "pjshell.resource.physical"
  | "pjshell.resource.pool"
  | "pjshell.resource.shared"
  | "pjshell.resource.split"
  | "pjshell.resource.storage"
  | "pjshell.resource.subtitle"
  | "pjshell.resource.title"
  | "pjshell.resource.unassign"
  | "pjshell.resource.unassign.body"
  | "pjshell.resource.unassign.confirm"
  | "pjshell.resource.unassign.last_prod"
  | "pjshell.resource.vendor"
  | "pjshell.takeover.none"
  | "pjshell.task.col.elapsed"
  | "pjshell.task.col.files"
  | "pjshell.task.col.name"
  | "pjshell.task.col.source"
  | "pjshell.task.col.state"
  | "pjshell.task.col.who"
  | "pjshell.task.empty"
  | "pjshell.task.filter.all"
  | "pjshell.task.filter.assignee"
  | "pjshell.task.filter.assignee.placeholder"
  | "pjshell.task.filter.decide"
  | "pjshell.task.filter.done"
  | "pjshell.task.filter.failed"
  | "pjshell.task.filter.running"
  | "pjshell.task.filter.updated"
  | "pjshell.task.filter.updated.any"
  | "pjshell.task.filter.updated.hour"
  | "pjshell.task.filter.updated.today"
  | "pjshell.task.filter.updated.week"
  | "pjshell.task.search.placeholder"
  | "pjshell.task.sort.hint"
  | "pjshell.task.source.lulu"
  | "pjshell.task.source.user"
  | "pjshell.task.stale"
  | "pjshell.task.subtitle"
  | "pjshell.task.write"
  | "pjshell.unverified"
  | "project.action.add_new_host"
  | "project.action.all_records"
  | "project.action.assign_host"
  | "project.action.create"
  | "project.action.open_public_entry"
  | "project.archived"
  | "project.assign.idle_empty"
  | "project.assign.idle_heading"
  | "project.assign.idle_loading"
  | "project.builtin.public_infra.name"
  | "project.builtin.public_infra.summary"
  | "project.empty.no_host"
  | "project.empty.no_host.detail"
  | "project.env.promote.no_digest"
  | "project.env.promote.not_verified"
  | "project.env.promote.wrong_kind"
  | "project.env.rollback.no_target"
  | "project.error.builtin_undeletable"
  | "project.error.host_exclusive"
  | "project.error.name_blank"
  | "project.feed.empty"
  | "project.feed.loading"
  | "project.health.all_good"
  | "project.health.host_trouble"
  | "project.health.label"
  | "project.health.publish_failed"
  | "project.list.empty.body"
  | "project.list.empty.title"
  | "project.local_vs_platform.heading"
  | "project.local_vs_platform.how_you_know"
  | "project.local_vs_platform.tag"
  | "project.restored"
  | "project.section.feed"
  | "project.section.public_entry"
  | "project.section.tasks"
  | "project.section.where_it_lives"
  | "project.summary.ai_written_hint"
  | "project_import.action.approve"
  | "project_import.action.start"
  | "project_import.action.unlink"
  | "project_import.approve.hint"
  | "project_import.approve.no_selectable"
  | "project_import.approve.submitting"
  | "project_import.approve.vendor_usage"
  | "project_import.assignee.assigning"
  | "project_import.assignee.create_one_time"
  | "project_import.assignee.one_time_hint"
  | "project_import.assignee.one_time_title"
  | "project_import.assignee.regenerate_one_time"
  | "project_import.assignee.source_locked"
  | "project_import.card.audit"
  | "project_import.card.open"
  | "project_import.card.source_label"
  | "project_import.card.title"
  | "project_import.card.unavailable"
  | "project_import.conflict.deployment_ref"
  | "project_import.conflict.domain_vendor"
  | "project_import.conflict.host"
  | "project_import.conflict.ownership_subject"
  | "project_import.conflict.project"
  | "project_import.conflict.repository"
  | "project_import.conflict.subscription"
  | "project_import.conflict.subscription_due"
  | "project_import.conflict.subscription_vendor"
  | "project_import.conflict.vendor"
  | "project_import.deployment.derived"
  | "project_import.domain.no_record"
  | "project_import.error.conflict_selected"
  | "project_import.error.extra_fields"
  | "project_import.error.host_missing"
  | "project_import.error.idempotency_mismatch"
  | "project_import.error.not_ready"
  | "project_import.error.not_reviewed"
  | "project_import.error.nothing_linked"
  | "project_import.error.nothing_selected"
  | "project_import.error.reissue_conflict"
  | "project_import.error.secrets"
  | "project_import.error.source_not_resendable"
  | "project_import.error.token_expired"
  | "project_import.error.token_used"
  | "project_import.error.unknown_schema"
  | "project_import.error.vendor_conflict"
  | "project_import.evidence.ai_declared"
  | "project_import.evidence.conflict"
  | "project_import.evidence.inventory_matched"
  | "project_import.evidence.missing"
  | "project_import.evidence.platform_verified"
  | "project_import.grades.title"
  | "project_import.idle.not_reusable"
  | "project_import.kind.deployment"
  | "project_import.kind.domain"
  | "project_import.kind.endpoint"
  | "project_import.kind.host"
  | "project_import.kind.ownership"
  | "project_import.kind.project"
  | "project_import.kind.repository"
  | "project_import.kind.subscription"
  | "project_import.kind.unknown"
  | "project_import.kind.vendor"
  | "project_import.links.before_ledger"
  | "project_import.links.created_entity_conditional"
  | "project_import.links.empty"
  | "project_import.links.pre_existing"
  | "project_import.links.released"
  | "project_import.links.title"
  | "project_import.ownership.dashboard_account"
  | "project_import.ownership.deploy_history"
  | "project_import.ownership.derived"
  | "project_import.ownership.dns_record"
  | "project_import.ownership.other"
  | "project_import.ownership.repo_write"
  | "project_import.ownership.ssh_login"
  | "project_import.package.reissue"
  | "project_import.package.reissue_hint"
  | "project_import.package.reissuing"
  | "project_import.project.seed_summary"
  | "project_import.prompt.body"
  | "project_import.prompt.copied"
  | "project_import.prompt.copy"
  | "project_import.prompt.copy_failed"
  | "project_import.prompt.hidden"
  | "project_import.prompt.once"
  | "project_import.prompt.path_label"
  | "project_import.prompt.title"
  | "project_import.prompt.token_label"
  | "project_import.renewal.none"
  | "project_import.renewal.today"
  | "project_import.review.empty"
  | "project_import.review.title"
  | "project_import.review.waiting"
  | "project_import.source.awaiting"
  | "project_import.source.awaiting_assignee"
  | "project_import.source.candidate"
  | "project_import.source.imported"
  | "project_import.source.importing"
  | "project_import.source.needs_rebase"
  | "project_import.source.repository"
  | "project_import.source.resend_hint"
  | "project_import.source.retry"
  | "project_import.source.retrying"
  | "project_import.source.setup_failed"
  | "project_import.source.status_unavailable"
  | "project_import.source.title"
  | "project_import.status.approved"
  | "project_import.status.awaiting_package"
  | "project_import.status.reviewed"
  | "project_import.subscription.no_due"
  | "project_import.unlink.hint"
  | "project_import.unlink.submitting"
  | "project_import.wizard.draft_ready"
  | "project_import.wizard.name"
  | "project_import.wizard.submit"
  | "project_import.wizard.submitting"
  | "project_import.wizard.subtitle"
  | "project_import.wizard.title"
  | "repo.conflict.clear"
  | "repo.gate.blocked.our_environment"
  | "repo.gate.blocked.platform_stopped"
  | "repo.gate.deployed"
  | "repo.gate.held"
  | "repo.gate.needs_you"
  | "repo.gate.passed"
  | "repo.gate.pending"
  | "repo.gate.rejected"
  | "repo.gate.rejected.tests_unknown_count"
  | "repo.npcmd.intro"
  | "repo.npcmd.never_touch_main"
  | "repo.npcmd.online_unknown"
  | "repo.npcmd.pending_none"
  | "repo.npcmd.title"
  | "repo.npcmd.touched_files"
  | "repo.push.accepted"
  | "repo.push.delete_rejected"
  | "repo.push.forward_conflict"
  | "repo.push.forward_rejected"
  | "repo.push.held_no_remote"
  | "repo.push.ref_rejected"
  | "repo.push.tag_rejected"
  | "repo.redline.credentials"
  | "repo.redline.data_delete"
  | "repo.redline.money"
  | "repo.redline.permission"
  | "sec.clean"
  | "sec.count.fixed"
  | "sec.count.must_fix"
  | "sec.count.when_free"
  | "sec.empty"
  | "sec.level.fixed"
  | "sec.level.must_fix"
  | "sec.level.when_free"
  | "sec.no_firewall.explanation"
  | "sec.no_firewall.suggestion"
  | "sec.no_firewall.title"
  | "sec.page.subtitle"
  | "sec.page.title"
  | "sec.password_login_enabled.explanation"
  | "sec.password_login_enabled.suggestion"
  | "sec.password_login_enabled.title"
  | "sec.pending_security_updates.explanation"
  | "sec.pending_security_updates.suggestion"
  | "sec.risk.model_unsure"
  | "sec.root_password_login.explanation"
  | "sec.root_password_login.suggestion"
  | "sec.root_password_login.title"
  | "sec.score.label"
  | "sec.ssh_open_to_world.suggestion"
  | "sec.ssh_open_to_world.title"
  | "split.action.preview"
  | "split.action.preview_only"
  | "split.capacity.reason.child_host"
  | "split.capacity.reason.has_capacity"
  | "split.capacity.reason.incomplete"
  | "split.capacity.reason.unknown_carvable"
  | "split.card.body"
  | "split.card.title"
  | "split.exposure.domain"
  | "split.exposure.internal_only"
  | "split.exposure.ip_port"
  | "split.model.degraded.rule"
  | "split.name.default_project"
  | "split.name.spare"
  | "split.posture.balanced"
  | "split.posture.conservative"
  | "split.posture.dense"
  | "split.posture.heading"
  | "split.posture.minimal"
  | "split.preview.provenance.heading"
  | "split.reason.no_context"
  | "split.requirement.placeholder"
  | "split.runtime.kvm.database"
  | "split.runtime.lxc.default"
  | "split.size.lt_one_g"
  | "split.size.some"
  | "split.slice.reason.database"
  | "split.slice.reason.spare"
  | "split.state.empty"
  | "split.state.pending"
  | "split.validation.accepted"
  | "split.validation.adjusted"
  | "split.validation.rejected"
  | "split_exec.blocked.busy"
  | "split_exec.blocked.no_executor"
  | "split_exec.blocked.plan_rejected"
  | "split_exec.blocked.plan_stale"
  | "split_exec.confirm.red"
  | "static_site.account.empty"
  | "static_site.account.loading"
  | "static_site.create.slug_invalid"
  | "static_site.create.slug_label"
  | "static_site.create.slug_placeholder"
  | "static_site.create.submit"
  | "static_site.create.title_label"
  | "static_site.create.title_placeholder"
  | "static_site.drop.busy"
  | "static_site.drop.done"
  | "static_site.drop.hint"
  | "static_site.drop.label"
  | "static_site.drop.update_label"
  | "static_site.empty"
  | "static_site.live.failed"
  | "static_site.live.none"
  | "static_site.live.pending"
  | "static_site.live.superseded"
  | "static_site.live.title"
  | "static_site.loading"
  | "static_site.name.label"
  | "static_site.name.save"
  | "static_site.name.saved"
  | "static_site.name.url_is_fixed"
  | "static_site.preview.again"
  | "static_site.preview.expired"
  | "static_site.preview.failed"
  | "static_site.preview.hint"
  | "static_site.preview.none"
  | "static_site.preview.open"
  | "static_site.preview.revoke"
  | "static_site.preview.revoked"
  | "static_site.preview.title"
  | "static_site.publish.action"
  | "static_site.publish.approval_ask"
  | "static_site.publish.approval_asking"
  | "static_site.publish.approval_expired"
  | "static_site.publish.approval_hint"
  | "static_site.publish.approval_label"
  | "static_site.publish.approval_not_a_grant"
  | "static_site.publish.busy"
  | "static_site.publish.reason_label"
  | "static_site.publish.reason_placeholder"
  | "static_site.receipt.health_failed"
  | "static_site.receipt.health_passed"
  | "static_site.receipt.health_pending"
  | "static_site.receipt.health_unknown"
  | "static_site.receipt.rollback_none"
  | "static_site.receipt.toggle"
  | "static_site.rollback.action"
  | "static_site.rollback.busy"
  | "static_site.section.hint"
  | "static_site.section.title"
  | "static_site.status.active"
  | "static_site.status.offlined"
  | "static_site.status.suspended"
  | "static_site.upload.busy"
  | "static_site.upload.hint"
  | "static_site.upload.label"
  | "static_site.url_hint"
  | "static_site.versions.empty"
  | "static_site.versions.title"
  | "steward.brief.action.go_to_plan"
  | "steward.brief.action.ignore"
  | "steward.brief.action.later"
  | "steward.brief.action.mute"
  | "steward.brief.action.schedule"
  | "steward.brief.action.why"
  | "steward.brief.already_today"
  | "steward.brief.context_read"
  | "steward.brief.decided.ignore"
  | "steward.brief.decided.later"
  | "steward.brief.decided.mute"
  | "steward.brief.decided.scheduled"
  | "steward.brief.decisions_none"
  | "steward.brief.findings_head"
  | "steward.brief.findings_none"
  | "steward.brief.footer"
  | "steward.brief.headline"
  | "steward.brief.item.finding"
  | "steward.brief.item.proposal"
  | "steward.brief.proposals_head"
  | "steward.brief.proposals_none"
  | "steward.brief.releases_none"
  | "steward.brief.scheduled"
  | "steward.chat.acceptance"
  | "steward.chat.account_scope_only"
  | "steward.chat.model_auth_hold"
  | "steward.chat.model_down_hold"
  | "steward.chat.plan_unavailable"
  | "steward.finding.context_read"
  | "steward.finding.none"
  | "steward.memory.todo_why"
  | "steward.reason.green_auto"
  | "steward.reason.invalid_permission"
  | "steward.reason.invalid_request"
  | "steward.reason.observe_only"
  | "steward.reason.read_only"
  | "steward.reason.red_action"
  | "steward.reason.rollback_bounded_auto"
  | "steward.reason.suggest_only"
  | "steward.reason.yellow_not_authorized"
  | "steward.remote_ai.card_hint"
  | "steward.remote_ai.card_title"
  | "steward.remote_ai.copy_link"
  | "steward.remote_ai.copy_link_done"
  | "steward.remote_ai.copy_prompt"
  | "steward.remote_ai.copy_prompt_done"
  | "steward.remote_ai.dont_close"
  | "steward.remote_ai.duration_180d"
  | "steward.remote_ai.duration_30d"
  | "steward.remote_ai.duration_90d"
  | "steward.remote_ai.duration_long_term"
  | "steward.remote_ai.edit"
  | "steward.remote_ai.failed"
  | "steward.remote_ai.field_duration"
  | "steward.remote_ai.field_model"
  | "steward.remote_ai.field_name"
  | "steward.remote_ai.field_provider"
  | "steward.remote_ai.issue"
  | "steward.remote_ai.issuing"
  | "steward.remote_ai.link_label"
  | "steward.remote_ai.once"
  | "steward.remote_ai.prompt_label"
  | "steward.role.backend"
  | "steward.role.frontend"
  | "steward.role.qa"
  | "steward.role.release"
  | "steward.role.research"
  | "steward.role.reviewer"
  | "steward.role.steward"
  | "steward.run.compose_failed"
  | "steward.run.step.stopped_cancelled"
  | "steward.run.step.stopped_clock"
  | "steward.run.step.stopped_steps"
  | "steward.run.step.stopped_tokens"
  | "steward.run.stopped.cancelled"
  | "steward.run.stopped.limit"
  | "steward.skill.deepinspect.step.read_findings"
  | "steward.skill.deepinspect.step.report"
  | "steward.skill.deepinspect.what"
  | "steward.skill.disabled"
  | "steward.skill.diskforecast.step.extrapolate"
  | "steward.skill.diskforecast.step.take_samples"
  | "steward.skill.diskforecast.what"
  | "steward.skill.finding_to_task.name"
  | "steward.skill.logsniff.step.pick_template"
  | "steward.skill.logsniff.step.scan_rules"
  | "steward.skill.logsniff.what"
  | "steward.skill.morning_brief.name"
  | "steward.skill.pulse.step.confirm"
  | "steward.skill.pulse.step.read_findings"
  | "steward.skill.pulse.what"
  | "steward.smalltalk.acknowledged"
  | "steward.smalltalk.done.create_project"
  | "steward.smalltalk.done.list_projects"
  | "steward.smalltalk.done.other"
  | "steward.smalltalk.done.web_search"
  | "steward.smalltalk.failed.create_project"
  | "steward.smalltalk.failed.list_projects"
  | "steward.smalltalk.failed.other"
  | "steward.smalltalk.failed.web_search"
  | "steward.smalltalk.greeting"
  | "steward.smalltalk.project_chat"
  | "steward.smalltalk.project_work"
  | "steward.smalltalk.unclear"
  | "steward.smalltalk.what_can_you_do"
  | "steward.smalltalk.work_needs_project"
  | "steward.smalltalk.working.create_project"
  | "steward.smalltalk.working.inspection"
  | "steward.smalltalk.working.list_projects"
  | "steward.smalltalk.working.remote_ai_invite"
  | "steward.smalltalk.working.remote_ai_status"
  | "steward.smalltalk.working.think"
  | "steward.smalltalk.working.web_search"
  | "team.action.edit"
  | "team.action.invite"
  | "team.empty"
  | "team.error.forbidden"
  | "team.error.last_owner"
  | "team.error.not_in_project"
  | "team.error.owner_only"
  | "team.invite.dialog.cancel"
  | "team.invite.dialog.email"
  | "team.invite.dialog.email.hint"
  | "team.invite.dialog.password"
  | "team.invite.dialog.password.why"
  | "team.invite.dialog.projects"
  | "team.invite.dialog.role"
  | "team.invite.dialog.submit"
  | "team.invite.dialog.title"
  | "team.invite.disabled.why"
  | "team.invite.done"
  | "team.invite.form.cancel"
  | "team.invite.form.email"
  | "team.invite.form.projects"
  | "team.invite.form.projects_hint"
  | "team.invite.form.role"
  | "team.invite.form.submit"
  | "team.invite.form.title"
  | "team.invite.invalid"
  | "team.invite.label"
  | "team.invite.link"
  | "team.invite.link.hint"
  | "team.invite.link.title"
  | "team.invite.link_copied"
  | "team.invite.link_copy"
  | "team.invite.link_manual"
  | "team.invite.needs_projects"
  | "team.invite.no_cap"
  | "team.invite.pending.empty"
  | "team.invite.pending.revoke"
  | "team.invite.pending.title"
  | "team.invite.redeem.go"
  | "team.invite.redeem.need_login"
  | "team.invite.redeem.title"
  | "team.invite.revoked"
  | "team.invite.stepup"
  | "team.invite.taken"
  | "team.invites.heading"
  | "team.invites.hint"
  | "team.invites.revoke"
  | "team.member.dialog.cancel"
  | "team.member.dialog.projects"
  | "team.member.dialog.projects_hint"
  | "team.member.dialog.role"
  | "team.member.dialog.stepup"
  | "team.member.dialog.submit"
  | "team.member.edit"
  | "team.member.saved"
  | "team.page.subtitle"
  | "team.page.title"
  | "team.projects.none_yet"
  | "team.projects.owner_sees_all"
  | "team.projects.pick_all"
  | "team.projects.pick_none"
  | "team.projects.search"
  | "team.role.operator"
  | "team.role.operator.desc"
  | "team.role.owner"
  | "team.role.owner.desc"
  | "team.role.viewer"
  | "team.role.viewer.desc"
  | "team.roles.heading"
  | "team.roles.hint"
  | "team.table.person"
  | "team.table.role"
  | "team.table.scope"
  | "timeline.action.approve"
  | "timeline.action.detail"
  | "timeline.action.not_ready"
  | "timeline.action.out_of_bounds"
  | "timeline.action.undo"
  | "timeline.approve.confirm.body"
  | "timeline.approve.confirm.title"
  | "timeline.approve.done"
  | "timeline.approve.forbidden"
  | "timeline.detail.checks"
  | "timeline.detail.commands"
  | "timeline.detail.exit_failed"
  | "timeline.detail.exit_ok"
  | "timeline.detail.output"
  | "timeline.detail.snapshot"
  | "timeline.empty"
  | "timeline.filter.all"
  | "timeline.filter.changed"
  | "timeline.filter.troubled"
  | "timeline.page.subtitle"
  | "timeline.page.title"
  | "timeline.stamp.yesterday"
  | "timeline.state.rolled_back"
  | "timeline.state.undone"
  | "timeline.tag.acted"
  | "timeline.tag.code_changed"
  | "timeline.tag.deployed"
  | "timeline.tag.noted"
  | "timeline.tag.routine"
  | "timeline.tag.trouble"
  | "timeline.undo.cost.restart"
  | "timeline.undo.done"
  | "ui.cancel"
  | "ui.close"
  | "ui.edit"
  | "ui.navigation"
  | "ui.not_ready"
  | "ui.stale_build.action"
  | "ui.stale_build.notice"
  | "vendor.action.edit_scope"
  | "vendor.action.remove_public_scope"
  | "vendor.action.remove_scope"
  | "vendor.action.save_project_scope"
  | "vendor.action.save_public_scope"
  | "vendor.auto_renew_on"
  | "vendor.capability.acme_dns01"
  | "vendor.capability.ai"
  | "vendor.capability.cdn"
  | "vendor.capability.compute"
  | "vendor.capability.dns"
  | "vendor.capability.email"
  | "vendor.capability.git"
  | "vendor.capability.object_storage"
  | "vendor.capability.other"
  | "vendor.capability.registrar"
  | "vendor.card.monthly_cost"
  | "vendor.card.scope"
  | "vendor.card.secret"
  | "vendor.card.secret_kept"
  | "vendor.card.usage"
  | "vendor.detail.account"
  | "vendor.detail.account_hint"
  | "vendor.detail.account_section"
  | "vendor.detail.console_url"
  | "vendor.detail.mfa"
  | "vendor.detail.password"
  | "vendor.detail.peek"
  | "vendor.detail.secrets_section"
  | "vendor.empty"
  | "vendor.error.bad_kind"
  | "vendor.error.bad_project_link_scope"
  | "vendor.error.name_blank"
  | "vendor.error.usage_note_blank"
  | "vendor.page.subtitle"
  | "vendor.page.title"
  | "vendor.scope.editor.current"
  | "vendor.scope.editor.project"
  | "vendor.scope.editor.project_note"
  | "vendor.scope.editor.public_note"
  | "vendor.scope.editor.title"
  | "vendor.scope.public"

export const TEMPLATES: Readonly<Record<CopyId, Template>> = {
  "account.billing.empty.honest": { id: "account.billing.empty.honest", domain: "account", text: "账单数据还没接——接上后这里显示本月用量与额度，账户菜单右侧也会出现真实额度。现在没有需要你处理的账单。", vars: [], tone: "", source: "v3 §4C.3" },
  "account.devices.admin_note": { id: "account.devices.admin_note", domain: "account", text: "换电脑先由老板本人登录，账户权限会跟过来。要让本机 AI 开发，再点上面的“授权这台电脑”完成工具配置；它不会创建免登录后门。", vars: [], tone: "", source: "补充" },
  "account.devices.current": { id: "account.devices.current", domain: "account", text: "你正在用的这台", vars: [], tone: "", source: "补充" },
  "account.devices.empty": { id: "account.devices.empty", domain: "account", text: "只有你正在用的这一台。", vars: [], tone: "", source: "补充" },
  "account.devices.heading": { id: "account.devices.heading", domain: "account", text: "登录着的设备", vars: [], tone: "", source: "补充" },
  "account.devices.hint": { id: "account.devices.hint", domain: "account", text: "这是现在能进你账户的所有设备。看到不认得的，直接把它退掉——它下次刷新就进不来了。", vars: [], tone: "", source: "补充" },
  "account.devices.last_used": { id: "account.devices.last_used", domain: "account", text: "最近用过 {when}", vars: ["when"], tone: "", source: "补充" },
  "account.devices.method.bootstrap": { id: "account.devices.method.bootstrap", domain: "account", text: "第一次开通这个账户时进来的", vars: [], tone: "", source: "补充" },
  "account.devices.method.email_code": { id: "account.devices.method.email_code", domain: "account", text: "用邮箱验证码进来的", vars: [], tone: "", source: "补充" },
  "account.devices.method.local_ai": { id: "account.devices.method.local_ai", domain: "account", text: "这台电脑上的本机 AI（继承老板当前权限）", vars: [], tone: "", source: "2026-09-08 本机老板设备身份修复" },
  "account.devices.method.passkey": { id: "account.devices.method.passkey", domain: "account", text: "用指纹 / 面容进来的", vars: [], tone: "", source: "补充" },
  "account.devices.method.password": { id: "account.devices.method.password", domain: "account", text: "用邮箱密码进来的", vars: [], tone: "", source: "补充" },
  "account.devices.method.recovery_code": { id: "account.devices.method.recovery_code", domain: "account", text: "用恢复码进来的", vars: [], tone: "", source: "补充" },
  "account.devices.method.unknown": { id: "account.devices.method.unknown", domain: "account", text: "记不清当时是怎么进来的", vars: [], tone: "", source: "补充" },
  "account.devices.name": { id: "account.devices.name", domain: "account", text: "{os} 上的 {browser}", vars: ["browser", "os"], tone: "", source: "补充" },
  "account.devices.name.os_only": { id: "account.devices.name.os_only", domain: "account", text: "{os} 上的浏览器", vars: ["os"], tone: "", source: "补充" },
  "account.devices.name.unknown": { id: "account.devices.name.unknown", domain: "account", text: "说不上来是什么设备", vars: [], tone: "", source: "补充" },
  "account.devices.revoke.confirm.body": { id: "account.devices.revoke.confirm.body", domain: "account", text: "退掉之后它下次刷新就进不来了。要是那台其实是你自己的，重新登一次就行。", vars: [], tone: "", source: "补充" },
  "account.devices.revoke.confirm.title": { id: "account.devices.revoke.confirm.title", domain: "account", text: "要把这台退掉吗", vars: [], tone: "", source: "补充" },
  "account.devices.revoke.cta": { id: "account.devices.revoke.cta", domain: "account", text: "退掉这台", vars: [], tone: "", source: "补充" },
  "account.devices.revoke.done": { id: "account.devices.revoke.done", domain: "account", text: "退掉了。那台下次刷新就得重新登录。", vars: [], tone: "", source: "补充" },
  "account.devices.revoke.others.cta": { id: "account.devices.revoke.others.cta", domain: "account", text: "把其他设备都退掉", vars: [], tone: "", source: "补充" },
  "account.devices.revoke.others.done": { id: "account.devices.revoke.others.done", domain: "account", text: "退掉了 {count} 台。它们下次刷新就得重新登录。", vars: ["count"], tone: "", source: "补充" },
  "account.devices.revoke.others.none": { id: "account.devices.revoke.others.none", domain: "account", text: "现在只有你这一台登着，没有别的要退。", vars: [], tone: "", source: "补充" },
  "account.devices.revoke.self": { id: "account.devices.revoke.self", domain: "account", text: "这是你正在用的这台。要下线自己，点「退出登录」就行。", vars: [], tone: "", source: "补充" },
  "account.devices.signed_in": { id: "account.devices.signed_in", domain: "account", text: "{when} 登进来的", vars: ["when"], tone: "", source: "补充" },
  "account.local_ai.copied": { id: "account.local_ai.copied", domain: "account", text: "已复制", vars: [], tone: "", source: "2026-09-07 双电脑协作简化" },
  "account.local_ai.copy": { id: "account.local_ai.copy", domain: "account", text: "复制配置提示词", vars: [], tone: "", source: "2026-09-07 双电脑协作简化" },
  "account.local_ai.cta": { id: "account.local_ai.cta", domain: "account", text: "授权这台电脑", vars: [], tone: "", source: "2026-09-07 双电脑协作简化" },
  "account.local_ai.error": { id: "account.local_ai.error", domain: "account", text: "这次没能生成授权，再点一次即可。不会要求你改用 Forgejo 账号或手工添加密钥。", vars: [], tone: "", source: "2026-09-08 双电脑无仓库账号接入" },
  "account.local_ai.generating": { id: "account.local_ai.generating", domain: "account", text: "正在生成", vars: [], tone: "", source: "2026-09-08 双电脑无仓库账号接入" },
  "account.local_ai.heading": { id: "account.local_ai.heading", domain: "account", text: "本机 AI 开发", vars: [], tone: "", source: "2026-09-07 双电脑协作简化" },
  "account.local_ai.hint": { id: "account.local_ai.hint", domain: "account", text: "生成一次性配置提示词，交给本机 Codex、Claude 或 Cursor。这台设备会继承当前老板账号的完整平台权限；源码和发布仍由 NPC API 代理，不需要 Forgejo 账号、仓库密码或手工添加 SSH Key。", vars: [], tone: "", source: "2026-09-08 本机老板设备身份修复" },
  "account.local_ai.modal.close": { id: "account.local_ai.modal.close", domain: "account", text: "完成", vars: [], tone: "", source: "2026-09-07 双电脑协作简化" },
  "account.local_ai.modal.description": { id: "account.local_ai.modal.description", domain: "account", text: "复制整段发送。邀请只可兑换一次；它创建的是这台电脑的老板设备 API，不会把账号密码、Cookie、Forgejo 凭证或服务器密钥交给 AI。", vars: [], tone: "", source: "2026-09-08 本机老板设备身份修复" },
  "account.local_ai.modal.title": { id: "account.local_ai.modal.title", domain: "account", text: "交给这台电脑上的 AI", vars: [], tone: "", source: "2026-09-07 双电脑协作简化" },
  "account.paths.email_code": { id: "account.paths.email_code", domain: "account", text: "邮箱验证码", vars: [], tone: "", source: "契约请求 · pending-copy.ts 草案" },
  "account.paths.heading": { id: "account.paths.heading", domain: "account", text: "你现在有几条路能进来", vars: [], tone: "", source: "契约请求 · apps/console/src/screens/auth/pending-copy.ts 草案" },
  "account.paths.passkey": { id: "account.paths.passkey", domain: "account", text: "指纹 / 面容", vars: [], tone: "", source: "契约请求 · pending-copy.ts 草案" },
  "account.paths.password": { id: "account.paths.password", domain: "account", text: "邮箱密码", vars: [], tone: "", source: "补充" },
  "account.paths.recovery_code": { id: "account.paths.recovery_code", domain: "account", text: "恢复码", vars: [], tone: "", source: "契约请求 · pending-copy.ts 草案" },
  "account.paths.unusable": { id: "account.paths.unusable", domain: "account", text: "用不了", vars: [], tone: "", source: "契约请求 · pending-copy.ts 草案" },
  "account.paths.usable": { id: "account.paths.usable", domain: "account", text: "能用", vars: [], tone: "", source: "契约请求 · pending-copy.ts 草案" },
  "account.stepup.body": { id: "account.stepup.body", domain: "account", text: "这一步不好收回，所以我要当场再确认一次。就算有人拿到了你的登录状态，他也没有这一样。", vars: [], tone: "", source: "补充" },
  "account.stepup.cancel": { id: "account.stepup.cancel", domain: "account", text: "先不动", vars: [], tone: "", source: "补充" },
  "account.stepup.code.label": { id: "account.stepup.code.label", domain: "account", text: "邮箱里那 6 位数字", vars: [], tone: "", source: "补充" },
  "account.stepup.code.resend": { id: "account.stepup.code.resend", domain: "account", text: "没收到？再发一封", vars: [], tone: "", source: "补充" },
  "account.stepup.code.send": { id: "account.stepup.code.send", domain: "account", text: "给我发一封", vars: [], tone: "", source: "补充" },
  "account.stepup.code.sent": { id: "account.stepup.code.sent", domain: "account", text: "发到 {email} 了，10 分钟内有效。", vars: ["email"], tone: "", source: "补充" },
  "account.stepup.confirm": { id: "account.stepup.confirm", domain: "account", text: "确认，继续", vars: [], tone: "", source: "补充" },
  "account.stepup.method.email_code": { id: "account.stepup.method.email_code", domain: "account", text: "用邮箱验证码", vars: [], tone: "", source: "补充" },
  "account.stepup.method.password": { id: "account.stepup.method.password", domain: "account", text: "用登录密码", vars: [], tone: "", source: "补充" },
  "account.stepup.no_ticket": { id: "account.stepup.no_ticket", domain: "account", text: "你这一下验过了，可平台没把凭据交回来——这是我这边的毛病，不是你输错了。再点一次「确认，继续」；还是这样就把这句话告诉我。", vars: [], tone: "warn", source: "补充 2026-09-06" },
  "account.stepup.none": { id: "account.stepup.none", domain: "account", text: "现在一种确认方式都用不上：这个账号还没设密码，发信通道也没通。先在下面设一个密码，就能继续了。", vars: [], tone: "", source: "补充" },
  "account.stepup.password.label": { id: "account.stepup.password.label", domain: "account", text: "你的登录密码", vars: [], tone: "", source: "补充" },
  "account.stepup.switch": { id: "account.stepup.switch", domain: "account", text: "换一种方式", vars: [], tone: "", source: "补充" },
  "account.stepup.title": { id: "account.stepup.title", domain: "account", text: "确认一下是你本人", vars: [], tone: "", source: "补充" },
  "account.stepup.working": { id: "account.stepup.working", domain: "account", text: "正在确认…", vars: [], tone: "", source: "补充" },
  "activity.action.copy_link": { id: "activity.action.copy_link", domain: "activity", text: "复制链接", vars: [], tone: "", source: "设计稿 A06" },
  "activity.action.manage_follow": { id: "activity.action.manage_follow", domain: "activity", text: "管理关注", vars: [], tone: "", source: "设计稿 A03" },
  "activity.action.mark_all_read": { id: "activity.action.mark_all_read", domain: "activity", text: "全部已读", vars: [], tone: "", source: "设计稿 A01" },
  "activity.actor.lulu": { id: "activity.actor.lulu", domain: "activity", text: "Lulu", vars: [], tone: "", source: "动态中心诚实生产者" },
  "activity.actor.system": { id: "activity.actor.system", domain: "activity", text: "平台", vars: [], tone: "", source: "动态中心诚实生产者" },
  "activity.catalog.copy": { id: "activity.catalog.copy", domain: "activity", text: "文案", vars: [], tone: "", source: "设计稿 A11" },
  "activity.catalog.scene": { id: "activity.catalog.scene", domain: "activity", text: "场景", vars: [], tone: "", source: "设计稿 A11" },
  "activity.catalog.scene.action": { id: "activity.catalog.scene.action", domain: "activity", text: "要我处理为空", vars: [], tone: "", source: "设计稿 A11" },
  "activity.catalog.scene.all": { id: "activity.catalog.scene.all", domain: "activity", text: "全部为空", vars: [], tone: "", source: "设计稿 A11" },
  "activity.catalog.scene.disconnected": { id: "activity.catalog.scene.disconnected", domain: "activity", text: "断线", vars: [], tone: "", source: "设计稿 A11" },
  "activity.catalog.scene.following": { id: "activity.catalog.scene.following", domain: "activity", text: "关注为空", vars: [], tone: "", source: "设计稿 A11" },
  "activity.catalog.scene.omitted": { id: "activity.catalog.scene.omitted", domain: "activity", text: "文案缺失", vars: [], tone: "", source: "设计稿 A11" },
  "activity.catalog.scene.recovered": { id: "activity.catalog.scene.recovered", domain: "activity", text: "补齐成功", vars: [], tone: "", source: "设计稿 A11" },
  "activity.catalog.scene.search": { id: "activity.catalog.scene.search", domain: "activity", text: "搜索为空", vars: [], tone: "", source: "设计稿 A11" },
  "activity.catalog.scene.unknown": { id: "activity.catalog.scene.unknown", domain: "activity", text: "状态未知", vars: [], tone: "", source: "设计稿 A11" },
  "activity.catalog.subtitle": { id: "activity.catalog.subtitle", domain: "activity", text: "八种空和错的场景，文案意图逐条钉死。", vars: [], tone: "", source: "设计稿 A11" },
  "activity.catalog.title": { id: "activity.catalog.title", domain: "activity", text: "空态怎么写", vars: [], tone: "", source: "设计稿 A11" },
  "activity.conn.live": { id: "activity.conn.live", domain: "activity", text: "实时已连接", vars: [], tone: "", source: "设计稿 A01" },
  "activity.detail.boundary": { id: "activity.detail.boundary", domain: "activity", text: "动态中心只负责发现和理解，操作回到 Lulu 或对应模块。", vars: [], tone: "", source: "设计稿 A04" },
  "activity.detail.close": { id: "activity.detail.close", domain: "activity", text: "关掉详情", vars: [], tone: "", source: "设计稿 A04" },
  "activity.detail.continue_lulu": { id: "activity.detail.continue_lulu", domain: "activity", text: "和 Lulu 处理", vars: [], tone: "", source: "设计稿 A02" },
  "activity.detail.evidence": { id: "activity.detail.evidence", domain: "activity", text: "证据", vars: [], tone: "", source: "设计稿 A04" },
  "activity.detail.follow": { id: "activity.detail.follow", domain: "activity", text: "关注", vars: [], tone: "", source: "设计稿 A04" },
  "activity.detail.go_release": { id: "activity.detail.go_release", domain: "activity", text: "去发布页", vars: [], tone: "", source: "设计稿 A04" },
  "activity.detail.open_session": { id: "activity.detail.open_session", domain: "activity", text: "打开这条会话", vars: [], tone: "", source: "设计稿 A01" },
  "activity.detail.open_source": { id: "activity.detail.open_source", domain: "activity", text: "打开来源", vars: [], tone: "", source: "设计稿 A04" },
  "activity.detail.result": { id: "activity.detail.result", domain: "activity", text: "结果", vars: [], tone: "", source: "设计稿 A04" },
  "activity.detail.sidecar_sub": { id: "activity.detail.sidecar_sub", domain: "activity", text: "一个活动线程 = 一件事从开始到结果。", vars: [], tone: "", source: "设计稿 A04" },
  "activity.detail.stages": { id: "activity.detail.stages", domain: "activity", text: "关键节点", vars: [], tone: "", source: "设计稿 A04" },
  "activity.detail.unfollow": { id: "activity.detail.unfollow", domain: "activity", text: "取消关注", vars: [], tone: "", source: "设计稿 A04" },
  "activity.detail.view_evidence": { id: "activity.detail.view_evidence", domain: "activity", text: "查看证据", vars: [], tone: "", source: "设计稿 A04" },
  "activity.detail.view_impact": { id: "activity.detail.view_impact", domain: "activity", text: "看影响范围", vars: [], tone: "", source: "设计稿 A01" },
  "activity.empty.action": { id: "activity.empty.action", domain: "activity", text: "现在没有需要你处理的事。", vars: [], tone: "", source: "设计稿 A11" },
  "activity.empty.action.title": { id: "activity.empty.action.title", domain: "activity", text: "现在没有需要你处理的事。", vars: [], tone: "", source: "设计稿 A11" },
  "activity.empty.all": { id: "activity.empty.all", domain: "activity", text: "这里还没有动态。Lulu、项目、发布和资源有变化时会出现在这里。", vars: [], tone: "", source: "设计稿 A10 / A11" },
  "activity.empty.all.hint": { id: "activity.empty.all.hint", domain: "activity", text: "现在什么都没发生。这不是加载失败。", vars: [], tone: "", source: "设计稿 A10" },
  "activity.empty.all.title": { id: "activity.empty.all.title", domain: "activity", text: "这里还没有动态", vars: [], tone: "", source: "设计稿 A10" },
  "activity.empty.following": { id: "activity.empty.following", domain: "activity", text: "关注项目、任务、站点、资源或 Agent 后，它们的变化会集中在这里。", vars: [], tone: "", source: "设计稿 A11 / M06" },
  "activity.empty.following.hint": { id: "activity.empty.following.hint", domain: "activity", text: "你参与的项目和你发起的任务会自动关注。", vars: [], tone: "", source: "设计稿 M06" },
  "activity.empty.following.quiet.hint": { id: "activity.empty.following.quiet.hint", domain: "activity", text: "有变化我会放到这里，不用一直盯着。", vars: [], tone: "", source: "动态中心关注视图 2026-09-02" },
  "activity.empty.following.quiet.title": { id: "activity.empty.following.quiet.title", domain: "activity", text: "你关注的东西最近没有动静", vars: [], tone: "", source: "动态中心关注视图 2026-09-02" },
  "activity.empty.following.title": { id: "activity.empty.following.title", domain: "activity", text: "还没有关注任何东西", vars: [], tone: "", source: "设计稿 M06" },
  "activity.empty.go_chat": { id: "activity.empty.go_chat", domain: "activity", text: "和 Lulu 说点什么", vars: [], tone: "", source: "设计稿 A10" },
  "activity.empty.go_projects": { id: "activity.empty.go_projects", domain: "activity", text: "去项目列表", vars: [], tone: "", source: "设计稿 A10" },
  "activity.empty.important": { id: "activity.empty.important", domain: "activity", text: "当前没有影响推进、发布结果或需要关注的变化。普通过程仍可在全部动态中查看。", vars: [], tone: "", source: "动态中心产品会议 2026-08-28" },
  "activity.empty.important.title": { id: "activity.empty.important.title", domain: "activity", text: "暂无重要进展", vars: [], tone: "", source: "动态中心产品会议 2026-08-28" },
  "activity.empty.list_failed": { id: "activity.empty.list_failed", domain: "activity", text: "暂时读不到动态列表", vars: [], tone: "", source: "设计稿 A11" },
  "activity.empty.list_failed.hint": { id: "activity.empty.list_failed.hint", domain: "activity", text: "列表这一下没拉下来。点重试，不是没有动态。", vars: [], tone: "", source: "补充" },
  "activity.empty.ops_alerts": { id: "activity.empty.ops_alerts", domain: "activity", text: "打开的运维告警会显示在这里。这不是动态列表。", vars: [], tone: "", source: "异步巡检 batch 4" },
  "activity.empty.ops_alerts.title": { id: "activity.empty.ops_alerts.title", domain: "activity", text: "现在没有未处理的运维告警", vars: [], tone: "", source: "异步巡检 batch 4" },
  "activity.empty.projects_failed": { id: "activity.empty.projects_failed", domain: "activity", text: "暂时读不到项目列表", vars: [], tone: "", source: "设计稿 A11" },
  "activity.empty.retry": { id: "activity.empty.retry", domain: "activity", text: "重试", vars: [], tone: "", source: "设计稿 A11" },
  "activity.empty.search": { id: "activity.empty.search", domain: "activity", text: "没找到符合当前搜索和筛选的动态。", vars: [], tone: "", source: "设计稿 A15" },
  "activity.empty.search.clear_all": { id: "activity.empty.search.clear_all", domain: "activity", text: "清空全部", vars: [], tone: "", source: "设计稿 A15" },
  "activity.empty.search.clear_filters": { id: "activity.empty.search.clear_filters", domain: "activity", text: "清空筛选，只搜关键词", vars: [], tone: "", source: "设计稿 A15" },
  "activity.empty.search.hint": { id: "activity.empty.search.hint", domain: "activity", text: "筛选可能是原因。可以先清空筛选，只留关键词。", vars: [], tone: "", source: "设计稿 A15" },
  "activity.empty.search.title": { id: "activity.empty.search.title", domain: "activity", text: "没找到符合当前搜索和筛选的动态", vars: [], tone: "", source: "设计稿 A15" },
  "activity.excluded.held": { id: "activity.excluded.held", domain: "activity", text: "平台挂起", vars: [], tone: "", source: "设计稿 A02" },
  "activity.excluded.held.desc": { id: "activity.excluded.held.desc", domain: "activity", text: "小译因平台故障停了 4 分钟，已自动恢复并接着跑", vars: [], tone: "", source: "设计稿 A02" },
  "activity.excluded.hint": { id: "activity.excluded.hint", domain: "activity", text: "平台能自动重试或恢复的失败不算待办 —— 它们在「全部」里能看到恢复过程。", vars: [], tone: "", source: "设计稿 A02" },
  "activity.excluded.retry": { id: "activity.excluded.retry", domain: "activity", text: "重试成功", vars: [], tone: "", source: "设计稿 A02" },
  "activity.excluded.retry.desc": { id: "activity.excluded.retry.desc", domain: "activity", text: "阿光第二次拉依赖成功，第一次失败没打扰你", vars: [], tone: "", source: "设计稿 A02" },
  "activity.excluded.rollback": { id: "activity.excluded.rollback", domain: "activity", text: "自动回退了", vars: [], tone: "", source: "设计稿 A02" },
  "activity.excluded.rollback.desc": { id: "activity.excluded.rollback.desc", domain: "activity", text: "官网改版 v88 打不开，已自动退回 v87，旧版本继续在线", vars: [], tone: "", source: "设计稿 A02" },
  "activity.excluded.title": { id: "activity.excluded.title", domain: "activity", text: "这些没进\"要我处理\"", vars: [], tone: "", source: "设计稿 A02" },
  "activity.filter.actor": { id: "activity.filter.actor", domain: "activity", text: "谁做的", vars: [], tone: "", source: "动态中心产品会议 2026-08-28" },
  "activity.filter.clear": { id: "activity.filter.clear", domain: "activity", text: "清空筛选", vars: [], tone: "", source: "设计稿 A06" },
  "activity.filter.hint.project": { id: "activity.filter.hint.project", domain: "activity", text: "和全局筛选此项目结果一致", vars: [], tone: "", source: "设计稿 A05" },
  "activity.filter.hint.results": { id: "activity.filter.hint.results", domain: "activity", text: "{count} 条结果 · 已筛选", vars: ["count"], tone: "", source: "设计稿 A06" },
  "activity.filter.open": { id: "activity.filter.open", domain: "activity", text: "筛选", vars: [], tone: "", source: "设计稿 M04" },
  "activity.filter.search": { id: "activity.filter.search", domain: "activity", text: "搜项目、任务、SHA、域名、Agent", vars: [], tone: "", source: "设计稿 A01" },
  "activity.filter.search.disconnected": { id: "activity.filter.search.disconnected", domain: "activity", text: "搜索照常可用 —— 搜的是已经收到的那些", vars: [], tone: "", source: "设计稿 A07" },
  "activity.filter.search.project": { id: "activity.filter.search.project", domain: "activity", text: "在这个项目里搜", vars: [], tone: "", source: "设计稿 A05" },
  "activity.filter.status": { id: "activity.filter.status", domain: "activity", text: "当前结果", vars: [], tone: "", source: "动态中心产品会议 2026-08-28" },
  "activity.filter.time": { id: "activity.filter.time", domain: "activity", text: "时间", vars: [], tone: "", source: "设计稿 A06" },
  "activity.filter.time.earlier": { id: "activity.filter.time.earlier", domain: "activity", text: "更早", vars: [], tone: "", source: "设计稿 A06" },
  "activity.filter.time.today": { id: "activity.filter.time.today", domain: "activity", text: "今天", vars: [], tone: "", source: "设计稿 A06" },
  "activity.filter.time.week": { id: "activity.filter.time.week", domain: "activity", text: "近 7 天", vars: [], tone: "", source: "设计稿 A06" },
  "activity.filter.time.yesterday": { id: "activity.filter.time.yesterday", domain: "activity", text: "昨天", vars: [], tone: "", source: "设计稿 A06" },
  "activity.filter.type": { id: "activity.filter.type", domain: "activity", text: "发生了什么", vars: [], tone: "", source: "动态中心产品会议 2026-08-28" },
  "activity.follow.auto.tag": { id: "activity.follow.auto.tag", domain: "activity", text: "默认", vars: [], tone: "", source: "设计稿 A03" },
  "activity.follow.auto.title": { id: "activity.follow.auto.title", domain: "activity", text: "自动关注", vars: [], tone: "", source: "设计稿 A03" },
  "activity.follow.manual.tag": { id: "activity.follow.manual.tag", domain: "activity", text: "按需", vars: [], tone: "", source: "设计稿 A03" },
  "activity.follow.manual.title": { id: "activity.follow.manual.title", domain: "activity", text: "手动关注", vars: [], tone: "", source: "设计稿 A03" },
  "activity.follow.object.agent": { id: "activity.follow.object.agent", domain: "activity", text: "Agent", vars: [], tone: "", source: "设计稿 A03" },
  "activity.follow.object.project": { id: "activity.follow.object.project", domain: "activity", text: "项目", vars: [], tone: "", source: "设计稿 A03" },
  "activity.follow.object.resource": { id: "activity.follow.object.resource", domain: "activity", text: "资源", vars: [], tone: "", source: "设计稿 A03" },
  "activity.follow.object.site": { id: "activity.follow.object.site", domain: "activity", text: "站点", vars: [], tone: "", source: "设计稿 A03" },
  "activity.follow.object.task": { id: "activity.follow.object.task", domain: "activity", text: "任务", vars: [], tone: "", source: "设计稿 A03" },
  "activity.follow.source.assigned": { id: "activity.follow.source.assigned", domain: "activity", text: "自动 · 你派的活", vars: [], tone: "", source: "设计稿 A03" },
  "activity.follow.source.auto": { id: "activity.follow.source.auto", domain: "activity", text: "自动", vars: [], tone: "", source: "设计稿 A03" },
  "activity.follow.source.joined": { id: "activity.follow.source.joined", domain: "activity", text: "自动 · 你参与", vars: [], tone: "", source: "设计稿 A03" },
  "activity.follow.source.manual": { id: "activity.follow.source.manual", domain: "activity", text: "手动", vars: [], tone: "", source: "设计稿 A03" },
  "activity.follow.source.started": { id: "activity.follow.source.started", domain: "activity", text: "自动 · 你发起", vars: [], tone: "", source: "设计稿 A03" },
  "activity.follow.table.foot": { id: "activity.follow.table.foot", domain: "activity", text: "关注只改变这一页显示什么和通知你什么，不改变事件本身，也不改变你能看到哪些项目。", vars: [], tone: "", source: "设计稿 A03" },
  "activity.gate.entitlement": { id: "activity.gate.entitlement", domain: "activity", text: "权限配额或供应商到期", vars: [], tone: "", source: "设计稿 A02" },
  "activity.gate.needs_info": { id: "activity.gate.needs_info", domain: "activity", text: "补信息", vars: [], tone: "", source: "设计稿 A02" },
  "activity.gate.question": { id: "activity.gate.question", domain: "activity", text: "明确提问", vars: [], tone: "", source: "设计稿 A02" },
  "activity.gate.recovery_choice": { id: "activity.gate.recovery_choice", domain: "activity", text: "多个恢复方案", vars: [], tone: "", source: "设计稿 A02" },
  "activity.gate.red_confirm": { id: "activity.gate.red_confirm", domain: "activity", text: "红级确认", vars: [], tone: "", source: "设计稿 A02" },
  "activity.group.decide": { id: "activity.group.decide", domain: "activity", text: "等你决定 · {count}", vars: ["count"], tone: "", source: "设计稿 A02" },
  "activity.group.events": { id: "activity.group.events", domain: "activity", text: "{count} 条", vars: ["count"], tone: "", source: "设计稿 A17" },
  "activity.group.locked": { id: "activity.group.locked", domain: "activity", text: "固定 project_id", vars: [], tone: "", source: "设计稿 A05" },
  "activity.group.long": { id: "activity.group.long", domain: "activity", text: "长字段与多语言 · 截断规则", vars: [], tone: "", source: "设计稿 A17" },
  "activity.group.offline": { id: "activity.group.offline", domain: "activity", text: "断线前最后确认的", vars: [], tone: "", source: "设计稿 A07" },
  "activity.group.recovered": { id: "activity.group.recovered", domain: "activity", text: "断线期间发生的", vars: [], tone: "", source: "设计稿 A08" },
  "activity.group.recovered.meta": { id: "activity.group.recovered.meta", domain: "activity", text: "7 条中的 3 条", vars: [], tone: "", source: "设计稿 A08" },
  "activity.group.single": { id: "activity.group.single", domain: "activity", text: "单事件 —— 不是所有事都成线程", vars: [], tone: "", source: "设计稿 A17" },
  "activity.group.threads": { id: "activity.group.threads", domain: "activity", text: "{count} 个活动线程", vars: ["count"], tone: "", source: "设计稿 A01" },
  "activity.group.unclosed": { id: "activity.group.unclosed", domain: "activity", text: "这个线程没闭环", vars: [], tone: "", source: "设计稿 A12" },
  "activity.internal.desc": { id: "activity.internal.desc", domain: "activity", text: "token、心跳、轮询、命令逐行输出、自动保存、被正常拒绝的请求。", vars: [], tone: "", source: "设计稿 A01" },
  "activity.internal.title": { id: "activity.internal.title", domain: "activity", text: "这些不进动态", vars: [], tone: "", source: "设计稿 A01" },
  "activity.kind.activity": { id: "activity.kind.activity", domain: "activity", text: "动态", vars: [], tone: "", source: "动态与通知 2026-08-30" },
  "activity.kind.ops_alert": { id: "activity.kind.ops_alert", domain: "activity", text: "运维告警", vars: [], tone: "", source: "动态与通知 2026-08-30" },
  "activity.list.load_more": { id: "activity.list.load_more", domain: "activity", text: "加载更早动态", vars: [], tone: "", source: "动态中心分页交互" },
  "activity.list.loading_more": { id: "activity.list.loading_more", domain: "activity", text: "正在加载", vars: [], tone: "", source: "动态中心分页交互" },
  "activity.macos.title": { id: "activity.macos.title", domain: "activity", text: "动态 · NPC", vars: [], tone: "", source: "设计稿 A14" },
  "activity.narrow.order.detail": { id: "activity.narrow.order.detail", domain: "activity", text: "② 详情收到 360px", vars: [], tone: "", source: "设计稿 A13" },
  "activity.narrow.order.detail.desc": { id: "activity.narrow.order.detail.desc", domain: "activity", text: "380–480 的下限", vars: [], tone: "", source: "设计稿 A13" },
  "activity.narrow.order.detail.pill": { id: "activity.narrow.order.detail.pill", domain: "activity", text: "已收窄", vars: [], tone: "", source: "设计稿 A13" },
  "activity.narrow.order.list": { id: "activity.narrow.order.list", domain: "activity", text: "③ 列表变窄", vars: [], tone: "", source: "设计稿 A13" },
  "activity.narrow.order.list.desc": { id: "activity.narrow.order.list.desc", domain: "activity", text: "最后才动它。卡片第一层照常完整显示", vars: [], tone: "", source: "设计稿 A13" },
  "activity.narrow.order.nav": { id: "activity.narrow.order.nav", domain: "activity", text: "① 全局左栏先收起", vars: [], tone: "", source: "设计稿 A13" },
  "activity.narrow.order.nav.desc": { id: "activity.narrow.order.nav.desc", domain: "activity", text: "动态中心没有会话栏，收的是全局导航的次级区域", vars: [], tone: "", source: "设计稿 A13" },
  "activity.narrow.order.nav.pill": { id: "activity.narrow.order.nav.pill", domain: "activity", text: "已收起", vars: [], tone: "", source: "设计稿 A13" },
  "activity.narrow.order.note": { id: "activity.narrow.order.note", domain: "activity", text: "列表和详情始终是两条并列的轨道。窄不是把详情降级成遮挡式弹窗的理由。", vars: [], tone: "", source: "设计稿 A13" },
  "activity.narrow.order.title": { id: "activity.narrow.order.title", domain: "activity", text: "折叠顺序", vars: [], tone: "", source: "设计稿 A13" },
  "activity.narrow.sidecar_sub": { id: "activity.narrow.sidecar_sub", domain: "activity", text: "窄桌面下详情收到 360px，但仍然是布局轨道 —— 列表变窄，不被盖住。", vars: [], tone: "", source: "设计稿 A13" },
  "activity.offline.note.desc": { id: "activity.offline.note.desc", domain: "activity", text: "列表上还是断线前那一刻的事实，没有变旧也没有变假。重连之后会用游标把这段时间的事件补回来，不会重复也不会丢。", vars: [], tone: "", source: "设计稿 A07" },
  "activity.offline.note.title": { id: "activity.offline.note.title", domain: "activity", text: "暂时收不到最新动态，正在重连", vars: [], tone: "", source: "设计稿 A07" },
  "activity.omitted": { id: "activity.omitted", domain: "activity", text: "有 {count} 条记录缺少可读文案，原始事实仍保留。仅管理员可见。", vars: ["count"], tone: "", source: "设计稿 A11" },
  "activity.ops_alert.acknowledge": { id: "activity.ops_alert.acknowledge", domain: "activity", text: "这条我看过了", vars: [], tone: "", source: "OpenAPI acknowledgeAlert" },
  "activity.overview.see_all": { id: "activity.overview.see_all", domain: "activity", text: "查看全部动态", vars: [], tone: "", source: "设计稿 A05 / 项目概览 CTA" },
  "activity.page.subtitle": { id: "activity.page.subtitle", domain: "activity", text: "刚刚发生了什么、影响了谁、要不要你处理、结果是不是真的完成了。", vars: [], tone: "", source: "动态中心 PRD v2" },
  "activity.page.subtitle.narrow": { id: "activity.page.subtitle.narrow", domain: "activity", text: "1024px 下先收左栏，再给详情留位置。", vars: [], tone: "", source: "设计稿 A13" },
  "activity.page.subtitle.project": { id: "activity.page.subtitle.project", domain: "activity", text: "同一份事实，固定在这个项目上。没有项目切换器 —— 要看别的项目去全局动态。", vars: [], tone: "", source: "设计稿 A05" },
  "activity.page.title": { id: "activity.page.title", domain: "activity", text: "动态", vars: [], tone: "", source: "动态中心 PRD v2 / 设计稿 A01" },
  "activity.page.title.project": { id: "activity.page.title.project", domain: "activity", text: "{project} · 动态", vars: ["project"], tone: "", source: "设计稿 A05" },
  "activity.project.name.event2026": { id: "activity.project.name.event2026", domain: "activity", text: "活动页 2026", vars: [], tone: "", source: "设计稿 A01" },
  "activity.project.name.npcshop": { id: "activity.project.name.npcshop", domain: "activity", text: "NPC 商城", vars: [], tone: "", source: "设计稿 A01" },
  "activity.project.note.desc": { id: "activity.project.note.desc", domain: "activity", text: "概览是「这个项目怎么样了」，不是完整流水。要看全部从概览的「查看全部动态」进来。", vars: [], tone: "", source: "设计稿 A05" },
  "activity.project.note.overview": { id: "activity.project.note.overview", domain: "activity", text: "概览 / 这一页", vars: [], tone: "", source: "设计稿 A05" },
  "activity.project.note.overview.desc": { id: "activity.project.note.overview.desc", domain: "activity", text: "概览放最近 3–5 条 + 「查看全部动态」；这一页是完整事件流", vars: [], tone: "", source: "设计稿 A05" },
  "activity.project.note.title": { id: "activity.project.note.title", domain: "activity", text: "项目概览上只放最近 3 条", vars: [], tone: "", source: "设计稿 A05" },
  "activity.project.note.wont": { id: "activity.project.note.wont", domain: "activity", text: "不会有", vars: [], tone: "", source: "设计稿 A05" },
  "activity.project.note.wont.desc": { id: "activity.project.note.wont.desc", domain: "activity", text: "项目专属的第二张动态表、第二套筛选、第二个未读计数", vars: [], tone: "", source: "设计稿 A05" },
  "activity.recover.note.desc": { id: "activity.recover.note.desc", domain: "activity", text: "按 Last-Event-ID 续传，重复投递按 event_id 去重。补回来的插在正确时间位置，不是全堆在顶部闪一遍。", vars: [], tone: "", source: "设计稿 A08" },
  "activity.recover.note.title": { id: "activity.recover.note.title", domain: "activity", text: "已补回断线期间的 7 条动态", vars: [], tone: "", source: "设计稿 A08" },
  "activity.scope.all": { id: "activity.scope.all", domain: "activity", text: "全部范围", vars: [], tone: "", source: "动态中心产品会议 2026-08-28" },
  "activity.scope.all_projects": { id: "activity.scope.all_projects", domain: "activity", text: "全部范围", vars: [], tone: "", source: "设计稿 M04" },
  "activity.scope.label": { id: "activity.scope.label", domain: "activity", text: "范围", vars: [], tone: "", source: "设计稿 A01" },
  "activity.scope.pick": { id: "activity.scope.pick", domain: "activity", text: "选择项目…", vars: [], tone: "", source: "设计稿 A01" },
  "activity.scope.platform": { id: "activity.scope.platform", domain: "activity", text: "平台本身", vars: [], tone: "", source: "动态中心产品会议 2026-08-28" },
  "activity.scope.project": { id: "activity.scope.project", domain: "activity", text: "项目", vars: [], tone: "", source: "设计稿 A01" },
  "activity.search.group": { id: "activity.search.group", domain: "activity", text: "搜 a3f91c2 的结果", vars: [], tone: "", source: "设计稿 A06" },
  "activity.search.meta": { id: "activity.search.meta", domain: "activity", text: "同一线程的 3 个节点", vars: [], tone: "", source: "设计稿 A06" },
  "activity.sha.note.desc": { id: "activity.sha.note.desc", domain: "activity", text: "部署返回成功只说明部署动作没报错，不说明线上跑的是你要的代码。", vars: [], tone: "", source: "设计稿 A12" },
  "activity.sha.note.title": { id: "activity.sha.note.title", domain: "activity", text: "这一条为什么不显示\"已上线\"", vars: [], tone: "", source: "设计稿 A12" },
  "activity.sheet.apply": { id: "activity.sheet.apply", domain: "activity", text: "看结果", vars: [], tone: "", source: "设计稿 M04" },
  "activity.sheet.clear": { id: "activity.sheet.clear", domain: "activity", text: "清空", vars: [], tone: "", source: "设计稿 M04" },
  "activity.sheet.count": { id: "activity.sheet.count", domain: "activity", text: "{count} 条", vars: ["count"], tone: "", source: "设计稿 M04" },
  "activity.sheet.current": { id: "activity.sheet.current", domain: "activity", text: "当前", vars: [], tone: "", source: "设计稿 M04" },
  "activity.sheet.event2026.sub": { id: "activity.sheet.event2026.sub", domain: "activity", text: "1 条今天 · 未知", vars: [], tone: "", source: "设计稿 M04" },
  "activity.sheet.npcshop.sub": { id: "activity.sheet.npcshop.sub", domain: "activity", text: "8 条今天", vars: [], tone: "", source: "设计稿 M04" },
  "activity.sheet.project_search": { id: "activity.sheet.project_search", domain: "activity", text: "项目 · 搜索并单选", vars: [], tone: "", source: "设计稿 M04" },
  "activity.sheet.status.bundle": { id: "activity.sheet.status.bundle", domain: "activity", text: "失败 · 回滚 · 未知", vars: [], tone: "", source: "设计稿 M04" },
  "activity.sheet.sub": { id: "activity.sheet.sub", domain: "activity", text: "每项筛选只选一个。选完点「看结果」，条件会保留在页面地址里。", vars: [], tone: "", source: "设计稿 M04" },
  "activity.stages.folded": { id: "activity.stages.folded", domain: "activity", text: "中间 {count} 个成功步骤已折叠", vars: ["count"], tone: "", source: "设计稿 A04" },
  "activity.states.col.mean": { id: "activity.states.col.mean", domain: "activity", text: "用户看到的意思", vars: [], tone: "", source: "设计稿 A09" },
  "activity.states.col.proof": { id: "activity.states.col.proof", domain: "activity", text: "靠什么证明", vars: [], tone: "", source: "设计稿 A09" },
  "activity.states.col.status": { id: "activity.states.col.status", domain: "activity", text: "状态", vars: [], tone: "", source: "设计稿 A09" },
  "activity.states.col.wrong": { id: "activity.states.col.wrong", domain: "activity", text: "写错会怎样", vars: [], tone: "", source: "设计稿 A09" },
  "activity.states.label": { id: "activity.states.label", domain: "activity", text: "十二种状态", vars: [], tone: "", source: "设计稿 A09" },
  "activity.states.meta": { id: "activity.states.meta", domain: "activity", text: "最右列是给实现看的：每种状态最容易被写成什么错样子", vars: [], tone: "", source: "设计稿 A09" },
  "activity.states.subtitle": { id: "activity.states.subtitle", domain: "activity", text: "动态中心只呈现能证明的状态。这十二个的文案是钉死的，实现时不许改写。", vars: [], tone: "", source: "设计稿 A09" },
  "activity.states.tag": { id: "activity.states.tag", domain: "activity", text: "PRD §7.1", vars: [], tone: "", source: "设计稿 A09" },
  "activity.states.title": { id: "activity.states.title", domain: "activity", text: "状态语义", vars: [], tone: "", source: "设计稿 A09" },
  "activity.status.awaiting_decision": { id: "activity.status.awaiting_decision", domain: "activity", text: "等你决定", vars: [], tone: "", source: "设计稿 A09" },
  "activity.status.awaiting_dependency": { id: "activity.status.awaiting_dependency", domain: "activity", text: "等依赖", vars: [], tone: "", source: "设计稿 A09" },
  "activity.status.completed": { id: "activity.status.completed", domain: "activity", text: "已完成", vars: [], tone: "", source: "设计稿 A09" },
  "activity.status.disconnected": { id: "activity.status.disconnected", domain: "activity", text: "连接中断", vars: [], tone: "", source: "设计稿 A09" },
  "activity.status.failed": { id: "activity.status.failed", domain: "activity", text: "失败", vars: [], tone: "", source: "设计稿 A09" },
  "activity.status.platform_held": { id: "activity.status.platform_held", domain: "activity", text: "平台挂起", vars: [], tone: "", source: "设计稿 A09" },
  "activity.status.platform_held.hint": { id: "activity.status.platform_held.hint", domain: "activity", text: "平台故障停了，修好会自动恢复", vars: [], tone: "", source: "设计稿 A09 / A16" },
  "activity.status.platform_held.no_resubmit": { id: "activity.status.platform_held.no_resubmit", domain: "activity", text: "你不用重新提交，重复提交也不会加快。", vars: [], tone: "", source: "设计稿 A16" },
  "activity.status.production_verified": { id: "activity.status.production_verified", domain: "activity", text: "已上线", vars: [], tone: "", source: "设计稿 A09" },
  "activity.status.queued": { id: "activity.status.queued", domain: "activity", text: "排队中", vars: [], tone: "", source: "设计稿 A09" },
  "activity.status.recovering": { id: "activity.status.recovering", domain: "activity", text: "恢复中", vars: [], tone: "", source: "设计稿 A09" },
  "activity.status.rollback.executed": { id: "activity.status.rollback.executed", domain: "activity", text: "已执行并恢复", vars: [], tone: "", source: "设计稿 A09" },
  "activity.status.rollback.registered": { id: "activity.status.rollback.registered", domain: "activity", text: "已登记恢复点", vars: [], tone: "", source: "设计稿 A09" },
  "activity.status.rolled_back": { id: "activity.status.rolled_back", domain: "activity", text: "已回滚", vars: [], tone: "", source: "设计稿 A09" },
  "activity.status.running": { id: "activity.status.running", domain: "activity", text: "进行中", vars: [], tone: "", source: "设计稿 A09" },
  "activity.status.unknown": { id: "activity.status.unknown", domain: "activity", text: "未知", vars: [], tone: "", source: "设计稿 A09" },
  "activity.status.unknown.hint": { id: "activity.status.unknown.hint", domain: "activity", text: "目前拿不到足够证据，状态未知", vars: [], tone: "", source: "设计稿 A11" },
  "activity.stream.disconnected": { id: "activity.stream.disconnected", domain: "activity", text: "暂时收不到最新动态，正在重连。最后更新于 {time}。", vars: ["time"], tone: "", source: "设计稿 A07" },
  "activity.stream.recovered": { id: "activity.stream.recovered", domain: "activity", text: "已补回断线期间的 {count} 条动态。", vars: ["count"], tone: "", source: "设计稿 A08" },
  "activity.stream.recovered.deduped": { id: "activity.stream.recovered.deduped", domain: "activity", text: "已按事件去重 {count} 条。", vars: ["count"], tone: "", source: "设计稿 A08" },
  "activity.stream.reset": { id: "activity.stream.reset", domain: "activity", text: "实时流需要重新对齐，正在按已保存的位置重建。", vars: [], tone: "", source: "动态中心 PRD v2" },
  "activity.summary.conversation.created": { id: "activity.summary.conversation.created", domain: "activity", text: "{actor} 开了会话 {title}", vars: ["actor", "title"], tone: "", source: "动态中心诚实生产者" },
  "activity.summary.conversation.waiting": { id: "activity.summary.conversation.waiting", domain: "activity", text: "{title} 在等你回话", vars: ["title"], tone: "", source: "动态中心诚实生产者" },
  "activity.summary.fast_delivery.production_verified": { id: "activity.summary.fast_delivery.production_verified", domain: "activity", text: "正式环境已经验过这一版", vars: [], tone: "", source: "动态中心诚实生产者" },
  "activity.summary.host.assigned": { id: "activity.summary.host.assigned", domain: "activity", text: "{actor} 把机器 {host} 挂到了 {project}", vars: ["actor", "host", "project"], tone: "", source: "资源模块诚实生产者" },
  "activity.summary.host.unassigned": { id: "activity.summary.host.unassigned", domain: "activity", text: "{actor} 把机器 {host} 从 {project} 卸了下来", vars: ["actor", "host", "project"], tone: "", source: "资源模块诚实生产者" },
  "activity.summary.inspection.completed": { id: "activity.summary.inspection.completed", domain: "activity", text: "巡检已经看过这一版", vars: [], tone: "", source: "异步巡检 batch 1" },
  "activity.summary.project.archived": { id: "activity.summary.project.archived", domain: "activity", text: "{actor} 把项目 {name} 收起来了", vars: ["actor", "name"], tone: "", source: "动态中心诚实生产者" },
  "activity.summary.project.created": { id: "activity.summary.project.created", domain: "activity", text: "{actor} 建了项目 {name}", vars: ["actor", "name"], tone: "", source: "动态中心诚实生产者" },
  "activity.summary.task.completed": { id: "activity.summary.task.completed", domain: "activity", text: "{title} 做完了", vars: ["title"], tone: "", source: "动态中心诚实生产者" },
  "activity.summary.task.created": { id: "activity.summary.task.created", domain: "activity", text: "{actor} 建了开发任务 {title}", vars: ["actor", "title"], tone: "", source: "动态中心诚实生产者" },
  "activity.summary.task.failed": { id: "activity.summary.task.failed", domain: "activity", text: "{title} 失败了", vars: ["title"], tone: "", source: "动态中心诚实生产者" },
  "activity.summary.task.held": { id: "activity.summary.task.held", domain: "activity", text: "{title} 被平台挂起", vars: ["title"], tone: "", source: "动态中心诚实生产者" },
  "activity.summary.task.running": { id: "activity.summary.task.running", domain: "activity", text: "{actor} 正在做 {title}", vars: ["actor", "title"], tone: "", source: "动态中心诚实生产者" },
  "activity.summary.task.waiting": { id: "activity.summary.task.waiting", domain: "activity", text: "{title} 等你决定", vars: ["title"], tone: "", source: "动态中心诚实生产者" },
  "activity.summary.team.joined": { id: "activity.summary.team.joined", domain: "activity", text: "{actor} 加入了团队", vars: ["actor"], tone: "", source: "动态中心诚实生产者" },
  "activity.thread.updates": { id: "activity.thread.updates", domain: "activity", text: "{count} 条更新", vars: ["count"], tone: "", source: "动态中心产品会议 2026-08-28" },
  "activity.type.conversation": { id: "activity.type.conversation", domain: "activity", text: "会话", vars: [], tone: "", source: "动态中心 PRD v2" },
  "activity.type.lulu": { id: "activity.type.lulu", domain: "activity", text: "Lulu", vars: [], tone: "", source: "动态中心 PRD v2" },
  "activity.type.project": { id: "activity.type.project", domain: "activity", text: "项目", vars: [], tone: "", source: "动态中心 PRD v2" },
  "activity.type.release": { id: "activity.type.release", domain: "activity", text: "发布", vars: [], tone: "", source: "动态中心 PRD v2" },
  "activity.type.resource": { id: "activity.type.resource", domain: "activity", text: "资源", vars: [], tone: "", source: "动态中心 PRD v2" },
  "activity.type.site": { id: "activity.type.site", domain: "activity", text: "静态网页", vars: [], tone: "", source: "动态中心 PRD v2" },
  "activity.type.task": { id: "activity.type.task", domain: "activity", text: "开发", vars: [], tone: "", source: "动态中心 PRD v2" },
  "activity.type.team": { id: "activity.type.team", domain: "activity", text: "团队", vars: [], tone: "", source: "动态中心 PRD v2" },
  "activity.unclosed": { id: "activity.unclosed", domain: "activity", text: "未闭环", vars: [], tone: "", source: "设计稿 A12" },
  "activity.unclosed.hint": { id: "activity.unclosed.hint", domain: "activity", text: "候选、主干和部署的版本对不上，还不能写成已上线。", vars: [], tone: "", source: "设计稿 A12" },
  "activity.unread": { id: "activity.unread", domain: "activity", text: "未读", vars: [], tone: "", source: "设计稿 A01" },
  "activity.unread.count": { id: "activity.unread.count", domain: "activity", text: "{count} 条未读", vars: ["count"], tone: "", source: "设计稿 A01" },
  "activity.view.action": { id: "activity.view.action", domain: "activity", text: "需我处理", vars: [], tone: "", source: "动态中心产品会议 2026-08-28" },
  "activity.view.action.subtitle": { id: "activity.view.action.subtitle", domain: "activity", text: "只有这五类进这里：Lulu 或 Agent 问你、红级操作要你确认、缺信息要你补、失败后有多个恢复方案要你选、权限配额付款或供应商到期要你处理。", vars: [], tone: "", source: "设计稿 A02" },
  "activity.view.all": { id: "activity.view.all", domain: "activity", text: "全部动态", vars: [], tone: "", source: "动态中心产品会议 2026-08-28" },
  "activity.view.following": { id: "activity.view.following", domain: "activity", text: "我关注的", vars: [], tone: "", source: "动态中心产品会议 2026-08-28" },
  "activity.view.following.subtitle": { id: "activity.view.following.subtitle", domain: "activity", text: "你参与的项目和你发起的任务默认关注。取消关注不影响权限，只改变这里显示什么。", vars: [], tone: "", source: "设计稿 A03" },
  "activity.view.important": { id: "activity.view.important", domain: "activity", text: "重要进展", vars: [], tone: "", source: "动态中心产品会议 2026-08-28" },
  "activity.view.important.subtitle": { id: "activity.view.important.subtitle", domain: "activity", text: "默认只看会影响项目推进、发布结果或需要关注的变化，普通过程仍可在全部动态里查看。", vars: [], tone: "", source: "动态中心产品会议 2026-08-28" },
  "ai_os.action.approve_red": { id: "ai_os.action.approve_red", domain: "ai_os", text: "我确认，去做吧", vars: [], tone: "danger", source: "2026-08-20 AI OS 合同" },
  "ai_os.action.cancel": { id: "ai_os.action.cancel", domain: "ai_os", text: "先不做", vars: [], tone: "", source: "2026-08-20 AI OS 合同" },
  "ai_os.action.create": { id: "ai_os.action.create", domain: "ai_os", text: "提一件要改的事", vars: [], tone: "", source: "2026-08-20 AI OS 合同" },
  "ai_os.action.disable_learning": { id: "ai_os.action.disable_learning", domain: "ai_os", text: "别再用这条经验", vars: [], tone: "", source: "蓝图 §7 OS-B" },
  "ai_os.action.retry": { id: "ai_os.action.retry", domain: "ai_os", text: "再来一次", vars: [], tone: "", source: "2026-08-20 AI OS 合同" },
  "ai_os.action.submit": { id: "ai_os.action.submit", domain: "ai_os", text: "记下来", vars: [], tone: "", source: "2026-08-20 AI OS 合同" },
  "ai_os.action.submitted": { id: "ai_os.action.submitted", domain: "ai_os", text: "记下了。要不要开工还得再说一步，我不会自己就动手。", vars: [], tone: "ok", source: "2026-08-20 AI OS 合同" },
  "ai_os.action.submitting": { id: "ai_os.action.submitting", domain: "ai_os", text: "我在记", vars: [], tone: "", source: "2026-08-20 AI OS 合同" },
  "ai_os.action.view_evidence": { id: "ai_os.action.view_evidence", domain: "ai_os", text: "看我凭什么这么说", vars: [], tone: "", source: "2026-08-20 AI OS 合同" },
  "ai_os.conflict.already_submitted": { id: "ai_os.conflict.already_submitted", domain: "ai_os", text: "这条我已经记过一次了，没有重复记。", vars: [], tone: "ok", source: "2026-08-20 AI OS 合同" },
  "ai_os.conflict.changed_elsewhere": { id: "ai_os.conflict.changed_elsewhere", domain: "ai_os", text: "你看的时候，这件事已经被改过了。我把新的调出来了，你再看一眼。", vars: [], tone: "warn", source: "2026-08-20 AI OS 合同" },
  "ai_os.conflict.same_key_different_content": { id: "ai_os.conflict.same_key_different_content", domain: "ai_os", text: "这条跟我之前记下的那件事对不上。我先不动，你确认一下是不是两件事。", vars: [], tone: "warn", source: "2026-08-20 AI OS 合同" },
  "ai_os.empty.evaluations": { id: "ai_os.empty.evaluations", domain: "ai_os", text: "这件事我还没开始验。", vars: [], tone: "", source: "2026-08-20 AI OS 合同" },
  "ai_os.empty.learning": { id: "ai_os.empty.learning", domain: "ai_os", text: "我还没攒下什么经验。只有在正式环境上真验过的，我才会记。", vars: [], tone: "", source: "蓝图 §3.6" },
  "ai_os.empty.modules": { id: "ai_os.empty.modules", domain: "ai_os", text: "这个项目还没接进来什么东西让我盯。", vars: [], tone: "", source: "2026-08-20 AI OS 合同" },
  "ai_os.empty.proposals": { id: "ai_os.empty.proposals", domain: "ai_os", text: "这个项目现在没什么要改的，我继续盯着。", vars: [], tone: "ok", source: "2026-08-20 AI OS 合同" },
  "ai_os.error.create_failed": { id: "ai_os.error.create_failed", domain: "ai_os", text: "这条我没记下来，你刚填的还在，不用重打。", vars: [], tone: "warn", source: "2026-08-20 AI OS 合同" },
  "ai_os.error.detail_failed": { id: "ai_os.error.detail_failed", domain: "ai_os", text: "这件事的详情我一时调不出来，列表上那几行还是准的。", vars: [], tone: "warn", source: "2026-08-20 AI OS 合同" },
  "ai_os.error.list_failed": { id: "ai_os.error.list_failed", domain: "ai_os", text: "我一时读不到这个项目的记录。这不影响正在跑的事，我过一会儿自己再试。", vars: [], tone: "warn", source: "2026-08-20 AI OS 合同" },
  "ai_os.error.missing_evidence": { id: "ai_os.error.missing_evidence", domain: "ai_os", text: "还差一条能查回去的记录。没有证据我只是在猜。", vars: [], tone: "warn", source: "蓝图 §3.4" },
  "ai_os.error.missing_rollback": { id: "ai_os.error.missing_rollback", domain: "ai_os", text: "还差一条「不对的话怎么退回去」。退不回去的改动我不会做。", vars: [], tone: "warn", source: "CLAUDE.md §2 第 3 条" },
  "ai_os.error.missing_user_value": { id: "ai_os.error.missing_user_value", domain: "ai_os", text: "还差一句「做完之后谁会感觉到不一样」。写不出来的话，这件事多半不值得我自己去做。", vars: [], tone: "warn", source: "蓝图 §3.4" },
  "ai_os.error.module_gone": { id: "ai_os.error.module_gone", domain: "ai_os", text: "这一部分已经不在这个项目里了，这条提案我不能接着走。", vars: [], tone: "warn", source: "2026-08-20 AI OS 合同" },
  "ai_os.error.red_needs_click": { id: "ai_os.error.red_needs_click", domain: "ai_os", text: "这件事碰到钱了，我不能替你把「要你点一下」这一项关掉。", vars: [], tone: "danger", source: "蓝图 §5" },
  "ai_os.eval.compare": { id: "ai_os.eval.compare", domain: "ai_os", text: "改之前 {before}，改之后 {after}", vars: ["after", "before"], tone: "", source: "蓝图 §3.6" },
  "ai_os.eval.degraded": { id: "ai_os.eval.degraded", domain: "ai_os", text: "过是过了，但比原来差", vars: [], tone: "warn", source: "2026-08-20 AI OS 合同" },
  "ai_os.eval.failed": { id: "ai_os.eval.failed", domain: "ai_os", text: "没过", vars: [], tone: "danger", source: "2026-08-20 AI OS 合同" },
  "ai_os.eval.heading": { id: "ai_os.eval.heading", domain: "ai_os", text: "我验了哪些", vars: [], tone: "", source: "蓝图 §3.3" },
  "ai_os.eval.negative_cases": { id: "ai_os.eval.negative_cases", domain: "ai_os", text: "我还试了 {count} 种「本来就该被拦住」的情况，都拦住了。", vars: ["count"], tone: "ok", source: "蓝图 §3.3" },
  "ai_os.eval.negative_cases_failed": { id: "ai_os.eval.negative_cases_failed", domain: "ai_os", text: "有 {count} 种本该被拦住的情况没拦住，我停下了。", vars: ["count"], tone: "danger", source: "蓝图 §3.3" },
  "ai_os.eval.passed": { id: "ai_os.eval.passed", domain: "ai_os", text: "都过了", vars: [], tone: "ok", source: "2026-08-20 AI OS 合同" },
  "ai_os.eval.pending": { id: "ai_os.eval.pending", domain: "ai_os", text: "还在跑", vars: [], tone: "neutral", source: "2026-08-20 AI OS 合同" },
  "ai_os.evidence.candidate": { id: "ai_os.evidence.candidate", domain: "ai_os", text: "只在隔离环境里试过", vars: [], tone: "neutral", source: "蓝图 §3.3" },
  "ai_os.evidence.candidate.detail": { id: "ai_os.evidence.candidate.detail", domain: "ai_os", text: "测试跑过了，但还没有真的发到任何地方，也就还说明不了线上会怎样。", vars: [], tone: "", source: "蓝图 §4" },
  "ai_os.evidence.frozen": { id: "ai_os.evidence.frozen", domain: "ai_os", text: "这条证据已经有经验靠着它了，我不会再改它的结论。", vars: [], tone: "", source: "2026-08-20 AI OS 合同" },
  "ai_os.evidence.heading": { id: "ai_os.evidence.heading", domain: "ai_os", text: "这件事验到哪一步了", vars: [], tone: "", source: "蓝图 §3.3" },
  "ai_os.evidence.not_enough_to_learn": { id: "ai_os.evidence.not_enough_to_learn", domain: "ai_os", text: "还没在正式环境上验过，所以这条我不会记成经验。", vars: [], tone: "neutral", source: "蓝图 §3.6" },
  "ai_os.evidence.preview_verified": { id: "ai_os.evidence.preview_verified", domain: "ai_os", text: "在预览环境上真跑通了", vars: [], tone: "ok", source: "蓝图 §3.3" },
  "ai_os.evidence.preview_verified.detail": { id: "ai_os.evidence.preview_verified.detail", domain: "ai_os", text: "预览环境上过了同一份检查。正式环境的量和数据不一样，所以还得再验一次。", vars: [], tone: "", source: "蓝图 §3.3" },
  "ai_os.evidence.production_verified": { id: "ai_os.evidence.production_verified", domain: "ai_os", text: "正式环境上真的验过了", vars: [], tone: "ok", source: "蓝图 §3.3" },
  "ai_os.evidence.production_verified.detail": { id: "ai_os.evidence.production_verified.detail", domain: "ai_os", text: "同一份代码发到正式环境，真的跑了一遍业务检查，而且是跑完的。", vars: [], tone: "", source: "蓝图 §4" },
  "ai_os.field.acceptance": { id: "ai_os.field.acceptance", domain: "ai_os", text: "怎么算做好了", vars: [], tone: "", source: "蓝图 §3.4" },
  "ai_os.field.acceptance.hint": { id: "ai_os.field.acceptance.hint", domain: "ai_os", text: "每一条写成能检查的结果，别写「变快一点」。", vars: [], tone: "", source: "2026-08-20 AI OS 合同" },
  "ai_os.field.budget": { id: "ai_os.field.budget", domain: "ai_os", text: "最多花多少", vars: [], tone: "", source: "蓝图 §2.2" },
  "ai_os.field.budget.hint": { id: "ai_os.field.budget.hint", domain: "ai_os", text: "时间、次数、花销，写一个上限就行，到了我就停。", vars: [], tone: "", source: "2026-08-20 AI OS 合同" },
  "ai_os.field.forbidden_boundaries": { id: "ai_os.field.forbidden_boundaries", domain: "ai_os", text: "哪些地方不许碰", vars: [], tone: "", source: "蓝图 §3.4" },
  "ai_os.field.goal": { id: "ai_os.field.goal", domain: "ai_os", text: "想达到什么", vars: [], tone: "", source: "蓝图 §3.4" },
  "ai_os.field.impact_audience": { id: "ai_os.field.impact_audience", domain: "ai_os", text: "影响的是谁", vars: [], tone: "", source: "2026-08-20 AI OS 合同（补 OS-B 字段名）" },
  "ai_os.field.module": { id: "ai_os.field.module", domain: "ai_os", text: "是哪一部分的事", vars: [], tone: "", source: "2026-08-20 AI OS 合同" },
  "ai_os.field.owner_stream": { id: "ai_os.field.owner_stream", domain: "ai_os", text: "这件事归谁做", vars: [], tone: "", source: "蓝图 §3.4" },
  "ai_os.field.problem_evidence": { id: "ai_os.field.problem_evidence", domain: "ai_os", text: "凭什么说它有问题", vars: [], tone: "", source: "蓝图 §3.4" },
  "ai_os.field.problem_evidence.hint": { id: "ai_os.field.problem_evidence.hint", domain: "ai_os", text: "至少给一条能查回去的记录。没有证据的改进是猜的。", vars: [], tone: "", source: "蓝图 §3.4" },
  "ai_os.field.requires_human_click": { id: "ai_os.field.requires_human_click", domain: "ai_os", text: "做之前要我先问你一声", vars: [], tone: "", source: "2026-08-20 AI OS 合同" },
  "ai_os.field.requires_human_click.locked": { id: "ai_os.field.requires_human_click.locked", domain: "ai_os", text: "这件事碰到钱了，必须你点，取消不掉。", vars: [], tone: "danger", source: "2026-08-20 AI OS 合同" },
  "ai_os.field.risk_level": { id: "ai_os.field.risk_level", domain: "ai_os", text: "这件事有多大", vars: [], tone: "", source: "蓝图 §5" },
  "ai_os.field.rollback": { id: "ai_os.field.rollback", domain: "ai_os", text: "不对的话怎么退回去", vars: [], tone: "", source: "蓝图 §2.2" },
  "ai_os.field.rollback.hint": { id: "ai_os.field.rollback.hint", domain: "ai_os", text: "必填。退不回去的改动我不会自己做。", vars: [], tone: "", source: "CLAUDE.md §2 第 3 条" },
  "ai_os.field.stop_conditions": { id: "ai_os.field.stop_conditions", domain: "ai_os", text: "什么情况下就别做了", vars: [], tone: "", source: "蓝图 §2.2" },
  "ai_os.field.stop_conditions.hint": { id: "ai_os.field.stop_conditions.hint", domain: "ai_os", text: "至少一条。没有停下来的条件，这件事就可能一直做下去。", vars: [], tone: "", source: "蓝图 §2.2" },
  "ai_os.field.title": { id: "ai_os.field.title", domain: "ai_os", text: "一句话说这是什么事", vars: [], tone: "", source: "2026-08-20 AI OS 合同" },
  "ai_os.field.user_value": { id: "ai_os.field.user_value", domain: "ai_os", text: "做完之后谁会感觉到不一样", vars: [], tone: "", source: "蓝图 §3.4" },
  "ai_os.field.user_value.hint": { id: "ai_os.field.user_value.hint", domain: "ai_os", text: "用大白话写，比如「下单卡住的情况会消失」。", vars: [], tone: "", source: "2026-08-20 AI OS 合同" },
  "ai_os.learning.active": { id: "ai_os.learning.active", domain: "ai_os", text: "这条现在管用", vars: [], tone: "ok", source: "2026-08-20 AI OS 合同" },
  "ai_os.learning.disabled": { id: "ai_os.learning.disabled", domain: "ai_os", text: "这条我关掉了，因为 {reason}", vars: ["reason"], tone: "neutral", source: "蓝图 §3.6" },
  "ai_os.learning.expired_state": { id: "ai_os.learning.expired_state", domain: "ai_os", text: "这条到期了，我先不用它", vars: [], tone: "neutral", source: "2026-08-20 AI OS 合同" },
  "ai_os.learning.expires": { id: "ai_os.learning.expires", domain: "ai_os", text: "到 {when} 我会重新验一次，不再默认它还成立。", vars: ["when"], tone: "", source: "蓝图 §3.6" },
  "ai_os.learning.rolled_back_state": { id: "ai_os.learning.rolled_back_state", domain: "ai_os", text: "这条跟着一次回退作废了", vars: [], tone: "neutral", source: "2026-08-20 AI OS 合同" },
  "ai_os.learning.scope": { id: "ai_os.learning.scope", domain: "ai_os", text: "这条经验只在 {where} 用得上", vars: ["where"], tone: "", source: "蓝图 §3.6" },
  "ai_os.loading.detail": { id: "ai_os.loading.detail", domain: "ai_os", text: "我在把这件事的来龙去脉理出来", vars: [], tone: "", source: "2026-08-20 AI OS 合同" },
  "ai_os.loading.evidence": { id: "ai_os.loading.evidence", domain: "ai_os", text: "我在把证据调出来", vars: [], tone: "", source: "2026-08-20 AI OS 合同" },
  "ai_os.loading.list": { id: "ai_os.loading.list", domain: "ai_os", text: "我在翻这个项目最近的记录", vars: [], tone: "", source: "2026-08-20 AI OS 合同" },
  "ai_os.loading.submitting": { id: "ai_os.loading.submitting", domain: "ai_os", text: "我在记下来", vars: [], tone: "", source: "2026-08-20 AI OS 合同" },
  "ai_os.module.heading": { id: "ai_os.module.heading", domain: "ai_os", text: "我在管的部分", vars: [], tone: "", source: "2026-08-20 AI OS 合同" },
  "ai_os.module.no_rollback": { id: "ai_os.module.no_rollback", domain: "ai_os", text: "这部分我还说不出怎么退回去，所以不会自己动它。", vars: [], tone: "warn", source: "蓝图 §3.1" },
  "ai_os.module.owner": { id: "ai_os.module.owner", domain: "ai_os", text: "{name} 归 {owner} 管", vars: ["name", "owner"], tone: "", source: "2026-08-20 AI OS 合同" },
  "ai_os.module.state.active": { id: "ai_os.module.state.active", domain: "ai_os", text: "我盯着", vars: [], tone: "ok", source: "2026-08-20 AI OS 合同" },
  "ai_os.module.state.deprecated": { id: "ai_os.module.state.deprecated", domain: "ai_os", text: "准备不用了，我先不动它", vars: [], tone: "neutral", source: "2026-08-20 AI OS 合同" },
  "ai_os.module.state.retired": { id: "ai_os.module.state.retired", domain: "ai_os", text: "已经不用了", vars: [], tone: "neutral", source: "2026-08-20 AI OS 合同" },
  "ai_os.proposal.auto_note": { id: "ai_os.proposal.auto_note", domain: "ai_os", text: "这条我会自己做完，做完告诉你结果。", vars: [], tone: "neutral", source: "CLAUDE.md §2 第 1 条" },
  "ai_os.proposal.evaluation_degraded.acceptance": { id: "ai_os.proposal.evaluation_degraded.acceptance", domain: "ai_os", text: "{module} 的 {suite} 这项检查回到变差之前的水平，而且在正式环境上验过。", vars: ["module", "suite"], tone: "", source: "2026-08-20 规划器规则表（evaluation-degraded）" },
  "ai_os.proposal.evaluation_degraded.goal": { id: "ai_os.proposal.evaluation_degraded.goal", domain: "ai_os", text: "把 {module} 的 {suite} 这项检查拉回原来的水平", vars: ["module", "suite"], tone: "", source: "2026-08-20 规划器规则表（evaluation-degraded）" },
  "ai_os.proposal.evaluation_degraded.impact_audience": { id: "ai_os.proposal.evaluation_degraded.impact_audience", domain: "ai_os", text: "用到 {module} 这部分的人现在会觉得慢一点或者偶尔不顺，还不至于用不了。", vars: ["module"], tone: "", source: "2026-08-20 规划器规则表（evaluation-degraded）" },
  "ai_os.proposal.evaluation_degraded.title": { id: "ai_os.proposal.evaluation_degraded.title", domain: "ai_os", text: "{module} 还能用，但比原来差了", vars: ["module"], tone: "warn", source: "2026-08-20 规划器规则表（evaluation-degraded）" },
  "ai_os.proposal.evaluation_degraded.user_value": { id: "ai_os.proposal.evaluation_degraded.user_value", domain: "ai_os", text: "现在还没坏，但这么放着多半会继续往下滑，等到真出事就不是小修小补了。", vars: [], tone: "", source: "2026-08-20 规划器规则表（evaluation-degraded）" },
  "ai_os.proposal.evaluation_failed.acceptance": { id: "ai_os.proposal.evaluation_failed.acceptance", domain: "ai_os", text: "{module} 的 {suite} 这项检查在正式环境上重新跑过一次，而且过了。", vars: ["module", "suite"], tone: "", source: "2026-08-20 规划器规则表（evaluation-failed）" },
  "ai_os.proposal.evaluation_failed.goal": { id: "ai_os.proposal.evaluation_failed.goal", domain: "ai_os", text: "让 {module} 的 {suite} 这项检查重新通过", vars: ["module", "suite"], tone: "", source: "2026-08-20 规划器规则表（evaluation-failed）" },
  "ai_os.proposal.evaluation_failed.impact_audience": { id: "ai_os.proposal.evaluation_failed.impact_audience", domain: "ai_os", text: "暂时还没人受影响——{module} 本身没出事，是拦它出事的那道检查先坏了。", vars: ["module"], tone: "", source: "2026-08-20 规划器规则表（evaluation-failed）" },
  "ai_os.proposal.evaluation_failed.title": { id: "ai_os.proposal.evaluation_failed.title", domain: "ai_os", text: "{module} 的自动检查没过", vars: ["module"], tone: "warn", source: "2026-08-20 规划器规则表（evaluation-failed）" },
  "ai_os.proposal.evaluation_failed.user_value": { id: "ai_os.proposal.evaluation_failed.user_value", domain: "ai_os", text: "这项检查是拦住线上出问题的最后一道。它坏着的时候，我不敢再自己放行 {module} 的改动。", vars: ["module"], tone: "", source: "2026-08-20 规划器规则表（evaluation-failed）" },
  "ai_os.proposal.found_at": { id: "ai_os.proposal.found_at", domain: "ai_os", text: "我在 {when} 发现的", vars: ["when"], tone: "", source: "2026-08-20 AI OS 合同" },
  "ai_os.proposal.impact": { id: "ai_os.proposal.impact", domain: "ai_os", text: "影响的是 {who}", vars: ["who"], tone: "", source: "CLAUDE.md §3" },
  "ai_os.proposal.no_task_yet": { id: "ai_os.proposal.no_task_yet", domain: "ai_os", text: "还没派活，等这条定下来我再开。", vars: [], tone: "", source: "2026-08-20 AI OS 合同" },
  "ai_os.proposal.stop.attempts_exhausted": { id: "ai_os.proposal.stop.attempts_exhausted", domain: "ai_os", text: "同一件事连着几次都没做成，我就停下来交给你，不自己一直试下去。", vars: [], tone: "", source: "2026-08-20 规划器规则表（两条规则共用的停止条件）" },
  "ai_os.proposal.stopped_by_budget": { id: "ai_os.proposal.stopped_by_budget", domain: "ai_os", text: "这件事花的时间超过我给自己定的上限了，我停在这儿。", vars: [], tone: "warn", source: "蓝图 §2.2" },
  "ai_os.proposal.task_link": { id: "ai_os.proposal.task_link", domain: "ai_os", text: "这条已经派成一个开发任务了", vars: [], tone: "", source: "蓝图 §3.4" },
  "ai_os.proposal.uncertain": { id: "ai_os.proposal.uncertain", domain: "ai_os", text: "我拿不太准这条能不能解决，所以先跟你说一声。", vars: [], tone: "warn", source: "蓝图 §3.4" },
  "ai_os.proposal.why_worth_it": { id: "ai_os.proposal.why_worth_it", domain: "ai_os", text: "做完之后 {benefit}", vars: ["benefit"], tone: "", source: "蓝图 §3.4" },
  "ai_os.retry.auto": { id: "ai_os.retry.auto", domain: "ai_os", text: "我自己再试一次，第 {attempt} 次。", vars: ["attempt"], tone: "", source: "2026-08-20 AI OS 合同" },
  "ai_os.retry.blocked_by_red": { id: "ai_os.retry.blocked_by_red", domain: "ai_os", text: "这件事碰到钱了，重试也得你先点一下。", vars: [], tone: "danger", source: "蓝图 §5" },
  "ai_os.retry.gave_up": { id: "ai_os.retry.gave_up", domain: "ai_os", text: "试了 {attempt} 次都没成，我停下了，等你看一眼再说。", vars: ["attempt"], tone: "danger", source: "蓝图 §2.2" },
  "ai_os.retry.manual_ok": { id: "ai_os.retry.manual_ok", domain: "ai_os", text: "这次成了。", vars: [], tone: "ok", source: "2026-08-20 AI OS 合同" },
  "ai_os.risk.amber": { id: "ai_os.risk.amber", domain: "ai_os", text: "动静有点大，我会盯紧", vars: [], tone: "warn", source: "蓝图 §5" },
  "ai_os.risk.amber.detail": { id: "ai_os.risk.amber.detail", domain: "ai_os", text: "这类会动到好几处，或者要发一次版。我会多验几遍，出事自动退回去。", vars: [], tone: "", source: "蓝图 §5" },
  "ai_os.risk.green": { id: "ai_os.risk.green", domain: "ai_os", text: "小事，我自己来", vars: [], tone: "ok", source: "蓝图 §5" },
  "ai_os.risk.green.detail": { id: "ai_os.risk.green.detail", domain: "ai_os", text: "只读的检查、隔离环境里的测试、改句文案这类，出问题我能很快退回去。", vars: [], tone: "", source: "蓝图 §5" },
  "ai_os.risk.over_module_cap": { id: "ai_os.risk.over_module_cap", domain: "ai_os", text: "这件事比我在「{name}」这块被允许做的还大，我停在这儿等你。", vars: ["name"], tone: "warn", source: "蓝图 §3.1" },
  "ai_os.risk.red": { id: "ai_os.risk.red", domain: "ai_os", text: "这一步碰到钱了，得你点一下", vars: [], tone: "danger", source: "CLAUDE.md §3 逐字" },
  "ai_os.risk.red.await_click": { id: "ai_os.risk.red.await_click", domain: "ai_os", text: "我准备好了，就等你这一下。", vars: [], tone: "warn", source: "2026-08-20 AI OS 合同" },
  "ai_os.risk.red.clicked": { id: "ai_os.risk.red.clicked", domain: "ai_os", text: "{who} 在 {when} 点过了，我这就去做。", vars: ["when", "who"], tone: "", source: "2026-08-20 AI OS 合同" },
  "ai_os.risk.red.detail": { id: "ai_os.risk.red.detail", domain: "ai_os", text: "删数据、删机器、改谁能进来、改结账、花钱——这几样我不替你决定。", vars: [], tone: "danger", source: "蓝图 §5" },
  "ai_os.risk.red.refuse_auto": { id: "ai_os.risk.red.refuse_auto", domain: "ai_os", text: "我不敢自己改——万一你有别的程序正靠这个连着", vars: [], tone: "warn", source: "CLAUDE.md §3 逐字" },
  "ai_os.section.acceptance_heading": { id: "ai_os.section.acceptance_heading", domain: "ai_os", text: "怎么算做好了", vars: [], tone: "", source: "2026-08-20 AI OS 合同" },
  "ai_os.section.budget_heading": { id: "ai_os.section.budget_heading", domain: "ai_os", text: "这件事我给自己定的上限", vars: [], tone: "", source: "2026-08-20 AI OS 合同" },
  "ai_os.section.detail_link": { id: "ai_os.section.detail_link", domain: "ai_os", text: "看详细过程", vars: [], tone: "", source: "CLAUDE.md §3 逐字" },
  "ai_os.section.empty": { id: "ai_os.section.empty", domain: "ai_os", text: "这个项目现在没什么要改的，我继续盯着。", vars: [], tone: "ok", source: "2026-08-20 AI OS 合同" },
  "ai_os.section.evidence_heading": { id: "ai_os.section.evidence_heading", domain: "ai_os", text: "我是怎么看出来的", vars: [], tone: "", source: "2026-08-20 AI OS 合同" },
  "ai_os.section.learning_heading": { id: "ai_os.section.learning_heading", domain: "ai_os", text: "我记住的经验", vars: [], tone: "", source: "蓝图 §3.6" },
  "ai_os.section.learning_subtitle": { id: "ai_os.section.learning_subtitle", domain: "ai_os", text: "只有在正式环境上真的验过的，我才会记住。", vars: [], tone: "", source: "蓝图 §3.6" },
  "ai_os.section.needs_you": { id: "ai_os.section.needs_you", domain: "ai_os", text: "有 {count} 件得你点一下", vars: ["count"], tone: "warn", source: "2026-08-20 AI OS 合同" },
  "ai_os.section.plan_heading": { id: "ai_os.section.plan_heading", domain: "ai_os", text: "我打算怎么做", vars: [], tone: "", source: "2026-08-20 AI OS 合同" },
  "ai_os.section.rollback_heading": { id: "ai_os.section.rollback_heading", domain: "ai_os", text: "万一不对怎么退回去", vars: [], tone: "", source: "2026-08-20 AI OS 合同" },
  "ai_os.section.subtitle": { id: "ai_os.section.subtitle", domain: "ai_os", text: "这些是我自己看出来的，不用你去找。", vars: [], tone: "", source: "2026-08-20 AI OS 合同" },
  "ai_os.section.title": { id: "ai_os.section.title", domain: "ai_os", text: "我发现的可改进项", vars: [], tone: "", source: "蓝图 §7 OS-B 逐字" },
  "ai_os.stage.accepted": { id: "ai_os.stage.accepted", domain: "ai_os", text: "说定了，准备开工", vars: [], tone: "neutral", source: "蓝图 §4 状态机" },
  "ai_os.stage.diagnosed": { id: "ai_os.stage.diagnosed", domain: "ai_os", text: "我找到原因了", vars: [], tone: "neutral", source: "蓝图 §4 状态机" },
  "ai_os.stage.executing": { id: "ai_os.stage.executing", domain: "ai_os", text: "我正在改", vars: [], tone: "neutral", source: "蓝图 §4 状态机" },
  "ai_os.stage.failed": { id: "ai_os.stage.failed", domain: "ai_os", text: "没做成，我停下了", vars: [], tone: "danger", source: "蓝图 §4 状态机" },
  "ai_os.stage.fix_requested": { id: "ai_os.stage.fix_requested", domain: "ai_os", text: "验的时候不对，我打回去重做", vars: [], tone: "warn", source: "蓝图 §4 状态机" },
  "ai_os.stage.learning_candidate": { id: "ai_os.stage.learning_candidate", domain: "ai_os", text: "我先记着，再观察一阵子", vars: [], tone: "neutral", source: "蓝图 §4 状态机" },
  "ai_os.stage.observed": { id: "ai_os.stage.observed", domain: "ai_os", text: "我注意到了", vars: [], tone: "neutral", source: "蓝图 §4 状态机" },
  "ai_os.stage.preview_verified": { id: "ai_os.stage.preview_verified", domain: "ai_os", text: "改完了，我在预览环境上验过一遍", vars: [], tone: "ok", source: "蓝图 §4 状态机" },
  "ai_os.stage.production_verified": { id: "ai_os.stage.production_verified", domain: "ai_os", text: "正式环境上也验过了，这件事成了", vars: [], tone: "ok", source: "蓝图 §4 状态机" },
  "ai_os.stage.promoted": { id: "ai_os.stage.promoted", domain: "ai_os", text: "这条经验我记住了，以后照着办", vars: [], tone: "ok", source: "蓝图 §4 状态机" },
  "ai_os.stage.proposed": { id: "ai_os.stage.proposed", domain: "ai_os", text: "办法我想好了", vars: [], tone: "neutral", source: "蓝图 §4 状态机" },
  "ai_os.stage.releasing": { id: "ai_os.stage.releasing", domain: "ai_os", text: "我正在把它发到正式环境", vars: [], tone: "neutral", source: "蓝图 §4 状态机" },
  "ai_os.stage.rollback_requested": { id: "ai_os.stage.rollback_requested", domain: "ai_os", text: "上线之后指标变差了，我准备退回去", vars: [], tone: "warn", source: "蓝图 §4 状态机" },
  "ai_os.stage.rolled_back": { id: "ai_os.stage.rolled_back", domain: "ai_os", text: "已经退回改之前的样子了", vars: [], tone: "neutral", source: "蓝图 §4 状态机" },
  "alert.affected_unknown": { id: "alert.affected_unknown", domain: "alert", text: "我还在查这件事影响到谁。", vars: [], tone: "", source: "补充" },
  "alert.card.ask": { id: "alert.card.ask", domain: "alert", text: "要我做点什么吗", vars: [], tone: "", source: "设计稿 · 告警与值班" },
  "alert.card.handled": { id: "alert.card.handled", domain: "alert", text: "刚刚 · 已经处理好了", vars: [], tone: "ok", source: "设计稿 · 告警与值班" },
  "alert.card.how_fixed": { id: "alert.card.how_fixed", domain: "alert", text: "看它到底怎么修的", vars: [], tone: "", source: "设计稿 · 告警与值班" },
  "alert.card.mute_this_kind": { id: "alert.card.mute_this_kind", domain: "alert", text: "以后这种别叫醒我", vars: [], tone: "", source: "设计稿 · 告警与值班" },
  "alert.cert_expiring": { id: "alert.cert_expiring", domain: "alert", text: "{domain} 的证书还有 {days} 天到期，我提前续上了。", vars: ["days", "domain"], tone: "ok", source: "补充" },
  "alert.channel.digest": { id: "alert.channel.digest", domain: "alert", text: "早报里汇总", vars: [], tone: "", source: "设计稿" },
  "alert.channel.none": { id: "alert.channel.none", domain: "alert", text: "不打扰", vars: [], tone: "", source: "设计稿" },
  "alert.channel.phone": { id: "alert.channel.phone", domain: "alert", text: "打电话", vars: [], tone: "", source: "设计稿" },
  "alert.channel.push": { id: "alert.channel.push", domain: "alert", text: "微信", vars: [], tone: "", source: "设计稿" },
  "alert.conversation_feed_stuck": { id: "alert.conversation_feed_stuck", domain: "alert", text: "有 {count} 条干活的记录没能存进「他们干过什么」里", vars: ["count"], tone: "", source: "冻结合同 · 自动开发飞轮" },
  "alert.conversation_feed_stuck_affected": { id: "alert.conversation_feed_stuck_affected", domain: "alert", text: "这段时间里做过的一些事，在记录上会看不见", vars: [], tone: "", source: "冻结合同 · 自动开发飞轮" },
  "alert.deploy_done": { id: "alert.deploy_done", domain: "alert", text: "部署好了，可以去测了。", vars: [], tone: "ok", source: "CLAUDE.md §3" },
  "alert.disk_almost_full.affected": { id: "alert.disk_almost_full.affected", domain: "alert", text: "照现在的增长，大概 {days} 天后写不进新数据。到那时下单和上传都会失败。", vars: ["days"], tone: "warn", source: "补充" },
  "alert.disk_almost_full.title": { id: "alert.disk_almost_full.title", domain: "alert", text: "{host_name} 硬盘快满了", vars: ["host_name"], tone: "warn", source: "补充" },
  "alert.disk_cleaned": { id: "alert.disk_cleaned", domain: "alert", text: "我清掉了 {size} 旧日志，现在还剩 {free}。", vars: ["free", "size"], tone: "ok", source: "CLAUDE.md §3" },
  "alert.duty.link": { id: "alert.duty.link", domain: "alert", text: "排班与自动处置", vars: [], tone: "", source: "M6-16 入口" },
  "alert.host_down.affected": { id: "alert.host_down.affected", domain: "alert", text: "{project_name}这段时间用不了，大约 {user_count} 个客人受影响。", vars: ["project_name", "user_count"], tone: "danger", source: "补充" },
  "alert.host_down.affected_unknown": { id: "alert.host_down.affected_unknown", domain: "alert", text: "这台上跑的东西现在都用不了，我还在查具体影响到谁。", vars: [], tone: "danger", source: "补充" },
  "alert.host_down.title": { id: "alert.host_down.title", domain: "alert", text: "{host_name} 联系不上了", vars: ["host_name"], tone: "danger", source: "补充" },
  "alert.incident.empty": { id: "alert.incident.empty", domain: "alert", text: "还没有出过事。", vars: [], tone: "", source: "补充" },
  "alert.incident.heading": { id: "alert.incident.heading", domain: "alert", text: "最近一次真出事", vars: [], tone: "", source: "设计稿 · 告警与值班" },
  "alert.incident.meta.asleep": { id: "alert.incident.meta.asleep", domain: "alert", text: "{when} · 全程 {duration}，你在睡觉", vars: ["duration", "when"], tone: "", source: "设计稿" },
  "alert.incident.meta.awake": { id: "alert.incident.meta.awake", domain: "alert", text: "{when} · 全程 {duration}", vars: ["duration", "when"], tone: "", source: "设计稿" },
  "alert.narrow.empty": { id: "alert.narrow.empty", domain: "alert", text: "现在没有告警。沉默是好消息。", vars: [], tone: "", source: "M8-03 窄屏告警" },
  "alert.narrow.heading": { id: "alert.narrow.heading", domain: "alert", text: "现在的告警", vars: [], tone: "", source: "M8-03 窄屏告警" },
  "alert.needs_your_click": { id: "alert.needs_your_click", domain: "alert", text: "这一步碰到钱了，得你点一下。", vars: [], tone: "danger", source: "CLAUDE.md §3" },
  "alert.page.subtitle": { id: "alert.page.subtitle", domain: "alert", text: "AI 先自己救，救不回来才吵醒你 —— 而且会用人话告诉你发生了什么、影响谁。", vars: [], tone: "", source: "设计稿 · 告警与值班" },
  "alert.page.title": { id: "alert.page.title", domain: "alert", text: "出事的时候", vars: [], tone: "", source: "设计稿 · 告警与值班" },
  "alert.phone.empty": { id: "alert.phone.empty", domain: "alert", text: "还没有推到手机上的那一条。沉默是好消息。", vars: [], tone: "", source: "补充" },
  "alert.phone.hint": { id: "alert.phone.hint", domain: "alert", text: "手机上你只会收到「真需要你知道」的那几条", vars: [], tone: "", source: "设计稿 · 告警与值班" },
  "alert.refused_to_touch": { id: "alert.refused_to_touch", domain: "alert", text: "我不敢自己改——万一你有别的程序正靠这个连着。", vars: [], tone: "warn", source: "CLAUDE.md §3" },
  "alert.rest_all_good": { id: "alert.rest_all_good", domain: "alert", text: "其余 {count} 台机器一切正常", vars: ["count"], tone: "ok", source: "设计稿 · 告警与值班" },
  "alert.rule.handled.desc": { id: "alert.rule.handled.desc", domain: "alert", text: "打补丁、清日志、续证书这类", vars: [], tone: "", source: "补充" },
  "alert.rule.handled.title": { id: "alert.rule.handled.title", domain: "alert", text: "AI 自己搞定了，只是告诉你一声", vars: [], tone: "", source: "补充" },
  "alert.rule.needs_you.desc": { id: "alert.rule.needs_you.desc", domain: "alert", text: "比如要花钱、要删数据、要改核心逻辑", vars: [], tone: "", source: "补充" },
  "alert.rule.needs_you.title": { id: "alert.rule.needs_you.title", domain: "alert", text: "AI 修不了，需要你拿主意", vars: [], tone: "", source: "补充" },
  "alert.rule.night_noise.desc": { id: "alert.rule.night_noise.desc", domain: "alert", text: "不影响用户的，攒到早上 9 点一起说", vars: [], tone: "", source: "补充" },
  "alert.rule.night_noise.title": { id: "alert.rule.night_noise.title", domain: "alert", text: "半夜的小毛病", vars: [], tone: "", source: "补充" },
  "alert.rule.site_down.desc": { id: "alert.rule.site_down.desc", domain: "alert", text: "AI 先自己救 3 分钟，救不回来立刻打你电话", vars: [], tone: "", source: "补充" },
  "alert.rule.site_down.title": { id: "alert.rule.site_down.title", domain: "alert", text: "网站打不开了", vars: [], tone: "", source: "补充" },
  "alert.rules.empty": { id: "alert.rules.empty", domain: "alert", text: "还没有告警规则。出事了才会按这里的规矩找你。", vars: [], tone: "", source: "补充" },
  "alert.rules.heading": { id: "alert.rules.heading", domain: "alert", text: "什么时候才吵你", vars: [], tone: "", source: "设计稿 · 告警与值班" },
  "alert.rules.stop_calling": { id: "alert.rules.stop_calling", domain: "alert", text: "别打电话了，发微信就行", vars: [], tone: "", source: "补充" },
  "alert.rules.wait_for_digest": { id: "alert.rules.wait_for_digest", domain: "alert", text: "别单独说了，攒到早报里", vars: [], tone: "", source: "补充" },
  "alert.service_recovered": { id: "alert.service_recovered", domain: "alert", text: "{project_name}刚才断了 {minutes} 分钟，现在好了。", vars: ["minutes", "project_name"], tone: "ok", source: "CLAUDE.md §3" },
  "auth.authentication.strong_required": { id: "auth.authentication.strong_required", domain: "auth", text: "这一步会新增或重签登录凭证，请先用邮箱验证码或登录密码当场再验一次。", vars: [], tone: "warn", source: "补充" },
  "auth.bootstrap.mode.cta": { id: "auth.bootstrap.mode.cta", domain: "auth", text: "这是一个空平台", vars: [], tone: "", source: "补充" },
  "auth.bootstrap.token.label": { id: "auth.bootstrap.token.label", domain: "auth", text: "引导令牌", vars: [], tone: "", source: "补充" },
  "auth.bootstrap.token.placeholder": { id: "auth.bootstrap.token.placeholder", domain: "auth", text: "输入服务器上的一次性引导令牌", vars: [], tone: "", source: "补充" },
  "auth.brand.captain.detail": { id: "auth.brand.captain.detail", domain: "auth", text: "她负责分活、盯进度、在你睡着的时候拿主意。真出事了，是她给你打电话。", vars: [], tone: "", source: "设计稿 · 登录页" },
  "auth.brand.captain.name": { id: "auth.brand.captain.name", domain: "auth", text: "Lulu", vars: [], tone: "", source: "设计稿 · 登录页" },
  "auth.brand.headline": { id: "auth.brand.headline", domain: "auth", text: "你睡觉的时候，\n有人在盯着你的服务器", vars: [], tone: "", source: "设计稿 · 登录页" },
  "auth.brand.portrait_placeholder": { id: "auth.brand.portrait_placeholder", domain: "auth", text: "把 Lulu 的立绘拖进来", vars: [], tone: "", source: "设计稿 · 登录页" },
  "auth.brand.subhead": { id: "auth.brand.subhead", domain: "auth", text: "贴一次 SSH，之后不用管。哪台机器是干嘛的、SSH 是多少、上次是哪个 AI 改的 —— 都不用你记了。", vars: [], tone: "", source: "设计稿 · 登录页" },
  "auth.brand.vault_note": { id: "auth.brand.vault_note", domain: "auth", text: "你的服务器钥匙加密后存在保险箱里，我们看不到。也可以选自部署版，主密钥完全由你自己拿着。", vars: [], tone: "", source: "设计稿 · 登录页" },
  "auth.brand.wordmark": { id: "auth.brand.wordmark", domain: "auth", text: "arron 与他的 NPC 小伙伴们", vars: [], tone: "", source: "设计稿 · 登录页" },
  "auth.code.expired": { id: "auth.code.expired", domain: "auth", text: "这个码过期了，我再发一个给你。", vars: [], tone: "warn", source: "补充" },
  "auth.code.resend_wait": { id: "auth.code.resend_wait", domain: "auth", text: "刚发过一次，{seconds} 秒后可以再发。", vars: ["seconds"], tone: "", source: "补充" },
  "auth.code.sent": { id: "auth.code.sent", domain: "auth", text: "码发到 {email} 了，{minutes} 分钟内有效。", vars: ["email", "minutes"], tone: "", source: "补充" },
  "auth.code.wrong": { id: "auth.code.wrong", domain: "auth", text: "这个码不对，再看一眼邮件？", vars: [], tone: "danger", source: "补充" },
  "auth.divider.or": { id: "auth.divider.or", domain: "auth", text: "或者", vars: [], tone: "", source: "设计稿 · 登录页" },
  "auth.email_code.cta": { id: "auth.email_code.cta", domain: "auth", text: "用验证码登录", vars: [], tone: "", source: "补充" },
  "auth.error.mail_from_invalid": { id: "auth.error.mail_from_invalid", domain: "auth", text: "验证码发不出去：发信地址没配对。这不是你的邮箱写错了，再点也没用——得运维把发信配置改对。", vars: [], tone: "warn", source: "补充" },
  "auth.error.mail_invalid": { id: "auth.error.mail_invalid", domain: "auth", text: "验证码发不出去：Cloudflare 说这封信的地址无效。先核对你填的邮箱；要是邮箱没错，就是发信地址没配对——再点也没用，得运维改配置。", vars: [], tone: "warn", source: "补充" },
  "auth.error.no_mail_channel": { id: "auth.error.no_mail_channel", domain: "auth", text: "邮箱验证码那条路我还没接通。先用恢复码进来，然后花一分钟设个指纹——恢复码用一张少一张。", vars: [], tone: "warn", source: "补充" },
  "auth.error.passkey_setup_required": { id: "auth.error.passkey_setup_required", domain: "auth", text: "这一步得按指纹，而你还没设过。先花一分钟设一个，之后都用它。", vars: [], tone: "warn", source: "补充" },
  "auth.field.code.label": { id: "auth.field.code.label", domain: "auth", text: "验证码", vars: [], tone: "", source: "补充" },
  "auth.field.current_password.label": { id: "auth.field.current_password.label", domain: "auth", text: "当前密码", vars: [], tone: "", source: "补充" },
  "auth.field.email.label": { id: "auth.field.email.label", domain: "auth", text: "邮箱", vars: [], tone: "", source: "设计稿 · 登录页" },
  "auth.field.email.placeholder": { id: "auth.field.email.placeholder", domain: "auth", text: "me@example.com", vars: [], tone: "", source: "设计稿 · 登录页" },
  "auth.field.new_password.label": { id: "auth.field.new_password.label", domain: "auth", text: "新密码", vars: [], tone: "", source: "补充" },
  "auth.field.password.label": { id: "auth.field.password.label", domain: "auth", text: "密码", vars: [], tone: "", source: "补充" },
  "auth.field.password.placeholder": { id: "auth.field.password.placeholder", domain: "auth", text: "至少 12 个字", vars: [], tone: "", source: "补充" },
  "auth.field.recovery.label": { id: "auth.field.recovery.label", domain: "auth", text: "恢复码", vars: [], tone: "", source: "补充" },
  "auth.first_step.body": { id: "auth.first_step.body", domain: "auth", text: "把你任意一台服务器的 SSH 贴进来。40 秒后你就能看到它是干嘛的、跑了什么、有没有毛病 —— 那一刻你就知道这东西有没有用。", vars: [], tone: "", source: "设计稿 · 登录页" },
  "auth.first_step.title": { id: "auth.first_step.title", domain: "auth", text: "注册完只有一件事要做", vars: [], tone: "", source: "设计稿 · 登录页" },
  "auth.invited.body": { id: "auth.invited.body", domain: "auth", text: "用邀请链接里的那个邮箱登录就行，你能看到什么由请你来的人决定 —— 通常是某一个项目，看不到密钥。", vars: [], tone: "", source: "设计稿 · 登录页" },
  "auth.invited.title": { id: "auth.invited.title", domain: "auth", text: "你是被叫来一起管的？", vars: [], tone: "", source: "设计稿 · 登录页" },
  "auth.mail.code.body": { id: "auth.mail.code.body", domain: "auth", text: "你的登录码是 {code}，{minutes} 分钟内有效。\n不是你在登录的话，这封信不用管——光有这个码，别人也进不来。", vars: ["code", "minutes"], tone: "", source: "补充" },
  "auth.mail.code.subject": { id: "auth.mail.code.subject", domain: "auth", text: "你的登录码：{code}（{minutes} 分钟内有效）", vars: ["code", "minutes"], tone: "", source: "补充" },
  "auth.mail.invite.body": { id: "auth.mail.invite.body", domain: "auth", text: "{inviter} 请你一起管 NPC，给你的身份是「{role}」。\n点这个链接加入团队（登录你自己的账号就行，已经注册过也没关系）：{link}\n这条邀请 {days} 天后失效、只能用一次。你能看到什么由请你来的人决定，通常是某几个项目，看不到密钥。", vars: ["days", "inviter", "link", "role"], tone: "", source: "补充" },
  "auth.mail.invite.subject": { id: "auth.mail.invite.subject", domain: "auth", text: "{inviter} 请你一起管 NPC（{role}）", vars: ["inviter", "role"], tone: "", source: "补充" },
  "auth.mail.stepup.body": { id: "auth.mail.stepup.body", domain: "auth", text: "你正在确认一个敏感操作。验证码：{code}\n{minutes} 分钟内有效，只能用一次。\n如果这不是你本人发起的，请立即修改密码。\n", vars: ["code", "minutes"], tone: "", source: "补充" },
  "auth.mail.stepup.subject": { id: "auth.mail.stepup.subject", domain: "auth", text: "确认这个操作：验证码 {code}（{minutes} 分钟内有效）", vars: ["code", "minutes"], tone: "", source: "补充" },
  "auth.no_password.body": { id: "auth.no_password.body", domain: "auth", text: "这个账号能打开你所有服务器的门。我们只存一串没法还原的摘要，指纹、验证码和恢复码也都还留着。", vars: [], tone: "", source: "方向变更" },
  "auth.no_password.title": { id: "auth.no_password.title", domain: "auth", text: "密码只存成一串看不懂的摘要", vars: [], tone: "", source: "方向变更" },
  "auth.passkey.cta": { id: "auth.passkey.cta", domain: "auth", text: "用指纹 / 面容登录", vars: [], tone: "", source: "设计稿 · 登录页" },
  "auth.passkey.done": { id: "auth.passkey.done", domain: "auth", text: "好了，下次直接按指纹。", vars: [], tone: "ok", source: "补充" },
  "auth.passkey.failed.already": { id: "auth.passkey.failed.already", domain: "auth", text: "这台设备上已经设过了。换一台设备，或者直接用它登录。", vars: [], tone: "neutral", source: "补充" },
  "auth.passkey.failed.dismissed": { id: "auth.passkey.failed.dismissed", domain: "auth", text: "这次没设成——弹窗被关掉了，或者等太久了。再点一次就行。", vars: [], tone: "warn", source: "补充" },
  "auth.passkey.failed.domain": { id: "auth.passkey.failed.domain", domain: "auth", text: "这个网址和指纹绑定的域名对不上，我这边配错了。你先别管，我去修。", vars: [], tone: "warn", source: "补充" },
  "auth.passkey.failed.unknown": { id: "auth.passkey.failed.unknown", domain: "auth", text: "这次没设成。再点一次试试。", vars: [], tone: "warn", source: "补充" },
  "auth.passkey.failed.unsupported": { id: "auth.passkey.failed.unsupported", domain: "auth", text: "这台设备或这个浏览器不支持指纹登录。换个浏览器，或者换台设备再试。", vars: [], tone: "warn", source: "补充" },
  "auth.passkey.invite": { id: "auth.passkey.invite", domain: "auth", text: "下次用指纹进来吧，一秒就好，也不怕被人撞库。", vars: [], tone: "", source: "补充" },
  "auth.passkey.setup_cta": { id: "auth.passkey.setup_cta", domain: "auth", text: "现在就设", vars: [], tone: "", source: "补充" },
  "auth.passkey.unsupported": { id: "auth.passkey.unsupported", domain: "auth", text: "这个浏览器用不了指纹登录。换个浏览器打开，或者确认地址是 https 开头的。", vars: [], tone: "warn", source: "契约请求 · apps/console/src/screens/auth/pending-copy.ts 草案" },
  "auth.password.change.cta": { id: "auth.password.change.cta", domain: "auth", text: "修改密码", vars: [], tone: "", source: "补充" },
  "auth.password.cta": { id: "auth.password.cta", domain: "auth", text: "用密码登录", vars: [], tone: "", source: "补充" },
  "auth.password.current_invalid": { id: "auth.password.current_invalid", domain: "auth", text: "当前密码不对，再试一次。", vars: [], tone: "warn", source: "补充" },
  "auth.password.hint": { id: "auth.password.hint", domain: "auth", text: "至少 12 个字，大写、小写、数字、符号里混着用三种。", vars: [], tone: "", source: "补充" },
  "auth.password.invalid": { id: "auth.password.invalid", domain: "auth", text: "邮箱或密码不对，再试一次。", vars: [], tone: "warn", source: "补充" },
  "auth.password.recent_auth_required": { id: "auth.password.recent_auth_required", domain: "auth", text: "这次登录已经有一会儿了，请重新登录后再改密码。", vars: [], tone: "warn", source: "补充" },
  "auth.password.set.cta": { id: "auth.password.set.cta", domain: "auth", text: "设置密码", vars: [], tone: "", source: "补充" },
  "auth.password.updated": { id: "auth.password.updated", domain: "auth", text: "密码已经更新。", vars: [], tone: "", source: "补充" },
  "auth.password.weak": { id: "auth.password.weak", domain: "auth", text: "密码还不够结实。至少 12 个字，大写、小写、数字、符号里混着用三种。", vars: [], tone: "warn", source: "补充" },
  "auth.paths.only_consumable": { id: "auth.paths.only_consumable", domain: "auth", text: "你现在只剩恢复码这一条路能进来，用一张少一张，还剩 {left} 张。进来之后花一分钟设个指纹，这条路就不会再少了。", vars: ["left"], tone: "warn", source: "补充" },
  "auth.paths.only_one": { id: "auth.paths.only_one", domain: "auth", text: "现在只有一种办法能进来。再丢一条你就进不来了——加一个指纹吧，一分钟。", vars: [], tone: "warn", source: "补充" },
  "auth.paths.recovery_left": { id: "auth.paths.recovery_left", domain: "auth", text: "恢复码还剩 {left} 张。", vars: ["left"], tone: "", source: "补充" },
  "auth.point.autonomous.detail": { id: "auth.point.autonomous.detail", domain: "auth", text: "打补丁、清硬盘、修 Bug、灰度上线，它做完才告诉你。真出事才叫醒你。", vars: [], tone: "", source: "设计稿 · 登录页" },
  "auth.point.autonomous.title": { id: "auth.point.autonomous.title", domain: "auth", text: "AI 自己巡检、自己修、自己发布", vars: [], tone: "", source: "设计稿 · 登录页" },
  "auth.point.ssh_once.detail": { id: "auth.point.ssh_once.detail", domain: "auth", text: "以后换任何一个 AI 助手来干活，它都从小队这儿拿临时钥匙，你不用再翻聊天记录找 IP 和密码。", vars: [], tone: "", source: "设计稿 · 登录页" },
  "auth.point.ssh_once.title": { id: "auth.point.ssh_once.title", domain: "auth", text: "一次贴 SSH，永久不用管", vars: [], tone: "", source: "设计稿 · 登录页" },
  "auth.point.team.detail": { id: "auth.point.team.detail", domain: "auth", text: "现在就你自己。以后叫外包或客户进来，给权限就行，不用把密码发给任何人。", vars: [], tone: "", source: "设计稿 · 登录页" },
  "auth.point.team.title": { id: "auth.point.team.title", domain: "auth", text: "一个人够用，来人了也够用", vars: [], tone: "", source: "设计稿 · 登录页" },
  "auth.recovery.cta": { id: "auth.recovery.cta", domain: "auth", text: "用恢复码登录", vars: [], tone: "", source: "补充" },
  "auth.recovery.hint": { id: "auth.recovery.hint", domain: "auth", text: "邮箱和恢复码都要填。", vars: [], tone: "", source: "补充" },
  "auth.recovery.needs_email": { id: "auth.recovery.needs_email", domain: "auth", text: "邮箱也要填——上面那个框还空着。", vars: [], tone: "warn", source: "补充" },
  "auth.recovery.submit": { id: "auth.recovery.submit", domain: "auth", text: "用这个码进来", vars: [], tone: "", source: "补充" },
  "auth.recovery_codes.detail": { id: "auth.recovery_codes.detail", domain: "auth", text: "手机丢了、指纹用不了的时候，靠它们进来。**这些码只显示这一次**，关掉就再也看不到了。", vars: [], tone: "", source: "补充" },
  "auth.recovery_codes.heading": { id: "auth.recovery_codes.heading", domain: "auth", text: "这几串码存到你的密码管理器里", vars: [], tone: "", source: "补充" },
  "auth.registration.invalid": { id: "auth.registration.invalid", domain: "auth", text: "这次注册没通过，请重新发起注册。", vars: [], tone: "warn", source: "补充" },
  "auth.signin.cta": { id: "auth.signin.cta", domain: "auth", text: "用密码登录", vars: [], tone: "", source: "设计稿 · 登录页" },
  "auth.signin.failed": { id: "auth.signin.failed", domain: "auth", text: "这次没进来。检查一下邮箱和恢复码是不是都填对了。", vars: [], tone: "warn", source: "补充" },
  "auth.signin.subtitle": { id: "auth.signin.subtitle", domain: "auth", text: "输入邮箱和密码就能进来。", vars: [], tone: "", source: "设计稿 · 登录页" },
  "auth.signin.switch_cta": { id: "auth.signin.switch_cta", domain: "auth", text: "开个账号", vars: [], tone: "", source: "设计稿 · 登录页" },
  "auth.signin.switch_hint": { id: "auth.signin.switch_hint", domain: "auth", text: "第一次来？", vars: [], tone: "", source: "设计稿 · 登录页" },
  "auth.signin.title": { id: "auth.signin.title", domain: "auth", text: "登录", vars: [], tone: "", source: "设计稿 · 登录页" },
  "auth.signup.cta": { id: "auth.signup.cta", domain: "auth", text: "开好账号", vars: [], tone: "", source: "设计稿 · 登录页" },
  "auth.signup.subtitle": { id: "auth.signup.subtitle", domain: "auth", text: "填邮箱和密码就好。", vars: [], tone: "", source: "设计稿 · 登录页" },
  "auth.signup.switch_cta": { id: "auth.signup.switch_cta", domain: "auth", text: "去登录", vars: [], tone: "", source: "设计稿 · 登录页" },
  "auth.signup.switch_hint": { id: "auth.signup.switch_hint", domain: "auth", text: "已经有账号了？", vars: [], tone: "", source: "设计稿 · 登录页" },
  "auth.signup.title": { id: "auth.signup.title", domain: "auth", text: "开个账号", vars: [], tone: "", source: "设计稿 · 登录页" },
  "auth.step_up.prompt": { id: "auth.step_up.prompt", domain: "auth", text: "这一步得你当场再验一次，验完我就去办。", vars: [], tone: "", source: "补充" },
  "auth.stepup.code.cta": { id: "auth.stepup.code.cta", domain: "auth", text: "用邮箱验证码确认", vars: [], tone: "", source: "补充" },
  "auth.stepup.code.sent": { id: "auth.stepup.code.sent", domain: "auth", text: "确认码发到你的邮箱了，十分钟内有效。", vars: [], tone: "ok", source: "补充" },
  "auth.stepup.password.cta": { id: "auth.stepup.password.cta", domain: "auth", text: "确认", vars: [], tone: "", source: "补充" },
  "auth.stepup.password.label": { id: "auth.stepup.password.label", domain: "auth", text: "当前密码", vars: [], tone: "", source: "补充" },
  "auth.stepup.password.wrong": { id: "auth.stepup.password.wrong", domain: "auth", text: "密码不对，再输一次。", vars: [], tone: "warn", source: "补充" },
  "bridge.error.scope_insufficient": { id: "bridge.error.scope_insufficient", domain: "bridge", text: "这把钥匙没开这个权限。要用它做这件事，得让开钥匙的人重新开一把带这项的。", vars: [], tone: "warn", source: "补充" },
  "bridge.grants.empty": { id: "bridge.grants.empty", domain: "bridge", text: "还没有给过动手授权。", vars: [], tone: "", source: "M6-06" },
  "bridge.grants.heading": { id: "bridge.grants.heading", domain: "bridge", text: "平台动手的授权", vars: [], tone: "", source: "M6-06" },
  "bridge.grants.hint": { id: "bridge.grants.hint", domain: "bridge", text: "这不是发给外部 AI 的钥匙。这是平台自己动手前要你点头的那一张。默认一次，用掉即收。", vars: [], tone: "", source: "M6-06" },
  "bridge.grants.issue": { id: "bridge.grants.issue", domain: "bridge", text: "给一次拉起授权", vars: [], tone: "", source: "M6-06" },
  "bridge.grants.revoke": { id: "bridge.grants.revoke", domain: "bridge", text: "收回", vars: [], tone: "", source: "M6-06" },
  "bridge.tokens.empty": { id: "bridge.tokens.empty", domain: "bridge", text: "还没给过任何 AI 钥匙。", vars: [], tone: "", source: "补充" },
  "bridge.tokens.error.idempotency_mismatch": { id: "bridge.tokens.error.idempotency_mismatch", domain: "bridge", text: "这个重试键上一次开的是另一把钥匙。换一个键再试。", vars: [], tone: "warn", source: "补充" },
  "bridge.tokens.error.invalid": { id: "bridge.tokens.error.invalid", domain: "bridge", text: "这把钥匙的信息没填全：给谁用、管哪个项目、能碰到什么，三样都要有。", vars: [], tone: "warn", source: "补充" },
  "bridge.tokens.error.scope_forbidden": { id: "bridge.tokens.error.scope_forbidden", domain: "bridge", text: "能拿机器钥匙的授权，得老板本人来开。", vars: [], tone: "warn", source: "补充" },
  "bridge.tokens.heading": { id: "bridge.tokens.heading", domain: "bridge", text: "你已经给过的授权", vars: [], tone: "", source: "设计稿 · 交办与对话" },
  "bridge.tokens.hint": { id: "bridge.tokens.hint", domain: "bridge", text: "这把钥匙是给这个 AI 的，可以随时作废。它能干什么、干过什么，都记在时间线里。", vars: [], tone: "", source: "设计稿 · 给 AI 的接口" },
  "bridge.tokens.issue.cta": { id: "bridge.tokens.issue.cta", domain: "bridge", text: "开一把钥匙", vars: [], tone: "", source: "补充" },
  "bridge.tokens.issue.failed": { id: "bridge.tokens.issue.failed", domain: "bridge", text: "这把没开成。再点一次试试。", vars: [], tone: "", source: "补充" },
  "bridge.tokens.issue.heading": { id: "bridge.tokens.issue.heading", domain: "bridge", text: "给一个外部 AI 开一把钥匙", vars: [], tone: "", source: "补充" },
  "bridge.tokens.issue.label": { id: "bridge.tokens.issue.label", domain: "bridge", text: "这把钥匙给谁用", vars: [], tone: "", source: "补充" },
  "bridge.tokens.issue.label_example": { id: "bridge.tokens.issue.label_example", domain: "bridge", text: "比如「我笔记本上的 Claude Code」", vars: [], tone: "", source: "契约 · BridgeToken.label" },
  "bridge.tokens.issue.pending": { id: "bridge.tokens.issue.pending", domain: "bridge", text: "正在开", vars: [], tone: "", source: "补充" },
  "bridge.tokens.issue.project": { id: "bridge.tokens.issue.project", domain: "bridge", text: "管哪个项目", vars: [], tone: "", source: "补充" },
  "bridge.tokens.issue.scopes": { id: "bridge.tokens.issue.scopes", domain: "bridge", text: "能碰到什么", vars: [], tone: "", source: "补充" },
  "bridge.tokens.issue.stepup": { id: "bridge.tokens.issue.stepup", domain: "bridge", text: "开钥匙这一步我要当场再确认一次是你：它一到手就能替你调平台。", vars: [], tone: "", source: "补充" },
  "bridge.tokens.issue.ttl": { id: "bridge.tokens.issue.ttl", domain: "bridge", text: "多久过期", vars: [], tone: "", source: "补充" },
  "bridge.tokens.issued.close": { id: "bridge.tokens.issued.close", domain: "bridge", text: "我存好了，关掉", vars: [], tone: "", source: "补充" },
  "bridge.tokens.issued.copied": { id: "bridge.tokens.issued.copied", domain: "bridge", text: "复制好了", vars: [], tone: "", source: "补充" },
  "bridge.tokens.issued.copy": { id: "bridge.tokens.issued.copy", domain: "bridge", text: "复制", vars: [], tone: "", source: "设计稿 · 给 AI 的接口" },
  "bridge.tokens.issued.heading": { id: "bridge.tokens.issued.heading", domain: "bridge", text: "钥匙开好了，只显示这一次", vars: [], tone: "", source: "补充" },
  "bridge.tokens.issued.hint": { id: "bridge.tokens.issued.hint", domain: "bridge", text: "关掉就再也看不到了。复制下来贴给那个 AI，别存在别处。", vars: [], tone: "", source: "补充" },
  "bridge.tokens.issued.replayed": { id: "bridge.tokens.issued.replayed", domain: "bridge", text: "这一把刚才已经开过了，明文只在那一次显示过。要新的就再开一把。", vars: [], tone: "", source: "补充" },
  "bridge.tokens.mask": { id: "bridge.tokens.mask", domain: "bridge", text: "{prefix}……{suffix}", vars: ["prefix", "suffix"], tone: "", source: "设计稿 · 给 AI 的接口" },
  "bridge.tokens.revoke": { id: "bridge.tokens.revoke", domain: "bridge", text: "收回", vars: [], tone: "", source: "设计稿 · 交办与对话" },
  "bridge.tokens.revoke.failed": { id: "bridge.tokens.revoke.failed", domain: "bridge", text: "这把没收回成，它还能用。再点一次试试。", vars: [], tone: "", source: "补充" },
  "bridge.tokens.revoke.stepup": { id: "bridge.tokens.revoke.stepup", domain: "bridge", text: "收回之后它立刻失效，不等过期。那个 AI 手上这把就用不了了，所以我要当场再确认一次是你。", vars: [], tone: "", source: "补充" },
  "bridge.tokens.revoke.title": { id: "bridge.tokens.revoke.title", domain: "bridge", text: "收回这把钥匙", vars: [], tone: "", source: "契约 · DELETE /bridge/tokens/{tokenId}" },
  "bridge.tokens.revoking": { id: "bridge.tokens.revoking", domain: "bridge", text: "正在收回", vars: [], tone: "", source: "补充" },
  "bridge.tokens.row.expires": { id: "bridge.tokens.row.expires", domain: "bridge", text: "{date} 到期", vars: ["date"], tone: "", source: "补充" },
  "bridge.tokens.row.last_used": { id: "bridge.tokens.row.last_used", domain: "bridge", text: "上次用是 {date}", vars: ["date"], tone: "", source: "补充" },
  "bridge.tokens.row.never_expires": { id: "bridge.tokens.row.never_expires", domain: "bridge", text: "不会自己过期", vars: [], tone: "", source: "补充" },
  "bridge.tokens.row.never_used": { id: "bridge.tokens.row.never_used", domain: "bridge", text: "还没用过", vars: [], tone: "", source: "补充" },
  "bridge.tokens.scope.access_request": { id: "bridge.tokens.scope.access_request", domain: "bridge", text: "要一把短时效的机器钥匙，它拿到就能连上你的服务器", vars: [], tone: "warn", source: "补充" },
  "bridge.tokens.scope.hosts_read": { id: "bridge.tokens.scope.hosts_read", domain: "bridge", text: "看机器档案：用途、跑了什么、怎么部署的", vars: [], tone: "", source: "补充" },
  "bridge.tokens.scope.projects_read": { id: "bridge.tokens.scope.projects_read", domain: "bridge", text: "看这个项目和它的机器名单", vars: [], tone: "", source: "补充" },
  "bridge.tokens.show_revoked": { id: "bridge.tokens.show_revoked", domain: "bridge", text: "把收回的也列出来", vars: [], tone: "", source: "补充" },
  "bridge.tokens.status.active": { id: "bridge.tokens.status.active", domain: "bridge", text: "能用", vars: [], tone: "ok", source: "补充" },
  "bridge.tokens.status.expired": { id: "bridge.tokens.status.expired", domain: "bridge", text: "已过期", vars: [], tone: "neutral", source: "补充" },
  "bridge.tokens.status.revoked": { id: "bridge.tokens.status.revoked", domain: "bridge", text: "已收回", vars: [], tone: "danger", source: "补充" },
  "bridge.tokens.ttl.30d": { id: "bridge.tokens.ttl.30d", domain: "bridge", text: "30 天", vars: [], tone: "", source: "补充" },
  "bridge.tokens.ttl.7d": { id: "bridge.tokens.ttl.7d", domain: "bridge", text: "7 天", vars: [], tone: "", source: "补充" },
  "bridge.tokens.ttl.90d": { id: "bridge.tokens.ttl.90d", domain: "bridge", text: "90 天", vars: [], tone: "", source: "补充" },
  "bridge.tokens.ttl.never": { id: "bridge.tokens.ttl.never", domain: "bridge", text: "不自动过期，随时能收回", vars: [], tone: "", source: "补充" },
  "bug_reports.close": { id: "bug_reports.close", domain: "bug_reports", text: "关闭", vars: [], tone: "", source: "arron 2026-09-06" },
  "bug_reports.confirm_fix": { id: "bug_reports.confirm_fix", domain: "bug_reports", text: "确认修复", vars: [], tone: "", source: "arron 2026-09-06" },
  "bug_reports.disable": { id: "bug_reports.disable", domain: "bug_reports", text: "停用", vars: [], tone: "", source: "arron 2026-09-06" },
  "bug_reports.empty": { id: "bug_reports.empty", domain: "bug_reports", text: "现在没有需要看的问题。", vars: [], tone: "", source: "arron 2026-09-06" },
  "bug_reports.enable": { id: "bug_reports.enable", domain: "bug_reports", text: "给这个项目开启反馈入口", vars: [], tone: "", source: "arron 2026-09-06" },
  "bug_reports.enabled": { id: "bug_reports.enabled", domain: "bug_reports", text: "反馈入口已经开启", vars: [], tone: "", source: "arron 2026-09-06" },
  "bug_reports.failed": { id: "bug_reports.failed", domain: "bug_reports", text: "这次没读到问题反馈，请稍后再试。", vars: [], tone: "", source: "arron 2026-09-06" },
  "bug_reports.filter.all": { id: "bug_reports.filter.all", domain: "bug_reports", text: "全部", vars: [], tone: "", source: "arron 2026-09-06" },
  "bug_reports.loading": { id: "bug_reports.loading", domain: "bug_reports", text: "正在读取问题反馈…", vars: [], tone: "", source: "arron 2026-09-06" },
  "bug_reports.more": { id: "bug_reports.more", domain: "bug_reports", text: "请他补充", vars: [], tone: "", source: "arron 2026-09-06" },
  "bug_reports.no_description": { id: "bug_reports.no_description", domain: "bug_reports", text: "用户只框出了问题位置，没有写说明。", vars: [], tone: "", source: "arron 2026-09-06" },
  "bug_reports.resolved_note": { id: "bug_reports.resolved_note", domain: "bug_reports", text: "我修好了，已经上线。你再试一次；还是不对就在这条反馈的修复任务下面再说一声。", vars: [], tone: "", source: "arron 2026-09-09：修完了应该有个反馈，已修复" },
  "bug_reports.rotate": { id: "bug_reports.rotate", domain: "bug_reports", text: "换一个公开 Key", vars: [], tone: "", source: "arron 2026-09-06" },
  "bug_reports.screenshot": { id: "bug_reports.screenshot", domain: "bug_reports", text: "问题截图", vars: [], tone: "", source: "arron 2026-09-06" },
  "bug_reports.state.admin": { id: "bug_reports.state.admin", domain: "bug_reports", text: "等你确认", vars: [], tone: "", source: "arron 2026-09-06" },
  "bug_reports.state.analyzing": { id: "bug_reports.state.analyzing", domain: "bug_reports", text: "Buger 正在看", vars: [], tone: "", source: "arron 2026-09-06" },
  "bug_reports.state.done": { id: "bug_reports.state.done", domain: "bug_reports", text: "已结束", vars: [], tone: "", source: "arron 2026-09-06" },
  "bug_reports.state.fixing": { id: "bug_reports.state.fixing", domain: "bug_reports", text: "正在修复", vars: [], tone: "", source: "arron 2026-09-06" },
  "bug_reports.state.reporter": { id: "bug_reports.state.reporter", domain: "bug_reports", text: "等提交人决定", vars: [], tone: "", source: "arron 2026-09-06" },
  "bug_reports.subtitle": { id: "bug_reports.subtitle", domain: "bug_reports", text: "Buger 先判断，再把需要处理的问题送到这里。", vars: [], tone: "", source: "arron 2026-09-06" },
  "bug_reports.title": { id: "bug_reports.title", domain: "bug_reports", text: "问题反馈", vars: [], tone: "", source: "arron 2026-09-06" },
  "chat.brief.active": { id: "chat.brief.active", domain: "chat", text: "今天有动静的话头", vars: [], tone: "", source: "设计稿 v2 · V01 Lulu 默认工作台" },
  "chat.brief.empty": { id: "chat.brief.empty", domain: "chat", text: "今天暂无实际事件", vars: [], tone: "", source: "设计稿 v2 · V01 Lulu 默认工作台" },
  "chat.brief.empty_hint": { id: "chat.brief.empty_hint", domain: "chat", text: "有真实事件之后，这里按会话逐条列出，每个数字都能点回出处。", vars: [], tone: "", source: "设计稿 v2 · V01 Lulu 默认工作台" },
  "chat.brief.heading": { id: "chat.brief.heading", domain: "chat", text: "今日简报", vars: [], tone: "", source: "设计稿 v2 · V01 Lulu 默认工作台" },
  "chat.brief.note": { id: "chat.brief.note", domain: "chat", text: "这两个数从话头本身数出来。发布次数要另一张还没有的表，所以这里不列。", vars: [], tone: "", source: "设计稿 v2 · V01 Lulu 默认工作台" },
  "chat.brief.waiting": { id: "chat.brief.waiting", domain: "chat", text: "等你拿主意", vars: [], tone: "", source: "设计稿 v2 · V01 Lulu 默认工作台" },
  "chat.error.unavailable": { id: "chat.error.unavailable", domain: "chat", text: "现在连不上后台，这一屏的内容是空的 —— 不是没有，是取不到。", vars: [], tone: "", source: "冻结合同 · 前端合同" },
  "chat.facts.external_verify_hint": { id: "chat.facts.external_verify_hint", domain: "chat", text: "外面到底能不能用，现在还没有一条事件能告诉我。发完了不等于外面能用。", vars: [], tone: "", source: "设计稿 v2 · V04" },
  "chat.facts.heading": { id: "chat.facts.heading", domain: "chat", text: "五类事实", vars: [], tone: "", source: "设计稿 v2 · V01/V03/V04 右栏" },
  "chat.facts.kind.commit": { id: "chat.facts.kind.commit", domain: "chat", text: "代码提交", vars: [], tone: "", source: "设计稿 v2 · V04" },
  "chat.facts.kind.deploy": { id: "chat.facts.kind.deploy", domain: "chat", text: "部署", vars: [], tone: "", source: "设计稿 v2 · V04" },
  "chat.facts.kind.external_verify": { id: "chat.facts.kind.external_verify", domain: "chat", text: "对外验证", vars: [], tone: "", source: "设计稿 v2 · V04" },
  "chat.facts.kind.rollback": { id: "chat.facts.kind.rollback", domain: "chat", text: "回滚", vars: [], tone: "", source: "设计稿 v2 · V04" },
  "chat.facts.kind.test": { id: "chat.facts.kind.test", domain: "chat", text: "测试", vars: [], tone: "", source: "设计稿 v2 · V04" },
  "chat.facts.note": { id: "chat.facts.note", domain: "chat", text: "互不等同", vars: [], tone: "", source: "设计稿 v2 · V01/V03/V04 右栏" },
  "chat.facts.status.failed": { id: "chat.facts.status.failed", domain: "chat", text: "没过", vars: [], tone: "", source: "设计稿 v2 · V04" },
  "chat.facts.status.none": { id: "chat.facts.status.none", domain: "chat", text: "尚无此证据", vars: [], tone: "", source: "设计稿 v2 · V04" },
  "chat.facts.status.not_applicable": { id: "chat.facts.status.not_applicable", domain: "chat", text: "不适用", vars: [], tone: "", source: "设计稿 v2 · V04" },
  "chat.facts.status.passed": { id: "chat.facts.status.passed", domain: "chat", text: "有收据", vars: [], tone: "", source: "设计稿 v2 · V04" },
  "chat.facts.status.pending_verify": { id: "chat.facts.status.pending_verify", domain: "chat", text: "已发起，待验证", vars: [], tone: "", source: "设计稿 v2 · M07" },
  "chat.facts.status.running": { id: "chat.facts.status.running", domain: "chat", text: "正在跑", vars: [], tone: "", source: "设计稿 v2 · V04" },
  "chat.flywheel.ci_failed": { id: "chat.flywheel.ci_failed", domain: "chat", text: "CI 没过，已经把失败原因发回给 {agent} 了", vars: ["agent"], tone: "", source: "冻结合同 · 自动开发飞轮" },
  "chat.flywheel.completed": { id: "chat.flywheel.completed", domain: "chat", text: "这件事做完了", vars: [], tone: "", source: "冻结合同 · 自动开发飞轮" },
  "chat.flywheel.deploy_failed": { id: "chat.flywheel.deploy_failed", domain: "chat", text: "上线没成，已经退回上一版", vars: [], tone: "", source: "冻结合同 · 自动开发飞轮" },
  "chat.flywheel.empty": { id: "chat.flywheel.empty", domain: "chat", text: "还没派出去过活。", vars: [], tone: "", source: "冻结合同 · 自动开发飞轮" },
  "chat.flywheel.heading": { id: "chat.flywheel.heading", domain: "chat", text: "他们做到哪了", vars: [], tone: "", source: "设计稿 · 交办与对话" },
  "chat.flywheel.review_fix_requested": { id: "chat.flywheel.review_fix_requested", domain: "chat", text: "复核的打回来了，{agent} 正在改", vars: ["agent"], tone: "", source: "冻结合同 · 自动开发飞轮" },
  "chat.flywheel.running": { id: "chat.flywheel.running", domain: "chat", text: "正在做第 {iteration} 轮", vars: ["iteration"], tone: "", source: "冻结合同 · 自动开发飞轮" },
  "chat.flywheel.stale": { id: "chat.flywheel.stale", domain: "chat", text: "自 {since} 起没再收到消息，我这儿看不到它现在到哪一步了", vars: ["since"], tone: "", source: "设计稿 v2 · V06" },
  "chat.gate.held": { id: "chat.gate.held", domain: "chat", text: "这次守门没跑成，是平台这边的问题，不是你的代码。自 {since} 起我在查，弄好了自己重来一次", vars: ["since"], tone: "", source: "补充" },
  "chat.input.archived": { id: "chat.input.archived", domain: "chat", text: "这个话头已经归档了，说不了话。要接着聊就另起一个。", vars: [], tone: "", source: "设计稿 · 交办与对话" },
  "chat.input.label": { id: "chat.input.label", domain: "chat", text: "消息", vars: [], tone: "", source: "设计稿 · 交办与对话" },
  "chat.input.placeholder": { id: "chat.input.placeholder", domain: "chat", text: "想让他们做什么，直接说", vars: [], tone: "", source: "设计稿 · 交办与对话" },
  "chat.input.send": { id: "chat.input.send", domain: "chat", text: "说给他们听", vars: [], tone: "", source: "设计稿 · 交办与对话" },
  "chat.list.account_create": { id: "chat.list.account_create", domain: "chat", text: "和 Lulu 开一条新的", vars: [], tone: "", source: "补充" },
  "chat.list.account_group": { id: "chat.list.account_group", domain: "chat", text: "和 Lulu 说", vars: [], tone: "", source: "补充" },
  "chat.list.archived": { id: "chat.list.archived", domain: "chat", text: "已归档", vars: [], tone: "", source: "设计稿 · 交办与对话" },
  "chat.list.create": { id: "chat.list.create", domain: "chat", text: "另起一个话头", vars: [], tone: "", source: "设计稿 · 交办与对话" },
  "chat.list.empty": { id: "chat.list.empty", domain: "chat", text: "还没开过话头。有事直接在右边说一句就行。", vars: [], tone: "", source: "设计稿 · 交办与对话" },
  "chat.list.group_create": { id: "chat.list.group_create", domain: "chat", text: "在这个项目下开一个", vars: [], tone: "", source: "arron 2026-08-24 · 左栏按项目分组" },
  "chat.list.group_less": { id: "chat.list.group_less", domain: "chat", text: "收起", vars: [], tone: "", source: "arron 2026-08-24 · 左栏按项目分组" },
  "chat.list.group_more": { id: "chat.list.group_more", domain: "chat", text: "还有 {count} 条", vars: ["count"], tone: "", source: "arron 2026-08-24 · 左栏按项目分组" },
  "chat.list.group_unavailable": { id: "chat.list.group_unavailable", domain: "chat", text: "这个项目的话头我没取到", vars: [], tone: "", source: "arron 2026-08-24 · 左栏按项目分组" },
  "chat.list.mobile_open": { id: "chat.list.mobile_open", domain: "chat", text: "换个话头", vars: [], tone: "", source: "设计稿 v2 · 移动 390" },
  "chat.list.nav": { id: "chat.list.nav", domain: "chat", text: "会话", vars: [], tone: "", source: "设计稿 · 交办与对话" },
  "chat.list.waiting": { id: "chat.list.waiting", domain: "chat", text: "等你拿主意", vars: [], tone: "", source: "arron 2026-08-24 · 左栏按项目分组" },
  "chat.lulu.receipts.approve": { id: "chat.lulu.receipts.approve", domain: "chat", text: "确认", vars: [], tone: "", source: "Lulu V2" },
  "chat.lulu.receipts.closed": { id: "chat.lulu.receipts.closed", domain: "chat", text: "已追加确认回执", vars: [], tone: "", source: "Lulu V2" },
  "chat.lulu.receipts.empty": { id: "chat.lulu.receipts.empty", domain: "chat", text: "还没有 Lulu 动作回执。", vars: [], tone: "", source: "Lulu V2" },
  "chat.lulu.receipts.heading": { id: "chat.lulu.receipts.heading", domain: "chat", text: "Lulu 动作回执", vars: [], tone: "", source: "Lulu V2" },
  "chat.lulu.receipts.pending": { id: "chat.lulu.receipts.pending", domain: "chat", text: "等待你的确认", vars: [], tone: "", source: "Lulu V2" },
  "chat.lulu.receipts.reject": { id: "chat.lulu.receipts.reject", domain: "chat", text: "拒绝", vars: [], tone: "", source: "Lulu V2" },
  "chat.mention.action": { id: "chat.mention.action", domain: "chat", text: "点名", vars: [], tone: "", source: "设计稿 v2 · M04" },
  "chat.mention.empty": { id: "chat.mention.empty", domain: "chat", text: "现在没有谁能点。等我把人排上来。", vars: [], tone: "", source: "设计稿 v2 · M04" },
  "chat.mention.hint": { id: "chat.mention.hint", domain: "chat", text: "点名只是告诉我你想让谁来。归谁做还要看写域和现在谁腾得出手。", vars: [], tone: "", source: "设计稿 v2 · M04" },
  "chat.message.empty": { id: "chat.message.empty", domain: "chat", text: "这里还什么都没有。", vars: [], tone: "", source: "设计稿 · 交办与对话" },
  "chat.next.developing": { id: "chat.next.developing", domain: "chat", text: "等干活的交出这一版", vars: [], tone: "", source: "冻结合同 · 交办阶段" },
  "chat.next.fix": { id: "chat.next.fix", domain: "chat", text: "等干活的改", vars: [], tone: "", source: "冻结合同 · 交办阶段" },
  "chat.next.live": { id: "chat.next.live", domain: "chat", text: "已经在线上", vars: [], tone: "", source: "冻结合同 · 交办阶段" },
  "chat.next.preview": { id: "chat.next.preview", domain: "chat", text: "可以去看预览", vars: [], tone: "", source: "冻结合同 · 交办阶段" },
  "chat.next.release": { id: "chat.next.release", domain: "chat", text: "等人确认发布", vars: [], tone: "", source: "冻结合同 · 交办阶段" },
  "chat.next.testing": { id: "chat.next.testing", domain: "chat", text: "等快速测试跑完", vars: [], tone: "", source: "冻结合同 · 交办阶段" },
  "chat.page.subtitle": { id: "chat.page.subtitle", domain: "chat", text: "有事直接说。要谁做就 @ 谁，剩下的他们自己商量。", vars: [], tone: "", source: "设计稿 · 交办与对话" },
  "chat.page.title": { id: "chat.page.title", domain: "chat", text: "交办与对话", vars: [], tone: "", source: "设计稿 · 交办与对话" },
  "chat.panel.collapse": { id: "chat.panel.collapse", domain: "chat", text: "收起旁边这栏", vars: [], tone: "", source: "设计稿 v2 · V01" },
  "chat.panel.expand": { id: "chat.panel.expand", domain: "chat", text: "展开旁边这栏", vars: [], tone: "", source: "设计稿 v2 · V01" },
  "chat.panel.mobile_close": { id: "chat.panel.mobile_close", domain: "chat", text: "收起", vars: [], tone: "", source: "设计稿 v2 · 移动 390" },
  "chat.panel.mobile_open": { id: "chat.panel.mobile_open", domain: "chat", text: "看进度与证据", vars: [], tone: "", source: "设计稿 v2 · 移动 390" },
  "chat.participant.developer": { id: "chat.participant.developer", domain: "chat", text: "干活的", vars: [], tone: "", source: "设计稿 · 交办与对话" },
  "chat.participant.human": { id: "chat.participant.human", domain: "chat", text: "你", vars: [], tone: "", source: "设计稿 · 交办与对话" },
  "chat.participant.reviewer": { id: "chat.participant.reviewer", domain: "chat", text: "复核的", vars: [], tone: "", source: "设计稿 · 交办与对话" },
  "chat.participant.steward": { id: "chat.participant.steward", domain: "chat", text: "Lulu", vars: [], tone: "", source: "设计稿 · 交办与对话" },
  "chat.participants.empty": { id: "chat.participants.empty", domain: "chat", text: "还没人进来。我把需求拆完之后才知道该叫谁。", vars: [], tone: "", source: "设计稿 v2 · V01 左栏" },
  "chat.participants.error": { id: "chat.participants.error", domain: "chat", text: "这个话头里有谁，我这会儿问不出来 —— 不是没人，是取不到。", vars: [], tone: "", source: "冻结合同 · 前端合同" },
  "chat.participants.heading": { id: "chat.participants.heading", domain: "chat", text: "这个话头里有谁", vars: [], tone: "", source: "设计稿 v2 · V01/V03 左栏" },
  "chat.phase.developing": { id: "chat.phase.developing", domain: "chat", text: "开发中", vars: [], tone: "", source: "冻结合同 · 交办阶段" },
  "chat.phase.fix": { id: "chat.phase.fix", domain: "chat", text: "需修复", vars: [], tone: "", source: "冻结合同 · 交办阶段" },
  "chat.phase.live": { id: "chat.phase.live", domain: "chat", text: "已上线", vars: [], tone: "", source: "冻结合同 · 交办阶段" },
  "chat.phase.preview": { id: "chat.phase.preview", domain: "chat", text: "预览可用", vars: [], tone: "", source: "冻结合同 · 交办阶段" },
  "chat.phase.release": { id: "chat.phase.release", domain: "chat", text: "待发布", vars: [], tone: "", source: "冻结合同 · 交办阶段" },
  "chat.phase.testing": { id: "chat.phase.testing", domain: "chat", text: "快速测试", vars: [], tone: "", source: "冻结合同 · 交办阶段" },
  "chat.platform.job_failed": { id: "chat.platform.job_failed", domain: "chat", text: "这件活没跑完，我把过程留下来了。", vars: [], tone: "", source: "冻结合同 · 自动开发飞轮" },
  "chat.platform.job_succeeded": { id: "chat.platform.job_succeeded", domain: "chat", text: "这件活跑完了，没出问题。", vars: [], tone: "", source: "冻结合同 · 自动开发飞轮" },
  "chat.receipt.action": { id: "chat.receipt.action", domain: "chat", text: "平台动作回执", vars: [], tone: "", source: "Lulu V2" },
  "chat.receipt.declared": { id: "chat.receipt.declared", domain: "chat", text: "它自己说用的是 {model}", vars: ["model"], tone: "", source: "冻结合同 · Lulu 运行时模型" },
  "chat.receipt.degraded": { id: "chat.receipt.degraded", domain: "chat", text: "模型没应答，这条是按规则兜底出来的", vars: [], tone: "", source: "冻结合同 · Lulu 运行时模型" },
  "chat.receipt.platform": { id: "chat.receipt.platform", domain: "chat", text: "平台配的 {model}", vars: ["model"], tone: "", source: "冻结合同 · Lulu 运行时模型" },
  "chat.schedule.action": { id: "chat.schedule.action", domain: "chat", text: "安排开发", vars: [], tone: "", source: "设计稿 · 交办与对话" },
  "chat.schedule.done": { id: "chat.schedule.done", domain: "chat", text: "已经按这句话安排下去了。", vars: [], tone: "", source: "设计稿 · 交办与对话" },
  "chat.schedule.executor.auto": { id: "chat.schedule.executor.auto", domain: "chat", text: "就用默认的 {model}", vars: ["model"], tone: "", source: "补充" },
  "chat.schedule.executor.label": { id: "chat.schedule.executor.label", domain: "chat", text: "交给谁做", vars: [], tone: "", source: "补充" },
  "chat.schedule.executor.own_key": { id: "chat.schedule.executor.own_key", domain: "chat", text: "自己贴的 Key", vars: [], tone: "", source: "补充" },
  "chat.schedule.executor.plan": { id: "chat.schedule.executor.plan", domain: "chat", text: "套餐里的", vars: [], tone: "", source: "补充" },
  "chat.schedule.executor.unavailable": { id: "chat.schedule.executor.unavailable", domain: "chat", text: "现在调不动", vars: [], tone: "", source: "补充" },
  "chat.schedule.hint": { id: "chat.schedule.hint", domain: "chat", text: "确认之后按这句话安排开发。", vars: [], tone: "", source: "设计稿 · 交办与对话" },
  "chat.schedule.no_project": { id: "chat.schedule.no_project", domain: "chat", text: "这条是咱俩的总话头，不挂在哪个项目上，所以这个按钮在这儿点不动。你跟我说一声想动哪儿，我把它挂到项目上再开。", vars: [], tone: "", source: "补充" },
  "chat.task.base_sha": { id: "chat.task.base_sha", domain: "chat", text: "底 {sha}", vars: ["sha"], tone: "", source: "冻结合同 · 交办阶段" },
  "chat.task.base_sha_pending": { id: "chat.task.base_sha_pending", domain: "chat", text: "代码底还没冻上", vars: [], tone: "", source: "冻结合同 · 交办阶段" },
  "chat.task.project": { id: "chat.task.project", domain: "chat", text: "项目 {name}", vars: ["name"], tone: "", source: "冻结合同 · 交办阶段" },
  "chat.tasktree.empty": { id: "chat.tasktree.empty", domain: "chat", text: "还没有计划回执", vars: [], tone: "", source: "设计稿 v2 · V03 右栏" },
  "chat.tasktree.empty_hint": { id: "chat.tasktree.empty_hint", domain: "chat", text: "我把需求拆完、回执回来之后，这里才会出现子任务和归谁做。现在是真的空。", vars: [], tone: "", source: "设计稿 v2 · V03 右栏" },
  "chat.tasktree.heading": { id: "chat.tasktree.heading", domain: "chat", text: "这个话头在做的事", vars: [], tone: "", source: "设计稿 v2 · V03 右栏" },
  "chat.tasktree.owner_unassigned": { id: "chat.tasktree.owner_unassigned", domain: "chat", text: "还没定归谁", vars: [], tone: "", source: "设计稿 v2 · V03 右栏" },
  "check.backup.failed": { id: "check.backup.failed", domain: "check", text: "{host} 的备份跑挂了。上一次成功的备份还在，但从那之后的改动没有兜底。", vars: ["host"], tone: "danger", source: "补充" },
  "check.backup.stale": { id: "check.backup.stale", domain: "check", text: "{host} 已经 {hours} 小时没备份了。", vars: ["host", "hours"], tone: "warn", source: "补充" },
  "check.cert.expiring": { id: "check.cert.expiring", domain: "check", text: "{host} 上 {domain} 的证书还有 {days} 天到期，过期之后浏览器会拦着不让进。", vars: ["days", "domain", "host"], tone: "warn", source: "补充" },
  "check.disk.almost_full": { id: "check.disk.almost_full", domain: "check", text: "{host} 的硬盘快满了，{mount} 还剩 {free_percent}%。", vars: ["free_percent", "host", "mount"], tone: "warn", source: "补充" },
  "check.disk.will_be_full": { id: "check.disk.will_be_full", domain: "check", text: "{host} 的 {mount} 照这个速度还有 {days} 天就满了，到时候新文件会写不进去。", vars: ["days", "host", "mount"], tone: "warn", source: "补充" },
  "check.load.high": { id: "check.load.high", domain: "check", text: "{host} 一直在忙，每个核上排着 {per_core} 个活。", vars: ["host", "per_core"], tone: "warn", source: "补充" },
  "check.log.disk_pressure": { id: "check.log.disk_pressure", domain: "check", text: "{host} 的日志里在报写不进去了，多半是硬盘满了。", vars: ["host"], tone: "warn", source: "补充" },
  "check.log.nothing_found": { id: "check.log.nothing_found", domain: "check", text: "我翻了一遍日志，没看出什么苗头。", vars: [], tone: "", source: "补充" },
  "check.log.oom": { id: "check.log.oom", domain: "check", text: "{host} 上有进程因为内存不够被系统杀掉了。", vars: ["host"], tone: "warn", source: "补充" },
  "check.log.port_taken": { id: "check.log.port_taken", domain: "check", text: "{host} 上有个服务起不来，端口被别的东西占着。", vars: ["host"], tone: "warn", source: "补充" },
  "check.memory.almost_full": { id: "check.memory.almost_full", domain: "check", text: "{host} 的内存有点紧，用到 {percent}% 了。", vars: ["host", "percent"], tone: "warn", source: "补充" },
  "check.port.closed": { id: "check.port.closed", domain: "check", text: "{host} 的 {port} 端口连不上了，走这个口进来的都会吃闭门羹。", vars: ["host", "port"], tone: "danger", source: "补充" },
  "check.process.gone": { id: "check.process.gone", domain: "check", text: "{host} 上的 {process} 不见了，它负责的那部分现在没人管。", vars: ["host", "process"], tone: "danger", source: "补充" },
  "code.action.diff": { id: "code.action.diff", domain: "code", text: "看改了哪几行", vars: [], tone: "", source: "设计稿" },
  "code.application.current": { id: "code.application.current", domain: "code", text: "各项目当前线上版本", vars: [], tone: "", source: "发布中心 vNext 产品会议 2026-08-28" },
  "code.application.empty": { id: "code.application.empty", domain: "code", text: "还没有应用发布记录。", vars: [], tone: "", source: "发布中心 vNext 产品会议 2026-08-28" },
  "code.application.open_project": { id: "code.application.open_project", domain: "code", text: "打开项目发布", vars: [], tone: "", source: "发布中心 vNext 产品会议 2026-08-28" },
  "code.application.partial": { id: "code.application.partial", domain: "code", text: "部分项目暂时没有返回发布状态，已显示其余可靠结果。", vars: [], tone: "", source: "发布中心 vNext 产品会议 2026-08-28" },
  "code.application.recent": { id: "code.application.recent", domain: "code", text: "最近发布", vars: [], tone: "", source: "发布中心 vNext 产品会议 2026-08-28" },
  "code.inspection.detail": { id: "code.inspection.detail", domain: "code", text: "查看失败输出", vars: [], tone: "", source: "发布中心 vNext 产品会议 2026-08-28" },
  "code.inspection.empty": { id: "code.inspection.empty", domain: "code", text: "DeepSeek 巡检没找到问题。", vars: [], tone: "", source: "异步巡检 batch 4" },
  "code.inspection.idle": { id: "code.inspection.idle", domain: "code", text: "还没有上线后的巡检。", vars: [], tone: "", source: "补充" },
  "code.inspection.repair": { id: "code.inspection.repair", domain: "code", text: "修复", vars: [], tone: "", source: "异步巡检 batch 2" },
  "code.inspection.subtitle": { id: "code.inspection.subtitle", domain: "code", text: "上线后 DeepSeek 巡检的发现放在这里，不阻塞开发和发布。", vars: [], tone: "", source: "异步巡检 batch 4" },
  "code.overview.active": { id: "code.overview.active", domain: "code", text: "正在上线", vars: [], tone: "", source: "发布中心 vNext 产品会议 2026-08-28" },
  "code.overview.attention": { id: "code.overview.attention", domain: "code", text: "需要处理", vars: [], tone: "", source: "发布中心 vNext 产品会议 2026-08-28" },
  "code.overview.live": { id: "code.overview.live", domain: "code", text: "线上版本", vars: [], tone: "", source: "发布中心 vNext 产品会议 2026-08-28" },
  "code.page.subtitle": { id: "code.page.subtitle", domain: "code", text: "一眼看清线上版本、正在发生的发布、网页站点和需要处理的问题。", vars: [], tone: "", source: "发布中心 vNext 产品会议 2026-08-28" },
  "code.section.commits": { id: "code.section.commits", domain: "code", text: "AI 提交了什么", vars: [], tone: "", source: "设计稿" },
  "code.section.commits.hint": { id: "code.section.commits.hint", domain: "code", text: "每一次提交都先过平台这一关：跑测试、扫安全、看有没有碰红线，过了才进你的 Forgejo", vars: [], tone: "", source: "设计稿" },
  "code.section.prs": { id: "code.section.prs", domain: "code", text: "AI 这周提的修改", vars: [], tone: "", source: "设计稿" },
  "code.section.prs.hint": { id: "code.section.prs.hint", domain: "code", text: "小改动自己合，动到钱和数据的会先问你", vars: [], tone: "", source: "设计稿" },
  "code.section.repos": { id: "code.section.repos", domain: "code", text: "仓库体检", vars: [], tone: "", source: "设计稿" },
  "code.tab.applications": { id: "code.tab.applications", domain: "code", text: "应用版本", vars: [], tone: "", source: "发布中心 vNext 产品会议 2026-08-28" },
  "code.tab.inspections": { id: "code.tab.inspections", domain: "code", text: "巡检发现", vars: [], tone: "", source: "发布中心 vNext 产品会议 2026-08-28" },
  "code.tab.sites": { id: "code.tab.sites", domain: "code", text: "网页站点", vars: [], tone: "", source: "发布中心 vNext 产品会议 2026-08-28" },
  "credential.blast.one_scope": { id: "credential.blast.one_scope", domain: "credential", text: "只有 {scope} 这一处", vars: ["scope"], tone: "", source: "补充" },
  "credential.blast.several": { id: "credential.blast.several", domain: "credential", text: "{vendor} 账户下的 {count} 处", vars: ["count", "vendor"], tone: "", source: "补充" },
  "credential.blast.whole_account": { id: "credential.blast.whole_account", domain: "credential", text: "整个 {vendor} 账户", vars: ["vendor"], tone: "", source: "补充" },
  "credential.derived.also_dies": { id: "credential.derived.also_dies", domain: "credential", text: "这把钥匙是从「{parent}」派生出来的。吊销那一把，这把跟着废——它俩在 {vendor} 那边其实是同一个东西。", vars: ["parent", "vendor"], tone: "warn", source: "补充" },
  "credential.error.blank": { id: "credential.error.blank", domain: "credential", text: "这一格是空的。空的钥匙存进去，用的时候才会发现开不了门。", vars: [], tone: "warn", source: "补充" },
  "credential.error.forbidden_raw": { id: "credential.error.forbidden_raw", domain: "credential", text: "这个得老板来看。你的身份能用这把钥匙干活，但看不到它本身。", vars: [], tone: "warn", source: "补充" },
  "credential.error.vendor_missing": { id: "credential.error.vendor_missing", domain: "credential", text: "得先有这家服务商，才能把它的钥匙放进来。", vars: [], tone: "warn", source: "补充" },
  "credential.reveal.code_required": { id: "credential.reveal.code_required", domain: "credential", text: "给你邮箱发了一个码，填进来我就把它显示出来。这一步是防别人趁你没锁屏的时候看一眼。", vars: [], tone: "neutral", source: "补充（arron 2026-08-09 定的门）" },
  "credential.reveal.code_wrong": { id: "credential.reveal.code_wrong", domain: "credential", text: "这个码不对。再看一眼邮件，或者让我重发一个。", vars: [], tone: "warn", source: "补充（arron 2026-08-09 定的门）" },
  "credential.reveal.hidden_again": { id: "credential.reveal.hidden_again", domain: "credential", text: "收起来了，现在这儿又只剩前后四位。", vars: [], tone: "neutral", source: "补充（arron 2026-08-09）" },
  "credential.reveal.reason_required": { id: "credential.reveal.reason_required", domain: "credential", text: "说一句为什么要看，我记在账上。", vars: [], tone: "", source: "补充" },
  "credential.revoked": { id: "credential.revoked", domain: "credential", text: "作废了。这把钥匙从现在起开不了任何东西。", vars: [], tone: "ok", source: "补充" },
  "credential.rotated": { id: "credential.rotated", domain: "credential", text: "换好了，旧的那把我已经作废。", vars: [], tone: "ok", source: "补充" },
  "credential.rotation.pending": { id: "credential.rotation.pending", domain: "credential", text: "新钥匙已经在用了。旧的那把还活着，得你去 {vendor} 后台吊销一下——我没有那个权限。", vars: ["vendor"], tone: "warn", source: "补充" },
  "credential.scope.too_wide": { id: "credential.scope.too_wide", domain: "credential", text: "这把钥匙管得太宽了——它能改账单、能把域名转走。日常用不着这么大的权，我建议换一把只够用的。", vars: [], tone: "warn", source: "补充" },
  "credential.source.leaked_channel": { id: "credential.source.leaked_channel", domain: "credential", text: "这把钥匙走过聊天，得当成已经泄露了办——我建议换一把，旧的那把去后台吊销掉。", vars: [], tone: "warn", source: "补充" },
  "dashboard.action.add_host": { id: "dashboard.action.add_host", domain: "dashboard", text: "+ 加一台机器", vars: [], tone: "", source: "设计稿 · 总览" },
  "dashboard.action.nightly_report": { id: "dashboard.action.nightly_report", domain: "dashboard", text: "昨夜报告", vars: [], tone: "", source: "设计稿 · 总览" },
  "dashboard.attention.ack": { id: "dashboard.attention.ack", domain: "dashboard", text: "知道了", vars: [], tone: "", source: "设计稿 · 总览" },
  "dashboard.attention.detail_cta": { id: "dashboard.attention.detail_cta", domain: "dashboard", text: "看详细过程", vars: [], tone: "", source: "设计稿 · 总览" },
  "dashboard.attention.rest": { id: "dashboard.attention.rest", domain: "dashboard", text: "其余 {count} 件 AI 自己搞定了", vars: ["count"], tone: "", source: "设计稿 · 总览" },
  "dashboard.attention.timeline_cta": { id: "dashboard.attention.timeline_cta", domain: "dashboard", text: "看时间线 →", vars: [], tone: "", source: "设计稿 · 总览" },
  "dashboard.greeting.all_well": { id: "dashboard.greeting.all_well", domain: "dashboard", text: "早上好，昨晚一切还行", vars: [], tone: "", source: "设计稿 · 总览" },
  "dashboard.greeting.detail": { id: "dashboard.greeting.detail", domain: "dashboard", text: "{host_count} 台机器都醒着，AI 昨晚替你干了 {action_count} 件事，有 {attention_count} 件想让你看一眼。", vars: ["action_count", "attention_count", "host_count"], tone: "", source: "设计稿 · 总览" },
  "dashboard.greeting.detail.unreachable": { id: "dashboard.greeting.detail.unreachable", domain: "dashboard", text: "有 {count} 台机器联系不上。可能只是探针没上报，我还在试；真出了事我会马上说。", vars: ["count"], tone: "warn", source: "补充（2026-08-09）" },
  "dashboard.greeting.something_burning": { id: "dashboard.greeting.something_burning", domain: "dashboard", text: "早上好，昨晚有件事没搞定", vars: [], tone: "danger", source: "补充" },
  "dashboard.last_night.window": { id: "dashboard.last_night.window", domain: "dashboard", text: "{from} – {to} 的自动巡检", vars: ["from", "to"], tone: "", source: "设计稿 · 总览" },
  "dashboard.nightly.backed_up": { id: "dashboard.nightly.backed_up", domain: "dashboard", text: "{count} 个项目的数据库都备份好了", vars: ["count"], tone: "", source: "设计稿 · 总览" },
  "dashboard.nightly.backed_up.detail": { id: "dashboard.nightly.backed_up.detail", domain: "dashboard", text: "存到{destination}，保留 {days} 天", vars: ["days", "destination"], tone: "", source: "设计稿 · 总览" },
  "dashboard.nightly.cleaned_logs": { id: "dashboard.nightly.cleaned_logs", domain: "dashboard", text: "清掉「{project_name}」的 {size} 旧日志", vars: ["project_name", "size"], tone: "", source: "设计稿 · 总览" },
  "dashboard.nightly.cleaned_logs.detail": { id: "dashboard.nightly.cleaned_logs.detail", domain: "dashboard", text: "硬盘从 {before} 降到 {after}", vars: ["after", "before"], tone: "", source: "设计稿 · 总览" },
  "dashboard.nightly.fixed_bug": { id: "dashboard.nightly.fixed_bug", domain: "dashboard", text: "修好「{project_name}」的一个{issue}", vars: ["issue", "project_name"], tone: "", source: "设计稿 · 总览" },
  "dashboard.nightly.fixed_bug.detail": { id: "dashboard.nightly.fixed_bug.detail", domain: "dashboard", text: "代码已提交，等你上班后发布", vars: [], tone: "", source: "设计稿 · 总览" },
  "dashboard.nightly.patched": { id: "dashboard.nightly.patched", domain: "dashboard", text: "给 {count} 台机器打了系统安全补丁", vars: ["count"], tone: "", source: "设计稿 · 总览" },
  "dashboard.nightly.patched.detail": { id: "dashboard.nightly.patched.detail", domain: "dashboard", text: "全部成功，没人察觉", vars: [], tone: "", source: "设计稿 · 总览" },
  "dashboard.nightly.watching": { id: "dashboard.nightly.watching", domain: "dashboard", text: "「{project_name}」有台机器硬盘偏满，盯着", vars: ["project_name"], tone: "warn", source: "设计稿 · 总览" },
  "dashboard.nightly.watching.detail": { id: "dashboard.nightly.watching.detail", domain: "dashboard", text: "还不用管，我先记下了", vars: [], tone: "", source: "设计稿 · 总览" },
  "dashboard.project.host_count": { id: "dashboard.project.host_count", domain: "dashboard", text: "{count} 台机器", vars: ["count"], tone: "", source: "设计稿 · 总览" },
  "dashboard.project.no_domain": { id: "dashboard.project.no_domain", domain: "dashboard", text: "还没绑域名", vars: [], tone: "", source: "设计稿 · 总览" },
  "dashboard.running.hint": { id: "dashboard.running.hint", domain: "dashboard", text: "跑太久的我会自己掐掉，你也可以随时停", vars: [], tone: "", source: "设计稿" },
  "dashboard.running.item": { id: "dashboard.running.item", domain: "dashboard", text: "{project} · {doing}", vars: ["doing", "project"], tone: "", source: "设计稿" },
  "dashboard.running.title": { id: "dashboard.running.title", domain: "dashboard", text: "正在跑的活", vars: [], tone: "", source: "设计稿" },
  "dashboard.section.attention": { id: "dashboard.section.attention", domain: "dashboard", text: "想让你看一眼", vars: [], tone: "", source: "设计稿 · 总览" },
  "dashboard.section.attention.hint": { id: "dashboard.section.attention.hint", domain: "dashboard", text: "AI 已经处理过了，只是告诉你一声", vars: [], tone: "", source: "设计稿 · 总览" },
  "dashboard.section.last_night": { id: "dashboard.section.last_night", domain: "dashboard", text: "昨晚发生了什么", vars: [], tone: "", source: "设计稿 · 总览" },
  "dashboard.section.projects": { id: "dashboard.section.projects", domain: "dashboard", text: "你的项目", vars: [], tone: "", source: "设计稿 · 总览" },
  "dashboard.section.projects.hint": { id: "dashboard.section.projects.hint", domain: "dashboard", text: "点进去能看到它用了哪些机器和服务", vars: [], tone: "", source: "设计稿 · 总览" },
  "dashboard.stat.attention": { id: "dashboard.stat.attention", domain: "dashboard", text: "等你看一眼", vars: [], tone: "warn", source: "设计稿 · 总览" },
  "dashboard.stat.hosts": { id: "dashboard.stat.hosts", domain: "dashboard", text: "在管的机器", vars: [], tone: "", source: "设计稿 · 总览" },
  "dashboard.stat.hosts.all_online": { id: "dashboard.stat.hosts.all_online", domain: "dashboard", text: "全部在线", vars: [], tone: "ok", source: "设计稿 · 总览" },
  "dashboard.stat.hosts.unreachable": { id: "dashboard.stat.hosts.unreachable", domain: "dashboard", text: "有 {count} 台联系不上", vars: ["count"], tone: "warn", source: "补充（2026-08-09，首屏标题说了没处落）" },
  "dashboard.stat.projects": { id: "dashboard.stat.projects", domain: "dashboard", text: "在管的项目", vars: [], tone: "", source: "设计稿 · 总览" },
  "development_task.action.add_acceptance": { id: "development_task.action.add_acceptance", domain: "development_task", text: "添加一条验收", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.action.add_context": { id: "development_task.action.add_context", domain: "development_task", text: "附加资料", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.action.cancel": { id: "development_task.action.cancel", domain: "development_task", text: "取消任务", vars: [], tone: "", source: "补充" },
  "development_task.action.cancelling": { id: "development_task.action.cancelling", domain: "development_task", text: "正在取消", vars: [], tone: "", source: "补充" },
  "development_task.action.claim": { id: "development_task.action.claim", domain: "development_task", text: "领取给另一台电脑", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.action.claiming": { id: "development_task.action.claiming", domain: "development_task", text: "正在领取", vars: [], tone: "", source: "补充" },
  "development_task.action.confirm_cancel": { id: "development_task.action.confirm_cancel", domain: "development_task", text: "确认取消任务", vars: [], tone: "", source: "补充" },
  "development_task.action.copied": { id: "development_task.action.copied", domain: "development_task", text: "已复制", vars: [], tone: "", source: "补充" },
  "development_task.action.copy": { id: "development_task.action.copy", domain: "development_task", text: "复制给执行器", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.action.keep": { id: "development_task.action.keep", domain: "development_task", text: "先不取消", vars: [], tone: "", source: "补充" },
  "development_task.action.prepare_repo": { id: "development_task.action.prepare_repo", domain: "development_task", text: "准备这个仓库", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.action.preparing": { id: "development_task.action.preparing", domain: "development_task", text: "正在准备", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.action.remove": { id: "development_task.action.remove", domain: "development_task", text: "移除", vars: [], tone: "", source: "补充" },
  "development_task.action.repair": { id: "development_task.action.repair", domain: "development_task", text: "继续修", vars: [], tone: "", source: "2026-08-30 用户裁决 · 任务收件箱" },
  "development_task.action.retry": { id: "development_task.action.retry", domain: "development_task", text: "再试一次", vars: [], tone: "", source: "补充" },
  "development_task.actor.external": { id: "development_task.actor.external", domain: "development_task", text: "外部执行器", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.actor.internal": { id: "development_task.actor.internal", domain: "development_task", text: "平台执行器", vars: [], tone: "", source: "补充" },
  "development_task.assignee.auto": { id: "development_task.assignee.auto", domain: "development_task", text: "Lulu 平台自动分配", vars: [], tone: "", source: "2026-09-07 用户指定任务分配选项" },
  "development_task.assignee.cannot_execute": { id: "development_task.assignee.cannot_execute", domain: "development_task", text: "本机执行器只会往 README 和 docs 里加一行，别的它做不了。这件活在「交给远程 AI」那里挑一个会写代码的。", vars: [], tone: "", source: "2026-09-06 生产 · 点名派给本机执行器的活静默停在待领取" },
  "development_task.assignee.local_hint": { id: "development_task.assignee.local_hint", domain: "development_task", text: "只会往 README 和 docs 里加一行，不写代码", vars: [], tone: "", source: "2026-09-06 生产 · 点名派给本机执行器的活静默停在待领取" },
  "development_task.assignee.manual": { id: "development_task.assignee.manual", domain: "development_task", text: "不指定，手动领取", vars: [], tone: "", source: "2026-09-07 用户指定任务分配选项" },
  "development_task.assignee.unavailable": { id: "development_task.assignee.unavailable", domain: "development_task", text: "这个项目还没有能接这件活的开发 AI，任务尚未创建。请先接入会写代码的执行器，或指定一位可用的远程 AI。", vars: [], tone: "", source: "2026-09-07 创建任务自动派活" },
  "development_task.cancel.body": { id: "development_task.cancel.body", domain: "development_task", text: "已开始的执行会收到停止请求，已提交的代码不会被平台自动删除。", vars: [], tone: "", source: "补充" },
  "development_task.cancel.title": { id: "development_task.cancel.title", domain: "development_task", text: "取消这个开发任务？", vars: [], tone: "", source: "补充" },
  "development_task.claim.copy": { id: "development_task.claim.copy", domain: "development_task", text: "目标：完成 NPC_TASK_PACKET_JSON 中的任务并满足 acceptance_criteria。先核对 base_sha 和 target_ref，再用下方一次性 RepoGate 参数以标准 Git 工作；只推 target_ref。不要直连普通仓库、push main，或把凭证写进聊天、日志和长期配置。", vars: [], tone: "", source: "2026-09-10 外部 AI 提示词收敛" },
  "development_task.claim.endpoint": { id: "development_task.claim.endpoint", domain: "development_task", text: "RepoGate 地址", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.claim.expiry": { id: "development_task.claim.expiry", domain: "development_task", text: "过期时间", vars: [], tone: "", source: "补充" },
  "development_task.claim.fingerprint": { id: "development_task.claim.fingerprint", domain: "development_task", text: "指纹", vars: [], tone: "", source: "补充" },
  "development_task.claim.subtitle": { id: "development_task.claim.subtitle", domain: "development_task", text: "只显示这一次。关闭窗口后，平台不会再保存这把凭证。", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.claim.title": { id: "development_task.claim.title", domain: "development_task", text: "给另一台电脑的执行凭证", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.claim.token": { id: "development_task.claim.token", domain: "development_task", text: "一次性 Token", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.claim.username": { id: "development_task.claim.username", domain: "development_task", text: "用户名", vars: [], tone: "", source: "补充" },
  "development_task.comments.empty": { id: "development_task.comments.empty", domain: "development_task", text: "还没有人评论过。", vars: [], tone: "", source: "修复任务闭环 PRD v1 §D" },
  "development_task.comments.failed": { id: "development_task.comments.failed", domain: "development_task", text: "没发出去，再试一次。", vars: [], tone: "", source: "修复任务闭环 PRD v1 §D" },
  "development_task.comments.outcome_exhausted": { id: "development_task.comments.outcome_exhausted", domain: "development_task", text: "已经改了 {max} 轮，不再自动改了，转给人来看。", vars: ["max"], tone: "", source: "修复任务闭环 PRD v1 §D" },
  "development_task.comments.outcome_recorded": { id: "development_task.comments.outcome_recorded", domain: "development_task", text: "记下了，它这一轮就能看到。", vars: [], tone: "", source: "修复任务闭环 PRD v1 §D" },
  "development_task.comments.outcome_reopened": { id: "development_task.comments.outcome_reopened", domain: "development_task", text: "收到了，它会再来一轮。", vars: [], tone: "", source: "修复任务闭环 PRD v1 §D" },
  "development_task.comments.placeholder": { id: "development_task.comments.placeholder", domain: "development_task", text: "说说哪里还不对，它会再改一轮", vars: [], tone: "", source: "修复任务闭环 PRD v1 §D" },
  "development_task.comments.rounds": { id: "development_task.comments.rounds", domain: "development_task", text: "已经按评论改了 {rounds} 轮，最多 {max} 轮。", vars: ["max", "rounds"], tone: "", source: "修复任务闭环 PRD v1 §D" },
  "development_task.comments.submit": { id: "development_task.comments.submit", domain: "development_task", text: "发给它", vars: [], tone: "", source: "修复任务闭环 PRD v1 §D" },
  "development_task.comments.title": { id: "development_task.comments.title", domain: "development_task", text: "没修好？告诉它", vars: [], tone: "", source: "修复任务闭环 PRD v1 §D" },
  "development_task.context.api_contract": { id: "development_task.context.api_contract", domain: "development_task", text: "API 契约", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.context.asset": { id: "development_task.context.asset", domain: "development_task", text: "素材", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.context.code_path": { id: "development_task.context.code_path", domain: "development_task", text: "代码位置", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.context.data_migration": { id: "development_task.context.data_migration", domain: "development_task", text: "数据迁移", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.context.deployment": { id: "development_task.context.deployment", domain: "development_task", text: "部署说明", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.context.design": { id: "development_task.context.design", domain: "development_task", text: "设计稿", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.context.product_doc": { id: "development_task.context.product_doc", domain: "development_task", text: "产品文档", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.context.reference": { id: "development_task.context.reference", domain: "development_task", text: "参考资料", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.context.test_plan": { id: "development_task.context.test_plan", domain: "development_task", text: "测试计划", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.context.ui_route": { id: "development_task.context.ui_route", domain: "development_task", text: "页面路由", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.create.action": { id: "development_task.create.action", domain: "development_task", text: "新建开发任务", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.create.submit": { id: "development_task.create.submit", domain: "development_task", text: "创建并准备领取", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.create.submitting": { id: "development_task.create.submitting", domain: "development_task", text: "正在创建", vars: [], tone: "", source: "补充" },
  "development_task.create.subtitle": { id: "development_task.create.subtitle", domain: "development_task", text: "先把目标和验收说清楚，资料可以后补。", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.create.title": { id: "development_task.create.title", domain: "development_task", text: "开发任务", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.detail.live_sha": { id: "development_task.detail.live_sha", domain: "development_task", text: "线上 SHA", vars: [], tone: "", source: "2026-08-30 用户裁决 · 任务收件箱" },
  "development_task.detail.needs_rebase": { id: "development_task.detail.needs_rebase", domain: "development_task", text: "基线已经往前走了，需要在同一条任务上继续修。", vars: [], tone: "warn", source: "2026-08-30 用户裁决 · 任务收件箱" },
  "development_task.detail.release_id": { id: "development_task.detail.release_id", domain: "development_task", text: "发布单", vars: [], tone: "", source: "2026-08-30 用户裁决 · 任务收件箱" },
  "development_task.domain.backend": { id: "development_task.domain.backend", domain: "development_task", text: "后端", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.domain.data": { id: "development_task.domain.data", domain: "development_task", text: "数据", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.domain.design": { id: "development_task.domain.design", domain: "development_task", text: "设计", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.domain.frontend": { id: "development_task.domain.frontend", domain: "development_task", text: "前端", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.domain.infra": { id: "development_task.domain.infra", domain: "development_task", text: "基础设施", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.domain.product": { id: "development_task.domain.product", domain: "development_task", text: "产品", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.domain.qa": { id: "development_task.domain.qa", domain: "development_task", text: "测试", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.domain.release": { id: "development_task.domain.release", domain: "development_task", text: "发布", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.error.claimed": { id: "development_task.error.claimed", domain: "development_task", text: "这次任务已被领取，请取消或创建新尝试。", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.error.prepare_paused": { id: "development_task.error.prepare_paused", domain: "development_task", text: "代码环境暂时没有准备好，已暂停自动重试。", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.error.prepare_retrying": { id: "development_task.error.prepare_retrying", domain: "development_task", text: "代码环境暂时没有准备好，正在重试。", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.error.prepare_select_repo": { id: "development_task.error.prepare_select_repo", domain: "development_task", text: "代码环境暂时没有准备好，请选择仓库后再试。", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.event.attempt_claimed": { id: "development_task.event.attempt_claimed", domain: "development_task", text: "已被领取", vars: [], tone: "", source: "补充" },
  "development_task.event.attempt_progress": { id: "development_task.event.attempt_progress", domain: "development_task", text: "远程 AI 记下了进度", vars: [], tone: "", source: "2026-08-30 用户裁决 · 任务收件箱" },
  "development_task.event.attempt_state_changed": { id: "development_task.event.attempt_state_changed", domain: "development_task", text: "执行进度已更新", vars: [], tone: "", source: "补充" },
  "development_task.event.task_cancelled": { id: "development_task.event.task_cancelled", domain: "development_task", text: "任务已取消", vars: [], tone: "", source: "补充" },
  "development_task.event.task_created": { id: "development_task.event.task_created", domain: "development_task", text: "任务已创建", vars: [], tone: "", source: "补充" },
  "development_task.event.task_state_changed": { id: "development_task.event.task_state_changed", domain: "development_task", text: "任务进度已更新", vars: [], tone: "", source: "补充" },
  "development_task.event.updated": { id: "development_task.event.updated", domain: "development_task", text: "执行记录已更新", vars: [], tone: "", source: "补充" },
  "development_task.field.acceptance": { id: "development_task.field.acceptance", domain: "development_task", text: "验收标准", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.field.acceptance_hint": { id: "development_task.field.acceptance_hint", domain: "development_task", text: "每一条写成能检查的结果。", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.field.base_sha": { id: "development_task.field.base_sha", domain: "development_task", text: "基线 SHA", vars: [], tone: "", source: "补充" },
  "development_task.field.context_digest": { id: "development_task.field.context_digest", domain: "development_task", text: "Digest", vars: [], tone: "", source: "补充" },
  "development_task.field.context_kind": { id: "development_task.field.context_kind", domain: "development_task", text: "资料类型", vars: [], tone: "", source: "补充" },
  "development_task.field.context_locator": { id: "development_task.field.context_locator", domain: "development_task", text: "资料位置", vars: [], tone: "", source: "补充" },
  "development_task.field.context_title": { id: "development_task.field.context_title", domain: "development_task", text: "资料名称", vars: [], tone: "", source: "补充" },
  "development_task.field.executor": { id: "development_task.field.executor", domain: "development_task", text: "执行器标识", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.field.executor_model": { id: "development_task.field.executor_model", domain: "development_task", text: "执行模型", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.field.executor_provider": { id: "development_task.field.executor_provider", domain: "development_task", text: "执行模型提供方", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.field.instructions": { id: "development_task.field.instructions", domain: "development_task", text: "需求说明", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.field.model": { id: "development_task.field.model", domain: "development_task", text: "平台建议与审计记录", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.field.repo": { id: "development_task.field.repo", domain: "development_task", text: "代码仓库", vars: [], tone: "", source: "补充" },
  "development_task.field.title": { id: "development_task.field.title", domain: "development_task", text: "任务名称", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.hint.claim": { id: "development_task.hint.claim", domain: "development_task", text: "任务主路径是待领取、进行中、已上线、需处理或已取消。一次性凭证只在领取当时出现，不是这条任务的下一步。", vars: [], tone: "", source: "2026-08-30 用户裁决 · 五态收敛" },
  "development_task.hint.context": { id: "development_task.hint.context", domain: "development_task", text: "资料只是帮助执行者更快理解任务，不会挡住领取。", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.hint.copy_failed": { id: "development_task.hint.copy_failed", domain: "development_task", text: "没能复制，请手动选择下面这段内容。", vars: [], tone: "", source: "补充" },
  "development_task.hint.digest": { id: "development_task.hint.digest", domain: "development_task", text: "Digest 留空时只冻结资料位置，不会自动抓取外部地址。", vars: [], tone: "", source: "补充" },
  "development_task.hint.domains": { id: "development_task.hint.domains", domain: "development_task", text: "选了领域后，我会提示可能有用的资料；不选也能创建。", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.hint.draft": { id: "development_task.hint.draft", domain: "development_task", text: "还差任务名称、需求说明或一条用户确认的验收。", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.hint.executor_identity": { id: "development_task.hint.executor_identity", domain: "development_task", text: "由另一台电脑自行选择，留空不影响领取；完整填写时只作为执行器自声明记录。", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.hint.executor_identity_partial": { id: "development_task.hint.executor_identity_partial", domain: "development_task", text: "请补全或清空两项；不影响领取。", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.hint.model": { id: "development_task.hint.model", domain: "development_task", text: "这里记录平台的建议；另一台电脑实际使用什么 AI，由那台电脑自己决定。", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.hint.no_context": { id: "development_task.hint.no_context", domain: "development_task", text: "还没有附资料。", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.hint.no_recommendation": { id: "development_task.hint.no_recommendation", domain: "development_task", text: "目前没有额外建议。", vars: [], tone: "", source: "补充" },
  "development_task.hint.preparing": { id: "development_task.hint.preparing", domain: "development_task", text: "需求已经保存，正在准备代码环境。", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.hint.preparing_claim": { id: "development_task.hint.preparing_claim", domain: "development_task", text: "正在准备代码环境，准备完成后就可以领取。", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.hint.preparing_packet": { id: "development_task.hint.preparing_packet", domain: "development_task", text: "需求已经保存；代码仓库、基线和开发包准备好后才可以领取。", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.hint.ready": { id: "development_task.hint.ready", domain: "development_task", text: "目标和验收已经确认，可以领取。资料不足只会显示建议。", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.hint.request_error": { id: "development_task.hint.request_error", domain: "development_task", text: "任务暂时没有取到。", vars: [], tone: "", source: "补充" },
  "development_task.hint.timeline_empty": { id: "development_task.hint.timeline_empty", domain: "development_task", text: "任务已创建，正在等待第一条执行记录。", vars: [], tone: "", source: "补充" },
  "development_task.hint.timeline_error": { id: "development_task.hint.timeline_error", domain: "development_task", text: "执行记录暂时没有取到。", vars: [], tone: "", source: "补充" },
  "development_task.hint.timeline_loading": { id: "development_task.hint.timeline_loading", domain: "development_task", text: "正在读取执行记录。", vars: [], tone: "", source: "补充" },
  "development_task.magic.acceptance": { id: "development_task.magic.acceptance", domain: "development_task", text: "完成标准", vars: [], tone: "", source: "2026-08-13 用户裁决" },
  "development_task.magic.claim_error": { id: "development_task.magic.claim_error", domain: "development_task", text: "领取失败。", vars: [], tone: "", source: "2026-08-13 用户裁决" },
  "development_task.magic.claimed.hint": { id: "development_task.magic.claimed.hint", domain: "development_task", text: "目标：按 task_prompt 完成任务并满足验收标准。下面凭证只显示一次；使用标准 Git，只推送指定 target_ref。", vars: [], tone: "", source: "2026-09-10 RepoGate 标准 Git 协议" },
  "development_task.magic.claimed.title": { id: "development_task.magic.claimed.title", domain: "development_task", text: "“{executor}”，任务已经交给你。", vars: ["executor"], tone: "", source: "2026-08-13 用户裁决" },
  "development_task.magic.claiming": { id: "development_task.magic.claiming", domain: "development_task", text: "正在签发一次性开发 key", vars: [], tone: "", source: "2026-08-13 用户裁决" },
  "development_task.magic.copy.action": { id: "development_task.magic.copy.action", domain: "development_task", text: "复制任务提示词和 key", vars: [], tone: "", source: "2026-08-13 用户裁决" },
  "development_task.magic.copy.done": { id: "development_task.magic.copy.done", domain: "development_task", text: "已复制任务提示词和 key", vars: [], tone: "", source: "2026-08-13 用户裁决" },
  "development_task.magic.error.back": { id: "development_task.magic.error.back", domain: "development_task", text: "返回任务", vars: [], tone: "", source: "2026-08-13 用户裁决" },
  "development_task.magic.error.title": { id: "development_task.magic.error.title", domain: "development_task", text: "暂时不能接这个任务", vars: [], tone: "", source: "2026-08-13 用户裁决" },
  "development_task.magic.identity.action": { id: "development_task.magic.identity.action", domain: "development_task", text: "以这个名字领取任务", vars: [], tone: "", source: "2026-08-13 用户裁决" },
  "development_task.magic.identity.capability": { id: "development_task.magic.identity.capability", domain: "development_task", text: "邀请凭据不要放进命令参数、聊天、日志或截图。网页不会显示、复制或导出 RepoGate 和任务会话 token。", vars: [], tone: "", source: "2026-08-26 远程 AI 机器交互裁决" },
  "development_task.magic.identity.hint": { id: "development_task.magic.identity.hint", domain: "development_task", text: "本页只供人核对冻结任务，不执行领取。远程 AI 把原始邀请从标准输入交给 npc-agent，机器会自动声明稳定执行器身份并把短期凭据写入 0600 私有文件。", vars: [], tone: "", source: "2026-08-26 远程 AI 机器交互裁决" },
  "development_task.magic.identity.invalid": { id: "development_task.magic.identity.invalid", domain: "development_task", text: "标识不能包含空格或斜杠。", vars: [], tone: "", source: "2026-08-24 生产领取故障修复" },
  "development_task.magic.identity.label": { id: "development_task.magic.identity.label", domain: "development_task", text: "你给自己取的名字", vars: [], tone: "", source: "2026-08-13 用户裁决" },
  "development_task.magic.identity.placeholder": { id: "development_task.magic.identity.placeholder", domain: "development_task", text: "例如：terra-lulu-v2", vars: [], tone: "", source: "2026-08-13 用户裁决" },
  "development_task.magic.identity.title": { id: "development_task.magic.identity.title", domain: "development_task", text: "交给机器客户端", vars: [], tone: "", source: "2026-08-26 远程 AI 机器交互裁决" },
  "development_task.magic.invalid": { id: "development_task.magic.invalid", domain: "development_task", text: "这个任务链接已失效、已被领取或已经过期。", vars: [], tone: "", source: "2026-08-13 用户裁决" },
  "development_task.magic.issue.action": { id: "development_task.magic.issue.action", domain: "development_task", text: "生成并复制 AI 任务链接", vars: [], tone: "", source: "2026-08-13 用户裁决" },
  "development_task.magic.issue.pending": { id: "development_task.magic.issue.pending", domain: "development_task", text: "正在生成", vars: [], tone: "", source: "2026-08-13 用户裁决" },
  "development_task.magic.issue.renew": { id: "development_task.magic.issue.renew", domain: "development_task", text: "重新生成并复制", vars: [], tone: "", source: "2026-08-13 用户裁决" },
  "development_task.magic.issue_error": { id: "development_task.magic.issue_error", domain: "development_task", text: "暂时不能生成 AI 任务链接。", vars: [], tone: "", source: "2026-08-13 用户裁决" },
  "development_task.magic.open_error": { id: "development_task.magic.open_error", domain: "development_task", text: "无法打开任务。", vars: [], tone: "", source: "2026-08-13 用户裁决" },
  "development_task.magic.opening": { id: "development_task.magic.opening", domain: "development_task", text: "正在读取冻结任务包", vars: [], tone: "", source: "2026-08-13 用户裁决" },
  "development_task.magic.panel.hint": { id: "development_task.magic.panel.hint", domain: "development_task", text: "AI 不用注册。链接是一次性任务登录证；它先给自己取名，确认能改代码后自行领取。", vars: [], tone: "", source: "2026-08-13 用户裁决" },
  "development_task.magic.panel.title": { id: "development_task.magic.panel.title", domain: "development_task", text: "给外部 AI 一个链接", vars: [], tone: "", source: "2026-08-13 用户裁决" },
  "development_task.magic.prompt": { id: "development_task.magic.prompt", domain: "development_task", text: "任务提示词", vars: [], tone: "", source: "2026-08-13 用户裁决" },
  "development_task.magic.public.hint": { id: "development_task.magic.public.hint", domain: "development_task", text: "把原始邀请链接通过安全通道交给远程 AI。AI 应直接调用 npc-agent/v2 机器接口领取、读事件和上报进度，不需要登录平台，也不需要控制浏览器。", vars: [], tone: "", source: "2026-08-26 远程 AI 机器交互裁决" },
  "development_task.magic.public.title": { id: "development_task.magic.public.title", domain: "development_task", text: "这是机器任务入口，不需要点网页。", vars: [], tone: "", source: "2026-08-26 远程 AI 机器交互裁决" },
  "development_task.magic.request_error": { id: "development_task.magic.request_error", domain: "development_task", text: "平台暂时无法签发领取凭证。", vars: [], tone: "", source: "2026-08-13 用户裁决" },
  "development_task.magic.token_missing": { id: "development_task.magic.token_missing", domain: "development_task", text: "任务链接缺少登录证。", vars: [], tone: "", source: "2026-08-13 用户裁决" },
  "development_task.maintainer.duration.180d": { id: "development_task.maintainer.duration.180d", domain: "development_task", text: "180 天", vars: [], tone: "", source: "2026-09-01 用户裁决" },
  "development_task.maintainer.duration.30d": { id: "development_task.maintainer.duration.30d", domain: "development_task", text: "30 天", vars: [], tone: "", source: "2026-09-01 用户裁决" },
  "development_task.maintainer.duration.90d": { id: "development_task.maintainer.duration.90d", domain: "development_task", text: "90 天", vars: [], tone: "", source: "2026-08-14 用户裁决" },
  "development_task.maintainer.duration.label": { id: "development_task.maintainer.duration.label", domain: "development_task", text: "有效期", vars: [], tone: "", source: "2026-08-14 用户裁决" },
  "development_task.maintainer.duration.long_term": { id: "development_task.maintainer.duration.long_term", domain: "development_task", text: "长期，直到手动收回", vars: [], tone: "", source: "2026-08-14 用户裁决" },
  "development_task.maintainer.error.claimed": { id: "development_task.maintainer.error.claimed", domain: "development_task", text: "这项任务已经进入处理流程，不能再领取。", vars: [], tone: "", source: "2026-08-14 生产恢复复核" },
  "development_task.maintainer.error.expired": { id: "development_task.maintainer.error.expired", domain: "development_task", text: "这把长期接入 key 已过期，请让项目管理员重新签发。", vars: [], tone: "", source: "2026-08-14 生产恢复复核" },
  "development_task.maintainer.error.key_mismatch": { id: "development_task.maintainer.error.key_mismatch", domain: "development_task", text: "这把长期接入 key 已失效或不属于当前任务，请让项目管理员重新签发。", vars: [], tone: "", source: "2026-08-14 生产恢复复核" },
  "development_task.maintainer.issue": { id: "development_task.maintainer.issue", domain: "development_task", text: "生成并复制长期接入提示词", vars: [], tone: "", source: "2026-08-14 用户裁决" },
  "development_task.maintainer.label": { id: "development_task.maintainer.label", domain: "development_task", text: "长期 AI 名称或备注", vars: [], tone: "", source: "2026-08-14 用户裁决" },
  "development_task.maintainer.panel.hint": { id: "development_task.maintainer.panel.hint", domain: "development_task", text: "长期维护 AI 可按用户的明确需求直接开发，不需要先创建或领取任务；任务只用于协作记录。源码与发布凭证仍按次签发，长期身份可随时轮换或收回。", vars: [], tone: "", source: "2026-09-10 长期维护身份无需任务" },
  "development_task.maintainer.panel.title": { id: "development_task.maintainer.panel.title", domain: "development_task", text: "给长期维护 AI 一把项目 key", vars: [], tone: "", source: "2026-08-14 用户裁决" },
  "development_task.maintainer.pending": { id: "development_task.maintainer.pending", domain: "development_task", text: "正在处理长期 key", vars: [], tone: "", source: "2026-08-14 用户裁决" },
  "development_task.maintainer.placeholder": { id: "development_task.maintainer.placeholder", domain: "development_task", text: "例如：Terra 家具维护", vars: [], tone: "", source: "2026-08-14 用户裁决" },
  "development_task.maintainer.public.hint": { id: "development_task.maintainer.public.hint", domain: "development_task", text: "这是项目长期机器身份。远程 AI 应把原始邀请从标准输入交给 npc-agent；客户端会把长期身份保存在 0600 私有文件，用它列出后续任务，而每次 Git 权限仍按任务短期签发。", vars: [], tone: "", source: "2026-08-26 远程 AI 机器交互裁决" },
  "development_task.maintainer.revoke": { id: "development_task.maintainer.revoke", domain: "development_task", text: "收回长期 key", vars: [], tone: "", source: "2026-08-14 用户裁决" },
  "development_task.maintainer.rotate": { id: "development_task.maintainer.rotate", domain: "development_task", text: "轮换长期 key 并复制", vars: [], tone: "", source: "2026-08-14 用户裁决" },
  "development_task.memory.empty": { id: "development_task.memory.empty", domain: "development_task", text: "还没开始改。", vars: [], tone: "", source: "修复任务闭环 PRD v1 §C" },
  "development_task.memory.kind.comment": { id: "development_task.memory.kind.comment", domain: "development_task", text: "评论", vars: [], tone: "", source: "修复任务闭环 PRD v1 §C" },
  "development_task.memory.kind.failed_because": { id: "development_task.memory.kind.failed_because", domain: "development_task", text: "没成", vars: [], tone: "", source: "修复任务闭环 PRD v1 §C" },
  "development_task.memory.kind.note": { id: "development_task.memory.kind.note", domain: "development_task", text: "备注", vars: [], tone: "", source: "修复任务闭环 PRD v1 §C" },
  "development_task.memory.kind.tried": { id: "development_task.memory.kind.tried", domain: "development_task", text: "试过", vars: [], tone: "", source: "修复任务闭环 PRD v1 §C" },
  "development_task.memory.title": { id: "development_task.memory.title", domain: "development_task", text: "它试过什么", vars: [], tone: "", source: "修复任务闭环 PRD v1 §C" },
  "development_task.mission.action.open_preview": { id: "development_task.mission.action.open_preview", domain: "development_task", text: "打开预览", vars: [], tone: "", source: "P0-B Delivery Mission" },
  "development_task.mission.action.publish": { id: "development_task.mission.action.publish", domain: "development_task", text: "发布正式", vars: [], tone: "", source: "P0-B Delivery Mission" },
  "development_task.mission.action.rollback": { id: "development_task.mission.action.rollback", domain: "development_task", text: "回滚", vars: [], tone: "", source: "P0-B Delivery Mission" },
  "development_task.mission.action.unavailable": { id: "development_task.mission.action.unavailable", domain: "development_task", text: "打开预览、发布正式、回滚都要真实入口。现在这三条都还没有，所以都不能点。", vars: [], tone: "", source: "P0-B Delivery Mission" },
  "development_task.mission.field.integration_sha": { id: "development_task.mission.field.integration_sha", domain: "development_task", text: "合入的这一版", vars: [], tone: "", source: "P0-B Delivery Mission" },
  "development_task.mission.field.next_step": { id: "development_task.mission.field.next_step", domain: "development_task", text: "下一步", vars: [], tone: "", source: "P0-B Delivery Mission" },
  "development_task.mission.field.owner_sha": { id: "development_task.mission.field.owner_sha", domain: "development_task", text: "AI 交上来的这一版", vars: [], tone: "", source: "P0-B Delivery Mission" },
  "development_task.mission.field.preview_url": { id: "development_task.mission.field.preview_url", domain: "development_task", text: "预览地址", vars: [], tone: "", source: "P0-B Delivery Mission" },
  "development_task.mission.field.production_sha": { id: "development_task.mission.field.production_sha", domain: "development_task", text: "线上的这一版", vars: [], tone: "", source: "P0-B Delivery Mission" },
  "development_task.mission.next.cancelled": { id: "development_task.mission.next.cancelled", domain: "development_task", text: "这条任务已经取消，不能再往下走。", vars: [], tone: "", source: "P0-B Delivery Mission" },
  "development_task.mission.next.fast_test": { id: "development_task.mission.next.fast_test", domain: "development_task", text: "预览还在跑，跑通了才能看效果。", vars: [], tone: "", source: "P0-B Delivery Mission" },
  "development_task.mission.next.in_development": { id: "development_task.mission.next.in_development", domain: "development_task", text: "等 AI 交出这一版，再跑预览。", vars: [], tone: "", source: "P0-B Delivery Mission" },
  "development_task.mission.next.live": { id: "development_task.mission.next.live", domain: "development_task", text: "正式环境已经验过这一版。", vars: [], tone: "", source: "P0-D Publish Rollback" },
  "development_task.mission.next.live_rollback": { id: "development_task.mission.next.live_rollback", domain: "development_task", text: "正式环境已经验过这一版。有上一版就可以回滚。", vars: [], tone: "", source: "P0-D Publish Rollback" },
  "development_task.mission.next.needs_fix": { id: "development_task.mission.next.needs_fix", domain: "development_task", text: "这一版需要修复，修好再交。", vars: [], tone: "", source: "P0-B Delivery Mission" },
  "development_task.mission.next.pending_release": { id: "development_task.mission.next.pending_release", domain: "development_task", text: "正式发布已经受理，等平台验到线上。", vars: [], tone: "", source: "P0-D Publish Rollback" },
  "development_task.mission.next.preview_available": { id: "development_task.mission.next.preview_available", domain: "development_task", text: "预览已经跑通。打开预览看效果，或者发布正式。", vars: [], tone: "", source: "P0-B Delivery Mission" },
  "development_task.mission.next.preview_available_no_url": { id: "development_task.mission.next.preview_available_no_url", domain: "development_task", text: "预览已经跑通，但预览地址还没有，不能打开。", vars: [], tone: "", source: "P0-B Delivery Mission" },
  "development_task.mission.next.publish_failed": { id: "development_task.mission.next.publish_failed", domain: "development_task", text: "这一版发布没过，可以原位再试。", vars: [], tone: "", source: "P0-D Publish Rollback" },
  "development_task.mission.panel.hint": { id: "development_task.mission.panel.hint", domain: "development_task", text: "这一屏只说得出平台已经核对过的版本和地址。没有核对过的，不写成已上线。", vars: [], tone: "", source: "P0-B Delivery Mission" },
  "development_task.mission.panel.title": { id: "development_task.mission.panel.title", domain: "development_task", text: "交付任务", vars: [], tone: "", source: "P0-B Delivery Mission" },
  "development_task.mission.request.failure": { id: "development_task.mission.request.failure", domain: "development_task", text: "未通过", vars: [], tone: "danger", source: "P0-D Publish Rollback" },
  "development_task.mission.request.running": { id: "development_task.mission.request.running", domain: "development_task", text: "进行中", vars: [], tone: "", source: "P0-D Publish Rollback" },
  "development_task.mission.request.success": { id: "development_task.mission.request.success", domain: "development_task", text: "已完成", vars: [], tone: "ok", source: "P0-D Publish Rollback" },
  "development_task.mission.status.fast_test": { id: "development_task.mission.status.fast_test", domain: "development_task", text: "快速测试", vars: [], tone: "info", source: "P0-B Delivery Mission" },
  "development_task.mission.status.in_development": { id: "development_task.mission.status.in_development", domain: "development_task", text: "开发中", vars: [], tone: "", source: "P0-B Delivery Mission" },
  "development_task.mission.status.live": { id: "development_task.mission.status.live", domain: "development_task", text: "已上线", vars: [], tone: "ok", source: "P0-B Delivery Mission" },
  "development_task.mission.status.needs_fix": { id: "development_task.mission.status.needs_fix", domain: "development_task", text: "需修复", vars: [], tone: "danger", source: "P0-B Delivery Mission" },
  "development_task.mission.status.pending_release": { id: "development_task.mission.status.pending_release", domain: "development_task", text: "待发布", vars: [], tone: "warn", source: "P0-B Delivery Mission" },
  "development_task.mission.status.preview_available": { id: "development_task.mission.status.preview_available", domain: "development_task", text: "预览可用", vars: [], tone: "ok", source: "P0-B Delivery Mission" },
  "development_task.mission.unavailable": { id: "development_task.mission.unavailable", domain: "development_task", text: "还没有", vars: [], tone: "", source: "P0-B Delivery Mission" },
  "development_task.optional.summary": { id: "development_task.optional.summary", domain: "development_task", text: "已选 {domains} 个领域，附 {contexts} 份资料。", vars: ["contexts", "domains"], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.preview.action": { id: "development_task.preview.action", domain: "development_task", text: "让我先跑一遍", vars: [], tone: "", source: "补充" },
  "development_task.preview.again": { id: "development_task.preview.again", domain: "development_task", text: "再跑一遍这一版", vars: [], tone: "", source: "补充" },
  "development_task.preview.blame.access": { id: "development_task.preview.blame.access", domain: "development_task", text: "卡在这个项目上——这台浏览器现在动不了它。", vars: [], tone: "", source: "补充" },
  "development_task.preview.blame.input": { id: "development_task.preview.blame.input", domain: "development_task", text: "卡在这一版本身——我认不出它，得等 AI 把结果交清楚。", vars: [], tone: "", source: "补充" },
  "development_task.preview.blame.label": { id: "development_task.preview.blame.label", domain: "development_task", text: "这次卡在哪", vars: [], tone: "", source: "补充" },
  "development_task.preview.blame.offline": { id: "development_task.preview.blame.offline", domain: "development_task", text: "卡在半路——这句话没递到平台。是网络或者平台地址的事，跟这一版代码无关。", vars: [], tone: "", source: "补充" },
  "development_task.preview.blame.platform": { id: "development_task.preview.blame.platform", domain: "development_task", text: "卡在我这边——预览还没接好，跟 AI 交上来的这一版没关系。", vars: [], tone: "", source: "补充" },
  "development_task.preview.blame.unknown": { id: "development_task.preview.blame.unknown", domain: "development_task", text: "我没看明白这次卡在哪，先记下了。", vars: [], tone: "", source: "补充" },
  "development_task.preview.blame.version": { id: "development_task.preview.blame.version", domain: "development_task", text: "卡在版本上——这一版要么已经在跑了，要么 AI 又交了新的。刷新一下再看。", vars: [], tone: "", source: "补充" },
  "development_task.preview.closed": { id: "development_task.preview.closed", domain: "development_task", text: "这条任务已经收摊了，不再跑预览。", vars: [], tone: "", source: "补充" },
  "development_task.preview.field.owner_tip": { id: "development_task.preview.field.owner_tip", domain: "development_task", text: "AI 交上来的这一版", vars: [], tone: "", source: "补充" },
  "development_task.preview.field.preview_sha": { id: "development_task.preview.field.preview_sha", domain: "development_task", text: "正在预览的这一版", vars: [], tone: "", source: "补充" },
  "development_task.preview.field.release_sha": { id: "development_task.preview.field.release_sha", domain: "development_task", text: "已经发出去的这一版", vars: [], tone: "", source: "补充" },
  "development_task.preview.panel.hint": { id: "development_task.preview.panel.hint", domain: "development_task", text: "这一版会单独跑一份预览，跟正式发布是两回事；没跑通我自己退回去，你线上那套一直不动。", vars: [], tone: "", source: "补充" },
  "development_task.preview.panel.title": { id: "development_task.preview.panel.title", domain: "development_task", text: "先看看效果", vars: [], tone: "", source: "补充" },
  "development_task.preview.pending": { id: "development_task.preview.pending", domain: "development_task", text: "正在交给预览", vars: [], tone: "", source: "补充" },
  "development_task.preview.rollback": { id: "development_task.preview.rollback", domain: "development_task", text: "预览那份已经恢复原样，你线上那套自始至终没动过。", vars: [], tone: "", source: "补充" },
  "development_task.preview.state.owner_tip": { id: "development_task.preview.state.owner_tip", domain: "development_task", text: "刚交上来，还没排上", vars: [], tone: "", source: "补充" },
  "development_task.preview.state.preview_failed_rolled_back": { id: "development_task.preview.state.preview_failed_rolled_back", domain: "development_task", text: "没跑通，我已经把预览退回去了", vars: [], tone: "danger", source: "补充" },
  "development_task.preview.state.preview_ready": { id: "development_task.preview.state.preview_ready", domain: "development_task", text: "排上了，马上开始跑", vars: [], tone: "info", source: "补充" },
  "development_task.preview.state.preview_running": { id: "development_task.preview.state.preview_running", domain: "development_task", text: "我正在跑这一版", vars: [], tone: "info", source: "补充" },
  "development_task.preview.state.production_verified": { id: "development_task.preview.state.production_verified", domain: "development_task", text: "正式环境也验过了", vars: [], tone: "ok", source: "补充" },
  "development_task.preview.state.release_requested": { id: "development_task.preview.state.release_requested", domain: "development_task", text: "我在申请把这一版正式发出去", vars: [], tone: "info", source: "补充" },
  "development_task.preview.state.test_candidate": { id: "development_task.preview.state.test_candidate", domain: "development_task", text: "跑通了，可以去看效果了", vars: [], tone: "ok", source: "补充" },
  "development_task.preview.view_only": { id: "development_task.preview.view_only", domain: "development_task", text: "这个项目你现在只能看。要跑预览，得让能动手的人来点。", vars: [], tone: "", source: "补充" },
  "development_task.preview.waiting": { id: "development_task.preview.waiting", domain: "development_task", text: "等 AI 把这一版交上来，我才跑得了预览。", vars: [], tone: "", source: "补充" },
  "development_task.redline.what": { id: "development_task.redline.what", domain: "development_task", text: "「{title}」这一步碰到钱了，得你点一下。", vars: ["title"], tone: "", source: "修复任务闭环 PRD v1 §A" },
  "development_task.remote_ai.invitation.pending_hint": { id: "development_task.remote_ai.invitation.pending_hint", domain: "development_task", text: "邀请链接只在生成那一次显示，这里看不到也找不回。要是没能交到那个 AI 手上，就在这儿把它作废——重新生成一张不会让这一张失效。", vars: [], tone: "", source: "2026-09-02 邀请主动撤销" },
  "development_task.remote_ai.invitation.revoke": { id: "development_task.remote_ai.invitation.revoke", domain: "development_task", text: "作废这张邀请", vars: [], tone: "", source: "2026-09-02 邀请主动撤销" },
  "development_task.remote_ai.invitation.revoke_confirm": { id: "development_task.remote_ai.invitation.revoke_confirm", domain: "development_task", text: "作废这张邀请？之后这条链接谁拿到都用不了了。要再给这个 AI 一次机会，得重新生成一张发过去。", vars: [], tone: "", source: "2026-09-02 邀请主动撤销" },
  "development_task.remote_ai.invitation.revoke_failed": { id: "development_task.remote_ai.invitation.revoke_failed", domain: "development_task", text: "这张邀请没作废成，它还能被领走。再点一次试试。", vars: [], tone: "", source: "2026-09-02 邀请主动撤销" },
  "development_task.remote_ai.invitation.revoking": { id: "development_task.remote_ai.invitation.revoking", domain: "development_task", text: "正在作废", vars: [], tone: "", source: "2026-09-02 邀请主动撤销" },
  "development_task.repo.account_error": { id: "development_task.repo.account_error", domain: "development_task", text: "暂时没有确认你的项目权限。", vars: [], tone: "", source: "补充" },
  "development_task.repo.all_unavailable": { id: "development_task.repo.all_unavailable", domain: "development_task", text: "关联的代码仓库暂时都取不到可用基线，稍后再试。", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.repo.association_error": { id: "development_task.repo.association_error", domain: "development_task", text: "已关联的代码仓库暂时没有取到。", vars: [], tone: "", source: "补充" },
  "development_task.repo.association_loading": { id: "development_task.repo.association_loading", domain: "development_task", text: "正在确认可关联的代码仓库。", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.repo.candidate_empty_option": { id: "development_task.repo.candidate_empty_option", domain: "development_task", text: "“{repo}”（还没有代码）", vars: ["repo"], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.repo.candidate_label": { id: "development_task.repo.candidate_label", domain: "development_task", text: "选择代码仓库", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.repo.candidate_select": { id: "development_task.repo.candidate_select", domain: "development_task", text: "请选择", vars: [], tone: "", source: "补充" },
  "development_task.repo.candidates_error": { id: "development_task.repo.candidates_error", domain: "development_task", text: "暂时没有取到可关联的代码仓库。", vars: [], tone: "", source: "补充" },
  "development_task.repo.candidates_unavailable": { id: "development_task.repo.candidates_unavailable", domain: "development_task", text: "代码仓库服务暂时没有响应。", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.repo.empty_hint": { id: "development_task.repo.empty_hint", domain: "development_task", text: "另有 {count} 个空仓库，推送第一笔代码后就能关联。", vars: ["count"], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.repo.error": { id: "development_task.repo.error", domain: "development_task", text: "代码仓库暂时没有取到。", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.repo.link_action": { id: "development_task.repo.link_action", domain: "development_task", text: "关联代码仓库", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.repo.link_conflict": { id: "development_task.repo.link_conflict", domain: "development_task", text: "这个仓库的关联刚刚发生变化，请重新选择。", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.repo.link_error": { id: "development_task.repo.link_error", domain: "development_task", text: "这次没有关联成功，请重试。", vars: [], tone: "", source: "补充" },
  "development_task.repo.link_hint": { id: "development_task.repo.link_hint", domain: "development_task", text: "关联后就能直接创建任务，不需要填写地址、分支或 SHA。", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.repo.link_unavailable": { id: "development_task.repo.link_unavailable", domain: "development_task", text: "代码仓库服务暂时没有响应，请稍后再试。", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.repo.linking": { id: "development_task.repo.linking", domain: "development_task", text: "正在关联", vars: [], tone: "", source: "补充" },
  "development_task.repo.loading": { id: "development_task.repo.loading", domain: "development_task", text: "正在确认代码仓库。", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.repo.no_candidates": { id: "development_task.repo.no_candidates", domain: "development_task", text: "还没有可关联的代码仓库。先在代码仓库服务里创建一个，再回来重试。", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.repo.none": { id: "development_task.repo.none", domain: "development_task", text: "这个项目还没有关联代码仓库。", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.repo.option_unavailable": { id: "development_task.repo.option_unavailable", domain: "development_task", text: "“{repo}”（暂时不可用）", vars: ["repo"], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.repo.permission": { id: "development_task.repo.permission", domain: "development_task", text: "需要项目管理员先关联代码仓库。", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.repo.refreshing": { id: "development_task.repo.refreshing", domain: "development_task", text: "仓库已关联，正在准备开发任务。", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.repo.retrying": { id: "development_task.repo.retrying", domain: "development_task", text: "正在重试", vars: [], tone: "", source: "补充" },
  "development_task.repo.select": { id: "development_task.repo.select", domain: "development_task", text: "选择代码仓库", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.repo.select_hint": { id: "development_task.repo.select_hint", domain: "development_task", text: "平台会实时确认默认分支和基线，不需要手填 SHA。", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.repo.single_unavailable": { id: "development_task.repo.single_unavailable", domain: "development_task", text: "“{repo}”暂时取不到可用基线，稍后再试。", vars: ["repo"], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.section.advanced": { id: "development_task.section.advanced", domain: "development_task", text: "高级设置", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.section.attached": { id: "development_task.section.attached", domain: "development_task", text: "已附资料", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.section.context": { id: "development_task.section.context", domain: "development_task", text: "建议补充", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.section.details": { id: "development_task.section.details", domain: "development_task", text: "任务信息", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.section.domains": { id: "development_task.section.domains", domain: "development_task", text: "涉及领域", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.section.executor_identity": { id: "development_task.section.executor_identity", domain: "development_task", text: "实际执行模型（可选）", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.section.git": { id: "development_task.section.git", domain: "development_task", text: "代码基线", vars: [], tone: "", source: "补充" },
  "development_task.section.optional": { id: "development_task.section.optional", domain: "development_task", text: "可选资料", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.section.packet": { id: "development_task.section.packet", domain: "development_task", text: "冻结任务包", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.section.recommended": { id: "development_task.section.recommended", domain: "development_task", text: "推荐补充", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.section.status": { id: "development_task.section.status", domain: "development_task", text: "当前进度", vars: [], tone: "", source: "补充" },
  "development_task.section.timeline": { id: "development_task.section.timeline", domain: "development_task", text: "执行时间线", vars: [], tone: "", source: "补充" },
  "development_task.stage.claimed": { id: "development_task.stage.claimed", domain: "development_task", text: "我领到了「{title}」，开始改。这一轮是第 {attempt} 次。", vars: ["attempt", "title"], tone: "", source: "修复任务闭环 PRD v1 §B" },
  "development_task.stage.delivered": { id: "development_task.stage.delivered", domain: "development_task", text: "「{title}」改好了，推上去了（{sha}）。接下来过门、切流、健康检查。", vars: ["sha", "title"], tone: "", source: "修复任务闭环 PRD v1 §B" },
  "development_task.stage.exhausted": { id: "development_task.stage.exhausted", domain: "development_task", text: "「{title}」我改了 {rounds} 轮还没让你满意，换个人看看吧。", vars: ["rounds", "title"], tone: "", source: "修复任务闭环 PRD v1 §D" },
  "development_task.stage.failed": { id: "development_task.stage.failed", domain: "development_task", text: "「{title}」没过，线上退回去了（现在跑的是 {sha}）。我会再看一遍。", vars: ["sha", "title"], tone: "", source: "修复任务闭环 PRD v1 §B" },
  "development_task.stage.verified": { id: "development_task.stage.verified", domain: "development_task", text: "「{title}」上线了，生产现在跑的是 {sha}。", vars: ["sha", "title"], tone: "", source: "修复任务闭环 PRD v1 §B" },
  "development_task.stagecard.cancelled": { id: "development_task.stagecard.cancelled", domain: "development_task", text: "取消了", vars: [], tone: "", source: "修复任务闭环 PRD v1 §E" },
  "development_task.stagecard.ci": { id: "development_task.stagecard.ci", domain: "development_task", text: "过门", vars: [], tone: "", source: "修复任务闭环 PRD v1 §E" },
  "development_task.stagecard.claimed": { id: "development_task.stagecard.claimed", domain: "development_task", text: "领到了", vars: [], tone: "", source: "修复任务闭环 PRD v1 §E" },
  "development_task.stagecard.decision": { id: "development_task.stagecard.decision", domain: "development_task", text: "等你点一下", vars: [], tone: "", source: "修复任务闭环 PRD v1 §E" },
  "development_task.stagecard.delivered": { id: "development_task.stagecard.delivered", domain: "development_task", text: "推上去了", vars: [], tone: "", source: "修复任务闭环 PRD v1 §E" },
  "development_task.stagecard.failed": { id: "development_task.stagecard.failed", domain: "development_task", text: "没成", vars: [], tone: "", source: "修复任务闭环 PRD v1 §E" },
  "development_task.stagecard.fix_requested": { id: "development_task.stagecard.fix_requested", domain: "development_task", text: "打回再改", vars: [], tone: "", source: "修复任务闭环 PRD v1 §E" },
  "development_task.stagecard.live": { id: "development_task.stagecard.live", domain: "development_task", text: "上线了", vars: [], tone: "", source: "修复任务闭环 PRD v1 §E" },
  "development_task.stagecard.ready": { id: "development_task.stagecard.ready", domain: "development_task", text: "可以上了", vars: [], tone: "", source: "修复任务闭环 PRD v1 §E" },
  "development_task.stagecard.reviewing": { id: "development_task.stagecard.reviewing", domain: "development_task", text: "独立复核", vars: [], tone: "", source: "修复任务闭环 PRD v1 §E" },
  "development_task.stages.attempt": { id: "development_task.stages.attempt", domain: "development_task", text: "第 {n} 轮", vars: ["n"], tone: "", source: "修复任务闭环 PRD v1 §E" },
  "development_task.stages.empty": { id: "development_task.stages.empty", domain: "development_task", text: "还没开始干，等有人领。", vars: [], tone: "", source: "修复任务闭环 PRD v1 §E" },
  "development_task.stages.live_note": { id: "development_task.stages.live_note", domain: "development_task", text: "上线时刻按最后一行事件算，是下界。", vars: [], tone: "", source: "修复任务闭环 PRD v1 §E" },
  "development_task.stages.title": { id: "development_task.stages.title", domain: "development_task", text: "走到哪了", vars: [], tone: "", source: "修复任务闭环 PRD v1 §E" },
  "development_task.stages.total": { id: "development_task.stages.total", domain: "development_task", text: "从领到到现在 {elapsed}", vars: ["elapsed"], tone: "", source: "修复任务闭环 PRD v1 §E" },
  "development_task.state.cancelled": { id: "development_task.state.cancelled", domain: "development_task", text: "已取消", vars: [], tone: "", source: "补充" },
  "development_task.state.ci_running": { id: "development_task.state.ci_running", domain: "development_task", text: "进行中", vars: [], tone: "", source: "2026-08-30 用户裁决 · 五态收敛" },
  "development_task.state.draft": { id: "development_task.state.draft", domain: "development_task", text: "等你确认目标", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.state.failed": { id: "development_task.state.failed", domain: "development_task", text: "需处理", vars: [], tone: "danger", source: "2026-08-30 用户裁决 · 五态收敛" },
  "development_task.state.fix_requested": { id: "development_task.state.fix_requested", domain: "development_task", text: "需处理", vars: [], tone: "danger", source: "2026-08-30 用户裁决 · 五态收敛" },
  "development_task.state.gating": { id: "development_task.state.gating", domain: "development_task", text: "进行中", vars: [], tone: "", source: "2026-08-30 用户裁决 · 五态收敛" },
  "development_task.state.pending_approval": { id: "development_task.state.pending_approval", domain: "development_task", text: "进行中", vars: [], tone: "", source: "2026-08-30 用户裁决 · 五态收敛" },
  "development_task.state.preparing": { id: "development_task.state.preparing", domain: "development_task", text: "正在准备代码环境", vars: [], tone: "", source: "2026-08-12 用户裁决" },
  "development_task.state.ready": { id: "development_task.state.ready", domain: "development_task", text: "进行中", vars: [], tone: "", source: "2026-08-30 用户裁决 · 五态收敛" },
  "development_task.state.ready_to_claim": { id: "development_task.state.ready_to_claim", domain: "development_task", text: "待领取", vars: [], tone: "ok", source: "2026-08-30 用户裁决 · 五态收敛" },
  "development_task.state.reviewing": { id: "development_task.state.reviewing", domain: "development_task", text: "进行中", vars: [], tone: "", source: "2026-08-30 用户裁决 · 五态收敛" },
  "development_task.state.running": { id: "development_task.state.running", domain: "development_task", text: "进行中", vars: [], tone: "", source: "2026-08-30 用户裁决 · 五态收敛" },
  "development_task.state.v2_handoff": { id: "development_task.state.v2_handoff", domain: "development_task", text: "进行中", vars: [], tone: "", source: "2026-08-30 用户裁决 · 五态收敛" },
  "development_task.user_state.cancelled": { id: "development_task.user_state.cancelled", domain: "development_task", text: "已取消", vars: [], tone: "", source: "2026-08-30 用户裁决 · 五态收敛" },
  "development_task.user_state.claimable": { id: "development_task.user_state.claimable", domain: "development_task", text: "待领取", vars: [], tone: "ok", source: "2026-08-30 用户裁决 · 五态收敛" },
  "development_task.user_state.in_progress": { id: "development_task.user_state.in_progress", domain: "development_task", text: "进行中", vars: [], tone: "", source: "2026-08-30 用户裁决 · 五态收敛" },
  "development_task.user_state.live": { id: "development_task.user_state.live", domain: "development_task", text: "已上线", vars: [], tone: "ok", source: "2026-08-30 用户裁决 · 五态收敛" },
  "development_task.user_state.needs_action": { id: "development_task.user_state.needs_action", domain: "development_task", text: "需处理", vars: [], tone: "danger", source: "2026-08-30 用户裁决 · 五态收敛" },
  "duty.cards.heading": { id: "duty.cards.heading", domain: "duty", text: "这些本事", vars: [], tone: "", source: "M6-16" },
  "duty.collab.pending": { id: "duty.collab.pending", domain: "duty", text: "多 AI 协同还没启用", vars: [], tone: "", source: "M7-04" },
  "duty.kind.act": { id: "duty.kind.act", domain: "duty", text: "会动手", vars: [], tone: "", source: "M6-16" },
  "duty.kind.observe": { id: "duty.kind.observe", domain: "duty", text: "只看", vars: [], tone: "", source: "M6-16" },
  "duty.page.subtitle": { id: "duty.page.subtitle", domain: "duty", text: "平台自己在盯的那些本事。关掉一项，它就只报告、不动手。", vars: [], tone: "", source: "M6-16" },
  "duty.page.title": { id: "duty.page.title", domain: "duty", text: "排班与自动处置", vars: [], tone: "", source: "M6-16" },
  "duty.schedule.empty": { id: "duty.schedule.empty", domain: "duty", text: "还没有排上的本事。", vars: [], tone: "", source: "M6-16" },
  "duty.schedule.heading": { id: "duty.schedule.heading", domain: "duty", text: "现在的排班", vars: [], tone: "", source: "M6-16" },
  "duty.schedule.source": { id: "duty.schedule.source", domain: "duty", text: "平台自带", vars: [], tone: "", source: "M6-16" },
  "duty.toggle.off": { id: "duty.toggle.off", domain: "duty", text: "关了", vars: [], tone: "", source: "M6-16" },
  "duty.toggle.on": { id: "duty.toggle.on", domain: "duty", text: "开着", vars: [], tone: "", source: "M6-16" },
  "error.conversation.attachment_bad_type": { id: "error.conversation.attachment_bad_type", domain: "error", text: "这种文件先不收。能收的是图片（png、jpg、webp、gif）和常见文档（pdf、txt、md、csv、json、zip）。", vars: [], tone: "warn", source: "补充" },
  "error.conversation.attachment_looks_like_key": { id: "error.conversation.attachment_looks_like_key", domain: "error", text: "这个文件里像是一把私钥，我不收。密钥不该发到对话里 —— 要连服务器的话，去「机器」那边贴。", vars: [], tone: "warn", source: "补充" },
  "error.conversation.attachment_not_claimable": { id: "error.conversation.attachment_not_claimable", domain: "error", text: "有附件挂不上去 —— 可能已经发出去了，或者不是这条会话的。重新传一次就行。", vars: [], tone: "warn", source: "补充" },
  "error.conversation.attachment_too_large": { id: "error.conversation.attachment_too_large", domain: "error", text: "这个文件超过 10MB 了，传不上去。挑个小一点的，或者传到别处把链接发给我。", vars: [], tone: "warn", source: "补充" },
  "error.conversation.attachment_too_many": { id: "error.conversation.attachment_too_many", domain: "error", text: "一条消息最多挂 10 个附件。先发这一批，剩下的下一条再发。", vars: [], tone: "warn", source: "补充" },
  "error.conversation.attachment_type_mismatch": { id: "error.conversation.attachment_type_mismatch", domain: "error", text: "这个文件的内容和它的后缀对不上 —— 我没敢收。确认一下是不是选错了文件。", vars: [], tone: "warn", source: "补充" },
  "error.executor_unavailable": { id: "error.executor_unavailable", domain: "error", text: "这一步我动不了手——平台到那台机器的通道还没接上。你点了也不会有任何事发生，所以这次确认我不收下。", vars: [], tone: "warn", source: "补充" },
  "error.forbidden.hosts": { id: "error.forbidden.hosts", domain: "error", text: "这一页你看不到。不是坏了，是这个账户没有机器这一档的权限。找能管机器的人开一下。", vars: [], tone: "", source: "资源模块 SPEC 2026-08-27 · R17" },
  "error.generic": { id: "error.generic", domain: "error", text: "这一下没成，我再试试。要是一直不行我会告诉你。", vars: [], tone: "warn", source: "补充" },
  "error.job_stalled": { id: "error.job_stalled", domain: "error", text: "这件事跑了 {minutes} 分钟没动静，我先停下了。卡在「{step}」这一步。", vars: ["minutes", "step"], tone: "warn", source: "补充" },
  "error.memo.attachment_bad_type": { id: "error.memo.attachment_bad_type", domain: "error", text: "这种文件先不收。支持的：图片（png、jpg、webp、gif）和常见文档（pdf、txt、md、csv、json、zip）。", vars: [], tone: "warn", source: "补充" },
  "error.memo.attachment_too_large": { id: "error.memo.attachment_too_large", domain: "error", text: "这个附件太大了（超过 10MB），备忘录不放这种大文件——传到别处，把链接记下来。", vars: [], tone: "warn", source: "补充" },
  "error.memo.audio_bad_type": { id: "error.memo.audio_bad_type", domain: "error", text: "这个录音格式我认不了，用浏览器录出来的那种就行。", vars: [], tone: "warn", source: "补充" },
  "error.memo.audio_too_large": { id: "error.memo.audio_too_large", domain: "error", text: "这条录音太大了（超过 5MB），录短一点再存。", vars: [], tone: "warn", source: "补充" },
  "error.memo.audio_too_long": { id: "error.memo.audio_too_long", domain: "error", text: "这条录音超过 10 分钟了，拆成几条短的再存。", vars: [], tone: "warn", source: "补充" },
  "error.memo.password_too_short": { id: "error.memo.password_too_short", domain: "error", text: "密码至少 4 个字符。这是挡一眼的锁，不是账号口令——太长的规则只会逼人把密码写进正文里。", vars: [], tone: "warn", source: "补充" },
  "error.memo.password_wrong": { id: "error.memo.password_wrong", domain: "error", text: "密码不对。这条的内容只有输对密码才能看——再试一次，或去改掉这条的密码。", vars: [], tone: "warn", source: "补充" },
  "error.memo.unlock_throttled": { id: "error.memo.unlock_throttled", domain: "error", text: "密码试的次数有点多，先等一分钟再试。这条没坏，也不缺东西。", vars: [], tone: "warn", source: "补充" },
  "error.memo.version_conflict": { id: "error.memo.version_conflict", domain: "error", text: "这条别人刚改过，你手里的还是旧版本。两个版本都在，选一个再存。", vars: [], tone: "warn", source: "补充" },
  "error.memo.voice_needs_access": { id: "error.memo.voice_needs_access", domain: "error", text: "语音备忘存之前先选一下：这条 AI 能不能读。", vars: [], tone: "warn", source: "补充" },
  "error.not_found": { id: "error.not_found", domain: "error", text: "找不到这个东西了，可能已经被删掉。", vars: [], tone: "neutral", source: "补充" },
  "error.rate_limited": { id: "error.rate_limited", domain: "error", text: "有点太快了，等 {seconds} 秒再来一次。", vars: ["seconds"], tone: "neutral", source: "补充" },
  "error.read_failed.retry": { id: "error.read_failed.retry", domain: "error", text: "再试一次", vars: [], tone: "", source: "资源模块 SPEC 2026-08-27 · R16" },
  "error.read_failed.title": { id: "error.read_failed.title", domain: "error", text: "这一下没读到", vars: [], tone: "", source: "资源模块 SPEC 2026-08-27 · R16" },
  "error.step_up_required": { id: "error.step_up_required", domain: "error", text: "这一步得你当场再验一次——给我个机会发一封验证码，或者输一次登录密码。", vars: [], tone: "warn", source: "补充" },
  "error.unauthorized": { id: "error.unauthorized", domain: "error", text: "你这次的登录已经过期了，重新登一下就好。", vars: [], tone: "neutral", source: "补充" },
  "error.upstream_down": { id: "error.upstream_down", domain: "error", text: "{vendor}那边现在连不上，不是你的问题。我会一直重试，好了告诉你。", vars: ["vendor"], tone: "warn", source: "补充" },
  "host.access.credential.kept": { id: "host.access.credential.kept", domain: "host", text: "你当初给我的那份我留着——加密存着，忘了的话可以在这儿看一眼。", vars: [], tone: "neutral", source: "契约 openapi.yaml · AccessMethod.user_credential" },
  "host.access.credential.revoked": { id: "host.access.credential.revoked", domain: "host", text: "你当初给我的那份，你已经让我删掉了。这台机器我现在只靠自己那把钥匙进。", vars: [], tone: "warn", source: "契约 openapi.yaml · AccessMethod.user_credential.revoked" },
  "host.access.heading": { id: "host.access.heading", domain: "host", text: "万一我这边挂了，你还进得去吗", vars: [], tone: "", source: "补充" },
  "host.access.keys.heading": { id: "host.access.keys.heading", domain: "host", text: "这台机器上现在有哪几把钥匙", vars: [], tone: "", source: "补充（arron 2026-08-09）" },
  "host.access.keys.ours": { id: "host.access.keys.ours", domain: "host", text: "我自己那把——接你这台机器的时候加上去的。撤掉它不影响你进来。", vars: [], tone: "neutral", source: "补充（arron 2026-08-09）" },
  "host.access.keys.yours": { id: "host.access.keys.yours", domain: "host", text: "你自己的 {count} 把——我从来没动过它们。平台要是哪天挂了，你还能用它们进来。", vars: ["count"], tone: "ok", source: "补充（arron 2026-08-09）" },
  "host.access.keys.yours_none": { id: "host.access.keys.yours_none", domain: "host", text: "这台机器上没有你自己的钥匙了，只剩我那一把。", vars: [], tone: "danger", source: "补充（arron 2026-08-09）" },
  "host.access.original.keys": { id: "host.access.original.keys", domain: "host", text: "进得去。你自己的钥匙还在这台机器上，一共 {count} 把。我那把是多加的一把，不影响你。", vars: ["count"], tone: "ok", source: "契约 openapi.yaml · AccessMethod.original_access = keys" },
  "host.access.original.none": { id: "host.access.original.none", domain: "host", text: "这台机器上现在只剩我这一把钥匙了。是我早先接管的时候，把你自己的那几把一起删掉了——不是你哪儿做错了，是我删的。我正在把它补回来。", vars: [], tone: "danger", source: "契约 openapi.yaml · AccessMethod.original_access = none" },
  "host.access.original.password": { id: "host.access.original.password", domain: "host", text: "进得去。这台机器的密码登录还开着，你当初给我的那个密码就能登。我那把钥匙是多加的一把，不影响你。", vars: [], tone: "ok", source: "契约 openapi.yaml · AccessMethod.original_access = password" },
  "host.access.original.unknown": { id: "host.access.original.unknown", domain: "host", text: "我这次没能连上这台机器，没当场看一眼。你原来那条路我说不准——不是说它没了，是我这会儿不知道。", vars: [], tone: "warn", source: "契约 openapi.yaml · AccessMethod.original_access = unknown" },
  "host.access.original.unknown_reachable": { id: "host.access.original.unknown_reachable", domain: "host", text: "你原来那条路我这次没去看，说不准——不是说它没了，是我这会儿不知道。", vars: [], tone: "warn", source: "契约 openapi.yaml · original_access = unknown 且 reach.kind = ok" },
  "host.access.ours.checked_at": { id: "host.access.ours.checked_at", domain: "host", text: "上次验它：{when}。", vars: ["when"], tone: "", source: "契约 openapi.yaml · AccessMethod.platform_key_installed" },
  "host.access.ours.status.unknown": { id: "host.access.ours.status.unknown", domain: "host", text: "我这把这次没去验，说不准。", vars: [], tone: "warn", source: "契约 openapi.yaml · AccessMethod.platform_key_installed" },
  "host.access.ours.status.unusable": { id: "host.access.ours.status.unusable", domain: "host", text: "我这把进不去了，所以这台机器我暂时管不了。你自己那条路不受影响。", vars: [], tone: "warn", source: "契约 openapi.yaml · AccessMethod.platform_key_installed" },
  "host.access.ours.status.usable": { id: "host.access.ours.status.usable", domain: "host", text: "还能用——巡检、发布、修东西都走它。", vars: [], tone: "ok", source: "契约 openapi.yaml · AccessMethod.platform_key_installed" },
  "host.access.ours.used_by": { id: "host.access.ours.used_by", domain: "host", text: "只有我在用它。撤掉它我就管不了这台机器了，但不影响你自己进来。", vars: [], tone: "", source: "契约 openapi.yaml · AccessMethod.platform_key_installed" },
  "host.access.stale": { id: "host.access.stale", domain: "host", text: "这是存档：{checked_at}。不是刚才看到的。", vars: ["checked_at"], tone: "warn", source: "契约 openapi.yaml · AccessMethod.live = false" },
  "host.access.yours.checked_at": { id: "host.access.yours.checked_at", domain: "host", text: "上次验它：{when}。", vars: ["when"], tone: "", source: "契约 openapi.yaml · AccessMethod.user_credential" },
  "host.access.yours.never_checked": { id: "host.access.yours.never_checked", domain: "host", text: "我还没验过这把。", vars: [], tone: "warn", source: "契约 openapi.yaml · AccessMethod.user_credential" },
  "host.access.yours.status.unknown": { id: "host.access.yours.status.unknown", domain: "host", text: "这把我这次没去验，说不准现在还灵不灵。", vars: [], tone: "warn", source: "契约 openapi.yaml · AccessMethod.user_credential" },
  "host.access.yours.status.unusable": { id: "host.access.yours.status.unusable", domain: "host", text: "这把现在进不去了。也就是说，你眼下没有一条不靠我的路能进这台机器。", vars: [], tone: "danger", source: "契约 openapi.yaml · AccessMethod.user_credential" },
  "host.access.yours.status.usable": { id: "host.access.yours.status.usable", domain: "host", text: "还能用——你自己进这台机器，用的就是它。", vars: [], tone: "ok", source: "契约 openapi.yaml · AccessMethod.user_credential" },
  "host.access.yours.used_by": { id: "host.access.yours.used_by", domain: "host", text: "只有你在用它。我干活从来不走这把——我走我自己那把。", vars: [], tone: "", source: "契约 openapi.yaml · AccessMethod.user_credential" },
  "host.action.connect_myself": { id: "host.action.connect_myself", domain: "host", text: "我要自己连上去", vars: [], tone: "", source: "设计稿 · 机器详情" },
  "host.action.reconnect": { id: "host.action.reconnect", domain: "host", text: "重新接一次", vars: [], tone: "", source: "机器模块 PRD v1 · 详情连通" },
  "host.action.temp_key": { id: "host.action.temp_key", domain: "host", text: "给 AI 一把临时钥匙", vars: [], tone: "", source: "设计稿 · 机器详情" },
  "host.busy.heading": { id: "host.busy.heading", domain: "host", text: "忙不忙", vars: [], tone: "", source: "设计稿 · 机器详情" },
  "host.busy.window": { id: "host.busy.window", domain: "host", text: "最近 24 小时", vars: [], tone: "", source: "设计稿 · 机器详情" },
  "host.card.activity": { id: "host.card.activity", domain: "host", text: "最近活动", vars: [], tone: "", source: "机器模块 PRD v1 · 列表卡片" },
  "host.card.agent": { id: "host.card.agent", domain: "host", text: "Agent", vars: [], tone: "", source: "机器模块 PRD v1 · 列表卡片" },
  "host.card.capacity": { id: "host.card.capacity", domain: "host", text: "容量", vars: [], tone: "", source: "机器模块 PRD v1 · 列表卡片" },
  "host.card.detail": { id: "host.card.detail", domain: "host", text: "进详情", vars: [], tone: "", source: "机器模块 PRD v1 · 列表卡片" },
  "host.card.more_addresses": { id: "host.card.more_addresses", domain: "host", text: "还有 {count} 个地址", vars: ["count"], tone: "", source: "机器模块 · 列表卡片收束" },
  "host.card.more_workloads": { id: "host.card.more_workloads", domain: "host", text: "还有 {count} 个", vars: ["count"], tone: "", source: "机器模块 · 列表卡片收束" },
  "host.card.next": { id: "host.card.next", domain: "host", text: "下一步", vars: [], tone: "", source: "机器模块 PRD v1 · 列表卡片" },
  "host.card.uncollected": { id: "host.card.uncollected", domain: "host", text: "未采集", vars: [], tone: "", source: "机器模块 PRD v1 · 列表卡片" },
  "host.card.unknown": { id: "host.card.unknown", domain: "host", text: "未知", vars: [], tone: "", source: "机器模块 PRD v1 · 列表卡片" },
  "host.card.workloads": { id: "host.card.workloads", domain: "host", text: "容器与 Agent", vars: [], tone: "", source: "机器模块 PRD v1 · 列表卡片" },
  "host.carve.lives_on": { id: "host.carve.lives_on", domain: "host", text: "住在「{parent_name}」上", vars: ["parent_name"], tone: "", source: "RFC-001 §7.2" },
  "host.carve.parent_spec": { id: "host.carve.parent_spec", domain: "host", text: "{cores} 核 {memory}", vars: ["cores", "memory"], tone: "", source: "RFC-001 §7.2" },
  "host.carve.shared_fate": { id: "host.carve.shared_fate", domain: "host", text: "住在「{parent_name}」上——那台要是倒了，这台也会跟着倒。", vars: ["parent_name"], tone: "warn", source: "RFC-001 §7.2" },
  "host.carve.split_count": { id: "host.carve.split_count", domain: "host", text: "上面拆了 {count} 台", vars: ["count"], tone: "", source: "RFC-001 §7.2" },
  "host.credential.copy": { id: "host.credential.copy", domain: "host", text: "复制", vars: [], tone: "", source: "设计稿 · 机器详情" },
  "host.credential.field.address": { id: "host.credential.field.address", domain: "host", text: "地址", vars: [], tone: "", source: "设计稿 · 机器详情" },
  "host.credential.field.key": { id: "host.credential.field.key", domain: "host", text: "私钥", vars: [], tone: "", source: "设计稿 · 机器详情" },
  "host.credential.field.user": { id: "host.credential.field.user", domain: "host", text: "用户", vars: [], tone: "", source: "设计稿 · 机器详情" },
  "host.credential.heading": { id: "host.credential.heading", domain: "host", text: "连这台机器的钥匙", vars: [], tone: "", source: "设计稿 · 机器详情" },
  "host.credential.kept": { id: "host.credential.kept", domain: "host", text: "已加密保管", vars: [], tone: "", source: "设计稿 · 机器详情" },
  "host.credential.note": { id: "host.credential.note", domain: "host", text: "下次哪个 AI 助手要连它，直接在这里点「给 AI 一把临时钥匙」，2 小时后自动作废。你不用再把密码发到聊天框里。", vars: [], tone: "", source: "设计稿 · 机器详情" },
  "host.detail.breadcrumb": { id: "host.detail.breadcrumb", domain: "host", text: "机器 / {name}", vars: ["name"], tone: "", source: "设计稿 · 机器详情" },
  "host.group.assigned": { id: "host.group.assigned", domain: "host", text: "已分配", vars: [], tone: "", source: "机器模块 PRD v1 · 列表分组" },
  "host.group.available": { id: "host.group.available", domain: "host", text: "可用", vars: [], tone: "", source: "机器模块 PRD v1 · 列表分组" },
  "host.group.exception": { id: "host.group.exception", domain: "host", text: "异常/离线", vars: [], tone: "", source: "机器模块 PRD v1 · 列表分组" },
  "host.label.behind_nat": { id: "host.label.behind_nat", domain: "host", text: "没有公网，靠探针连回来", vars: [], tone: "neutral", source: "设计稿 · 机器列表" },
  "host.label.cannot_go_down": { id: "host.label.cannot_go_down", domain: "host", text: "不能倒", vars: [], tone: "danger", source: "设计稿 · 机器详情" },
  "host.label.daily_backup": { id: "host.label.daily_backup", domain: "host", text: "每天 {time} 自动备份到 {destination}", vars: ["destination", "time"], tone: "neutral", source: "设计稿 · 机器详情" },
  "host.label.has_database": { id: "host.label.has_database", domain: "host", text: "有数据库，删之前一定要问我", vars: [], tone: "neutral", source: "设计稿 · 机器详情" },
  "host.label.shared_infra": { id: "host.label.shared_infra", domain: "host", text: "跨项目共用，动它之前想清楚", vars: [], tone: "warn", source: "补充" },
  "host.list.col.host": { id: "host.list.col.host", domain: "host", text: "机器", vars: [], tone: "", source: "设计稿 · 机器列表" },
  "host.list.col.project": { id: "host.list.col.project", domain: "host", text: "属于哪个项目", vars: [], tone: "", source: "设计稿 · 机器列表" },
  "host.list.col.state": { id: "host.list.col.state", domain: "host", text: "状态", vars: [], tone: "", source: "设计稿 · 机器列表" },
  "host.list.col.what": { id: "host.list.col.what", domain: "host", text: "这台是干嘛的", vars: [], tone: "", source: "设计稿 · 机器列表" },
  "host.list.col.where": { id: "host.list.col.where", domain: "host", text: "在哪儿", vars: [], tone: "", source: "设计稿 · 机器列表" },
  "host.list.decision_hint": { id: "host.list.decision_hint", domain: "host", text: "没归项目的，或者我看到它住在另一台上。确认一下就好。", vars: [], tone: "warn", source: "机器模块 PRD v1 · 决策条" },
  "host.list.decision_title": { id: "host.list.decision_title", domain: "host", text: "{count} 台要你点一下", vars: ["count"], tone: "warn", source: "机器模块 PRD v1 · 决策条" },
  "host.list.empty.body": { id: "host.list.empty.body", domain: "host", text: "贴一次 SSH，剩下的我来。我会看它跑了什么、归到哪个项目，然后一直盯着它。", vars: [], tone: "", source: "补充" },
  "host.list.empty.title": { id: "host.list.empty.title", domain: "host", text: "还没有机器", vars: [], tone: "", source: "补充" },
  "host.list.intro": { id: "host.list.intro", domain: "host", text: "机器是一个池子，项目只是看它的角度。加机器的时候**不用先想好它属于谁** —— 先接进来，我看完它跑了什么再给你建议，你点头就归好了。", vars: [], tone: "", source: "设计稿 · 机器列表" },
  "host.list.intro_ready": { id: "host.list.intro_ready", domain: "host", text: "先接进来，归谁你点头就好。", vars: [], tone: "", source: "机器模块 PRD v1 · 列表页头" },
  "host.list.mixed.body": { id: "host.list.mixed.body", domain: "host", text: "可以。一台机器能同时挂在多个项目下，我按容器和端口分得清谁是谁。", vars: [], tone: "", source: "设计稿 · 机器列表" },
  "host.list.mixed.body_warn": { id: "host.list.mixed.body_warn", domain: "host", text: "但我会提醒你：混着放，一个项目出事会拖累另一个。", vars: [], tone: "warn", source: "设计稿 · 机器列表" },
  "host.list.mixed.title": { id: "host.list.mixed.title", domain: "host", text: "一台机器跑了两个项目？", vars: [], tone: "", source: "设计稿 · 机器列表" },
  "host.list.more": { id: "host.list.more", domain: "host", text: "还有 {count} 台，滚动查看", vars: ["count"], tone: "", source: "设计稿 · 机器列表" },
  "host.list.parent_accept": { id: "host.list.parent_accept", domain: "host", text: "对，它在「{parent_name}」上", vars: ["parent_name"], tone: "", source: "补充" },
  "host.list.parent_reject": { id: "host.list.parent_reject", domain: "host", text: "不对，它是单独一台", vars: [], tone: "", source: "补充" },
  "host.list.parent_suggestion": { id: "host.list.parent_suggestion", domain: "host", text: "我这次看到它住在「{parent_name}」上，之前不知道。是这样吗？", vars: ["parent_name"], tone: "warn", source: "补充" },
  "host.list.pool.title": { id: "host.list.pool.title", domain: "host", text: "已经在池子里", vars: [], tone: "", source: "机器模块 PRD v1 · 列表池子" },
  "host.list.project_first.body": { id: "host.list.project_first.body", domain: "host", text: "你的习惯是先写文档、让 AI 建仓库开发。等要上线时，在项目页点「给它找台机器」—— 你可以贴一台新买的，也可以从池子里挑一台闲着的。", vars: [], tone: "", source: "设计稿 · 机器列表" },
  "host.list.project_first.cta": { id: "host.list.project_first.cta", domain: "host", text: "新建一个项目", vars: [], tone: "", source: "设计稿 · 机器列表" },
  "host.list.project_first.title": { id: "host.list.project_first.title", domain: "host", text: "先有项目，还没有机器？", vars: [], tone: "", source: "设计稿 · 机器列表" },
  "host.list.suggestion_accept": { id: "host.list.suggestion_accept", domain: "host", text: "归到「{project_name}」", vars: ["project_name"], tone: "", source: "设计稿 · 机器列表" },
  "host.list.suggestion_pick": { id: "host.list.suggestion_pick", domain: "host", text: "我自己选", vars: [], tone: "", source: "设计稿 · 机器列表" },
  "host.list.title": { id: "host.list.title", domain: "host", text: "所有机器", vars: [], tone: "", source: "设计稿 · 机器列表" },
  "host.list.unassigned_banner": { id: "host.list.unassigned_banner", domain: "host", text: "有 {count} 台还没归项目。它们一样被巡检、一样告警，归项目只是为了你自己看得清。", vars: ["count"], tone: "warn", source: "补充" },
  "host.list.unassigned_hint": { id: "host.list.unassigned_hint", domain: "host", text: "我根据它们跑的东西猜了归属，你确认一下就好", vars: [], tone: "warn", source: "设计稿 · 机器列表" },
  "host.list.unassigned_hint_none": { id: "host.list.unassigned_hint_none", domain: "host", text: "还没认出来。先放着也行，巡检不停。", vars: [], tone: "warn", source: "机器模块 PRD v1 · 琥珀条" },
  "host.list.unassigned_title": { id: "host.list.unassigned_title", domain: "host", text: "{count} 台机器还没归项目", vars: ["count"], tone: "warn", source: "设计稿 · 机器列表" },
  "host.location.at_vendor": { id: "host.location.at_vendor", domain: "host", text: "{vendor} {region}", vars: ["region", "vendor"], tone: "", source: "设计稿 · 机器列表" },
  "host.location.lan": { id: "host.location.lan", domain: "host", text: "内网", vars: [], tone: "", source: "补充" },
  "host.meta.line": { id: "host.meta.line", domain: "host", text: "{vendor} · {region} · {spec}", vars: ["region", "spec", "vendor"], tone: "", source: "设计稿 · 机器详情" },
  "host.meta.managed_days": { id: "host.meta.managed_days", domain: "host", text: "已托管 {days} 天", vars: ["days"], tone: "", source: "设计稿 · 机器详情" },
  "host.metric.cpu.busy": { id: "host.metric.cpu.busy", domain: "host", text: "一直在忙", vars: [], tone: "warn", source: "补充" },
  "host.metric.cpu.idle": { id: "host.metric.cpu.idle", domain: "host", text: "很闲", vars: [], tone: "ok", source: "设计稿 · CLAUDE.md §3" },
  "host.metric.cpu.label": { id: "host.metric.cpu.label", domain: "host", text: "CPU 处理器", vars: [], tone: "", source: "设计稿 · 机器详情" },
  "host.metric.cpu.overloaded": { id: "host.metric.cpu.overloaded", domain: "host", text: "快扛不住了", vars: [], tone: "danger", source: "补充" },
  "host.metric.disk.filling": { id: "host.metric.disk.filling", domain: "host", text: "硬盘有点满了", vars: [], tone: "warn", source: "补充" },
  "host.metric.disk.full": { id: "host.metric.disk.full", domain: "host", text: "硬盘快满了", vars: [], tone: "danger", source: "设计稿 · CLAUDE.md §3" },
  "host.metric.disk.label": { id: "host.metric.disk.label", domain: "host", text: "硬盘 存东西的地方", vars: [], tone: "", source: "设计稿 · 机器详情" },
  "host.metric.disk.ok": { id: "host.metric.disk.ok", domain: "host", text: "硬盘还宽裕", vars: [], tone: "ok", source: "补充" },
  "host.metric.memory.label": { id: "host.metric.memory.label", domain: "host", text: "内存 临时记忆", vars: [], tone: "", source: "设计稿 · 机器详情" },
  "host.metric.memory.ok": { id: "host.metric.memory.ok", domain: "host", text: "内存够用", vars: [], tone: "ok", source: "补充" },
  "host.metric.memory.tight": { id: "host.metric.memory.tight", domain: "host", text: "内存有点紧", vars: [], tone: "warn", source: "补充" },
  "host.occupancy.unassigned": { id: "host.occupancy.unassigned", domain: "host", text: "未归项目", vars: [], tone: "neutral", source: "机器模块 PRD v1 · occupancy 三档" },
  "host.overview.all": { id: "host.overview.all", domain: "host", text: "全部", vars: [], tone: "", source: "机器模块 PRD v1 · 列表总览" },
  "host.overview.assigned": { id: "host.overview.assigned", domain: "host", text: "已分配", vars: [], tone: "", source: "机器模块 PRD v1 · 列表总览" },
  "host.overview.available": { id: "host.overview.available", domain: "host", text: "可用", vars: [], tone: "", source: "机器模块 PRD v1 · 列表总览" },
  "host.overview.exception": { id: "host.overview.exception", domain: "host", text: "异常", vars: [], tone: "", source: "机器模块 PRD v1 · 列表总览" },
  "host.overview.pending": { id: "host.overview.pending", domain: "host", text: "待处理", vars: [], tone: "", source: "机器模块 PRD v1 · 列表总览" },
  "host.probe.disconnected": { id: "host.probe.disconnected", domain: "host", text: "探针这会儿连不上。忙不忙我这会儿不知道——不是拿上次的数顶上。", vars: [], tone: "warn", source: "资源模块 SPEC 2026-08-27 · R18" },
  "host.reach.blocked": { id: "host.reach.blocked", domain: "host", text: "我够不到它——网络上就连不上。多半是有东西挡着：机器关了、端口关了，或者防火墙改过。", vars: [], tone: "warn", source: "契约 openapi.yaml · HostReach.kind = blocked" },
  "host.reach.credential": { id: "host.reach.credential", domain: "host", text: "我连得上这台机器，但进不去——钥匙不认了。多半是它重装过，或者那把钥匙被清掉了。重新接一次就好。", vars: [], tone: "warn", source: "契约 openapi.yaml · HostReach.kind = credential" },
  "host.reach.fail_streak": { id: "host.reach.fail_streak", domain: "host", text: "连着 {count} 次没看成了。", vars: ["count"], tone: "warn", source: "契约 openapi.yaml · HostReach.fail_streak" },
  "host.reach.host_key_changed": { id: "host.reach.host_key_changed", domain: "host", text: "这台机器的指纹变了。可能是你重装了系统，也可能是别的机器顶了它的地址——这一下我不敢替你判，你看看是不是你自己动的。", vars: [], tone: "danger", source: "契约 openapi.yaml · HostReach.kind = host_key_changed" },
  "host.reach.never_succeeded": { id: "host.reach.never_succeeded", domain: "host", text: "这台机器我一次都没看成过。多半是接进来那一步就没对上——地址、端口，或者要不要走跳板。", vars: [], tone: "warn", source: "契约 openapi.yaml · HostReach.never_succeeded = true" },
  "host.reach.ok": { id: "host.reach.ok", domain: "host", text: "看过它了——{when}，没问题。", vars: ["when"], tone: "ok", source: "契约 openapi.yaml · HostReach.kind = ok" },
  "host.reach.stale": { id: "host.reach.stale", domain: "host", text: "{since}没看到它了。", vars: ["since"], tone: "warn", source: "契约 openapi.yaml · HostReach.stale = true" },
  "host.reach.unknown": { id: "host.reach.unknown", domain: "host", text: "我没看成，但说不清为什么。先别急着查防火墙——我还没弄明白是哪一头的事，弄明白了告诉你。", vars: [], tone: "warn", source: "契约 openapi.yaml · HostReach.kind = unknown" },
  "host.recent.heading": { id: "host.recent.heading", domain: "host", text: "我最近在这台上做了什么", vars: [], tone: "", source: "设计稿 · 机器详情" },
  "host.recent.today": { id: "host.recent.today", domain: "host", text: "今天", vars: [], tone: "", source: "设计稿 · 机器详情" },
  "host.recent.yesterday": { id: "host.recent.yesterday", domain: "host", text: "昨天", vars: [], tone: "", source: "设计稿 · 机器详情" },
  "host.recheck.action": { id: "host.recheck.action", domain: "host", text: "现在重新看一眼", vars: [], tone: "", source: "补充" },
  "host.recheck.failed": { id: "host.recheck.failed", domain: "host", text: "这台机器现在连不上——多半是关机了，或者网断了。我每 6 小时会自己再试一次，你也可以等它上线之后再点一下。", vars: [], tone: "warn", source: "契约 openapi.yaml · recheck 连不上回 upstream_down（502）" },
  "host.recheck.running": { id: "host.recheck.running", domain: "host", text: "我正在连上去重新看一遍，大概几十秒。", vars: [], tone: "neutral", source: "补充" },
  "host.recheck.still_unknown": { id: "host.recheck.still_unknown", domain: "host", text: "我重新看过了，这两台机器还是报不出名字来。归属这件事先这么放着——你的档案我一个字都不会动，等它们有了名字我再问你一次。", vars: [], tone: "neutral", source: "补充" },
  "host.reparent.reject": { id: "host.reparent.reject", domain: "host", text: "不对，它还在「{parent_recorded_name}」上", vars: ["parent_recorded_name"], tone: "", source: "补充" },
  "host.reparent.suggest": { id: "host.reparent.suggest", domain: "host", text: "我这次在「{parent_observed_name}」上看到了它，档案里记的是「{parent_recorded_name}」。哪个对？", vars: ["parent_observed_name", "parent_recorded_name"], tone: "warn", source: "契约 openapi.yaml · HostSuggestion.parent_observed_name / parent_recorded_name" },
  "host.reparent.suggest.neither": { id: "host.reparent.suggest.neither", domain: "host", text: "我这次看到它换了一台机器住，跟档案里记的对不上——两台我都没认出来。是你把它挪了吗？", vars: [], tone: "warn", source: "契约 openapi.yaml · 两个变量都是空串时" },
  "host.reparent.suggest.observed_only": { id: "host.reparent.suggest.observed_only", domain: "host", text: "我这次在「{parent_observed_name}」上看到了它，跟档案里记的那台对不上。是这样吗？", vars: ["parent_observed_name"], tone: "warn", source: "契约 openapi.yaml · parent_recorded_name 为空串时" },
  "host.reparent.suggest.recorded_only": { id: "host.reparent.suggest.recorded_only", domain: "host", text: "我这次看到它不在「{parent_recorded_name}」上了，可现在这台我没认出来。是你把它挪了吗？", vars: ["parent_recorded_name"], tone: "warn", source: "契约 openapi.yaml · parent_observed_name 为空串时" },
  "host.status.credential": { id: "host.status.credential", domain: "host", text: "钥匙不认了", vars: [], tone: "warn", source: "机器模块 PRD v1 · 列表状态芯片" },
  "host.status.disk_filling": { id: "host.status.disk_filling", domain: "host", text: "盘偏满", vars: [], tone: "warn", source: "设计稿 · 机器列表" },
  "host.status.error": { id: "host.status.error", domain: "host", text: "没接进来", vars: [], tone: "danger", source: "补充" },
  "host.status.offline": { id: "host.status.offline", domain: "host", text: "联系不上", vars: [], tone: "danger", source: "补充" },
  "host.status.onboarding": { id: "host.status.onboarding", domain: "host", text: "正在接进来", vars: [], tone: "neutral", source: "补充" },
  "host.status.online": { id: "host.status.online", domain: "host", text: "正常", vars: [], tone: "ok", source: "设计稿 · 机器列表" },
  "host.status.provisioning": { id: "host.status.provisioning", domain: "host", text: "正在拆出来", vars: [], tone: "neutral", source: "补充" },
  "host.status.reclaimed": { id: "host.status.reclaimed", domain: "host", text: "已经收回去了", vars: [], tone: "neutral", source: "补充" },
  "host.summary.backend_and_db": { id: "host.summary.backend_and_db", domain: "host", text: "{project_name}的后端和数据库都在这台上。{who_uses}，请求最后都走到这里。", vars: ["project_name", "who_uses"], tone: "", source: "设计稿 · 机器详情" },
  "host.summary.critical_suffix": { id: "host.summary.critical_suffix", domain: "host", text: "它挂了，{consequence} —— 所以我把它标成了「不能倒」。", vars: ["consequence"], tone: "", source: "设计稿 · 机器详情" },
  "host.summary.frontend": { id: "host.summary.frontend", domain: "host", text: "客人扫码看到的那个页面", vars: [], tone: "", source: "设计稿 · 机器列表" },
  "host.summary.heading": { id: "host.summary.heading", domain: "host", text: "这台机器是干嘛的", vars: [], tone: "", source: "设计稿 · 机器详情" },
  "host.summary.unassigned": { id: "host.summary.unassigned", domain: "host", text: "这台上跑的东西我还没认出来。它照样有人看着，你想起来了随时归到项目里。", vars: [], tone: "", source: "补充" },
  "host.workloads.heading": { id: "host.workloads.heading", domain: "host", text: "上面跑着这些东西", vars: [], tone: "", source: "设计稿 · 机器详情" },
  "job.canceled": { id: "job.canceled", domain: "job", text: "停掉了。已经做完的那几步我没有回退——要退的话你点一下撤销。", vars: [], tone: "neutral", source: "补充" },
  "job.failed": { id: "job.failed", domain: "job", text: "「{title}」没做成，卡在「{step}」这一步", vars: ["step", "title"], tone: "warn", source: "补充" },
  "job.resumed": { id: "job.resumed", domain: "job", text: "接着上次停下的地方继续了。", vars: [], tone: "ok", source: "补充" },
  "job.started": { id: "job.started", domain: "job", text: "我开始做「{title}」了", vars: ["title"], tone: "", source: "补充" },
  "job.step.done": { id: "job.step.done", domain: "job", text: "「{title}」第 {index}/{total} 步做完了：{step}", vars: ["index", "step", "title", "total"], tone: "", source: "补充" },
  "job.step.not_started": { id: "job.step.not_started", domain: "job", text: "这一步根本没跑起来——不是你的代码有问题，是我这边没把它送到该跑的地方。我这就去查，你先别改代码。", vars: [], tone: "warn", source: "补充" },
  "job.stopped.budget_used_up": { id: "job.stopped.budget_used_up", domain: "job", text: "这件事花掉的额度到头了（用了 {used}，上限 {limit}）。我先停下，要接着干你说一声。", vars: ["limit", "used"], tone: "warn", source: "补充" },
  "job.stopped.no_progress": { id: "job.stopped.no_progress", domain: "job", text: "「{step}」这一步卡了 {minutes} 分钟没动静，我先停下来等你看一眼。", vars: ["minutes", "step"], tone: "warn", source: "补充" },
  "job.stopped.too_long": { id: "job.stopped.too_long", domain: "job", text: "这件事我干了 {minutes} 分钟还没完，卡在「{step}」这一步。我先停下来了，你看看要不要接着来。", vars: ["minutes", "step"], tone: "warn", source: "补充" },
  "job.stopped.too_many_steps": { id: "job.stopped.too_many_steps", domain: "job", text: "这件事我拆出了 {steps} 步还没走完，比我预计的多不少。先停下来等你看一眼，免得越走越偏。", vars: ["steps"], tone: "warn", source: "补充" },
  "job.succeeded": { id: "job.succeeded", domain: "job", text: "「{title}」做完了，用了 {seconds} 秒", vars: ["seconds", "title"], tone: "ok", source: "补充" },
  "lulu.history.hidden_entry": { id: "lulu.history.hidden_entry", domain: "lulu", text: "有一条你看不到的记录。", vars: [], tone: "", source: "会话团队与真人协作 PRD v1 §8" },
  "lulu.reply.accepted": { id: "lulu.reply.accepted", domain: "lulu", text: "Lulu 已记录 {kind}。", vars: ["kind"], tone: "", source: "Lulu V2" },
  "lulu.reply.action_pending": { id: "lulu.reply.action_pending", domain: "lulu", text: "动作 {action} 正在等待用户确认；回执 {receipt}。", vars: ["action", "receipt"], tone: "", source: "Lulu V2" },
  "lulu.reply.action_recorded": { id: "lulu.reply.action_recorded", domain: "lulu", text: "动作 {action} 的回执：{receipt}。", vars: ["action", "receipt"], tone: "", source: "Lulu V2" },
  "lulu.reply.candidate_missing": { id: "lulu.reply.candidate_missing", domain: "lulu", text: "尚未收到候选 SHA；测试、交接、部署和回滚都不能称为已完成。", vars: [], tone: "", source: "Lulu V2" },
  "lulu.reply.candidate_present": { id: "lulu.reply.candidate_present", domain: "lulu", text: "候选 SHA：{sha}。", vars: ["sha"], tone: "", source: "Lulu V2" },
  "lulu.reply.mentioned_not_here": { id: "lulu.reply.mentioned_not_here", domain: "lulu", text: "{name} 不在这条会话里，我没法替你叫他。把他拉进来就能 @ 到了。", vars: ["name"], tone: "", source: "会话团队与真人协作 PRD v1 §6" },
  "lulu.reply.mentioned_someone": { id: "lulu.reply.mentioned_someone", domain: "lulu", text: "有人", vars: [], tone: "", source: "会话团队与真人协作 PRD v1 §6（名字说不出来时的替代，不拿 uuid 顶上）" },
  "lulu.reply.red_needs_owner": { id: "lulu.reply.red_needs_owner", domain: "lulu", text: "这一步碰到钱了，得 {owner} 点一下。我停在这儿等着。", vars: ["owner"], tone: "", source: "会话团队与真人协作 PRD v1 §4.1" },
  "lulu.reply.task_status": { id: "lulu.reply.task_status", domain: "lulu", text: "任务状态：{state}；attempt：{attempt}。", vars: ["attempt", "state"], tone: "", source: "Lulu V2" },
  "lulu.reply.watcher_noted": { id: "lulu.reply.watcher_noted", domain: "lulu", text: "我先记下来了。这件事得让能动手的人开口——你可以叫上 {owner}。", vars: ["owner"], tone: "", source: "会话团队与真人协作 PRD v1 §4.1" },
  "lulu.reply.watcher_noted_no_owner": { id: "lulu.reply.watcher_noted_no_owner", domain: "lulu", text: "我先记下来了。这件事得让能动手的人开口。", vars: [], tone: "", source: "会话团队与真人协作 PRD v1 §4.1" },
  "lulu_agents.add": { id: "lulu_agents.add", domain: "lulu_agents", text: "添加 Agent", vars: [], tone: "", source: "设计稿 · agents" },
  "lulu_agents.autofill": { id: "lulu_agents.autofill", domain: "lulu_agents", text: "让 Lulu 配", vars: [], tone: "", source: "需求 2026-09-06 · 按描述自动配职责" },
  "lulu_agents.autofill_done": { id: "lulu_agents.autofill_done", domain: "lulu_agents", text: "配好了：{tags}。干活用「{executor}」。", vars: ["executor", "tags"], tone: "ok", source: "需求 2026-09-06 · 按描述自动配职责" },
  "lulu_agents.autofill_done_no_executor": { id: "lulu_agents.autofill_done_no_executor", domain: "lulu_agents", text: "配好了：{tags}。**还没有能给他用的执行器**——这样他接不到活，去「服务商与账号」里加一个。", vars: ["tags"], tone: "warn", source: "需求 2026-09-06 · 按描述自动配职责" },
  "lulu_agents.autofill_failed": { id: "lulu_agents.autofill_failed", domain: "lulu_agents", text: "我这会儿配不了，你自己勾一下吧——不影响保存。", vars: [], tone: "warn", source: "需求 2026-09-06 · 按描述自动配职责" },
  "lulu_agents.autofill_hint": { id: "lulu_agents.autofill_hint", domain: "lulu_agents", text: "上面那句话写完点一下，我把标签和干活用的执行器一起配上——配完你都能改。", vars: [], tone: "", source: "需求 2026-09-06 · 按描述自动配职责" },
  "lulu_agents.autofill_unsure": { id: "lulu_agents.autofill_unsure", domain: "lulu_agents", text: "这句话我没看懂他负责什么——你自己在下面勾一下就行，勾了就能派活。", vars: [], tone: "warn", source: "需求 2026-09-06 · 按描述自动配职责" },
  "lulu_agents.autofill_working": { id: "lulu_agents.autofill_working", domain: "lulu_agents", text: "配着…", vars: [], tone: "", source: "需求 2026-09-06 · 按描述自动配职责" },
  "lulu_agents.cancel": { id: "lulu_agents.cancel", domain: "lulu_agents", text: "取消", vars: [], tone: "", source: "设计稿 · agentAdd 次操作" },
  "lulu_agents.col_agent": { id: "lulu_agents.col_agent", domain: "lulu_agents", text: "Agent", vars: [], tone: "", source: "设计稿 · agents 表头" },
  "lulu_agents.col_executor": { id: "lulu_agents.col_executor", domain: "lulu_agents", text: "谁来干活", vars: [], tone: "", source: "需求 2026-09-04 · 派活给 claude code / 系统 agent / 项目研发 agent" },
  "lulu_agents.col_model": { id: "lulu_agents.col_model", domain: "lulu_agents", text: "用什么模型", vars: [], tone: "", source: "设计稿 · agents 表头" },
  "lulu_agents.col_responsibilities": { id: "lulu_agents.col_responsibilities", domain: "lulu_agents", text: "负责", vars: [], tone: "", source: "需求 2026-09-04 · agent 可以添加标签" },
  "lulu_agents.col_role": { id: "lulu_agents.col_role", domain: "lulu_agents", text: "职责", vars: [], tone: "", source: "设计稿 · agents 表头" },
  "lulu_agents.col_scope": { id: "lulu_agents.col_scope", domain: "lulu_agents", text: "作用域", vars: [], tone: "", source: "设计稿 · agents 表头（对应「记忆」那一列能给出来的那半）" },
  "lulu_agents.col_state": { id: "lulu_agents.col_state", domain: "lulu_agents", text: "状态", vars: [], tone: "", source: "设计稿 · agents 表头" },
  "lulu_agents.count": { id: "lulu_agents.count", domain: "lulu_agents", text: "{count} 个", vars: ["count"], tone: "", source: "设计稿 · agents" },
  "lulu_agents.create": { id: "lulu_agents.create", domain: "lulu_agents", text: "创建", vars: [], tone: "", source: "设计稿 · agentAdd 主操作" },
  "lulu_agents.create_failed": { id: "lulu_agents.create_failed", domain: "lulu_agents", text: "没建成 —— 你填的字还在，点一下重试", vars: [], tone: "warn", source: "设计稿 · 失败不丢用户输入" },
  "lulu_agents.dialog_desc": { id: "lulu_agents.dialog_desc", domain: "lulu_agents", text: "先给它起名字和职责 —— 你在对话里看到的是这个，不是模型名。模型只是它用的引擎，以后能换。", vars: [], tone: "", source: "设计稿 · agentAdd" },
  "lulu_agents.dialog_title": { id: "lulu_agents.dialog_title", domain: "lulu_agents", text: "添加 Agent", vars: [], tone: "", source: "设计稿 · agentAdd" },
  "lulu_agents.disable": { id: "lulu_agents.disable", domain: "lulu_agents", text: "停用", vars: [], tone: "", source: "后端 DELETE 是软删" },
  "lulu_agents.disable_note": { id: "lulu_agents.disable_note", domain: "lulu_agents", text: "停用不删历史 —— 它做过的事、留下的证据都还在，只是不再被派新活。", vars: [], tone: "", source: "后端合同：软删、幂等" },
  "lulu_agents.edit": { id: "lulu_agents.edit", domain: "lulu_agents", text: "改配置", vars: [], tone: "", source: "设计稿 · agents 行操作" },
  "lulu_agents.edit_dialog_desc": { id: "lulu_agents.edit_dialog_desc", domain: "lulu_agents", text: "名字、职责、干活用哪个执行器都能改。正在跑的活不受影响——它们钉在改之前那一版上。", vars: [], tone: "", source: "需求 2026-09-06 · 已有 Agent 也要能配" },
  "lulu_agents.edit_dialog_title": { id: "lulu_agents.edit_dialog_title", domain: "lulu_agents", text: "改 {name}", vars: ["name"], tone: "", source: "需求 2026-09-06 · 已有 Agent 也要能配" },
  "lulu_agents.empty": { id: "lulu_agents.empty", domain: "lulu_agents", text: "还没有 Agent。建一个，Lulu 才有人可派。", vars: [], tone: "", source: "设计稿 · teamEmpty 同一条道理" },
  "lulu_agents.executor_unbound": { id: "lulu_agents.executor_unbound", domain: "lulu_agents", text: "谁有空给谁", vars: [], tone: "", source: "需求 2026-09-04 · 没绑时按今天的规则兜底" },
  "lulu_agents.f_name": { id: "lulu_agents.f_name", domain: "lulu_agents", text: "Agent 名称", vars: [], tone: "", source: "设计稿 · agentAdd" },
  "lulu_agents.f_name_hint": { id: "lulu_agents.f_name_hint", domain: "lulu_agents", text: "会出现在对话、任务和证据里。你不填我就根据职责起一个 —— 不会拿模型名凑。", vars: [], tone: "", source: "设计稿 · agentAdd" },
  "lulu_agents.f_responsibilities": { id: "lulu_agents.f_responsibilities", domain: "lulu_agents", text: "负责什么", vars: [], tone: "", source: "需求 2026-09-04 · agent 可以添加标签" },
  "lulu_agents.f_responsibilities_empty": { id: "lulu_agents.f_responsibilities_empty", domain: "lulu_agents", text: "一个都没勾的话，Lulu 派活时找不到他——他会一直闲着。", vars: [], tone: "warn", source: "需求 2026-09-06 · 按描述自动配职责" },
  "lulu_agents.f_responsibilities_hint": { id: "lulu_agents.f_responsibilities_hint", domain: "lulu_agents", text: "可以多选。Lulu 派活时按这些标签找它，不再猜上面那句话。", vars: [], tone: "", source: "需求 2026-09-04 · agent 可以添加标签" },
  "lulu_agents.f_role": { id: "lulu_agents.f_role", domain: "lulu_agents", text: "角色 / 职责", vars: [], tone: "", source: "设计稿 · agentAdd" },
  "lulu_agents.f_role_hint": { id: "lulu_agents.f_role_hint", domain: "lulu_agents", text: "一句话。Lulu 派活时按这句话判断该不该找它。", vars: [], tone: "", source: "设计稿 · agentAdd" },
  "lulu_agents.f_scope": { id: "lulu_agents.f_scope", domain: "lulu_agents", text: "作用域", vars: [], tone: "", source: "设计稿 · agentAdd" },
  "lulu_agents.f_scope_hint": { id: "lulu_agents.f_scope_hint", domain: "lulu_agents", text: "账户级：你允许的多个项目都能用它。项目级：只在那个项目里存在。", vars: [], tone: "", source: "设计稿 · agentAdd" },
  "lulu_agents.identity_note": { id: "lulu_agents.identity_note", domain: "lulu_agents", text: "名称、角色是身份；模型、作用域是配置。身份定了很少改，配置随时能调。", vars: [], tone: "", source: "设计稿 · agentAdd" },
  "lulu_agents.model_disabled": { id: "lulu_agents.model_disabled", domain: "lulu_agents", text: "已经禁用", vars: [], tone: "warn", source: "后端 model_status=disabled" },
  "lulu_agents.model_no_key": { id: "lulu_agents.model_no_key", domain: "lulu_agents", text: "差一把 Key", vars: [], tone: "", source: "后端 model_status=no_key" },
  "lulu_agents.model_not_callable": { id: "lulu_agents.model_not_callable", domain: "lulu_agents", text: "现在调不动", vars: [], tone: "warn", source: "后端 model_status=not_callable" },
  "lulu_agents.model_not_implemented": { id: "lulu_agents.model_not_implemented", domain: "lulu_agents", text: "这家还没接", vars: [], tone: "", source: "后端 model_status=not_implemented" },
  "lulu_agents.model_not_wired": { id: "lulu_agents.model_not_wired", domain: "lulu_agents", text: "待接运行时", vars: [], tone: "", source: "后端 model_status=not_wired" },
  "lulu_agents.model_quota_exhausted": { id: "lulu_agents.model_quota_exhausted", domain: "lulu_agents", text: "额度不足", vars: [], tone: "warn", source: "后端 model_status=quota_exhausted" },
  "lulu_agents.model_rate_limited": { id: "lulu_agents.model_rate_limited", domain: "lulu_agents", text: "正在限流", vars: [], tone: "warn", source: "后端 model_status=rate_limited" },
  "lulu_agents.model_unavailable": { id: "lulu_agents.model_unavailable", domain: "lulu_agents", text: "现在不可用", vars: [], tone: "warn", source: "后端 model_status=unavailable" },
  "lulu_agents.model_unknown": { id: "lulu_agents.model_unknown", domain: "lulu_agents", text: "我说不清", vars: [], tone: "", source: "后端 model_status=unknown" },
  "lulu_agents.model_unlisted": { id: "lulu_agents.model_unlisted", domain: "lulu_agents", text: "不在库里", vars: [], tone: "warn", source: "后端 model_status=unlisted" },
  "lulu_agents.model_unset": { id: "lulu_agents.model_unset", domain: "lulu_agents", text: "还没选", vars: [], tone: "", source: "后端 model_status=unset" },
  "lulu_agents.model_unverified": { id: "lulu_agents.model_unverified", domain: "lulu_agents", text: "还没验证", vars: [], tone: "", source: "后端 model_status=unverified" },
  "lulu_agents.resp_architect": { id: "lulu_agents.resp_architect", domain: "lulu_agents", text: "架构师", vars: [], tone: "", source: "需求 2026-09-04" },
  "lulu_agents.resp_backend": { id: "lulu_agents.resp_backend", domain: "lulu_agents", text: "后端研发", vars: [], tone: "", source: "需求 2026-09-04" },
  "lulu_agents.resp_frontend": { id: "lulu_agents.resp_frontend", domain: "lulu_agents", text: "前端研发", vars: [], tone: "", source: "需求 2026-09-04" },
  "lulu_agents.resp_ops": { id: "lulu_agents.resp_ops", domain: "lulu_agents", text: "运维", vars: [], tone: "", source: "需求 2026-09-04" },
  "lulu_agents.resp_product_design": { id: "lulu_agents.resp_product_design", domain: "lulu_agents", text: "产品设计", vars: [], tone: "", source: "需求 2026-09-04" },
  "lulu_agents.resp_qa": { id: "lulu_agents.resp_qa", domain: "lulu_agents", text: "测试", vars: [], tone: "", source: "需求 2026-09-04" },
  "lulu_agents.resp_release": { id: "lulu_agents.resp_release", domain: "lulu_agents", text: "发布", vars: [], tone: "", source: "需求 2026-09-04" },
  "lulu_agents.resp_research": { id: "lulu_agents.resp_research", domain: "lulu_agents", text: "调研", vars: [], tone: "", source: "需求 2026-09-04" },
  "lulu_agents.resp_review": { id: "lulu_agents.resp_review", domain: "lulu_agents", text: "代码审查", vars: [], tone: "", source: "需求 2026-09-04" },
  "lulu_agents.resp_ui_design": { id: "lulu_agents.resp_ui_design", domain: "lulu_agents", text: "UI 设计", vars: [], tone: "", source: "需求 2026-09-04" },
  "lulu_agents.save": { id: "lulu_agents.save", domain: "lulu_agents", text: "保存", vars: [], tone: "", source: "需求 2026-09-06 · 已有 Agent 也要能配" },
  "lulu_agents.save_failed": { id: "lulu_agents.save_failed", domain: "lulu_agents", text: "没改成。再点一次；还是这样就把这句话告诉我。", vars: [], tone: "warn", source: "需求 2026-09-06 · 已有 Agent 也要能配" },
  "lulu_agents.scope_account": { id: "lulu_agents.scope_account", domain: "lulu_agents", text: "账户级", vars: [], tone: "", source: "设计稿 · agentAdd 作用域" },
  "lulu_agents.scope_project": { id: "lulu_agents.scope_project", domain: "lulu_agents", text: "项目级", vars: [], tone: "", source: "设计稿 · agentAdd 作用域" },
  "lulu_agents.speak.here": { id: "lulu_agents.speak.here", domain: "lulu_agents", text: "我在。{role} 这块归我，你说要看哪儿。", vars: ["role"], tone: "", source: "需求 2026-09-06 · @ 到谁谁回话" },
  "lulu_agents.speak.here_no_role": { id: "lulu_agents.speak.here_no_role", domain: "lulu_agents", text: "我在。你说。", vars: [], tone: "", source: "需求 2026-09-06 · @ 到谁谁回话" },
  "lulu_agents.speak.need_more": { id: "lulu_agents.speak.need_more", domain: "lulu_agents", text: "我还差点东西才动得了手。", vars: [], tone: "", source: "需求 2026-09-06 · @ 到谁谁回话" },
  "lulu_agents.speak.not_mine": { id: "lulu_agents.speak.not_mine", domain: "lulu_agents", text: "这事不归我。", vars: [], tone: "", source: "需求 2026-09-06 · @ 到谁谁回话" },
  "lulu_agents.speak.on_it": { id: "lulu_agents.speak.on_it", domain: "lulu_agents", text: "好，我来。", vars: [], tone: "", source: "需求 2026-09-06 · @ 到谁谁回话" },
  "lulu_agents.state_available": { id: "lulu_agents.state_available", domain: "lulu_agents", text: "可用", vars: [], tone: "", source: "设计稿 · agents 状态列" },
  "lulu_agents.state_disabled": { id: "lulu_agents.state_disabled", domain: "lulu_agents", text: "已停用", vars: [], tone: "warn", source: "设计稿 · agents 状态列" },
  "lulu_agents.sub": { id: "lulu_agents.sub", domain: "lulu_agents", text: "Agent 是你的团队成员，有名字、有头像、有职责。它用哪个模型是它的配置，可以随时换。", vars: [], tone: "", source: "设计稿 · agents" },
  "lulu_agents.title": { id: "lulu_agents.title", domain: "lulu_agents", text: "Agent", vars: [], tone: "", source: "设计稿 · agents" },
  "lulu_agents.unreachable": { id: "lulu_agents.unreachable", domain: "lulu_agents", text: "暂时读不到 Agent 库 · 重试", vars: [], tone: "warn", source: "设计稿 · Z10 同规矩" },
  "lulu_agents.why_body": { id: "lulu_agents.why_body", domain: "lulu_agents", text: "你派活给 Agent，不是派给模型。同一个模型可以支撑好几个 Agent —— 它们名字不同、职责不同、写域不同、记忆不通。", vars: [], tone: "", source: "设计稿 · agents" },
  "lulu_agents.why_heading": { id: "lulu_agents.why_heading", domain: "lulu_agents", text: "为什么不是直接选模型", vars: [], tone: "", source: "设计稿 · agents" },
  "lulu_agents.why_title": { id: "lulu_agents.why_title", domain: "lulu_agents", text: "先说清 Agent 和模型的关系", vars: [], tone: "", source: "设计稿 · agents" },
  "lulu_workbench.attach.action": { id: "lulu_workbench.attach.action", domain: "lulu_workbench", text: "加附件", vars: [], tone: "", source: "设计稿 · 输入框工具条 tip" },
  "lulu_workbench.attach.bad_type": { id: "lulu_workbench.attach.bad_type", domain: "lulu_workbench", text: "这种文件先不收 —— 图片和常见文档可以", vars: [], tone: "", source: "补充 · 传之前就拦" },
  "lulu_workbench.attach.download": { id: "lulu_workbench.attach.download", domain: "lulu_workbench", text: "下载", vars: [], tone: "", source: "补充 · 发出去的附件要有一条取回来的路" },
  "lulu_workbench.attach.failed": { id: "lulu_workbench.attach.failed", domain: "lulu_workbench", text: "没传上去", vars: [], tone: "", source: "补充 · 上传四态之一" },
  "lulu_workbench.attach.kind_image": { id: "lulu_workbench.attach.kind_image", domain: "lulu_workbench", text: "图片", vars: [], tone: "", source: "补充 · 附件是个什么" },
  "lulu_workbench.attach.kind_json": { id: "lulu_workbench.attach.kind_json", domain: "lulu_workbench", text: "JSON", vars: [], tone: "", source: "补充 · 附件是个什么" },
  "lulu_workbench.attach.kind_pdf": { id: "lulu_workbench.attach.kind_pdf", domain: "lulu_workbench", text: "PDF", vars: [], tone: "", source: "补充 · 附件是个什么" },
  "lulu_workbench.attach.kind_table": { id: "lulu_workbench.attach.kind_table", domain: "lulu_workbench", text: "表格", vars: [], tone: "", source: "补充 · 附件是个什么" },
  "lulu_workbench.attach.kind_text": { id: "lulu_workbench.attach.kind_text", domain: "lulu_workbench", text: "文本", vars: [], tone: "", source: "补充 · 附件是个什么" },
  "lulu_workbench.attach.kind_zip": { id: "lulu_workbench.attach.kind_zip", domain: "lulu_workbench", text: "压缩包", vars: [], tone: "", source: "补充 · 附件是个什么" },
  "lulu_workbench.attach.remove": { id: "lulu_workbench.attach.remove", domain: "lulu_workbench", text: "不要了", vars: [], tone: "", source: "补充 · 已经传上去的可以摘掉" },
  "lulu_workbench.attach.retry": { id: "lulu_workbench.attach.retry", domain: "lulu_workbench", text: "再试一次", vars: [], tone: "", source: "补充 · 失败要有出口" },
  "lulu_workbench.attach.too_large": { id: "lulu_workbench.attach.too_large", domain: "lulu_workbench", text: "这个超过 10MB 了，传不上去", vars: [], tone: "", source: "补充 · 传之前就拦" },
  "lulu_workbench.attach.too_many": { id: "lulu_workbench.attach.too_many", domain: "lulu_workbench", text: "一条消息最多挂 10 个", vars: [], tone: "", source: "补充 · 与服务端同一个上限" },
  "lulu_workbench.attach.uploading": { id: "lulu_workbench.attach.uploading", domain: "lulu_workbench", text: "正在传", vars: [], tone: "", source: "补充 · 上传四态之一" },
  "lulu_workbench.attach.wait_upload": { id: "lulu_workbench.attach.wait_upload", domain: "lulu_workbench", text: "等这几个传完再发 —— 现在发的话它们会挂不上", vars: [], tone: "", source: "补充 · 有在传的就不能发" },
  "lulu_workbench.attribution.declared": { id: "lulu_workbench.attribution.declared", domain: "lulu_workbench", text: "用户声明，未验证", vars: [], tone: "warn", source: "设计稿 · vf()" },
  "lulu_workbench.attribution.platform": { id: "lulu_workbench.attribution.platform", domain: "lulu_workbench", text: "平台已验证", vars: [], tone: "ok", source: "设计稿 · vf()" },
  "lulu_workbench.attribution.self": { id: "lulu_workbench.attribution.self", domain: "lulu_workbench", text: "Agent 自述", vars: [], tone: "neutral", source: "设计稿 · vf()" },
  "lulu_workbench.bind.already": { id: "lulu_workbench.bind.already", domain: "lulu_workbench", text: "这条会话已经绑过项目了，换不了", vars: [], tone: "warn", source: "设计稿 · bindCard「绑了不能换」" },
  "lulu_workbench.bind.do": { id: "lulu_workbench.bind.do", domain: "lulu_workbench", text: "绑定{name}", vars: ["name"], tone: "", source: "设计稿 · bindCard 主操作" },
  "lulu_workbench.bind.failed": { id: "lulu_workbench.bind.failed", domain: "lulu_workbench", text: "没绑上 —— 再点一次", vars: [], tone: "warn", source: "设计稿 · 真实状态合同的推论" },
  "lulu_workbench.bind.keep_chatting": { id: "lulu_workbench.bind.keep_chatting", domain: "lulu_workbench", text: "先接着聊也行 —— 不动这三类的事不用绑", vars: [], tone: "", source: "设计稿 · 不弹阻塞 Modal" },
  "lulu_workbench.bind.kind_code": { id: "lulu_workbench.bind.kind_code", domain: "lulu_workbench", text: "代码", vars: [], tone: "", source: "设计稿 · 三类触发之一" },
  "lulu_workbench.bind.kind_deploy": { id: "lulu_workbench.bind.kind_deploy", domain: "lulu_workbench", text: "部署", vars: [], tone: "", source: "设计稿 · 三类触发之二" },
  "lulu_workbench.bind.kind_resource": { id: "lulu_workbench.bind.kind_resource", domain: "lulu_workbench", text: "服务器或资源", vars: [], tone: "", source: "设计稿 · 三类触发之三" },
  "lulu_workbench.bind.needed": { id: "lulu_workbench.bind.needed", domain: "lulu_workbench", text: "这件事要动{what}，得先告诉我是哪个项目", vars: ["what"], tone: "", source: "设计稿 · 新合同 §0 碰到代码/部署/资源才要求绑定" },
  "lulu_workbench.bind.one_way": { id: "lulu_workbench.bind.one_way", domain: "lulu_workbench", text: "绑上之后这条会话就固定在这个项目了，换不了", vars: [], tone: "", source: "设计稿 · 绑定后不可换项目" },
  "lulu_workbench.bind.pick": { id: "lulu_workbench.bind.pick", domain: "lulu_workbench", text: "选一个项目", vars: [], tone: "", source: "设计稿 · 绑定卡主操作" },
  "lulu_workbench.bind.skip": { id: "lulu_workbench.bind.skip", domain: "lulu_workbench", text: "先不绑", vars: [], tone: "", source: "设计稿 · bindCard 次操作" },
  "lulu_workbench.blocked.no_eligible_executor": { id: "lulu_workbench.blocked.no_eligible_executor", domain: "lulu_workbench", text: "这一步要用的执行器我这边暂时不在，先没往下派。这不是你的问题——想让它继续，跟我说一声，我重新安排。", vars: [], tone: "", source: "补充" },
  "lulu_workbench.board.auto_start": { id: "lulu_workbench.board.auto_start", domain: "lulu_workbench", text: "等到了自动开始，不用你点。", vars: [], tone: "neutral", source: "设计稿 · W08 工作板" },
  "lulu_workbench.board.queue_reason": { id: "lulu_workbench.board.queue_reason", domain: "lulu_workbench", text: "同一个写域同一时刻只有一个人在写。排队是为了不冲突，不是慢。", vars: [], tone: "neutral", source: "设计稿 · W08 工作板" },
  "lulu_workbench.board.undo": { id: "lulu_workbench.board.undo", domain: "lulu_workbench", text: "撤回这次安排", vars: [], tone: "", source: "补充" },
  "lulu_workbench.board.undo_confirm": { id: "lulu_workbench.board.undo_confirm", domain: "lulu_workbench", text: "撤回之后这件事就不做了。已经改的代码不会自动回滚，那一份还在。", vars: [], tone: "", source: "补充" },
  "lulu_workbench.board.undo_done": { id: "lulu_workbench.board.undo_done", domain: "lulu_workbench", text: "撤回了。这件事我不做了。", vars: [], tone: "", source: "补充" },
  "lulu_workbench.board.undo_failed": { id: "lulu_workbench.board.undo_failed", domain: "lulu_workbench", text: "没撤回成——它可能已经跑完了。刷新看看现在是什么状态。", vars: [], tone: "", source: "补充" },
  "lulu_workbench.chat.new_below": { id: "lulu_workbench.chat.new_below", domain: "lulu_workbench", text: "下面有新消息", vars: [], tone: "", source: "2026-09-08 arron：「新消息来了右边对话框应该会自动到最新消息，现在对话空停了不动」。没贴着底时新消息落在视野外，这一颗把人带下去" },
  "lulu_workbench.chat.stop": { id: "lulu_workbench.chat.stop", domain: "lulu_workbench", text: "停下", vars: [], tone: "", source: "补充" },
  "lulu_workbench.chat.thinking": { id: "lulu_workbench.chat.thinking", domain: "lulu_workbench", text: "小队长正在想…… {seconds} 秒", vars: ["seconds"], tone: "", source: "补充" },
  "lulu_workbench.chat.thinking_phase": { id: "lulu_workbench.chat.thinking_phase", domain: "lulu_workbench", text: "{seconds} 秒 · {phase}", vars: ["phase", "seconds"], tone: "", source: "补充" },
  "lulu_workbench.chat.thinking_tokens": { id: "lulu_workbench.chat.thinking_tokens", domain: "lulu_workbench", text: "{seconds} 秒 · {tokens} tokens · {phase}", vars: ["phase", "seconds", "tokens"], tone: "", source: "补充" },
  "lulu_workbench.composer.key_hint": { id: "lulu_workbench.composer.key_hint", domain: "lulu_workbench", text: "Enter 发送 · Shift+Enter 换行 · Esc 停下", vars: [], tone: "", source: "补充" },
  "lulu_workbench.composer.ph_first": { id: "lulu_workbench.composer.ph_first", domain: "lulu_workbench", text: "说一句你想做的事…", vars: [], tone: "", source: "设计稿 · W01 home" },
  "lulu_workbench.composer.ph_more": { id: "lulu_workbench.composer.ph_more", domain: "lulu_workbench", text: "继续说…", vars: [], tone: "", source: "设计稿 · generalChat" },
  "lulu_workbench.composer.ph_offline": { id: "lulu_workbench.composer.ph_offline", domain: "lulu_workbench", text: "断线期间你说的话会存本机草稿…", vars: [], tone: "warn", source: "设计稿 · offline" },
  "lulu_workbench.composer.ph_project": { id: "lulu_workbench.composer.ph_project", domain: "lulu_workbench", text: "跟 Lulu 说这个项目的事…", vars: [], tone: "", source: "设计稿 · pjChat" },
  "lulu_workbench.composer.plan_only_chip": { id: "lulu_workbench.composer.plan_only_chip", domain: "lulu_workbench", text: "这一条只出计划 · 点「开始做」才动手", vars: [], tone: "", source: "补充" },
  "lulu_workbench.composer.send": { id: "lulu_workbench.composer.send", domain: "lulu_workbench", text: "发送", vars: [], tone: "", source: "设计稿 · W16a 输入区" },
  "lulu_workbench.composer.send_failed": { id: "lulu_workbench.composer.send_failed", domain: "lulu_workbench", text: "这条没发出去 —— 你的字还在，点一下重发", vars: [], tone: "", source: "设计稿 · 失败不丢用户输入" },
  "lulu_workbench.composer.sending": { id: "lulu_workbench.composer.sending", domain: "lulu_workbench", text: "正在发", vars: [], tone: "", source: "设计稿 · W16a 输入区" },
  "lulu_workbench.convfail.draft_kept": { id: "lulu_workbench.convfail.draft_kept", domain: "lulu_workbench", text: "你打了一半的那句话我存着，再建时原样带进去", vars: [], tone: "", source: "设计稿 · Z12 草稿原样带入" },
  "lulu_workbench.convfail.headline": { id: "lulu_workbench.convfail.headline", domain: "lulu_workbench", text: "项目建好了，会话没建成", vars: [], tone: "", source: "设计稿 · Z12" },
  "lulu_workbench.convfail.project_kept": { id: "lulu_workbench.convfail.project_kept", domain: "lulu_workbench", text: "项目和仓库都在，去项目列表就能看见", vars: [], tone: "", source: "设计稿 · Z12 项目不回滚" },
  "lulu_workbench.convfail.retry_last_step": { id: "lulu_workbench.convfail.retry_last_step", domain: "lulu_workbench", text: "再建一次只补最后一步，不会又建个项目", vars: [], tone: "", source: "设计稿 · Z12" },
  "lulu_workbench.convfail.why_no_rollback": { id: "lulu_workbench.convfail.why_no_rollback", domain: "lulu_workbench", text: "不整个回滚是因为项目更贵 —— 会话只是一次对话，再建一次就有", vars: [], tone: "", source: "设计稿 · Z12" },
  "lulu_workbench.convfail.wont_delete": { id: "lulu_workbench.convfail.wont_delete", domain: "lulu_workbench", text: "要删去项目设置里删，我不替你删", vars: [], tone: "", source: "设计稿 · Z12 失败不给平台自作主张的授权" },
  "lulu_workbench.disable.cancel": { id: "lulu_workbench.disable.cancel", domain: "lulu_workbench", text: "先不停", vars: [], tone: "", source: "补充 · 确认框的另一侧" },
  "lulu_workbench.disable.clean": { id: "lulu_workbench.disable.clean", domain: "lulu_workbench", text: "它手上没有事，停用不会打断任何东西。", vars: [], tone: "", source: "补充 · 四档全零那一档" },
  "lulu_workbench.disable.confirm": { id: "lulu_workbench.disable.confirm", domain: "lulu_workbench", text: "知道了，还是停用", vars: [], tone: "", source: "补充 · 内核交接 §2.2「一个能点的『还是停用』」" },
  "lulu_workbench.disable.conversations_truncated": { id: "lulu_workbench.disable.conversations_truncated", domain: "lulu_workbench", text: "还有更多会话没列出来", vars: [], tone: "", source: "补充 · conversations_truncated" },
  "lulu_workbench.disable.failed": { id: "lulu_workbench.disable.failed", domain: "lulu_workbench", text: "没停成 —— 再点一下就行", vars: [], tone: "warn", source: "补充 · 失败不丢用户动作" },
  "lulu_workbench.disable.pending": { id: "lulu_workbench.disable.pending", domain: "lulu_workbench", text: "{count} 件活在排队 —— 停了它们就一直排着，直到你派给别人", vars: ["count"], tone: "warn", source: "补充 · pending_items" },
  "lulu_workbench.disable.running": { id: "lulu_workbench.disable.running", domain: "lulu_workbench", text: "{count} 件活正在跑 —— 停了得有人接手，不然它们停在半路", vars: ["count"], tone: "warn", source: "补充 · running_items" },
  "lulu_workbench.disable.seats": { id: "lulu_workbench.disable.seats", domain: "lulu_workbench", text: "{count} 个话头里有它的位子 —— 只是以后派不到它，正在做的不受影响", vars: ["count"], tone: "", source: "补充 · roster_seats" },
  "lulu_workbench.disable.sessions": { id: "lulu_workbench.disable.sessions", domain: "lulu_workbench", text: "{count} 条会话里它还醒着 —— 停用会把它请出去", vars: ["count"], tone: "", source: "补充 · active_sessions" },
  "lulu_workbench.disable.title": { id: "lulu_workbench.disable.title", domain: "lulu_workbench", text: "{agent} 手上还有事没完", vars: ["agent"], tone: "warn", source: "补充 · 内核交接 §2.2 四档影响面" },
  "lulu_workbench.empty.desc": { id: "lulu_workbench.empty.desc", domain: "lulu_workbench", text: "不用说清怎么做。说目标和「做成什么样算成功」，Lulu 判断项目、组队、拆活、处理故障，只在必须你决定时打断。", vars: [], tone: "", source: "设计稿 · W01 空状态" },
  "lulu_workbench.empty.foot": { id: "lulu_workbench.empty.foot", domain: "lulu_workbench", text: "这里不显示示例统计。没有事件就是空的。", vars: [], tone: "neutral", source: "设计稿 · W01 空状态" },
  "lulu_workbench.empty.s1_d": { id: "lulu_workbench.empty.s1_d", domain: "lulu_workbench", text: "普通 UI 改动，一般几分钟内上线", vars: [], tone: "", source: "设计稿 · W01 starters" },
  "lulu_workbench.empty.s1_t": { id: "lulu_workbench.empty.s1_t", domain: "lulu_workbench", text: "改一下结算页的优惠券位置", vars: [], tone: "", source: "设计稿 · W01 starters" },
  "lulu_workbench.empty.s2_d": { id: "lulu_workbench.empty.s2_d", domain: "lulu_workbench", text: "先查再给方案，不直接动手", vars: [], tone: "", source: "设计稿 · W01 starters" },
  "lulu_workbench.empty.s2_t": { id: "lulu_workbench.empty.s2_t", domain: "lulu_workbench", text: "订单接口最近有点慢，看看", vars: [], tone: "", source: "设计稿 · W01 starters" },
  "lulu_workbench.empty.s3_d": { id: "lulu_workbench.empty.s3_d", domain: "lulu_workbench", text: "交给原来那个 AI 整理", vars: [], tone: "", source: "设计稿 · W01 starters" },
  "lulu_workbench.empty.s3_t": { id: "lulu_workbench.empty.s3_t", domain: "lulu_workbench", text: "把这个老项目接管进来", vars: [], tone: "", source: "设计稿 · W01 starters" },
  "lulu_workbench.empty.s4_d": { id: "lulu_workbench.empty.s4_d", domain: "lulu_workbench", text: "AI 团队 → 模型 → 添加 API 模型", vars: [], tone: "", source: "设计稿 · W01 starters" },
  "lulu_workbench.empty.s4_t": { id: "lulu_workbench.empty.s4_t", domain: "lulu_workbench", text: "加一个自己的模型", vars: [], tone: "", source: "设计稿 · W01 starters" },
  "lulu_workbench.empty.title": { id: "lulu_workbench.empty.title", domain: "lulu_workbench", text: "跟 Lulu 说你想做什么", vars: [], tone: "", source: "设计稿 · W01 空状态" },
  "lulu_workbench.evidence.empty": { id: "lulu_workbench.evidence.empty", domain: "lulu_workbench", text: "还没有产出", vars: [], tone: "", source: "设计稿 · 证据页签" },
  "lulu_workbench.evidence.from_sub": { id: "lulu_workbench.evidence.from_sub", domain: "lulu_workbench", text: "来自 {agent}", vars: ["agent"], tone: "", source: "设计稿 · S03 证据挂在父任务上" },
  "lulu_workbench.evidence.on_parent": { id: "lulu_workbench.evidence.on_parent", domain: "lulu_workbench", text: "挂在「{item}」下面", vars: ["item"], tone: "", source: "设计稿 · S03 证据可由 work_item 反查" },
  "lulu_workbench.evidence.title": { id: "lulu_workbench.evidence.title", domain: "lulu_workbench", text: "这一轮留下了什么", vars: [], tone: "", source: "设计稿 · 证据页签" },
  "lulu_workbench.folder.empty": { id: "lulu_workbench.folder.empty", domain: "lulu_workbench", text: "空文件夹 —— 我会在这儿建一个新仓库", vars: [], tone: "", source: "设计稿 · Z13 五种之一" },
  "lulu_workbench.folder.git_clean": { id: "lulu_workbench.folder.git_clean", domain: "lulu_workbench", text: "已经是 Git 仓库，工作区是干净的", vars: [], tone: "", source: "设计稿 · Z13 五种之二" },
  "lulu_workbench.folder.git_dirty": { id: "lulu_workbench.folder.git_dirty", domain: "lulu_workbench", text: "是 Git 仓库，还有 {count} 处没提交的改动", vars: ["count"], tone: "", source: "设计稿 · Z13 五种之四（最常见）" },
  "lulu_workbench.folder.no_permission": { id: "lulu_workbench.folder.no_permission", domain: "lulu_workbench", text: "我没有读这个文件夹的权限", vars: [], tone: "", source: "设计稿 · Z13 权限被拒" },
  "lulu_workbench.folder.not_git": { id: "lulu_workbench.folder.not_git", domain: "lulu_workbench", text: "有文件但不是 Git 仓库 —— 我会把它变成一个，原有文件不动", vars: [], tone: "", source: "设计稿 · Z13 五种之三" },
  "lulu_workbench.folder.open_settings": { id: "lulu_workbench.folder.open_settings", domain: "lulu_workbench", text: "打开系统设置", vars: [], tone: "", source: "设计稿 · Z13 权限被拒的出口之一" },
  "lulu_workbench.folder.pick_another": { id: "lulu_workbench.folder.pick_another", domain: "lulu_workbench", text: "换一个", vars: [], tone: "", source: "设计稿 · Z13" },
  "lulu_workbench.folder.readonly_promise": { id: "lulu_workbench.folder.readonly_promise", domain: "lulu_workbench", text: "你确认之前，这个目录里一个字节都不会变", vars: [], tone: "", source: "设计稿 · Z13 主卡片第一句" },
  "lulu_workbench.folder.stale_fix": { id: "lulu_workbench.folder.stale_fix", domain: "lulu_workbench", text: "重新指一个文件夹就行", vars: [], tone: "", source: "设计稿 · Z13" },
  "lulu_workbench.folder.stale_not_broken": { id: "lulu_workbench.folder.stale_not_broken", domain: "lulu_workbench", text: "项目没坏 —— 远程仓库还在，只是这台机器上跑不了 Agent", vars: [], tone: "", source: "设计稿 · Z13 路径失效不等于项目坏了" },
  "lulu_workbench.folder.stale_path": { id: "lulu_workbench.folder.stale_path", domain: "lulu_workbench", text: "找不到这个路径了", vars: [], tone: "", source: "设计稿 · Z13 路径失效" },
  "lulu_workbench.folder.taken": { id: "lulu_workbench.folder.taken", domain: "lulu_workbench", text: "这个文件夹已经属于「{project}」了", vars: ["project"], tone: "", source: "设计稿 · Z13 五种之五，标红最要紧" },
  "lulu_workbench.folder.taken_why": { id: "lulu_workbench.folder.taken_why", domain: "lulu_workbench", text: "两个项目同时往一个目录写会把文件写坏，所以我不接管", vars: [], tone: "", source: "设计稿 · Z13 静默抢占是数据损坏" },
  "lulu_workbench.gap.detail": { id: "lulu_workbench.gap.detail", domain: "lulu_workbench", text: "我不显示假数据顶上 —— 接上之前这里就是空的。", vars: [], tone: "neutral", source: "设计稿 · 真实状态合同的推论" },
  "lulu_workbench.gap.not_wired": { id: "lulu_workbench.gap.not_wired", domain: "lulu_workbench", text: "这一块还没接上后端 · {what}", vars: ["what"], tone: "warn", source: "设计稿 · 真实状态合同的推论" },
  "lulu_workbench.gap.unreachable": { id: "lulu_workbench.gap.unreachable", domain: "lulu_workbench", text: "暂时读不到 · {what}", vars: ["what"], tone: "warn", source: "设计稿 · Z10 同规矩" },
  "lulu_workbench.held.dont_resubmit": { id: "lulu_workbench.held.dont_resubmit", domain: "lulu_workbench", text: "别重复提交 —— 重复提交不会让你更靠前", vars: [], tone: "", source: "设计稿 · W12" },
  "lulu_workbench.held.idempotent": { id: "lulu_workbench.held.idempotent", domain: "lulu_workbench", text: "排队期间不重复扣费、不重复提交、不重复部署", vars: [], tone: "", source: "设计稿 · W12 三条幂等承诺" },
  "lulu_workbench.held.not_your_fault": { id: "lulu_workbench.held.not_your_fault", domain: "lulu_workbench", text: "不是你的代码有问题，也不是 Agent 干错了 —— 是平台的事", vars: [], tone: "", source: "设计稿 · W12 第一句" },
  "lulu_workbench.held.production_fine": { id: "lulu_workbench.held.production_fine", domain: "lulu_workbench", text: "线上现在正常服务，没受影响", vars: [], tone: "", source: "设计稿 · W12 必须在前三行" },
  "lulu_workbench.init.blocked_by_prev": { id: "lulu_workbench.init.blocked_by_prev", domain: "lulu_workbench", text: "上一步没过，没往下走", vars: [], tone: "", source: "设计稿 · StageList 未走到的步骤要写明为什么" },
  "lulu_workbench.init.not_ready_yet": { id: "lulu_workbench.init.not_ready_yet", domain: "lulu_workbench", text: "三步都回来了才算好，这一页在那之前不说「已准备好」", vars: [], tone: "", source: "设计稿 · Z11" },
  "lulu_workbench.init.same_key": { id: "lulu_workbench.init.same_key", domain: "lulu_workbench", text: "再点一次不会多建一个 —— 三步用的是同一把钥匙", vars: [], tone: "", source: "设计稿 · Z11 同一个 idempotency key 贯穿三步" },
  "lulu_workbench.init.stage_conversation": { id: "lulu_workbench.init.stage_conversation", domain: "lulu_workbench", text: "建会话", vars: [], tone: "", source: "设计稿 · Z11 三阶段之三" },
  "lulu_workbench.init.stage_project": { id: "lulu_workbench.init.stage_project", domain: "lulu_workbench", text: "建项目记录", vars: [], tone: "", source: "设计稿 · Z11 三阶段之一" },
  "lulu_workbench.init.stage_repo": { id: "lulu_workbench.init.stage_repo", domain: "lulu_workbench", text: "建远程仓库", vars: [], tone: "", source: "设计稿 · Z11 三阶段之二" },
  "lulu_workbench.init.state_done": { id: "lulu_workbench.init.state_done", domain: "lulu_workbench", text: "好了", vars: [], tone: "", source: "设计稿 · Z11 StageList st=done" },
  "lulu_workbench.init.state_fail": { id: "lulu_workbench.init.state_fail", domain: "lulu_workbench", text: "没成", vars: [], tone: "", source: "设计稿 · Z11 StageList st=fail" },
  "lulu_workbench.init.state_none": { id: "lulu_workbench.init.state_none", domain: "lulu_workbench", text: "这个项目没有远程仓库 —— 不影响后面几步", vars: [], tone: "", source: "arron 2026-08-30 点名：只有名字、无仓库的项目不许被说成失败" },
  "lulu_workbench.init.state_running": { id: "lulu_workbench.init.state_running", domain: "lulu_workbench", text: "正在做", vars: [], tone: "", source: "设计稿 · Z11 StageList st=run" },
  "lulu_workbench.init.state_wait": { id: "lulu_workbench.init.state_wait", domain: "lulu_workbench", text: "还没到", vars: [], tone: "", source: "设计稿 · Z11 StageList st=todo" },
  "lulu_workbench.item.block": { id: "lulu_workbench.item.block", domain: "lulu_workbench", text: "阻塞", vars: [], tone: "warn", source: "设计稿 · 状态药丸" },
  "lulu_workbench.item.closed": { id: "lulu_workbench.item.closed", domain: "lulu_workbench", text: "已关闭", vars: [], tone: "neutral", source: "设计稿 · 状态药丸" },
  "lulu_workbench.item.done": { id: "lulu_workbench.item.done", domain: "lulu_workbench", text: "已完成", vars: [], tone: "ok", source: "设计稿 · 状态药丸" },
  "lulu_workbench.item.fail": { id: "lulu_workbench.item.fail", domain: "lulu_workbench", text: "失败", vars: [], tone: "danger", source: "设计稿 · 状态药丸" },
  "lulu_workbench.item.held": { id: "lulu_workbench.item.held", domain: "lulu_workbench", text: "平台排队", vars: [], tone: "warn", source: "设计稿 · 状态药丸" },
  "lulu_workbench.item.none": { id: "lulu_workbench.item.none", domain: "lulu_workbench", text: "未分配", vars: [], tone: "neutral", source: "设计稿 · 状态药丸" },
  "lulu_workbench.item.rec": { id: "lulu_workbench.item.rec", domain: "lulu_workbench", text: "恢复中", vars: [], tone: "neutral", source: "设计稿 · 状态药丸" },
  "lulu_workbench.item.run": { id: "lulu_workbench.item.run", domain: "lulu_workbench", text: "进行中", vars: [], tone: "neutral", source: "设计稿 · 状态药丸" },
  "lulu_workbench.item.todo": { id: "lulu_workbench.item.todo", domain: "lulu_workbench", text: "待开始", vars: [], tone: "neutral", source: "设计稿 · 状态药丸" },
  "lulu_workbench.item.unknown": { id: "lulu_workbench.item.unknown", domain: "lulu_workbench", text: "不知道", vars: [], tone: "warn", source: "设计稿 · 状态药丸" },
  "lulu_workbench.item.wait": { id: "lulu_workbench.item.wait", domain: "lulu_workbench", text: "等依赖", vars: [], tone: "warn", source: "设计稿 · 状态药丸" },
  "lulu_workbench.launch.direct_k": { id: "lulu_workbench.launch.direct_k", domain: "lulu_workbench", text: "直接开始", vars: [], tone: "", source: "设计稿 · Z01" },
  "lulu_workbench.launch.direct_v": { id: "lulu_workbench.launch.direct_v", domain: "lulu_workbench", text: "通用会话。能聊天讨论、组账户级 Agent；不能读代码、派任务、动资源、部署", vars: [], tone: "", source: "设计稿 · Z01" },
  "lulu_workbench.launch.folder_readonly": { id: "lulu_workbench.launch.folder_readonly", domain: "lulu_workbench", text: "你确认之前，这个目录里一个字节都不会变。", vars: [], tone: "ok", source: "设计稿 · Z13" },
  "lulu_workbench.launch.how_else_k": { id: "lulu_workbench.launch.how_else_k", domain: "lulu_workbench", text: "还能怎么建", vars: [], tone: "", source: "设计稿 · Z01" },
  "lulu_workbench.launch.how_else_v": { id: "lulu_workbench.launch.how_else_v", domain: "lulu_workbench", text: "新建远程项目（只填名字）/ 连接远程仓库 / 导入已有项目", vars: [], tone: "", source: "设计稿 · Z01" },
  "lulu_workbench.launch.import_project": { id: "lulu_workbench.launch.import_project", domain: "lulu_workbench", text: "导入已有项目", vars: [], tone: "", source: "设计稿 · Z01 第 2099 行 actions" },
  "lulu_workbench.launch.loading_desc": { id: "lulu_workbench.launch.loading_desc", domain: "lulu_workbench", text: "读不到之前不显示任何项目行，也不放灰色骨架假装有六个。「直接开始」始终可点 —— 它不依赖项目列表。", vars: [], tone: "", source: "设计稿 · Z10" },
  "lulu_workbench.launch.loading_title": { id: "lulu_workbench.launch.loading_title", domain: "lulu_workbench", text: "项目列表正在读", vars: [], tone: "", source: "设计稿 · Z10" },
  "lulu_workbench.launch.mac_only_desc": { id: "lulu_workbench.launch.mac_only_desc", domain: "lulu_workbench", text: "本机文件夹要系统级权限和原生 Git，浏览器给不了。", vars: [], tone: "", source: "设计稿 · Z02" },
  "lulu_workbench.launch.mac_only_title": { id: "lulu_workbench.launch.mac_only_title", domain: "lulu_workbench", text: "这两个入口只有 macOS 客户端有", vars: [], tone: "", source: "设计稿 · Z02" },
  "lulu_workbench.launch.mode_change_k": { id: "lulu_workbench.launch.mode_change_k", domain: "lulu_workbench", text: "改得了吗", vars: [], tone: "", source: "设计稿 · Z01" },
  "lulu_workbench.launch.mode_change_v": { id: "lulu_workbench.launch.mode_change_v", domain: "lulu_workbench", text: "单 Agent 会话之后可以升成团队；团队不能降回单 Agent", vars: [], tone: "", source: "设计稿 · Z01" },
  "lulu_workbench.launch.mode_default_k": { id: "lulu_workbench.launch.mode_default_k", domain: "lulu_workbench", text: "默认", vars: [], tone: "", source: "设计稿 · Z01" },
  "lulu_workbench.launch.mode_default_v": { id: "lulu_workbench.launch.mode_default_v", domain: "lulu_workbench", text: "简单改动默认单 Agent —— 协作成本不该大于开发收益", vars: [], tone: "", source: "设计稿 · Z01" },
  "lulu_workbench.launch.mode_desc": { id: "lulu_workbench.launch.mode_desc", domain: "lulu_workbench", text: "两种都能随时聊天。区别在于谁来干活、以及界面上有没有团队入口。", vars: [], tone: "", source: "设计稿 · Z01" },
  "lulu_workbench.launch.mode_not_persisted": { id: "lulu_workbench.launch.mode_not_persisted", domain: "lulu_workbench", text: "这个选择暂时还存不下 —— 后端收不了它。会话能正常建，但下次打开时我认不出你选的是哪种。", vars: [], tone: "warn", source: "设计稿 · 真实状态合同的推论" },
  "lulu_workbench.launch.mode_solo_k": { id: "lulu_workbench.launch.mode_solo_k", domain: "lulu_workbench", text: "单 Agent", vars: [], tone: "", source: "设计稿 · Z01" },
  "lulu_workbench.launch.mode_solo_v": { id: "lulu_workbench.launch.mode_solo_v", domain: "lulu_workbench", text: "一个 Agent 全程负责。右上角和输入框上方都没有团队入口，界面更干净", vars: [], tone: "", source: "设计稿 · Z01" },
  "lulu_workbench.launch.mode_team_k": { id: "lulu_workbench.launch.mode_team_k", domain: "lulu_workbench", text: "团队", vars: [], tone: "", source: "设计稿 · Z01" },
  "lulu_workbench.launch.mode_team_v": { id: "lulu_workbench.launch.mode_team_v", domain: "lulu_workbench", text: "Lulu 组队、拆活、安排依赖。输入框上方常驻团队条，可随时调整", vars: [], tone: "", source: "设计稿 · Z01" },
  "lulu_workbench.launch.mode_title": { id: "lulu_workbench.launch.mode_title", domain: "lulu_workbench", text: "先决定这条会话怎么干活", vars: [], tone: "", source: "设计稿 · Z01" },
  "lulu_workbench.launch.new_folder": { id: "lulu_workbench.launch.new_folder", domain: "lulu_workbench", text: "新建本地开发文件夹", vars: [], tone: "", source: "设计稿 · Z02" },
  "lulu_workbench.launch.new_project": { id: "lulu_workbench.launch.new_project", domain: "lulu_workbench", text: "新建远程项目", vars: [], tone: "", source: "设计稿 · Z01" },
  "lulu_workbench.launch.new_title": { id: "lulu_workbench.launch.new_title", domain: "lulu_workbench", text: "新的话头", vars: [], tone: "", source: "设计稿 · Z01 直接开始" },
  "lulu_workbench.launch.path_desc_web": { id: "lulu_workbench.launch.path_desc_web", domain: "lulu_workbench", text: "Web 上没有本地文件夹入口 —— 不显示、不置灰、也不用浏览器目录 API 假装。要用本机代码请在 macOS 客户端里做。", vars: [], tone: "", source: "设计稿 · Z01" },
  "lulu_workbench.launch.path_title": { id: "lulu_workbench.launch.path_title", domain: "lulu_workbench", text: "两条路：直接开始，或者先选一个项目", vars: [], tone: "", source: "设计稿 · Z01" },
  "lulu_workbench.launch.pick_folder": { id: "lulu_workbench.launch.pick_folder", domain: "lulu_workbench", text: "选择本地开发文件夹", vars: [], tone: "", source: "设计稿 · Z02" },
  "lulu_workbench.launch.picked_k": { id: "lulu_workbench.launch.picked_k", domain: "lulu_workbench", text: "选了项目", vars: [], tone: "", source: "设计稿 · Z01" },
  "lulu_workbench.launch.picked_v": { id: "lulu_workbench.launch.picked_v", domain: "lulu_workbench", text: "一步进对话，没有第二个「确认项目」页；绑定后不能再换", vars: [], tone: "", source: "设计稿 · Z01" },
  "lulu_workbench.launch.read_failed": { id: "lulu_workbench.launch.read_failed", domain: "lulu_workbench", text: "暂时读不到项目列表 · 重试", vars: [], tone: "warn", source: "设计稿 · Z10" },
  "lulu_workbench.launch.really_none": { id: "lulu_workbench.launch.really_none", domain: "lulu_workbench", text: "还没有项目。可以先聊，也可以现在建一个。", vars: [], tone: "", source: "设计稿 · Z10" },
  "lulu_workbench.launch.recent_foot": { id: "lulu_workbench.launch.recent_foot", domain: "lulu_workbench", text: "另有数据看板、小程序后端 —— 最多列 6 个。同步状态读不到就写\"未核验\"，不用绿点也不填 0。", vars: [], tone: "", source: "设计稿 · Z01 第 2104 行" },
  "lulu_workbench.launch.recent_meta": { id: "lulu_workbench.launch.recent_meta", domain: "lulu_workbench", text: "6 个 · 按最近活动排", vars: [], tone: "", source: "设计稿 · Z01" },
  "lulu_workbench.launch.recent_title": { id: "lulu_workbench.launch.recent_title", domain: "lulu_workbench", text: "最近的项目", vars: [], tone: "", source: "设计稿 · Z01" },
  "lulu_workbench.launch.retry": { id: "lulu_workbench.launch.retry", domain: "lulu_workbench", text: "重试", vars: [], tone: "", source: "设计稿 · Z10" },
  "lulu_workbench.launch.search_clear": { id: "lulu_workbench.launch.search_clear", domain: "lulu_workbench", text: "清空搜索", vars: [], tone: "", source: "设计稿 · Z10" },
  "lulu_workbench.launch.search_create": { id: "lulu_workbench.launch.search_create", domain: "lulu_workbench", text: "用「{keyword}」新建项目", vars: ["keyword"], tone: "", source: "设计稿 · Z10" },
  "lulu_workbench.launch.search_hint": { id: "lulu_workbench.launch.search_hint", domain: "lulu_workbench", text: "搜项目名、仓库地址或标签", vars: [], tone: "", source: "设计稿 · Z10" },
  "lulu_workbench.launch.search_none": { id: "lulu_workbench.launch.search_none", domain: "lulu_workbench", text: "没有匹配「{keyword}」的项目", vars: ["keyword"], tone: "", source: "设计稿 · Z10" },
  "lulu_workbench.launch.start_failed": { id: "lulu_workbench.launch.start_failed", domain: "lulu_workbench", text: "这条没开成 —— 你选的还在，再点一下就行", vars: [], tone: "", source: "设计稿 · Z12 失败不丢用户已经做的选择" },
  "lulu_workbench.launch.start_solo": { id: "lulu_workbench.launch.start_solo", domain: "lulu_workbench", text: "单 Agent 开始", vars: [], tone: "", source: "设计稿 · Z01" },
  "lulu_workbench.launch.start_team": { id: "lulu_workbench.launch.start_team", domain: "lulu_workbench", text: "组个团队开始", vars: [], tone: "", source: "设计稿 · Z01" },
  "lulu_workbench.launch.starting": { id: "lulu_workbench.launch.starting", domain: "lulu_workbench", text: "正在开", vars: [], tone: "", source: "设计稿 · Z01" },
  "lulu_workbench.launch.sub": { id: "lulu_workbench.launch.sub", domain: "lulu_workbench", text: "可以直接聊天；选择项目后 Lulu 才会读取对应代码与上下文。", vars: [], tone: "", source: "设计稿 · Z01" },
  "lulu_workbench.launch.title": { id: "lulu_workbench.launch.title", domain: "lulu_workbench", text: "开始新会话", vars: [], tone: "", source: "设计稿 · Z01" },
  "lulu_workbench.launch.title_shows_k": { id: "lulu_workbench.launch.title_shows_k", domain: "lulu_workbench", text: "标题会显示", vars: [], tone: "", source: "设计稿 · Z01" },
  "lulu_workbench.launch.title_shows_v": { id: "lulu_workbench.launch.title_shows_v", domain: "lulu_workbench", text: "通用对话 · 未关联项目 —— 这不是错误状态", vars: [], tone: "", source: "设计稿 · Z01" },
  "lulu_workbench.launch.unverified": { id: "lulu_workbench.launch.unverified", domain: "lulu_workbench", text: "未核验", vars: [], tone: "warn", source: "设计稿 · Z01" },
  "lulu_workbench.mention.empty": { id: "lulu_workbench.mention.empty", domain: "lulu_workbench", text: "这条会话只有 Lulu，没有别人可叫", vars: [], tone: "", source: "设计稿 · W08 输入区 @ 面板" },
  "lulu_workbench.mention.group_here": { id: "lulu_workbench.mention.group_here", domain: "lulu_workbench", text: "这条会话里的", vars: [], tone: "", source: "需求 2026-09-06 · @ 面板接上 Agent 库" },
  "lulu_workbench.mention.group_invite_people": { id: "lulu_workbench.mention.group_invite_people", domain: "lulu_workbench", text: "还没进这条会话的人", vars: [], tone: "", source: "会话团队与真人协作 PRD v1 §6（叫进来才 @ 得到）" },
  "lulu_workbench.mention.group_library": { id: "lulu_workbench.mention.group_library", domain: "lulu_workbench", text: "从 Agent 库叫进来", vars: [], tone: "", source: "需求 2026-09-06 · @ 面板接上 Agent 库" },
  "lulu_workbench.mention.group_people": { id: "lulu_workbench.mention.group_people", domain: "lulu_workbench", text: "一起管这条的人", vars: [], tone: "", source: "会话团队与真人协作 PRD v1 §6" },
  "lulu_workbench.mention.join_failed": { id: "lulu_workbench.mention.join_failed", domain: "lulu_workbench", text: "没叫进来。再点一次试试。", vars: [], tone: "warn", source: "需求 2026-09-06 · @ 面板接上 Agent 库" },
  "lulu_workbench.mention.joining": { id: "lulu_workbench.mention.joining", domain: "lulu_workbench", text: "正在叫…", vars: [], tone: "", source: "需求 2026-09-06 · @ 面板接上 Agent 库" },
  "lulu_workbench.mention.no_team_change": { id: "lulu_workbench.mention.no_team_change", domain: "lulu_workbench", text: "从库里叫一位进来，只作用于这条会话，不改 Agent 库", vars: [], tone: "", source: "设计稿 · W08 输入区 @ 面板（2026-09-06 改真）" },
  "lulu_workbench.mention.own_memory": { id: "lulu_workbench.mention.own_memory", domain: "lulu_workbench", text: "他在每条会话里的记忆是分开的，不会串", vars: [], tone: "", source: "需求 2026-09-06 · 多个组加同一位 Agent" },
  "lulu_workbench.mention.person_hint": { id: "lulu_workbench.mention.person_hint", domain: "lulu_workbench", text: "叫他来看一眼，不会让他动手。", vars: [], tone: "", source: "会话团队与真人协作 PRD v1 §6" },
  "lulu_workbench.mention.sub_excluded": { id: "lulu_workbench.mention.sub_excluded", domain: "lulu_workbench", text: "临时子 Agent 不在这里 —— 它们不是团队成员", vars: [], tone: "", source: "设计稿 · 子 Agent 边界" },
  "lulu_workbench.mention.title": { id: "lulu_workbench.mention.title", domain: "lulu_workbench", text: "叫谁", vars: [], tone: "", source: "设计稿 · W08 输入区 @ 面板" },
  "lulu_workbench.model.auto": { id: "lulu_workbench.model.auto", domain: "lulu_workbench", text: "Lulu 自动选", vars: [], tone: "", source: "设计稿 · W16a 默认" },
  "lulu_workbench.model.effort_fast": { id: "lulu_workbench.model.effort_fast", domain: "lulu_workbench", text: "快速", vars: [], tone: "", source: "设计稿 · W16a 推理强度三档" },
  "lulu_workbench.model.effort_max": { id: "lulu_workbench.model.effort_max", domain: "lulu_workbench", text: "最高", vars: [], tone: "", source: "设计稿 · W16a 推理强度三档" },
  "lulu_workbench.model.effort_sheet_sub": { id: "lulu_workbench.model.effort_sheet_sub", domain: "lulu_workbench", text: "仅影响下一条消息，发送后恢复。不改系统默认或 Agents，不打断运行中任务。", vars: [], tone: "", source: "after-v4-taste Pattern A · honesty footer" },
  "lulu_workbench.model.effort_sheet_title": { id: "lulu_workbench.model.effort_sheet_title", domain: "lulu_workbench", text: "本次消息力度", vars: [], tone: "", source: "after-v4-taste Pattern A · 本次消息力度" },
  "lulu_workbench.model.effort_standard": { id: "lulu_workbench.model.effort_standard", domain: "lulu_workbench", text: "标准", vars: [], tone: "", source: "设计稿 · W16a 推理强度三档" },
  "lulu_workbench.model.group_default": { id: "lulu_workbench.model.group_default", domain: "lulu_workbench", text: "默认", vars: [], tone: "", source: "设计稿 · modelPick" },
  "lulu_workbench.model.group_fixed": { id: "lulu_workbench.model.group_fixed", domain: "lulu_workbench", text: "固定一个（不会静默换）", vars: [], tone: "", source: "设计稿 · modelPick" },
  "lulu_workbench.model.next_message_only": { id: "lulu_workbench.model.next_message_only", domain: "lulu_workbench", text: "仅影响下一条消息，发送后恢复。不改系统默认或 Agents，不打断运行中任务。", vars: [], tone: "", source: "after-v4-taste Pattern A · honesty footer" },
  "lulu_workbench.model.picker_sub": { id: "lulu_workbench.model.picker_sub", domain: "lulu_workbench", text: "选和你对话的策略；不动团队里的 Agent，也不打断正在跑的活。", vars: [], tone: "", source: "after-v4-taste Pattern A" },
  "lulu_workbench.model.picker_title": { id: "lulu_workbench.model.picker_title", domain: "lulu_workbench", text: "选择策略", vars: [], tone: "", source: "after-v4-taste Pattern A · 选择策略" },
  "lulu_workbench.model.pinned": { id: "lulu_workbench.model.pinned", domain: "lulu_workbench", text: "固定", vars: [], tone: "", source: "设计稿 · W16b 绿色角标" },
  "lulu_workbench.model.reason_expired": { id: "lulu_workbench.model.reason_expired", domain: "lulu_workbench", text: "授权过期了", vars: [], tone: "", source: "设计稿 · W18 状态列" },
  "lulu_workbench.model.reason_quota": { id: "lulu_workbench.model.reason_quota", domain: "lulu_workbench", text: "额度用完了", vars: [], tone: "", source: "设计稿 · W18 状态列" },
  "lulu_workbench.model.runtime_not_wired": { id: "lulu_workbench.model.runtime_not_wired", domain: "lulu_workbench", text: "当前仅保存本次消息的模型选择；统一模型凭据尚未接入对话运行时，不会伪装成已生效。", vars: [], tone: "warn", source: "模型库与 Agent 配置 V2 · 真实运行边界" },
  "lulu_workbench.model.scope_note": { id: "lulu_workbench.model.scope_note", domain: "lulu_workbench", text: "这里选的是和你对话的那个模型。团队里的 Agent 用什么模型，在 Agent 编辑弹窗里改", vars: [], tone: "", source: "设计稿 · W16a 边界写死在下拉里" },
  "lulu_workbench.model.sheet_foot": { id: "lulu_workbench.model.sheet_foot", domain: "lulu_workbench", text: "推理强度在旁边那个按钮里单独选。Agent 换模型要进它的编辑页。", vars: [], tone: "", source: "设计稿 · mModelSheet" },
  "lulu_workbench.model.unavailable": { id: "lulu_workbench.model.unavailable", domain: "lulu_workbench", text: "{model} 现在用不了：{reason}", vars: ["model", "reason"], tone: "", source: "设计稿 · W16c/W19 显示具体原因" },
  "lulu_workbench.model.unverified": { id: "lulu_workbench.model.unverified", domain: "lulu_workbench", text: "未验证", vars: [], tone: "", source: "设计稿 · W16a 未验证的降为灰字加标签" },
  "lulu_workbench.model.unverified_note": { id: "lulu_workbench.model.unverified_note", domain: "lulu_workbench", text: "没验过，我不会自动派重要的活给它", vars: [], tone: "", source: "设计稿 · 验收 §E.32" },
  "lulu_workbench.model.wont_switch": { id: "lulu_workbench.model.wont_switch", domain: "lulu_workbench", text: "我停下来问你，绝不静默换 —— 换了结果可能不一样而你不知道", vars: [], tone: "", source: "设计稿 · W19 第一句" },
  "lulu_workbench.people.add_hint": { id: "lulu_workbench.people.add_hint", domain: "lulu_workbench", text: "只能从「一起管」里已有的成员挑。要请新的人，去那一屏办。", vars: [], tone: "", source: "会话团队与真人协作 PRD v1 §7" },
  "lulu_workbench.people.cannot_dispatch": { id: "lulu_workbench.people.cannot_dispatch", domain: "lulu_workbench", text: "他能看、能说，但不能让 NPC 动手。", vars: [], tone: "", source: "会话团队与真人协作 PRD v1 §5" },
  "lulu_workbench.people.invite": { id: "lulu_workbench.people.invite", domain: "lulu_workbench", text: "叫一个人进来", vars: [], tone: "", source: "会话团队与真人协作 PRD v1 §7" },
  "lulu_workbench.people.invite_failed": { id: "lulu_workbench.people.invite_failed", domain: "lulu_workbench", text: "没叫进来。再点一下试试。", vars: [], tone: "", source: "会话团队与真人协作 PRD v1 §7" },
  "lulu_workbench.people.invite_none": { id: "lulu_workbench.people.invite_none", domain: "lulu_workbench", text: "「一起管」里的人都已经在这条会话里了。", vars: [], tone: "", source: "会话团队与真人协作 PRD v1 §7" },
  "lulu_workbench.people.inviting": { id: "lulu_workbench.people.inviting", domain: "lulu_workbench", text: "正在叫…", vars: [], tone: "", source: "会话团队与真人协作 PRD v1 §7" },
  "lulu_workbench.people.none": { id: "lulu_workbench.people.none", domain: "lulu_workbench", text: "这条会话现在只有你和 NPC。", vars: [], tone: "", source: "会话团队与真人协作 PRD v1" },
  "lulu_workbench.people.remove": { id: "lulu_workbench.people.remove", domain: "lulu_workbench", text: "移出这条", vars: [], tone: "", source: "会话团队与真人协作 PRD v1" },
  "lulu_workbench.people.remove_failed": { id: "lulu_workbench.people.remove_failed", domain: "lulu_workbench", text: "没移出去。再点一下试试。", vars: [], tone: "", source: "会话团队与真人协作 PRD v1 §7" },
  "lulu_workbench.people.removing": { id: "lulu_workbench.people.removing", domain: "lulu_workbench", text: "正在移出…", vars: [], tone: "", source: "会话团队与真人协作 PRD v1 §7" },
  "lulu_workbench.people.role.operator": { id: "lulu_workbench.people.role.operator", domain: "lulu_workbench", text: "干活的", vars: [], tone: "", source: "会话团队与真人协作 PRD v1" },
  "lulu_workbench.people.role.owner": { id: "lulu_workbench.people.role.owner", domain: "lulu_workbench", text: "老板", vars: [], tone: "", source: "会话团队与真人协作 PRD v1" },
  "lulu_workbench.people.role.unknown": { id: "lulu_workbench.people.role.unknown", domain: "lulu_workbench", text: "认不出他这一档", vars: [], tone: "", source: "会话团队与真人协作 PRD v1" },
  "lulu_workbench.people.role.viewer": { id: "lulu_workbench.people.role.viewer", domain: "lulu_workbench", text: "看看就好", vars: [], tone: "", source: "会话团队与真人协作 PRD v1" },
  "lulu_workbench.people.title": { id: "lulu_workbench.people.title", domain: "lulu_workbench", text: "一起管这条的人", vars: [], tone: "", source: "会话团队与真人协作 PRD v1" },
  "lulu_workbench.plan.acceptance_label": { id: "lulu_workbench.plan.acceptance_label", domain: "lulu_workbench", text: "怎么算成功", vars: [], tone: "", source: "设计稿 · goal 卡内行标" },
  "lulu_workbench.plan.already": { id: "lulu_workbench.plan.already", domain: "lulu_workbench", text: "这一轮已经安排下去了 —— 进度在右边的工作板上", vars: [], tone: "", source: "设计稿 · goal 已安排态（服务端 task_id 非空）" },
  "lulu_workbench.plan.current": { id: "lulu_workbench.plan.current", domain: "lulu_workbench", text: "当前这一版 · 第 {revision} 稿", vars: ["revision"], tone: "", source: "补充 · 内核交接 §1.3 plans[].revision" },
  "lulu_workbench.plan.failed": { id: "lulu_workbench.plan.failed", domain: "lulu_workbench", text: "这一下没安排成。再点一次就行 —— 不会开出第二条。", vars: [], tone: "", source: "补充（失败要留在原地说清楚，不跳转）" },
  "lulu_workbench.plan.headline": { id: "lulu_workbench.plan.headline", domain: "lulu_workbench", text: "我理解成这样，你看对不对：", vars: [], tone: "", source: "设计稿 · goal Lulu 那句原话" },
  "lulu_workbench.plan.none": { id: "lulu_workbench.plan.none", domain: "lulu_workbench", text: "还没有计划。说一句你想做的事，Lulu 会先拆出来给你看。", vars: [], tone: "", source: "补充 · 工作板 plans 为空是真话，不是错误" },
  "lulu_workbench.plan.objective_label": { id: "lulu_workbench.plan.objective_label", domain: "lulu_workbench", text: "做成什么样", vars: [], tone: "", source: "设计稿 · goal 卡内行标" },
  "lulu_workbench.plan.revise": { id: "lulu_workbench.plan.revise", domain: "lulu_workbench", text: "我改一下目标", vars: [], tone: "", source: "设计稿 · goal 次操作" },
  "lulu_workbench.plan.roster_changed": { id: "lulu_workbench.plan.roster_changed", domain: "lulu_workbench", text: "这一版是按 {planned} 位排的，现在队里有 {now} 位", vars: ["now", "planned"], tone: "warn", source: "补充 · 内核交接 §2.2" },
  "lulu_workbench.plan.same_roster": { id: "lulu_workbench.plan.same_roster", domain: "lulu_workbench", text: "这一版是按现在队里这 {count} 位排的", vars: ["count"], tone: "", source: "补充 · 内核交接 §2.2「说得出这一版是按谁排的」" },
  "lulu_workbench.plan.start": { id: "lulu_workbench.plan.start", domain: "lulu_workbench", text: "开始做", vars: [], tone: "", source: "设计稿 · goal 主操作" },
  "lulu_workbench.presence.last_seen": { id: "lulu_workbench.presence.last_seen", domain: "lulu_workbench", text: "最后一次听到它 · {when}", vars: ["when"], tone: "", source: "设计稿 · 「写最后事件时间」" },
  "lulu_workbench.presence.unknown": { id: "lulu_workbench.presence.unknown", domain: "lulu_workbench", text: "不知道它在不在", vars: [], tone: "warn", source: "设计稿 · SPEC-subagent-run-panel-v3 §63" },
  "lulu_workbench.rail.group_general": { id: "lulu_workbench.rail.group_general", domain: "lulu_workbench", text: "不挂项目", vars: [], tone: "", source: "补充" },
  "lulu_workbench.rail.new_conversation": { id: "lulu_workbench.rail.new_conversation", domain: "lulu_workbench", text: "新会话", vars: [], tone: "", source: "设计稿 · 会话栏主操作" },
  "lulu_workbench.rail.recents": { id: "lulu_workbench.rail.recents", domain: "lulu_workbench", text: "最近对话", vars: [], tone: "", source: "左侧全局导航" },
  "lulu_workbench.recover.catching_up": { id: "lulu_workbench.recover.catching_up", domain: "lulu_workbench", text: "补齐断线期间的事件 · {count} 条", vars: ["count"], tone: "", source: "设计稿 · W13 第三步" },
  "lulu_workbench.recover.headline": { id: "lulu_workbench.recover.headline", domain: "lulu_workbench", text: "把这段时间的事一次补齐，不是重新做一遍", vars: [], tone: "", source: "设计稿 · W13" },
  "lulu_workbench.recover.idle": { id: "lulu_workbench.recover.idle", domain: "lulu_workbench", text: "{who} 等在那儿没动", vars: ["who"], tone: "", source: "设计稿 · W13 要具体" },
  "lulu_workbench.recover.nothing_running": { id: "lulu_workbench.recover.nothing_running", domain: "lulu_workbench", text: "补齐完成前不显示任何「进行中」", vars: [], tone: "", source: "设计稿 · W13 底部" },
  "lulu_workbench.recover.what_happened": { id: "lulu_workbench.recover.what_happened", domain: "lulu_workbench", text: "{who} {what}", vars: ["what", "who"], tone: "", source: "设计稿 · W13 要具体，不是「正在同步」" },
  "lulu_workbench.red.card_approve": { id: "lulu_workbench.red.card_approve", domain: "lulu_workbench", text: "同意，继续", vars: [], tone: "", source: "修复任务闭环 PRD v1 §A" },
  "lulu_workbench.red.card_ask": { id: "lulu_workbench.red.card_ask", domain: "lulu_workbench", text: "问 Lulu", vars: [], tone: "", source: "修复任务闭环 PRD v1 §A（arron 2026-09-09：可以问，Lulu 搞不定就找人）" },
  "lulu_workbench.red.card_ask_seed": { id: "lulu_workbench.red.card_ask_seed", domain: "lulu_workbench", text: "这一步为什么要我点？碰到了什么？", vars: [], tone: "", source: "修复任务闭环 PRD v1 §A" },
  "lulu_workbench.red.card_failed": { id: "lulu_workbench.red.card_failed", domain: "lulu_workbench", text: "没点上，再试一次。", vars: [], tone: "", source: "修复任务闭环 PRD v1 §A" },
  "lulu_workbench.red.card_reject": { id: "lulu_workbench.red.card_reject", domain: "lulu_workbench", text: "不同意，停下", vars: [], tone: "", source: "修复任务闭环 PRD v1 §A" },
  "lulu_workbench.red.card_settled": { id: "lulu_workbench.red.card_settled", domain: "lulu_workbench", text: "这一条已经处理过了。", vars: [], tone: "", source: "修复任务闭环 PRD v1 §A" },
  "lulu_workbench.red.expired": { id: "lulu_workbench.red.expired", domain: "lulu_workbench", text: "这张卡过期了，我重新问一次 —— 没有替你执行", vars: [], tone: "", source: "设计稿 · W15 过期重新询问，绝不默认执行" },
  "lulu_workbench.red.expires_in": { id: "lulu_workbench.red.expires_in", domain: "lulu_workbench", text: "这张卡还有 {duration} 有效", vars: ["duration"], tone: "", source: "设计稿 · W15 卡多久有效" },
  "lulu_workbench.red.kind_access_policy": { id: "lulu_workbench.red.kind_access_policy", domain: "lulu_workbench", text: "改访问策略", vars: [], tone: "", source: "设计稿 · W15 五类之三" },
  "lulu_workbench.red.kind_data_migration": { id: "lulu_workbench.red.kind_data_migration", domain: "lulu_workbench", text: "迁数据", vars: [], tone: "", source: "设计稿 · W15 五类之五" },
  "lulu_workbench.red.kind_delete_data": { id: "lulu_workbench.red.kind_delete_data", domain: "lulu_workbench", text: "删数据", vars: [], tone: "", source: "设计稿 · W15 五类之一" },
  "lulu_workbench.red.kind_irreversible_infra": { id: "lulu_workbench.red.kind_irreversible_infra", domain: "lulu_workbench", text: "动不可逆的基础设施", vars: [], tone: "", source: "设计稿 · W15 五类之四" },
  "lulu_workbench.red.kind_spend_money": { id: "lulu_workbench.red.kind_spend_money", domain: "lulu_workbench", text: "花钱", vars: [], tone: "", source: "设计稿 · W15 五类之二" },
  "lulu_workbench.red.never_for_you": { id: "lulu_workbench.red.never_for_you", domain: "lulu_workbench", text: "这五类我永远不会替你决定，哪怕你之前授权过一次", vars: [], tone: "", source: "设计稿 · W15" },
  "lulu_workbench.red.q_after": { id: "lulu_workbench.red.q_after", domain: "lulu_workbench", text: "做完之后会怎样", vars: [], tone: "", source: "设计稿 · W15 八问之三" },
  "lulu_workbench.red.q_alternative": { id: "lulu_workbench.red.q_alternative", domain: "lulu_workbench", text: "有没有别的办法", vars: [], tone: "", source: "设计稿 · W15 八问之六" },
  "lulu_workbench.red.q_backup": { id: "lulu_workbench.red.q_backup", domain: "lulu_workbench", text: "有没有备份", vars: [], tone: "", source: "设计稿 · W15 八问之五" },
  "lulu_workbench.red.q_frozen": { id: "lulu_workbench.red.q_frozen", domain: "lulu_workbench", text: "写域冻了没有", vars: [], tone: "", source: "设计稿 · W15 八问之七" },
  "lulu_workbench.red.q_undo": { id: "lulu_workbench.red.q_undo", domain: "lulu_workbench", text: "能不能撤回", vars: [], tone: "", source: "设计稿 · W15 八问之四" },
  "lulu_workbench.red.q_valid_for": { id: "lulu_workbench.red.q_valid_for", domain: "lulu_workbench", text: "这张卡多久有效", vars: [], tone: "", source: "设计稿 · W15 八问之八" },
  "lulu_workbench.red.q_what": { id: "lulu_workbench.red.q_what", domain: "lulu_workbench", text: "要做什么", vars: [], tone: "", source: "设计稿 · W15 八问之一" },
  "lulu_workbench.red.q_why": { id: "lulu_workbench.red.q_why", domain: "lulu_workbench", text: "为什么要做", vars: [], tone: "", source: "设计稿 · W15 八问之二" },
  "lulu_workbench.red.recommended": { id: "lulu_workbench.red.recommended", domain: "lulu_workbench", text: "推荐", vars: [], tone: "", source: "设计稿 · W15 替代方案标绿推荐" },
  "lulu_workbench.red.scopes_frozen": { id: "lulu_workbench.red.scopes_frozen", domain: "lulu_workbench", text: "相关写域已冻结。你决定之前没人能改", vars: [], tone: "", source: "设计稿 · W15 决定期间的一致性保证" },
  "lulu_workbench.run.action.cancel": { id: "lulu_workbench.run.action.cancel", domain: "lulu_workbench", text: "先不动", vars: [], tone: "", source: "子 Agent 运行面板 v3" },
  "lulu_workbench.run.action.confirm": { id: "lulu_workbench.run.action.confirm", domain: "lulu_workbench", text: "确定停止", vars: [], tone: "", source: "子 Agent 运行面板 v3" },
  "lulu_workbench.run.action.confirm_all": { id: "lulu_workbench.run.action.confirm_all", domain: "lulu_workbench", text: "确定停止这一轮？正在运行的子 Agent 会一起停止。", vars: [], tone: "", source: "子 Agent 运行面板 v3" },
  "lulu_workbench.run.action.confirm_one": { id: "lulu_workbench.run.action.confirm_one", domain: "lulu_workbench", text: "确定停止这个子 Agent？父 Agent 和其他子 Agent 不会受影响。", vars: [], tone: "", source: "子 Agent 运行面板 v3" },
  "lulu_workbench.run.action.confirm_round": { id: "lulu_workbench.run.action.confirm_round", domain: "lulu_workbench", text: "确定停下这一轮？还没做完的我都停掉，已经做完的不动。", vars: [], tone: "", source: "补充" },
  "lulu_workbench.run.action.failed": { id: "lulu_workbench.run.action.failed", domain: "lulu_workbench", text: "这一条没停下来，请再试一次。", vars: [], tone: "danger", source: "子 Agent 运行面板 v3" },
  "lulu_workbench.run.action.pause": { id: "lulu_workbench.run.action.pause", domain: "lulu_workbench", text: "暂停", vars: [], tone: "", source: "补充" },
  "lulu_workbench.run.action.resume": { id: "lulu_workbench.run.action.resume", domain: "lulu_workbench", text: "继续", vars: [], tone: "", source: "补充" },
  "lulu_workbench.run.action.round_already_stopped": { id: "lulu_workbench.run.action.round_already_stopped", domain: "lulu_workbench", text: "这一轮已经停了，没有还在跑的活。", vars: [], tone: "", source: "补充" },
  "lulu_workbench.run.action.round_failed": { id: "lulu_workbench.run.action.round_failed", domain: "lulu_workbench", text: "这一轮没停下来，再点一次试试。", vars: [], tone: "danger", source: "补充" },
  "lulu_workbench.run.action.round_stopped": { id: "lulu_workbench.run.action.round_stopped", domain: "lulu_workbench", text: "这一轮我停下了，{count} 件还没做完的一起停了。", vars: ["count"], tone: "", source: "补充" },
  "lulu_workbench.run.action.stop": { id: "lulu_workbench.run.action.stop", domain: "lulu_workbench", text: "停止这个子 Agent", vars: [], tone: "", source: "子 Agent 运行面板 v3" },
  "lulu_workbench.run.action.stop_all": { id: "lulu_workbench.run.action.stop_all", domain: "lulu_workbench", text: "停止全部", vars: [], tone: "", source: "子 Agent 运行面板 v3" },
  "lulu_workbench.run.action.stop_round": { id: "lulu_workbench.run.action.stop_round", domain: "lulu_workbench", text: "停下这一轮", vars: [], tone: "", source: "补充" },
  "lulu_workbench.run.check.failed": { id: "lulu_workbench.run.check.failed", domain: "lulu_workbench", text: "没过", vars: [], tone: "", source: "补充" },
  "lulu_workbench.run.check.passed": { id: "lulu_workbench.run.check.passed", domain: "lulu_workbench", text: "过了", vars: [], tone: "", source: "补充" },
  "lulu_workbench.run.check.skipped": { id: "lulu_workbench.run.check.skipped", domain: "lulu_workbench", text: "跳过了", vars: [], tone: "", source: "补充" },
  "lulu_workbench.run.column.agent": { id: "lulu_workbench.run.column.agent", domain: "lulu_workbench", text: "Agent", vars: [], tone: "", source: "子 Agent 运行面板 v3" },
  "lulu_workbench.run.column.elapsed": { id: "lulu_workbench.run.column.elapsed", domain: "lulu_workbench", text: "耗时", vars: [], tone: "", source: "子 Agent 运行面板 v3" },
  "lulu_workbench.run.column.model": { id: "lulu_workbench.run.column.model", domain: "lulu_workbench", text: "模型", vars: [], tone: "", source: "子 Agent 运行面板 v3" },
  "lulu_workbench.run.column.token": { id: "lulu_workbench.run.column.token", domain: "lulu_workbench", text: "Token", vars: [], tone: "", source: "子 Agent 运行面板 v3" },
  "lulu_workbench.run.detail.back": { id: "lulu_workbench.run.detail.back", domain: "lulu_workbench", text: "返回运行", vars: [], tone: "", source: "子 Agent 运行面板 v3" },
  "lulu_workbench.run.detail.evidence": { id: "lulu_workbench.run.detail.evidence", domain: "lulu_workbench", text: "结果、证据和失败都回到父任务，不单独生成一条历史。", vars: [], tone: "", source: "子 Agent 运行面板 v3" },
  "lulu_workbench.run.detail.responsibility": { id: "lulu_workbench.run.detail.responsibility", domain: "lulu_workbench", text: "负责内容", vars: [], tone: "", source: "子 Agent 运行面板 v3" },
  "lulu_workbench.run.details.open": { id: "lulu_workbench.run.details.open", domain: "lulu_workbench", text: "查看详情", vars: [], tone: "", source: "补充" },
  "lulu_workbench.run.details.unresolved": { id: "lulu_workbench.run.details.unresolved", domain: "lulu_workbench", text: "{n} 项没解决", vars: ["n"], tone: "", source: "补充" },
  "lulu_workbench.run.duration.minutes": { id: "lulu_workbench.run.duration.minutes", domain: "lulu_workbench", text: "{n} 分钟", vars: ["n"], tone: "", source: "补充" },
  "lulu_workbench.run.duration.seconds": { id: "lulu_workbench.run.duration.seconds", domain: "lulu_workbench", text: "{n} 秒", vars: ["n"], tone: "", source: "补充" },
  "lulu_workbench.run.empty": { id: "lulu_workbench.run.empty", domain: "lulu_workbench", text: "这轮还没有子 Agent。", vars: [], tone: "", source: "子 Agent 运行面板 v3" },
  "lulu_workbench.run.footer": { id: "lulu_workbench.run.footer", domain: "lulu_workbench", text: "子 Agent 是临时运行单元，不加入团队。结果、证据和失败都回到父任务。", vars: [], tone: "", source: "子 Agent 运行面板 v3" },
  "lulu_workbench.run.heading.finished": { id: "lulu_workbench.run.heading.finished", domain: "lulu_workbench", text: "已结束 {count}", vars: ["count"], tone: "", source: "子 Agent 运行面板 v3" },
  "lulu_workbench.run.meta": { id: "lulu_workbench.run.meta", domain: "lulu_workbench", text: "{phases} 个阶段 · {agents} 个子 Agent", vars: ["agents", "phases"], tone: "", source: "子 Agent 运行面板 v3" },
  "lulu_workbench.run.nothing_to_verify": { id: "lulu_workbench.run.nothing_to_verify", domain: "lulu_workbench", text: "这一轮没有要验的东西", vars: [], tone: "", source: "补充" },
  "lulu_workbench.run.paused": { id: "lulu_workbench.run.paused", domain: "lulu_workbench", text: "暂停中：计划先放着，活也不派", vars: [], tone: "", source: "补充" },
  "lulu_workbench.run.phase.count": { id: "lulu_workbench.run.phase.count", domain: "lulu_workbench", text: "{done}/{total}", vars: ["done", "total"], tone: "", source: "子 Agent 运行面板 v3" },
  "lulu_workbench.run.process.collapsed": { id: "lulu_workbench.run.process.collapsed", domain: "lulu_workbench", text: "查看过程 · {steps} 步 · {duration}", vars: ["duration", "steps"], tone: "", source: "补充" },
  "lulu_workbench.run.process.needs_you": { id: "lulu_workbench.run.process.needs_you", domain: "lulu_workbench", text: "等你一下", vars: [], tone: "", source: "补充" },
  "lulu_workbench.run.process.running": { id: "lulu_workbench.run.process.running", domain: "lulu_workbench", text: "正在做", vars: [], tone: "", source: "补充" },
  "lulu_workbench.run.process.title": { id: "lulu_workbench.run.process.title", domain: "lulu_workbench", text: "工作过程", vars: [], tone: "", source: "补充" },
  "lulu_workbench.run.release.deployed": { id: "lulu_workbench.run.release.deployed", domain: "lulu_workbench", text: "已上线 {sha}", vars: ["sha"], tone: "", source: "补充" },
  "lulu_workbench.run.release.deployed_label": { id: "lulu_workbench.run.release.deployed_label", domain: "lulu_workbench", text: "已上线", vars: [], tone: "", source: "补充" },
  "lulu_workbench.run.release.health": { id: "lulu_workbench.run.release.health", domain: "lulu_workbench", text: "健康检查", vars: [], tone: "", source: "补充" },
  "lulu_workbench.run.release.merged": { id: "lulu_workbench.run.release.merged", domain: "lulu_workbench", text: "已合并 {sha}", vars: ["sha"], tone: "", source: "补充" },
  "lulu_workbench.run.release.merged_label": { id: "lulu_workbench.run.release.merged_label", domain: "lulu_workbench", text: "已合并", vars: [], tone: "", source: "补充" },
  "lulu_workbench.run.release.pending": { id: "lulu_workbench.run.release.pending", domain: "lulu_workbench", text: "上线还没验完", vars: [], tone: "", source: "补充" },
  "lulu_workbench.run.release.production_verified": { id: "lulu_workbench.run.release.production_verified", domain: "lulu_workbench", text: "生产已验证", vars: [], tone: "", source: "需求" },
  "lulu_workbench.run.release.rollback": { id: "lulu_workbench.run.release.rollback", domain: "lulu_workbench", text: "回滚演练", vars: [], tone: "", source: "补充" },
  "lulu_workbench.run.release.rolled_back": { id: "lulu_workbench.run.release.rolled_back", domain: "lulu_workbench", text: "线上又退回去了", vars: [], tone: "", source: "补充" },
  "lulu_workbench.run.release.rolled_back_label": { id: "lulu_workbench.run.release.rolled_back_label", domain: "lulu_workbench", text: "退回到", vars: [], tone: "", source: "补充" },
  "lulu_workbench.run.release.smoke": { id: "lulu_workbench.run.release.smoke", domain: "lulu_workbench", text: "业务冒烟", vars: [], tone: "", source: "补充" },
  "lulu_workbench.run.section.artifacts": { id: "lulu_workbench.run.section.artifacts", domain: "lulu_workbench", text: "关键结果", vars: [], tone: "", source: "补充" },
  "lulu_workbench.run.section.changes": { id: "lulu_workbench.run.section.changes", domain: "lulu_workbench", text: "改了哪些文件", vars: [], tone: "", source: "补充" },
  "lulu_workbench.run.section.checks": { id: "lulu_workbench.run.section.checks", domain: "lulu_workbench", text: "验证", vars: [], tone: "", source: "补充" },
  "lulu_workbench.run.section.did": { id: "lulu_workbench.run.section.did", domain: "lulu_workbench", text: "完成了什么", vars: [], tone: "", source: "补充" },
  "lulu_workbench.run.section.next": { id: "lulu_workbench.run.section.next", domain: "lulu_workbench", text: "接下来", vars: [], tone: "", source: "补充" },
  "lulu_workbench.run.section.release": { id: "lulu_workbench.run.section.release", domain: "lulu_workbench", text: "发布", vars: [], tone: "", source: "补充" },
  "lulu_workbench.run.section.risks": { id: "lulu_workbench.run.section.risks", domain: "lulu_workbench", text: "还有这些没解决", vars: [], tone: "", source: "补充" },
  "lulu_workbench.run.sha.copied": { id: "lulu_workbench.run.sha.copied", domain: "lulu_workbench", text: "复制好了", vars: [], tone: "", source: "补充" },
  "lulu_workbench.run.sha.copy": { id: "lulu_workbench.run.sha.copy", domain: "lulu_workbench", text: "复制", vars: [], tone: "", source: "补充" },
  "lulu_workbench.run.status.cancelled": { id: "lulu_workbench.run.status.cancelled", domain: "lulu_workbench", text: "已取消", vars: [], tone: "", source: "补充" },
  "lulu_workbench.run.status.completed": { id: "lulu_workbench.run.status.completed", domain: "lulu_workbench", text: "已完成", vars: [], tone: "", source: "补充" },
  "lulu_workbench.run.status.failed": { id: "lulu_workbench.run.status.failed", domain: "lulu_workbench", text: "未完成", vars: [], tone: "", source: "补充" },
  "lulu_workbench.run.status.partial": { id: "lulu_workbench.run.status.partial", domain: "lulu_workbench", text: "部分完成", vars: [], tone: "", source: "补充" },
  "lulu_workbench.run.step.agent_completed": { id: "lulu_workbench.run.step.agent_completed", domain: "lulu_workbench", text: "Agent 已完成", vars: [], tone: "", source: "补充" },
  "lulu_workbench.run.step.agent_joined": { id: "lulu_workbench.run.step.agent_joined", domain: "lulu_workbench", text: "Agent 已接手", vars: [], tone: "", source: "补充" },
  "lulu_workbench.run.step.agent_progress": { id: "lulu_workbench.run.step.agent_progress", domain: "lulu_workbench", text: "Agent 已保存进度", vars: [], tone: "", source: "补充" },
  "lulu_workbench.run.step.agent_recovered": { id: "lulu_workbench.run.step.agent_recovered", domain: "lulu_workbench", text: "Agent 已恢复", vars: [], tone: "", source: "补充" },
  "lulu_workbench.run.step.agent_stopped": { id: "lulu_workbench.run.step.agent_stopped", domain: "lulu_workbench", text: "Agent 已停止", vars: [], tone: "", source: "补充" },
  "lulu_workbench.run.step.item_cancelled": { id: "lulu_workbench.run.step.item_cancelled", domain: "lulu_workbench", text: "工作项已取消", vars: [], tone: "", source: "补充" },
  "lulu_workbench.run.step.item_completed": { id: "lulu_workbench.run.step.item_completed", domain: "lulu_workbench", text: "工作项已完成", vars: [], tone: "", source: "补充" },
  "lulu_workbench.run.step.item_failed": { id: "lulu_workbench.run.step.item_failed", domain: "lulu_workbench", text: "工作项未完成", vars: [], tone: "", source: "补充" },
  "lulu_workbench.run.step.item_ready": { id: "lulu_workbench.run.step.item_ready", domain: "lulu_workbench", text: "工作项已准备", vars: [], tone: "", source: "补充" },
  "lulu_workbench.run.step.item_recovering": { id: "lulu_workbench.run.step.item_recovering", domain: "lulu_workbench", text: "正在恢复工作项", vars: [], tone: "", source: "补充" },
  "lulu_workbench.run.step.item_running": { id: "lulu_workbench.run.step.item_running", domain: "lulu_workbench", text: "正在执行工作项", vars: [], tone: "", source: "补充" },
  "lulu_workbench.run.step.item_waiting": { id: "lulu_workbench.run.step.item_waiting", domain: "lulu_workbench", text: "工作项正在等待", vars: [], tone: "", source: "补充" },
  "lulu_workbench.run.step.plan_ready": { id: "lulu_workbench.run.step.plan_ready", domain: "lulu_workbench", text: "工作计划已准备", vars: [], tone: "", source: "补充" },
  "lulu_workbench.run.step.result_available": { id: "lulu_workbench.run.step.result_available", domain: "lulu_workbench", text: "结果已整理好", vars: [], tone: "", source: "补充" },
  "lulu_workbench.run.step.waiting": { id: "lulu_workbench.run.step.waiting", domain: "lulu_workbench", text: "在等外面", vars: [], tone: "", source: "补充" },
  "lulu_workbench.run.stream.unknown": { id: "lulu_workbench.run.stream.unknown", domain: "lulu_workbench", text: "连不上，这会儿说不准它到哪一步了", vars: [], tone: "", source: "补充" },
  "lulu_workbench.run.summary.default_title": { id: "lulu_workbench.run.summary.default_title", domain: "lulu_workbench", text: "这轮并行工作", vars: [], tone: "", source: "子 Agent 运行面板 v3" },
  "lulu_workbench.run.summary.meta": { id: "lulu_workbench.run.summary.meta", domain: "lulu_workbench", text: "{phases} 个阶段 · {agents} 个子 Agent · 完成 {done}/{agents}", vars: ["agents", "done", "phases"], tone: "", source: "子 Agent 运行面板 v3" },
  "lulu_workbench.run.summary.open": { id: "lulu_workbench.run.summary.open", domain: "lulu_workbench", text: "查看运行", vars: [], tone: "", source: "子 Agent 运行面板 v3" },
  "lulu_workbench.run.unverified": { id: "lulu_workbench.run.unverified", domain: "lulu_workbench", text: "未验证", vars: [], tone: "", source: "补充" },
  "lulu_workbench.settle.artifact.branch": { id: "lulu_workbench.settle.artifact.branch", domain: "lulu_workbench", text: "写好的那个分支", vars: [], tone: "", source: "补充" },
  "lulu_workbench.settle.artifact.commit": { id: "lulu_workbench.settle.artifact.commit", domain: "lulu_workbench", text: "最后一次提交", vars: [], tone: "", source: "补充" },
  "lulu_workbench.settle.artifact.task": { id: "lulu_workbench.settle.artifact.task", domain: "lulu_workbench", text: "这条开发任务", vars: [], tone: "", source: "补充" },
  "lulu_workbench.settle.headline.cancelled": { id: "lulu_workbench.settle.headline.cancelled", domain: "lulu_workbench", text: "这批活取消了。", vars: [], tone: "", source: "补充" },
  "lulu_workbench.settle.headline.completed": { id: "lulu_workbench.settle.headline.completed", domain: "lulu_workbench", text: "这批活做完了，一共 {total} 步。", vars: ["total"], tone: "", source: "补充" },
  "lulu_workbench.settle.headline.failed": { id: "lulu_workbench.settle.headline.failed", domain: "lulu_workbench", text: "这批活没做成。", vars: [], tone: "", source: "补充" },
  "lulu_workbench.settle.headline.partial": { id: "lulu_workbench.settle.headline.partial", domain: "lulu_workbench", text: "{total} 步里做成了 {done} 步，剩下的没成。", vars: ["done", "total"], tone: "", source: "补充" },
  "lulu_workbench.sidecar.add_agent": { id: "lulu_workbench.sidecar.add_agent", domain: "lulu_workbench", text: "添加 Agent", vars: [], tone: "", source: "设计稿 · Sidecar 标题行" },
  "lulu_workbench.sidecar.back_to_chat": { id: "lulu_workbench.sidecar.back_to_chat", domain: "lulu_workbench", text: "回到对话", vars: [], tone: "", source: "设计稿 · M04 工作板 sheet" },
  "lulu_workbench.sidecar.close": { id: "lulu_workbench.sidecar.close", domain: "lulu_workbench", text: "关掉", vars: [], tone: "", source: "设计稿 · W08b" },
  "lulu_workbench.sidecar.keep_state": { id: "lulu_workbench.sidecar.keep_state", domain: "lulu_workbench", text: "关掉这条轨道，聊天的滚动位置、草稿和焦点都不变。", vars: [], tone: "neutral", source: "设计稿 · W08b" },
  "lulu_workbench.sidecar.tab_board": { id: "lulu_workbench.sidecar.tab_board", domain: "lulu_workbench", text: "工作板", vars: [], tone: "", source: "设计稿 · Sidecar" },
  "lulu_workbench.sidecar.tab_decisions": { id: "lulu_workbench.sidecar.tab_decisions", domain: "lulu_workbench", text: "要你决定", vars: [], tone: "", source: "设计稿 · Sidecar" },
  "lulu_workbench.sidecar.tab_evidence": { id: "lulu_workbench.sidecar.tab_evidence", domain: "lulu_workbench", text: "证据", vars: [], tone: "", source: "设计稿 · Sidecar" },
  "lulu_workbench.sidecar.tab_team": { id: "lulu_workbench.sidecar.tab_team", domain: "lulu_workbench", text: "当前团队", vars: [], tone: "", source: "设计稿 · Sidecar" },
  "lulu_workbench.sidecar.title_work": { id: "lulu_workbench.sidecar.title_work", domain: "lulu_workbench", text: "这条会话的工作", vars: [], tone: "", source: "设计稿 · W08 工作板" },
  "lulu_workbench.sidecar.width_hint": { id: "lulu_workbench.sidecar.width_hint", domain: "lulu_workbench", text: "拖动改宽度 · 380–520px", vars: [], tone: "", source: "设计稿 · Sidecar 拖拽把手" },
  "lulu_workbench.skills.ago_days": { id: "lulu_workbench.skills.ago_days", domain: "lulu_workbench", text: "{n} 天前", vars: ["n"], tone: "", source: "补充" },
  "lulu_workbench.skills.ago_hours": { id: "lulu_workbench.skills.ago_hours", domain: "lulu_workbench", text: "{n} 小时前", vars: ["n"], tone: "", source: "补充" },
  "lulu_workbench.skills.ago_minutes": { id: "lulu_workbench.skills.ago_minutes", domain: "lulu_workbench", text: "{n} 分钟前", vars: ["n"], tone: "", source: "补充" },
  "lulu_workbench.skills.ago_now": { id: "lulu_workbench.skills.ago_now", domain: "lulu_workbench", text: "刚刚", vars: [], tone: "", source: "补充" },
  "lulu_workbench.skills.disabled": { id: "lulu_workbench.skills.disabled", domain: "lulu_workbench", text: "关着", vars: [], tone: "", source: "补充" },
  "lulu_workbench.skills.empty": { id: "lulu_workbench.skills.empty", domain: "lulu_workbench", text: "还没有技能。", vars: [], tone: "", source: "补充" },
  "lulu_workbench.skills.enabled": { id: "lulu_workbench.skills.enabled", domain: "lulu_workbench", text: "开着", vars: [], tone: "", source: "补充" },
  "lulu_workbench.skills.last_run": { id: "lulu_workbench.skills.last_run", domain: "lulu_workbench", text: "上次 {when} · {state}", vars: ["state", "when"], tone: "", source: "补充" },
  "lulu_workbench.skills.last_run_failed": { id: "lulu_workbench.skills.last_run_failed", domain: "lulu_workbench", text: "没做成", vars: [], tone: "", source: "补充" },
  "lulu_workbench.skills.last_run_ok": { id: "lulu_workbench.skills.last_run_ok", domain: "lulu_workbench", text: "做完了", vars: [], tone: "", source: "补充" },
  "lulu_workbench.skills.never_ran": { id: "lulu_workbench.skills.never_ran", domain: "lulu_workbench", text: "还没跑过", vars: [], tone: "", source: "补充" },
  "lulu_workbench.skills.section": { id: "lulu_workbench.skills.section", domain: "lulu_workbench", text: "Lulu 的技能", vars: [], tone: "", source: "补充" },
  "lulu_workbench.skills.section_hint": { id: "lulu_workbench.skills.section_hint", domain: "lulu_workbench", text: "这些是 Lulu 会自己做的事。关掉一个，它就不再做，也不会提。", vars: [], tone: "", source: "补充" },
  "lulu_workbench.skills.toggle_failed": { id: "lulu_workbench.skills.toggle_failed", domain: "lulu_workbench", text: "这一下没拧成，再试一次。", vars: [], tone: "", source: "补充" },
  "lulu_workbench.skills.trigger_daily": { id: "lulu_workbench.skills.trigger_daily", domain: "lulu_workbench", text: "每天 {at}", vars: ["at"], tone: "", source: "补充" },
  "lulu_workbench.skills.trigger_say": { id: "lulu_workbench.skills.trigger_say", domain: "lulu_workbench", text: "或者跟它说「{phrase}」", vars: ["phrase"], tone: "", source: "补充" },
  "lulu_workbench.slash.effort": { id: "lulu_workbench.slash.effort", domain: "lulu_workbench", text: "想多深 · {tier}", vars: ["tier"], tone: "", source: "补充" },
  "lulu_workbench.slash.effort_hint": { id: "lulu_workbench.slash.effort_hint", domain: "lulu_workbench", text: "只管下一条消息，发完复位", vars: [], tone: "", source: "补充" },
  "lulu_workbench.slash.empty": { id: "lulu_workbench.slash.empty", domain: "lulu_workbench", text: "没有对得上的。换个词，或者把「/」删掉直接说。", vars: [], tone: "", source: "补充" },
  "lulu_workbench.slash.keys": { id: "lulu_workbench.slash.keys", domain: "lulu_workbench", text: "↑↓ 挑一条 · Enter 用它 · Esc 收起", vars: [], tone: "", source: "补充" },
  "lulu_workbench.slash.new": { id: "lulu_workbench.slash.new", domain: "lulu_workbench", text: "新开一条话头", vars: [], tone: "", source: "补充" },
  "lulu_workbench.slash.new_hint": { id: "lulu_workbench.slash.new_hint", domain: "lulu_workbench", text: "挑项目、单 Agent 还是团队，从头来", vars: [], tone: "", source: "补充" },
  "lulu_workbench.slash.plan_only_hint": { id: "lulu_workbench.slash.plan_only_hint", domain: "lulu_workbench", text: "这一条只出「开始做」那张卡，你点了我才动手", vars: [], tone: "", source: "补充" },
  "lulu_workbench.slash.plan_only_off": { id: "lulu_workbench.slash.plan_only_off", domain: "lulu_workbench", text: "改回来：出了计划就开工", vars: [], tone: "", source: "补充" },
  "lulu_workbench.slash.plan_only_on": { id: "lulu_workbench.slash.plan_only_on", domain: "lulu_workbench", text: "只出计划，别开工", vars: [], tone: "", source: "补充" },
  "lulu_workbench.slash.rename": { id: "lulu_workbench.slash.rename", domain: "lulu_workbench", text: "改名", vars: [], tone: "", source: "补充" },
  "lulu_workbench.slash.rename_failed": { id: "lulu_workbench.slash.rename_failed", domain: "lulu_workbench", text: "没改成，名字还是原来的", vars: [], tone: "", source: "补充" },
  "lulu_workbench.slash.rename_hint": { id: "lulu_workbench.slash.rename_hint", domain: "lulu_workbench", text: "把这条话头改成「{title}」", vars: ["title"], tone: "", source: "补充" },
  "lulu_workbench.slash.rename_hint_empty": { id: "lulu_workbench.slash.rename_hint_empty", domain: "lulu_workbench", text: "在「/改名」后面接上新名字", vars: [], tone: "", source: "补充" },
  "lulu_workbench.slash.skill_hint": { id: "lulu_workbench.slash.skill_hint", domain: "lulu_workbench", text: "直接说「{utterance}」也行", vars: ["utterance"], tone: "", source: "补充" },
  "lulu_workbench.slash.stop_hint": { id: "lulu_workbench.slash.stop_hint", domain: "lulu_workbench", text: "叫停正在跑的这一轮", vars: [], tone: "", source: "补充" },
  "lulu_workbench.slash.title": { id: "lulu_workbench.slash.title", domain: "lulu_workbench", text: "打「/」能做的事", vars: [], tone: "", source: "补充" },
  "lulu_workbench.state.blocked": { id: "lulu_workbench.state.blocked", domain: "lulu_workbench", text: "已确认阻塞原因，Lulu 正在处理", vars: [], tone: "warn", source: "设计稿 · 12 态合同" },
  "lulu_workbench.state.completed": { id: "lulu_workbench.state.completed", domain: "lulu_workbench", text: "已完成并验证", vars: [], tone: "ok", source: "设计稿 · 12 态合同" },
  "lulu_workbench.state.disconnected": { id: "lulu_workbench.state.disconnected", domain: "lulu_workbench", text: "暂时收不到最新状态，现场已保留", vars: [], tone: "warn", source: "设计稿 · 12 态合同" },
  "lulu_workbench.state.discussing": { id: "lulu_workbench.state.discussing", domain: "lulu_workbench", text: "正在讨论方案", vars: [], tone: "neutral", source: "设计稿 · 12 态合同" },
  "lulu_workbench.state.failed": { id: "lulu_workbench.state.failed", domain: "lulu_workbench", text: "这一步没有完成，原有结果未受影响", vars: [], tone: "danger", source: "设计稿 · 12 态合同" },
  "lulu_workbench.state.planning": { id: "lulu_workbench.state.planning", domain: "lulu_workbench", text: "Lulu 正在整理目标和验收结果", vars: [], tone: "neutral", source: "设计稿 · 12 态合同" },
  "lulu_workbench.state.platform_held": { id: "lulu_workbench.state.platform_held", domain: "lulu_workbench", text: "平台故障，等待自动恢复", vars: [], tone: "warn", source: "设计稿 · 12 态合同" },
  "lulu_workbench.state.recovering": { id: "lulu_workbench.state.recovering", domain: "lulu_workbench", text: "正在从上次 checkpoint 恢复", vars: [], tone: "neutral", source: "设计稿 · 12 态合同" },
  "lulu_workbench.state.running": { id: "lulu_workbench.state.running", domain: "lulu_workbench", text: "团队已开始执行", vars: [], tone: "neutral", source: "设计稿 · 12 态合同" },
  "lulu_workbench.state.unknown": { id: "lulu_workbench.state.unknown", domain: "lulu_workbench", text: "当前状态尚未确认", vars: [], tone: "neutral", source: "设计稿 · 12 态合同" },
  "lulu_workbench.state.waiting_agent": { id: "lulu_workbench.state.waiting_agent", domain: "lulu_workbench", text: "正在等待依赖 Agent", vars: [], tone: "warn", source: "设计稿 · 12 态合同" },
  "lulu_workbench.state.waiting_user": { id: "lulu_workbench.state.waiting_user", domain: "lulu_workbench", text: "有事需要你决定", vars: [], tone: "warn", source: "设计稿 · 12 态合同" },
  "lulu_workbench.sub.auto_named": { id: "lulu_workbench.sub.auto_named", domain: "lulu_workbench", text: "自动命名", vars: [], tone: "", source: "设计稿 · W09b Agent 库" },
  "lulu_workbench.sub.boundary": { id: "lulu_workbench.sub.boundary", domain: "lulu_workbench", text: "临时子 Agent 不会加入团队，任务结束后自动关闭。", vars: [], tone: "neutral", source: "设计稿 · SPEC-components 文案黑白名单" },
  "lulu_workbench.sub.elapsed": { id: "lulu_workbench.sub.elapsed", domain: "lulu_workbench", text: "已经 {duration}", vars: ["duration"], tone: "", source: "设计稿 · S01" },
  "lulu_workbench.sub.evidence_on_parent": { id: "lulu_workbench.sub.evidence_on_parent", domain: "lulu_workbench", text: "证据挂在主任务上，不单独成一条历史 —— 它是任务的一部分，不是一个人。", vars: [], tone: "neutral", source: "设计稿 · S03" },
  "lulu_workbench.sub.no_progress_bar": { id: "lulu_workbench.sub.no_progress_bar", domain: "lulu_workbench", text: "不显示进度条 —— 我没有它的进度，画一个就是编的。", vars: [], tone: "warn", source: "设计稿 · S06 子 Agent 失联" },
  "lulu_workbench.sub.not_member": { id: "lulu_workbench.sub.not_member", domain: "lulu_workbench", text: "子 Agent 不是团队成员。", vars: [], tone: "neutral", source: "设计稿 · S02 工作板底部" },
  "lulu_workbench.sub.parent": { id: "lulu_workbench.sub.parent", domain: "lulu_workbench", text: "父 Agent", vars: [], tone: "", source: "设计稿 · S03 子 Agent 详情" },
  "lulu_workbench.sub.stop_isolated": { id: "lulu_workbench.sub.stop_isolated", domain: "lulu_workbench", text: "停掉它不影响 {parent} 和另外那几个子 Agent。", vars: ["parent"], tone: "neutral", source: "设计稿 · S03" },
  "lulu_workbench.sub.team_unchanged": { id: "lulu_workbench.sub.team_unchanged", domain: "lulu_workbench", text: "团队成员数：{count} 位（没变）—— 子 Agent 不算成员", vars: ["count"], tone: "ok", source: "设计稿 · S01" },
  "lulu_workbench.subfail.costs_money": { id: "lulu_workbench.subfail.costs_money", domain: "lulu_workbench", text: "这一条要花钱，所以我不替你决定", vars: [], tone: "", source: "设计稿 · S04 花钱那条走 waiting_user" },
  "lulu_workbench.subfail.exit_retry": { id: "lulu_workbench.subfail.exit_retry", domain: "lulu_workbench", text: "换一台构建机重跑", vars: [], tone: "", source: "设计稿 · S04 三条出路之一" },
  "lulu_workbench.subfail.exit_swap_model": { id: "lulu_workbench.subfail.exit_swap_model", domain: "lulu_workbench", text: "换个模型再试", vars: [], tone: "", source: "设计稿 · S04 三条出路之二" },
  "lulu_workbench.subfail.exit_takeover": { id: "lulu_workbench.subfail.exit_takeover", domain: "lulu_workbench", text: "我自己接手跑完剩下的", vars: [], tone: "", source: "设计稿 · S04 三条出路之三" },
  "lulu_workbench.subfail.failed": { id: "lulu_workbench.subfail.failed", domain: "lulu_workbench", text: "这一条没成 —— 你还能挑别的两条", vars: [], tone: "", source: "设计稿 · S04 失败不假成功" },
  "lulu_workbench.subfail.headline": { id: "lulu_workbench.subfail.headline", domain: "lulu_workbench", text: "{done} 个做完了，{failed} 个没成", vars: ["done", "failed"], tone: "", source: "设计稿 · S04" },
  "lulu_workbench.subfail.keep_done": { id: "lulu_workbench.subfail.keep_done", domain: "lulu_workbench", text: "完成的两个结果都保留，不用重跑", vars: [], tone: "", source: "设计稿 · S04" },
  "lulu_workbench.subfail.my_pick": { id: "lulu_workbench.subfail.my_pick", domain: "lulu_workbench", text: "我倾向第三条，但等你点", vars: [], tone: "", source: "设计稿 · S04 Lulu 说倾向但不代决" },
  "lulu_workbench.subfail.no_reason_yet": { id: "lulu_workbench.subfail.no_reason_yet", domain: "lulu_workbench", text: "还说不清是哪一步出的问题", vars: [], tone: "", source: "设计稿 · S04（原句需要 failure_class，后端还没有）" },
  "lulu_workbench.subfail.no_reopen": { id: "lulu_workbench.subfail.no_reopen", domain: "lulu_workbench", text: "失败的那个不重开 —— 再开一个也是同一台构建机", vars: [], tone: "", source: "设计稿 · S04" },
  "lulu_workbench.team.account_only": { id: "lulu_workbench.team.account_only", domain: "lulu_workbench", text: "这条会话没绑项目，所以只列账户级 Agent。绑定项目后，那个项目的 Agent 才会出现。", vars: [], tone: "neutral", source: "设计稿 · Z06 空团队" },
  "lulu_workbench.team.candidate_count": { id: "lulu_workbench.team.candidate_count", domain: "lulu_workbench", text: "还没进来的 · {count} 位", vars: ["count"], tone: "", source: "设计稿 · teamEmpty" },
  "lulu_workbench.team.empty_ok": { id: "lulu_workbench.team.empty_ok", domain: "lulu_workbench", text: "空团队不是错误。Lulu 能聊天、能讨论、能出方案；要动代码就得先有 Agent。", vars: [], tone: "neutral", source: "设计稿 · Z06 空团队" },
  "lulu_workbench.team.join": { id: "lulu_workbench.team.join", domain: "lulu_workbench", text: "加入团队", vars: [], tone: "", source: "设计稿 · teamEmpty / agentJoin" },
  "lulu_workbench.team.join_failed": { id: "lulu_workbench.team.join_failed", domain: "lulu_workbench", text: "没加进去 —— 再点一下就行", vars: [], tone: "warn", source: "设计稿 · 失败不丢用户动作" },
  "lulu_workbench.team.joining": { id: "lulu_workbench.team.joining", domain: "lulu_workbench", text: "正在加", vars: [], tone: "", source: "设计稿 · 进行中态" },
  "lulu_workbench.team.member_disabled": { id: "lulu_workbench.team.member_disabled", domain: "lulu_workbench", text: "已停用 · 当时在队里", vars: [], tone: "", source: "补充 · 内核交接 §2.2「disabled 的成员照常显示并标出来」" },
  "lulu_workbench.team.mention_scope": { id: "lulu_workbench.team.mention_scope", domain: "lulu_workbench", text: "@ 只能点名这 {count} 位，不会加人。", vars: ["count"], tone: "neutral", source: "设计稿 · Z07 Sidecar 底部" },
  "lulu_workbench.team.only_agents": { id: "lulu_workbench.team.only_agents", domain: "lulu_workbench", text: "库里只有 Agent，没有裸模型。想用一个新模型，先去设置里连上，然后回来新建一个 Agent。", vars: [], tone: "neutral", source: "设计稿 · W09b" },
  "lulu_workbench.team.remove_no_interrupt": { id: "lulu_workbench.team.remove_no_interrupt", domain: "lulu_workbench", text: "移出正在干活的 Agent 不会立刻打断它 —— 先让它跑完当前这一步并交接，然后移出。", vars: [], tone: "neutral", source: "设计稿 · Z07" },
  "lulu_workbench.team.try_one": { id: "lulu_workbench.team.try_one", domain: "lulu_workbench", text: "先加一位试试", vars: [], tone: "", source: "设计稿 · teamEmpty" },
  "lulu_workbench.teambar.adjust": { id: "lulu_workbench.teambar.adjust", domain: "lulu_workbench", text: "调整", vars: [], tone: "", source: "设计稿 · TeamBar 团队形态" },
  "lulu_workbench.teambar.solo": { id: "lulu_workbench.teambar.solo", domain: "lulu_workbench", text: "单 Agent：{agent} · 换一个", vars: ["agent"], tone: "", source: "设计稿 · TeamBar 单 Agent 形态" },
  "lulu_workbench.teambar.team": { id: "lulu_workbench.teambar.team", domain: "lulu_workbench", text: "团队：{mode} · {count} 位", vars: ["count", "mode"], tone: "", source: "设计稿 · TeamBar 团队形态" },
  "lulu_workbench.title.bound": { id: "lulu_workbench.title.bound", domain: "lulu_workbench", text: "项目会话 · 已绑定，不可更换", vars: [], tone: "", source: "设计稿 · Z05 绑定完成" },
  "lulu_workbench.title.general": { id: "lulu_workbench.title.general", domain: "lulu_workbench", text: "通用对话", vars: [], tone: "", source: "设计稿 · Z03 通用会话" },
  "lulu_workbench.title.no_project": { id: "lulu_workbench.title.no_project", domain: "lulu_workbench", text: "未关联项目", vars: [], tone: "warn", source: "设计稿 · Z03 通用会话" },
  "lulu_workbench.title.offline": { id: "lulu_workbench.title.offline", domain: "lulu_workbench", text: "收不到最新状态", vars: [], tone: "warn", source: "设计稿 · M07 断线" },
  "lulu_workbench.title.solo": { id: "lulu_workbench.title.solo", domain: "lulu_workbench", text: "单 Agent · {agent}", vars: ["agent"], tone: "", source: "设计稿 · Z09 单 Agent 会话" },
  "lulu_workbench.voice.cancel": { id: "lulu_workbench.voice.cancel", domain: "lulu_workbench", text: "取消这段录音", vars: [], tone: "", source: "2026-08-30 · Lulu 输入框语音接线" },
  "lulu_workbench.voice.no_mic": { id: "lulu_workbench.voice.no_mic", domain: "lulu_workbench", text: "没拿到话筒权限，点这里再试", vars: [], tone: "", source: "2026-08-30 · Lulu 输入框语音接线" },
  "lulu_workbench.voice.retry": { id: "lulu_workbench.voice.retry", domain: "lulu_workbench", text: "没转出来，再试一次", vars: [], tone: "", source: "2026-08-30 · Lulu 输入框语音接线" },
  "lulu_workbench.voice.start": { id: "lulu_workbench.voice.start", domain: "lulu_workbench", text: "语音输入", vars: [], tone: "", source: "2026-08-30 · Lulu 输入框语音接线" },
  "lulu_workbench.voice.stop": { id: "lulu_workbench.voice.stop", domain: "lulu_workbench", text: "录好了，转成文字", vars: [], tone: "", source: "2026-08-30 · Lulu 输入框语音接线" },
  "lulu_workbench.voice.transcribing": { id: "lulu_workbench.voice.transcribing", domain: "lulu_workbench", text: "正在转成文字", vars: [], tone: "", source: "2026-08-30 · Lulu 输入框语音接线" },
  "lulu_workbench.voice.unsupported": { id: "lulu_workbench.voice.unsupported", domain: "lulu_workbench", text: "这台浏览器不能录音", vars: [], tone: "", source: "2026-08-30 · Lulu 输入框语音接线" },
  "memo.access.all": { id: "memo.access.all", domain: "memo", text: "全部", vars: [], tone: "", source: "补充" },
  "memo.access.audit": { id: "memo.access.audit", domain: "memo", text: "把一条备忘从「不给 AI 看」改成「让 AI 也读」，是一次授权变更，会单独记一条审计。", vars: [], tone: "", source: "补充" },
  "memo.access.default": { id: "memo.access.default", domain: "memo", text: "尚未允许 AI 读取", vars: [], tone: "", source: "设计稿 · AI 状态" },
  "memo.access.filter.empty": { id: "memo.access.filter.empty", domain: "memo", text: "这一档还没有条目", vars: [], tone: "", source: "补充" },
  "memo.access.hidden": { id: "memo.access.hidden", domain: "memo", text: "禁止 AI 读取", vars: [], tone: "", source: "设计稿 · AI 状态" },
  "memo.access.label": { id: "memo.access.label", domain: "memo", text: "按 AI 能不能读筛", vars: [], tone: "", source: "补充" },
  "memo.ai.change": { id: "memo.ai.change", domain: "memo", text: "改 AI 权限", vars: [], tone: "", source: "设计稿 S09" },
  "memo.ai.default": { id: "memo.ai.default", domain: "memo", text: "尚未允许 AI 读取", vars: [], tone: "", source: "设计稿 · AI 状态" },
  "memo.ai.default.desc": { id: "memo.ai.default.desc", domain: "memo", text: "不进入 AI 上下文。可以一直放着。", vars: [], tone: "", source: "设计稿 · AiAccessControl" },
  "memo.ai.hidden": { id: "memo.ai.hidden", domain: "memo", text: "禁止 AI 读取", vars: [], tone: "", source: "设计稿 · AI 状态" },
  "memo.ai.hidden.desc": { id: "memo.ai.hidden.desc", domain: "memo", text: "不进上下文，也不留档。Agent 请求时会显示「这条被你锁了」。", vars: [], tone: "", source: "设计稿 · AiAccessControl" },
  "memo.ai.panel.locked": { id: "memo.ai.panel.locked", domain: "memo", text: "禁止 AI 读", vars: [], tone: "", source: "设计稿 S06" },
  "memo.ai.panel.readable": { id: "memo.ai.panel.readable", domain: "memo", text: "AI 可读", vars: [], tone: "", source: "设计稿 S06" },
  "memo.ai.panel.undecided": { id: "memo.ai.panel.undecided", domain: "memo", text: "尚未决定", vars: [], tone: "", source: "设计稿 S06" },
  "memo.ai.shared": { id: "memo.ai.shared", domain: "memo", text: "AI 可读", vars: [], tone: "", source: "设计稿 · AI 状态" },
  "memo.ai.shared.scope.global": { id: "memo.ai.shared.scope.global", domain: "memo", text: "AI 可读 —— 只有全局 Lulu", vars: [], tone: "", source: "SPEC-scope-ai §2.2" },
  "memo.ai.shared.scope.global.desc": { id: "memo.ai.shared.scope.global.desc", domain: "memo", text: "只有全局 Lulu 能看到这条。任何项目的 Agent 都读不到。", vars: [], tone: "", source: "SPEC-scope-ai §2.2" },
  "memo.ai.shared.scope.project": { id: "memo.ai.shared.scope.project", domain: "memo", text: "AI 可读 —— 这个项目的 Claude 和 Grok", vars: [], tone: "", source: "SPEC-scope-ai §2.2" },
  "memo.ai.shared.scope.project.desc": { id: "memo.ai.shared.scope.project.desc", domain: "memo", text: "干活时会参考这条。别的项目读不到。", vars: [], tone: "", source: "设计稿 · AiAccessControl" },
  "memo.ai.toggle.hide": { id: "memo.ai.toggle.hide", domain: "memo", text: "不让 AI 读这条", vars: [], tone: "", source: "用户需求 2026-09-01（行级眼睛开关）" },
  "memo.ai.toggle.show": { id: "memo.ai.toggle.show", domain: "memo", text: "让 AI 读这条", vars: [], tone: "", source: "用户需求 2026-09-01（行级眼睛开关）" },
  "memo.archive.archived.at": { id: "memo.archive.archived.at", domain: "memo", text: "{date}归档", vars: ["date"], tone: "", source: "设计稿 S18" },
  "memo.archive.delete.note": { id: "memo.archive.delete.note", domain: "memo", text: "想彻底删掉", vars: [], tone: "", source: "设计稿 S18" },
  "memo.archive.delete.note.body": { id: "memo.archive.delete.note.body", domain: "memo", text: "归档能一键撤销，删除不能——所以它们不放在一起。", vars: [], tone: "", source: "设计稿 S18" },
  "memo.archive.empty": { id: "memo.archive.empty", domain: "memo", text: "还没有归档过东西。归档的条目会从主列表消失，但都留在这儿，随时拿得回来。", vars: [], tone: "", source: "补充" },
  "memo.archive.empty.title": { id: "memo.archive.empty.title", domain: "memo", text: "这里还是空的", vars: [], tone: "", source: "补充" },
  "memo.archive.entry": { id: "memo.archive.entry", domain: "memo", text: "归档区", vars: [], tone: "", source: "设计稿 S01" },
  "memo.archive.notice": { id: "memo.archive.notice", domain: "memo", text: "归档了的东西还在", vars: [], tone: "", source: "设计稿 S18" },
  "memo.archive.notice.body": { id: "memo.archive.notice.body", domain: "memo", text: "归档只是让它从主列表里消失，好让最近的东西更清楚。内容、语音、附件都还在，AI 权限也保持原样——AI 可读的归档条目，AI 还是能读。", vars: [], tone: "", source: "设计稿 S18" },
  "memo.archive.restore": { id: "memo.archive.restore", domain: "memo", text: "拿回来", vars: [], tone: "", source: "设计稿 S18" },
  "memo.archive.subtitle": { id: "memo.archive.subtitle", domain: "memo", text: "归档不是删除。这里的东西还在，搜也搜得到，随时能拿回来。", vars: [], tone: "", source: "设计稿 S18" },
  "memo.archive.title": { id: "memo.archive.title", domain: "memo", text: "归档区", vars: [], tone: "", source: "设计稿 S18" },
  "memo.candidates.badge": { id: "memo.candidates.badge", domain: "memo", text: "候选 · 还没保存", vars: [], tone: "", source: "设计稿 S20" },
  "memo.candidates.confirm": { id: "memo.candidates.confirm", domain: "memo", text: "保存", vars: [], tone: "", source: "设计稿 S20" },
  "memo.candidates.confirmed": { id: "memo.candidates.confirmed", domain: "memo", text: "存好了 —— 已经是一条能点开的备忘录", vars: [], tone: "", source: "设计稿 S20" },
  "memo.candidates.desc": { id: "memo.candidates.desc", domain: "memo", text: "这还只是个候选 —— 你不点保存，它不存在。", vars: [], tone: "", source: "设计稿 S20" },
  "memo.candidates.discard": { id: "memo.candidates.discard", domain: "memo", text: "不用这条建议", vars: [], tone: "", source: "设计稿 S20" },
  "memo.candidates.discarded": { id: "memo.candidates.discarded", domain: "memo", text: "已丢弃。这条建议不会再出现。", vars: [], tone: "", source: "设计稿 S20" },
  "memo.candidates.empty": { id: "memo.candidates.empty", domain: "memo", text: "还没有待决定的建议。Lulu 觉得哪句话值得记下来时会放在这儿，由你决定存不存。", vars: [], tone: "", source: "设计稿 S20" },
  "memo.candidates.heading": { id: "memo.candidates.heading", domain: "memo", text: "Lulu 建议记录", vars: [], tone: "", source: "设计稿 S20" },
  "memo.candidates.only_me": { id: "memo.candidates.only_me", domain: "memo", text: "只给我看，Lulu 不读", vars: [], tone: "", source: "补充" },
  "memo.candidates.source": { id: "memo.candidates.source", domain: "memo", text: "来源", vars: [], tone: "", source: "补充" },
  "memo.candidates.why": { id: "memo.candidates.why", domain: "memo", text: "为什么值得留", vars: [], tone: "", source: "补充" },
  "memo.capture.hint": { id: "memo.capture.hint", domain: "memo", text: "Enter 保存 · Shift+Enter 换行", vars: [], tone: "", source: "设计稿 · CaptureBox" },
  "memo.capture.retry": { id: "memo.capture.retry", domain: "memo", text: "重试", vars: [], tone: "", source: "设计稿 S15" },
  "memo.capture.save": { id: "memo.capture.save", domain: "memo", text: "保存", vars: [], tone: "", source: "设计稿 · CaptureBox" },
  "memo.capture.saving": { id: "memo.capture.saving", domain: "memo", text: "正在保存…", vars: [], tone: "", source: "设计稿 · CaptureBox" },
  "memo.capture.tool.clip": { id: "memo.capture.tool.clip", domain: "memo", text: "附件", vars: [], tone: "", source: "设计稿 · CaptureBox" },
  "memo.capture.tool.link": { id: "memo.capture.tool.link", domain: "memo", text: "链接", vars: [], tone: "", source: "设计稿 · CaptureBox" },
  "memo.capture.tool.voice": { id: "memo.capture.tool.voice", domain: "memo", text: "录一段", vars: [], tone: "", source: "设计稿 · CaptureBox" },
  "memo.capture.tool.voice.cancel": { id: "memo.capture.tool.voice.cancel", domain: "memo", text: "不录了", vars: [], tone: "", source: "补充" },
  "memo.clip.bytes": { id: "memo.clip.bytes", domain: "memo", text: "{size}", vars: ["size"], tone: "", source: "补充" },
  "memo.clip.fail.foot": { id: "memo.clip.fail.foot", domain: "memo", text: "正文存好了，附件还没都上去：{names}。重试或移除，都处理完这个框才清空。", vars: ["names"], tone: "", source: "补充" },
  "memo.clip.reject.size": { id: "memo.clip.reject.size", domain: "memo", text: "这个文件超过 10MB，传不上去——大文件不适合走备忘录", vars: [], tone: "", source: "SPEC-components §8" },
  "memo.clip.reject.type": { id: "memo.clip.reject.type", domain: "memo", text: "这种文件先不收——支持图片和常见文档（png、jpg、webp、gif、pdf、txt、md、csv、json、zip）", vars: [], tone: "", source: "SPEC-components §8" },
  "memo.clip.remove": { id: "memo.clip.remove", domain: "memo", text: "移除", vars: [], tone: "", source: "SPEC-components §8" },
  "memo.clip.state.done": { id: "memo.clip.state.done", domain: "memo", text: "传上去了", vars: [], tone: "", source: "SPEC-components §8" },
  "memo.clip.state.failed": { id: "memo.clip.state.failed", domain: "memo", text: "没传上去", vars: [], tone: "", source: "SPEC-components §8" },
  "memo.clip.state.uploading": { id: "memo.clip.state.uploading", domain: "memo", text: "上传中 {percent}%", vars: ["percent"], tone: "", source: "SPEC-components §8" },
  "memo.clip.state.waiting": { id: "memo.clip.state.waiting", domain: "memo", text: "等正文先存，马上传", vars: [], tone: "", source: "补充" },
  "memo.conflict.body": { id: "memo.conflict.body", domain: "memo", text: "两个版本都在，你选一个。选之前什么都不会覆盖。", vars: [], tone: "", source: "设计稿 S12" },
  "memo.conflict.foot": { id: "memo.conflict.foot", domain: "memo", text: "选之前，你本机那份一直留着，不会被自动覆盖", vars: [], tone: "", source: "设计稿 S12" },
  "memo.conflict.mine": { id: "memo.conflict.mine", domain: "memo", text: "你改的", vars: [], tone: "", source: "设计稿 S12" },
  "memo.conflict.mine.v": { id: "memo.conflict.mine.v", domain: "memo", text: "还在本机 · 没上传", vars: [], tone: "", source: "设计稿 S12" },
  "memo.conflict.option.both": { id: "memo.conflict.option.both", domain: "memo", text: "两边都留（推荐）", vars: [], tone: "", source: "设计稿 S12" },
  "memo.conflict.option.both.desc": { id: "memo.conflict.option.both.desc", domain: "memo", text: "把你改的那部分接在服务器上的版本后面。两个人的改动都不丢。", vars: [], tone: "", source: "设计稿 S12" },
  "memo.conflict.option.mine": { id: "memo.conflict.option.mine", domain: "memo", text: "用我的", vars: [], tone: "", source: "设计稿 S12" },
  "memo.conflict.option.mine.desc": { id: "memo.conflict.option.mine.desc", domain: "memo", text: "覆盖掉服务器上的改动。", vars: [], tone: "", source: "设计稿 S12" },
  "memo.conflict.option.server": { id: "memo.conflict.option.server", domain: "memo", text: "用服务器上的", vars: [], tone: "", source: "设计稿 S12" },
  "memo.conflict.option.server.desc": { id: "memo.conflict.option.server.desc", domain: "memo", text: "丢掉你本机的改动。", vars: [], tone: "", source: "设计稿 S12" },
  "memo.conflict.server": { id: "memo.conflict.server", domain: "memo", text: "服务器上的", vars: [], tone: "", source: "设计稿 S12" },
  "memo.conflict.server.v": { id: "memo.conflict.server.v", domain: "memo", text: "已生效", vars: [], tone: "", source: "设计稿 S12" },
  "memo.conflict.title": { id: "memo.conflict.title", domain: "memo", text: "这条你和别人同时改了", vars: [], tone: "", source: "设计稿 S12" },
  "memo.crumb.project": { id: "memo.crumb.project", domain: "memo", text: "项目", vars: [], tone: "", source: "设计稿 S06" },
  "memo.detail.actions.archive": { id: "memo.detail.actions.archive", domain: "memo", text: "归档", vars: [], tone: "", source: "设计稿 S09" },
  "memo.detail.actions.move": { id: "memo.detail.actions.move", domain: "memo", text: "移动", vars: [], tone: "", source: "设计稿 S09" },
  "memo.detail.ai": { id: "memo.detail.ai", domain: "memo", text: "AI 能读吗", vars: [], tone: "", source: "设计稿 S09" },
  "memo.detail.ai.reads": { id: "memo.detail.ai.reads", domain: "memo", text: "读过的记录", vars: [], tone: "", source: "设计稿 S09" },
  "memo.detail.ai.reads.none": { id: "memo.detail.ai.reads.none", domain: "memo", text: "还没有 AI 读过", vars: [], tone: "", source: "SPEC-components §8" },
  "memo.detail.cant.read": { id: "memo.detail.cant.read", domain: "memo", text: "读不到", vars: [], tone: "", source: "设计稿 S09" },
  "memo.detail.edited": { id: "memo.detail.edited", domain: "memo", text: "{date} 改过", vars: ["date"], tone: "", source: "设计稿 S09" },
  "memo.detail.files.none": { id: "memo.detail.files.none", domain: "memo", text: "没有附件", vars: [], tone: "", source: "补充" },
  "memo.detail.group.files": { id: "memo.detail.group.files", domain: "memo", text: "附件", vars: [], tone: "", source: "设计稿 S09 · AttachmentList" },
  "memo.detail.group.relations": { id: "memo.detail.group.relations", domain: "memo", text: "关联到（真实对象，不是复制内容）", vars: [], tone: "", source: "设计稿 S09" },
  "memo.detail.group.scope": { id: "memo.detail.group.scope", domain: "memo", text: "作用域和 AI", vars: [], tone: "", source: "设计稿 S09" },
  "memo.detail.other.projects": { id: "memo.detail.other.projects", domain: "memo", text: "别的项目", vars: [], tone: "", source: "设计稿 S09" },
  "memo.detail.source.none": { id: "memo.detail.source.none", domain: "memo", text: "—— 这条是手写的，没有来源会话", vars: [], tone: "", source: "设计稿 S09" },
  "memo.detail.voice.title": { id: "memo.detail.voice.title", domain: "memo", text: "语音 {duration}", vars: ["duration"], tone: "", source: "设计稿 S11" },
  "memo.detail.where": { id: "memo.detail.where", domain: "memo", text: "存在哪", vars: [], tone: "", source: "设计稿 S09" },
  "memo.detail.where.global": { id: "memo.detail.where.global", domain: "memo", text: "杂项备忘录（只属于你）", vars: [], tone: "", source: "设计稿 S09" },
  "memo.detail.where.project": { id: "memo.detail.where.project", domain: "memo", text: "{project}（项目内）", vars: ["project"], tone: "", source: "设计稿 S09" },
  "memo.detail.written": { id: "memo.detail.written", domain: "memo", text: "{date} 写的", vars: ["date"], tone: "", source: "设计稿 S09" },
  "memo.empty.filter": { id: "memo.empty.filter", domain: "memo", text: "这一档还没有条目", vars: [], tone: "", source: "补充" },
  "memo.empty.from.misc": { id: "memo.empty.from.misc", domain: "memo", text: "从杂项里移过来", vars: [], tone: "", source: "设计稿 S07" },
  "memo.empty.global.body": { id: "memo.empty.global.body", domain: "memo", text: "想到什么先写在这儿，不用先想它属于哪个项目。以后想归到某个项目，一条一条移过去就行。语音、图片、链接都能存。", vars: [], tone: "", source: "设计稿 S02" },
  "memo.empty.global.placeholder": { id: "memo.empty.global.placeholder", domain: "memo", text: "在这儿写第一条 —— 一句话就行", vars: [], tone: "", source: "设计稿 S02" },
  "memo.empty.global.title": { id: "memo.empty.global.title", domain: "memo", text: "随手记下，不会丢", vars: [], tone: "", source: "设计稿 S02" },
  "memo.empty.project.body": { id: "memo.empty.project.body", domain: "memo", text: "适合写在这儿的：环境不能乱动的地方、字段的历史包袱、压测结论、和客户约好的事。开了「AI 可读」之后，这个项目的 Agent 干活时就会参考这些。", vars: [], tone: "", source: "设计稿 S07" },
  "memo.empty.project.placeholder": { id: "memo.empty.project.placeholder", domain: "memo", text: "比如：这个项目的约定、踩过的坑、不要动的地方", vars: [], tone: "", source: "设计稿 S07" },
  "memo.empty.project.title": { id: "memo.empty.project.title", domain: "memo", text: "把这个项目的约定写下来", vars: [], tone: "", source: "设计稿 S07" },
  "memo.error.body": { id: "memo.error.body", domain: "memo", text: "服务器暂时没有响应。现在写的东西会先存在本机，连上之后自动补上去。", vars: [], tone: "", source: "设计稿 S04" },
  "memo.error.retry": { id: "memo.error.retry", domain: "memo", text: "重试", vars: [], tone: "", source: "设计稿 S04" },
  "memo.error.title": { id: "memo.error.title", domain: "memo", text: "读不到备忘录列表", vars: [], tone: "", source: "设计稿 S04" },
  "memo.group.earlier": { id: "memo.group.earlier", domain: "memo", text: "更早", vars: [], tone: "", source: "补充" },
  "memo.group.today": { id: "memo.group.today", domain: "memo", text: "今天", vars: [], tone: "", source: "补充" },
  "memo.group.week": { id: "memo.group.week", domain: "memo", text: "本周", vars: [], tone: "", source: "补充" },
  "memo.group.yesterday": { id: "memo.group.yesterday", domain: "memo", text: "昨天", vars: [], tone: "", source: "补充" },
  "memo.image.preview": { id: "memo.image.preview", domain: "memo", text: "查看大图", vars: [], tone: "", source: "补充" },
  "memo.link.add": { id: "memo.link.add", domain: "memo", text: "加进正文", vars: [], tone: "", source: "补充" },
  "memo.link.invalid": { id: "memo.link.invalid", domain: "memo", text: "这不像一个链接——网址形如 example.com 或 https://example.com，不带协议头的会自动补上", vars: [], tone: "", source: "补充" },
  "memo.link.placeholder": { id: "memo.link.placeholder", domain: "memo", text: "粘贴一个链接", vars: [], tone: "", source: "设计稿 · CaptureBox" },
  "memo.list.fact.files": { id: "memo.list.fact.files", domain: "memo", text: "{n} 个文件", vars: ["n"], tone: "", source: "设计稿 S01" },
  "memo.list.fact.images": { id: "memo.list.fact.images", domain: "memo", text: "{n} 张图", vars: ["n"], tone: "", source: "设计稿 S01" },
  "memo.list.filter.all": { id: "memo.list.filter.all", domain: "memo", text: "全部", vars: [], tone: "", source: "设计稿 S01" },
  "memo.list.filter.files": { id: "memo.list.filter.files", domain: "memo", text: "有附件", vars: [], tone: "", source: "设计稿 S01" },
  "memo.list.filter.lulu": { id: "memo.list.filter.lulu", domain: "memo", text: "来自 Lulu", vars: [], tone: "", source: "设计稿 S06" },
  "memo.list.filter.recent": { id: "memo.list.filter.recent", domain: "memo", text: "最近改的", vars: [], tone: "", source: "设计稿 S01" },
  "memo.list.filter.voice": { id: "memo.list.filter.voice", domain: "memo", text: "语音", vars: [], tone: "", source: "设计稿 S01" },
  "memo.list.head.find": { id: "memo.list.head.find", domain: "memo", text: "找一条", vars: [], tone: "", source: "设计稿 S01" },
  "memo.list.recent": { id: "memo.list.recent", domain: "memo", text: "最近", vars: [], tone: "", source: "设计稿 S01" },
  "memo.list.recent.meta": { id: "memo.list.recent.meta", domain: "memo", text: "{count} 条 · 按最近改动排", vars: ["count"], tone: "", source: "设计稿 S01" },
  "memo.list.search": { id: "memo.list.search", domain: "memo", text: "搜正文、语音转写、附件名", vars: [], tone: "", source: "设计稿 S01" },
  "memo.list.search.clear": { id: "memo.list.search.clear", domain: "memo", text: "清掉筛选", vars: [], tone: "", source: "补充" },
  "memo.list.search.empty": { id: "memo.list.search.empty", domain: "memo", text: "没有匹配的——换个词，或把筛选清掉再试", vars: [], tone: "", source: "补充" },
  "memo.list.source.file": { id: "memo.list.source.file", domain: "memo", text: "附件", vars: [], tone: "", source: "设计稿 S01" },
  "memo.list.source.link": { id: "memo.list.source.link", domain: "memo", text: "链接", vars: [], tone: "", source: "设计稿 S01" },
  "memo.list.source.lulu": { id: "memo.list.source.lulu", domain: "memo", text: "来自 Lulu", vars: [], tone: "", source: "设计稿 S06" },
  "memo.list.source.text": { id: "memo.list.source.text", domain: "memo", text: "手写", vars: [], tone: "", source: "设计稿 S01" },
  "memo.list.source.voice": { id: "memo.list.source.voice", domain: "memo", text: "语音", vars: [], tone: "", source: "设计稿 S01" },
  "memo.list.this.project": { id: "memo.list.this.project", domain: "memo", text: "这个项目的", vars: [], tone: "", source: "设计稿 S06" },
  "memo.list.uploads.waiting": { id: "memo.list.uploads.waiting", domain: "memo", text: "等上传", vars: [], tone: "", source: "设计稿 S05" },
  "memo.list.voice.no_text": { id: "memo.list.voice.no_text", domain: "memo", text: "（语音 {duration} · 还没有文字）", vars: ["duration"], tone: "", source: "设计稿 · MemoItem" },
  "memo.loading": { id: "memo.loading", domain: "memo", text: "正在读取", vars: [], tone: "", source: "设计稿 S03" },
  "memo.loading.note": { id: "memo.loading.note", domain: "memo", text: "现在也能写，读取完会一起显示", vars: [], tone: "", source: "设计稿 S03" },
  "memo.lock.desc": { id: "memo.lock.desc", domain: "memo", text: "正文和附件只有输对密码才能看。密码存在这条上，改在详情里改。", vars: [], tone: "", source: "补充" },
  "memo.lock.input": { id: "memo.lock.input", domain: "memo", text: "输入这条的密码", vars: [], tone: "", source: "补充" },
  "memo.lock.placeholder": { id: "memo.lock.placeholder", domain: "memo", text: "（设了密码 · 点开输入密码查看）", vars: [], tone: "", source: "补充" },
  "memo.lock.title": { id: "memo.lock.title", domain: "memo", text: "这条设了密码", vars: [], tone: "", source: "补充" },
  "memo.lock.unlock": { id: "memo.lock.unlock", domain: "memo", text: "解锁", vars: [], tone: "", source: "补充" },
  "memo.mobile.input": { id: "memo.mobile.input", domain: "memo", text: "写点什么…", vars: [], tone: "", source: "设计稿 M01" },
  "memo.mobile.search.open": { id: "memo.mobile.search.open", domain: "memo", text: "搜一条", vars: [], tone: "", source: "补充" },
  "memo.move.confirm": { id: "memo.move.confirm", domain: "memo", text: "移到 {project}", vars: ["project"], tone: "", source: "设计稿 S16" },
  "memo.move.confirm.none": { id: "memo.move.confirm.none", domain: "memo", text: "先选一个项目", vars: [], tone: "", source: "补充" },
  "memo.move.desc": { id: "memo.move.desc", domain: "memo", text: "「{body}」 —— 移过去之后，这条就跟着那个项目走。", vars: ["body"], tone: "", source: "设计稿 S16" },
  "memo.move.foot": { id: "memo.move.foot", domain: "memo", text: "移动成功之前，这条在列表里一直看得见", vars: [], tone: "", source: "设计稿 S16" },
  "memo.move.invalid.body": { id: "memo.move.invalid.body", domain: "memo", text: "这条还在原处，一个字没动。{reason}", vars: ["reason"], tone: "", source: "设计稿 S17" },
  "memo.move.invalid.title": { id: "memo.move.invalid.title", domain: "memo", text: "移不过去", vars: [], tone: "", source: "设计稿 S17" },
  "memo.move.invalid.wont.1": { id: "memo.move.invalid.wont.1", domain: "memo", text: "不会悄悄存到别的项目", vars: [], tone: "", source: "设计稿 S17" },
  "memo.move.invalid.wont.2": { id: "memo.move.invalid.wont.2", domain: "memo", text: "不会丢掉这条", vars: [], tone: "", source: "设计稿 S17" },
  "memo.move.invalid.wont.3": { id: "memo.move.invalid.wont.3", domain: "memo", text: "不会把归档项目自动恢复", vars: [], tone: "", source: "设计稿 S17" },
  "memo.move.note": { id: "memo.move.note", domain: "memo", text: "为什么 AI 权限要重新定：杂项里「不允许读」和项目里「不允许读」是两个不同的范围，不能直接搬过去当成同一个意思。", vars: [], tone: "", source: "设计稿 S16" },
  "memo.move.notice": { id: "memo.move.notice", domain: "memo", text: "移动是先加后删", vars: [], tone: "", source: "设计稿 S16" },
  "memo.move.notice.body": { id: "memo.move.notice.body", domain: "memo", text: "移过去成功了，才从这个列表里消失。中间失败的话它还在原处，不会两边都没有。", vars: [], tone: "", source: "设计稿 S16" },
  "memo.move.pick.other": { id: "memo.move.pick.other", domain: "memo", text: "换一个项目", vars: [], tone: "", source: "设计稿 S17" },
  "memo.move.row.ai": { id: "memo.move.row.ai", domain: "memo", text: "AI 权限要重新定", vars: [], tone: "", source: "设计稿 S16" },
  "memo.move.row.ai.v": { id: "memo.move.row.ai.v", domain: "memo", text: "移过去后默认还是「不允许读」，需要你单独开", vars: [], tone: "", source: "设计稿 S16" },
  "memo.move.row.back": { id: "memo.move.row.back", domain: "memo", text: "还能移回来吗", vars: [], tone: "", source: "设计稿 S16" },
  "memo.move.row.back.v": { id: "memo.move.row.back.v", domain: "memo", text: "能，随时移回杂项", vars: [], tone: "", source: "设计稿 S16" },
  "memo.move.row.delete": { id: "memo.move.row.delete", domain: "memo", text: "项目删了", vars: [], tone: "", source: "设计稿 S16" },
  "memo.move.row.delete.v": { id: "memo.move.row.delete.v", domain: "memo", text: "这条会跟着一起删", vars: [], tone: "", source: "设计稿 S16" },
  "memo.move.row.to": { id: "memo.move.row.to", domain: "memo", text: "移到", vars: [], tone: "", source: "设计稿 S16" },
  "memo.move.row.who": { id: "memo.move.row.who", domain: "memo", text: "谁能看", vars: [], tone: "", source: "设计稿 S16" },
  "memo.move.row.who.v": { id: "memo.move.row.who.v", domain: "memo", text: "这个项目的可写成员", vars: [], tone: "", source: "设计稿 S16" },
  "memo.move.title": { id: "memo.move.title", domain: "memo", text: "移到哪个项目？", vars: [], tone: "", source: "设计稿 S16" },
  "memo.move.to.misc": { id: "memo.move.to.misc", domain: "memo", text: "移回杂项", vars: [], tone: "", source: "设计稿 S16" },
  "memo.page.back.list": { id: "memo.page.back.list", domain: "memo", text: "回到备忘录", vars: [], tone: "", source: "设计稿 S18" },
  "memo.page.badge.project": { id: "memo.page.badge.project", domain: "memo", text: "项目内", vars: [], tone: "", source: "设计稿 S06" },
  "memo.page.notice.global": { id: "memo.page.notice.global", domain: "memo", text: "这一页只有杂项，不会混进项目里的", vars: [], tone: "", source: "设计稿 S01" },
  "memo.page.notice.global.body": { id: "memo.page.notice.global.body", domain: "memo", text: "项目里的备忘录在那个项目的「备忘录」页签里。想同时搜两边，用跨项目搜索——那是个明确的动作，不会默默把项目内容混进来。", vars: [], tone: "", source: "设计稿 S01" },
  "memo.page.notice.project": { id: "memo.page.notice.project", domain: "memo", text: "这一页看不到别的项目，也看不到杂项", vars: [], tone: "", source: "设计稿 S06" },
  "memo.page.notice.project.body": { id: "memo.page.notice.project.body", domain: "memo", text: "要同时找两边，回到一级导航的「备忘录」——那是个明确动作。", vars: [], tone: "", source: "设计稿 S06" },
  "memo.page.subtitle": { id: "memo.page.subtitle", domain: "memo", text: "还没归到任何项目的东西都在这儿。写的时候不用先想属于哪个项目——想清楚了再移过去。", vars: [], tone: "", source: "设计稿 S01" },
  "memo.page.subtitle.project": { id: "memo.page.subtitle.project", domain: "memo", text: "只属于这个项目。写在这儿的东西，这个项目的 Agent 按你给的权限能读到。", vars: [], tone: "", source: "设计稿 S06" },
  "memo.page.title": { id: "memo.page.title", domain: "memo", text: "杂项备忘录", vars: [], tone: "", source: "设计稿 S01" },
  "memo.page.title.project": { id: "memo.page.title.project", domain: "memo", text: "{project} / 备忘录", vars: ["project"], tone: "", source: "设计稿 S06" },
  "memo.page.write": { id: "memo.page.write", domain: "memo", text: "写一条", vars: [], tone: "", source: "设计稿 S01" },
  "memo.password.change": { id: "memo.password.change", domain: "memo", text: "改密码", vars: [], tone: "", source: "补充" },
  "memo.password.confirm.remove": { id: "memo.password.confirm.remove", domain: "memo", text: "去掉后这条不再需要密码，正文直接可见。确定？", vars: [], tone: "", source: "补充" },
  "memo.password.group": { id: "memo.password.group", domain: "memo", text: "密码", vars: [], tone: "", source: "补充" },
  "memo.password.input": { id: "memo.password.input", domain: "memo", text: "至少 4 个字符", vars: [], tone: "", source: "补充" },
  "memo.password.none": { id: "memo.password.none", domain: "memo", text: "没设密码。要挡一眼的话可以设一个——设了之后正文只有输对密码才能看，AI 也永远读不到这条。", vars: [], tone: "", source: "补充" },
  "memo.password.remove": { id: "memo.password.remove", domain: "memo", text: "去掉密码", vars: [], tone: "", source: "补充" },
  "memo.password.removed": { id: "memo.password.removed", domain: "memo", text: "密码去掉了，这条恢复成普通备忘录。", vars: [], tone: "", source: "补充" },
  "memo.password.set": { id: "memo.password.set", domain: "memo", text: "设密码", vars: [], tone: "", source: "补充" },
  "memo.password.set.ok": { id: "memo.password.set.ok", domain: "memo", text: "密码设好了。这条在列表里只显示「设了密码」，正文要解锁才能看。", vars: [], tone: "", source: "补充" },
  "memo.queue.dead": { id: "memo.queue.dead", domain: "memo", text: "没补上去——这条所在的项目可能已经删除或没了权限，正文留在本机", vars: [], tone: "", source: "补充" },
  "memo.queue.dead.remove": { id: "memo.queue.dead.remove", domain: "memo", text: "移除", vars: [], tone: "", source: "补充" },
  "memo.quick.badge": { id: "memo.quick.badge", domain: "memo", text: "按 N 打开", vars: [], tone: "", source: "设计稿 S13" },
  "memo.quick.composing.note": { id: "memo.quick.composing.note", domain: "memo", text: "拼音选字时按 Enter 不会误提交", vars: [], tone: "", source: "设计稿 S13" },
  "memo.quick.desc.global": { id: "memo.quick.desc.global", domain: "memo", text: "当前在「杂项备忘录」——不属于任何项目，也不会进任何项目 AI 的上下文。", vars: [], tone: "", source: "设计稿 S13" },
  "memo.quick.desc.project": { id: "memo.quick.desc.project", domain: "memo", text: "你现在在项目里，所以默认存到这个项目。作用域一直显示在上面，不用猜。", vars: [], tone: "", source: "设计稿 S14" },
  "memo.quick.foot": { id: "memo.quick.foot", domain: "memo", text: "草稿会存在本机，关了浏览器再回来还在", vars: [], tone: "", source: "设计稿 S13" },
  "memo.quick.note": { id: "memo.quick.note", domain: "memo", text: "保存成功之前这个框不会关。失败了内容留着，给你「重试」。", vars: [], tone: "", source: "设计稿 S13" },
  "memo.quick.note.project": { id: "memo.quick.note.project", domain: "memo", text: "如果保存时这个项目没了权限或被归档，不会偷偷存成杂项——会问你要不要另存为杂项。", vars: [], tone: "", source: "设计稿 S14" },
  "memo.quick.title": { id: "memo.quick.title", domain: "memo", text: "随手记一条", vars: [], tone: "", source: "设计稿 S13" },
  "memo.quick.title.project": { id: "memo.quick.title.project", domain: "memo", text: "记到 {project}", vars: ["project"], tone: "", source: "设计稿 S14" },
  "memo.reads.bar.latest": { id: "memo.reads.bar.latest", domain: "memo", text: "最近一次 AI 读取：读了 {read} 条，可读的有 {total} 条。", vars: ["read", "total"], tone: "", source: "补充" },
  "memo.reads.bar.none": { id: "memo.reads.bar.none", domain: "memo", text: "还没有 AI 读过", vars: [], tone: "", source: "补充" },
  "memo.reads.scope.global": { id: "memo.reads.scope.global", domain: "memo", text: "全局范围", vars: [], tone: "", source: "补充" },
  "memo.reads.scope.host": { id: "memo.reads.scope.host", domain: "memo", text: "机器", vars: [], tone: "", source: "补充" },
  "memo.reads.scope.project": { id: "memo.reads.scope.project", domain: "memo", text: "项目", vars: [], tone: "", source: "补充" },
  "memo.save.fail.body": { id: "memo.save.fail.body", domain: "memo", text: "服务器返回了错误。你的内容一个字都没丢——它还在下面的框里，也存了一份在本机。点重试就行。", vars: [], tone: "", source: "设计稿 S15" },
  "memo.save.fail.foot": { id: "memo.save.fail.foot", domain: "memo", text: "上次失败：{reason}（{time}）。内容已存本机草稿。", vars: ["reason", "time"], tone: "", source: "设计稿 S15" },
  "memo.save.fail.title": { id: "memo.save.fail.title", domain: "memo", text: "这条没存上服务器", vars: [], tone: "", source: "设计稿 S15" },
  "memo.save.giveup": { id: "memo.save.giveup", domain: "memo", text: "不管了", vars: [], tone: "", source: "设计稿 S15" },
  "memo.save.offline.foot": { id: "memo.save.offline.foot", domain: "memo", text: "连不上服务器，写完先存本机，连上自动补上去", vars: [], tone: "", source: "设计稿 S04" },
  "memo.save.why": { id: "memo.save.why", domain: "memo", text: "为什么不显示「已保存」", vars: [], tone: "", source: "设计稿 S15" },
  "memo.save.why.body": { id: "memo.save.why.body", domain: "memo", text: "没到服务器就不算保存好。这里写「没保存上」，因为换台设备现在看不到它。", vars: [], tone: "", source: "设计稿 S15" },
  "memo.scope.local": { id: "memo.scope.local", domain: "memo", text: "本机", vars: [], tone: "", source: "设计稿 · ScopeLabel" },
  "memo.scope.misc": { id: "memo.scope.misc", domain: "memo", text: "杂项", vars: [], tone: "", source: "设计稿 · ScopeLabel" },
  "memo.scope.save.global": { id: "memo.scope.save.global", domain: "memo", text: "存到杂项备忘录", vars: [], tone: "", source: "设计稿 S13" },
  "memo.scope.save.global.note": { id: "memo.scope.save.global.note", domain: "memo", text: "不会进入任何项目的 AI", vars: [], tone: "", source: "设计稿 S13" },
  "memo.scope.save.project": { id: "memo.scope.save.project", domain: "memo", text: "存到 {project}", vars: ["project"], tone: "", source: "设计稿 S14" },
  "memo.scope.save.project.note": { id: "memo.scope.save.project.note", domain: "memo", text: "这个项目的 Agent 能读（你可以关）", vars: [], tone: "", source: "设计稿 S14" },
  "memo.scope.switch.misc": { id: "memo.scope.switch.misc", domain: "memo", text: "改成杂项", vars: [], tone: "", source: "设计稿 S14" },
  "memo.search.cross": { id: "memo.search.cross", domain: "memo", text: "也搜项目", vars: [], tone: "", source: "设计稿 S01" },
  "memo.undo.action": { id: "memo.undo.action", domain: "memo", text: "撤销", vars: [], tone: "", source: "补充" },
  "memo.undo.archived": { id: "memo.undo.archived", domain: "memo", text: "已归档", vars: [], tone: "", source: "补充" },
  "memo.undo.failed": { id: "memo.undo.failed", domain: "memo", text: "撤销没成功", vars: [], tone: "", source: "补充" },
  "memo.undo.moved": { id: "memo.undo.moved", domain: "memo", text: "已移动", vars: [], tone: "", source: "补充" },
  "memo.view.label": { id: "memo.view.label", domain: "memo", text: "切换显示方式", vars: [], tone: "", source: "补充" },
  "memo.view.list": { id: "memo.view.list", domain: "memo", text: "列表", vars: [], tone: "", source: "补充" },
  "memo.view.tiles": { id: "memo.view.tiles", domain: "memo", text: "平铺", vars: [], tone: "", source: "补充" },
  "memo.voice.audition": { id: "memo.voice.audition", domain: "memo", text: "听一遍再决定要不要留", vars: [], tone: "", source: "设计稿 · VoiceRecorder" },
  "memo.voice.cancel": { id: "memo.voice.cancel", domain: "memo", text: "丢掉这段，不会存", vars: [], tone: "", source: "设计稿 · VoiceRecorder" },
  "memo.voice.finish": { id: "memo.voice.finish", domain: "memo", text: "录完了", vars: [], tone: "", source: "设计稿 · VoiceRecorder" },
  "memo.voice.level.off": { id: "memo.voice.level.off", domain: "memo", text: "还没收到声音，看看是不是选错了话筒", vars: [], tone: "", source: "补充" },
  "memo.voice.level.on": { id: "memo.voice.level.on", domain: "memo", text: "收到声音了", vars: [], tone: "", source: "补充" },
  "memo.voice.no_mic": { id: "memo.voice.no_mic", domain: "memo", text: "没拿到话筒权限，浏览器地址栏里那个锁里能改", vars: [], tone: "", source: "补充" },
  "memo.voice.record": { id: "memo.voice.record", domain: "memo", text: "录一段", vars: [], tone: "", source: "设计稿 M04" },
  "memo.voice.rerecord": { id: "memo.voice.rerecord", domain: "memo", text: "丢掉这段，不会存", vars: [], tone: "", source: "设计稿 · VoiceRecorder" },
  "memo.voice.save": { id: "memo.voice.save", domain: "memo", text: "存这段原声", vars: [], tone: "", source: "补充" },
  "memo.voice.saved": { id: "memo.voice.saved", domain: "memo", text: "原声已保存", vars: [], tone: "", source: "设计稿 · VoiceRecorder" },
  "memo.voice.saving": { id: "memo.voice.saving", domain: "memo", text: "正在存原声…", vars: [], tone: "", source: "补充" },
  "memo.voice.search.note": { id: "memo.voice.search.note", domain: "memo", text: "现在搜不到这条的内容 —— 因为没有文字", vars: [], tone: "", source: "SPEC-scope-ai §6.3" },
  "memo.voice.selfwrite": { id: "memo.voice.selfwrite", domain: "memo", text: "自己补写文字", vars: [], tone: "", source: "设计稿 S11" },
  "memo.voice.stop": { id: "memo.voice.stop", domain: "memo", text: "先停一下，还能接着录", vars: [], tone: "", source: "设计稿 · VoiceRecorder" },
  "memo.voice.transcribing": { id: "memo.voice.transcribing", domain: "memo", text: "正在转写", vars: [], tone: "", source: "设计稿 · VoiceRecorder" },
  "memo.voice.transcript.failed": { id: "memo.voice.transcript.failed", domain: "memo", text: "原声已保存，暂未转写", vars: [], tone: "", source: "设计稿 S11" },
  "memo.voice.transcript.failed.body": { id: "memo.voice.transcript.failed.body", domain: "memo", text: "所以这里不写「已转写」，也不放一段空文字冒充成功。你可以重试，也可以自己补几个字——补了就能搜到。", vars: [], tone: "", source: "设计稿 S11" },
  "memo.voice.unsupported": { id: "memo.voice.unsupported", domain: "memo", text: "这台浏览器录不了音，用 Chrome 或 Safari 打开试试", vars: [], tone: "", source: "补充" },
  "memo.when.date": { id: "memo.when.date", domain: "memo", text: "{m} 月 {d} 日", vars: ["d", "m"], tone: "", source: "设计稿 S01" },
  "memo.when.full": { id: "memo.when.full", domain: "memo", text: "{y} 年 {m} 月 {d} 日", vars: ["d", "m", "y"], tone: "", source: "补充" },
  "memo.when.today": { id: "memo.when.today", domain: "memo", text: "今天 {time}", vars: ["time"], tone: "", source: "设计稿 S01" },
  "memo.when.yesterday": { id: "memo.when.yesterday", domain: "memo", text: "昨天 {time}", vars: ["time"], tone: "", source: "设计稿 S01" },
  "model.application.action.remove": { id: "model.application.action.remove", domain: "model", text: "移除项目覆盖", vars: [], tone: "", source: "2026-08-16 用户确认" },
  "model.application.action.save": { id: "model.application.action.save", domain: "model", text: "保存项目设置", vars: [], tone: "", source: "2026-08-16 用户确认" },
  "model.application.override.hint": { id: "model.application.override.hint", domain: "model", text: "关闭并保存后，这项能力重新跟随全局默认。", vars: [], tone: "", source: "2026-08-16 用户确认" },
  "model.application.override.label": { id: "model.application.override.label", domain: "model", text: "这个项目单独设置", vars: [], tone: "", source: "2026-08-16 用户确认" },
  "model.application.saved": { id: "model.application.saved", domain: "model", text: "项目设置已更新。", vars: [], tone: "positive", source: "2026-08-16 用户确认" },
  "model.budget.only_one_brain": { id: "model.budget.only_one_brain", domain: "model", text: "现在只有一个脑子在干活，没得挑。你要是想让粗活更省，去「大脑与 Key」那页贴第二家的 Key，我就能把巡检这类活挪过去。", vars: [], tone: "", source: "补充（单厂商阶段）" },
  "model.budget.switch_cheap": { id: "model.budget.switch_cheap", domain: "model", text: "要我把巡检这类粗活全切到 {provider} 吗？能省一半，准确率差一点点。", vars: ["provider"], tone: "", source: "设计稿 · 大脑与 Key（厂商名改成变量）" },
  "model.degraded.budget_used_up": { id: "model.degraded.budget_used_up", domain: "model", text: "这个月给 AI 的额度用完了，我按老规矩接着干，一样在看着。下个月一号自动恢复。", vars: [], tone: "neutral", source: "补充" },
  "model.degraded.no_answer": { id: "model.degraded.no_answer", domain: "model", text: "我本来想让 AI 帮忙看一下，它这会儿没反应，我就按老规矩办了。可能保守一点，你要是想让它再看一遍，随时说。", vars: [], tone: "neutral", source: "补充" },
  "model.degraded.secret_in_paste": { id: "model.degraded.secret_in_paste", domain: "model", text: "你贴的这段里有一把私钥，我没把它发给外面的 AI，自己在本机看的。", vars: [], tone: "warn", source: "补充" },
  "model.developer.action.save": { id: "model.developer.action.save", domain: "model", text: "保存开发默认", vars: [], tone: "", source: "补充" },
  "model.developer.heading": { id: "model.developer.heading", domain: "model", text: "远程开发默认用", vars: [], tone: "", source: "2026-08-12 用户纠正" },
  "model.developer.hint": { id: "model.developer.hint", domain: "model", text: "创建任务时还可以单独换；这里会记住你的上次选择，换电脑登录也一样。", vars: [], tone: "", source: "2026-08-12 用户纠正" },
  "model.developer.model.auto.detail": { id: "model.developer.model.auto.detail", domain: "model", text: "由套餐动态选模型；实际模型以执行回执为准。", vars: [], tone: "", source: "2026-08-12 用户纠正" },
  "model.developer.model.auto.name": { id: "model.developer.model.auto.name", domain: "model", text: "Auto / 动态", vars: [], tone: "", source: "2026-08-12 用户纠正" },
  "model.developer.model.deepseek.detail": { id: "model.developer.model.deepseek.detail", domain: "model", text: "响应快，适合短任务和频繁迭代。", vars: [], tone: "", source: "补充" },
  "model.developer.model.deepseek.name": { id: "model.developer.model.deepseek.name", domain: "model", text: "DeepSeek V4 Flash", vars: [], tone: "", source: "2026-08-12 用户纠正" },
  "model.developer.model.doubao.detail": { id: "model.developer.model.doubao.detail", domain: "model", text: "综合开发能力均衡，适合作为日常默认。", vars: [], tone: "", source: "补充" },
  "model.developer.model.doubao.name": { id: "model.developer.model.doubao.name", domain: "model", text: "豆包 Evolving", vars: [], tone: "", source: "2026-08-12 用户纠正" },
  "model.developer.model.kimi.detail": { id: "model.developer.model.kimi.detail", domain: "model", text: "可作为长上下文开发任务的明确选择。", vars: [], tone: "", source: "补充" },
  "model.developer.model.kimi.name": { id: "model.developer.model.kimi.name", domain: "model", text: "Kimi K3", vars: [], tone: "", source: "2026-08-12 用户纠正" },
  "model.developer.provider.plan": { id: "model.developer.provider.plan", domain: "model", text: "Agent Plan 包月优先", vars: [], tone: "", source: "2026-08-12 用户确认" },
  "model.developer.recommended": { id: "model.developer.recommended", domain: "model", text: "推荐", vars: [], tone: "", source: "2026-08-12 用户纠正" },
  "model.developer.saved": { id: "model.developer.saved", domain: "model", text: "保存好了，创建远程开发任务时会优先带上这个选择。", vars: [], tone: "positive", source: "补充" },
  "model.generator.action.save_global": { id: "model.generator.action.save_global", domain: "model", text: "保存补丁生成默认", vars: [], tone: "", source: "2026-08-16 用户确认" },
  "model.generator.heading": { id: "model.generator.heading", domain: "model", text: "补丁生成模型", vars: [], tone: "", source: "2026-08-16 用户确认" },
  "model.generator.hint": { id: "model.generator.hint", domain: "model", text: "负责产出代码补丁，与 Lulu 规划和独立代码审核分开配置。", vars: [], tone: "", source: "2026-08-16 用户确认" },
  "model.generator.model.doubao.badge": { id: "model.generator.model.doubao.badge", domain: "model", text: "代码", vars: [], tone: "", source: "2026-08-16 用户确认" },
  "model.generator.model.doubao.detail": { id: "model.generator.model.doubao.detail", domain: "model", text: "可用于需要明确代码能力的项目补丁生成。", vars: [], tone: "", source: "2026-08-16 用户确认" },
  "model.generator.model.doubao.name": { id: "model.generator.model.doubao.name", domain: "model", text: "豆包 Seed Code", vars: [], tone: "", source: "2026-08-16 用户确认" },
  "model.generator.model.flash.badge": { id: "model.generator.model.flash.badge", domain: "model", text: "快速", vars: [], tone: "", source: "2026-08-16 用户确认" },
  "model.generator.model.flash.detail": { id: "model.generator.model.flash.detail", domain: "model", text: "适合小改动、短反馈和高频修复。", vars: [], tone: "", source: "2026-08-16 用户确认" },
  "model.generator.model.flash.name": { id: "model.generator.model.flash.name", domain: "model", text: "DeepSeek V4 Flash", vars: [], tone: "", source: "2026-08-16 用户确认" },
  "model.generator.model.glm.badge": { id: "model.generator.model.glm.badge", domain: "model", text: "默认", vars: [], tone: "", source: "2026-08-16 用户确认" },
  "model.generator.model.glm.detail": { id: "model.generator.model.glm.detail", domain: "model", text: "默认补丁生成路线，适合持续写代码和快速返修。", vars: [], tone: "", source: "2026-08-16 用户确认" },
  "model.generator.model.glm.name": { id: "model.generator.model.glm.name", domain: "model", text: "GLM 5.3", vars: [], tone: "", source: "2026-08-16 用户确认" },
  "model.generator.saved": { id: "model.generator.saved", domain: "model", text: "保存好了，下一次补丁生成会按新的应用设置走。", vars: [], tone: "positive", source: "2026-08-16 用户确认" },
  "model.not_connected": { id: "model.not_connected", domain: "model", text: "还没接 · 贴一个 Key 就行", vars: [], tone: "", source: "设计稿" },
  "model.provider.plan": { id: "model.provider.plan", domain: "model", text: "火山方舟 Agent Plan", vars: [], tone: "", source: "2026-08-16 用户确认" },
  "model.reviewer.action.remove_override": { id: "model.reviewer.action.remove_override", domain: "model", text: "移除单独设置", vars: [], tone: "", source: "补充" },
  "model.reviewer.action.save_global": { id: "model.reviewer.action.save_global", domain: "model", text: "保存全局设置", vars: [], tone: "", source: "补充" },
  "model.reviewer.action.save_project": { id: "model.reviewer.action.save_project", domain: "model", text: "保存这个项目", vars: [], tone: "", source: "补充" },
  "model.reviewer.action.saving": { id: "model.reviewer.action.saving", domain: "model", text: "正在保存", vars: [], tone: "", source: "补充" },
  "model.reviewer.capability.heading": { id: "model.reviewer.capability.heading", domain: "model", text: "代码审核模型", vars: [], tone: "", source: "2026-08-16 用户确认" },
  "model.reviewer.effective.label": { id: "model.reviewer.effective.label", domain: "model", text: "现在生效", vars: [], tone: "", source: "补充" },
  "model.reviewer.global.heading": { id: "model.reviewer.global.heading", domain: "model", text: "所有项目默认用", vars: [], tone: "", source: "2026-08-11 用户确认" },
  "model.reviewer.global.hint": { id: "model.reviewer.global.hint", domain: "model", text: "没有单独设置的项目，都跟这里走。", vars: [], tone: "", source: "2026-08-11 用户确认" },
  "model.reviewer.model.flash.badge": { id: "model.reviewer.model.flash.badge", domain: "model", text: "默认", vars: [], tone: "", source: "2026-08-11 用户确认" },
  "model.reviewer.model.flash.detail": { id: "model.reviewer.model.flash.detail", domain: "model", text: "出结果快，适合每天反复审。", vars: [], tone: "", source: "2026-08-11 用户确认" },
  "model.reviewer.model.flash.name": { id: "model.reviewer.model.flash.name", domain: "model", text: "Flash", vars: [], tone: "", source: "2026-08-11 用户确认" },
  "model.reviewer.model.pro.badge": { id: "model.reviewer.model.pro.badge", domain: "model", text: "结构化", vars: [], tone: "", source: "2026-08-11 用户确认" },
  "model.reviewer.model.pro.detail": { id: "model.reviewer.model.pro.detail", domain: "model", text: "适合需要综合上下文和结构化结论的独立审核。", vars: [], tone: "", source: "2026-08-11 用户确认" },
  "model.reviewer.model.pro.name": { id: "model.reviewer.model.pro.name", domain: "model", text: "豆包 Seed Evolving", vars: [], tone: "", source: "2026-08-11 用户确认" },
  "model.reviewer.override.hint": { id: "model.reviewer.override.hint", domain: "model", text: "关掉并保存，这个项目就重新跟着全局走。", vars: [], tone: "", source: "2026-08-11 用户确认" },
  "model.reviewer.override.label": { id: "model.reviewer.override.label", domain: "model", text: "这个项目单独设置", vars: [], tone: "", source: "2026-08-11 用户确认" },
  "model.reviewer.page.subtitle": { id: "model.reviewer.page.subtitle", domain: "model", text: "Lulu、补丁生成和代码审核分别选模型；全局默认与单项目覆盖互不影响。", vars: [], tone: "", source: "2026-08-14 用户确认" },
  "model.reviewer.project.empty": { id: "model.reviewer.project.empty", domain: "model", text: "还没有可以单独设置的项目。", vars: [], tone: "", source: "补充" },
  "model.reviewer.project.heading": { id: "model.reviewer.project.heading", domain: "model", text: "单个项目", vars: [], tone: "", source: "2026-08-11 用户确认" },
  "model.reviewer.project.hint": { id: "model.reviewer.project.hint", domain: "model", text: "只给需要更深检查的项目单独换，不影响别的项目。", vars: [], tone: "", source: "2026-08-11 用户确认" },
  "model.reviewer.project.select": { id: "model.reviewer.project.select", domain: "model", text: "选一个项目", vars: [], tone: "", source: "2026-08-11 用户确认" },
  "model.reviewer.removed": { id: "model.reviewer.removed", domain: "model", text: "单独设置已移除，这个项目重新跟着全局走。", vars: [], tone: "positive", source: "补充" },
  "model.reviewer.saved": { id: "model.reviewer.saved", domain: "model", text: "保存好了，下一次代码审核会按这个设置走。", vars: [], tone: "positive", source: "补充" },
  "model.reviewer.source.global": { id: "model.reviewer.source.global", domain: "model", text: "跟着全局", vars: [], tone: "", source: "补充" },
  "model.reviewer.source.project": { id: "model.reviewer.source.project", domain: "model", text: "这个项目单独设置", vars: [], tone: "", source: "补充" },
  "model.route.developer.deepseek_fallback": { id: "model.route.developer.deepseek_fallback", domain: "model", text: "Agent Plan 暂时不可用时，仅由服务端使用原厂 DeepSeek 备选；后台不提供原厂路线选择", vars: [], tone: "", source: "2026-08-16 用户确认" },
  "model.route.developer.fix_bug": { id: "model.route.developer.fix_bug", domain: "model", text: "写代码与修 Bug 使用任务携带的用户选择；doubao-seed-evolving 只是推荐值", vars: [], tone: "", source: "2026-08-12 用户纠正" },
  "model.route.developer.read_repo": { id: "model.route.developer.read_repo", domain: "model", text: "长时间通读仓库使用任务携带的用户选择；doubao-seed-evolving 只是推荐值", vars: [], tone: "", source: "2026-08-12 用户纠正" },
  "model.route.steward.ark_selected": { id: "model.route.steward.ark_selected", domain: "model", text: "Lulu 使用你已保存的火山方舟选择", vars: [], tone: "", source: "2026-08-14 用户确认" },
  "model.route.steward.deepseek_selected": { id: "model.route.steward.deepseek_selected", domain: "model", text: "Lulu 使用你已保存的 DeepSeek V4 Flash 选择", vars: [], tone: "", source: "2026-08-14 用户确认" },
  "model.steward.action.save": { id: "model.steward.action.save", domain: "model", text: "保存 Lulu 设置", vars: [], tone: "", source: "2026-08-14 用户确认" },
  "model.steward.effective.label": { id: "model.steward.effective.label", domain: "model", text: "现在生效", vars: [], tone: "", source: "2026-08-14 用户确认" },
  "model.steward.heading": { id: "model.steward.heading", domain: "model", text: "Lulu 主模型", vars: [], tone: "", source: "2026-08-14 用户确认" },
  "model.steward.hint": { id: "model.steward.hint", domain: "model", text: "决定 Lulu 的规划与调度；可按项目覆盖，不改变补丁生成或代码审核模型。", vars: [], tone: "", source: "2026-08-14 用户确认" },
  "model.steward.model.deepseek.badge": { id: "model.steward.model.deepseek.badge", domain: "model", text: "快速", vars: [], tone: "", source: "2026-08-14 用户确认" },
  "model.steward.model.deepseek.detail": { id: "model.steward.model.deepseek.detail", domain: "model", text: "响应快，适合高频判断和快速推进。", vars: [], tone: "", source: "2026-08-14 用户确认" },
  "model.steward.model.deepseek.name": { id: "model.steward.model.deepseek.name", domain: "model", text: "DeepSeek V4 Flash", vars: [], tone: "", source: "2026-08-14 用户确认" },
  "model.steward.model.doubao.badge": { id: "model.steward.model.doubao.badge", domain: "model", text: "默认", vars: [], tone: "", source: "2026-08-14 用户确认" },
  "model.steward.model.doubao.detail": { id: "model.steward.model.doubao.detail", domain: "model", text: "适合全局规划、结构化协作和多模态任务。", vars: [], tone: "", source: "2026-08-14 用户确认" },
  "model.steward.model.doubao.name": { id: "model.steward.model.doubao.name", domain: "model", text: "豆包 Seed Evolving", vars: [], tone: "", source: "2026-08-14 用户确认" },
  "model.steward.provider.ark": { id: "model.steward.provider.ark", domain: "model", text: "火山方舟 Agent Plan", vars: [], tone: "", source: "2026-08-14 用户确认" },
  "model.steward.revision": { id: "model.steward.revision", domain: "model", text: "版本 {revision}", vars: ["revision"], tone: "", source: "2026-08-14 用户确认" },
  "model.steward.saved": { id: "model.steward.saved", domain: "model", text: "保存好了，Lulu 下一次规划会按新的应用设置走。", vars: [], tone: "positive", source: "2026-08-14 用户确认" },
  "model.steward.source.global": { id: "model.steward.source.global", domain: "model", text: "全局设置", vars: [], tone: "", source: "2026-08-14 用户确认" },
  "model.vendor_not_open": { id: "model.vendor_not_open", domain: "model", text: "这个型号你的账号还没开通，去{vendor}控制台点一下就行。我先用能用的那个了。", vars: ["vendor"], tone: "warn", source: "补充" },
  "model_configuration.access_token_label": { id: "model_configuration.access_token_label", domain: "model_configuration", text: "Access Token", vars: [], tone: "", source: "2026-08-29 模型库增加 openspeech Seed ASR 占位" },
  "model_configuration.action_target": { id: "model_configuration.action_target", domain: "model_configuration", text: "{action} {name}", vars: ["action", "name"], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.add_and_test": { id: "model_configuration.add_and_test", domain: "model_configuration", text: "添加并测试", vars: [], tone: "", source: "2026-08-28 模型接入抽屉设计" },
  "model_configuration.add_model": { id: "model_configuration.add_model", domain: "model_configuration", text: "接入模型", vars: [], tone: "", source: "2026-08-28 模型主列表设计" },
  "model_configuration.advanced_label": { id: "model_configuration.advanced_label", domain: "model_configuration", text: "高级配置", vars: [], tone: "", source: "2026-08-28 自定义模型设计" },
  "model_configuration.agent_capabilities_resources": { id: "model_configuration.agent_capabilities_resources", domain: "model_configuration", text: "能力与资源", vars: [], tone: "", source: "2026-08-28 Agent 设置抽屉设计" },
  "model_configuration.agent_count": { id: "model_configuration.agent_count", domain: "model_configuration", text: "{count} 位长期配置", vars: ["count"], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.agent_settings_title": { id: "model_configuration.agent_settings_title", domain: "model_configuration", text: "Agent 设置", vars: [], tone: "", source: "2026-08-28 Agent 设置抽屉设计" },
  "model_configuration.api_key_label": { id: "model_configuration.api_key_label", domain: "model_configuration", text: "API Key", vars: [], tone: "", source: "2026-08-28 模型接入抽屉设计" },
  "model_configuration.api_key_placeholder": { id: "model_configuration.api_key_placeholder", domain: "model_configuration", text: "请输入 API Key", vars: [], tone: "", source: "2026-08-28 模型接入抽屉设计" },
  "model_configuration.api_key_replace_hint": { id: "model_configuration.api_key_replace_hint", domain: "model_configuration", text: "已配置。留空不会修改，输入新值会替换；原 Key 永不回显。", vars: [], tone: "", source: "2026-08-28 模型编辑抽屉设计" },
  "model_configuration.api_url_label": { id: "model_configuration.api_url_label", domain: "model_configuration", text: "API URL", vars: [], tone: "", source: "2026-08-28 自定义模型设计" },
  "model_configuration.app_id_label": { id: "model_configuration.app_id_label", domain: "model_configuration", text: "APP ID", vars: [], tone: "", source: "2026-08-29 模型库增加 openspeech Seed ASR 占位" },
  "model_configuration.app_id_placeholder": { id: "model_configuration.app_id_placeholder", domain: "model_configuration", text: "火山引擎语音控制台的 APP ID", vars: [], tone: "", source: "2026-08-29 模型库增加 openspeech Seed ASR 占位" },
  "model_configuration.assist.entry": { id: "model_configuration.assist.entry", domain: "model_configuration", text: "贴一段代码，我帮你填", vars: [], tone: "", source: "2026-09-02 arron 定的 AI 辅助添加模型" },
  "model_configuration.assist.hint": { id: "model_configuration.assist.hint", domain: "model_configuration", text: "服务商给的示例代码、一段 JSON、或者文档里拷出来的一段都行。我不会留下里面的密钥。", vars: [], tone: "", source: "2026-09-02 arron 定的 AI 辅助添加模型" },
  "model_configuration.assist.no_base_url": { id: "model_configuration.assist.no_base_url", domain: "model_configuration", text: "没找到接口地址，这一格得你填", vars: [], tone: "", source: "2026-09-02 arron 定的 AI 辅助添加模型" },
  "model_configuration.assist.no_model_id": { id: "model_configuration.assist.no_model_id", domain: "model_configuration", text: "没找到模型名，这一格得你填", vars: [], tone: "", source: "2026-09-02 arron 定的 AI 辅助添加模型" },
  "model_configuration.assist.nothing": { id: "model_configuration.assist.nothing", domain: "model_configuration", text: "这段我没看懂，你手填吧", vars: [], tone: "", source: "2026-09-02 arron 定的 AI 辅助添加模型" },
  "model_configuration.assist.reasoning": { id: "model_configuration.assist.reasoning", domain: "model_configuration", text: "看着支持思考模式，我给你勾上了", vars: [], tone: "", source: "2026-09-02 arron 定的 AI 辅助添加模型" },
  "model_configuration.assist.secret_seen": { id: "model_configuration.assist.secret_seen", domain: "model_configuration", text: "这段里有一把真的密钥，我没留下它。你自己贴到下面「密钥」那一格", vars: [], tone: "", source: "2026-09-02 arron 定的 AI 辅助添加模型" },
  "model_configuration.assist.unknown_provider": { id: "model_configuration.assist.unknown_provider", domain: "model_configuration", text: "这家我没见过，先按「自定义」放着——地址和模型名填好了就一样能用", vars: [], tone: "", source: "2026-09-02 arron 定的 AI 辅助添加模型" },
  "model_configuration.avatar_select_aria": { id: "model_configuration.avatar_select_aria", domain: "model_configuration", text: "选择{avatar}头像", vars: ["avatar"], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.binding_picker_add_select": { id: "model_configuration.binding_picker_add_select", domain: "model_configuration", text: "接入并选择", vars: [], tone: "", source: "2026-08-29 Agent 与系统模型来源选择" },
  "model_configuration.binding_picker_catalog_hint": { id: "model_configuration.binding_picker_catalog_hint", domain: "model_configuration", text: "选择后会使用当前连接真实测试，成功才会绑定。", vars: [], tone: "", source: "2026-08-29 Key 驱动模型发现修正" },
  "model_configuration.binding_picker_configure_provider": { id: "model_configuration.binding_picker_configure_provider", domain: "model_configuration", text: "配置连接", vars: [], tone: "", source: "2026-08-29 Agent 与系统模型来源选择修正" },
  "model_configuration.binding_picker_connection_label": { id: "model_configuration.binding_picker_connection_label", domain: "model_configuration", text: "已配置连接", vars: [], tone: "", source: "2026-08-29 Agent 与系统模型来源选择修正" },
  "model_configuration.binding_picker_connection_placeholder": { id: "model_configuration.binding_picker_connection_placeholder", domain: "model_configuration", text: "选择一条已配置连接", vars: [], tone: "", source: "2026-08-29 Agent 与系统模型来源选择" },
  "model_configuration.binding_picker_connections": { id: "model_configuration.binding_picker_connections", domain: "model_configuration", text: "按服务商 / 连接", vars: [], tone: "", source: "2026-08-29 Agent 与系统模型来源选择修正" },
  "model_configuration.binding_picker_empty_connections": { id: "model_configuration.binding_picker_empty_connections", domain: "model_configuration", text: "还没有保存凭据的模型连接，请先去模型库添加。", vars: [], tone: "", source: "2026-08-29 Agent 与系统模型来源选择" },
  "model_configuration.binding_picker_empty_profiles": { id: "model_configuration.binding_picker_empty_profiles", domain: "model_configuration", text: "当前范围还没有已验证并启用的模型。", vars: [], tone: "", source: "2026-08-29 Agent 与系统模型来源选择" },
  "model_configuration.binding_picker_mode": { id: "model_configuration.binding_picker_mode", domain: "model_configuration", text: "模型选择方式", vars: [], tone: "", source: "2026-08-29 Agent 与系统模型来源选择" },
  "model_configuration.binding_picker_profiles": { id: "model_configuration.binding_picker_profiles", domain: "model_configuration", text: "已接入模型", vars: [], tone: "", source: "2026-08-29 Agent 与系统模型来源选择" },
  "model_configuration.binding_picker_provider_label": { id: "model_configuration.binding_picker_provider_label", domain: "model_configuration", text: "服务商", vars: [], tone: "", source: "2026-08-29 Agent 与系统模型来源选择修正" },
  "model_configuration.binding_picker_provider_placeholder": { id: "model_configuration.binding_picker_provider_placeholder", domain: "model_configuration", text: "选择服务商", vars: [], tone: "", source: "2026-08-29 Agent 与系统模型来源选择修正" },
  "model_configuration.binding_picker_provider_unconfigured": { id: "model_configuration.binding_picker_provider_unconfigured", domain: "model_configuration", text: "{provider} 还没有保存可用连接。", vars: ["provider"], tone: "", source: "2026-08-29 Agent 与系统模型来源选择修正" },
  "model_configuration.binding_picker_runtime_hint": { id: "model_configuration.binding_picker_runtime_hint", domain: "model_configuration", text: "只显示当前 Key 返回或验证可用的型号；服务商返回的高级配置会自动带入。", vars: [], tone: "", source: "2026-08-29 Key 驱动模型发现修正" },
  "model_configuration.binding_picker_select_existing": { id: "model_configuration.binding_picker_select_existing", domain: "model_configuration", text: "选择", vars: [], tone: "", source: "2026-08-29 Agent 与系统模型来源选择" },
  "model_configuration.binding_picker_supported_models": { id: "model_configuration.binding_picker_supported_models", domain: "model_configuration", text: "连接支持的型号", vars: [], tone: "", source: "2026-08-29 Agent 与系统模型来源选择" },
  "model_configuration.binding_picker_testing": { id: "model_configuration.binding_picker_testing", domain: "model_configuration", text: "正在测试", vars: [], tone: "", source: "2026-08-29 Agent 与系统模型来源选择" },
  "model_configuration.catalog_loaded": { id: "model_configuration.catalog_loaded", domain: "model_configuration", text: "此服务商不提供模型目录，请手动填写模型 ID，保存时会真实测试。", vars: [], tone: "", source: "2026-08-29 Key 驱动模型发现修正" },
  "model_configuration.choose_supported_model": { id: "model_configuration.choose_supported_model", domain: "model_configuration", text: "返回支持模型列表", vars: [], tone: "", source: "2026-08-28 添加模型选择语义修正" },
  "model_configuration.col_actions": { id: "model_configuration.col_actions", domain: "model_configuration", text: "操作", vars: [], tone: "", source: "2026-08-28 模型主列表设计" },
  "model_configuration.col_key": { id: "model_configuration.col_key", domain: "model_configuration", text: "API Key", vars: [], tone: "", source: "2026-08-28 模型主列表设计" },
  "model_configuration.col_model": { id: "model_configuration.col_model", domain: "model_configuration", text: "模型", vars: [], tone: "", source: "2026-08-28 模型主列表设计" },
  "model_configuration.col_provider": { id: "model_configuration.col_provider", domain: "model_configuration", text: "服务商", vars: [], tone: "", source: "2026-08-28 模型主列表设计" },
  "model_configuration.col_reasoning": { id: "model_configuration.col_reasoning", domain: "model_configuration", text: "推理", vars: [], tone: "", source: "2026-08-28 模型主列表设计" },
  "model_configuration.col_scope": { id: "model_configuration.col_scope", domain: "model_configuration", text: "范围", vars: [], tone: "", source: "2026-08-28 模型主列表设计" },
  "model_configuration.col_status": { id: "model_configuration.col_status", domain: "model_configuration", text: "状态", vars: [], tone: "", source: "2026-08-28 模型主列表设计" },
  "model_configuration.col_tokens": { id: "model_configuration.col_tokens", domain: "model_configuration", text: "最大输入", vars: [], tone: "", source: "2026-08-28 模型主列表设计" },
  "model_configuration.col_url": { id: "model_configuration.col_url", domain: "model_configuration", text: "接入地址", vars: [], tone: "", source: "2026-08-28 模型主列表设计" },
  "model_configuration.col_vision": { id: "model_configuration.col_vision", domain: "model_configuration", text: "视觉", vars: [], tone: "", source: "2026-08-28 模型主列表设计" },
  "model_configuration.configure_credential_action": { id: "model_configuration.configure_credential_action", domain: "model_configuration", text: "配置密钥", vars: [], tone: "", source: "2026-08-28 无密钥测试动作修正" },
  "model_configuration.connection_default_name": { id: "model_configuration.connection_default_name", domain: "model_configuration", text: "{provider} 连接", vars: ["provider"], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.connection_details_action": { id: "model_configuration.connection_details_action", domain: "model_configuration", text: "连接详情", vars: [], tone: "", source: "2026-08-28 平台与用户连接一致性修正" },
  "model_configuration.connection_failed": { id: "model_configuration.connection_failed", domain: "model_configuration", text: "没有连通。请检查 API URL、Key、额度和服务商权限后重试。", vars: [], tone: "", source: "2026-08-28 模型接入错误设计" },
  "model_configuration.connection_key_required_for_discovery": { id: "model_configuration.connection_key_required_for_discovery", domain: "model_configuration", text: "先保存该连接的 API Key，才能读取支持模型。", vars: [], tone: "", source: "2026-08-28 添加模型选择语义修正" },
  "model_configuration.connection_ready": { id: "model_configuration.connection_ready", domain: "model_configuration", text: "当前 Key 已验证，可以选择返回的模型。", vars: [], tone: "", source: "2026-08-29 Key 驱动模型发现修正" },
  "model_configuration.connection_settings_action": { id: "model_configuration.connection_settings_action", domain: "model_configuration", text: "连接与密钥", vars: [], tone: "", source: "2026-08-28 模型库编辑入口修正" },
  "model_configuration.connection_shared_notice": { id: "model_configuration.connection_shared_notice", domain: "model_configuration", text: "API URL 与 Key 属于这条服务商连接；保存后会同时影响该连接下的 {count} 个模型。", vars: ["count"], tone: "", source: "2026-08-28 连接影响面设计" },
  "model_configuration.credential_configured": { id: "model_configuration.credential_configured", domain: "model_configuration", text: "{mask} · 已配置", vars: ["mask"], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.credential_configured_at": { id: "model_configuration.credential_configured_at", domain: "model_configuration", text: "{mask} · 已配置 · {time} 更新", vars: ["mask", "time"], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.credential_first_save_hint": { id: "model_configuration.credential_first_save_hint", domain: "model_configuration", text: "请输入 API Key。保存后只显示配置状态，不回显密钥。", vars: [], tone: "", source: "2026-08-28 平台连接可配置语义修正" },
  "model_configuration.credential_rotation_hint": { id: "model_configuration.credential_rotation_hint", domain: "model_configuration", text: "当前 {mask}；输入新值后旧密钥将被撤销。", vars: ["mask"], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.custom_access": { id: "model_configuration.custom_access", domain: "model_configuration", text: "自定义接入", vars: [], tone: "", source: "2026-08-28 模型接入抽屉设计" },
  "model_configuration.delete_model": { id: "model_configuration.delete_model", domain: "model_configuration", text: "删除", vars: [], tone: "", source: "2026-08-28 模型主列表设计" },
  "model_configuration.description_label": { id: "model_configuration.description_label", domain: "model_configuration", text: "描述", vars: [], tone: "", source: "2026-08-28 模型编辑设计" },
  "model_configuration.direct_connections_advanced": { id: "model_configuration.direct_connections_advanced", domain: "model_configuration", text: "高级：直连单个服务商", vars: [], tone: "", source: "2026-08-28 LiteLLM 统一网关产品决策" },
  "model_configuration.direct_connections_hint": { id: "model_configuration.direct_connections_hint", domain: "model_configuration", text: "仅为现有直连配置保留。新增多家模型时优先使用 LiteLLM 统一网关。", vars: [], tone: "", source: "2026-08-28 LiteLLM 统一网关产品决策" },
  "model_configuration.disable_model": { id: "model_configuration.disable_model", domain: "model_configuration", text: "停用", vars: [], tone: "", source: "2026-08-28 模型主列表设计" },
  "model_configuration.discovery_empty": { id: "model_configuration.discovery_empty", domain: "model_configuration", text: "服务商没有返回模型列表。可以切换到自定义接入手动填写模型 ID。", vars: [], tone: "", source: "2026-08-28 模型发现空态设计" },
  "model_configuration.discovery_manual_only_hint": { id: "model_configuration.discovery_manual_only_hint", domain: "model_configuration", text: "该服务商暂不支持自动读取模型，可手动输入模型 ID。", vars: [], tone: "", source: "2026-08-28 添加模型选择语义修正" },
  "model_configuration.discovery_metadata_hint": { id: "model_configuration.discovery_metadata_hint", domain: "model_configuration", text: "服务商返回的长度与能力已自动带入；未返回的项目保持未设置，可手动补充。", vars: [], tone: "", source: "2026-08-29 模型高级配置自动回填" },
  "model_configuration.discovery_not_supported": { id: "model_configuration.discovery_not_supported", domain: "model_configuration", text: "该服务商不提供模型目录，请手动填写模型 ID。", vars: [], tone: "", source: "2026-08-28 模型发现降级设计" },
  "model_configuration.display_name_label": { id: "model_configuration.display_name_label", domain: "model_configuration", text: "模型展示名称", vars: [], tone: "", source: "2026-08-28 自定义模型设计" },
  "model_configuration.edit_model": { id: "model_configuration.edit_model", domain: "model_configuration", text: "编辑", vars: [], tone: "", source: "2026-08-28 模型主列表设计" },
  "model_configuration.edit_model_information": { id: "model_configuration.edit_model_information", domain: "model_configuration", text: "编辑模型信息", vars: [], tone: "", source: "2026-08-28 模型编辑抽屉设计" },
  "model_configuration.empty_model_library": { id: "model_configuration.empty_model_library", domain: "model_configuration", text: "还没有接入模型", vars: [], tone: "", source: "2026-08-28 模型主列表空态设计" },
  "model_configuration.empty_model_library_hint": { id: "model_configuration.empty_model_library_hint", domain: "model_configuration", text: "选择服务商并验证 Key，或直接接入一个 OpenAI-compatible / Anthropic API。", vars: [], tone: "", source: "2026-08-28 模型主列表空态设计" },
  "model_configuration.enable_model": { id: "model_configuration.enable_model", domain: "model_configuration", text: "启用", vars: [], tone: "", source: "2026-08-28 模型主列表设计" },
  "model_configuration.explicit_model": { id: "model_configuration.explicit_model", domain: "model_configuration", text: "显式模型 · {model}", vars: ["model"], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.failure_auth": { id: "model_configuration.failure_auth", domain: "model_configuration", text: "API Key 无效或没有该模型权限", vars: [], tone: "", source: "2026-08-28 模型测试失败分类" },
  "model_configuration.failure_incompatible": { id: "model_configuration.failure_incompatible", domain: "model_configuration", text: "服务商响应与当前协议不兼容", vars: [], tone: "", source: "2026-08-28 模型测试失败分类" },
  "model_configuration.failure_model_not_found": { id: "model_configuration.failure_model_not_found", domain: "model_configuration", text: "模型 ID 不存在或当前账户不可用", vars: [], tone: "", source: "2026-08-28 模型测试失败分类" },
  "model_configuration.failure_network": { id: "model_configuration.failure_network", domain: "model_configuration", text: "API URL 无法连通", vars: [], tone: "", source: "2026-08-28 模型测试失败分类" },
  "model_configuration.failure_quota_exhausted": { id: "model_configuration.failure_quota_exhausted", domain: "model_configuration", text: "服务商额度不足，请补充额度后重新测试", vars: [], tone: "", source: "2026-08-28 模型测试失败分类" },
  "model_configuration.failure_rate_limited": { id: "model_configuration.failure_rate_limited", domain: "model_configuration", text: "服务商正在限流，请稍后重新测试", vars: [], tone: "", source: "2026-08-28 模型测试失败分类" },
  "model_configuration.fetch_models": { id: "model_configuration.fetch_models", domain: "model_configuration", text: "使用当前 Key 读取可用模型", vars: [], tone: "", source: "2026-08-29 Key 驱动模型发现修正" },
  "model_configuration.fetch_models_again": { id: "model_configuration.fetch_models_again", domain: "model_configuration", text: "用当前 Key 重新读取", vars: [], tone: "", source: "2026-08-29 Key 驱动模型发现修正" },
  "model_configuration.filter_aria": { id: "model_configuration.filter_aria", domain: "model_configuration", text: "Agent {label}筛选", vars: ["label"], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.finish_agent_information": { id: "model_configuration.finish_agent_information", domain: "model_configuration", text: "完成信息修改", vars: [], tone: "", source: "2026-08-28 Agent 设置抽屉设计" },
  "model_configuration.form_required": { id: "model_configuration.form_required", domain: "model_configuration", text: "请先补全必填项。", vars: [], tone: "", source: "2026-08-28 模型接入表单错误设计" },
  "model_configuration.gateway_address": { id: "model_configuration.gateway_address", domain: "model_configuration", text: "LiteLLM 网关地址", vars: [], tone: "", source: "2026-08-28 LiteLLM 统一网关产品决策" },
  "model_configuration.gateway_key": { id: "model_configuration.gateway_key", domain: "model_configuration", text: "LiteLLM 网关 Key", vars: [], tone: "", source: "2026-08-28 LiteLLM 统一网关产品决策" },
  "model_configuration.gateway_key_rotation": { id: "model_configuration.gateway_key_rotation", domain: "model_configuration", text: "替换 LiteLLM 网关 Key（可选）", vars: [], tone: "", source: "2026-08-28 LiteLLM 统一网关产品决策" },
  "model_configuration.gateway_model_source": { id: "model_configuration.gateway_model_source", domain: "model_configuration", text: "LiteLLM 返回来源：{source}", vars: ["source"], tone: "", source: "2026-08-28 LiteLLM 统一网关产品决策" },
  "model_configuration.gateway_models_empty": { id: "model_configuration.gateway_models_empty", domain: "model_configuration", text: "网关已连通，但没有返回可用模型。请先在 LiteLLM 中配置模型。", vars: [], tone: "", source: "2026-08-28 LiteLLM 统一网关产品决策" },
  "model_configuration.gateway_models_loading": { id: "model_configuration.gateway_models_loading", domain: "model_configuration", text: "正在从 LiteLLM 读取可用模型…", vars: [], tone: "", source: "2026-08-28 LiteLLM 统一网关产品决策" },
  "model_configuration.gateway_recommended": { id: "model_configuration.gateway_recommended", domain: "model_configuration", text: "推荐", vars: [], tone: "", source: "2026-08-28 LiteLLM 统一网关产品决策" },
  "model_configuration.gateway_summary": { id: "model_configuration.gateway_summary", domain: "model_configuration", text: "一个网关统一管理多家服务商和全部模型，NPC 只保存网关地址与密钥。", vars: [], tone: "", source: "2026-08-28 LiteLLM 统一网关产品决策" },
  "model_configuration.impact_agents": { id: "model_configuration.impact_agents", domain: "model_configuration", text: "Agent：", vars: [], tone: "", source: "2026-08-28 模型影响拦截设计" },
  "model_configuration.impact_blocked": { id: "model_configuration.impact_blocked", domain: "model_configuration", text: "请先替换受影响绑定或明确暂停，再执行此操作。", vars: [], tone: "", source: "2026-08-28 模型影响拦截设计" },
  "model_configuration.impact_clear": { id: "model_configuration.impact_clear", domain: "model_configuration", text: "没有系统模块或 Agent 使用这个模型，可以直接操作。", vars: [], tone: "", source: "2026-08-29 零引用模型删除语义" },
  "model_configuration.impact_description": { id: "model_configuration.impact_description", domain: "model_configuration", text: "停用或删除前先检查系统模型与长期 Agent 的实际绑定。", vars: [], tone: "", source: "2026-08-28 模型影响拦截设计" },
  "model_configuration.impact_loading": { id: "model_configuration.impact_loading", domain: "model_configuration", text: "正在检查影响范围…", vars: [], tone: "", source: "2026-08-28 模型影响拦截设计" },
  "model_configuration.impact_system_bindings": { id: "model_configuration.impact_system_bindings", domain: "model_configuration", text: "系统模块：", vars: [], tone: "", source: "2026-08-28 模型影响拦截设计" },
  "model_configuration.load_catalog_models": { id: "model_configuration.load_catalog_models", domain: "model_configuration", text: "使用当前 Key 检查支持型号", vars: [], tone: "", source: "2026-08-29 Key 驱动模型发现修正" },
  "model_configuration.load_supported_models": { id: "model_configuration.load_supported_models", domain: "model_configuration", text: "读取支持模型", vars: [], tone: "", source: "2026-08-28 添加模型选择语义修正" },
  "model_configuration.manual_model_toggle": { id: "model_configuration.manual_model_toggle", domain: "model_configuration", text: "手动输入模型 ID", vars: [], tone: "", source: "2026-08-28 添加模型选择语义修正" },
  "model_configuration.max_input_label": { id: "model_configuration.max_input_label", domain: "model_configuration", text: "最大输入长度", vars: [], tone: "", source: "2026-08-28 自定义模型设计" },
  "model_configuration.max_output_label": { id: "model_configuration.max_output_label", domain: "model_configuration", text: "最大回复长度", vars: [], tone: "", source: "2026-08-28 自定义模型设计" },
  "model_configuration.model_connection_settings_hint": { id: "model_configuration.model_connection_settings_hint", domain: "model_configuration", text: "Endpoint 和 API Key 由服务商连接统一管理。密钥只能替换，不会回显。", vars: [], tone: "", source: "2026-08-28 模型库编辑入口修正" },
  "model_configuration.model_count": { id: "model_configuration.model_count", domain: "model_configuration", text: "{count} 个模型", vars: ["count"], tone: "", source: "2026-08-28 模型主列表设计" },
  "model_configuration.model_edit_action": { id: "model_configuration.model_edit_action", domain: "model_configuration", text: "编辑模型", vars: [], tone: "", source: "2026-08-28 模型库编辑入口修正" },
  "model_configuration.model_id_label": { id: "model_configuration.model_id_label", domain: "model_configuration", text: "模型 ID", vars: [], tone: "", source: "2026-08-28 自定义模型设计" },
  "model_configuration.model_library_subtitle": { id: "model_configuration.model_library_subtitle", domain: "model_configuration", text: "统一管理 NPC 全部 AI 功能与 Agent 可用的模型。", vars: [], tone: "", source: "2026-08-28 模型主列表设计" },
  "model_configuration.model_library_title": { id: "model_configuration.model_library_title", domain: "model_configuration", text: "模型库", vars: [], tone: "", source: "2026-08-28 模型主列表设计" },
  "model_configuration.model_list_heading": { id: "model_configuration.model_list_heading", domain: "model_configuration", text: "已接入模型", vars: [], tone: "", source: "2026-08-28 模型主列表设计" },
  "model_configuration.model_saved_test_failed": { id: "model_configuration.model_saved_test_failed", domain: "model_configuration", text: "模型已保存，但真实测试没有通过；当前不会出现在 Agent 可选模型中。", vars: [], tone: "", source: "2026-08-28 模型测试错误设计" },
  "model_configuration.modify_agent_information": { id: "model_configuration.modify_agent_information", domain: "model_configuration", text: "修改 Agent 信息", vars: [], tone: "", source: "2026-08-28 Agent 设置抽屉设计" },
  "model_configuration.module_default_model_aria": { id: "model_configuration.module_default_model_aria", domain: "model_configuration", text: "{module}默认模型", vars: ["module"], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.no_value": { id: "model_configuration.no_value", domain: "model_configuration", text: "未声明", vars: [], tone: "", source: "2026-08-28 模型能力状态设计" },
  "model_configuration.open_connection_settings": { id: "model_configuration.open_connection_settings", domain: "model_configuration", text: "打开连接设置", vars: [], tone: "", source: "2026-08-28 模型库编辑入口修正" },
  "model_configuration.platform_auto_detected": { id: "model_configuration.platform_auto_detected", domain: "model_configuration", text: "平台自动检测", vars: [], tone: "", source: "Platform-managed model availability contract" },
  "model_configuration.platform_connection_hint": { id: "model_configuration.platform_connection_hint", domain: "model_configuration", text: "平台提供初始连接；你可以替换 Endpoint 与 API Key，并执行真实测试。Key 只保存，不会回显。", vars: [], tone: "", source: "2026-08-28 平台连接可配置语义修正" },
  "model_configuration.platform_credential_label": { id: "model_configuration.platform_credential_label", domain: "model_configuration", text: "凭据归属", vars: [], tone: "", source: "2026-08-28 平台与用户连接一致性修正" },
  "model_configuration.platform_credential_summary": { id: "model_configuration.platform_credential_summary", domain: "model_configuration", text: "平台初始凭据不回显 · 保存你的 Key 后可测试", vars: [], tone: "", source: "2026-08-28 平台连接可配置语义修正" },
  "model_configuration.platform_managed": { id: "model_configuration.platform_managed", domain: "model_configuration", text: "平台托管", vars: [], tone: "", source: "2026-08-28 平台模型来源澄清" },
  "model_configuration.platform_model_hint": { id: "model_configuration.platform_model_hint", domain: "model_configuration", text: "平台预置模型", vars: [], tone: "", source: "2026-08-28 平台连接可配置语义修正" },
  "model_configuration.platform_name_hint": { id: "model_configuration.platform_name_hint", domain: "model_configuration", text: "平台来源名称固定，Endpoint 与 API Key 可以修改。", vars: [], tone: "", source: "2026-08-28 平台连接可配置语义修正" },
  "model_configuration.platform_status_sync": { id: "model_configuration.platform_status_sync", domain: "model_configuration", text: "尚未保存用户凭据", vars: [], tone: "", source: "2026-08-28 平台连接可配置语义修正" },
  "model_configuration.project_scope": { id: "model_configuration.project_scope", domain: "model_configuration", text: "项目级", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.project_scope_named": { id: "model_configuration.project_scope_named", domain: "model_configuration", text: "项目级 · {project}", vars: ["project"], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.protocol_label": { id: "model_configuration.protocol_label", domain: "model_configuration", text: "模型协议", vars: [], tone: "", source: "2026-08-28 自定义模型设计" },
  "model_configuration.provider_access": { id: "model_configuration.provider_access", domain: "model_configuration", text: "服务商接入", vars: [], tone: "", source: "2026-08-28 模型接入抽屉设计" },
  "model_configuration.provider_label": { id: "model_configuration.provider_label", domain: "model_configuration", text: "服务商", vars: [], tone: "", source: "2026-08-28 模型接入抽屉设计" },
  "model_configuration.reasoning_capability_label": { id: "model_configuration.reasoning_capability_label", domain: "model_configuration", text: "支持推理", vars: [], tone: "", source: "2026-08-29 模型推理策略设计" },
  "model_configuration.reasoning_default_hint": { id: "model_configuration.reasoning_default_hint", domain: "model_configuration", text: "开启后，NPC 使用此模型时会请求服务商启用推理模式。", vars: [], tone: "", source: "2026-08-29 模型推理策略设计" },
  "model_configuration.reasoning_default_label": { id: "model_configuration.reasoning_default_label", domain: "model_configuration", text: "默认开启推理", vars: [], tone: "", source: "2026-08-29 模型推理策略设计" },
  "model_configuration.reasoning_label": { id: "model_configuration.reasoning_label", domain: "model_configuration", text: "推理", vars: [], tone: "", source: "2026-08-28 模型能力设计" },
  "model_configuration.reasoning_unsupported_hint": { id: "model_configuration.reasoning_unsupported_hint", domain: "model_configuration", text: "先确认此模型支持推理，才能设置默认开关。", vars: [], tone: "", source: "2026-08-29 模型推理策略设计" },
  "model_configuration.refresh_supported_models": { id: "model_configuration.refresh_supported_models", domain: "model_configuration", text: "刷新支持模型", vars: [], tone: "", source: "2026-08-28 添加模型选择语义修正" },
  "model_configuration.reload_catalog_models": { id: "model_configuration.reload_catalog_models", domain: "model_configuration", text: "用当前 Key 重新检查", vars: [], tone: "", source: "2026-08-29 Key 驱动模型发现修正" },
  "model_configuration.required_fields": { id: "model_configuration.required_fields", domain: "model_configuration", text: "请填写连接名称、地址和密钥。", vars: [], tone: "", source: "2026-08-28 表单错误反馈修正" },
  "model_configuration.retire_no_replacement": { id: "model_configuration.retire_no_replacement", domain: "model_configuration", text: "当前范围没有可用的替代模型，可先添加模型或选择明确暂停。", vars: [], tone: "", source: "Model library atomic retirement flow" },
  "model_configuration.retire_pause": { id: "model_configuration.retire_pause", domain: "model_configuration", text: "明确暂停", vars: [], tone: "", source: "Model library atomic retirement flow" },
  "model_configuration.retire_pause_hint": { id: "model_configuration.retire_pause_hint", domain: "model_configuration", text: "暂停相关系统模块和显式绑定的 Agent，不会静默切换模型。", vars: [], tone: "", source: "Model library atomic retirement flow" },
  "model_configuration.retire_replace": { id: "model_configuration.retire_replace", domain: "model_configuration", text: "替换为其他模型", vars: [], tone: "", source: "Model library atomic retirement flow" },
  "model_configuration.retire_replace_hint": { id: "model_configuration.retire_replace_hint", domain: "model_configuration", text: "系统默认与 Agent 绑定在同一次操作中切换，不会出现中间失效状态。", vars: [], tone: "", source: "Model library atomic retirement flow" },
  "model_configuration.retire_replacement_label": { id: "model_configuration.retire_replacement_label", domain: "model_configuration", text: "替代模型", vars: [], tone: "", source: "Model library atomic retirement flow" },
  "model_configuration.retire_replacement_placeholder": { id: "model_configuration.retire_replacement_placeholder", domain: "model_configuration", text: "选择已验证且已启用的模型", vars: [], tone: "", source: "Model library atomic retirement flow" },
  "model_configuration.retire_strategy": { id: "model_configuration.retire_strategy", domain: "model_configuration", text: "处理受影响的绑定", vars: [], tone: "", source: "Model library atomic retirement flow" },
  "model_configuration.save_and_test": { id: "model_configuration.save_and_test", domain: "model_configuration", text: "保存并测试", vars: [], tone: "", source: "2026-08-28 平台连接可配置语义修正" },
  "model_configuration.save_and_test_model": { id: "model_configuration.save_and_test_model", domain: "model_configuration", text: "保存并测试", vars: [], tone: "", source: "2026-08-28 模型编辑抽屉设计" },
  "model_configuration.scope_account": { id: "model_configuration.scope_account", domain: "model_configuration", text: "账户级", vars: [], tone: "", source: "2026-08-28 模型范围设计" },
  "model_configuration.scope_project": { id: "model_configuration.scope_project", domain: "model_configuration", text: "项目级", vars: [], tone: "", source: "2026-08-28 模型范围设计" },
  "model_configuration.select_model_label": { id: "model_configuration.select_model_label", domain: "model_configuration", text: "选择模型", vars: [], tone: "", source: "2026-08-28 模型接入抽屉设计" },
  "model_configuration.speech_not_testable": { id: "model_configuration.speech_not_testable", domain: "model_configuration", text: "语音连接不走 Chat 测试", vars: [], tone: "", source: "2026-08-29 模型库增加 openspeech Seed ASR 占位" },
  "model_configuration.status_available": { id: "model_configuration.status_available", domain: "model_configuration", text: "可用", vars: [], tone: "", source: "2026-08-28 模型状态设计" },
  "model_configuration.status_disabled": { id: "model_configuration.status_disabled", domain: "model_configuration", text: "已停用", vars: [], tone: "", source: "2026-08-28 模型状态设计" },
  "model_configuration.status_quota_exhausted": { id: "model_configuration.status_quota_exhausted", domain: "model_configuration", text: "额度不足", vars: [], tone: "", source: "2026-08-28 模型状态设计" },
  "model_configuration.status_rate_limited": { id: "model_configuration.status_rate_limited", domain: "model_configuration", text: "限流", vars: [], tone: "", source: "2026-08-28 模型状态设计" },
  "model_configuration.status_unavailable": { id: "model_configuration.status_unavailable", domain: "model_configuration", text: "不可用", vars: [], tone: "", source: "2026-08-28 模型状态设计" },
  "model_configuration.status_unverified": { id: "model_configuration.status_unverified", domain: "model_configuration", text: "未验证", vars: [], tone: "", source: "2026-08-28 模型状态设计" },
  "model_configuration.supported_model_hint": { id: "model_configuration.supported_model_hint", domain: "model_configuration", text: "从该连接读取支持的模型，再从下拉列表选择。", vars: [], tone: "", source: "2026-08-28 添加模型选择语义修正" },
  "model_configuration.supported_model_label": { id: "model_configuration.supported_model_label", domain: "model_configuration", text: "支持的模型", vars: [], tone: "", source: "2026-08-28 添加模型选择语义修正" },
  "model_configuration.supported_model_placeholder": { id: "model_configuration.supported_model_placeholder", domain: "model_configuration", text: "请选择模型", vars: [], tone: "", source: "2026-08-28 添加模型选择语义修正" },
  "model_configuration.system_default_model": { id: "model_configuration.system_default_model", domain: "model_configuration", text: "跟随系统默认 · {module}", vars: ["module"], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.test_failed_keep_editing": { id: "model_configuration.test_failed_keep_editing", domain: "model_configuration", text: "测试未通过。请检查 Endpoint、API Key、额度或网络后重试。已保存的密钥不会回显。", vars: [], tone: "", source: "2026-08-28 平台连接可配置语义修正" },
  "model_configuration.test_model": { id: "model_configuration.test_model", domain: "model_configuration", text: "测试", vars: [], tone: "", source: "2026-08-28 模型主列表设计" },
  "model_configuration.testing_model": { id: "model_configuration.testing_model", domain: "model_configuration", text: "测试中…", vars: [], tone: "", source: "2026-08-28 模型主列表设计" },
  "model_configuration.ui_001": { id: "model_configuration.ui_001", domain: "model_configuration", text: "具名协作成员", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_002": { id: "model_configuration.ui_002", domain: "model_configuration", text: "系统模型", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_003": { id: "model_configuration.ui_003", domain: "model_configuration", text: "NPC 功能默认", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_004": { id: "model_configuration.ui_004", domain: "model_configuration", text: "模型库 / 连接", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_005": { id: "model_configuration.ui_005", domain: "model_configuration", text: "统一能力来源", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_006": { id: "model_configuration.ui_006", domain: "model_configuration", text: "AI 团队配置", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_007": { id: "model_configuration.ui_007", domain: "model_configuration", text: "模型库", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_008": { id: "model_configuration.ui_008", domain: "model_configuration", text: "连接负责服务商、协议和密钥；模型档案才是系统模块与 Agent 可选择的能力来源。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_009": { id: "model_configuration.ui_009", domain: "model_configuration", text: "模型范围", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_010": { id: "model_configuration.ui_010", domain: "model_configuration", text: "模型库范围", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_011": { id: "model_configuration.ui_011", domain: "model_configuration", text: "账户级模型", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_012": { id: "model_configuration.ui_012", domain: "model_configuration", text: "· 项目可用", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_013": { id: "model_configuration.ui_013", domain: "model_configuration", text: "添加连接", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_014": { id: "model_configuration.ui_014", domain: "model_configuration", text: "完成验证后返回原配置页，原表单草稿不会由模型库覆盖。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_015": { id: "model_configuration.ui_015", domain: "model_configuration", text: "连接", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_016": { id: "model_configuration.ui_016", domain: "model_configuration", text: "模型", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_017": { id: "model_configuration.ui_017", domain: "model_configuration", text: "可用于 Agent", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_018": { id: "model_configuration.ui_018", domain: "model_configuration", text: "需处理", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_019": { id: "model_configuration.ui_019", domain: "model_configuration", text: "账户连接、密钥与账户级模型仅账户管理员可修改。选择一个项目后，项目维护者可以基于现有连接添加项目可用模型。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_020": { id: "model_configuration.ui_020", domain: "model_configuration", text: "服务商连接与模型", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_021": { id: "model_configuration.ui_021", domain: "model_configuration", text: "添加服务商连接", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_022": { id: "model_configuration.ui_022", domain: "model_configuration", text: "验证密钥", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_023": { id: "model_configuration.ui_023", domain: "model_configuration", text: "发现或添加模型", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_024": { id: "model_configuration.ui_024", domain: "model_configuration", text: "选择可用模型", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_025": { id: "model_configuration.ui_025", domain: "model_configuration", text: "从一条真实连接开始", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_026": { id: "model_configuration.ui_026", domain: "model_configuration", text: "添加服务商连接，验证密钥，再发现或手动添加多个模型。密钥保存后只显示配置状态，不会再次回显。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_027": { id: "model_configuration.ui_027", domain: "model_configuration", text: "添加第一个连接", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_028": { id: "model_configuration.ui_028", domain: "model_configuration", text: "需要账户管理员先建立连接。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_029": { id: "model_configuration.ui_029", domain: "model_configuration", text: "返回原配置", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_030": { id: "model_configuration.ui_030", domain: "model_configuration", text: "未保存密钥", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_031": { id: "model_configuration.ui_031", domain: "model_configuration", text: "测试连接", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_032": { id: "model_configuration.ui_032", domain: "model_configuration", text: "编辑", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_033": { id: "model_configuration.ui_033", domain: "model_configuration", text: "删除", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_034": { id: "model_configuration.ui_034", domain: "model_configuration", text: "禁用", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_035": { id: "model_configuration.ui_035", domain: "model_configuration", text: "只读连接", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_036": { id: "model_configuration.ui_036", domain: "model_configuration", text: "操作未完成。若模型仍被系统模块或 Agent 使用，请先替换或明确暂停。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_037": { id: "model_configuration.ui_037", domain: "model_configuration", text: "模型档案", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_038": { id: "model_configuration.ui_038", domain: "model_configuration", text: "添加模型", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_039": { id: "model_configuration.ui_039", domain: "model_configuration", text: "这条连接在当前范围还没有模型。添加并单独测试后，才会进入 Agent 与系统模型选择器。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_040": { id: "model_configuration.ui_040", domain: "model_configuration", text: "禁用会让此连接下的模型停止进入新选择器；仍有依赖时服务端会拒绝。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_041": { id: "model_configuration.ui_041", domain: "model_configuration", text: "只有连接下没有任何模型档案时才能删除；凭据将从 Vault 撤销。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_042": { id: "model_configuration.ui_042", domain: "model_configuration", text: "取消", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_043": { id: "model_configuration.ui_043", domain: "model_configuration", text: "处理中", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_044": { id: "model_configuration.ui_044", domain: "model_configuration", text: "确认", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_045": { id: "model_configuration.ui_045", domain: "model_configuration", text: "先处理并删除这条连接下的", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_046": { id: "model_configuration.ui_046", domain: "model_configuration", text: "个模型档案。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_047": { id: "model_configuration.ui_047", domain: "model_configuration", text: "项目模型", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_048": { id: "model_configuration.ui_048", domain: "model_configuration", text: "账户模型", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_049": { id: "model_configuration.ui_049", domain: "model_configuration", text: "重新测试", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_050": { id: "model_configuration.ui_050", domain: "model_configuration", text: "测试模型", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_051": { id: "model_configuration.ui_051", domain: "model_configuration", text: "只读", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_052": { id: "model_configuration.ui_052", domain: "model_configuration", text: "测试失败。状态已按认证、限流、额度或连通性分类，密钥与上游响应不会显示。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_053": { id: "model_configuration.ui_053", domain: "model_configuration", text: "添加模型连接", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_054": { id: "model_configuration.ui_054", domain: "model_configuration", text: "服务商连接 → 验证密钥 → 发现或手动添加模型 → 单独测试模型", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_055": { id: "model_configuration.ui_055", domain: "model_configuration", text: "1 服务商", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_056": { id: "model_configuration.ui_056", domain: "model_configuration", text: "2 连接", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_057": { id: "model_configuration.ui_057", domain: "model_configuration", text: "3 验证", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_058": { id: "model_configuration.ui_058", domain: "model_configuration", text: "4 模型", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_059": { id: "model_configuration.ui_059", domain: "model_configuration", text: "支持真实测试", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_060": { id: "model_configuration.ui_060", domain: "model_configuration", text: "需适配器 · 不会伪造连通", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_061": { id: "model_configuration.ui_061", domain: "model_configuration", text: "可测试", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_062": { id: "model_configuration.ui_062", domain: "model_configuration", text: "需适配器", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_063": { id: "model_configuration.ui_063", domain: "model_configuration", text: "连接名称", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_064": { id: "model_configuration.ui_064", domain: "model_configuration", text: "协议", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_065": { id: "model_configuration.ui_065", domain: "model_configuration", text: "只提交到受控 Vault。保存后不会在页面、日志或接口响应中回显。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_066": { id: "model_configuration.ui_066", domain: "model_configuration", text: "此预设缺少专有认证适配器。可以保存配置，但测试与发现会明确阻止。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_067": { id: "model_configuration.ui_067", domain: "model_configuration", text: "连接保存失败。已输入内容仍保留，密钥不会被页面回显。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_068": { id: "model_configuration.ui_068", domain: "model_configuration", text: "返回", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_069": { id: "model_configuration.ui_069", domain: "model_configuration", text: "保存中", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_070": { id: "model_configuration.ui_070", domain: "model_configuration", text: "保存连接并继续", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_071": { id: "model_configuration.ui_071", domain: "model_configuration", text: "密钥已保存 · 待验证", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_072": { id: "model_configuration.ui_072", domain: "model_configuration", text: "配置已保存 · 需适配器", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_073": { id: "model_configuration.ui_073", domain: "model_configuration", text: "现在只验证连接与密钥，不依赖任何模型。验证通过后再发现或手动添加多个模型。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_074": { id: "model_configuration.ui_074", domain: "model_configuration", text: "当前预设没有可调用的专有认证适配器，系统不会执行假测试或生成假模型。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_075": { id: "model_configuration.ui_075", domain: "model_configuration", text: "连接验证失败。连接已保留为失败状态，可返回模型库编辑后重新测试；密钥和上游响应不会显示。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_076": { id: "model_configuration.ui_076", domain: "model_configuration", text: "完成保存", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_077": { id: "model_configuration.ui_077", domain: "model_configuration", text: "验证中", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_078": { id: "model_configuration.ui_078", domain: "model_configuration", text: "重新验证", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_079": { id: "model_configuration.ui_079", domain: "model_configuration", text: "连接与密钥已验证", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_080": { id: "model_configuration.ui_080", domain: "model_configuration", text: "接下来添加任意多个模型，并逐个执行真实最小测试。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_081": { id: "model_configuration.ui_081", domain: "model_configuration", text: "发现模型", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_082": { id: "model_configuration.ui_082", domain: "model_configuration", text: "发现中", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_083": { id: "model_configuration.ui_083", domain: "model_configuration", text: "该协议没有通用发现接口，请手动添加模型 ID。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_084": { id: "model_configuration.ui_084", domain: "model_configuration", text: "发现失败。连接状态已记录；你仍可手动添加，系统不会生成假模型列表。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_085": { id: "model_configuration.ui_085", domain: "model_configuration", text: "筛选模型 ID", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_086": { id: "model_configuration.ui_086", domain: "model_configuration", text: "已添加", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_087": { id: "model_configuration.ui_087", domain: "model_configuration", text: "添加", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_088": { id: "model_configuration.ui_088", domain: "model_configuration", text: "手动添加", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_089": { id: "model_configuration.ui_089", domain: "model_configuration", text: "模型 ID", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_090": { id: "model_configuration.ui_090", domain: "model_configuration", text: "例如 gpt-5.2", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_091": { id: "model_configuration.ui_091", domain: "model_configuration", text: "显示名称（可选）", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_092": { id: "model_configuration.ui_092", domain: "model_configuration", text: "模型添加失败，已输入内容仍保留。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_093": { id: "model_configuration.ui_093", domain: "model_configuration", text: "已添加 · 逐个验证", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_094": { id: "model_configuration.ui_094", domain: "model_configuration", text: "测试失败。已记录认证、限流、额度或连通性状态；密钥和上游响应不会显示。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_095": { id: "model_configuration.ui_095", domain: "model_configuration", text: "完成", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_096": { id: "model_configuration.ui_096", domain: "model_configuration", text: "添加到：", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_097": { id: "model_configuration.ui_097", domain: "model_configuration", text: "当前项目可用模型", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_098": { id: "model_configuration.ui_098", domain: "model_configuration", text: "添加失败，请检查权限与模型 ID 是否重复。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_099": { id: "model_configuration.ui_099", domain: "model_configuration", text: "留空 API Key 表示不轮换。现有密钥永不回显。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_100": { id: "model_configuration.ui_100", domain: "model_configuration", text: "轮换 API Key（可选）", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_101": { id: "model_configuration.ui_101", domain: "model_configuration", text: "保存失败，现有连接保持不变。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_102": { id: "model_configuration.ui_102", domain: "model_configuration", text: "保存", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_103": { id: "model_configuration.ui_103", domain: "model_configuration", text: "修改模型 ID 后会回到未验证状态，需重新测试。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_104": { id: "model_configuration.ui_104", domain: "model_configuration", text: "显示名称", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_105": { id: "model_configuration.ui_105", domain: "model_configuration", text: "保存失败，原配置未改变。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_106": { id: "model_configuration.ui_106", domain: "model_configuration", text: "系统会先检查系统模块与长期 Agent 依赖；不会静默切换或破坏现有配置。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_107": { id: "model_configuration.ui_107", domain: "model_configuration", text: "检查中", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_108": { id: "model_configuration.ui_108", domain: "model_configuration", text: "确认删除", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_109": { id: "model_configuration.ui_109", domain: "model_configuration", text: "确认禁用", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_110": { id: "model_configuration.ui_110", domain: "model_configuration", text: "正在检查影响范围…", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_111": { id: "model_configuration.ui_111", domain: "model_configuration", text: "系统模块", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_112": { id: "model_configuration.ui_112", domain: "model_configuration", text: "长期 Agent", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_113": { id: "model_configuration.ui_113", domain: "model_configuration", text: "先为受影响对象选择替代模型，或在系统模型页明确暂停。处理完成后再回来执行。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_114": { id: "model_configuration.ui_114", domain: "model_configuration", text: "处理系统模型", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_115": { id: "model_configuration.ui_115", domain: "model_configuration", text: "处理 Agent", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_116": { id: "model_configuration.ui_116", domain: "model_configuration", text: "当前没有活动依赖。历史会话和审计记录不会被删除。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_117": { id: "model_configuration.ui_117", domain: "model_configuration", text: "操作失败，原配置保持不变。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_118": { id: "model_configuration.ui_118", domain: "model_configuration", text: "关闭", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_119": { id: "model_configuration.ui_119", domain: "model_configuration", text: "Bedrock Converse · 旧适配器", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_120": { id: "model_configuration.ui_120", domain: "model_configuration", text: "已验证", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_121": { id: "model_configuration.ui_121", domain: "model_configuration", text: "连接失败", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_122": { id: "model_configuration.ui_122", domain: "model_configuration", text: "已禁用", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_123": { id: "model_configuration.ui_123", domain: "model_configuration", text: "未验证", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_124": { id: "model_configuration.ui_124", domain: "model_configuration", text: "可用", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_125": { id: "model_configuration.ui_125", domain: "model_configuration", text: "不可用", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_126": { id: "model_configuration.ui_126", domain: "model_configuration", text: "限流", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_127": { id: "model_configuration.ui_127", domain: "model_configuration", text: "额度不足", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_128": { id: "model_configuration.ui_128", domain: "model_configuration", text: "时间未知", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_129": { id: "model_configuration.ui_129", domain: "model_configuration", text: "翠绿", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_130": { id: "model_configuration.ui_130", domain: "model_configuration", text: "默认人物头像", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_131": { id: "model_configuration.ui_131", domain: "model_configuration", text: "紫罗兰", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_132": { id: "model_configuration.ui_132", domain: "model_configuration", text: "人物头像", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_133": { id: "model_configuration.ui_133", domain: "model_configuration", text: "琥珀", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_134": { id: "model_configuration.ui_134", domain: "model_configuration", text: "模型连接正常", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_135": { id: "model_configuration.ui_135", domain: "model_configuration", text: "模型尚未验证", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_136": { id: "model_configuration.ui_136", domain: "model_configuration", text: "模型当前不可用", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_137": { id: "model_configuration.ui_137", domain: "model_configuration", text: "模型正在限流", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_138": { id: "model_configuration.ui_138", domain: "model_configuration", text: "模型额度不足", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_139": { id: "model_configuration.ui_139", domain: "model_configuration", text: "模型已禁用", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_140": { id: "model_configuration.ui_140", domain: "model_configuration", text: "系统默认已保存但运行时待接线", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_141": { id: "model_configuration.ui_141", domain: "model_configuration", text: "模型未通过目录校验", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_142": { id: "model_configuration.ui_142", domain: "model_configuration", text: "尚未选择模型", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_143": { id: "model_configuration.ui_143", domain: "model_configuration", text: "模型状态未确认", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_144": { id: "model_configuration.ui_144", domain: "model_configuration", text: "Lulu 对话与推理", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_145": { id: "model_configuration.ui_145", domain: "model_configuration", text: "任务规划 / 拆解", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_146": { id: "model_configuration.ui_146", domain: "model_configuration", text: "开发任务编排", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_147": { id: "model_configuration.ui_147", domain: "model_configuration", text: "补丁生成", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_148": { id: "model_configuration.ui_148", domain: "model_configuration", text: "独立代码复核", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_149": { id: "model_configuration.ui_149", domain: "model_configuration", text: "账户级", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_150": { id: "model_configuration.ui_150", domain: "model_configuration", text: "AI 团队", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_151": { id: "model_configuration.ui_151", domain: "model_configuration", text: "配置长期 Agent 的身份、职责、模型和范围。运行情况与临时子 Agent 在 Lulu 工作板查看。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_152": { id: "model_configuration.ui_152", domain: "model_configuration", text: "添加 Agent", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_153": { id: "model_configuration.ui_153", domain: "model_configuration", text: "Agent 筛选", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_154": { id: "model_configuration.ui_154", domain: "model_configuration", text: "查找 Agent", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_155": { id: "model_configuration.ui_155", domain: "model_configuration", text: "按名称、职责或项目范围搜索", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_156": { id: "model_configuration.ui_156", domain: "model_configuration", text: "搜索 Agent", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_157": { id: "model_configuration.ui_157", domain: "model_configuration", text: "作用域", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_158": { id: "model_configuration.ui_158", domain: "model_configuration", text: "全部", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_159": { id: "model_configuration.ui_159", domain: "model_configuration", text: "项目级", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_160": { id: "model_configuration.ui_160", domain: "model_configuration", text: "筛选项目", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_161": { id: "model_configuration.ui_161", domain: "model_configuration", text: "所有可见项目", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_162": { id: "model_configuration.ui_162", domain: "model_configuration", text: "生命周期", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_163": { id: "model_configuration.ui_163", domain: "model_configuration", text: "已配置", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_164": { id: "model_configuration.ui_164", domain: "model_configuration", text: "已停用", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_165": { id: "model_configuration.ui_165", domain: "model_configuration", text: "当前为只读。账户级 Agent 由账户管理员维护，项目级 Agent 由项目维护者维护。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_166": { id: "model_configuration.ui_166", domain: "model_configuration", text: "已配置的 Agent", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_167": { id: "model_configuration.ui_167", domain: "model_configuration", text: "保留历史配置，不参与后续新分配", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_168": { id: "model_configuration.ui_168", domain: "model_configuration", text: "筛选结果仅来自你当前可见的 Agent 配置。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_169": { id: "model_configuration.ui_169", domain: "model_configuration", text: "先配置一位 Agent", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_170": { id: "model_configuration.ui_170", domain: "model_configuration", text: "先定义身份、职责、模型和工作范围；Lulu 再按这份配置组织协作。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_171": { id: "model_configuration.ui_171", domain: "model_configuration", text: "没有匹配的 Agent", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_172": { id: "model_configuration.ui_172", domain: "model_configuration", text: "清除筛选，或按当前需要新建一位 Agent。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_173": { id: "model_configuration.ui_173", domain: "model_configuration", text: "清除筛选", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_174": { id: "model_configuration.ui_174", domain: "model_configuration", text: "模型档案不可读", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_175": { id: "model_configuration.ui_175", domain: "model_configuration", text: "未填写职责", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_176": { id: "model_configuration.ui_176", domain: "model_configuration", text: "系统命名", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_177": { id: "model_configuration.ui_177", domain: "model_configuration", text: "可被 Lulu 调度", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_178": { id: "model_configuration.ui_178", domain: "model_configuration", text: "仅手动使用", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_179": { id: "model_configuration.ui_179", domain: "model_configuration", text: "停用", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_180": { id: "model_configuration.ui_180", domain: "model_configuration", text: "当前浏览器合同还没有重新启用接口，历史配置会保留。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_181": { id: "model_configuration.ui_181", domain: "model_configuration", text: "当前范围只读。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_182": { id: "model_configuration.ui_182", domain: "model_configuration", text: "名称", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_183": { id: "model_configuration.ui_183", domain: "model_configuration", text: "留空时按职责自动命名", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_184": { id: "model_configuration.ui_184", domain: "model_configuration", text: "Agent 名称", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_185": { id: "model_configuration.ui_185", domain: "model_configuration", text: "职责", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_186": { id: "model_configuration.ui_186", domain: "model_configuration", text: "例如：前端开发", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_187": { id: "model_configuration.ui_187", domain: "model_configuration", text: "Agent 职责", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_188": { id: "model_configuration.ui_188", domain: "model_configuration", text: "头像模板", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_189": { id: "model_configuration.ui_189", domain: "model_configuration", text: "模板 3：大头像只改变长期身份的头像引用，不改变模型或权限。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_190": { id: "model_configuration.ui_190", domain: "model_configuration", text: "模型来源", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_191": { id: "model_configuration.ui_191", domain: "model_configuration", text: "显式绑定模型", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_192": { id: "model_configuration.ui_192", domain: "model_configuration", text: "固定一份已验证档案", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_193": { id: "model_configuration.ui_193", domain: "model_configuration", text: "跟随系统默认", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_194": { id: "model_configuration.ui_194", domain: "model_configuration", text: "按模块继承账户 / 项目配置", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_195": { id: "model_configuration.ui_195", domain: "model_configuration", text: "当前统一凭据运行时尚未接线；保存后会明确显示“待接线”，不会伪装可运行。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_196": { id: "model_configuration.ui_196", domain: "model_configuration", text: "工作范围", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_197": { id: "model_configuration.ui_197", domain: "model_configuration", text: "。当前浏览器合同不支持编辑已有 Agent 的作用域；如需变更，请创建新的配置。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_198": { id: "model_configuration.ui_198", domain: "model_configuration", text: "Agent 工作范围", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_199": { id: "model_configuration.ui_199", domain: "model_configuration", text: "选择项目", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_200": { id: "model_configuration.ui_200", domain: "model_configuration", text: "Agent 项目范围", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_201": { id: "model_configuration.ui_201", domain: "model_configuration", text: "选择一个可见项目", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_202": { id: "model_configuration.ui_202", domain: "model_configuration", text: "职责说明", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_203": { id: "model_configuration.ui_203", domain: "model_configuration", text: "说明它负责什么、如何协作。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_204": { id: "model_configuration.ui_204", domain: "model_configuration", text: "Agent 职责说明", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_205": { id: "model_configuration.ui_205", domain: "model_configuration", text: "关闭后仍保留在 Agent 库，只能由你手动选择。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_206": { id: "model_configuration.ui_206", domain: "model_configuration", text: "允许 Lulu 调度", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_207": { id: "model_configuration.ui_207", domain: "model_configuration", text: "保存失败", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_208": { id: "model_configuration.ui_208", domain: "model_configuration", text: "，草稿和模型选择已保留。请检查配置后重试。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_209": { id: "model_configuration.ui_209", domain: "model_configuration", text: "保存配置", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_210": { id: "model_configuration.ui_210", domain: "model_configuration", text: "创建 Agent", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_211": { id: "model_configuration.ui_211", domain: "model_configuration", text: "新配置只用于之后的新工作；正在进行的会话保留旧 revision。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_212": { id: "model_configuration.ui_212", domain: "model_configuration", text: "先定义身份，再选择模型和范围。不会遮住或改写 Lulu 的当前会话。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_213": { id: "model_configuration.ui_213", domain: "model_configuration", text: "关闭 Agent 配置", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_214": { id: "model_configuration.ui_214", domain: "model_configuration", text: "模型配置", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_215": { id: "model_configuration.ui_215", domain: "model_configuration", text: "只列模型库中已验证且启用的档案；不会改变系统默认或会话单次模型。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_216": { id: "model_configuration.ui_216", domain: "model_configuration", text: "选择主模型", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_217": { id: "model_configuration.ui_217", domain: "model_configuration", text: "只列已验证且启用的模型", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_218": { id: "model_configuration.ui_218", domain: "model_configuration", text: "选择 Agent 模型", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_219": { id: "model_configuration.ui_219", domain: "model_configuration", text: "搜索连接、供应商或模型", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_220": { id: "model_configuration.ui_220", domain: "model_configuration", text: "搜索模型", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_221": { id: "model_configuration.ui_221", domain: "model_configuration", text: "正在读取模型配置…", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_222": { id: "model_configuration.ui_222", domain: "model_configuration", text: "无法读取模型候选", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_223": { id: "model_configuration.ui_223", domain: "model_configuration", text: "。请检查模型库。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_224": { id: "model_configuration.ui_224", domain: "model_configuration", text: "当前范围没有可用模型。先去模型库添加并验证。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_225": { id: "model_configuration.ui_225", domain: "model_configuration", text: "已选择", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_226": { id: "model_configuration.ui_226", domain: "model_configuration", text: "管理模型并保留草稿", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_227": { id: "model_configuration.ui_227", domain: "model_configuration", text: "停用后不再接收新的分配；已有会话、历史证据和正在进行的工作不会被删除或中断。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_228": { id: "model_configuration.ui_228", domain: "model_configuration", text: "停用中", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_229": { id: "model_configuration.ui_229", domain: "model_configuration", text: "确认停用", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_230": { id: "model_configuration.ui_230", domain: "model_configuration", text: "这是长期配置的生命周期变更，不代表取消或接管任何当前工作。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_231": { id: "model_configuration.ui_231", domain: "model_configuration", text: "停用失败，请重试。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_232": { id: "model_configuration.ui_232", domain: "model_configuration", text: "按 NPC 功能模块设置默认模型。这里不保存密钥，也不会把系统模块变成 Agent。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_233": { id: "model_configuration.ui_233", domain: "model_configuration", text: "配置范围", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_234": { id: "model_configuration.ui_234", domain: "model_configuration", text: "系统模型配置范围", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_235": { id: "model_configuration.ui_235", domain: "model_configuration", text: "账户默认", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_236": { id: "model_configuration.ui_236", domain: "model_configuration", text: "· 项目覆盖", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_237": { id: "model_configuration.ui_237", domain: "model_configuration", text: "优先级：本次消息模型 → Agent 显式绑定 → 项目覆盖 → 账户默认。会话单次选择只影响下一条推理，不修改此页或团队成员。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_238": { id: "model_configuration.ui_238", domain: "model_configuration", text: "当前范围为只读。账户默认由账户管理员维护；项目覆盖由项目维护者维护。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_239": { id: "model_configuration.ui_239", domain: "model_configuration", text: "还没有已验证并启用的模型", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_240": { id: "model_configuration.ui_240", domain: "model_configuration", text: "先在模型库完成连接、验证密钥并测试具体模型。返回后会保留当前范围。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_241": { id: "model_configuration.ui_241", domain: "model_configuration", text: "去添加模型", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_242": { id: "model_configuration.ui_242", domain: "model_configuration", text: "项目覆盖", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_243": { id: "model_configuration.ui_243", domain: "model_configuration", text: "当前模型已失效。请选择替代模型或明确暂停，系统不会静默切换。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_244": { id: "model_configuration.ui_244", domain: "model_configuration", text: "未启用", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_245": { id: "model_configuration.ui_245", domain: "model_configuration", text: "选择已验证模型", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_246": { id: "model_configuration.ui_246", domain: "model_configuration", text: "明确暂停", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_247": { id: "model_configuration.ui_247", domain: "model_configuration", text: "恢复账户默认", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_248": { id: "model_configuration.ui_248", domain: "model_configuration", text: "保存失败，原配置未被静默替换。请检查模型状态后重试。", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_249": { id: "model_configuration.ui_249", domain: "model_configuration", text: "已生效", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_250": { id: "model_configuration.ui_250", domain: "model_configuration", text: "已暂停", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_251": { id: "model_configuration.ui_251", domain: "model_configuration", text: "需要替换", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_252": { id: "model_configuration.ui_252", domain: "model_configuration", text: "已保存 · 待接线", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_253": { id: "model_configuration.ui_253", domain: "model_configuration", text: "未配置", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.ui_254": { id: "model_configuration.ui_254", domain: "model_configuration", text: "Lulu 自动安排", vars: [], tone: "", source: "Lulu V2 approved implementation UI" },
  "model_configuration.unknown_value": { id: "model_configuration.unknown_value", domain: "model_configuration", text: "未设置", vars: [], tone: "", source: "2026-08-28 模型能力状态设计" },
  "model_configuration.vision_label": { id: "model_configuration.vision_label", domain: "model_configuration", text: "图片理解", vars: [], tone: "", source: "2026-08-28 自定义模型设计" },
  "model_configuration.yes_value": { id: "model_configuration.yes_value", domain: "model_configuration", text: "支持", vars: [], tone: "", source: "2026-08-28 模型能力状态设计" },
  "model_library.add_connection": { id: "model_library.add_connection", domain: "model_library", text: "添加连接", vars: [], tone: "", source: "2026-08-27 用户确认" },
  "model_library.add_model": { id: "model_library.add_model", domain: "model_library", text: "添加模型", vars: [], tone: "", source: "2026-08-27 用户确认" },
  "model_library.api_key": { id: "model_library.api_key", domain: "model_library", text: "API Key", vars: [], tone: "", source: "2026-08-27 用户确认" },
  "model_library.base_url": { id: "model_library.base_url", domain: "model_library", text: "API 地址", vars: [], tone: "", source: "2026-08-27 用户确认" },
  "model_library.cancel": { id: "model_library.cancel", domain: "model_library", text: "取消", vars: [], tone: "", source: "2026-08-27 用户确认" },
  "model_library.connection_disabled": { id: "model_library.connection_disabled", domain: "model_library", text: "停用连接", vars: [], tone: "", source: "2026-08-27 用户确认" },
  "model_library.connection_enabled": { id: "model_library.connection_enabled", domain: "model_library", text: "连接可用", vars: [], tone: "", source: "2026-08-27 用户确认" },
  "model_library.connection_name": { id: "model_library.connection_name", domain: "model_library", text: "连接名称", vars: [], tone: "", source: "2026-08-27 用户确认" },
  "model_library.connection_name_placeholder": { id: "model_library.connection_name_placeholder", domain: "model_library", text: "例如 OpenAI 主账号", vars: [], tone: "", source: "2026-08-27 用户确认" },
  "model_library.connections": { id: "model_library.connections", domain: "model_library", text: "服务商连接", vars: [], tone: "", source: "2026-08-27 用户确认" },
  "model_library.create": { id: "model_library.create", domain: "model_library", text: "保存连接", vars: [], tone: "", source: "2026-08-27 用户确认" },
  "model_library.empty_connections": { id: "model_library.empty_connections", domain: "model_library", text: "还没有模型连接。添加一个服务商连接后，就能在它下面继续添加模型。", vars: [], tone: "", source: "2026-08-27 用户确认" },
  "model_library.empty_models": { id: "model_library.empty_models", domain: "model_library", text: "这个连接还没有启用的模型。", vars: [], tone: "", source: "2026-08-27 用户确认" },
  "model_library.form_error": { id: "model_library.form_error", domain: "model_library", text: "请检查必填项和 API 地址后再试。", vars: [], tone: "", source: "2026-08-27 用户确认" },
  "model_library.key_hint": { id: "model_library.key_hint", domain: "model_library", text: "只会写入加密凭证库，保存后不会再次显示。", vars: [], tone: "", source: "2026-08-27 用户确认" },
  "model_library.model_disabled": { id: "model_library.model_disabled", domain: "model_library", text: "已停用", vars: [], tone: "", source: "2026-08-27 用户确认" },
  "model_library.model_enabled": { id: "model_library.model_enabled", domain: "model_library", text: "模型可选", vars: [], tone: "", source: "2026-08-27 用户确认" },
  "model_library.model_id": { id: "model_library.model_id", domain: "model_library", text: "模型 ID", vars: [], tone: "", source: "2026-08-27 用户确认" },
  "model_library.model_id_placeholder": { id: "model_library.model_id_placeholder", domain: "model_library", text: "填服务商实际接受的模型 ID", vars: [], tone: "", source: "2026-08-27 用户确认" },
  "model_library.model_name": { id: "model_library.model_name", domain: "model_library", text: "显示名称", vars: [], tone: "", source: "2026-08-27 用户确认" },
  "model_library.model_name_placeholder": { id: "model_library.model_name_placeholder", domain: "model_library", text: "例如 GPT-5.4", vars: [], tone: "", source: "2026-08-27 用户确认" },
  "model_library.models": { id: "model_library.models", domain: "model_library", text: "此连接下的模型", vars: [], tone: "", source: "2026-08-27 用户确认" },
  "model_library.platform.ark_connection": { id: "model_library.platform.ark_connection", domain: "model_library", text: "平台自带 · 方舟按量", vars: [], tone: "", source: "2026-08-28 arron 要求把系统已有模型灌进模型管理" },
  "model_library.platform.ark_monthly_connection": { id: "model_library.platform.ark_monthly_connection", domain: "model_library", text: "平台自带 · 火山方舟 Agent Plan", vars: [], tone: "", source: "2026-08-28 arron 要求把系统已有模型灌进模型管理" },
  "model_library.platform.deepseek_connection": { id: "model_library.platform.deepseek_connection", domain: "model_library", text: "平台自带 · DeepSeek 原厂", vars: [], tone: "", source: "2026-08-28 arron 要求把系统已有模型灌进模型管理" },
  "model_library.platform.model_ark_code": { id: "model_library.platform.model_ark_code", domain: "model_library", text: "Agent Plan（自动选）", vars: [], tone: "", source: "2026-08-28 arron 要求把系统已有模型灌进模型管理" },
  "model_library.platform.model_deepseek_flash": { id: "model_library.platform.model_deepseek_flash", domain: "model_library", text: "DeepSeek V4 Flash", vars: [], tone: "", source: "2026-08-28 arron 要求把系统已有模型灌进模型管理" },
  "model_library.platform.model_doubao": { id: "model_library.platform.model_doubao", domain: "model_library", text: "豆包 seed evolving", vars: [], tone: "", source: "2026-08-28 arron 要求把系统已有模型灌进模型管理" },
  "model_library.platform.model_doubao_speech_mini": { id: "model_library.platform.model_doubao_speech_mini", domain: "model_library", text: "Doubao ASR 2.0 · 语音识别", vars: [], tone: "", source: "2026-08-30 方舟 Agent Plan 语音模型官方合同与生产实测" },
  "model_library.platform.model_glm": { id: "model_library.platform.model_glm", domain: "model_library", text: "GLM 5.3", vars: [], tone: "", source: "2026-08-28 arron 要求把系统已有模型灌进模型管理" },
  "model_library.platform.model_kimi": { id: "model_library.platform.model_kimi", domain: "model_library", text: "Kimi K3", vars: [], tone: "", source: "2026-08-28 arron 要求把系统已有模型灌进模型管理" },
  "model_library.platform.model_seed_asr_file": { id: "model_library.platform.model_seed_asr_file", domain: "model_library", text: "豆包录音文件识别模型 2.0", vars: [], tone: "", source: "2026-08-29 模型库增加 openspeech Seed ASR 占位" },
  "model_library.platform.model_seed_asr_stream": { id: "model_library.platform.model_seed_asr_stream", domain: "model_library", text: "豆包流式语音识别", vars: [], tone: "", source: "2026-08-29 模型库增加 openspeech Seed ASR 占位" },
  "model_library.platform.openspeech_connection": { id: "model_library.platform.openspeech_connection", domain: "model_library", text: "火山语音 · Seed ASR", vars: [], tone: "", source: "2026-08-29 模型库增加 openspeech Seed ASR 占位" },
  "model_library.probe": { id: "model_library.probe", domain: "model_library", text: "测试连接", vars: [], tone: "", source: "2026-08-27 用户确认" },
  "model_library.probe_error": { id: "model_library.probe_error", domain: "model_library", text: "连接未通过验证。请检查服务商地址、模型 ID 和 API Key。", vars: [], tone: "", source: "2026-08-27 用户确认" },
  "model_library.probe_hint": { id: "model_library.probe_hint", domain: "model_library", text: "使用第一个启用模型发送一次最小请求，只记录安全状态。", vars: [], tone: "", source: "2026-08-27 用户确认" },
  "model_library.protocol": { id: "model_library.protocol", domain: "model_library", text: "接口协议", vars: [], tone: "", source: "2026-08-27 用户确认" },
  "model_library.protocol.anthropic": { id: "model_library.protocol.anthropic", domain: "model_library", text: "Anthropic Messages", vars: [], tone: "", source: "2026-08-27 用户确认" },
  "model_library.protocol.bedrock": { id: "model_library.protocol.bedrock", domain: "model_library", text: "Amazon Bedrock Converse", vars: [], tone: "", source: "2026-08-27 用户确认" },
  "model_library.protocol.openai": { id: "model_library.protocol.openai", domain: "model_library", text: "OpenAI 兼容 Chat Completions", vars: [], tone: "", source: "2026-08-27 用户确认" },
  "model_library.provider": { id: "model_library.provider", domain: "model_library", text: "服务商", vars: [], tone: "", source: "2026-08-27 用户确认" },
  "model_library.provider_hint": { id: "model_library.provider_hint", domain: "model_library", text: "预置只帮你填写协议和地址，不限制模型名称或数量。Amazon Bedrock 使用原生 Converse 适配器。", vars: [], tone: "", source: "2026-08-27 用户确认" },
  "model_library.save_error": { id: "model_library.save_error", domain: "model_library", text: "没有保存成功。连接和密钥没有显示在页面上。", vars: [], tone: "", source: "2026-08-27 用户确认" },
  "model_library.scope.account": { id: "model_library.scope.account", domain: "model_library", text: "账户级", vars: [], tone: "", source: "2026-08-27 用户确认" },
  "model_library.status.disabled": { id: "model_library.status.disabled", domain: "model_library", text: "已停用", vars: [], tone: "", source: "2026-08-27 用户确认" },
  "model_library.status.failed": { id: "model_library.status.failed", domain: "model_library", text: "连接失败", vars: [], tone: "", source: "2026-08-27 用户确认" },
  "model_library.status.unverified": { id: "model_library.status.unverified", domain: "model_library", text: "未验证", vars: [], tone: "", source: "2026-08-27 用户确认" },
  "model_library.status.verified": { id: "model_library.status.verified", domain: "model_library", text: "已验证", vars: [], tone: "", source: "2026-08-27 用户确认" },
  "model_library.subtitle": { id: "model_library.subtitle", domain: "model_library", text: "先连接服务商，再添加任意数量的模型。模型可以分配给不同的 Agent，但模型本身不是 Agent。", vars: [], tone: "", source: "2026-08-27 用户确认" },
  "model_library.title": { id: "model_library.title", domain: "model_library", text: "模型库", vars: [], tone: "", source: "2026-08-27 用户确认" },
  "model_runtime.agent.backend": { id: "model_runtime.agent.backend", domain: "model_runtime", text: "后端助手", vars: [], tone: "", source: "Lulu V2 Agent default naming" },
  "model_runtime.agent.design": { id: "model_runtime.agent.design", domain: "model_runtime", text: "设计助手", vars: [], tone: "", source: "Lulu V2 Agent default naming" },
  "model_runtime.agent.frontend": { id: "model_runtime.agent.frontend", domain: "model_runtime", text: "前端助手", vars: [], tone: "", source: "Lulu V2 Agent default naming" },
  "model_runtime.agent.ops": { id: "model_runtime.agent.ops", domain: "model_runtime", text: "运维专家", vars: [], tone: "", source: "Lulu V2 Agent default naming" },
  "model_runtime.agent.product": { id: "model_runtime.agent.product", domain: "model_runtime", text: "产品助手", vars: [], tone: "", source: "Lulu V2 Agent default naming" },
  "model_runtime.agent.project": { id: "model_runtime.agent.project", domain: "model_runtime", text: "项目助手", vars: [], tone: "", source: "Lulu V2 Agent default naming" },
  "model_runtime.agent.review": { id: "model_runtime.agent.review", domain: "model_runtime", text: "复核助手", vars: [], tone: "", source: "Lulu V2 Agent default naming" },
  "model_runtime.agent.test": { id: "model_runtime.agent.test", domain: "model_runtime", text: "测试助手", vars: [], tone: "", source: "Lulu V2 Agent default naming" },
  "model_runtime.module.code_review_description": { id: "model_runtime.module.code_review_description", domain: "model_runtime", text: "独立于执行 Agent 的代码复核", vars: [], tone: "", source: "Lulu V2 system module audit" },
  "model_runtime.module.code_review_name": { id: "model_runtime.module.code_review_name", domain: "model_runtime", text: "独立代码复核", vars: [], tone: "", source: "Lulu V2 system module audit" },
  "model_runtime.module.code_review_note": { id: "model_runtime.module.code_review_note", domain: "model_runtime", text: "复核现在按这里选的模型走；换了立刻生效，不用重启。这条路认豆包、DeepSeek Flash，以及 TokenHub 上的 glm-5.3-flash。选了认不出的，这一轮仍用原来那个，不会假装换成功。", vars: [], tone: "", source: "2026-09-03 第二家复核接到 TokenHub glm-5.3-flash" },
  "model_runtime.module.conversation_memory_description": { id: "model_runtime.module.conversation_memory_description", domain: "model_runtime", text: "会话压缩、摘要和长期记忆", vars: [], tone: "", source: "Lulu V2 system module audit" },
  "model_runtime.module.conversation_memory_name": { id: "model_runtime.module.conversation_memory_name", domain: "model_runtime", text: "会话摘要与记忆", vars: [], tone: "", source: "Lulu V2 system module audit" },
  "model_runtime.module.conversation_memory_note": { id: "model_runtime.module.conversation_memory_note", domain: "model_runtime", text: "现在还用不上。聊天记录是原样存着的，没有谁在替你压缩或改写。", vars: [], tone: "", source: "Lulu V2 system module audit" },
  "model_runtime.module.development_orchestration_description": { id: "model_runtime.module.development_orchestration_description", domain: "model_runtime", text: "选择执行者并调度开发任务", vars: [], tone: "", source: "Lulu V2 system module audit" },
  "model_runtime.module.development_orchestration_name": { id: "model_runtime.module.development_orchestration_name", domain: "model_runtime", text: "开发任务编排", vars: [], tone: "", source: "Lulu V2 system module audit" },
  "model_runtime.module.development_orchestration_note": { id: "model_runtime.module.development_orchestration_note", domain: "model_runtime", text: "这里选的模型是「默认交给谁写代码」；你在对话里点过下拉就用你点的那个。", vars: [], tone: "", source: "补充" },
  "model_runtime.module.document_content_description": { id: "model_runtime.module.document_content_description", domain: "model_runtime", text: "文档理解、改写和结构化处理", vars: [], tone: "", source: "Lulu V2 system module audit" },
  "model_runtime.module.document_content_name": { id: "model_runtime.module.document_content_name", domain: "model_runtime", text: "文档 / 内容处理", vars: [], tone: "", source: "Lulu V2 system module audit" },
  "model_runtime.module.document_content_note": { id: "model_runtime.module.document_content_note", domain: "model_runtime", text: "这块还没做。做好了它会自己出现在这儿。", vars: [], tone: "", source: "Lulu V2 system module audit" },
  "model_runtime.module.lulu_reasoning_description": { id: "model_runtime.module.lulu_reasoning_description", domain: "model_runtime", text: "Lulu 主会话的回复与推理", vars: [], tone: "", source: "Lulu V2 system module audit" },
  "model_runtime.module.lulu_reasoning_name": { id: "model_runtime.module.lulu_reasoning_name", domain: "model_runtime", text: "Lulu 对话与推理", vars: [], tone: "", source: "Lulu V2 system module audit" },
  "model_runtime.module.lulu_reasoning_not_usable": { id: "model_runtime.module.lulu_reasoning_not_usable", domain: "model_runtime", text: "这个模型 Lulu 还用不了，换一个。它本身是好的，不用去动 Key。", vars: [], tone: "", source: "2026-08-28 接线「系统模型」那一屏时新增" },
  "model_runtime.module.lulu_reasoning_not_wired": { id: "model_runtime.module.lulu_reasoning_not_wired", domain: "model_runtime", text: "现有会话循环仍读取部署级规划模型", vars: [], tone: "", source: "Lulu V2 system module audit" },
  "model_runtime.module.lulu_reasoning_note": { id: "model_runtime.module.lulu_reasoning_note", domain: "model_runtime", text: "Lulu 主会话现在按这里选的模型走；换了立刻生效，不用重启", vars: [], tone: "", source: "Lulu V2 system module audit" },
  "model_runtime.module.multimodal_description": { id: "model_runtime.module.multimodal_description", domain: "model_runtime", text: "把明确允许 AI 读取的录音转成可编辑文字", vars: [], tone: "", source: "Lulu V2 system module audit" },
  "model_runtime.module.multimodal_name": { id: "model_runtime.module.multimodal_name", domain: "model_runtime", text: "语音识别", vars: [], tone: "", source: "Lulu V2 system module audit" },
  "model_runtime.module.multimodal_note": { id: "model_runtime.module.multimodal_note", domain: "model_runtime", text: "实际执行固定为 Ark Plan / doubao-seed-asr-2.0。Doubao Seed 2.0 Mini 是通用文本模型，不接收这条语音；旧绑定不会再冒充已接线。", vars: [], tone: "", source: "2026-09-01 生产模型档案与语音执行回执对账" },
  "model_runtime.module.patch_generation_description": { id: "model_runtime.module.patch_generation_description", domain: "model_runtime", text: "生成补丁并执行独立代码复核", vars: [], tone: "", source: "Lulu V2 system module audit" },
  "model_runtime.module.patch_generation_name": { id: "model_runtime.module.patch_generation_name", domain: "model_runtime", text: "代码 / 产品巡检", vars: [], tone: "", source: "Lulu V2 system module audit" },
  "model_runtime.module.patch_generation_note": { id: "model_runtime.module.patch_generation_note", domain: "model_runtime", text: "写补丁的模型现在按这里选的走；换了下一次生成就生效。复核那一半在「独立代码复核」那一档", vars: [], tone: "", source: "Lulu V2 system module audit" },
  "model_runtime.module.product_inspection_description": { id: "model_runtime.module.product_inspection_description", domain: "model_runtime", text: "页面、流程与产品规则巡检", vars: [], tone: "", source: "Lulu V2 system module audit" },
  "model_runtime.module.product_inspection_name": { id: "model_runtime.module.product_inspection_name", domain: "model_runtime", text: "产品巡检", vars: [], tone: "", source: "Lulu V2 system module audit" },
  "model_runtime.module.product_inspection_note": { id: "model_runtime.module.product_inspection_note", domain: "model_runtime", text: "上线后的产品巡检按这里选的模型走，现在走 DeepSeek。没选模型或模型没应答时会留下一条没跑成的发现，不会假装通过。", vars: [], tone: "", source: "异步巡检 batch 4" },
  "model_runtime.module.task_planning_description": { id: "model_runtime.module.task_planning_description", domain: "model_runtime", text: "把目标拆成可执行任务", vars: [], tone: "", source: "Lulu V2 system module audit" },
  "model_runtime.module.task_planning_name": { id: "model_runtime.module.task_planning_name", domain: "model_runtime", text: "任务规划 / 拆解", vars: [], tone: "", source: "Lulu V2 system module audit" },
  "model_runtime.module.task_planning_not_wired": { id: "model_runtime.module.task_planning_not_wired", domain: "model_runtime", text: "现有 Steward Planner 仍读取部署配置", vars: [], tone: "", source: "Lulu V2 system module audit" },
  "model_runtime.module.task_planning_note": { id: "model_runtime.module.task_planning_note", domain: "model_runtime", text: "拆任务现在按这里选的模型走；换了立刻生效，不用重启", vars: [], tone: "", source: "2026-08-29 接线「任务规划 / 拆解」那一档" },
  "model_runtime.provider.agent_plan_catalog_hint": { id: "model_runtime.provider.agent_plan_catalog_hint", domain: "model_runtime", text: "Agent Plan 套餐支持范围会变化；选择公开候选或手填套餐页型号，保存后会用当前 Key 真实测试", vars: [], tone: "", source: "2026-08-29 Agent Plan catalog boundary" },
  "model_runtime.provider.api_key": { id: "model_runtime.provider.api_key", domain: "model_runtime", text: "使用 API Key", vars: [], tone: "", source: "Lulu V2 provider preset" },
  "model_runtime.provider.api_key_manual_models": { id: "model_runtime.provider.api_key_manual_models", domain: "model_runtime", text: "使用 API Key；模型需手动添加", vars: [], tone: "", source: "Lulu V2 provider preset" },
  "model_runtime.provider.bedrock_auth_hint": { id: "model_runtime.provider.bedrock_auth_hint", domain: "model_runtime", text: "原生认证需适配器", vars: [], tone: "", source: "Lulu V2 provider preset" },
  "model_runtime.provider.bedrock_base_hint": { id: "model_runtime.provider.bedrock_base_hint", domain: "model_runtime", text: "填写 OpenAI-compatible 网关；原生 SigV4 尚未接入", vars: [], tone: "", source: "Lulu V2 provider preset" },
  "model_runtime.provider.custom_hint": { id: "model_runtime.provider.custom_hint", domain: "model_runtime", text: "选择一种通用协议", vars: [], tone: "", source: "Lulu V2 provider preset" },
  "model_runtime.provider.custom_name": { id: "model_runtime.provider.custom_name", domain: "model_runtime", text: "自定义连接", vars: [], tone: "", source: "Lulu V2 provider preset" },
  "model_runtime.provider.huawei_hint": { id: "model_runtime.provider.huawei_hint", domain: "model_runtime", text: "按控制台创建的 API Key 填写", vars: [], tone: "", source: "Lulu V2 provider preset" },
  "model_runtime.provider.huawei_name": { id: "model_runtime.provider.huawei_name", domain: "model_runtime", text: "华为云 MaaS", vars: [], tone: "", source: "Lulu V2 provider preset" },
  "model_runtime.provider.manual_catalog_hint": { id: "model_runtime.provider.manual_catalog_hint", domain: "model_runtime", text: "服务商没有公开账户模型目录，请按控制台填写模型 ID，保存后会真实测试", vars: [], tone: "", source: "2026-08-29 provider catalog boundary" },
  "model_runtime.provider.plan_catalog_hint": { id: "model_runtime.provider.plan_catalog_hint", domain: "model_runtime", text: "型号来自服务商公开的套餐支持清单，不代表当前 Key 已开通；保存后会用所选模型真实测试", vars: [], tone: "", source: "2026-08-29 provider catalog boundary" },
  "model_runtime.provider.public_catalog_hint": { id: "model_runtime.provider.public_catalog_hint", domain: "model_runtime", text: "提供官方当前主型号作为候选，也可手填其他模型 ID；保存后会用当前 Key 真实测试", vars: [], tone: "", source: "2026-08-29 provider catalog boundary" },
  "model_runtime.provider.tencent_hint": { id: "model_runtime.provider.tencent_hint", domain: "model_runtime", text: "旧版 Hunyuan API 不提供模型目录；新接入请优先使用 TokenHub", vars: [], tone: "", source: "Lulu V2 provider preset" },
  "model_runtime.provider.tencent_name": { id: "model_runtime.provider.tencent_name", domain: "model_runtime", text: "腾讯混元（旧版）", vars: [], tone: "", source: "Lulu V2 provider preset" },
  "model_runtime.provider.tencent_token_plan_hint": { id: "model_runtime.provider.tencent_token_plan_hint", domain: "model_runtime", text: "使用 Token Plan 专用 sk-tp Key；通用套餐与 Hy 套餐共享 Key，但支持型号不同", vars: [], tone: "", source: "2026-08-29 Tencent Token Plan quick start" },
  "model_runtime.provider.tencent_token_plan_name": { id: "model_runtime.provider.tencent_token_plan_name", domain: "model_runtime", text: "腾讯云 Token Plan", vars: [], tone: "", source: "2026-08-29 Tencent Token Plan quick start" },
  "model_runtime.provider.tencent_tokenhub_hint": { id: "model_runtime.provider.tencent_tokenhub_hint", domain: "model_runtime", text: "使用 TokenHub API Key；可读取当前 Key 可用的模型", vars: [], tone: "", source: "2026-08-29 provider protocol audit" },
  "model_runtime.provider.tencent_tokenhub_name": { id: "model_runtime.provider.tencent_tokenhub_name", domain: "model_runtime", text: "腾讯云 TokenHub", vars: [], tone: "", source: "2026-08-29 provider protocol audit" },
  "model_runtime.provider.volcengine_agent_plan_hint": { id: "model_runtime.provider.volcengine_agent_plan_hint", domain: "model_runtime", text: "仅使用 Agent Plan 专用 API Key；普通方舟和 Coding Plan Key 不可用", vars: [], tone: "", source: "Lulu V2 provider preset" },
  "model_runtime.provider.volcengine_agent_plan_name": { id: "model_runtime.provider.volcengine_agent_plan_name", domain: "model_runtime", text: "火山方舟 Agent Plan", vars: [], tone: "", source: "Lulu V2 provider preset" },
  "model_runtime.provider.volcengine_coding_plan_hint": { id: "model_runtime.provider.volcengine_coding_plan_hint", domain: "model_runtime", text: "仅使用 Coding Plan 专用 API Key；普通方舟和 Agent Plan Key 不可用", vars: [], tone: "", source: "Lulu V2 provider preset" },
  "model_runtime.provider.volcengine_coding_plan_name": { id: "model_runtime.provider.volcengine_coding_plan_name", domain: "model_runtime", text: "火山方舟 Coding Plan", vars: [], tone: "", source: "Lulu V2 provider preset" },
  "model_runtime.provider.volcengine_hint": { id: "model_runtime.provider.volcengine_hint", domain: "model_runtime", text: "按方舟控制台的 API Key 填写", vars: [], tone: "", source: "Lulu V2 provider preset" },
  "model_runtime.provider.volcengine_name": { id: "model_runtime.provider.volcengine_name", domain: "model_runtime", text: "火山方舟（按量）", vars: [], tone: "", source: "Lulu V2 provider preset" },
  "model_runtime.provider.volcengine_openspeech_hint": { id: "model_runtime.provider.volcengine_openspeech_hint", domain: "model_runtime", text: "填写 openspeech 的 APP ID 与 Access Token，不是方舟 Chat Key。Resource-Id 即模型 ID，文件识别为 volc.seedasr.auc。", vars: [], tone: "", source: "2026-08-29 模型库增加 openspeech Seed ASR 占位" },
  "model_runtime.provider.volcengine_openspeech_name": { id: "model_runtime.provider.volcengine_openspeech_name", domain: "model_runtime", text: "火山语音 / Seed ASR", vars: [], tone: "", source: "2026-08-29 模型库增加 openspeech Seed ASR 占位" },
  "model_runtime.provider.zhipu_coding_plan_hint": { id: "model_runtime.provider.zhipu_coding_plan_hint", domain: "model_runtime", text: "使用 GLM Coding Plan 专用 API Key；团队版 Key 与通用 Key 不通用", vars: [], tone: "", source: "2026-08-29 provider protocol audit" },
  "model_runtime.provider.zhipu_coding_plan_name": { id: "model_runtime.provider.zhipu_coding_plan_name", domain: "model_runtime", text: "智谱 GLM Coding Plan", vars: [], tone: "", source: "2026-08-29 provider protocol audit" },
  "model_runtime.provider.zhipu_hint": { id: "model_runtime.provider.zhipu_hint", domain: "model_runtime", text: "使用智谱开放平台通用 API Key", vars: [], tone: "", source: "Lulu V2 provider preset" },
  "model_runtime.provider.zhipu_name": { id: "model_runtime.provider.zhipu_name", domain: "model_runtime", text: "智谱 GLM（按量）", vars: [], tone: "", source: "Lulu V2 provider preset" },
  "nav.account": { id: "nav.account", domain: "nav", text: "账户", vars: [], tone: "", source: "导航菜单规范 2026-08-25" },
  "nav.account.appearance": { id: "nav.account.appearance", domain: "nav", text: "外观", vars: [], tone: "", source: "导航冻结参考 NavBar.dc（acctToggles）" },
  "nav.account.appearance.follow": { id: "nav.account.appearance.follow", domain: "nav", text: "跟随系统", vars: [], tone: "", source: "导航冻结参考 NavBar.dc" },
  "nav.account.billing": { id: "nav.account.billing", domain: "nav", text: "账单与额度", vars: [], tone: "", source: "导航冻结参考 NavBar.dc" },
  "nav.account.lang": { id: "nav.account.lang", domain: "nav", text: "语言", vars: [], tone: "", source: "导航冻结参考 NavBar.dc" },
  "nav.account.logout": { id: "nav.account.logout", domain: "nav", text: "退出登录", vars: [], tone: "", source: "补充" },
  "nav.account.me": { id: "nav.account.me", domain: "nav", text: "我的账户", vars: [], tone: "", source: "补充" },
  "nav.account.mobile.account": { id: "nav.account.mobile.account", domain: "nav", text: "账号", vars: [], tone: "", source: "移动端账户 bottom sheet" },
  "nav.account.mobile.lang": { id: "nav.account.mobile.lang", domain: "nav", text: "语言", vars: [], tone: "", source: "移动端账户 bottom sheet" },
  "nav.account.mobile.prefs": { id: "nav.account.mobile.prefs", domain: "nav", text: "偏好", vars: [], tone: "", source: "移动端账户 bottom sheet" },
  "nav.account.session": { id: "nav.account.session", domain: "nav", text: "{method} · 上次 {time}", vars: ["method", "time"], tone: "", source: "导航冻结参考 NavBar.dc" },
  "nav.account.session.password": { id: "nav.account.session.password", domain: "nav", text: "密码", vars: [], tone: "", source: "账户菜单会话行（原先硬编码在 shell.tsx，多语言审计收编）" },
  "nav.account.settings": { id: "nav.account.settings", domain: "nav", text: "设置", vars: [], tone: "", source: "导航冻结参考 NavBar.dc" },
  "nav.account.shortcuts": { id: "nav.account.shortcuts", domain: "nav", text: "键盘快捷键", vars: [], tone: "", source: "导航冻结参考 NavBar.dc" },
  "nav.account.shortcuts.hint": { id: "nav.account.shortcuts.hint", domain: "nav", text: "⌘/", vars: [], tone: "", source: "导航冻结参考 NavBar.dc" },
  "nav.account.team": { id: "nav.account.team", domain: "nav", text: "成员与权限", vars: [], tone: "", source: "导航冻结参考 NavBar.dc" },
  "nav.account.team.hint": { id: "nav.account.team.hint", domain: "nav", text: "{n} 人", vars: ["n"], tone: "", source: "导航冻结参考 NavBar.dc" },
  "nav.alert": { id: "nav.alert", domain: "nav", text: "告警", vars: [], tone: "", source: "导航菜单规范 2026-08-25" },
  "nav.auth": { id: "nav.auth", domain: "nav", text: "登录页", vars: [], tone: "", source: "设计稿" },
  "nav.bridge": { id: "nav.bridge", domain: "nav", text: "AI 接口", vars: [], tone: "", source: "导航菜单规范 2026-08-25" },
  "nav.bug_reports": { id: "nav.bug_reports", domain: "nav", text: "问题反馈", vars: [], tone: "", source: "arron 2026-09-06" },
  "nav.chat": { id: "nav.chat", domain: "nav", text: "Lulu", vars: [], tone: "", source: "arron 2026-08-24" },
  "nav.code": { id: "nav.code", domain: "nav", text: "发布", vars: [], tone: "", source: "导航菜单规范 2026-08-25" },
  "nav.common.loading": { id: "nav.common.loading", domain: "nav", text: "正在读取", vars: [], tone: "", source: "PRD FR-7 / 研讨会裁决五" },
  "nav.dash": { id: "nav.dash", domain: "nav", text: "总览", vars: [], tone: "", source: "设计稿" },
  "nav.duty": { id: "nav.duty", domain: "nav", text: "排班", vars: [], tone: "", source: "M6-16" },
  "nav.hosts": { id: "nav.hosts", domain: "nav", text: "机器", vars: [], tone: "", source: "资源模块 SPEC 2026-08-27" },
  "nav.inbox.alert.open": { id: "nav.inbox.alert.open", domain: "nav", text: "{count} 条未处理的告警", vars: ["count"], tone: "", source: "PRD FR-2" },
  "nav.inbox.approval": { id: "nav.inbox.approval", domain: "nav", text: "{count} 件等你确认", vars: ["count"], tone: "", source: "PRD FR-2" },
  "nav.inbox.empty": { id: "nav.inbox.empty", domain: "nav", text: "现在没有要你出手的事", vars: [], tone: "", source: "PRD FR-2" },
  "nav.inbox.title": { id: "nav.inbox.title", domain: "nav", text: "要你出手的", vars: [], tone: "", source: "PRD FR-2 / 研讨会裁决四" },
  "nav.inbox.view.all": { id: "nav.inbox.view.all", domain: "nav", text: "查看全部", vars: [], tone: "", source: "PRD FR-2" },
  "nav.memo": { id: "nav.memo", domain: "nav", text: "备忘录", vars: [], tone: "", source: "导航菜单规范 2026-08-25" },
  "nav.models": { id: "nav.models", domain: "nav", text: "模型", vars: [], tone: "", source: "导航菜单规范 2026-08-25" },
  "nav.more": { id: "nav.more", domain: "nav", text: "更多", vars: [], tone: "", source: "导航菜单规范 2026-08-25" },
  "nav.more.group.modules": { id: "nav.more.group.modules", domain: "nav", text: "其他模块", vars: [], tone: "", source: "导航冻结参考 MobileNav.dc（moreGroups）" },
  "nav.new_session": { id: "nav.new_session", domain: "nav", text: "新建会话", vars: [], tone: "", source: "导航菜单规范 2026-08-25" },
  "nav.notification": { id: "nav.notification", domain: "nav", text: "通知", vars: [], tone: "", source: "导航菜单规范 2026-08-25" },
  "nav.onboard": { id: "nav.onboard", domain: "nav", text: "加一台机器", vars: [], tone: "", source: "设计稿" },
  "nav.project": { id: "nav.project", domain: "nav", text: "项目", vars: [], tone: "", source: "导航菜单规范 2026-08-25" },
  "nav.project.loading": { id: "nav.project.loading", domain: "nav", text: "项目…", vars: [], tone: "", source: "导航菜单规范 2026-08-25" },
  "nav.project_tabs": { id: "nav.project_tabs", domain: "nav", text: "项目页签", vars: [], tone: "", source: "导航菜单规范 2026-08-25" },
  "nav.ptab.activity": { id: "nav.ptab.activity", domain: "nav", text: "动态", vars: [], tone: "", source: "动态中心 PRD v2 / 设计稿 A05" },
  "nav.ptab.chat": { id: "nav.ptab.chat", domain: "nav", text: "对话", vars: [], tone: "", source: "导航菜单规范 2026-08-25" },
  "nav.ptab.env": { id: "nav.ptab.env", domain: "nav", text: "环境", vars: [], tone: "", source: "导航菜单规范 2026-08-25" },
  "nav.ptab.memo": { id: "nav.ptab.memo", domain: "nav", text: "备忘录", vars: [], tone: "", source: "导航菜单规范 2026-08-25" },
  "nav.ptab.overview": { id: "nav.ptab.overview", domain: "nav", text: "概览", vars: [], tone: "", source: "导航菜单规范 2026-08-25" },
  "nav.ptab.release": { id: "nav.ptab.release", domain: "nav", text: "发布", vars: [], tone: "", source: "导航菜单规范 2026-08-25" },
  "nav.ptab.resources": { id: "nav.ptab.resources", domain: "nav", text: "资源", vars: [], tone: "", source: "导航菜单规范 2026-08-25" },
  "nav.ptab.tasks": { id: "nav.ptab.tasks", domain: "nav", text: "任务", vars: [], tone: "", source: "导航菜单规范 2026-08-25" },
  "nav.search.everything": { id: "nav.search.everything", domain: "nav", text: "搜一切", vars: [], tone: "", source: "PRD FR-3 / 研讨会裁决二" },
  "nav.search.group.hosts": { id: "nav.search.group.hosts", domain: "nav", text: "机器", vars: [], tone: "", source: "PRD FR-3" },
  "nav.search.group.memos": { id: "nav.search.group.memos", domain: "nav", text: "备忘录", vars: [], tone: "", source: "PRD FR-3" },
  "nav.search.group.projects": { id: "nav.search.group.projects", domain: "nav", text: "项目", vars: [], tone: "", source: "PRD FR-3" },
  "nav.search.group.timeline": { id: "nav.search.group.timeline", domain: "nav", text: "动态", vars: [], tone: "", source: "PRD FR-3" },
  "nav.search.hint": { id: "nav.search.hint", domain: "nav", text: "搜项目、机器、任务", vars: [], tone: "", source: "导航菜单规范 2026-08-25" },
  "nav.search.hint.all": { id: "nav.search.hint.all", domain: "nav", text: "搜项目、机器、备忘录、动态", vars: [], tone: "", source: "PRD FR-3" },
  "nav.search.none": { id: "nav.search.none", domain: "nav", text: "没有匹配的——换个词试试", vars: [], tone: "", source: "PRD FR-3" },
  "nav.search.placeholder": { id: "nav.search.placeholder", domain: "nav", text: "搜索", vars: [], tone: "", source: "导航菜单规范 2026-08-25" },
  "nav.sec": { id: "nav.sec", domain: "nav", text: "安全体检", vars: [], tone: "", source: "设计稿" },
  "nav.server": { id: "nav.server", domain: "nav", text: "机器详情", vars: [], tone: "", source: "设计稿" },
  "nav.shortcuts.group.global": { id: "nav.shortcuts.group.global", domain: "nav", text: "全局", vars: [], tone: "", source: "v3 §4C.4" },
  "nav.shortcuts.group.memo": { id: "nav.shortcuts.group.memo", domain: "nav", text: "备忘录", vars: [], tone: "", source: "v3 §4C.4" },
  "nav.shortcuts.yield.note": { id: "nav.shortcuts.yield.note", domain: "nav", text: "快捷键在输入框里会让位给打字", vars: [], tone: "", source: "v3 §4C.4" },
  "nav.skills": { id: "nav.skills", domain: "nav", text: "AI 团队", vars: [], tone: "", source: "导航菜单规范 2026-08-25" },
  "nav.status.idle": { id: "nav.status.idle", domain: "nav", text: "没有正在跑的任务", vars: [], tone: "", source: "导航菜单规范 2026-08-25" },
  "nav.status.running": { id: "nav.status.running", domain: "nav", text: "{count} 个任务正在运行", vars: ["count"], tone: "", source: "侧栏任务状态 2026-08-30" },
  "nav.status.unknown": { id: "nav.status.unknown", domain: "nav", text: "任务状态暂不可用", vars: [], tone: "", source: "侧栏任务状态 2026-08-30" },
  "nav.team": { id: "nav.team", domain: "nav", text: "成员", vars: [], tone: "", source: "导航菜单规范 2026-08-25" },
  "nav.theme.current": { id: "nav.theme.current", domain: "nav", text: "当前外观", vars: [], tone: "", source: "v3 §4C.1 设置页外观卡" },
  "nav.theme.dark": { id: "nav.theme.dark", domain: "nav", text: "深色", vars: [], tone: "", source: "设计稿 SPEC-tokens（theme 枚举）" },
  "nav.theme.light": { id: "nav.theme.light", domain: "nav", text: "浅色", vars: [], tone: "", source: "设计稿 SPEC-tokens（theme 枚举）" },
  "nav.theme.quick.hint": { id: "nav.theme.quick.hint", domain: "nav", text: "也可以直接点顶栏的太阳 / 月亮快速切换", vars: [], tone: "", source: "v3 §4C.1" },
  "nav.theme.switch": { id: "nav.theme.switch", domain: "nav", text: "换主题", vars: [], tone: "", source: "补充" },
  "nav.timeline": { id: "nav.timeline", domain: "nav", text: "动态", vars: [], tone: "", source: "导航菜单规范 2026-08-25" },
  "nav.today.card.night": { id: "nav.today.card.night", domain: "nav", text: "昨夜发生了什么", vars: [], tone: "", source: "PRD FR-1" },
  "nav.today.card.night.body": { id: "nav.today.card.night.body", domain: "nav", text: "做成了 {succeeded} 件，没成 {failed} 件，自动退回 {rolled} 件", vars: ["failed", "rolled", "succeeded"], tone: "", source: "PRD FR-1" },
  "nav.today.card.running": { id: "nav.today.card.running", domain: "nav", text: "在跑的", vars: [], tone: "", source: "PRD FR-1" },
  "nav.today.card.waiting": { id: "nav.today.card.waiting", domain: "nav", text: "等你确认的", vars: [], tone: "", source: "PRD FR-1" },
  "nav.today.count.items": { id: "nav.today.count.items", domain: "nav", text: "{count} 件", vars: ["count"], tone: "", source: "今天屏产品评审 v1（2026-09-01）" },
  "nav.today.empty.running": { id: "nav.today.empty.running", domain: "nav", text: "现在没有在跑的事——AI 队闲着", vars: [], tone: "", source: "PRD FR-1" },
  "nav.today.empty.waiting": { id: "nav.today.empty.waiting", domain: "nav", text: "没有等你确认的事", vars: [], tone: "", source: "PRD FR-1" },
  "nav.today.error.title": { id: "nav.today.error.title", domain: "nav", text: "没能读到今天的数据", vars: [], tone: "", source: "PRD FR-1" },
  "nav.today.freshness": { id: "nav.today.freshness", domain: "nav", text: "数据截至 {time}", vars: ["time"], tone: "", source: "今天屏产品评审 v1（2026-09-01）" },
  "nav.today.link.alerts": { id: "nav.today.link.alerts", domain: "nav", text: "查看告警", vars: [], tone: "", source: "PRD FR-1" },
  "nav.today.link.all_activity": { id: "nav.today.link.all_activity", domain: "nav", text: "全部动态", vars: [], tone: "", source: "今天屏产品评审 v1（2026-09-01）" },
  "nav.today.link.inbox": { id: "nav.today.link.inbox", domain: "nav", text: "去收件箱处理", vars: [], tone: "", source: "今天屏产品评审 v1（2026-09-01）" },
  "nav.today.link.night": { id: "nav.today.link.night", domain: "nav", text: "昨夜时间线", vars: [], tone: "", source: "今天屏产品评审 v1（2026-09-01）" },
  "nav.today.link.timeline": { id: "nav.today.link.timeline", domain: "nav", text: "查看全部动态", vars: [], tone: "", source: "PRD FR-1" },
  "nav.today.overview.all": { id: "nav.today.overview.all", domain: "nav", text: "都稳了——没有在跑的，也没有等你确认的", vars: [], tone: "", source: "今天屏产品评审 v1（2026-09-01）" },
  "nav.today.overview.night": { id: "nav.today.overview.night", domain: "nav", text: "昨夜做成了 {succeeded} 件", vars: ["succeeded"], tone: "", source: "今天屏产品评审 v1（2026-09-01）" },
  "nav.today.overview.night.failed": { id: "nav.today.overview.night.failed", domain: "nav", text: "没成 {failed} 件", vars: ["failed"], tone: "", source: "今天屏产品评审 v1（2026-09-01）" },
  "nav.today.overview.running": { id: "nav.today.overview.running", domain: "nav", text: "{count} 件事在跑", vars: ["count"], tone: "", source: "今天屏产品评审 v1（2026-09-01）" },
  "nav.today.overview.waiting": { id: "nav.today.overview.waiting", domain: "nav", text: "{count} 件要你确认", vars: ["count"], tone: "", source: "今天屏产品评审 v1（2026-09-01）" },
  "nav.today.page.title": { id: "nav.today.page.title", domain: "nav", text: "今天", vars: [], tone: "", source: "PRD FR-1 / 研讨会裁决一" },
  "nav.today.waiting.headline": { id: "nav.today.waiting.headline", domain: "nav", text: "有 {count} 件在等你点头", vars: ["count"], tone: "", source: "今天屏产品评审 v1（2026-09-01）" },
  "nav.vendor": { id: "nav.vendor", domain: "nav", text: "服务商", vars: [], tone: "", source: "导航菜单规范 2026-08-25" },
  "onboarding.action.start": { id: "onboarding.action.start", domain: "onboarding", text: "接进来", vars: [], tone: "", source: "补充" },
  "onboarding.error.auth_failed": { id: "onboarding.error.auth_failed", domain: "onboarding", text: "我用你给的这份进不去，而你给我的那份我一个字都没改过。我要的是三样：这台机器的地址、用户名，还有密码或者密钥——你平时怎么进它的，就把那个给我。每家服务商后台长得都不一样，我不知道你从哪儿拿，你那边能复制出来的就行。", vars: [], tone: "danger", source: "补充" },
  "onboarding.error.host_key_changed": { id: "onboarding.error.host_key_changed", domain: "onboarding", text: "这台机器的身份指纹跟我上次记的不一样。可能是重装过系统，也可能有人在中间。这一步我不敢自己往下走。", vars: [], tone: "danger", source: "补充" },
  "onboarding.error.key_passphrase": { id: "onboarding.error.key_passphrase", domain: "onboarding", text: "这把钥匙的口令不对。换一个再试，你的服务器没问题。", vars: [], tone: "danger", source: "补充" },
  "onboarding.error.key_unreadable": { id: "onboarding.error.key_unreadable", domain: "onboarding", text: "这把钥匙我读不出来——多半是它带口令。把口令一起贴给我就行，你的服务器没问题。", vars: [], tone: "danger", source: "补充" },
  "onboarding.error.no_credential": { id: "onboarding.error.no_credential", domain: "onboarding", text: "我没拿到密码或者密钥，没法连。", vars: [], tone: "danger", source: "补充" },
  "onboarding.error.port_closed": { id: "onboarding.error.port_closed", domain: "onboarding", text: "{address} 的 {port} 端口不通。这台机器的 SSH 可能换了端口，你翻一下服务商控制台上写的是多少。", vars: ["address", "port"], tone: "danger", source: "补充" },
  "onboarding.error.refused": { id: "onboarding.error.refused", domain: "onboarding", text: "我敲不开 {address} 的门，那台机器把连接拒了。多半是它没开机，或者服务商那边的防火墙没放行。", vars: ["address"], tone: "danger", source: "补充" },
  "onboarding.error.timeout": { id: "onboarding.error.timeout", domain: "onboarding", text: "我等了 {seconds} 秒，{address} 一直没回话。可能是网络不通，也可能它正忙着。", vars: ["address", "seconds"], tone: "danger", source: "补充" },
  "onboarding.guess.confirm": { id: "onboarding.guess.confirm", domain: "onboarding", text: "对，就这样", vars: [], tone: "", source: "设计稿 · 加一台机器" },
  "onboarding.guess.heading": { id: "onboarding.guess.heading", domain: "onboarding", text: "我猜这台是 ——", vars: [], tone: "", source: "设计稿 · 加一台机器" },
  "onboarding.guess.name": { id: "onboarding.guess.name", domain: "onboarding", text: "{project_name} · {role}", vars: ["project_name", "role"], tone: "", source: "设计稿 · 加一台机器" },
  "onboarding.guess.reason": { id: "onboarding.guess.reason", domain: "onboarding", text: "上面跑着 {container_count} 个 Docker 容器和一个 {database}，域名 {domain} 解析过来。要不要就叫这个名字？", vars: ["container_count", "database", "domain"], tone: "", source: "设计稿 · 加一台机器" },
  "onboarding.guess.rename": { id: "onboarding.guess.rename", domain: "onboarding", text: "我自己起个名", vars: [], tone: "", source: "设计稿 · 加一台机器" },
  "onboarding.guess.unknown": { id: "onboarding.guess.unknown", domain: "onboarding", text: "这台上跑的东西我认不出来，先放在「还没归项目」里。它照样有人看着，你想起来了随时归。", vars: [], tone: "neutral", source: "补充" },
  "onboarding.missing.address": { id: "onboarding.missing.address", domain: "onboarding", text: "我没在这段里找到机器地址，你把 IP 或者域名再给我一次？", vars: [], tone: "", source: "补充" },
  "onboarding.missing.secret": { id: "onboarding.missing.secret", domain: "onboarding", text: "我没看到密码或者密钥。你从服务商控制台复制一份，或者把私钥文件拖进来。", vars: [], tone: "", source: "补充" },
  "onboarding.missing.username": { id: "onboarding.missing.username", domain: "onboarding", text: "没看到用哪个账号登录，一般是 root，你确认一下？", vars: [], tone: "", source: "补充" },
  "onboarding.page.subtitle": { id: "onboarding.page.subtitle", domain: "onboarding", text: "把 AI 给你的那行连接命令原样贴进来就行，剩下的我来。", vars: [], tone: "", source: "设计稿 · 加一台机器" },
  "onboarding.page.title": { id: "onboarding.page.title", domain: "onboarding", text: "加一台机器", vars: [], tone: "", source: "设计稿 · 加一台机器" },
  "onboarding.passphrase.placeholder": { id: "onboarding.passphrase.placeholder", domain: "onboarding", text: "私钥有口令的话填这里；没有就空着", vars: [], tone: "", source: "arron 2026-09-01（贯通 passphrase 时补）" },
  "onboarding.paste.note": { id: "onboarding.paste.note", domain: "onboarding", text: "粘贴后我会立刻加一把只属于小队的钥匙。你给的那份我留着，加密存在这台机器的档案里——我这边万一挂了，你照样进得去。", vars: [], tone: "", source: "设计稿 · 加一台机器（arron 2026-08-09 拍板改）" },
  "onboarding.paste.placeholder": { id: "onboarding.paste.placeholder", domain: "onboarding", text: "# 支持这几种，随便哪种都认\nssh root@203.0.113.44 -p 22\n|\nHost: 203.0.113.44  User: root\nPassword: ••••••••••••", vars: [], tone: "", source: "设计稿 · 加一台机器" },
  "onboarding.probe.connect.detail": { id: "onboarding.probe.connect.detail", domain: "onboarding", text: "{distro} · {cpu_cores} vCPU · {mem_gb} GB", vars: ["cpu_cores", "distro", "mem_gb"], tone: "", source: "设计稿 · 加一台机器" },
  "onboarding.probe.connect.done": { id: "onboarding.probe.connect.done", domain: "onboarding", text: "连上了", vars: [], tone: "ok", source: "设计稿 · 加一台机器" },
  "onboarding.probe.fingerprint.detail": { id: "onboarding.probe.fingerprint.detail", domain: "onboarding", text: "{workload_names}", vars: ["workload_names"], tone: "", source: "设计稿 · 加一台机器" },
  "onboarding.probe.fingerprint.done": { id: "onboarding.probe.fingerprint.done", domain: "onboarding", text: "看到它在跑 {container_count} 个容器和一个数据库", vars: ["container_count"], tone: "ok", source: "设计稿 · 加一台机器" },
  "onboarding.probe.heading": { id: "onboarding.probe.heading", domain: "onboarding", text: "正在认这台机器…", vars: [], tone: "", source: "设计稿 · 加一台机器" },
  "onboarding.probe.install_agent.detail": { id: "onboarding.probe.install_agent.detail", domain: "onboarding", text: "agent {agent_version} · 约 {seconds} 秒", vars: ["agent_version", "seconds"], tone: "", source: "设计稿 · 加一台机器" },
  "onboarding.probe.install_agent.running": { id: "onboarding.probe.install_agent.running", domain: "onboarding", text: "正在装探针，之后我就能一直看着它了", vars: [], tone: "", source: "设计稿 · 加一台机器" },
  "onboarding.probe.security_check.detail": { id: "onboarding.probe.security_check.detail", domain: "onboarding", text: "ufw: {port}/tcp → 仅小队网关", vars: ["port"], tone: "", source: "设计稿 · 加一台机器" },
  "onboarding.probe.security_check.narrowed": { id: "onboarding.probe.security_check.narrowed", domain: "onboarding", text: "顺手发现 {port} 端口对全网开着，我给收窄了", vars: ["port"], tone: "ok", source: "设计稿 · 加一台机器" },
  "onboarding.probe.takeover_key.detail": { id: "onboarding.probe.takeover_key.detail", domain: "onboarding", text: "ed25519 · 只允许小队来源 IP", vars: [], tone: "", source: "设计稿 · 加一台机器" },
  "onboarding.probe.takeover_key.done": { id: "onboarding.probe.takeover_key.done", domain: "onboarding", text: "加了一把小队自己的钥匙，你原来那把我没动；你给的那份也替你留着了", vars: [], tone: "ok", source: "设计稿 · 加一台机器（arron 2026-08-09 拍板改）" },
  "onboarding.step.hands_off.body": { id: "onboarding.step.hands_off.body", domain: "onboarding", text: "以后换了哪个 AI 助手来干活，它都从小队这儿拿钥匙 —— 你再也不用翻聊天记录找 IP 和密码。", vars: [], tone: "", source: "设计稿 · 加一台机器" },
  "onboarding.step.hands_off.title": { id: "onboarding.step.hands_off.title", domain: "onboarding", text: "从此不用管", vars: [], tone: "", source: "设计稿 · 加一台机器" },
  "onboarding.step.identify.body": { id: "onboarding.step.identify.body", domain: "onboarding", text: "看它跑了什么、属于哪个项目、有没有明显毛病，然后装上探针。全程大概 40 秒。", vars: [], tone: "", source: "设计稿 · 加一台机器" },
  "onboarding.step.identify.title": { id: "onboarding.step.identify.title", domain: "onboarding", text: "我去认一认这台机器", vars: [], tone: "", source: "设计稿 · 加一台机器" },
  "onboarding.step.paste.title": { id: "onboarding.step.paste.title", domain: "onboarding", text: "贴进来", vars: [], tone: "", source: "设计稿 · 加一台机器" },
  "onboarding.takeover.extra_lines_removed": { id: "onboarding.takeover.extra_lines_removed", domain: "onboarding", text: "换钥匙的时候，我把这台机器上 {count} 条写着我名字的旧记录清掉了——按理只该有 1 条。动手之前的原样我存在 {backup}，要恢复直接把它挪回来。", vars: ["backup", "count"], tone: "warn", source: "补充" },
  "ops_backup.drill.confirm.body": { id: "ops_backup.drill.confirm.body", domain: "ops_backup", text: "我会新建一个一次性的空库，把这份备份还原进去，检查完就把那个空库删掉。你现在用的库一个字都不会动，也不会中断。", vars: [], tone: "", source: "补充" },
  "ops_backup.drill.confirm.title": { id: "ops_backup.drill.confirm.title", domain: "ops_backup", text: "拿这份备份演练一次恢复", vars: [], tone: "", source: "补充" },
  "ops_backup.drill.cta": { id: "ops_backup.drill.cta", domain: "ops_backup", text: "拿这份演练一次", vars: [], tone: "", source: "补充" },
  "ops_backup.drill.database": { id: "ops_backup.drill.database", domain: "ops_backup", text: "演练用的一次性库是 {database}，跑完已经删掉", vars: ["database"], tone: "", source: "补充" },
  "ops_backup.drill.explain": { id: "ops_backup.drill.explain", domain: "ops_backup", text: "演练是另找一个空库把这份备份还原一遍，看它还原得回来。你现在用的这个库一个字都不会动。", vars: [], tone: "", source: "补充" },
  "ops_backup.drill.heading": { id: "ops_backup.drill.heading", domain: "ops_backup", text: "恢复演练", vars: [], tone: "", source: "补充" },
  "ops_backup.drill.last.success": { id: "ops_backup.drill.last.success", domain: "ops_backup", text: "最近一次演练通过是 {when}，用的是 {snapshot}", vars: ["snapshot", "when"], tone: "ok", source: "补充" },
  "ops_backup.drill.none": { id: "ops_backup.drill.none", domain: "ops_backup", text: "还没有演练过。一份没有还原过的备份，只能算「大概能用」。", vars: [], tone: "warn", source: "补充" },
  "ops_backup.drill.not_restorable": { id: "ops_backup.drill.not_restorable", domain: "ops_backup", text: "这一条不能拿来演练——只有成功备份下来的那些才有东西可以还原。", vars: [], tone: "warn", source: "补充" },
  "ops_backup.executor.missing": { id: "ops_backup.executor.missing", domain: "ops_backup", text: "还没接上跑备份的那台机器。你在这儿点的会记下来排队，但在接上之前它不会真的开始跑。", vars: [], tone: "warn", source: "补充" },
  "ops_backup.executor.ok": { id: "ops_backup.executor.ok", domain: "ops_backup", text: "跑备份的那台机器在线，{when} 露过面。", vars: ["when"], tone: "ok", source: "补充" },
  "ops_backup.executor.queued_but_offline": { id: "ops_backup.executor.queued_but_offline", domain: "ops_backup", text: "这条还没有人来领——那台机器不在线。它不会自己过期，接上之后会接着跑。", vars: [], tone: "warn", source: "补充" },
  "ops_backup.executor.stale": { id: "ops_backup.executor.stale", domain: "ops_backup", text: "那台机器已经 {when} 没露面了。排队的这些得等它回来才会动。", vars: ["when"], tone: "warn", source: "补充" },
  "ops_backup.failure.checksum_mismatch": { id: "ops_backup.failure.checksum_mismatch", domain: "ops_backup", text: "导出来的文件校验对不上，我把它删了——一份校验不过的备份比没有备份更骗人。", vars: [], tone: "danger", source: "补充" },
  "ops_backup.failure.disk_full": { id: "ops_backup.failure.disk_full", domain: "ops_backup", text: "那台机器上没地方了，备份没敢开始——它要求至少留出两倍数据库大小的空间。先清一清再来。", vars: [], tone: "danger", source: "补充" },
  "ops_backup.failure.dump_failed": { id: "ops_backup.failure.dump_failed", domain: "ops_backup", text: "导出的时候数据库那边报错了，这次没有留下半份文件。", vars: [], tone: "danger", source: "补充" },
  "ops_backup.failure.locked": { id: "ops_backup.failure.locked", domain: "ops_backup", text: "那台机器上已经有一次备份在跑，这次没排上。", vars: [], tone: "warn", source: "补充" },
  "ops_backup.failure.restore_failed": { id: "ops_backup.failure.restore_failed", domain: "ops_backup", text: "还原到那个空库的时候失败了。这份备份可能是坏的，先别指望它。", vars: [], tone: "danger", source: "补充" },
  "ops_backup.failure.unknown": { id: "ops_backup.failure.unknown", domain: "ops_backup", text: "没跑成，那台机器报的原因我这边不认识（{code}）。详细过程在服务器的日志里。", vars: ["code"], tone: "danger", source: "补充" },
  "ops_backup.history.by": { id: "ops_backup.history.by", domain: "ops_backup", text: "{who} 点的", vars: ["who"], tone: "", source: "补充" },
  "ops_backup.history.by.schedule": { id: "ops_backup.history.by.schedule", domain: "ops_backup", text: "定时跑的", vars: [], tone: "", source: "补充" },
  "ops_backup.history.empty": { id: "ops_backup.history.empty", domain: "ops_backup", text: "还没有任何记录。第一次备份跑完就会出现在这儿。", vars: [], tone: "", source: "补充" },
  "ops_backup.history.heading": { id: "ops_backup.history.heading", domain: "ops_backup", text: "每一次的记录", vars: [], tone: "", source: "补充" },
  "ops_backup.history.kind.backup": { id: "ops_backup.history.kind.backup", domain: "ops_backup", text: "备份", vars: [], tone: "", source: "补充" },
  "ops_backup.history.kind.restore_drill": { id: "ops_backup.history.kind.restore_drill", domain: "ops_backup", text: "恢复演练", vars: [], tone: "", source: "补充" },
  "ops_backup.history.status.failed": { id: "ops_backup.history.status.failed", domain: "ops_backup", text: "没成", vars: [], tone: "danger", source: "补充" },
  "ops_backup.history.status.queued": { id: "ops_backup.history.status.queued", domain: "ops_backup", text: "排队中", vars: [], tone: "warn", source: "补充" },
  "ops_backup.history.status.running": { id: "ops_backup.history.status.running", domain: "ops_backup", text: "正在跑", vars: [], tone: "warn", source: "补充" },
  "ops_backup.history.status.succeeded": { id: "ops_backup.history.status.succeeded", domain: "ops_backup", text: "成了", vars: [], tone: "ok", source: "补充" },
  "ops_backup.history.stepup": { id: "ops_backup.history.stepup", domain: "ops_backup", text: "当场验过身份", vars: [], tone: "", source: "补充" },
  "ops_backup.history.took": { id: "ops_backup.history.took", domain: "ops_backup", text: "用了 {seconds} 秒", vars: ["seconds"], tone: "", source: "补充" },
  "ops_backup.last.failure": { id: "ops_backup.last.failure", domain: "ops_backup", text: "最近一次没成是 {when}", vars: ["when"], tone: "danger", source: "补充" },
  "ops_backup.last.failure.none": { id: "ops_backup.last.failure.none", domain: "ops_backup", text: "还没有失败过。", vars: [], tone: "", source: "补充" },
  "ops_backup.last.success": { id: "ops_backup.last.success", domain: "ops_backup", text: "最近一次备份成功是 {when}", vars: ["when"], tone: "ok", source: "补充" },
  "ops_backup.last.success.none": { id: "ops_backup.last.success.none", domain: "ops_backup", text: "还没有成功备份过一次。", vars: [], tone: "warn", source: "补充" },
  "ops_backup.page.subtitle": { id: "ops_backup.page.subtitle", domain: "ops_backup", text: "平台自己那个数据库的备份情况。这里存的是你所有项目、机器和凭证的档案，丢了没法重来。", vars: [], tone: "", source: "补充" },
  "ops_backup.page.title": { id: "ops_backup.page.title", domain: "ops_backup", text: "数据备份", vars: [], tone: "", source: "补充" },
  "ops_backup.plan.destination": { id: "ops_backup.plan.destination", domain: "ops_backup", text: "存到 {destination}", vars: ["destination"], tone: "", source: "补充" },
  "ops_backup.plan.heading": { id: "ops_backup.plan.heading", domain: "ops_backup", text: "备份计划", vars: [], tone: "", source: "补充" },
  "ops_backup.plan.next": { id: "ops_backup.plan.next", domain: "ops_backup", text: "下一次 {when}", vars: ["when"], tone: "", source: "补充" },
  "ops_backup.plan.next.unknown": { id: "ops_backup.plan.next.unknown", domain: "ops_backup", text: "下一次什么时候跑，那台机器没报上来", vars: [], tone: "", source: "补充" },
  "ops_backup.plan.none": { id: "ops_backup.plan.none", domain: "ops_backup", text: "还没有定时备份。现在只能手动点一次；要它每天自己跑，得先在服务器上装一个定时任务。", vars: [], tone: "warn", source: "补充" },
  "ops_backup.plan.reported": { id: "ops_backup.plan.reported", domain: "ops_backup", text: "这份计划是那台机器 {when} 报上来的", vars: ["when"], tone: "", source: "补充" },
  "ops_backup.plan.retention": { id: "ops_backup.plan.retention", domain: "ops_backup", text: "保留 {days} 天", vars: ["days"], tone: "", source: "补充" },
  "ops_backup.plan.schedule": { id: "ops_backup.plan.schedule", domain: "ops_backup", text: "{schedule}", vars: ["schedule"], tone: "", source: "补充" },
  "ops_backup.run.busy": { id: "ops_backup.run.busy", domain: "ops_backup", text: "已经有一次在跑了，等它跑完再来。同时跑两次会互相挤，谁都跑不完。", vars: [], tone: "warn", source: "补充" },
  "ops_backup.run.cta": { id: "ops_backup.run.cta", domain: "ops_backup", text: "现在备份一份", vars: [], tone: "", source: "补充" },
  "ops_backup.run.forbidden": { id: "ops_backup.run.forbidden", domain: "ops_backup", text: "备份和演练只有老板点得了。", vars: [], tone: "", source: "补充" },
  "ops_backup.run.queued": { id: "ops_backup.run.queued", domain: "ops_backup", text: "记下了。那台机器来领之后就开始，这一屏会跟着变。", vars: [], tone: "ok", source: "补充" },
  "ops_backup.snapshot.size": { id: "ops_backup.snapshot.size", domain: "ops_backup", text: "{size}", vars: ["size"], tone: "", source: "补充" },
  "ops_backup.state.heading": { id: "ops_backup.state.heading", domain: "ops_backup", text: "现在怎么样", vars: [], tone: "", source: "补充" },
  "ops_backup.state.idle": { id: "ops_backup.state.idle", domain: "ops_backup", text: "现在没有备份在跑。", vars: [], tone: "", source: "补充" },
  "ops_backup.state.queued": { id: "ops_backup.state.queued", domain: "ops_backup", text: "已经记下了，等那台机器来领。它每分钟看一次。", vars: [], tone: "warn", source: "补充" },
  "ops_backup.state.running": { id: "ops_backup.state.running", domain: "ops_backup", text: "正在备份，开始于 {when}", vars: ["when"], tone: "warn", source: "补充" },
  "ops_backup.state.running.drill": { id: "ops_backup.state.running.drill", domain: "ops_backup", text: "正在做恢复演练，开始于 {when}", vars: ["when"], tone: "warn", source: "补充" },
  "pjhub.action.create": { id: "pjhub.action.create", domain: "pjhub", text: "新建项目", vars: [], tone: "", source: "设计稿 · hub" },
  "pjhub.action.retry": { id: "pjhub.action.retry", domain: "pjhub", text: "重试", vars: [], tone: "", source: "设计稿 · hubUnverified / listError" },
  "pjhub.builtin": { id: "pjhub.builtin", domain: "pjhub", text: "内置", vars: [], tone: "", source: "任务说明 · is_builtin 项目仍列出，当作普通内置项目" },
  "pjhub.col.activity": { id: "pjhub.col.activity", domain: "pjhub", text: "最后活动", vars: [], tone: "", source: "任务说明 · 表格列" },
  "pjhub.col.env": { id: "pjhub.col.env", domain: "pjhub", text: "正式 / 测试", vars: [], tone: "", source: "任务说明 · test/production 列，第一屏用人话" },
  "pjhub.col.health": { id: "pjhub.col.health", domain: "pjhub", text: "健康", vars: [], tone: "", source: "任务说明 · 表格列" },
  "pjhub.col.name": { id: "pjhub.col.name", domain: "pjhub", text: "名称", vars: [], tone: "", source: "任务说明 · 表格列" },
  "pjhub.col.recent_release": { id: "pjhub.col.recent_release", domain: "pjhub", text: "最近发布", vars: [], tone: "", source: "任务说明 · 表格列" },
  "pjhub.col.recent_task": { id: "pjhub.col.recent_task", domain: "pjhub", text: "最近任务", vars: [], tone: "", source: "任务说明 · 表格列" },
  "pjhub.col.resource": { id: "pjhub.col.resource", domain: "pjhub", text: "资源异常", vars: [], tone: "", source: "任务说明 · 表格列" },
  "pjhub.empty.body": { id: "pjhub.empty.body", domain: "pjhub", text: "你不用逐个字段填。点「把一个现成项目接进来」，平台给你一段话，你转发给当初帮你做这个项目的 AI，它会把仓库、服务器、域名、环境和付费服务整理好交回来。也可以先新建一个空项目。", vars: [], tone: "", source: "设计稿 · listEmpty" },
  "pjhub.empty.title": { id: "pjhub.empty.title", domain: "pjhub", text: "把已经上线的项目导进来", vars: [], tone: "", source: "设计稿 · listEmpty" },
  "pjhub.error.body": { id: "pjhub.error.body", domain: "pjhub", text: "这不是「你没有项目」。列表暂时读不到，所以数字写成未核验，不写成 0。", vars: [], tone: "danger", source: "设计稿 · listError（读不到 ≠ 没有）" },
  "pjhub.error.title": { id: "pjhub.error.title", domain: "pjhub", text: "没能读到项目列表", vars: [], tone: "danger", source: "设计稿 · listError" },
  "pjhub.filter.all": { id: "pjhub.filter.all", domain: "pjhub", text: "全部", vars: [], tone: "", source: "设计稿 · hub" },
  "pjhub.filter.empty": { id: "pjhub.filter.empty", domain: "pjhub", text: "没有符合这些条件的项目。", vars: [], tone: "", source: "补充 · 搜索/筛选后为空，不是整份列表为空" },
  "pjhub.filter.needs_attention": { id: "pjhub.filter.needs_attention", domain: "pjhub", text: "需处理", vars: [], tone: "", source: "任务说明 · 筛选" },
  "pjhub.filter.unverified": { id: "pjhub.filter.unverified", domain: "pjhub", text: "未核验", vars: [], tone: "warn", source: "任务说明 · 筛选" },
  "pjhub.loading.hint": { id: "pjhub.loading.hint", domain: "pjhub", text: "已经发出请求，还没有回应。不会先拿上一次的数据顶着。", vars: [], tone: "", source: "SPEC-components · Skeleton" },
  "pjhub.loading.title": { id: "pjhub.loading.title", domain: "pjhub", text: "正在读取项目列表", vars: [], tone: "", source: "设计稿 · listLoading" },
  "pjhub.new.name": { id: "pjhub.new.name", domain: "pjhub", text: "项目叫什么", vars: [], tone: "", source: "与导入向导同一问法" },
  "pjhub.new.slug": { id: "pjhub.new.slug", domain: "pjhub", text: "标识，可不填", vars: [], tone: "", source: "补充 · slug 可选，第一屏不出现 slug 这个词" },
  "pjhub.new.submitting": { id: "pjhub.new.submitting", domain: "pjhub", text: "正在建", vars: [], tone: "", source: "补充 · 提交中" },
  "pjhub.new.subtitle": { id: "pjhub.new.subtitle", domain: "pjhub", text: "先起个名字。标识可以先空着，我来补。", vars: [], tone: "", source: "补充 · 新建页" },
  "pjhub.new.title": { id: "pjhub.new.title", domain: "pjhub", text: "新建项目", vars: [], tone: "", source: "设计稿 · hub 按钮同句" },
  "pjhub.notice.missing_fields.body": { id: "pjhub.notice.missing_fields.body", domain: "pjhub", text: "有的汇总数字还读不到。读不到的写成「未核验」，不写成 0。", vars: [], tone: "warn", source: "任务说明 · 查询失败时不编 0" },
  "pjhub.notice.not_switcher.body": { id: "pjhub.notice.not_switcher.body", domain: "pjhub", text: "它是管理入口：能新建、能导入、能比较。切项目也从这儿走——顶栏没有下拉切换器，当前项目由网址决定。", vars: [], tone: "", source: "设计稿 · hub" },
  "pjhub.notice.not_switcher.title": { id: "pjhub.notice.not_switcher.title", domain: "pjhub", text: "这一页不是项目切换器", vars: [], tone: "", source: "设计稿 · hub" },
  "pjhub.notice.unverified.body": { id: "pjhub.notice.unverified.body", domain: "pjhub", text: "读不到的数字现在是「未核验」，不是 0——填 0 会让你以为真的没有任务在跑。", vars: [], tone: "warn", source: "设计稿 · hubUnverified" },
  "pjhub.notice.unverified.title": { id: "pjhub.notice.unverified.title", domain: "pjhub", text: "汇总还没核验", vars: [], tone: "warn", source: "设计稿 · hubUnverified" },
  "pjhub.notice.unverified.why": { id: "pjhub.notice.unverified.why", domain: "pjhub", text: "0 和「不知道」是两件事。读不到的时候写 0，你会以为没事；写「未核验」，你才知道要么重试要么先别信这个数。", vars: [], tone: "", source: "设计稿 · hubUnverified" },
  "pjhub.resource.has": { id: "pjhub.resource.has", domain: "pjhub", text: "有要留意的", vars: [], tone: "", source: "设计稿 · hub 资源异常列（有事实的一侧）" },
  "pjhub.resource.none": { id: "pjhub.resource.none", domain: "pjhub", text: "没有", vars: [], tone: "", source: "设计稿 · hub 资源异常列（查到且无问题的一侧）" },
  "pjhub.search.placeholder": { id: "pjhub.search.placeholder", domain: "pjhub", text: "搜项目名或简介", vars: [], tone: "", source: "设计稿 · hub 搜索栏（按现有字段：名称 / slug / 简介）" },
  "pjhub.sort.hint": { id: "pjhub.sort.hint", domain: "pjhub", text: "要你处理的排最前", vars: [], tone: "", source: "设计稿 · hub" },
  "pjhub.stat.healthy": { id: "pjhub.stat.healthy", domain: "pjhub", text: "健康", vars: [], tone: "", source: "任务说明 · 汇总" },
  "pjhub.stat.needs_attention": { id: "pjhub.stat.needs_attention", domain: "pjhub", text: "需处理", vars: [], tone: "", source: "设计稿 · hub 汇总带" },
  "pjhub.stat.projects": { id: "pjhub.stat.projects", domain: "pjhub", text: "项目", vars: [], tone: "", source: "设计稿 · hub 汇总带" },
  "pjhub.stat.running_releases": { id: "pjhub.stat.running_releases", domain: "pjhub", text: "运行中发布", vars: [], tone: "", source: "任务说明 · 汇总" },
  "pjhub.stat.running_tasks": { id: "pjhub.stat.running_tasks", domain: "pjhub", text: "运行中任务", vars: [], tone: "", source: "任务说明 · 汇总" },
  "pjhub.subtitle": { id: "pjhub.subtitle", domain: "pjhub", text: "所有你能进的项目都在这儿。上面一条是跨项目的真实汇总，下面按「要你处理的排最前」列出来。", vars: [], tone: "", source: "设计稿 · hub" },
  "pjhub.subtitle.unverified": { id: "pjhub.subtitle.unverified", domain: "pjhub", text: "汇总数字暂时读不到。列表还在，能进项目。", vars: [], tone: "", source: "设计稿 · hubUnverified" },
  "pjhub.title": { id: "pjhub.title", domain: "pjhub", text: "项目中心", vars: [], tone: "", source: "设计稿 · hub" },
  "pjhub.value.unverified": { id: "pjhub.value.unverified", domain: "pjhub", text: "未核验", vars: [], tone: "warn", source: "设计稿 · 没有事实时显示「未核验」，不填 0" },
  "pjshell.capacity.cpu": { id: "pjshell.capacity.cpu", domain: "pjshell", text: "CPU", vars: [], tone: "", source: "设计稿 · pjHome" },
  "pjshell.capacity.disk": { id: "pjshell.capacity.disk", domain: "pjshell", text: "磁盘", vars: [], tone: "", source: "设计稿 · pjHome" },
  "pjshell.capacity.expiry": { id: "pjshell.capacity.expiry", domain: "pjshell", text: "到期", vars: [], tone: "", source: "设计稿 · pjHome" },
  "pjshell.capacity.host": { id: "pjshell.capacity.host", domain: "pjshell", text: "机器", vars: [], tone: "", source: "设计稿 · pjHome" },
  "pjshell.capacity.memory": { id: "pjshell.capacity.memory", domain: "pjshell", text: "内存", vars: [], tone: "", source: "设计稿 · pjHome" },
  "pjshell.chat.attach": { id: "pjshell.chat.attach", domain: "pjshell", text: "附件", vars: [], tone: "", source: "项目模块 V2 · 对话页" },
  "pjshell.chat.attach.blocked": { id: "pjshell.chat.attach.blocked", domain: "pjshell", text: "这边还不能把文件发出去。", vars: [], tone: "", source: "项目模块 V2 · 对话页" },
  "pjshell.chat.can.assign": { id: "pjshell.chat.can.assign", domain: "pjshell", text: "交给 Agent", vars: [], tone: "", source: "设计稿 · pjChat" },
  "pjshell.chat.can.assign.body": { id: "pjshell.chat.can.assign.body", domain: "pjshell", text: "@Claude、@Grok 直接点名，或让 Lulu 决定派谁", vars: [], tone: "", source: "设计稿 · pjChat" },
  "pjshell.chat.can.auto": { id: "pjshell.chat.can.auto", domain: "pjshell", text: "自动接上", vars: [], tone: "", source: "设计稿 · pjChat" },
  "pjshell.chat.can.auto.body": { id: "pjshell.chat.can.auto.body", domain: "pjshell", text: "进来就是这个项目最近那条会话，不用挑", vars: [], tone: "", source: "设计稿 · pjChat" },
  "pjshell.chat.can.send": { id: "pjshell.chat.can.send", domain: "pjshell", text: "能发什么", vars: [], tone: "", source: "设计稿 · pjChat" },
  "pjshell.chat.can.send.body": { id: "pjshell.chat.can.send.body", domain: "pjshell", text: "文字、按住说话、拖附件进来", vars: [], tone: "", source: "设计稿 · pjChat" },
  "pjshell.chat.can.status": { id: "pjshell.chat.can.status", domain: "pjshell", text: "任务状态", vars: [], tone: "", source: "设计稿 · pjChat" },
  "pjshell.chat.can.status.body": { id: "pjshell.chat.can.status.body", domain: "pjshell", text: "Agent 回复带真实状态，不是\"正在思考\"的占位", vars: [], tone: "", source: "设计稿 · pjChat" },
  "pjshell.chat.can.title": { id: "pjshell.chat.can.title", domain: "pjshell", text: "这个框能做什么", vars: [], tone: "", source: "设计稿 · pjChat" },
  "pjshell.chat.can.value": { id: "pjshell.chat.can.value", domain: "pjshell", text: "简版 Lulu", vars: [], tone: "", source: "设计稿 · pjChat" },
  "pjshell.chat.cannot.manage": { id: "pjshell.chat.cannot.manage", domain: "pjshell", text: "会话管理", vars: [], tone: "", source: "设计稿 · pjChat" },
  "pjshell.chat.cannot.manage.body": { id: "pjshell.chat.cannot.manage.body", domain: "pjshell", text: "新建、归档、多会话并排都在 Lulu 页", vars: [], tone: "", source: "设计稿 · pjChat" },
  "pjshell.chat.cannot.orch": { id: "pjshell.chat.cannot.orch", domain: "pjshell", text: "多 Agent 编排", vars: [], tone: "", source: "设计稿 · pjChat" },
  "pjshell.chat.cannot.orch.body": { id: "pjshell.chat.cannot.orch.body", domain: "pjshell", text: "完整的调度视图在 Lulu 页", vars: [], tone: "", source: "设计稿 · pjChat" },
  "pjshell.chat.cannot.other": { id: "pjshell.chat.cannot.other", domain: "pjshell", text: "别的项目", vars: [], tone: "", source: "设计稿 · pjChat" },
  "pjshell.chat.cannot.other.body": { id: "pjshell.chat.cannot.other.body", domain: "pjshell", text: "看不到，也搜不到——跨项目搜索走全局搜索", vars: [], tone: "", source: "设计稿 · pjChat" },
  "pjshell.chat.cannot.switcher": { id: "pjshell.chat.cannot.switcher", domain: "pjshell", text: "项目切换器", vars: [], tone: "", source: "设计稿 · pjChat" },
  "pjshell.chat.cannot.switcher.body": { id: "pjshell.chat.cannot.switcher.body", domain: "pjshell", text: "没有。要换项目回项目中心", vars: [], tone: "", source: "设计稿 · pjChat" },
  "pjshell.chat.cannot.title": { id: "pjshell.chat.cannot.title", domain: "pjshell", text: "这个框不做什么", vars: [], tone: "", source: "设计稿 · pjChat" },
  "pjshell.chat.cannot.value": { id: "pjshell.chat.cannot.value", domain: "pjshell", text: "留给一级 Lulu", vars: [], tone: "", source: "设计稿 · pjChat" },
  "pjshell.chat.context": { id: "pjshell.chat.context", domain: "pjshell", text: "当前上下文：{name}", vars: ["name"], tone: "", source: "设计稿 · pjChat" },
  "pjshell.chat.current": { id: "pjshell.chat.current", domain: "pjshell", text: "当前会话", vars: [], tone: "", source: "设计稿 · pjChat" },
  "pjshell.chat.open_full": { id: "pjshell.chat.open_full", domain: "pjshell", text: "在 Lulu 完整打开", vars: [], tone: "", source: "项目模块 V2 · 对话页" },
  "pjshell.chat.placeholder": { id: "pjshell.chat.placeholder", domain: "pjshell", text: "说需求就行，比如「优惠券入口挪到金额下方」。@ 可以点名某个 Agent。", vars: [], tone: "", source: "设计稿 · pjChat" },
  "pjshell.chat.split": { id: "pjshell.chat.split", domain: "pjshell", text: "和一级 Lulu 的分工", vars: [], tone: "", source: "设计稿 · pjChat" },
  "pjshell.chat.subtitle": { id: "pjshell.chat.subtitle", domain: "pjshell", text: "进来就自动接上这个项目最近的那条会话。只带当前项目的上下文，不显示项目切换器，也看不到别的项目。", vars: [], tone: "", source: "设计稿 · pjChat" },
  "pjshell.chat.voice.blocked": { id: "pjshell.chat.voice.blocked", domain: "pjshell", text: "这边还不能发语音。", vars: [], tone: "", source: "项目模块 V2 · 对话页" },
  "pjshell.env.address": { id: "pjshell.env.address", domain: "pjshell", text: "地址", vars: [], tone: "", source: "设计稿 · pjEnv" },
  "pjshell.env.certificate.stored": { id: "pjshell.env.certificate.stored", domain: "pjshell", text: "已安全保管", vars: [], tone: "", source: "2026-09-10 用户要求补齐域名与证书闭环" },
  "pjshell.env.col.cert": { id: "pjshell.env.col.cert", domain: "pjshell", text: "证书", vars: [], tone: "", source: "设计稿 · pjEnv 域名表" },
  "pjshell.env.col.expiry": { id: "pjshell.env.col.expiry", domain: "pjshell", text: "到期", vars: [], tone: "", source: "设计稿 · pjEnv 域名表" },
  "pjshell.env.col.point": { id: "pjshell.env.col.point", domain: "pjshell", text: "指向", vars: [], tone: "", source: "设计稿 · pjEnv 域名表" },
  "pjshell.env.col.resolve": { id: "pjshell.env.col.resolve", domain: "pjshell", text: "解析到", vars: [], tone: "", source: "设计稿 · pjEnv 域名表" },
  "pjshell.env.col.state": { id: "pjshell.env.col.state", domain: "pjshell", text: "状态", vars: [], tone: "", source: "设计稿 · pjEnv 域名表" },
  "pjshell.env.configure": { id: "pjshell.env.configure", domain: "pjshell", text: "配置环境", vars: [], tone: "", source: "2026-09-10 用户要求补齐域名与证书闭环" },
  "pjshell.env.configure.body": { id: "pjshell.env.configure.body", domain: "pjshell", text: "选择环境和机器。域名、证书有什么就填什么，没有可以留空；部署时再检查是否满足上线条件。", vars: [], tone: "", source: "2026-09-10 用户要求环境资料自由配置" },
  "pjshell.env.configure.domain": { id: "pjshell.env.configure.domain", domain: "pjshell", text: "域名", vars: [], tone: "", source: "2026-09-10 用户要求补齐域名与证书闭环" },
  "pjshell.env.configure.done": { id: "pjshell.env.configure.done", domain: "pjshell", text: "环境资料已保存，尚未满足的部署条件会继续显示在页面上。", vars: [], tone: "", source: "2026-09-10 用户要求环境资料自由配置" },
  "pjshell.env.configure.files": { id: "pjshell.env.configure.files", domain: "pjshell", text: "证书文件", vars: [], tone: "", source: "2026-09-10 用户要求补齐域名与证书闭环" },
  "pjshell.env.configure.files_hint": { id: "pjshell.env.configure.files_hint", domain: "pjshell", text: "可以选整个证书包，或者同时选择证书和私钥。我不会显示或下载私钥。", vars: [], tone: "", source: "2026-09-10 用户要求补齐域名与证书闭环" },
  "pjshell.env.configure.machine": { id: "pjshell.env.configure.machine", domain: "pjshell", text: "使用哪台机器", vars: [], tone: "", source: "2026-09-10 用户要求补齐域名与证书闭环" },
  "pjshell.env.configure.pick": { id: "pjshell.env.configure.pick", domain: "pjshell", text: "选择证书包", vars: [], tone: "", source: "2026-09-10 用户要求补齐域名与证书闭环" },
  "pjshell.env.configure.pick_folder": { id: "pjshell.env.configure.pick_folder", domain: "pjshell", text: "选择整个文件夹", vars: [], tone: "", source: "2026-09-10 用户提供完整证书目录" },
  "pjshell.env.configure.ready": { id: "pjshell.env.configure.ready", domain: "pjshell", text: "环境资料已保存，这台机器当前可以部署。", vars: [], tone: "", source: "2026-09-10 用户要求环境资料自由配置" },
  "pjshell.env.configure.submit": { id: "pjshell.env.configure.submit", domain: "pjshell", text: "保存资料", vars: [], tone: "", source: "2026-09-10 用户要求环境资料自由配置" },
  "pjshell.env.configure.target": { id: "pjshell.env.configure.target", domain: "pjshell", text: "放到哪里", vars: [], tone: "", source: "2026-09-10 用户要求补齐域名与证书闭环" },
  "pjshell.env.configure.title": { id: "pjshell.env.configure.title", domain: "pjshell", text: "配置环境资料", vars: [], tone: "", source: "2026-09-10 用户要求环境资料自由配置" },
  "pjshell.env.domain.registered": { id: "pjshell.env.domain.registered", domain: "pjshell", text: "已登记", vars: [], tone: "", source: "2026-09-10 用户要求补齐域名与证书闭环" },
  "pjshell.env.domain.verified": { id: "pjshell.env.domain.verified", domain: "pjshell", text: "已解析", vars: [], tone: "", source: "2026-09-10 用户要求补齐域名与证书闭环" },
  "pjshell.env.domain.waiting": { id: "pjshell.env.domain.waiting", domain: "pjshell", text: "等待解析", vars: [], tone: "", source: "2026-09-10 用户要求补齐域名与证书闭环" },
  "pjshell.env.domains": { id: "pjshell.env.domains", domain: "pjshell", text: "域名", vars: [], tone: "", source: "设计稿 · pjEnv" },
  "pjshell.env.group": { id: "pjshell.env.group", domain: "pjshell", text: "两套环境", vars: [], tone: "", source: "设计稿 · pjEnv" },
  "pjshell.env.machine": { id: "pjshell.env.machine", domain: "pjshell", text: "机器", vars: [], tone: "", source: "设计稿 · pjEnv" },
  "pjshell.env.no_bundle": { id: "pjshell.env.no_bundle", domain: "pjshell", text: "还没有可搬的包", vars: [], tone: "", source: "项目模块 V2 · 环境页" },
  "pjshell.env.open": { id: "pjshell.env.open", domain: "pjshell", text: "打开网站", vars: [], tone: "", source: "设计稿 · pjEnv" },
  "pjshell.env.probe": { id: "pjshell.env.probe", domain: "pjshell", text: "探测", vars: [], tone: "", source: "设计稿 · pjEnv" },
  "pjshell.env.production": { id: "pjshell.env.production", domain: "pjshell", text: "正式", vars: [], tone: "", source: "项目模块 V2 · 环境页" },
  "pjshell.env.production.title": { id: "pjshell.env.production.title", domain: "pjshell", text: "正式 · 用户在用的", vars: [], tone: "", source: "设计稿 · pjEnv" },
  "pjshell.env.promote": { id: "pjshell.env.promote", domain: "pjshell", text: "搬到正式", vars: [], tone: "", source: "项目模块 V2 · SPEC-acceptance" },
  "pjshell.env.promote.body": { id: "pjshell.env.promote.body", domain: "pjshell", text: "搬的是测试上跑着的那个包本身，不是重新打一个。所以测试上是什么样，正式上就是什么样。", vars: [], tone: "", source: "设计稿 · pjEnvPromote" },
  "pjshell.env.promote.note": { id: "pjshell.env.promote.note", domain: "pjshell", text: "不会重新打包 —— 同一个包直接换过去", vars: [], tone: "", source: "项目模块 V2 · SPEC-acceptance" },
  "pjshell.env.promote.title": { id: "pjshell.env.promote.title", domain: "pjshell", text: "把测试发到正式？", vars: [], tone: "", source: "设计稿 · pjEnv 主操作 / pjEnvPromote" },
  "pjshell.env.rollback": { id: "pjshell.env.rollback", domain: "pjshell", text: "回到上一版", vars: [], tone: "", source: "设计稿 · pjEnv" },
  "pjshell.env.status.failed": { id: "pjshell.env.status.failed", domain: "pjshell", text: "没过", vars: [], tone: "", source: "项目模块 V2 · 环境页" },
  "pjshell.env.status.ready": { id: "pjshell.env.status.ready", domain: "pjshell", text: "核过了", vars: [], tone: "", source: "项目模块 V2 · 环境页" },
  "pjshell.env.status.rolled_back": { id: "pjshell.env.status.rolled_back", domain: "pjshell", text: "已经退回去了", vars: [], tone: "", source: "项目模块 V2 · 环境页" },
  "pjshell.env.subtitle": { id: "pjshell.env.subtitle", domain: "pjshell", text: "两套环境：测试用来看效果，正式是用户在用的。", vars: [], tone: "", source: "设计稿 · pjEnv" },
  "pjshell.env.test": { id: "pjshell.env.test", domain: "pjshell", text: "测试", vars: [], tone: "", source: "项目模块 V2 · 环境页" },
  "pjshell.env.test.title": { id: "pjshell.env.test.title", domain: "pjshell", text: "测试 · 看效果用的", vars: [], tone: "", source: "设计稿 · pjEnv" },
  "pjshell.env.version": { id: "pjshell.env.version", domain: "pjshell", text: "版本", vars: [], tone: "", source: "设计稿 · pjEnv" },
  "pjshell.env.when": { id: "pjshell.env.when", domain: "pjshell", text: "什么时候", vars: [], tone: "", source: "设计稿 · pjEnv 版本行旁的时间" },
  "pjshell.env.who": { id: "pjshell.env.who", domain: "pjshell", text: "谁能发", vars: [], tone: "", source: "设计稿 · pjEnv" },
  "pjshell.fact.uncollected": { id: "pjshell.fact.uncollected", domain: "pjshell", text: "未采集", vars: [], tone: "", source: "项目模块 V2 · 资源读模型" },
  "pjshell.fact.unconfigured": { id: "pjshell.fact.unconfigured", domain: "pjshell", text: "未配置", vars: [], tone: "", source: "项目模块 V2 · 资源读模型" },
  "pjshell.fact.unknown": { id: "pjshell.fact.unknown", domain: "pjshell", text: "未知", vars: [], tone: "", source: "资源模块 SPEC 2026-08-27" },
  "pjshell.memo.empty": { id: "pjshell.memo.empty", domain: "pjshell", text: "这个项目还没有备忘。", vars: [], tone: "", source: "项目模块 V2 · 备忘录" },
  "pjshell.memo.voice.blocked": { id: "pjshell.memo.voice.blocked", domain: "pjshell", text: "项目备忘这边还不能录语音，写下来就能记在这个项目里。", vars: [], tone: "", source: "项目模块 V2 · 备忘录" },
  "pjshell.overview.capacity": { id: "pjshell.overview.capacity", domain: "pjshell", text: "机器和容量", vars: [], tone: "", source: "设计稿 · pjHome" },
  "pjshell.overview.card.entry": { id: "pjshell.overview.card.entry", domain: "pjshell", text: "对外入口", vars: [], tone: "", source: "资源模块 SPEC 2026-08-27 · R13" },
  "pjshell.overview.card.lives": { id: "pjshell.overview.card.lives", domain: "pjshell", text: "住在哪儿", vars: [], tone: "", source: "资源模块 SPEC 2026-08-27 · R13" },
  "pjshell.overview.card.publish": { id: "pjshell.overview.card.publish", domain: "pjshell", text: "发个网页", vars: [], tone: "", source: "资源模块 SPEC 2026-08-27 · R13" },
  "pjshell.overview.decide": { id: "pjshell.overview.decide", domain: "pjshell", text: "有 {count} 件事要你决定", vars: ["count"], tone: "", source: "设计稿 · pjHome" },
  "pjshell.overview.decide.action": { id: "pjshell.overview.decide.action", domain: "pjshell", text: "去处理", vars: [], tone: "", source: "设计稿 · pjHome" },
  "pjshell.overview.decide.body": { id: "pjshell.overview.decide.body", domain: "pjshell", text: "要你决定的事排在最上面，其余按状态往下看。", vars: [], tone: "", source: "设计稿 · pjHome" },
  "pjshell.overview.env": { id: "pjshell.overview.env", domain: "pjshell", text: "测试和正式", vars: [], tone: "", source: "项目模块 V2 · 概览" },
  "pjshell.overview.events": { id: "pjshell.overview.events", domain: "pjshell", text: "最近事件", vars: [], tone: "", source: "项目模块 V2 · 概览" },
  "pjshell.overview.feed": { id: "pjshell.overview.feed", domain: "pjshell", text: "这几天谁动了这个项目", vars: [], tone: "", source: "设计稿 · pjHome" },
  "pjshell.overview.feed.note": { id: "pjshell.overview.feed.note", domain: "pjshell", text: "按时间倒序 · 只放结果，过程在任务里", vars: [], tone: "", source: "设计稿 · pjHome" },
  "pjshell.overview.go_env": { id: "pjshell.overview.go_env", domain: "pjshell", text: "去环境页", vars: [], tone: "", source: "设计稿 · pjHome" },
  "pjshell.overview.go_release": { id: "pjshell.overview.go_release", domain: "pjshell", text: "看发布历史", vars: [], tone: "", source: "设计稿 · pjHome" },
  "pjshell.overview.go_resources": { id: "pjshell.overview.go_resources", domain: "pjshell", text: "去资源页", vars: [], tone: "", source: "设计稿 · pjHome" },
  "pjshell.overview.go_tasks": { id: "pjshell.overview.go_tasks", domain: "pjshell", text: "去任务页", vars: [], tone: "", source: "设计稿 · pjHome" },
  "pjshell.overview.health": { id: "pjshell.overview.health", domain: "pjshell", text: "现在怎么样", vars: [], tone: "", source: "项目模块 V2 · 概览" },
  "pjshell.overview.last_release": { id: "pjshell.overview.last_release", domain: "pjshell", text: "最近一次发布", vars: [], tone: "", source: "设计稿 · pjHome" },
  "pjshell.overview.live.note": { id: "pjshell.overview.live.note", domain: "pjshell", text: "能不能打开是真的去访问过一次得出的，不是根据发布成功推断的。", vars: [], tone: "", source: "设计稿 · pjHome" },
  "pjshell.overview.live_version": { id: "pjshell.overview.live_version", domain: "pjshell", text: "线上在跑哪个版本", vars: [], tone: "", source: "设计稿 · pjHome" },
  "pjshell.overview.no_resource_issue": { id: "pjshell.overview.no_resource_issue", domain: "pjshell", text: "机器这边没有要处理的。", vars: [], tone: "", source: "项目模块 V2 · 概览" },
  "pjshell.overview.now": { id: "pjshell.overview.now", domain: "pjshell", text: "现在的状态", vars: [], tone: "", source: "设计稿 · pjHome" },
  "pjshell.overview.release": { id: "pjshell.overview.release", domain: "pjshell", text: "发布", vars: [], tone: "", source: "项目模块 V2 · 概览" },
  "pjshell.overview.resource_issues": { id: "pjshell.overview.resource_issues", domain: "pjshell", text: "资源异常", vars: [], tone: "", source: "项目模块 V2 · 概览" },
  "pjshell.overview.subtitle": { id: "pjshell.overview.subtitle", domain: "pjshell", text: "一眼看完：有没有人在干活、线上是哪个版本、有没有要你决定的事，以及导入时还差哪几项。", vars: [], tone: "", source: "设计稿 · pjHome" },
  "pjshell.overview.takeover": { id: "pjshell.overview.takeover", domain: "pjshell", text: "接管缺口", vars: [], tone: "", source: "项目模块 V2 · 概览" },
  "pjshell.overview.tasks": { id: "pjshell.overview.tasks", domain: "pjshell", text: "任务", vars: [], tone: "", source: "项目模块 V2 · 概览" },
  "pjshell.overview.watch": { id: "pjshell.overview.watch", domain: "pjshell", text: "要补的和要留意的", vars: [], tone: "", source: "设计稿 · pjHome" },
  "pjshell.overview.working": { id: "pjshell.overview.working", domain: "pjshell", text: "现在有人在干活", vars: [], tone: "", source: "设计稿 · pjHome" },
  "pjshell.overview.working.empty": { id: "pjshell.overview.working.empty", domain: "pjshell", text: "现在没有人在干活", vars: [], tone: "", source: "设计稿 · pjHome" },
  "pjshell.overview.working.note": { id: "pjshell.overview.working.note", domain: "pjshell", text: "时间是从任务真实开始算的，不是进度条。想看它具体在改哪些文件，点进任务。", vars: [], tone: "", source: "设计稿 · pjHome" },
  "pjshell.pending_item": { id: "pjshell.pending_item", domain: "pjshell", text: "还没弄的", vars: [], tone: "", source: "项目模块 V2 · SPEC-components" },
  "pjshell.readiness.agent_only": { id: "pjshell.readiness.agent_only", domain: "pjshell", text: "此机器仅支持探针托管，不适用 SSH 部署验证。", vars: [], tone: "", source: "资源接入闭环" },
  "pjshell.readiness.awaiting_heartbeat": { id: "pjshell.readiness.awaiting_heartbeat", domain: "pjshell", text: "尚未收到有效心跳。再次继续接入会尝试补装探针；仍失败可查看连接信息。", vars: [], tone: "", source: "资源接入闭环" },
  "pjshell.readiness.check_failed": { id: "pjshell.readiness.check_failed", domain: "pjshell", text: "这次检查未完成，请重试。", vars: [], tone: "", source: "探针安装修复" },
  "pjshell.readiness.complete": { id: "pjshell.readiness.complete", domain: "pjshell", text: "已完成：", vars: [], tone: "", source: "资源接入闭环" },
  "pjshell.readiness.continue": { id: "pjshell.readiness.continue", domain: "pjshell", text: "继续接入", vars: [], tone: "", source: "资源接入闭环" },
  "pjshell.readiness.details": { id: "pjshell.readiness.details", domain: "pjshell", text: "查看连接信息", vars: [], tone: "", source: "资源接入闭环" },
  "pjshell.readiness.execution": { id: "pjshell.readiness.execution", domain: "pjshell", text: "命令执行验证", vars: [], tone: "", source: "资源接入闭环" },
  "pjshell.readiness.execution_failed": { id: "pjshell.readiness.execution_failed", domain: "pjshell", text: "命令执行验证失败，请检查机器的执行权限。", vars: [], tone: "", source: "资源接入闭环" },
  "pjshell.readiness.heartbeat": { id: "pjshell.readiness.heartbeat", domain: "pjshell", text: "收到首次心跳", vars: [], tone: "", source: "资源接入闭环" },
  "pjshell.readiness.install_failed": { id: "pjshell.readiness.install_failed", domain: "pjshell", text: "探针安装失败，可重试或查看机器详情。", vars: [], tone: "", source: "资源接入闭环" },
  "pjshell.readiness.install_timeout": { id: "pjshell.readiness.install_timeout", domain: "pjshell", text: "安装超时，可重试；平台会重新检查下载与启动。", vars: [], tone: "", source: "探针安装修复" },
  "pjshell.readiness.installer_unavailable": { id: "pjshell.readiness.installer_unavailable", domain: "pjshell", text: "平台未配置探针安装服务。", vars: [], tone: "", source: "资源接入闭环" },
  "pjshell.readiness.pending": { id: "pjshell.readiness.pending", domain: "pjshell", text: "接入未完成", vars: [], tone: "", source: "资源接入闭环" },
  "pjshell.readiness.ready": { id: "pjshell.readiness.ready", domain: "pjshell", text: "可部署", vars: [], tone: "", source: "资源接入闭环" },
  "pjshell.readiness.registered": { id: "pjshell.readiness.registered", domain: "pjshell", text: "注册到 NPC", vars: [], tone: "", source: "资源接入闭环" },
  "pjshell.readiness.running": { id: "pjshell.readiness.running", domain: "pjshell", text: "正在安装并检查…", vars: [], tone: "", source: "资源接入闭环" },
  "pjshell.readiness.scope": { id: "pjshell.readiness.scope", domain: "pjshell", text: "验证平台 SSH 命令通道；具体应用的部署配置仍需单独检查。", vars: [], tone: "", source: "资源接入闭环" },
  "pjshell.readiness.ssh_unavailable": { id: "pjshell.readiness.ssh_unavailable", domain: "pjshell", text: "连接验证失败，请检查现有连接信息。", vars: [], tone: "", source: "资源接入闭环" },
  "pjshell.readiness.validity": { id: "pjshell.readiness.validity", domain: "pjshell", text: "验证有效期 15 分钟；心跳失联后自动取消可部署状态。", vars: [], tone: "", source: "资源接入闭环" },
  "pjshell.readiness.verify": { id: "pjshell.readiness.verify", domain: "pjshell", text: "重新验证", vars: [], tone: "", source: "资源接入闭环" },
  "pjshell.readiness.waiting": { id: "pjshell.readiness.waiting", domain: "pjshell", text: "待完成：", vars: [], tone: "", source: "资源接入闭环" },
  "pjshell.release.app": { id: "pjshell.release.app", domain: "pjshell", text: "应用", vars: [], tone: "", source: "设计稿 · pjDeployStatic" },
  "pjshell.release.checking": { id: "pjshell.release.checking", domain: "pjshell", text: "校验中", vars: [], tone: "", source: "项目模块 V2 · 发布页" },
  "pjshell.release.col.actions": { id: "pjshell.release.col.actions", domain: "pjshell", text: "操作", vars: [], tone: "", source: "设计稿 · pjDeployStatic" },
  "pjshell.release.col.last": { id: "pjshell.release.col.last", domain: "pjshell", text: "最近一次", vars: [], tone: "", source: "设计稿 · pjDeployStatic" },
  "pjshell.release.col.name": { id: "pjshell.release.col.name", domain: "pjshell", text: "名字", vars: [], tone: "", source: "设计稿 · pjDeployStatic" },
  "pjshell.release.col.size": { id: "pjshell.release.col.size", domain: "pjshell", text: "大小", vars: [], tone: "", source: "设计稿 · pjDeployStatic" },
  "pjshell.release.col.status": { id: "pjshell.release.col.status", domain: "pjshell", text: "状态", vars: [], tone: "", source: "设计稿 · pjDeployStatic" },
  "pjshell.release.col.url": { id: "pjshell.release.col.url", domain: "pjshell", text: "网址", vars: [], tone: "", source: "设计稿 · pjDeployStatic" },
  "pjshell.release.col.version": { id: "pjshell.release.col.version", domain: "pjshell", text: "版本", vars: [], tone: "", source: "设计稿 · pjDeployStatic" },
  "pjshell.release.drop": { id: "pjshell.release.drop", domain: "pjshell", text: "拖一个 HTML 或 ZIP 更新主站", vars: [], tone: "", source: "设计稿 · pjDeployStatic" },
  "pjshell.release.drop.choose": { id: "pjshell.release.drop.choose", domain: "pjshell", text: "选择文件", vars: [], tone: "", source: "设计稿 · pjDeployStatic" },
  "pjshell.release.drop.empty": { id: "pjshell.release.drop.empty", domain: "pjshell", text: "这个项目还没有主站。拖进来会建第一个，不会偷偷建第二个。", vars: [], tone: "", source: "设计稿 · pjDeployStatic" },
  "pjshell.release.drop.hint": { id: "pjshell.release.drop.hint", domain: "pjshell", text: "默认更新 {slug}，要单独建站请明确点「另建一个站点」。", vars: ["slug"], tone: "", source: "设计稿 · pjDeployStatic" },
  "pjshell.release.drop.new_site": { id: "pjshell.release.drop.new_site", domain: "pjshell", text: "另建一个站点", vars: [], tone: "", source: "设计稿 · pjDeployStatic" },
  "pjshell.release.duration": { id: "pjshell.release.duration", domain: "pjshell", text: "用时", vars: [], tone: "", source: "设计稿 · pjHome" },
  "pjshell.release.failed": { id: "pjshell.release.failed", domain: "pjshell", text: "失败", vars: [], tone: "", source: "项目模块 V2 · 发布页" },
  "pjshell.release.live": { id: "pjshell.release.live", domain: "pjshell", text: "已上线", vars: [], tone: "", source: "项目模块 V2 · 发布页" },
  "pjshell.release.live_now": { id: "pjshell.release.live_now", domain: "pjshell", text: "线上现在是 v{version}", vars: ["version"], tone: "", source: "设计稿 · pjDeployStatic" },
  "pjshell.release.none": { id: "pjshell.release.none", domain: "pjshell", text: "还没放过网页。", vars: [], tone: "", source: "项目模块 V2 · 发布页" },
  "pjshell.release.open": { id: "pjshell.release.open", domain: "pjshell", text: "打开", vars: [], tone: "", source: "设计稿 · pjDeployStatic" },
  "pjshell.release.previous": { id: "pjshell.release.previous", domain: "pjshell", text: "上一次", vars: [], tone: "", source: "设计稿 · pjHome" },
  "pjshell.release.primary_now": { id: "pjshell.release.primary_now", domain: "pjshell", text: "当前主站 {slug} · v{version}", vars: ["slug", "version"], tone: "", source: "设计稿 · pjDeployStatic" },
  "pjshell.release.progress": { id: "pjshell.release.progress", domain: "pjshell", text: "看进度", vars: [], tone: "", source: "设计稿 · pjDeployStatic" },
  "pjshell.release.publishing": { id: "pjshell.release.publishing", domain: "pjshell", text: "发布中", vars: [], tone: "", source: "项目模块 V2 · 发布页" },
  "pjshell.release.replace": { id: "pjshell.release.replace", domain: "pjshell", text: "换新版", vars: [], tone: "", source: "设计稿 · pjDeployStatic" },
  "pjshell.release.rollbacks": { id: "pjshell.release.rollbacks", domain: "pjshell", text: "自动退回", vars: [], tone: "", source: "设计稿 · pjDeployStatic" },
  "pjshell.release.see_failure": { id: "pjshell.release.see_failure", domain: "pjshell", text: "看为什么失败", vars: [], tone: "", source: "设计稿 · pjDeployStatic" },
  "pjshell.release.sites": { id: "pjshell.release.sites", domain: "pjshell", text: "这个项目的站点", vars: [], tone: "", source: "设计稿 · pjDeployStatic" },
  "pjshell.release.static": { id: "pjshell.release.static", domain: "pjshell", text: "静态页面 · 拖进来就发", vars: [], tone: "", source: "设计稿 · pjDeployStatic" },
  "pjshell.release.step.check": { id: "pjshell.release.step.check", domain: "pjshell", text: "检查文件", vars: [], tone: "", source: "设计稿 · pjDeployStatic" },
  "pjshell.release.step.live.note": { id: "pjshell.release.step.live.note", domain: "pjshell", text: "这时候才给网址", vars: [], tone: "", source: "设计稿 · pjDeployStatic" },
  "pjshell.release.step.publish": { id: "pjshell.release.step.publish", domain: "pjshell", text: "发布", vars: [], tone: "", source: "设计稿 · pjDeployStatic" },
  "pjshell.release.step.verify": { id: "pjshell.release.step.verify", domain: "pjshell", text: "公网验证", vars: [], tone: "", source: "设计稿 · pjDeployStatic" },
  "pjshell.release.step.verify.note": { id: "pjshell.release.step.verify.note", domain: "pjshell", text: "我们自己访问一次才算数", vars: [], tone: "", source: "设计稿 · pjDeployStatic" },
  "pjshell.release.steps": { id: "pjshell.release.steps", domain: "pjshell", text: "四步都要真的走完", vars: [], tone: "", source: "设计稿 · pjDeployStatic" },
  "pjshell.release.subtitle": { id: "pjshell.release.subtitle", domain: "pjshell", text: "这个项目的应用和静态页面都在这儿。默认更新主站，不会偷偷建第二个站点。", vars: [], tone: "", source: "设计稿 · pjDeployStatic" },
  "pjshell.release.today": { id: "pjshell.release.today", domain: "pjshell", text: "今天发了", vars: [], tone: "", source: "设计稿 · pjDeployStatic" },
  "pjshell.release.verifying": { id: "pjshell.release.verifying", domain: "pjshell", text: "验证中", vars: [], tone: "", source: "项目模块 V2 · 发布页" },
  "pjshell.release.verifying.public": { id: "pjshell.release.verifying.public", domain: "pjshell", text: "公网验证中", vars: [], tone: "", source: "设计稿 · pjDeployStatic" },
  "pjshell.release.version": { id: "pjshell.release.version", domain: "pjshell", text: "版本", vars: [], tone: "", source: "设计稿 · pjHome / pjDeploy" },
  "pjshell.release.what": { id: "pjshell.release.what", domain: "pjshell", text: "内容", vars: [], tone: "", source: "设计稿 · pjHome" },
  "pjshell.release.who": { id: "pjshell.release.who", domain: "pjshell", text: "谁发的", vars: [], tone: "", source: "设计稿 · pjHome / pjDeploy" },
  "pjshell.release.who_when": { id: "pjshell.release.who_when", domain: "pjshell", text: "{when} 由 {who} 发的，用了 {duration}", vars: ["duration", "when", "who"], tone: "", source: "设计稿 · pjDeployStatic" },
  "pjshell.resource.add_one": { id: "pjshell.resource.add_one", domain: "pjshell", text: "加一台", vars: [], tone: "", source: "资源模块 SPEC 2026-08-27 · R09" },
  "pjshell.resource.address": { id: "pjshell.resource.address", domain: "pjshell", text: "地址", vars: [], tone: "", source: "项目模块 V2 · 资源页" },
  "pjshell.resource.assign_idle": { id: "pjshell.resource.assign_idle", domain: "pjshell", text: "挂上空闲机", vars: [], tone: "", source: "资源模块 SPEC 2026-08-27 · R09" },
  "pjshell.resource.assign_to_project": { id: "pjshell.resource.assign_to_project", domain: "pjshell", text: "挂到这个项目", vars: [], tone: "", source: "资源模块 SPEC 2026-08-27 · R10" },
  "pjshell.resource.cert": { id: "pjshell.resource.cert", domain: "pjshell", text: "证书", vars: [], tone: "", source: "项目模块 V2 · 资源页" },
  "pjshell.resource.col.actions": { id: "pjshell.resource.col.actions", domain: "pjshell", text: "操作", vars: [], tone: "", source: "资源模块 SPEC 2026-08-27 · R08" },
  "pjshell.resource.col.capacity": { id: "pjshell.resource.col.capacity", domain: "pjshell", text: "容量", vars: [], tone: "", source: "设计稿 · resources" },
  "pjshell.resource.col.cert": { id: "pjshell.resource.col.cert", domain: "pjshell", text: "证书到期", vars: [], tone: "", source: "设计稿 · resources" },
  "pjshell.resource.col.entry": { id: "pjshell.resource.col.entry", domain: "pjshell", text: "域名 / 入口", vars: [], tone: "", source: "设计稿 · resources" },
  "pjshell.resource.col.env": { id: "pjshell.resource.col.env", domain: "pjshell", text: "环境", vars: [], tone: "", source: "设计稿 · resources" },
  "pjshell.resource.col.expiry": { id: "pjshell.resource.col.expiry", domain: "pjshell", text: "到期", vars: [], tone: "", source: "设计稿 · resources" },
  "pjshell.resource.col.host": { id: "pjshell.resource.col.host", domain: "pjshell", text: "机器", vars: [], tone: "", source: "设计稿 · resources" },
  "pjshell.resource.col.owner": { id: "pjshell.resource.col.owner", domain: "pjshell", text: "归属", vars: [], tone: "", source: "设计稿 · resources" },
  "pjshell.resource.col.point": { id: "pjshell.resource.col.point", domain: "pjshell", text: "指向", vars: [], tone: "", source: "设计稿 · resources" },
  "pjshell.resource.col.spec": { id: "pjshell.resource.col.spec", domain: "pjshell", text: "规格", vars: [], tone: "", source: "设计稿 · resources" },
  "pjshell.resource.col.type": { id: "pjshell.resource.col.type", domain: "pjshell", text: "类型", vars: [], tone: "", source: "设计稿 · resources" },
  "pjshell.resource.col.vendor": { id: "pjshell.resource.col.vendor", domain: "pjshell", text: "服务商", vars: [], tone: "", source: "设计稿 · resources" },
  "pjshell.resource.domain": { id: "pjshell.resource.domain", domain: "pjshell", text: "域名", vars: [], tone: "", source: "项目模块 V2 · 资源页" },
  "pjshell.resource.domains": { id: "pjshell.resource.domains", domain: "pjshell", text: "域名与入口", vars: [], tone: "", source: "设计稿 · resources" },
  "pjshell.resource.empty.body": { id: "pjshell.resource.empty.body", domain: "pjshell", text: "这个项目还没挂机器。空闲机可以挂上来，也可以贴一台新的。没挂之前项目照样能写、能对话；要上线再找台机器。", vars: [], tone: "", source: "资源模块 SPEC 2026-08-27 · R09" },
  "pjshell.resource.empty.title": { id: "pjshell.resource.empty.title", domain: "pjshell", text: "还没有关联主机", vars: [], tone: "", source: "资源模块 SPEC 2026-08-27 · R09" },
  "pjshell.resource.exclusive": { id: "pjshell.resource.exclusive", domain: "pjshell", text: "独占", vars: [], tone: "", source: "设计稿 · resources" },
  "pjshell.resource.go_cert": { id: "pjshell.resource.go_cert", domain: "pjshell", text: "去发布页看证书", vars: [], tone: "", source: "项目模块 V2 · 资源读模型" },
  "pjshell.resource.go_dns": { id: "pjshell.resource.go_dns", domain: "pjshell", text: "去环境页配置", vars: [], tone: "", source: "项目模块 V2 · 资源读模型" },
  "pjshell.resource.network": { id: "pjshell.resource.network", domain: "pjshell", text: "网络", vars: [], tone: "", source: "项目模块 V2 · 资源页" },
  "pjshell.resource.physical": { id: "pjshell.resource.physical", domain: "pjshell", text: "住着它的那台机器", vars: [], tone: "", source: "项目模块 V2 · 资源页" },
  "pjshell.resource.pool": { id: "pjshell.resource.pool", domain: "pjshell", text: "公共池借用", vars: [], tone: "", source: "设计稿 · resources" },
  "pjshell.resource.shared": { id: "pjshell.resource.shared", domain: "pjshell", text: "共用", vars: [], tone: "", source: "设计稿 · resources" },
  "pjshell.resource.split": { id: "pjshell.resource.split", domain: "pjshell", text: "拆出来的机器", vars: [], tone: "", source: "项目模块 V2 · 资源页" },
  "pjshell.resource.storage": { id: "pjshell.resource.storage", domain: "pjshell", text: "存储", vars: [], tone: "", source: "项目模块 V2 · 资源页" },
  "pjshell.resource.subtitle": { id: "pjshell.resource.subtitle", domain: "pjshell", text: "独占的、共用的、公共池里借的，分开列。", vars: [], tone: "", source: "设计稿 · resources" },
  "pjshell.resource.title": { id: "pjshell.resource.title", domain: "pjshell", text: "这个项目用了什么", vars: [], tone: "", source: "设计稿 · resources" },
  "pjshell.resource.unassign": { id: "pjshell.resource.unassign", domain: "pjshell", text: "卸下", vars: [], tone: "", source: "资源模块 SPEC 2026-08-27 · R11" },
  "pjshell.resource.unassign.body": { id: "pjshell.resource.unassign.body", domain: "pjshell", text: "卸下来它回到空闲池，巡检和告警不停。这个项目不再把它算成自己的。", vars: [], tone: "", source: "资源模块 SPEC 2026-08-27 · R11" },
  "pjshell.resource.unassign.confirm": { id: "pjshell.resource.unassign.confirm", domain: "pjshell", text: "卸下来", vars: [], tone: "", source: "资源模块 SPEC 2026-08-27 · R11" },
  "pjshell.resource.unassign.last_prod": { id: "pjshell.resource.unassign.last_prod", domain: "pjshell", text: "这是正式环境最后一台独占机。卸下来，线上就没地方住了。", vars: [], tone: "danger", source: "资源模块 SPEC 2026-08-27 · R11" },
  "pjshell.resource.unassign.title": { id: "pjshell.resource.unassign.title", domain: "pjshell", text: "把这台从「{project_name}」卸下来？", vars: ["project_name"], tone: "", source: "资源模块 SPEC 2026-08-27 · R11" },
  "pjshell.resource.vendor": { id: "pjshell.resource.vendor", domain: "pjshell", text: "供应商", vars: [], tone: "", source: "项目模块 V2 · 资源页" },
  "pjshell.takeover.none": { id: "pjshell.takeover.none", domain: "pjshell", text: "这个项目不是接进来的，没有接管缺口。", vars: [], tone: "", source: "项目模块 V2 · 概览" },
  "pjshell.task.col.elapsed": { id: "pjshell.task.col.elapsed", domain: "pjshell", text: "用了多久", vars: [], tone: "", source: "设计稿 · pjTask" },
  "pjshell.task.col.files": { id: "pjshell.task.col.files", domain: "pjshell", text: "写哪些文件", vars: [], tone: "", source: "设计稿 · pjTask" },
  "pjshell.task.col.name": { id: "pjshell.task.col.name", domain: "pjshell", text: "任务", vars: [], tone: "", source: "设计稿 · pjTask" },
  "pjshell.task.col.source": { id: "pjshell.task.col.source", domain: "pjshell", text: "哪来的", vars: [], tone: "", source: "设计稿 · pjTask" },
  "pjshell.task.col.state": { id: "pjshell.task.col.state", domain: "pjshell", text: "状态", vars: [], tone: "", source: "设计稿 · pjTask" },
  "pjshell.task.col.who": { id: "pjshell.task.col.who", domain: "pjshell", text: "谁在做", vars: [], tone: "", source: "设计稿 · pjTask" },
  "pjshell.task.elapsed": { id: "pjshell.task.elapsed", domain: "pjshell", text: "已经跑了 {elapsed}", vars: ["elapsed"], tone: "", source: "项目模块 V2 · SPEC-components" },
  "pjshell.task.empty": { id: "pjshell.task.empty", domain: "pjshell", text: "这个项目还没有开发任务。", vars: [], tone: "", source: "项目模块 V2 · 任务页" },
  "pjshell.task.filter.all": { id: "pjshell.task.filter.all", domain: "pjshell", text: "全部", vars: [], tone: "", source: "设计稿 · pjTask" },
  "pjshell.task.filter.assignee": { id: "pjshell.task.filter.assignee", domain: "pjshell", text: "负责人", vars: [], tone: "", source: "任务收件箱筛选" },
  "pjshell.task.filter.assignee.placeholder": { id: "pjshell.task.filter.assignee.placeholder", domain: "pjshell", text: "执行人或维护身份", vars: [], tone: "", source: "任务收件箱筛选" },
  "pjshell.task.filter.decide": { id: "pjshell.task.filter.decide", domain: "pjshell", text: "要你决定", vars: [], tone: "", source: "设计稿 · pjTask" },
  "pjshell.task.filter.done": { id: "pjshell.task.filter.done", domain: "pjshell", text: "做完", vars: [], tone: "", source: "设计稿 · pjTask" },
  "pjshell.task.filter.failed": { id: "pjshell.task.filter.failed", domain: "pjshell", text: "失败", vars: [], tone: "", source: "设计稿 · pjTask" },
  "pjshell.task.filter.running": { id: "pjshell.task.filter.running", domain: "pjshell", text: "正在跑", vars: [], tone: "", source: "设计稿 · pjTask" },
  "pjshell.task.filter.updated": { id: "pjshell.task.filter.updated", domain: "pjshell", text: "更新时间", vars: [], tone: "", source: "任务收件箱筛选" },
  "pjshell.task.filter.updated.any": { id: "pjshell.task.filter.updated.any", domain: "pjshell", text: "全部时间", vars: [], tone: "", source: "任务收件箱筛选" },
  "pjshell.task.filter.updated.hour": { id: "pjshell.task.filter.updated.hour", domain: "pjshell", text: "最近 1 小时", vars: [], tone: "", source: "任务收件箱筛选" },
  "pjshell.task.filter.updated.today": { id: "pjshell.task.filter.updated.today", domain: "pjshell", text: "今天", vars: [], tone: "", source: "任务收件箱筛选" },
  "pjshell.task.filter.updated.week": { id: "pjshell.task.filter.updated.week", domain: "pjshell", text: "最近 7 天", vars: [], tone: "", source: "任务收件箱筛选" },
  "pjshell.task.search.placeholder": { id: "pjshell.task.search.placeholder", domain: "pjshell", text: "搜任务名或文件路径", vars: [], tone: "", source: "设计稿 · pjTask FilterBar" },
  "pjshell.task.sort.hint": { id: "pjshell.task.sort.hint", domain: "pjshell", text: "要你决定的排最前", vars: [], tone: "", source: "设计稿 · pjTask" },
  "pjshell.task.source.lulu": { id: "pjshell.task.source.lulu", domain: "pjshell", text: "Lulu", vars: [], tone: "", source: "设计稿 · pjTask" },
  "pjshell.task.source.user": { id: "pjshell.task.source.user", domain: "pjshell", text: "你派的", vars: [], tone: "", source: "设计稿 · pjTask" },
  "pjshell.task.stale": { id: "pjshell.task.stale", domain: "pjshell", text: "已经没动静了", vars: [], tone: "", source: "契约 openapi.yaml · DevelopmentTask.stale" },
  "pjshell.task.subtitle": { id: "pjshell.task.subtitle", domain: "pjshell", text: "谁在干什么、干到哪儿、写哪些文件。要你决定的排最上面。", vars: [], tone: "", source: "设计稿 · pjTask" },
  "pjshell.task.write": { id: "pjshell.task.write", domain: "pjshell", text: "正在改的文件", vars: [], tone: "", source: "项目模块 V2 · SPEC-components" },
  "pjshell.unverified": { id: "pjshell.unverified", domain: "pjshell", text: "未核验", vars: [], tone: "", source: "项目模块 V2 · SPEC-acceptance" },
  "project.action.add_new_host": { id: "project.action.add_new_host", domain: "project", text: "贴一台新买的", vars: [], tone: "", source: "设计稿 · 机器列表" },
  "project.action.all_records": { id: "project.action.all_records", domain: "project", text: "看全部记录", vars: [], tone: "", source: "设计稿 · 项目详情" },
  "project.action.assign_host": { id: "project.action.assign_host", domain: "project", text: "给它找台机器", vars: [], tone: "", source: "设计稿 · 机器列表" },
  "project.action.create": { id: "project.action.create", domain: "project", text: "新建一个项目", vars: [], tone: "", source: "设计稿 · 机器列表" },
  "project.action.open_public_entry": { id: "project.action.open_public_entry", domain: "project", text: "打开线上页面", vars: [], tone: "", source: "补充" },
  "project.archived": { id: "project.archived", domain: "project", text: "收起来了。机器和密钥都还在，什么时候要再打开都行。", vars: [], tone: "ok", source: "补充" },
  "project.assign.idle_empty": { id: "project.assign.idle_empty", domain: "project", text: "现在没有空着的机器。", vars: [], tone: "", source: "ROADMAP M3" },
  "project.assign.idle_heading": { id: "project.assign.idle_heading", domain: "project", text: "还没归项目的机器", vars: [], tone: "", source: "ROADMAP M3" },
  "project.assign.idle_loading": { id: "project.assign.idle_loading", domain: "project", text: "我在看哪些机器还空着。", vars: [], tone: "", source: "ROADMAP M3" },
  "project.builtin.public_infra.name": { id: "project.builtin.public_infra.name", domain: "project", text: "公共设施", vars: [], tone: "", source: "交接包 README §3" },
  "project.builtin.public_infra.summary": { id: "project.builtin.public_infra.summary", domain: "project", text: "Forgejo、备份存储这些跨项目共用的东西，都归在这儿。", vars: [], tone: "", source: "补充" },
  "project.detail.breadcrumb": { id: "project.detail.breadcrumb", domain: "project", text: "项目 / {name}", vars: ["name"], tone: "", source: "设计稿 · 项目详情" },
  "project.empty.no_host": { id: "project.empty.no_host", domain: "project", text: "先有项目，还没有机器？", vars: [], tone: "", source: "设计稿 · 机器列表" },
  "project.empty.no_host.detail": { id: "project.empty.no_host.detail", domain: "project", text: "你的习惯是先写文档、让 AI 建仓库开发。等要上线时，在项目页点「给它找台机器」—— 你可以贴一台新买的，也可以从池子里挑一台闲着的。", vars: [], tone: "", source: "设计稿 · 机器列表" },
  "project.env.promote.no_digest": { id: "project.env.promote.no_digest", domain: "project", text: "测试环境还没有可以上生产的版本", vars: [], tone: "warn", source: "补充" },
  "project.env.promote.not_verified": { id: "project.env.promote.not_verified", domain: "project", text: "测试还没核验过，我不敢送到生产", vars: [], tone: "warn", source: "补充" },
  "project.env.promote.wrong_kind": { id: "project.env.promote.wrong_kind", domain: "project", text: "只能把测试里已经过了的那一版送到生产，生产不能自己再构建一次", vars: [], tone: "warn", source: "补充" },
  "project.env.rollback.no_target": { id: "project.env.rollback.no_target", domain: "project", text: "没有可以退回去的版本", vars: [], tone: "warn", source: "补充" },
  "project.error.builtin_undeletable": { id: "project.error.builtin_undeletable", domain: "project", text: "「公共设施」删不掉。Forgejo、备份存储这些跨项目共用的东西都挂在它下面。", vars: [], tone: "warn", source: "补充" },
  "project.error.host_exclusive": { id: "project.error.host_exclusive", domain: "project", text: "这台机器已经被别的项目独占了，不能再借过来。", vars: [], tone: "warn", source: "项目模块 V2 · 公共池借用冲突" },
  "project.error.name_blank": { id: "project.error.name_blank", domain: "project", text: "得给这个项目起个名字。", vars: [], tone: "warn", source: "补充" },
  "project.error.slug_taken": { id: "project.error.slug_taken", domain: "project", text: "{slug} 这个标识已经有一个项目在用了，换一个。", vars: ["slug"], tone: "warn", source: "补充" },
  "project.feed.empty": { id: "project.feed.empty", domain: "project", text: "这个项目最近没什么动静。", vars: [], tone: "", source: "设计稿 · 项目详情" },
  "project.feed.loading": { id: "project.feed.loading", domain: "project", text: "我在看这个项目最近的记录。", vars: [], tone: "", source: "ROADMAP M3" },
  "project.health.all_good": { id: "project.health.all_good", domain: "project", text: "一切正常", vars: [], tone: "ok", source: "设计稿 · 项目详情" },
  "project.health.host_trouble": { id: "project.health.host_trouble", domain: "project", text: "这个项目下有机器连不上或出错了", vars: [], tone: "danger", source: "补充" },
  "project.health.label": { id: "project.health.label", domain: "project", text: "健康度", vars: [], tone: "", source: "设计稿 · 项目详情" },
  "project.health.publish_failed": { id: "project.health.publish_failed", domain: "project", text: "有一次网页发布没成", vars: [], tone: "warn", source: "补充" },
  "project.list.empty.body": { id: "project.list.empty.body", domain: "project", text: "项目是看机器的一个角度。等你接进来的机器多了，我会按它们跑的东西给你归好。", vars: [], tone: "", source: "补充" },
  "project.list.empty.title": { id: "project.list.empty.title", domain: "project", text: "还没有项目", vars: [], tone: "", source: "补充" },
  "project.local_vs_platform.heading": { id: "project.local_vs_platform.heading", domain: "project", text: "你本地 和 平台 之间", vars: [], tone: "", source: "设计稿 · 项目详情" },
  "project.local_vs_platform.how_you_know": { id: "project.local_vs_platform.how_you_know", domain: "project", text: "本地怎么知道我动过", vars: [], tone: "", source: "设计稿 · 项目详情" },
  "project.local_vs_platform.pending_count": { id: "project.local_vs_platform.pending_count", domain: "project", text: "平台这边有 {count} 个改动等着你", vars: ["count"], tone: "", source: "设计稿 · 项目详情" },
  "project.local_vs_platform.tag": { id: "project.local_vs_platform.tag", domain: "project", text: "你是主力，我是帮手", vars: [], tone: "", source: "设计稿 · 项目详情" },
  "project.mixed_tenancy_warning": { id: "project.mixed_tenancy_warning", domain: "project", text: "这台上还跑着「{other_project}」，它出事会拖累它。", vars: ["other_project"], tone: "warn", source: "交接包 README §4" },
  "project.restored": { id: "project.restored", domain: "project", text: "又打开了，跟收起来之前一样。", vars: [], tone: "ok", source: "补充" },
  "project.section.feed": { id: "project.section.feed", domain: "project", text: "最近的动静", vars: [], tone: "", source: "设计稿 · 项目详情" },
  "project.section.public_entry": { id: "project.section.public_entry", domain: "project", text: "对外入口", vars: [], tone: "", source: "设计稿 · 项目详情" },
  "project.section.tasks": { id: "project.section.tasks", domain: "project", text: "开发任务", vars: [], tone: "", source: "设计稿 · 项目详情" },
  "project.section.where_it_lives": { id: "project.section.where_it_lives", domain: "project", text: "它住在哪儿", vars: [], tone: "", source: "设计稿 · 项目详情" },
  "project.summary.ai_written_hint": { id: "project.summary.ai_written_hint", domain: "project", text: "（这段话是 AI 写的，你可以改）", vars: [], tone: "", source: "设计稿 · 项目详情" },
  "project_import.action.approve": { id: "project_import.action.approve", domain: "project_import", text: "把勾上的接进来", vars: [], tone: "", source: "2026-08-19 既有项目接管 I2" },
  "project_import.action.start": { id: "project_import.action.start", domain: "project_import", text: "把一个现成项目接进来", vars: [], tone: "", source: "2026-08-18 既有项目接管 P0" },
  "project_import.action.unlink": { id: "project_import.action.unlink", domain: "project_import", text: "撤掉这次接进来的", vars: [], tone: "", source: "2026-08-21 既有项目接管 I2 收口" },
  "project_import.approve.hint": { id: "project_import.approve.hint", domain: "project_import", text: "对不上的我不会改。已有的名字、地址、到期日保持原样。", vars: [], tone: "", source: "2026-08-19 既有项目接管 I2" },
  "project_import.approve.no_selectable": { id: "project_import.approve.no_selectable", domain: "project_import", text: "这份资料里没有可以接进来的机器或服务商。", vars: [], tone: "", source: "2026-08-30 空选择批准" },
  "project_import.approve.submitting": { id: "project_import.approve.submitting", domain: "project_import", text: "正在接进来", vars: [], tone: "", source: "2026-08-19 既有项目接管 I2" },
  "project_import.approve.vendor_usage": { id: "project_import.approve.vendor_usage", domain: "project_import", text: "从这个项目接进来的。", vars: [], tone: "", source: "2026-08-19 既有项目接管 I2" },
  "project_import.assignee.assigning": { id: "project_import.assignee.assigning", domain: "project_import", text: "正在交接", vars: [], tone: "", source: "2026-09-09 身份绑定导入闭环" },
  "project_import.assignee.create_one_time": { id: "project_import.assignee.create_one_time", domain: "project_import", text: "生成单次导入链接", vars: [], tone: "", source: "2026-09-09 导入流程收敛" },
  "project_import.assignee.import_identity_name": { id: "project_import.assignee.import_identity_name", domain: "project_import", text: "单次导入 · {short_id}", vars: ["short_id"], tone: "", source: "2026-09-09 导入流程收敛" },
  "project_import.assignee.import_only_prompt": { id: "project_import.assignee.import_only_prompt", domain: "project_import", text: "目标：把用户明确提供的真实源码和／或真实项目资料接入 NPC。源码与资料包彼此独立，只做用户指定的项目；NPC 空仓是目的地，不是源码来源。\n\n开始前先问用户：“这次要导入源码、资料包，还是两者？原源码和资料在哪里？”只使用用户明确提供或授权访问的仓库、当前工作区、源码压缩包或附件。拿不到真实源码时，不调用 source_checkout_url，不执行 Git，也不创建 README、空提交、占位文件或最小工程。\n\n激活：兑换前确认有可跨进程、跨工作区重新注入的持久 Secret Manager；否则返回 persistent_secret_store_unavailable，不得兑换。NPC_API_KEY 已存在时不得覆盖，先向用户说明冲突。有浏览器时打开 {invite_url}；自动化 Agent 也可只调用一次 POST {redeem_url}，请求体 {\"invite_token\":\"{token}\"}。api_key 只显示一次，立即原子保存为 NPC_API_KEY；不得写入聊天、日志或仓库。启动全新进程重新注入，调用 GET /api/v1/bridge/identity；仅当返回 identity_contract_version=7、remote_ai=true、local_device=false、project_import_ready=true、development_ready=false、authorization_scope=project_import 时继续。\n\n执行：调用 GET /api/v1/bridge/project-imports，先读 details_url。用户只要资料包时，仅根据真实材料向 package_url 提交 npc-project-import-v1；缺项写入 unknowns，禁止用最小合法体、空清单或臆造内容凑状态，提交后停止。用户要源码且真实源码已可读取、非空时，才向 source_checkout_url 发送空 POST；它只签发 NPC 目标空仓的传输参数，base_sha 只是目标基线。原样使用 endpoint、username、token，以标准 Git 核验 exact base_sha，把真实源码形成的非空候选推到 target_ref；成功后 best-effort 调用 revoke_url 并销毁临时 token。传输凭证只留当前进程。\n\n禁止索取账号、Cookie、SSH Key、密码或服务器密钥。取消邀请、停用身份或改派后停止使用旧身份。", vars: ["invite_url", "redeem_url", "token"], tone: "", source: "2026-09-10 空仓导入意图与来源门禁" },
  "project_import.assignee.one_time_hint": { id: "project_import.assignee.one_time_hint", domain: "project_import", text: "空仓期间可以重新生成并改交给别人，旧链接和旧的单次身份会立即失效。收到源码后不再开放单次上传；长期维护 AI 仍在项目设置里关联。", vars: [], tone: "", source: "2026-09-09 导入流程收敛" },
  "project_import.assignee.one_time_title": { id: "project_import.assignee.one_time_title", domain: "project_import", text: "空仓单次导入", vars: [], tone: "", source: "2026-09-09 导入流程收敛" },
  "project_import.assignee.regenerate_one_time": { id: "project_import.assignee.regenerate_one_time", domain: "project_import", text: "重新生成单次导入链接", vars: [], tone: "", source: "2026-09-09 空仓允许改派" },
  "project_import.assignee.source_locked": { id: "project_import.assignee.source_locked", domain: "project_import", text: "仓库已经收到源码，不能再生成单次导入链接。后续维护请到项目设置关联 AI。", vars: [], tone: "warn", source: "2026-09-09 空仓允许改派" },
  "project_import.card.audit": { id: "project_import.card.audit", domain: "project_import", text: "看他们干过什么", vars: [], tone: "", source: "2026-08-21 既有项目接管 I2 收口" },
  "project_import.card.open": { id: "project_import.card.open", domain: "project_import", text: "去核对页", vars: [], tone: "", source: "2026-08-21 既有项目接管 I2 收口" },
  "project_import.card.source_label": { id: "project_import.card.source_label", domain: "project_import", text: "资料包指纹", vars: [], tone: "", source: "2026-08-21 既有项目接管 I2 收口" },
  "project_import.card.title": { id: "project_import.card.title", domain: "project_import", text: "从现成项目接进来的", vars: [], tone: "", source: "2026-08-21 既有项目接管 I2 收口" },
  "project_import.card.unavailable": { id: "project_import.card.unavailable", domain: "project_import", text: "这个项目的接管情况我这会儿读不出来，等一下再看。", vars: [], tone: "warn", source: "2026-08-21 既有项目接管 I2 独审回归" },
  "project_import.conflict.deployment_ref": { id: "project_import.conflict.deployment_ref", domain: "project_import", text: "这条部署去向指着一个资料包里没有的东西。", vars: [], tone: "", source: "2026-08-21 既有项目接管 I2 收口" },
  "project_import.conflict.domain_vendor": { id: "project_import.conflict.domain_vendor", domain: "project_import", text: "这个域名说是在一家我找不到的服务商那儿买的。", vars: [], tone: "", source: "2026-08-21 既有项目接管 I2 收口" },
  "project_import.conflict.host": { id: "project_import.conflict.host", domain: "project_import", text: "地址对得上、别的对不上，我不敢猜是不是同一台。", vars: [], tone: "", source: "2026-08-18 既有项目接管 I1" },
  "project_import.conflict.ownership_subject": { id: "project_import.conflict.ownership_subject", domain: "project_import", text: "这条证据说的东西不在资料包里，我对不上。", vars: [], tone: "", source: "2026-08-21 既有项目接管 I2 收口" },
  "project_import.conflict.project": { id: "project_import.conflict.project", domain: "project_import", text: "资料包里的项目和这边已有的对不上，我不会覆盖。", vars: [], tone: "", source: "2026-08-18 既有项目接管 I1" },
  "project_import.conflict.repository": { id: "project_import.conflict.repository", domain: "project_import", text: "这个仓库已经挂在别的项目上，我不会挪过来。", vars: [], tone: "", source: "2026-08-18 既有项目接管 I1" },
  "project_import.conflict.subscription": { id: "project_import.conflict.subscription", domain: "project_import", text: "这笔续费没说清是哪家的，我不敢往谁头上记。", vars: [], tone: "", source: "2026-08-21 既有项目接管 I2 收口" },
  "project_import.conflict.subscription_due": { id: "project_import.conflict.subscription_due", domain: "project_import", text: "到期日和我这边记的不一样，我不会改我这边的。", vars: [], tone: "", source: "2026-08-21 既有项目接管 I2 收口" },
  "project_import.conflict.subscription_vendor": { id: "project_import.conflict.subscription_vendor", domain: "project_import", text: "这笔续费挂在一家我找不到的服务商上。", vars: [], tone: "", source: "2026-08-21 既有项目接管 I2 收口" },
  "project_import.conflict.vendor": { id: "project_import.conflict.vendor", domain: "project_import", text: "这家服务商对不上，已有的名字和到期日我不会改。", vars: [], tone: "", source: "2026-08-18 既有项目接管 I1" },
  "project_import.deployment.derived": { id: "project_import.deployment.derived", domain: "project_import", text: "这条的把握，跟它指的那台机器和那个仓库一样。", vars: [], tone: "", source: "2026-08-21 既有项目接管 I2 收口" },
  "project_import.domain.no_record": { id: "project_import.domain.no_record", domain: "project_import", text: "域名我这边还没有地方存，先记着，不会替你建。", vars: [], tone: "", source: "2026-08-21 既有项目接管 I2 收口" },
  "project_import.error.conflict_selected": { id: "project_import.error.conflict_selected", domain: "project_import", text: "对不上的那几条我不敢接，先去掉。", vars: [], tone: "warn", source: "2026-08-19 既有项目接管 I2" },
  "project_import.error.extra_fields": { id: "project_import.error.extra_fields", domain: "project_import", text: "多出来的字段我不敢猜。说不清的请放进 unknowns。", vars: [], tone: "warn", source: "2026-08-18 既有项目接管 P0" },
  "project_import.error.host_missing": { id: "project_import.error.host_missing", domain: "project_import", text: "这台机器这边还没有，我不会凭资料包新建一台。", vars: [], tone: "warn", source: "2026-08-19 既有项目接管 I2" },
  "project_import.error.idempotency_mismatch": { id: "project_import.error.idempotency_mismatch", domain: "project_import", text: "这个重试键上次建的是另一份草稿，请换一个键再试。", vars: [], tone: "warn", source: "2026-09-03 导入草稿幂等" },
  "project_import.error.not_ready": { id: "project_import.error.not_ready", domain: "project_import", text: "现在还不能收资料包，草稿还没准备好。", vars: [], tone: "warn", source: "2026-08-18 既有项目接管 P0" },
  "project_import.error.not_reviewed": { id: "project_import.error.not_reviewed", domain: "project_import", text: "还没核对完，不能接。", vars: [], tone: "warn", source: "2026-08-19 既有项目接管 I2" },
  "project_import.error.nothing_linked": { id: "project_import.error.nothing_linked", domain: "project_import", text: "这次导入没有接进来过东西，没什么可撤的。", vars: [], tone: "warn", source: "2026-08-21 既有项目接管 I2 收口" },
  "project_import.error.nothing_selected": { id: "project_import.error.nothing_selected", domain: "project_import", text: "先勾要接进来的。", vars: [], tone: "warn", source: "2026-08-19 既有项目接管 I2" },
  "project_import.error.reissue_conflict": { id: "project_import.error.reissue_conflict", domain: "project_import", text: "刚才有人同时换过这份口令，请再点一次。", vars: [], tone: "warn", source: "2026-08-30 资料包口令重发" },
  "project_import.error.secrets": { id: "project_import.error.secrets", domain: "project_import", text: "这份资料里像有密钥、私钥、Cookie 或完整连接串。拿掉再交给我。", vars: [], tone: "warn", source: "2026-08-18 既有项目接管 P0" },
  "project_import.error.source_not_resendable": { id: "project_import.error.source_not_resendable", domain: "project_import", text: "源码正在导入或已经导入，不能再发入口。", vars: [], tone: "warn", source: "2026-08-30 源码入口重发" },
  "project_import.error.token_expired": { id: "project_import.error.token_expired", domain: "project_import", text: "这个一次性口令过期了，重新建一份草稿就好。", vars: [], tone: "warn", source: "2026-08-18 既有项目接管 P0" },
  "project_import.error.token_used": { id: "project_import.error.token_used", domain: "project_import", text: "这个一次性口令用过了，再交一份请重新建草稿。", vars: [], tone: "warn", source: "2026-08-18 既有项目接管 P0" },
  "project_import.error.unknown_schema": { id: "project_import.error.unknown_schema", domain: "project_import", text: "我只收 npc-project-import-v1 这一种资料包。", vars: [], tone: "warn", source: "2026-08-18 既有项目接管 P0" },
  "project_import.error.vendor_conflict": { id: "project_import.error.vendor_conflict", domain: "project_import", text: "这家服务商对不上，已有的名字和到期日我不会改。", vars: [], tone: "warn", source: "2026-08-19 既有项目接管 I2" },
  "project_import.evidence.ai_declared": { id: "project_import.evidence.ai_declared", domain: "project_import", text: "AI 说的", vars: [], tone: "", source: "2026-08-18 既有项目接管 P0" },
  "project_import.evidence.conflict": { id: "project_import.evidence.conflict", domain: "project_import", text: "对不上", vars: [], tone: "", source: "2026-08-18 既有项目接管 P0" },
  "project_import.evidence.inventory_matched": { id: "project_import.evidence.inventory_matched", domain: "project_import", text: "清单对得上", vars: [], tone: "", source: "2026-09-04 既有项目接管 I3" },
  "project_import.evidence.missing": { id: "project_import.evidence.missing", domain: "project_import", text: "还没有", vars: [], tone: "", source: "2026-08-18 既有项目接管 P0" },
  "project_import.evidence.platform_verified": { id: "project_import.evidence.platform_verified", domain: "project_import", text: "平台核对过", vars: [], tone: "", source: "2026-08-18 既有项目接管 P0" },
  "project_import.grades.title": { id: "project_import.grades.title", domain: "project_import", text: "核对结论", vars: [], tone: "", source: "2026-09-04 既有项目接管 I3" },
  "project_import.idle.not_reusable": { id: "project_import.idle.not_reusable", domain: "project_import", text: "它说这台闲着，我不会只凭这句话拿去给别人用。", vars: [], tone: "", source: "2026-08-18 既有项目接管 P0" },
  "project_import.kind.deployment": { id: "project_import.kind.deployment", domain: "project_import", text: "部署去向", vars: [], tone: "", source: "2026-08-21 既有项目接管 I2 收口" },
  "project_import.kind.domain": { id: "project_import.kind.domain", domain: "project_import", text: "域名", vars: [], tone: "", source: "2026-08-21 既有项目接管 I2 收口" },
  "project_import.kind.endpoint": { id: "project_import.kind.endpoint", domain: "project_import", text: "入口", vars: [], tone: "", source: "2026-08-18 既有项目接管 P0" },
  "project_import.kind.host": { id: "project_import.kind.host", domain: "project_import", text: "机器", vars: [], tone: "", source: "2026-08-18 既有项目接管 P0" },
  "project_import.kind.ownership": { id: "project_import.kind.ownership", domain: "project_import", text: "凭什么说是这个项目的", vars: [], tone: "", source: "2026-08-21 既有项目接管 I2 收口" },
  "project_import.kind.project": { id: "project_import.kind.project", domain: "project_import", text: "项目", vars: [], tone: "", source: "2026-08-18 既有项目接管 I1" },
  "project_import.kind.repository": { id: "project_import.kind.repository", domain: "project_import", text: "仓库", vars: [], tone: "", source: "2026-08-18 既有项目接管 P0" },
  "project_import.kind.subscription": { id: "project_import.kind.subscription", domain: "project_import", text: "续费", vars: [], tone: "", source: "2026-08-18 既有项目接管 P0" },
  "project_import.kind.unknown": { id: "project_import.kind.unknown", domain: "project_import", text: "还说不清", vars: [], tone: "", source: "2026-08-18 既有项目接管 P0" },
  "project_import.kind.vendor": { id: "project_import.kind.vendor", domain: "project_import", text: "服务商", vars: [], tone: "", source: "2026-08-18 既有项目接管 P0" },
  "project_import.links.before_ledger": { id: "project_import.links.before_ledger", domain: "project_import", text: "这次是在我开始记账之前接进来的，我说不清当时连了哪几条，所以不敢替你撤。", vars: [], tone: "warn", source: "2026-08-21 既有项目接管 I2 独审回归" },
  "project_import.links.created_entity_conditional": { id: "project_import.links.created_entity_conditional", domain: "project_import", text: "这一条是接进来的时候新建的。撤掉时如果没有别的项目在用它，我会一起收回。", vars: [], tone: "", source: "2026-08-21 既有项目接管 I2 独审回归" },
  "project_import.links.empty": { id: "project_import.links.empty", domain: "project_import", text: "还没有东西被接进来。", vars: [], tone: "", source: "2026-08-21 既有项目接管 I2 收口" },
  "project_import.links.pre_existing": { id: "project_import.links.pre_existing", domain: "project_import", text: "本来就连着的我一条都没动，撤掉也不会碰。", vars: [], tone: "", source: "2026-08-21 既有项目接管 I2 收口" },
  "project_import.links.released": { id: "project_import.links.released", domain: "project_import", text: "已经撤掉了", vars: [], tone: "", source: "2026-08-21 既有项目接管 I2 收口" },
  "project_import.links.title": { id: "project_import.links.title", domain: "project_import", text: "这次接进来的", vars: [], tone: "", source: "2026-08-21 既有项目接管 I2 收口" },
  "project_import.ownership.dashboard_account": { id: "project_import.ownership.dashboard_account", domain: "project_import", text: "他说他有这家的后台账号", vars: [], tone: "", source: "2026-08-21 既有项目接管 I2 收口" },
  "project_import.ownership.deploy_history": { id: "project_import.ownership.deploy_history", domain: "project_import", text: "他说这是他自己部署上去的", vars: [], tone: "", source: "2026-08-21 既有项目接管 I2 收口" },
  "project_import.ownership.derived": { id: "project_import.ownership.derived", domain: "project_import", text: "这条证据的把握，跟它说的那个东西一样。", vars: [], tone: "", source: "2026-08-21 既有项目接管 I2 收口" },
  "project_import.ownership.dns_record": { id: "project_import.ownership.dns_record", domain: "project_import", text: "他说他能改这个域名的解析", vars: [], tone: "", source: "2026-08-21 既有项目接管 I2 收口" },
  "project_import.ownership.other": { id: "project_import.ownership.other", domain: "project_import", text: "他没说清是怎么证明的", vars: [], tone: "", source: "2026-08-21 既有项目接管 I2 收口" },
  "project_import.ownership.repo_write": { id: "project_import.ownership.repo_write", domain: "project_import", text: "他说他能往这个仓库推代码", vars: [], tone: "", source: "2026-08-21 既有项目接管 I2 收口" },
  "project_import.ownership.ssh_login": { id: "project_import.ownership.ssh_login", domain: "project_import", text: "他说他能登进这台机器", vars: [], tone: "", source: "2026-08-21 既有项目接管 I2 收口" },
  "project_import.package.reissue": { id: "project_import.package.reissue", domain: "project_import", text: "重新生成资料包链接", vars: [], tone: "", source: "2026-08-30 资料包口令重发" },
  "project_import.package.reissue_hint": { id: "project_import.package.reissue_hint", domain: "project_import", text: "原来的提交口令丢了的话，可以再发一份。旧的立刻作废。", vars: [], tone: "", source: "2026-08-30 资料包口令重发" },
  "project_import.package.reissuing": { id: "project_import.package.reissuing", domain: "project_import", text: "正在生成", vars: [], tone: "", source: "2026-08-30 资料包口令重发" },
  "project_import.project.seed_summary": { id: "project_import.project.seed_summary", domain: "project_import", text: "从现成项目接进来的，还在核对。", vars: [], tone: "", source: "2026-08-18 既有项目接管 P0" },
  "project_import.prompt.body": { id: "project_import.prompt.body", domain: "project_import", text: "目标：把用户明确提供的真实源码和／或真实资料接入 NPC。先问清要源码、资料包还是两者，以及原内容在哪里。NPC 空仓不是源码来源；无真实源码就不调用 source_checkout_url、不执行 Git、不造占位项目。只要资料时仅提交 package_url 后停止；资料包缺项写 unknowns，不用空内容凑状态。不得索取账号、Cookie、SSH Key、密码或服务器密钥。", vars: [], tone: "", source: "2026-09-10 空仓导入意图与来源门禁" },
  "project_import.prompt.copied": { id: "project_import.prompt.copied", domain: "project_import", text: "已经复制了", vars: [], tone: "", source: "2026-08-18 既有项目接管 P0" },
  "project_import.prompt.copy": { id: "project_import.prompt.copy", domain: "project_import", text: "复制交代词", vars: [], tone: "", source: "2026-08-18 既有项目接管 P0" },
  "project_import.prompt.copy_failed": { id: "project_import.prompt.copy_failed", domain: "project_import", text: "我这边复制不了，你手动选中下面那两行也行。", vars: [], tone: "warn", source: "2026-08-21 既有项目接管 I2 收口" },
  "project_import.prompt.hidden": { id: "project_import.prompt.hidden", domain: "project_import", text: "口令已经给过一次，我不会再显示。", vars: [], tone: "", source: "2026-08-18 既有项目接管 P0" },
  "project_import.prompt.once": { id: "project_import.prompt.once", domain: "project_import", text: "新 AI 的身份邀请链接只显示这一次。关掉页面就看不见了。", vars: [], tone: "", source: "2026-08-18 既有项目接管 P0" },
  "project_import.prompt.path_label": { id: "project_import.prompt.path_label", domain: "project_import", text: "提交路径", vars: [], tone: "", source: "2026-08-18 既有项目接管 P0" },
  "project_import.prompt.title": { id: "project_import.prompt.title", domain: "project_import", text: "把这段话交给被指定的 AI", vars: [], tone: "", source: "2026-08-18 既有项目接管 P0" },
  "project_import.prompt.token_label": { id: "project_import.prompt.token_label", domain: "project_import", text: "一次性口令", vars: [], tone: "", source: "2026-08-18 既有项目接管 P0" },
  "project_import.renewal.due": { id: "project_import.renewal.due", domain: "project_import", text: "{vendor} 到 {due} 要续费", vars: ["due", "vendor"], tone: "", source: "2026-08-21 既有项目接管 I2 收口" },
  "project_import.renewal.none": { id: "project_import.renewal.none", domain: "project_import", text: "接进来的这几家都没写到期日。", vars: [], tone: "", source: "2026-08-21 既有项目接管 I2 收口" },
  "project_import.renewal.today": { id: "project_import.renewal.today", domain: "project_import", text: "今天该提醒了", vars: [], tone: "", source: "2026-09-04 既有项目接管 I3" },
  "project_import.review.empty": { id: "project_import.review.empty", domain: "project_import", text: "资料包是空的。说不清的也要写进 unknowns，我才知道漏了什么。", vars: [], tone: "", source: "2026-08-18 既有项目接管 P0" },
  "project_import.review.title": { id: "project_import.review.title", domain: "project_import", text: "我先记下了这些", vars: [], tone: "", source: "2026-08-18 既有项目接管 P0" },
  "project_import.review.waiting": { id: "project_import.review.waiting", domain: "project_import", text: "还在等原来的开发 AI 交资料包。", vars: [], tone: "", source: "2026-08-18 既有项目接管 P0" },
  "project_import.source.awaiting": { id: "project_import.source.awaiting", domain: "project_import", text: "私有仓库已经备好，正在等 AI 推送源码。", vars: [], tone: "", source: "2026-08-29 完整项目导入" },
  "project_import.source.awaiting_assignee": { id: "project_import.source.awaiting_assignee", domain: "project_import", text: "私有空仓库已经备好，生成单次导入链接后即可交付源码。", vars: [], tone: "", source: "2026-09-09 导入流程收敛" },
  "project_import.source.candidate": { id: "project_import.source.candidate", domain: "project_import", text: "已接收提交", vars: [], tone: "", source: "2026-08-29 完整项目导入" },
  "project_import.source.claimed_hint": { id: "project_import.source.claimed_hint", domain: "project_import", text: "AI 在 {time} 领过一次传输参数，源码还没推上来。可以让当前身份重新领取，也可以重新生成链接改交给别人。", vars: ["time"], tone: "", source: "补充" },
  "project_import.source.imported": { id: "project_import.source.imported", domain: "project_import", text: "源码已经进入 NPC 自管仓库，后续开发从这里继续。", vars: [], tone: "", source: "2026-08-29 完整项目导入" },
  "project_import.source.importing": { id: "project_import.source.importing", domain: "project_import", text: "源码已经收到，正在写入 NPC 自管仓库。", vars: [], tone: "", source: "2026-08-29 完整项目导入" },
  "project_import.source.needs_rebase": { id: "project_import.source.needs_rebase", domain: "project_import", text: "仓库基线已经变化，请重新准备一次导入地址。", vars: [], tone: "", source: "2026-08-29 完整项目导入" },
  "project_import.source.repository": { id: "project_import.source.repository", domain: "project_import", text: "NPC 自管仓库", vars: [], tone: "", source: "2026-08-29 完整项目导入" },
  "project_import.source.resend_hint": { id: "project_import.source.resend_hint", domain: "project_import", text: "关掉页面后一次性地址就看不见了，可以再发一份。旧的立刻作废。", vars: [], tone: "", source: "2026-08-30 源码入口重发" },
  "project_import.source.retry": { id: "project_import.source.retry", domain: "project_import", text: "重新准备导入地址", vars: [], tone: "", source: "2026-08-29 完整项目导入" },
  "project_import.source.retrying": { id: "project_import.source.retrying", domain: "project_import", text: "正在准备", vars: [], tone: "", source: "2026-08-29 完整项目导入" },
  "project_import.source.setup_failed": { id: "project_import.source.setup_failed", domain: "project_import", text: "私有仓库或一次性地址还没准备好，可以直接重试。", vars: [], tone: "", source: "2026-08-29 完整项目导入" },
  "project_import.source.status_unavailable": { id: "project_import.source.status_unavailable", domain: "project_import", text: "暂时读不到源码接管状态，稍后会自动再看。", vars: [], tone: "", source: "2026-08-29 完整项目导入" },
  "project_import.source.title": { id: "project_import.source.title", domain: "project_import", text: "源码接管", vars: [], tone: "", source: "2026-08-29 完整项目导入" },
  "project_import.status.approved": { id: "project_import.status.approved", domain: "project_import", text: "已经接上了", vars: [], tone: "", source: "2026-08-19 既有项目接管 I2" },
  "project_import.status.awaiting_package": { id: "project_import.status.awaiting_package", domain: "project_import", text: "等资料包", vars: [], tone: "", source: "2026-08-18 既有项目接管 P0" },
  "project_import.status.reviewed": { id: "project_import.status.reviewed", domain: "project_import", text: "已核对", vars: [], tone: "", source: "2026-08-18 既有项目接管 P0" },
  "project_import.subscription.no_due": { id: "project_import.subscription.no_due", domain: "project_import", text: "我这边还没记到期日，接进来的时候会一起记上。", vars: [], tone: "", source: "2026-08-21 既有项目接管 I2 收口" },
  "project_import.summary.counts": { id: "project_import.summary.counts", domain: "project_import", text: "核对过 {verified} 条，清单对得上 {matched} 条，这边还没有 {missing} 条，对不上 {conflict} 条。", vars: ["conflict", "matched", "missing", "verified"], tone: "", source: "2026-09-04 既有项目接管 I3" },
  "project_import.unlink.hint": { id: "project_import.unlink.hint", domain: "project_import", text: "只撤这次接进来的那几条。你自己连的、别的项目在用的，我一条都不碰。", vars: [], tone: "", source: "2026-08-21 既有项目接管 I2 收口" },
  "project_import.unlink.submitting": { id: "project_import.unlink.submitting", domain: "project_import", text: "正在撤", vars: [], tone: "", source: "2026-08-21 既有项目接管 I2 收口" },
  "project_import.wizard.draft_ready": { id: "project_import.wizard.draft_ready", domain: "project_import", text: "草稿和私有空仓库已建好。", vars: [], tone: "", source: "2026-09-09 身份绑定导入闭环" },
  "project_import.wizard.name": { id: "project_import.wizard.name", domain: "project_import", text: "项目叫什么", vars: [], tone: "", source: "2026-08-18 既有项目接管 P0" },
  "project_import.wizard.submit": { id: "project_import.wizard.submit", domain: "project_import", text: "建好草稿", vars: [], tone: "", source: "2026-08-18 既有项目接管 P0" },
  "project_import.wizard.submitting": { id: "project_import.wizard.submitting", domain: "project_import", text: "正在建草稿", vars: [], tone: "", source: "2026-08-18 既有项目接管 P0" },
  "project_import.wizard.subtitle": { id: "project_import.wizard.subtitle", domain: "project_import", text: "先建项目草稿和私有空仓库，再生成单次导入链接交接源码。", vars: [], tone: "", source: "2026-09-09 导入流程收敛" },
  "project_import.wizard.title": { id: "project_import.wizard.title", domain: "project_import", text: "接进来一个现成项目", vars: [], tone: "", source: "2026-08-18 既有项目接管 P0" },
  "remedy.backup.check_job": { id: "remedy.backup.check_job", domain: "remedy", text: "我可以去 {host} 上看看备份是怎么跑的，是任务没触发还是跑到一半断了。", vars: ["host"], tone: "", source: "补充" },
  "remedy.cert.renew": { id: "remedy.cert.renew", domain: "remedy", text: "{host} 上 {domain} 的证书还有 {days} 天到期，我可以现在就续，续完打开网站确认一下真的好了。", vars: ["days", "domain", "host"], tone: "", source: "补充" },
  "remedy.disk.clean_docker": { id: "remedy.disk.clean_docker", domain: "remedy", text: "{host} 上 Docker 攒下的旧镜像和停掉的容器可以清，业务数据一个字节都不碰。", vars: ["host"], tone: "", source: "补充" },
  "remedy.disk.clean_old_logs": { id: "remedy.disk.clean_old_logs", domain: "remedy", text: "{host} 上 {mount} 里的旧日志我可以清掉，日志清了不影响正在跑的东西。", vars: ["host", "mount"], tone: "", source: "补充" },
  "remedy.disk.look_at_big_files": { id: "remedy.disk.look_at_big_files", domain: "remedy", text: "我可以先把 {host} 上 {mount} 里最占地方的那些列给你看，你说删哪个我再动手。", vars: ["host", "mount"], tone: "", source: "补充" },
  "remedy.load.look_at_top": { id: "remedy.load.look_at_top", domain: "remedy", text: "我可以看看 {host} 上是谁在占着 CPU,把最吃的那几个列给你。", vars: ["host"], tone: "", source: "补充" },
  "remedy.no_suggestion": { id: "remedy.no_suggestion", domain: "remedy", text: "{what} 这件事我暂时没有现成的处置办法，先记在这儿等你看一眼。", vars: ["what"], tone: "neutral", source: "补充" },
  "remedy.port.check_listener": { id: "remedy.port.check_listener", domain: "remedy", text: "我可以去 {host} 上看看 {port} 这个口本来该由谁守着，是程序没起来还是防火墙挡住了。", vars: ["host", "port"], tone: "", source: "补充" },
  "remedy.process.restart": { id: "remedy.process.restart", domain: "remedy", text: "我可以把 {host} 上的 {process} 重新拉起来。要是它反复挂，我会先查清楚为什么再动。", vars: ["host", "process"], tone: "", source: "补充" },
  "repo.conflict.clear": { id: "repo.conflict.clear", domain: "repo", text: "你最近推的东西和我要改的没碰在一起，我接着干。", vars: [], tone: "ok", source: "补充" },
  "repo.conflict.deferred": { id: "repo.conflict.deferred", domain: "repo", text: "我要改的 {file} 正是你本地在改的那个，我先停下来，等你说了再动。", vars: ["file"], tone: "warn", source: "补充" },
  "repo.gate.blocked.our_environment": { id: "repo.gate.blocked.our_environment", domain: "repo", text: "这次没跑成，是我这边的问题，不是你的代码。我在查，弄好了自己重来一次。", vars: [], tone: "warn", source: "补充" },
  "repo.gate.blocked.platform_stopped": { id: "repo.gate.blocked.platform_stopped", domain: "repo", text: "卡在：平台把这次跑停了，不是你的代码", vars: [], tone: "", source: "补充" },
  "repo.gate.deployed": { id: "repo.gate.deployed", domain: "repo", text: "过了，已上线", vars: [], tone: "ok", source: "设计稿 · 代码与发布" },
  "repo.gate.held": { id: "repo.gate.held", domain: "repo", text: "过了，先存我这儿", vars: [], tone: "", source: "补充" },
  "repo.gate.needs_you": { id: "repo.gate.needs_you", domain: "repo", text: "等你点头", vars: [], tone: "", source: "补充" },
  "repo.gate.passed": { id: "repo.gate.passed", domain: "repo", text: "过了，已入库", vars: [], tone: "ok", source: "设计稿 · 代码与发布" },
  "repo.gate.pending": { id: "repo.gate.pending", domain: "repo", text: "过了，等你发布", vars: [], tone: "warn", source: "设计稿 · 代码与发布" },
  "repo.gate.redline.hit": { id: "repo.gate.redline.hit", domain: "repo", text: "这一步碰到{what}了，得你点一下。", vars: ["what"], tone: "warn", source: "补充" },
  "repo.gate.redline.no_tests": { id: "repo.gate.redline.no_tests", domain: "repo", text: "这段碰了{what}，而且没有对应测试。", vars: ["what"], tone: "warn", source: "设计稿 · 代码与发布" },
  "repo.gate.rejected": { id: "repo.gate.rejected", domain: "repo", text: "被打回", vars: [], tone: "danger", source: "设计稿 · 代码与发布" },
  "repo.gate.rejected.plain": { id: "repo.gate.rejected.plain", domain: "repo", text: "平台拦下来了：{reason}。我把原因发回给 AI，它正在重写。你的仓库里没留下这次提交。", vars: ["reason"], tone: "danger", source: "设计稿 · 代码与发布" },
  "repo.gate.rejected.secret": { id: "repo.gate.rejected.secret", domain: "repo", text: "扫到了不该进仓库的东西——{what}，在 {location}。这次我拦下了，你的仓库里没留下它。", vars: ["location", "what"], tone: "danger", source: "补充" },
  "repo.gate.rejected.size": { id: "repo.gate.rejected.size", domain: "repo", text: "这次改得太大了，{files} 个文件、{lines} 行。拆成几次推，我好一件一件看清楚。", vars: ["files", "lines"], tone: "danger", source: "补充" },
  "repo.gate.rejected.spread": { id: "repo.gate.rejected.spread", domain: "repo", text: "这次一口气动了 {modules} 个模块。拆开推，出事了我才知道是哪一块。", vars: ["modules"], tone: "danger", source: "补充" },
  "repo.gate.rejected.tests": { id: "repo.gate.rejected.tests", domain: "repo", text: "测试没过，{failed} 个用例挂了。下面是它们的输出，改完再推一次。", vars: ["failed"], tone: "danger", source: "补充" },
  "repo.gate.rejected.tests_unknown_count": { id: "repo.gate.rejected.tests_unknown_count", domain: "repo", text: "测试没过。下面是它的输出，改完再推一次。", vars: [], tone: "danger", source: "补充" },
  "repo.npcmd.branch_line": { id: "repo.npcmd.branch_line", domain: "repo", text: "{branch}：{what}", vars: ["branch", "what"], tone: "neutral", source: "设计稿 · 项目详情" },
  "repo.npcmd.intro": { id: "repo.npcmd.intro", domain: "repo", text: "这个文件是平台自动写的，每次我动过你的代码就更新一次。你本地开工时跟 AI 说一句「先看一眼小队有没有动过」，它读这个文件就全知道了。", vars: [], tone: "neutral", source: "补充" },
  "repo.npcmd.never_touch_main": { id: "repo.npcmd.never_touch_main", domain: "repo", text: "我改的东西永远进独立分支，绝不动你的 main。你想什么时候合就什么时候合，也可以不合。", vars: [], tone: "neutral", source: "补充" },
  "repo.npcmd.online_unknown": { id: "repo.npcmd.online_unknown", domain: "repo", text: "线上跑的哪一版我还不知道——这个项目还没接发布流水线。", vars: [], tone: "neutral", source: "补充" },
  "repo.npcmd.online_version": { id: "repo.npcmd.online_version", domain: "repo", text: "线上正跑 {version}", vars: ["version"], tone: "neutral", source: "设计稿 · 项目详情" },
  "repo.npcmd.pending_count": { id: "repo.npcmd.pending_count", domain: "repo", text: "{count} 个分支等你合", vars: ["count"], tone: "neutral", source: "设计稿 · 项目详情" },
  "repo.npcmd.pending_none": { id: "repo.npcmd.pending_none", domain: "repo", text: "没有等你合的分支，我最近没动过这个仓库。", vars: [], tone: "ok", source: "补充" },
  "repo.npcmd.title": { id: "repo.npcmd.title", domain: "repo", text: "平台这边动过什么", vars: [], tone: "", source: "补充" },
  "repo.npcmd.touched_files": { id: "repo.npcmd.touched_files", domain: "repo", text: "我碰过的文件", vars: [], tone: "neutral", source: "设计稿 · 项目详情" },
  "repo.push.accepted": { id: "repo.push.accepted", domain: "repo", text: "我收下了，正在跑测试和安全扫描。过不了我会把原因发回给你，你的 Forgejo 里不会留下这次提交。", vars: [], tone: "neutral", source: "补充" },
  "repo.push.branch_rejected": { id: "repo.push.branch_rejected", domain: "repo", text: "我只往 npc/ 开头的分支推，{branch} 不归我动。换成 {suggestion} 再推一次。", vars: ["branch", "suggestion"], tone: "danger", source: "补充" },
  "repo.push.delete_rejected": { id: "repo.push.delete_rejected", domain: "repo", text: "删分支这种事我不自己做，你在控制台上点一下才算数。", vars: [], tone: "danger", source: "补充" },
  "repo.push.forward_conflict": { id: "repo.push.forward_conflict", domain: "repo", text: "Forgejo 的这个分支已经有另一份提交了，我不替你盖掉，等你来决定。", vars: [], tone: "warn", source: "补充" },
  "repo.push.forward_rejected": { id: "repo.push.forward_rejected", domain: "repo", text: "我没能把这次提交推进 Forgejo，而且重试也解决不了。我已经停下，等你决定下一步。", vars: [], tone: "danger", source: "补充" },
  "repo.push.forwarded": { id: "repo.push.forwarded", domain: "repo", text: "四道门都过了，我把它推进你的 Forgejo 了，在 {branch} 上等你合。", vars: ["branch"], tone: "ok", source: "补充" },
  "repo.push.held_no_remote": { id: "repo.push.held_no_remote", domain: "repo", text: "门都过了，但我还没拿到你 Forgejo 的钥匙，先替你存在平台这边。", vars: [], tone: "warn", source: "补充" },
  "repo.push.ref_rejected": { id: "repo.push.ref_rejected", domain: "repo", text: "这一次推送里有分支被我拦下了，所以整批都没进去。", vars: [], tone: "danger", source: "补充" },
  "repo.push.tag_rejected": { id: "repo.push.tag_rejected", domain: "repo", text: "标签我不碰——版本号是你说了算的东西。", vars: [], tone: "danger", source: "补充" },
  "repo.redline.credentials": { id: "repo.redline.credentials", domain: "repo", text: "存钥匙的地方", vars: [], tone: "", source: "补充" },
  "repo.redline.data_delete": { id: "repo.redline.data_delete", domain: "repo", text: "删数据的语句", vars: [], tone: "", source: "补充" },
  "repo.redline.money": { id: "repo.redline.money", domain: "repo", text: "钱", vars: [], tone: "", source: "补充" },
  "repo.redline.permission": { id: "repo.redline.permission", domain: "repo", text: "谁能看什么", vars: [], tone: "", source: "补充" },
  "sec.clean": { id: "sec.clean", domain: "sec", text: "这次体检没查出问题，该关的都关着。", vars: [], tone: "ok", source: "补充" },
  "sec.count.fixed": { id: "sec.count.fixed", domain: "sec", text: "我已经补好了", vars: [], tone: "ok", source: "设计稿 · 安全体检" },
  "sec.count.must_fix": { id: "sec.count.must_fix", domain: "sec", text: "需要马上处理", vars: [], tone: "danger", source: "设计稿 · 安全体检" },
  "sec.count.when_free": { id: "sec.count.when_free", domain: "sec", text: "找空补一补", vars: [], tone: "warn", source: "设计稿 · 安全体检" },
  "sec.empty": { id: "sec.empty", domain: "sec", text: "还没体检过。接进来的机器我会顺手查一遍，之后每周一凌晨再查。", vars: [], tone: "", source: "补充" },
  "sec.level.fixed": { id: "sec.level.fixed", domain: "sec", text: "已补好", vars: [], tone: "ok", source: "设计稿 · 安全体检" },
  "sec.level.must_fix": { id: "sec.level.must_fix", domain: "sec", text: "得管", vars: [], tone: "danger", source: "设计稿 · 安全体检" },
  "sec.level.when_free": { id: "sec.level.when_free", domain: "sec", text: "找空补", vars: [], tone: "warn", source: "设计稿 · 安全体检" },
  "sec.no_firewall.explanation": { id: "sec.no_firewall.explanation", domain: "sec", text: "机器上开着的每个端口现在都直接对着外网。你自己都不一定清楚上面跑着的程序偷偷开了哪些口。", vars: [], tone: "", source: "补充" },
  "sec.no_firewall.suggestion": { id: "sec.no_firewall.suggestion", domain: "sec", text: "我建议装一个，只留你确实要用的那几个口。要我先列一份「现在开着哪些口、各是谁在用」给你看看吗？", vars: [], tone: "", source: "补充" },
  "sec.no_firewall.title": { id: "sec.no_firewall.title", domain: "sec", text: "这台机器没有防火墙在跑", vars: [], tone: "", source: "补充" },
  "sec.page.subtitle": { id: "sec.page.subtitle", domain: "sec", text: "每周一凌晨自动体检一次，能自己补的当场补掉，补不了的写清楚为什么。", vars: [], tone: "", source: "设计稿 · 安全体检" },
  "sec.page.title": { id: "sec.page.title", domain: "sec", text: "安全体检", vars: [], tone: "", source: "设计稿 · 安全体检" },
  "sec.password_login_enabled.explanation": { id: "sec.password_login_enabled.explanation", domain: "sec", text: "密码是可以被慢慢猜出来的，钥匙不行。现在这台机器上跑的东西，都挡在一串能被猜到的字符后面。", vars: [], tone: "", source: "补充" },
  "sec.password_login_enabled.suggestion": { id: "sec.password_login_enabled.suggestion", domain: "sec", text: "我建议改成只认钥匙 —— 但你要是习惯自己用密码连，就先留着。", vars: [], tone: "", source: "设计稿 · 安全体检" },
  "sec.password_login_enabled.title": { id: "sec.password_login_enabled.title", domain: "sec", text: "这台机器还能用密码登录", vars: [], tone: "", source: "补充" },
  "sec.pending_security_updates.explanation": { id: "sec.pending_security_updates.explanation", domain: "sec", text: "这些补丁修的都是已经被公开的问题，也就是说找上门的人知道该试什么。多数打起来不影响服务。", vars: [], tone: "", source: "补充" },
  "sec.pending_security_updates.suggestion": { id: "sec.pending_security_updates.suggestion", domain: "sec", text: "我可以挑个夜里低峰的时候一台一台打，要重启的那几个单独挑出来问你。", vars: [], tone: "", source: "补充" },
  "sec.pending_security_updates.title": { id: "sec.pending_security_updates.title", domain: "sec", text: "有 {count} 个安全补丁还没打", vars: ["count"], tone: "", source: "补充" },
  "sec.risk.model_unsure": { id: "sec.risk.model_unsure", domain: "sec", text: "这一步我拿不准，你看一眼", vars: [], tone: "warn", source: "补充" },
  "sec.root_password_login.explanation": { id: "sec.root_password_login.explanation", domain: "sec", text: "root 是这台机器上什么都能做的那个账号，现在它和别的账号一样只靠一串密码挡着。猜中一次，删库、装东西、改任何配置都不需要再问谁。", vars: [], tone: "", source: "补充" },
  "sec.root_password_login.suggestion": { id: "sec.root_password_login.suggestion", domain: "sec", text: "我建议先把 root 的密码登录关掉，日常用你自己那个账号连，需要时再提权。这一步我不敢自己做 —— 万一你有别的程序正靠 root 连着。", vars: [], tone: "", source: "补充" },
  "sec.root_password_login.title": { id: "sec.root_password_login.title", domain: "sec", text: "这台机器的最高权限账号能直接用密码登进来", vars: [], tone: "", source: "补充" },
  "sec.score.label": { id: "sec.score.label", domain: "sec", text: "整体安全分 · 挺健康", vars: [], tone: "", source: "设计稿 · 安全体检" },
  "sec.ssh_open_to_world.explanation": { id: "sec.ssh_open_to_world.explanation", domain: "sec", text: "这台机器的 {port} 端口任何人都连得上，全世界的扫描器每天都在挨个试密码。真被试出来，这台机器上的东西就都是别人的了。", vars: ["port"], tone: "", source: "补充" },
  "sec.ssh_open_to_world.suggestion": { id: "sec.ssh_open_to_world.suggestion", domain: "sec", text: "我建议只放你自己常用的几个地址进来，别的一律挡在外面。要我帮你收一下吗？", vars: [], tone: "", source: "补充" },
  "sec.ssh_open_to_world.title": { id: "sec.ssh_open_to_world.title", domain: "sec", text: "登录这台机器的门开在外网上", vars: [], tone: "", source: "补充" },
  "split.action.preview": { id: "split.action.preview", domain: "split", text: "让 AI 给拆分方案", vars: [], tone: "", source: "RFC-002" },
  "split.action.preview_only": { id: "split.action.preview_only", domain: "split", text: "只是预览", vars: [], tone: "", source: "资源模块 SPEC 2026-08-27 · R07" },
  "split.capacity.reason.child_host": { id: "split.capacity.reason.child_host", domain: "split", text: "这台机器自己就是拆出来的，拆出来的机器不再往下拆", vars: [], tone: "", source: "RFC-001 §2.2" },
  "split.capacity.reason.has_capacity": { id: "split.capacity.reason.has_capacity", domain: "split", text: "这台有可分配的内存和硬盘", vars: [], tone: "", source: "RFC-002 §2.2" },
  "split.capacity.reason.incomplete": { id: "split.capacity.reason.incomplete", domain: "split", text: "还没拿到完整容量", vars: [], tone: "", source: "RFC-002 §4.3" },
  "split.capacity.reason.unknown_carvable": { id: "split.capacity.reason.unknown_carvable", domain: "split", text: "还没拿到可拆容量", vars: [], tone: "", source: "RFC-002 §4.3" },
  "split.card.body": { id: "split.card.body", domain: "split", text: "我会先给一份方案，校验过再拆。现在这一步不会动服务器。", vars: [], tone: "", source: "补充" },
  "split.card.title": { id: "split.card.title", domain: "split", text: "拆分方案", vars: [], tone: "", source: "RFC-002" },
  "split.exposure.domain": { id: "split.exposure.domain", domain: "split", text: "从域名进来", vars: [], tone: "", source: "RFC-002 §7.4" },
  "split.exposure.internal_only": { id: "split.exposure.internal_only", domain: "split", text: "只在内部用", vars: [], tone: "", source: "RFC-002 §7.4" },
  "split.exposure.ip_port": { id: "split.exposure.ip_port", domain: "split", text: "从 IP 和端口进来", vars: [], tone: "", source: "RFC-002 §7.4" },
  "split.model.degraded.rule": { id: "split.model.degraded.rule", domain: "split", text: "AI 这会儿没接上，我先按老规矩给了一版。方案偏保守，不会直接动服务器。", vars: [], tone: "neutral", source: "RFC-002 §6.1" },
  "split.name.backend": { id: "split.name.backend", domain: "split", text: "{project_name} · 后端", vars: ["project_name"], tone: "", source: "RFC-002 §4.4" },
  "split.name.database": { id: "split.name.database", domain: "split", text: "{project_name} · 数据库", vars: ["project_name"], tone: "", source: "RFC-002 §4.4" },
  "split.name.default_project": { id: "split.name.default_project", domain: "split", text: "这个项目", vars: [], tone: "", source: "RFC-002 §4.1" },
  "split.name.spare": { id: "split.name.spare", domain: "split", text: "备用", vars: [], tone: "", source: "RFC-002 §4.1" },
  "split.plan.cannot": { id: "split.plan.cannot", domain: "split", text: "这台现在不适合拆：{reason}", vars: ["reason"], tone: "warn", source: "RFC-001 §7.2" },
  "split.plan.headline": { id: "split.plan.headline", domain: "split", text: "我建议先拆 {count} 台", vars: ["count"], tone: "", source: "RFC-002 §4.1" },
  "split.plan.why_not_more": { id: "split.plan.why_not_more", domain: "split", text: "我先留着 {reserve_memory} 内存和 {reserve_disk} 硬盘不动，后面加项目不用重拆这台机器。", vars: ["reserve_disk", "reserve_memory"], tone: "", source: "RFC-002 §4.1" },
  "split.posture.balanced": { id: "split.posture.balanced", domain: "split", text: "均衡", vars: [], tone: "", source: "RFC-002 §7.4" },
  "split.posture.conservative": { id: "split.posture.conservative", domain: "split", text: "稳一点", vars: [], tone: "", source: "RFC-002 §7.4" },
  "split.posture.dense": { id: "split.posture.dense", domain: "split", text: "多拆", vars: [], tone: "", source: "RFC-002 §7.4" },
  "split.posture.heading": { id: "split.posture.heading", domain: "split", text: "拆分方式", vars: [], tone: "", source: "RFC-002 §7.4" },
  "split.posture.minimal": { id: "split.posture.minimal", domain: "split", text: "少拆", vars: [], tone: "", source: "RFC-002 §7.4" },
  "split.preview.provenance.by_ai": { id: "split.preview.provenance.by_ai", domain: "split", text: "{date} · AI 生成", vars: ["date"], tone: "", source: "RFC-002 §4.4" },
  "split.preview.provenance.by_rule": { id: "split.preview.provenance.by_rule", domain: "split", text: "{date} · 规则版", vars: ["date"], tone: "", source: "RFC-002 §4.4" },
  "split.preview.provenance.heading": { id: "split.preview.provenance.heading", domain: "split", text: "方案来源", vars: [], tone: "", source: "RFC-002 §4.4" },
  "split.reason.capacity": { id: "split.reason.capacity", domain: "split", text: "这台的内存和硬盘够放 {count} 台中等机器，再多就不稳了。", vars: ["count"], tone: "", source: "RFC-002 §4.1" },
  "split.reason.no_context": { id: "split.reason.no_context", domain: "split", text: "我没看出来这台打算干什么，先给你拆一台中等的。", vars: [], tone: "", source: "RFC-002 §4.3" },
  "split.reason.project_count": { id: "split.reason.project_count", domain: "split", text: "你现在有 {project_count} 个项目，我按一个项目一台、再留余量来分。", vars: ["project_count"], tone: "", source: "RFC-002 §4.1" },
  "split.requirement.placeholder": { id: "split.requirement.placeholder", domain: "split", text: "比如：给这个项目拆前端、后端和数据库，数据库要单独隔开。", vars: [], tone: "", source: "补充" },
  "split.runtime.kvm.database": { id: "split.runtime.kvm.database", domain: "split", text: "数据库用 KVM 隔开，边界更硬。", vars: [], tone: "", source: "RFC-002 §2.2" },
  "split.runtime.lxc.default": { id: "split.runtime.lxc.default", domain: "split", text: "这类服务用 LXC 就够，回滚和装探针都顺。", vars: [], tone: "", source: "RFC-002 §2.2" },
  "split.size.lt_one_g": { id: "split.size.lt_one_g", domain: "split", text: "不到 1G", vars: [], tone: "", source: "RFC-002 §4.1" },
  "split.size.some": { id: "split.size.some", domain: "split", text: "一些", vars: [], tone: "", source: "RFC-002 §4.1" },
  "split.slice.reason.database": { id: "split.slice.reason.database", domain: "split", text: "数据库单独隔开，出问题不拖着别的服务一起倒。", vars: [], tone: "", source: "RFC-002 §2.3" },
  "split.slice.reason.project": { id: "split.slice.reason.project", domain: "split", text: "给「{project_name}」放业务服务。", vars: ["project_name"], tone: "", source: "RFC-002 §4.4" },
  "split.slice.reason.spare": { id: "split.slice.reason.spare", domain: "split", text: "先留一台备用，后面新项目可以直接用。", vars: [], tone: "", source: "RFC-002 §4.1" },
  "split.state.empty": { id: "split.state.empty", domain: "split", text: "还没出方案。", vars: [], tone: "", source: "补充" },
  "split.state.pending": { id: "split.state.pending", domain: "split", text: "我在看这台机器能怎么拆。", vars: [], tone: "", source: "补充" },
  "split.validation.accepted": { id: "split.validation.accepted", domain: "split", text: "这份方案过了保守校验。", vars: [], tone: "ok", source: "RFC-002 §1.5" },
  "split.validation.adjusted": { id: "split.validation.adjusted", domain: "split", text: "我把方案往保守方向收了一点。", vars: [], tone: "warn", source: "RFC-002 §1.5" },
  "split.validation.rejected": { id: "split.validation.rejected", domain: "split", text: "这份方案没过校验，不会执行。", vars: [], tone: "danger", source: "RFC-002 §1.5" },
  "split_exec.blocked.busy": { id: "split_exec.blocked.busy", domain: "split_exec", text: "这台机器上已经有一次拆机在等你点头，我先不开第二次。", vars: [], tone: "warn", source: "补充" },
  "split_exec.blocked.no_executor": { id: "split_exec.blocked.no_executor", domain: "split_exec", text: "我现在够不到这台机器，先不给你那个按钮——省得你点了没反应。", vars: [], tone: "warn", source: "补充" },
  "split_exec.blocked.plan_rejected": { id: "split_exec.blocked.plan_rejected", domain: "split_exec", text: "这份方案没过校验，我不会把它变成命令。", vars: [], tone: "danger", source: "RFC-002 §1.5" },
  "split_exec.blocked.plan_stale": { id: "split_exec.blocked.plan_stale", domain: "split_exec", text: "这台机器的情况和出方案那会儿不一样了，我重新给你出一份再说。", vars: [], tone: "warn", source: "补充" },
  "split_exec.cause.carve_slice": { id: "split_exec.cause.carve_slice", domain: "split_exec", text: "我按你点头的那份方案，在这台上拆出「{slice_name}」。", vars: ["slice_name"], tone: "", source: "RFC-002 §1.6" },
  "split_exec.confirm.red": { id: "split_exec.confirm.red", domain: "split_exec", text: "这一步会真的动这台机器，得你点一下。", vars: [], tone: "warn", source: "CLAUDE.md §3 文案表「这一步碰到钱了，得你点一下」" },
  "split_exec.undo.manual": { id: "split_exec.undo.manual", domain: "split_exec", text: "万一我自己没撤干净：把 {instance_name} 这台删掉就回到原样了，别的我一样都没动。", vars: ["instance_name"], tone: "", source: "补充" },
  "static_site.account.empty": { id: "static_site.account.empty", domain: "static_site", text: "还没有公共网页。把一份拖进来就有网址了。", vars: [], tone: "", source: "补充" },
  "static_site.account.loading": { id: "static_site.account.loading", domain: "static_site", text: "我在看有哪些网页。", vars: [], tone: "", source: "补充" },
  "static_site.create.slug_invalid": { id: "static_site.create.slug_invalid", domain: "static_site", text: "这一段我用不了。小写字母开头，中间可以有短横线，最长 63 个字。", vars: [], tone: "", source: "补充" },
  "static_site.create.slug_label": { id: "static_site.create.slug_label", domain: "static_site", text: "网址里的那一段", vars: [], tone: "", source: "补充" },
  "static_site.create.slug_placeholder": { id: "static_site.create.slug_placeholder", domain: "static_site", text: "只能用小写字母、数字和中间的短横线", vars: [], tone: "", source: "补充" },
  "static_site.create.submit": { id: "static_site.create.submit", domain: "static_site", text: "开一个", vars: [], tone: "", source: "补充" },
  "static_site.create.title_label": { id: "static_site.create.title_label", domain: "static_site", text: "给它起个名字", vars: [], tone: "", source: "补充" },
  "static_site.create.title_placeholder": { id: "static_site.create.title_placeholder", domain: "static_site", text: "不填也行，我用那一段当名字", vars: [], tone: "", source: "补充" },
  "static_site.drop.busy": { id: "static_site.drop.busy", domain: "static_site", text: "我在发，发完这个网址就能打开了。", vars: [], tone: "", source: "补充" },
  "static_site.drop.done": { id: "static_site.drop.done", domain: "static_site", text: "发出去了，可以去测了。", vars: [], tone: "ok", source: "补充" },
  "static_site.drop.hint": { id: "static_site.drop.hint", domain: "static_site", text: "一个 HTML 文件，或者一个 ZIP 包。最大 5 MB。", vars: [], tone: "", source: "补充" },
  "static_site.drop.label": { id: "static_site.drop.label", domain: "static_site", text: "把网页拖到这里", vars: [], tone: "", source: "补充" },
  "static_site.drop.update_label": { id: "static_site.drop.update_label", domain: "static_site", text: "把新的一版拖到这里", vars: [], tone: "", source: "补充" },
  "static_site.empty": { id: "static_site.empty", domain: "static_site", text: "这个项目还没有网页。把一份拖进来就有网址了。", vars: [], tone: "", source: "补充" },
  "static_site.live.active": { id: "static_site.live.active", domain: "static_site", text: "第 {version_no} 版，{when} 换过来的。", vars: ["version_no", "when"], tone: "ok", source: "补充" },
  "static_site.live.failed": { id: "static_site.live.failed", domain: "static_site", text: "这一版没放出去，上一版还在服务。", vars: [], tone: "danger", source: "补充" },
  "static_site.live.none": { id: "static_site.live.none", domain: "static_site", text: "还没放出去过，这个网址现在打开是空的。", vars: [], tone: "", source: "补充" },
  "static_site.live.pending": { id: "static_site.live.pending", domain: "static_site", text: "我正在放这一版，还没换过来 —— 访问的人现在看到的仍是上一版。", vars: [], tone: "warn", source: "补充" },
  "static_site.live.superseded": { id: "static_site.live.superseded", domain: "static_site", text: "这一版让位给后面那次了。", vars: [], tone: "", source: "补充" },
  "static_site.live.title": { id: "static_site.live.title", domain: "static_site", text: "现在大家看到的", vars: [], tone: "", source: "补充" },
  "static_site.loading": { id: "static_site.loading", domain: "static_site", text: "我在看这个项目有哪些网页。", vars: [], tone: "", source: "补充" },
  "static_site.name.label": { id: "static_site.name.label", domain: "static_site", text: "这个项目叫什么", vars: [], tone: "", source: "补充" },
  "static_site.name.save": { id: "static_site.name.save", domain: "static_site", text: "改名字", vars: [], tone: "", source: "补充" },
  "static_site.name.saved": { id: "static_site.name.saved", domain: "static_site", text: "名字改好了", vars: [], tone: "", source: "补充" },
  "static_site.name.url_is_fixed": { id: "static_site.name.url_is_fixed", domain: "static_site", text: "网址在第一次发出去的时候就定下来了，改名字不会换网址——你发出去的链接不会失效", vars: [], tone: "", source: "补充" },
  "static_site.preview.again": { id: "static_site.preview.again", domain: "static_site", text: "再开一条", vars: [], tone: "", source: "补充" },
  "static_site.preview.expired": { id: "static_site.preview.expired", domain: "static_site", text: "这条链接过期了。再开一条就行。", vars: [], tone: "", source: "补充" },
  "static_site.preview.expires_at": { id: "static_site.preview.expires_at", domain: "static_site", text: "这个链接 {when} 之后就打不开了", vars: ["when"], tone: "", source: "补充" },
  "static_site.preview.failed": { id: "static_site.preview.failed", domain: "static_site", text: "网页存好了，但我没能给出能点开的链接。点「再开一条」试试。", vars: [], tone: "", source: "补充" },
  "static_site.preview.hint": { id: "static_site.preview.hint", domain: "static_site", text: "这个链接只有拿到的人能打开，搜索引擎搜不到，过一阵子会自己失效。它跟放出去的那个网址是两回事。", vars: [], tone: "", source: "补充" },
  "static_site.preview.none": { id: "static_site.preview.none", domain: "static_site", text: "这一版还没有能点开的链接。", vars: [], tone: "", source: "补充" },
  "static_site.preview.open": { id: "static_site.preview.open", domain: "static_site", text: "点开看看", vars: [], tone: "", source: "补充" },
  "static_site.preview.revoke": { id: "static_site.preview.revoke", domain: "static_site", text: "关掉这条", vars: [], tone: "", source: "补充" },
  "static_site.preview.revoked": { id: "static_site.preview.revoked", domain: "static_site", text: "这条链接被关掉了。", vars: [], tone: "", source: "补充" },
  "static_site.preview.title": { id: "static_site.preview.title", domain: "static_site", text: "先看一眼", vars: [], tone: "", source: "补充" },
  "static_site.publish.action": { id: "static_site.publish.action", domain: "static_site", text: "放出去", vars: [], tone: "", source: "补充" },
  "static_site.publish.approval_ask": { id: "static_site.publish.approval_ask", domain: "static_site", text: "去要一张批准码", vars: [], tone: "", source: "补充" },
  "static_site.publish.approval_asking": { id: "static_site.publish.approval_asking", domain: "static_site", text: "我去要码了，你按一下指纹就行。", vars: [], tone: "", source: "补充" },
  "static_site.publish.approval_expired": { id: "static_site.publish.approval_expired", domain: "static_site", text: "这张码过期了，重新要一张就行。", vars: [], tone: "", source: "补充" },
  "static_site.publish.approval_got": { id: "static_site.publish.approval_got", domain: "static_site", text: "码拿到了，{until} 之前有效。现在可以放出去了。", vars: ["until"], tone: "", source: "补充" },
  "static_site.publish.approval_hint": { id: "static_site.publish.approval_hint", domain: "static_site", text: "换掉别人正在看的东西，得有平台批准码才放行 —— 我不敢自己发。拿到码贴进来，我就把这一版换上去。", vars: [], tone: "", source: "补充" },
  "static_site.publish.approval_label": { id: "static_site.publish.approval_label", domain: "static_site", text: "平台批准码", vars: [], tone: "", source: "补充" },
  "static_site.publish.approval_not_a_grant": { id: "static_site.publish.approval_not_a_grant", domain: "static_site", text: "这一下批下来了，但我没拿到能用的码。你再点一次「去要一张批准码」。", vars: [], tone: "", source: "补充" },
  "static_site.publish.busy": { id: "static_site.publish.busy", domain: "static_site", text: "我在换，换完这个网址上就是新的了。", vars: [], tone: "", source: "补充" },
  "static_site.publish.reason_label": { id: "static_site.publish.reason_label", domain: "static_site", text: "为什么发这一版", vars: [], tone: "", source: "补充" },
  "static_site.publish.reason_placeholder": { id: "static_site.publish.reason_placeholder", domain: "static_site", text: "一句话就行，我记在账上", vars: [], tone: "", source: "补充" },
  "static_site.receipt.artifact": { id: "static_site.receipt.artifact", domain: "static_site", text: "这一版内容的编号是 {digest}", vars: ["digest"], tone: "", source: "补充" },
  "static_site.receipt.health_failed": { id: "static_site.receipt.health_failed", domain: "static_site", text: "内容已经放上去了，但我这边还没能点开那个网址。多半是域名解析还没生效，过一会儿再看看。", vars: [], tone: "warn", source: "补充" },
  "static_site.receipt.health_passed": { id: "static_site.receipt.health_passed", domain: "static_site", text: "我点开那个网址试过了，看到的就是这一版。", vars: [], tone: "", source: "补充" },
  "static_site.receipt.health_pending": { id: "static_site.receipt.health_pending", domain: "static_site", text: "刚换过去，我还没来得及点开看。", vars: [], tone: "", source: "补充" },
  "static_site.receipt.health_unknown": { id: "static_site.receipt.health_unknown", domain: "static_site", text: "这套环境没有对外的网址，我没法替你点开看。", vars: [], tone: "", source: "补充" },
  "static_site.receipt.rollback_none": { id: "static_site.receipt.rollback_none", domain: "static_site", text: "这是第一版，没有上一版可以退。", vars: [], tone: "", source: "补充" },
  "static_site.receipt.rollback_to": { id: "static_site.receipt.rollback_to", domain: "static_site", text: "要是不对劲，可以退回第 {version_no} 版。", vars: ["version_no"], tone: "", source: "补充" },
  "static_site.receipt.toggle": { id: "static_site.receipt.toggle", domain: "static_site", text: "看详细过程", vars: [], tone: "", source: "设计稿" },
  "static_site.rollback.action": { id: "static_site.rollback.action", domain: "static_site", text: "退回这一版", vars: [], tone: "", source: "补充" },
  "static_site.rollback.busy": { id: "static_site.rollback.busy", domain: "static_site", text: "我在退，退完访问的人看到的就是这一版。", vars: [], tone: "", source: "补充" },
  "static_site.section.hint": { id: "static_site.section.hint", domain: "static_site", text: "把网页拖进来，我直接发出去。同一个网址以后换版本也不会变。", vars: [], tone: "", source: "补充" },
  "static_site.section.title": { id: "static_site.section.title", domain: "static_site", text: "发个网页", vars: [], tone: "", source: "补充" },
  "static_site.status.active": { id: "static_site.status.active", domain: "static_site", text: "开着", vars: [], tone: "ok", source: "补充" },
  "static_site.status.offlined": { id: "static_site.status.offlined", domain: "static_site", text: "已经收起来了", vars: [], tone: "neutral", source: "补充" },
  "static_site.status.suspended": { id: "static_site.status.suspended", domain: "static_site", text: "先关了", vars: [], tone: "warn", source: "补充" },
  "static_site.upload.busy": { id: "static_site.upload.busy", domain: "static_site", text: "我在传，传完先存着不公开。", vars: [], tone: "", source: "补充" },
  "static_site.upload.done_with_preview": { id: "static_site.upload.done_with_preview", domain: "static_site", text: "存好了，是第 {version_no} 版。先点开看看对不对，觉得行再放出去。", vars: ["version_no"], tone: "", source: "补充" },
  "static_site.upload.hint": { id: "static_site.upload.hint", domain: "static_site", text: "一个 HTML 文件，或者一个 ZIP 包。最大 5 MB。", vars: [], tone: "", source: "补充" },
  "static_site.upload.label": { id: "static_site.upload.label", domain: "static_site", text: "传一份网页上来", vars: [], tone: "", source: "补充" },
  "static_site.url_hint": { id: "static_site.url_hint", domain: "static_site", text: "这个网址发出去就能用，以后每次换版本它都不变。", vars: [], tone: "", source: "补充" },
  "static_site.versions.empty": { id: "static_site.versions.empty", domain: "static_site", text: "还没传过东西。", vars: [], tone: "", source: "补充" },
  "static_site.versions.row": { id: "static_site.versions.row", domain: "static_site", text: "第 {version_no} 版 · {size}", vars: ["size", "version_no"], tone: "", source: "补充" },
  "static_site.versions.title": { id: "static_site.versions.title", domain: "static_site", text: "存着的版本", vars: [], tone: "", source: "补充" },
  "steward.brief.action.go_to_plan": { id: "steward.brief.action.go_to_plan", domain: "steward", text: "去项目话头看计划", vars: [], tone: "", source: "补充" },
  "steward.brief.action.ignore": { id: "steward.brief.action.ignore", domain: "steward", text: "忽略", vars: [], tone: "", source: "需求稿 V2 §7.4" },
  "steward.brief.action.later": { id: "steward.brief.action.later", domain: "steward", text: "稍后", vars: [], tone: "", source: "需求稿 V2 §7.4" },
  "steward.brief.action.mute": { id: "steward.brief.action.mute", domain: "steward", text: "不要再提", vars: [], tone: "", source: "需求稿 V2 §7.4" },
  "steward.brief.action.schedule": { id: "steward.brief.action.schedule", domain: "steward", text: "安排开发", vars: [], tone: "", source: "需求稿 V2 §7.4" },
  "steward.brief.action.why": { id: "steward.brief.action.why", domain: "steward", text: "为什么", vars: [], tone: "", source: "需求稿 V2 §7.4" },
  "steward.brief.already_today": { id: "steward.brief.already_today", domain: "steward", text: "今天的留言在上面，我没再写一份。", vars: [], tone: "", source: "补充" },
  "steward.brief.context_read": { id: "steward.brief.context_read", domain: "steward", text: "读了昨天到现在的发布、巡检、建议和待决定", vars: [], tone: "", source: "补充" },
  "steward.brief.decided.ignore": { id: "steward.brief.decided.ignore", domain: "steward", text: "好，这条不再提。", vars: [], tone: "", source: "补充" },
  "steward.brief.decided.later": { id: "steward.brief.decided.later", domain: "steward", text: "记下了，明天的留言里再提一次。连着三次「稍后」我就当你不要了。", vars: [], tone: "", source: "补充" },
  "steward.brief.decided.mute": { id: "steward.brief.decided.mute", domain: "steward", text: "好，这一类以后都不提了。", vars: [], tone: "", source: "补充" },
  "steward.brief.decided.scheduled": { id: "steward.brief.decided.scheduled", domain: "steward", text: "我把它带到项目话头里了，计划出在那儿。", vars: [], tone: "", source: "补充" },
  "steward.brief.decisions": { id: "steward.brief.decisions", domain: "steward", text: "有 {count} 件事在等你决定，在「今天」那一页。", vars: ["count"], tone: "", source: "补充" },
  "steward.brief.decisions_none": { id: "steward.brief.decisions_none", domain: "steward", text: "没有在等你决定的事。", vars: [], tone: "", source: "补充" },
  "steward.brief.decisions_stale": { id: "steward.brief.decisions_stale", domain: "steward", text: "其中 {count} 件红线等了超过一天没人点，那几件活停在那儿。", vars: ["count"], tone: "", source: "修复任务闭环 PRD v1 §A（红线 24 小时没人点，早报里提一句）" },
  "steward.brief.finding_line": { id: "steward.brief.finding_line", domain: "steward", text: "- {summary}（{count} 处）", vars: ["count", "summary"], tone: "", source: "补充" },
  "steward.brief.findings_head": { id: "steward.brief.findings_head", domain: "steward", text: "新发现的代码问题：", vars: [], tone: "", source: "补充" },
  "steward.brief.findings_none": { id: "steward.brief.findings_none", domain: "steward", text: "新发现的代码问题：没有新的。", vars: [], tone: "", source: "补充" },
  "steward.brief.footer": { id: "steward.brief.footer", domain: "steward", text: "要我先做哪一件，直接说。", vars: [], tone: "", source: "补充" },
  "steward.brief.headline": { id: "steward.brief.headline", domain: "steward", text: "这是今天的留言，我把昨天到现在的事过了一遍：", vars: [], tone: "", source: "补充" },
  "steward.brief.inspection_skipped": { id: "steward.brief.inspection_skipped", domain: "steward", text: "另外有 {count} 次发布的巡检没跑成（证据不够或模型没应答），那几次没有结论。", vars: ["count"], tone: "", source: "补充" },
  "steward.brief.item.count": { id: "steward.brief.item.count", domain: "steward", text: "出现了 {count} 处", vars: ["count"], tone: "", source: "补充" },
  "steward.brief.item.finding": { id: "steward.brief.item.finding", domain: "steward", text: "代码问题", vars: [], tone: "", source: "补充" },
  "steward.brief.item.proposal": { id: "steward.brief.item.proposal", domain: "steward", text: "迭代建议", vars: [], tone: "", source: "补充" },
  "steward.brief.memory_candidates": { id: "steward.brief.memory_candidates", domain: "steward", text: "我记下了 {count} 条想留作长期记忆的，你去备忘录里点一下确不确认。", vars: ["count"], tone: "", source: "补充" },
  "steward.brief.mentions_of_you": { id: "steward.brief.mentions_of_you", domain: "steward", text: "另外，有 {count} 句话叫到了你。", vars: ["count"], tone: "", source: "会话团队与真人协作 PRD v1 §8（arron 拍板：会话里高亮 + 进他的早报，不单独推送）" },
  "steward.brief.proposal_line": { id: "steward.brief.proposal_line", domain: "steward", text: "- {title}", vars: ["title"], tone: "", source: "补充" },
  "steward.brief.proposal_posted": { id: "steward.brief.proposal_posted", domain: "steward", text: "我看了一圈，有一条值得做的迭代：{title}。要不要做，卡上说一声。", vars: ["title"], tone: "", source: "补充" },
  "steward.brief.proposals_head": { id: "steward.brief.proposals_head", domain: "steward", text: "值得做的迭代：", vars: [], tone: "", source: "补充" },
  "steward.brief.proposals_none": { id: "steward.brief.proposals_none", domain: "steward", text: "值得做的迭代：没有新的。", vars: [], tone: "", source: "补充" },
  "steward.brief.releases": { id: "steward.brief.releases", domain: "steward", text: "上线：成功 {verified} 次，没成 {failed} 次，还在观察 {pending} 个。", vars: ["failed", "pending", "verified"], tone: "", source: "补充" },
  "steward.brief.releases_none": { id: "steward.brief.releases_none", domain: "steward", text: "上线：昨天到现在没有发布。", vars: [], tone: "", source: "补充" },
  "steward.brief.schedule_request": { id: "steward.brief.schedule_request", domain: "steward", text: "安排开发：{title}", vars: ["title"], tone: "", source: "补充" },
  "steward.brief.scheduled": { id: "steward.brief.scheduled", domain: "steward", text: "到点了，我来写今天的留言", vars: [], tone: "", source: "补充" },
  "steward.chat.acceptance": { id: "steward.chat.acceptance", domain: "steward", text: "按你说的这句话做出来，你在预览里能看到。", vars: [], tone: "", source: "补充" },
  "steward.chat.account_scope_only": { id: "steward.chat.account_scope_only", domain: "steward", text: "我记下了。这会儿我这边没接上，先替你办不了——过一会儿再跟我说一遍。", vars: [], tone: "", source: "补充" },
  "steward.chat.degraded": { id: "steward.chat.degraded", domain: "steward", text: "模型这会儿没应答，我先按规则把这件事记成 {count} 步。等它回来我再看一遍。", vars: ["count"], tone: "", source: "补充" },
  "steward.chat.model_auth_hold": { id: "steward.chat.model_auth_hold", domain: "steward", text: "模型那边说 Key 过期或者欠费了，你这句我先没当活记。去「大脑与 Key」看一眼，好了再跟我说。", vars: [], tone: "", source: "2026-09-08 厂商不通时不派活" },
  "steward.chat.model_down_hold": { id: "steward.chat.model_down_hold", domain: "steward", text: "模型这会儿没应答，你这句我先没当活记。等它回来，你再说一遍就行。", vars: [], tone: "", source: "2026-09-08 厂商不通时不派活" },
  "steward.chat.needs_you": { id: "steward.chat.needs_you", domain: "steward", text: "我看明白了，这件事我拆成 {count} 步。有一步我不敢自己来，得你点一下。", vars: ["count"], tone: "", source: "补充" },
  "steward.chat.no_one_free": { id: "steward.chat.no_one_free", domain: "steward", text: "我看明白了，这件事我拆成 {count} 步。其中有一步手上这几位都接不了，你去「AI 团队」里加一位能接的。", vars: ["count"], tone: "", source: "补充" },
  "steward.chat.paused_hold": { id: "steward.chat.paused_hold", domain: "steward", text: "这条话头暂停着，我把它拆成 {count} 步先放着；点「继续」我再动手。", vars: ["count"], tone: "", source: "补充" },
  "steward.chat.plan_only": { id: "steward.chat.plan_only", domain: "steward", text: "我看明白了，这件事我拆成 {count} 步。按现在给我的权限，我只能先把方案摆出来，动手还得你来。", vars: ["count"], tone: "", source: "补充" },
  "steward.chat.plan_only_asked": { id: "steward.chat.plan_only_asked", domain: "steward", text: "我看明白了，这件事我拆成 {count} 步。按你说的这次只出计划，点「开始做」我再动手。", vars: ["count"], tone: "", source: "补充" },
  "steward.chat.plan_unavailable": { id: "steward.chat.plan_unavailable", domain: "steward", text: "我这会儿想不了事情——我这边负责琢磨的那块连不上。这是我的毛病，不是你说得不对。你刚说的我留着了，过会儿再跟我说一声，我接着看。", vars: [], tone: "", source: "补充" },
  "steward.chat.start_failed": { id: "steward.chat.start_failed", domain: "steward", text: "我看明白了，这件事我拆成 {count} 步，本来该直接开工的，我这边没开起来。这是我的问题，你先别管，过一会儿看一眼工作板。", vars: ["count"], tone: "", source: "补充" },
  "steward.chat.started": { id: "steward.chat.started", domain: "steward", text: "我看明白了，这件事我拆成 {count} 步，已经开工了。不对的话在工作板上点一下「撤回这次安排」。", vars: ["count"], tone: "", source: "补充" },
  "steward.chat.started_partial": { id: "steward.chat.started_partial", domain: "steward", text: "我看明白了，这件事我拆成 {count} 步，能开的我已经开了。有一步手上这几位都接不了，想让它也动起来就去「AI 团队」加一位——不加也不耽误前面几步。不对的话在工作板上点一下「撤回这次安排」。", vars: ["count"], tone: "", source: "补充" },
  "steward.chat.working": { id: "steward.chat.working", domain: "steward", text: "我看明白了，这件事我拆成 {count} 步，人也都点好了。这批里没有要写代码的活，我先摆在这儿——想让我动手，跟我说具体要改什么。", vars: ["count"], tone: "", source: "补充" },
  "steward.finding.acceptance": { id: "steward.finding.acceptance", domain: "steward", text: "不再出现：{summary}", vars: ["summary"], tone: "", source: "补充" },
  "steward.finding.context_read": { id: "steward.finding.context_read", domain: "steward", text: "读了这个项目还开着的巡检发现", vars: [], tone: "", source: "补充" },
  "steward.finding.none": { id: "steward.finding.none", domain: "steward", text: "这个项目现在没有还开着的巡检发现。", vars: [], tone: "", source: "补充" },
  "steward.finding.objective": { id: "steward.finding.objective", domain: "steward", text: "修好巡检发现的这条：{summary}", vars: ["summary"], tone: "", source: "补充" },
  "steward.finding.restate": { id: "steward.finding.restate", domain: "steward", text: "我把巡检发现的这条转成一件活：{summary}。先出计划，你点「开始做」我再动手。", vars: ["summary"], tone: "", source: "补充" },
  "steward.item.title": { id: "steward.item.title", domain: "steward", text: "{objective} · {role}", vars: ["objective", "role"], tone: "", source: "补充" },
  "steward.memory.todo_summary": { id: "steward.memory.todo_summary", domain: "steward", text: "要做：{objective}", vars: ["objective"], tone: "", source: "补充" },
  "steward.memory.todo_why": { id: "steward.memory.todo_why", domain: "steward", text: "这是你确认过要做的事。存下来，下次聊这个项目我直接接着说，不用你再讲一遍。", vars: [], tone: "", source: "补充" },
  "steward.reason.green_auto": { id: "steward.reason.green_auto", domain: "steward", text: "这项操作风险较低，并且在当前自动执行边界内。", vars: [], tone: "", source: "2026-08-14 Lulu 执行边界" },
  "steward.reason.invalid_permission": { id: "steward.reason.invalid_permission", domain: "steward", text: "当前权限边界无法识别，Lulu 已拒绝执行。", vars: [], tone: "", source: "2026-08-14 Lulu 执行边界" },
  "steward.reason.invalid_request": { id: "steward.reason.invalid_request", domain: "steward", text: "这项操作的身份、权限、项目或动作信息不完整，Lulu 没有执行。", vars: [], tone: "", source: "2026-08-14 Lulu 执行边界" },
  "steward.reason.observe_only": { id: "steward.reason.observe_only", domain: "steward", text: "当前边界只允许查看，Lulu 没有修改任何内容。", vars: [], tone: "", source: "2026-08-14 Lulu 执行边界" },
  "steward.reason.read_only": { id: "steward.reason.read_only", domain: "steward", text: "这是只读检查，Lulu 可以直接执行。", vars: [], tone: "", source: "2026-08-14 Lulu 执行边界" },
  "steward.reason.red_action": { id: "steward.reason.red_action", domain: "steward", text: "这项操作风险较高，需要你完成二次确认后才会继续。", vars: [], tone: "", source: "2026-08-14 Lulu 执行边界" },
  "steward.reason.rollback_bounded_auto": { id: "steward.reason.rollback_bounded_auto", domain: "steward", text: "这项操作有明确回滚路径，并且在当前自动执行边界内。", vars: [], tone: "", source: "2026-08-14 Lulu 执行边界" },
  "steward.reason.suggest_only": { id: "steward.reason.suggest_only", domain: "steward", text: "当前边界只允许给出方案，Lulu 已停在计划阶段。", vars: [], tone: "", source: "2026-08-14 Lulu 执行边界" },
  "steward.reason.yellow_not_authorized": { id: "steward.reason.yellow_not_authorized", domain: "steward", text: "这项操作可以回滚，但超出当前自动执行边界，Lulu 只给出方案。", vars: [], tone: "", source: "2026-08-14 Lulu 执行边界" },
  "steward.remote_ai.card_hint": { id: "steward.remote_ai.card_hint", domain: "steward", text: "它不需要仓库地址，也不用注册账号——源码由平台发给它。", vars: [], tone: "", source: "arron 2026-09-10" },
  "steward.remote_ai.card_title": { id: "steward.remote_ai.card_title", domain: "steward", text: "找一个 AI 长期看着这个项目", vars: [], tone: "", source: "arron 2026-09-10" },
  "steward.remote_ai.copy_link": { id: "steward.remote_ai.copy_link", domain: "steward", text: "复制邀请链接", vars: [], tone: "", source: "arron 2026-09-10" },
  "steward.remote_ai.copy_link_done": { id: "steward.remote_ai.copy_link_done", domain: "steward", text: "邀请链接已复制", vars: [], tone: "", source: "arron 2026-09-10" },
  "steward.remote_ai.copy_prompt": { id: "steward.remote_ai.copy_prompt", domain: "steward", text: "复制整段提示词", vars: [], tone: "", source: "arron 2026-09-10" },
  "steward.remote_ai.copy_prompt_done": { id: "steward.remote_ai.copy_prompt_done", domain: "steward", text: "整段提示词已复制", vars: [], tone: "", source: "arron 2026-09-10" },
  "steward.remote_ai.dont_close": { id: "steward.remote_ai.dont_close", domain: "steward", text: "这段只在这儿显示这一次——平台自己也不留。先复制走，再关这一页。", vars: [], tone: "", source: "arron 2026-09-10" },
  "steward.remote_ai.duration_180d": { id: "steward.remote_ai.duration_180d", domain: "steward", text: "180 天", vars: [], tone: "", source: "arron 2026-09-10" },
  "steward.remote_ai.duration_30d": { id: "steward.remote_ai.duration_30d", domain: "steward", text: "30 天", vars: [], tone: "", source: "arron 2026-09-10" },
  "steward.remote_ai.duration_90d": { id: "steward.remote_ai.duration_90d", domain: "steward", text: "90 天", vars: [], tone: "", source: "arron 2026-09-10" },
  "steward.remote_ai.duration_long_term": { id: "steward.remote_ai.duration_long_term", domain: "steward", text: "长期", vars: [], tone: "", source: "arron 2026-09-10" },
  "steward.remote_ai.edit": { id: "steward.remote_ai.edit", domain: "steward", text: "改一下签给谁", vars: [], tone: "", source: "arron 2026-09-10" },
  "steward.remote_ai.failed": { id: "steward.remote_ai.failed", domain: "steward", text: "没签出来。再点一下试试。", vars: [], tone: "", source: "arron 2026-09-10" },
  "steward.remote_ai.field_duration": { id: "steward.remote_ai.field_duration", domain: "steward", text: "管多久", vars: [], tone: "", source: "arron 2026-09-10" },
  "steward.remote_ai.field_model": { id: "steward.remote_ai.field_model", domain: "steward", text: "哪个模型", vars: [], tone: "", source: "arron 2026-09-10" },
  "steward.remote_ai.field_name": { id: "steward.remote_ai.field_name", domain: "steward", text: "叫它什么", vars: [], tone: "", source: "arron 2026-09-10" },
  "steward.remote_ai.field_provider": { id: "steward.remote_ai.field_provider", domain: "steward", text: "哪一家", vars: [], tone: "", source: "arron 2026-09-10" },
  "steward.remote_ai.issue": { id: "steward.remote_ai.issue", domain: "steward", text: "签发邀请", vars: [], tone: "", source: "arron 2026-09-10" },
  "steward.remote_ai.issuing": { id: "steward.remote_ai.issuing", domain: "steward", text: "正在签发…", vars: [], tone: "", source: "arron 2026-09-10" },
  "steward.remote_ai.link_label": { id: "steward.remote_ai.link_label", domain: "steward", text: "一次性邀请链接 · 24 小时有效，只能激活一次", vars: [], tone: "", source: "arron 2026-09-10" },
  "steward.remote_ai.once": { id: "steward.remote_ai.once", domain: "steward", text: "下面这两段只显示这一次，关掉就看不到了。", vars: [], tone: "", source: "arron 2026-09-10" },
  "steward.remote_ai.prompt_label": { id: "steward.remote_ai.prompt_label", domain: "steward", text: "接入提示词 · 整段发给它就行", vars: [], tone: "", source: "arron 2026-09-10" },
  "steward.role.backend": { id: "steward.role.backend", domain: "steward", text: "后端", vars: [], tone: "", source: "补充" },
  "steward.role.frontend": { id: "steward.role.frontend", domain: "steward", text: "前端", vars: [], tone: "", source: "补充" },
  "steward.role.qa": { id: "steward.role.qa", domain: "steward", text: "测试", vars: [], tone: "", source: "补充" },
  "steward.role.release": { id: "steward.role.release", domain: "steward", text: "发布", vars: [], tone: "", source: "补充" },
  "steward.role.research": { id: "steward.role.research", domain: "steward", text: "调研", vars: [], tone: "", source: "补充" },
  "steward.role.reviewer": { id: "steward.role.reviewer", domain: "steward", text: "复核", vars: [], tone: "", source: "补充" },
  "steward.role.steward": { id: "steward.role.steward", domain: "steward", text: "统筹", vars: [], tone: "", source: "补充" },
  "steward.run.compose_failed": { id: "steward.run.compose_failed", domain: "steward", text: "这句话没写出来", vars: [], tone: "", source: "补充" },
  "steward.run.step.stopped_cancelled": { id: "steward.run.step.stopped_cancelled", domain: "steward", text: "你叫停了", vars: [], tone: "", source: "补充" },
  "steward.run.step.stopped_clock": { id: "steward.run.step.stopped_clock", domain: "steward", text: "跑得太久了，先停在这儿", vars: [], tone: "", source: "补充" },
  "steward.run.step.stopped_steps": { id: "steward.run.step.stopped_steps", domain: "steward", text: "步数到上限了，先停在这儿", vars: [], tone: "", source: "补充" },
  "steward.run.step.stopped_tokens": { id: "steward.run.step.stopped_tokens", domain: "steward", text: "这一轮的预算用完了，先停在这儿", vars: [], tone: "", source: "补充" },
  "steward.run.stopped.cancelled": { id: "steward.run.stopped.cancelled", domain: "steward", text: "停下了。刚做的那些我记在过程里了。", vars: [], tone: "", source: "补充" },
  "steward.run.stopped.limit": { id: "steward.run.stopped.limit", domain: "steward", text: "这件事我做到一半就停下了——它比我一次能干完的多。你把范围说小一点，我再来一遍。", vars: [], tone: "", source: "补充" },
  "steward.skill.deepinspect.step.read_findings": { id: "steward.skill.deepinspect.step.read_findings", domain: "steward", text: "读规则版这一轮的发现", vars: [], tone: "", source: "补充" },
  "steward.skill.deepinspect.step.report": { id: "steward.skill.deepinspect.step.report", domain: "steward", text: "凌晨窗口里看见什么就报什么，不数三次", vars: [], tone: "", source: "补充" },
  "steward.skill.deepinspect.what": { id: "steward.skill.deepinspect.what", domain: "steward", text: "每天凌晨把规则版看见的问题汇总告诉你", vars: [], tone: "", source: "补充" },
  "steward.skill.disabled": { id: "steward.skill.disabled", domain: "steward", text: "这个我关着。要开的话去「排班与技能」那一页。", vars: [], tone: "", source: "补充" },
  "steward.skill.diskforecast.step.extrapolate": { id: "steward.skill.diskforecast.step.extrapolate", domain: "steward", text: "线性外推算还有几天满", vars: [], tone: "", source: "补充" },
  "steward.skill.diskforecast.step.take_samples": { id: "steward.skill.diskforecast.step.take_samples", domain: "steward", text: "取最近 14 天的硬盘采样", vars: [], tone: "", source: "补充" },
  "steward.skill.diskforecast.what": { id: "steward.skill.diskforecast.what", domain: "steward", text: "算一下照这个速度硬盘什么时候会满，满之前一周告诉你", vars: [], tone: "", source: "补充" },
  "steward.skill.every.hours": { id: "steward.skill.every.hours", domain: "steward", text: "{n} 小时", vars: ["n"], tone: "", source: "补充" },
  "steward.skill.every.minutes": { id: "steward.skill.every.minutes", domain: "steward", text: "{n} 分钟", vars: ["n"], tone: "", source: "补充" },
  "steward.skill.every.seconds": { id: "steward.skill.every.seconds", domain: "steward", text: "{n} 秒", vars: ["n"], tone: "", source: "补充" },
  "steward.skill.finding_to_task.name": { id: "steward.skill.finding_to_task.name", domain: "steward", text: "巡检结果转任务", vars: [], tone: "", source: "补充" },
  "steward.skill.logsniff.step.pick_template": { id: "steward.skill.logsniff.step.pick_template", domain: "steward", text: "规则没认出来的那几行交给 AI 挑一个模板", vars: [], tone: "", source: "补充" },
  "steward.skill.logsniff.step.scan_rules": { id: "steward.skill.logsniff.step.scan_rules", domain: "steward", text: "规则先扫一遍", vars: [], tone: "", source: "补充" },
  "steward.skill.logsniff.what": { id: "steward.skill.logsniff.what", domain: "steward", text: "每十分钟翻一遍日志，找还没闹出事的苗头", vars: [], tone: "", source: "补充" },
  "steward.skill.morning_brief.name": { id: "steward.skill.morning_brief.name", domain: "steward", text: "早晨留言", vars: [], tone: "", source: "补充" },
  "steward.skill.pulse.step.confirm": { id: "steward.skill.pulse.step.confirm", domain: "steward", text: "同一条连着数够三次才放行", vars: [], tone: "", source: "补充" },
  "steward.skill.pulse.step.read_findings": { id: "steward.skill.pulse.step.read_findings", domain: "steward", text: "读规则版这一轮的发现", vars: [], tone: "", source: "补充" },
  "steward.skill.pulse.what": { id: "steward.skill.pulse.what", domain: "steward", text: "每半分钟摸一次脉，同一件事连着看到三回才告诉你", vars: [], tone: "", source: "补充" },
  "steward.skill.trigger.daily_dawn": { id: "steward.skill.trigger.daily_dawn", domain: "steward", text: "每天凌晨 {hour} 点做一次深检", vars: ["hour"], tone: "", source: "补充" },
  "steward.skill.trigger.every": { id: "steward.skill.trigger.every", domain: "steward", text: "每 {every}一次", vars: ["every"], tone: "", source: "补充" },
  "steward.smalltalk.acknowledged": { id: "steward.smalltalk.acknowledged", domain: "steward", text: "好，记下了。", vars: [], tone: "", source: "补充" },
  "steward.smalltalk.done.create_project": { id: "steward.smalltalk.done.create_project", domain: "steward", text: "项目建好了", vars: [], tone: "", source: "补充" },
  "steward.smalltalk.done.list_projects": { id: "steward.smalltalk.done.list_projects", domain: "steward", text: "项目看完了", vars: [], tone: "", source: "补充" },
  "steward.smalltalk.done.other": { id: "steward.smalltalk.done.other", domain: "steward", text: "那一步做完了", vars: [], tone: "", source: "补充" },
  "steward.smalltalk.done.web_search": { id: "steward.smalltalk.done.web_search", domain: "steward", text: "网上查完了", vars: [], tone: "", source: "补充" },
  "steward.smalltalk.failed.create_project": { id: "steward.smalltalk.failed.create_project", domain: "steward", text: "项目没建成", vars: [], tone: "", source: "补充" },
  "steward.smalltalk.failed.list_projects": { id: "steward.smalltalk.failed.list_projects", domain: "steward", text: "项目没看成", vars: [], tone: "", source: "补充" },
  "steward.smalltalk.failed.other": { id: "steward.smalltalk.failed.other", domain: "steward", text: "那一步没做成", vars: [], tone: "", source: "补充" },
  "steward.smalltalk.failed.web_search": { id: "steward.smalltalk.failed.web_search", domain: "steward", text: "网上没查成", vars: [], tone: "", source: "补充" },
  "steward.smalltalk.greeting": { id: "steward.smalltalk.greeting", domain: "steward", text: "在的。这条是咱俩的总话头——想聊什么、想让我干点什么，说就行。", vars: [], tone: "", source: "补充" },
  "steward.smalltalk.project_chat": { id: "steward.smalltalk.project_chat", domain: "steward", text: "好，这个我知道。", vars: [], tone: "", source: "补充" },
  "steward.smalltalk.project_ready": { id: "steward.smalltalk.project_ready", domain: "steward", text: "我建好了「{name}」这个项目，这件活就挂在它下面。你在这儿接着说就行。", vars: ["name"], tone: "", source: "补充" },
  "steward.smalltalk.project_work": { id: "steward.smalltalk.project_work", domain: "steward", text: "好，这是件活，我先拆一下。", vars: [], tone: "", source: "补充" },
  "steward.smalltalk.thought": { id: "steward.smalltalk.thought", domain: "steward", text: "在想：{thought}", vars: ["thought"], tone: "", source: "补充" },
  "steward.smalltalk.unclear": { id: "steward.smalltalk.unclear", domain: "steward", text: "这句我没太看懂。你想让我做的是哪件事？说得糙一点没关系，我照着猜。", vars: [], tone: "", source: "补充" },
  "steward.smalltalk.what_can_you_do": { id: "steward.smalltalk.what_can_you_do", domain: "steward", text: "我管着你的机器和项目：巡检、修问题、发版本，出事了我先处理完再告诉你。想让我动哪儿的代码，在这儿直接说就行，挂到哪个项目上我来弄。", vars: [], tone: "", source: "补充" },
  "steward.smalltalk.work_needs_project": { id: "steward.smalltalk.work_needs_project", domain: "steward", text: "这件事我记下了。动代码得挂在一个项目上——下面选一个，我就在这儿接着做，不用你再说一遍。", vars: [], tone: "", source: "补充" },
  "steward.smalltalk.working.create_project": { id: "steward.smalltalk.working.create_project", domain: "steward", text: "我先给你把项目建起来，马上回来。", vars: [], tone: "", source: "补充" },
  "steward.smalltalk.working.inspection": { id: "steward.smalltalk.working.inspection", domain: "steward", text: "我去看一眼巡检最近看到了什么，马上回来。", vars: [], tone: "", source: "补充" },
  "steward.smalltalk.working.list_projects": { id: "steward.smalltalk.working.list_projects", domain: "steward", text: "我先看看手上有哪些项目，马上回来。", vars: [], tone: "", source: "补充" },
  "steward.smalltalk.working.remote_ai_invite": { id: "steward.smalltalk.working.remote_ai_invite", domain: "steward", text: "我把要签的那个身份拟一下，签发那一下还是你点。", vars: [], tone: "", source: "补充" },
  "steward.smalltalk.working.remote_ai_status": { id: "steward.smalltalk.working.remote_ai_status", domain: "steward", text: "我看一眼这个项目现在有没有长期维护的 AI，马上回来。", vars: [], tone: "", source: "补充" },
  "steward.smalltalk.working.think": { id: "steward.smalltalk.working.think", domain: "steward", text: "我先想一想。", vars: [], tone: "", source: "补充" },
  "steward.smalltalk.working.web_search": { id: "steward.smalltalk.working.web_search", domain: "steward", text: "我先去网上查一下，马上回来。", vars: [], tone: "", source: "补充" },
  "team.action.edit": { id: "team.action.edit", domain: "team", text: "改", vars: [], tone: "", source: "设计稿 · 一起管" },
  "team.action.invite": { id: "team.action.invite", domain: "team", text: "+ 叫个人进来", vars: [], tone: "", source: "设计稿 · 一起管" },
  "team.empty": { id: "team.empty", domain: "team", text: "现在只有你一个人。", vars: [], tone: "", source: "设计稿 · 一起管" },
  "team.error.forbidden": { id: "team.error.forbidden", domain: "team", text: "这件事你的身份做不了。要做的话得让老板来，或者请他给你换个身份。", vars: [], tone: "warn", source: "补充" },
  "team.error.last_owner": { id: "team.error.last_owner", domain: "team", text: "得留一个老板。你要是走了，就没人能加人、也没人能批那些危险的操作了。", vars: [], tone: "warn", source: "补充" },
  "team.error.not_in_project": { id: "team.error.not_in_project", domain: "team", text: "这个项目不在你能碰的范围里。要是你觉得应该能碰，找老板加一下。", vars: [], tone: "warn", source: "补充" },
  "team.error.owner_only": { id: "team.error.owner_only", domain: "team", text: "这一步只有老板能点。", vars: [], tone: "warn", source: "补充" },
  "team.invite.dialog.cancel": { id: "team.invite.dialog.cancel", domain: "team", text: "先不请了", vars: [], tone: "", source: "邀请闭环 2026-09-05" },
  "team.invite.dialog.email": { id: "team.invite.dialog.email", domain: "team", text: "对方的邮箱", vars: [], tone: "", source: "邀请闭环 2026-09-05" },
  "team.invite.dialog.email.hint": { id: "team.invite.dialog.email.hint", domain: "team", text: "仅用于备注 invitation——对方用哪个邮箱注册都能接", vars: [], tone: "", source: "邀请闭环 2026-09-05" },
  "team.invite.dialog.password": { id: "team.invite.dialog.password", domain: "team", text: "你的当前密码", vars: [], tone: "", source: "邀请闭环 2026-09-05" },
  "team.invite.dialog.password.why": { id: "team.invite.dialog.password.why", domain: "team", text: "发邀请会动团队权限，需要当场再验一次", vars: [], tone: "", source: "邀请闭环 2026-09-05" },
  "team.invite.dialog.projects": { id: "team.invite.dialog.projects", domain: "team", text: "能碰哪些项目", vars: [], tone: "", source: "邀请闭环 2026-09-05" },
  "team.invite.dialog.role": { id: "team.invite.dialog.role", domain: "team", text: "身份", vars: [], tone: "", source: "邀请闭环 2026-09-05" },
  "team.invite.dialog.submit": { id: "team.invite.dialog.submit", domain: "team", text: "生成邀请链接", vars: [], tone: "", source: "邀请闭环 2026-09-05" },
  "team.invite.dialog.title": { id: "team.invite.dialog.title", domain: "team", text: "叫个人进来", vars: [], tone: "", source: "邀请闭环 2026-09-05" },
  "team.invite.disabled.why": { id: "team.invite.disabled.why", domain: "team", text: "邀请链路还没接——接上后这里能发邀请，现在只有你一个人", vars: [], tone: "", source: "v3 §4C.2" },
  "team.invite.done": { id: "team.invite.done", domain: "team", text: "关掉", vars: [], tone: "", source: "补充" },
  "team.invite.form.cancel": { id: "team.invite.form.cancel", domain: "team", text: "先不发", vars: [], tone: "", source: "补充" },
  "team.invite.form.email": { id: "team.invite.form.email", domain: "team", text: "他的邮箱", vars: [], tone: "", source: "补充" },
  "team.invite.form.projects": { id: "team.invite.form.projects", domain: "team", text: "能碰哪些项目", vars: [], tone: "", source: "补充" },
  "team.invite.form.projects_hint": { id: "team.invite.form.projects_hint", domain: "team", text: "老板看得见所有项目；别的身份至少挑一个，不然他进来什么都打不开。", vars: [], tone: "", source: "补充" },
  "team.invite.form.role": { id: "team.invite.form.role", domain: "team", text: "给他什么身份", vars: [], tone: "", source: "补充" },
  "team.invite.form.submit": { id: "team.invite.form.submit", domain: "team", text: "发邀请", vars: [], tone: "", source: "补充" },
  "team.invite.form.title": { id: "team.invite.form.title", domain: "team", text: "叫个人进来", vars: [], tone: "", source: "设计稿 · 一起管" },
  "team.invite.invalid": { id: "team.invite.invalid", domain: "team", text: "这张邀请不存在或已经不能用了——找发邀请的人要一张新的。", vars: [], tone: "", source: "邀请闭环 2026-09-05" },
  "team.invite.label": { id: "team.invite.label", domain: "team", text: "邀请成员", vars: [], tone: "", source: "v3 §4C.2" },
  "team.invite.link": { id: "team.invite.link", domain: "team", text: "邀请链接", vars: [], tone: "", source: "补充" },
  "team.invite.link.hint": { id: "team.invite.link.hint", domain: "team", text: "复制后发给对方。链接 7 天有效、只能用一次；服务器上不存明文，关掉就再也看不到了。", vars: [], tone: "", source: "邀请闭环 2026-09-05" },
  "team.invite.link.title": { id: "team.invite.link.title", domain: "team", text: "链接生成好了——只显示这一次", vars: [], tone: "", source: "邀请闭环 2026-09-05" },
  "team.invite.link_copied": { id: "team.invite.link_copied", domain: "team", text: "复制好了", vars: [], tone: "", source: "补充" },
  "team.invite.link_copy": { id: "team.invite.link_copy", domain: "team", text: "复制链接", vars: [], tone: "", source: "补充" },
  "team.invite.link_manual": { id: "team.invite.link_manual", domain: "team", text: "信没发出去，把这个链接发给他就行。他点开链接、登录自己的账号就能进来——已经注册过也没关系。", vars: [], tone: "", source: "补充" },
  "team.invite.needs_projects": { id: "team.invite.needs_projects", domain: "team", text: "得挑至少一个项目给他，不然他进来什么都打不开，会以为是系统坏了。", vars: [], tone: "warn", source: "补充" },
  "team.invite.no_cap": { id: "team.invite.no_cap", domain: "team", text: "只有能管团队的人能叫人进来", vars: [], tone: "", source: "补充" },
  "team.invite.pending.empty": { id: "team.invite.pending.empty", domain: "team", text: "没有挂着的邀请", vars: [], tone: "", source: "邀请闭环 2026-09-05" },
  "team.invite.pending.expires": { id: "team.invite.pending.expires", domain: "team", text: "{days} 天后过期", vars: ["days"], tone: "", source: "邀请闭环 2026-09-05" },
  "team.invite.pending.revoke": { id: "team.invite.pending.revoke", domain: "team", text: "撤回", vars: [], tone: "", source: "邀请闭环 2026-09-05" },
  "team.invite.pending.title": { id: "team.invite.pending.title", domain: "team", text: "发出去还没接的", vars: [], tone: "", source: "邀请闭环 2026-09-05" },
  "team.invite.redeem.go": { id: "team.invite.redeem.go", domain: "team", text: "进去看看", vars: [], tone: "", source: "邀请闭环 2026-09-05" },
  "team.invite.redeem.joined": { id: "team.invite.redeem.joined", domain: "team", text: "进来了——你的身份是「{role}」", vars: ["role"], tone: "", source: "邀请闭环 2026-09-05" },
  "team.invite.redeem.need_login": { id: "team.invite.redeem.need_login", domain: "team", text: "先登录，登录完自动接上邀请", vars: [], tone: "", source: "邀请闭环 2026-09-05" },
  "team.invite.redeem.title": { id: "team.invite.redeem.title", domain: "team", text: "你被邀请加入了这个团队", vars: [], tone: "", source: "邀请闭环 2026-09-05" },
  "team.invite.revoked": { id: "team.invite.revoked", domain: "team", text: "那条邀请作废了，链接点开也进不来。", vars: [], tone: "ok", source: "补充" },
  "team.invite.sent": { id: "team.invite.sent", domain: "team", text: "邀请发出去了，{email} 收到邮件点一下就能进来。这条链接 {days} 天后失效。", vars: ["days", "email"], tone: "ok", source: "补充" },
  "team.invite.stepup": { id: "team.invite.stepup", domain: "team", text: "加人是改团队权限，得当场再验一次。", vars: [], tone: "", source: "补充" },
  "team.invite.taken": { id: "team.invite.taken", domain: "team", text: "这张邀请刚刚被别人用了。", vars: [], tone: "", source: "邀请闭环 2026-09-05" },
  "team.invites.expires": { id: "team.invites.expires", domain: "team", text: "{date} 前有效", vars: ["date"], tone: "", source: "补充" },
  "team.invites.heading": { id: "team.invites.heading", domain: "team", text: "还挂着的邀请", vars: [], tone: "", source: "补充" },
  "team.invites.hint": { id: "team.invites.hint", domain: "team", text: "他点开链接、登录自己的账号就进来了（注册过哪个邮箱都行）；撤回之后链接点开也进不来。", vars: [], tone: "", source: "补充" },
  "team.invites.revoke": { id: "team.invites.revoke", domain: "team", text: "撤回", vars: [], tone: "", source: "补充" },
  "team.member.dialog.cancel": { id: "team.member.dialog.cancel", domain: "team", text: "先不改", vars: [], tone: "", source: "补充" },
  "team.member.dialog.projects": { id: "team.member.dialog.projects", domain: "team", text: "能碰哪些项目", vars: [], tone: "", source: "补充（与邀请表同一句话）" },
  "team.member.dialog.projects_hint": { id: "team.member.dialog.projects_hint", domain: "team", text: "老板看得见所有项目；别的身份至少挑一个，不然他进来什么都打不开。", vars: [], tone: "", source: "补充（与邀请表同一句话）" },
  "team.member.dialog.role": { id: "team.member.dialog.role", domain: "team", text: "给他什么身份", vars: [], tone: "", source: "补充（与邀请表同一句话，两处说法必须一致）" },
  "team.member.dialog.stepup": { id: "team.member.dialog.stepup", domain: "team", text: "改身份是改团队权限，得当场再验一次。", vars: [], tone: "", source: "补充" },
  "team.member.dialog.submit": { id: "team.member.dialog.submit", domain: "team", text: "保存", vars: [], tone: "", source: "补充" },
  "team.member.dialog.title": { id: "team.member.dialog.title", domain: "team", text: "改 {name} 的身份", vars: ["name"], tone: "", source: "补充" },
  "team.member.edit": { id: "team.member.edit", domain: "team", text: "改", vars: [], tone: "", source: "设计稿 · 一起管（名单那一格「改」）" },
  "team.member.saved": { id: "team.member.saved", domain: "team", text: "改好了。", vars: [], tone: "ok", source: "补充" },
  "team.page.subtitle": { id: "team.page.subtitle", domain: "team", text: "现在只有你一个人。以后叫人进来时，你不用把密码发给任何人 —— 给权限就行。", vars: [], tone: "", source: "设计稿 · 一起管" },
  "team.page.title": { id: "team.page.title", domain: "team", text: "成员", vars: [], tone: "", source: "设计稿 · 一起管" },
  "team.projects.no_match": { id: "team.projects.no_match", domain: "team", text: "没有名字带「{q}」的项目。", vars: ["q"], tone: "", source: "补充 2026-09-06" },
  "team.projects.none_yet": { id: "team.projects.none_yet", domain: "team", text: "你还一个项目都没有。他进来能看见的东西也就为零——先建一个项目再叫人。", vars: [], tone: "", source: "补充 2026-09-06" },
  "team.projects.owner_sees_all": { id: "team.projects.owner_sees_all", domain: "team", text: "老板本来就看得见所有项目，这里不用挑。", vars: [], tone: "", source: "补充 2026-09-06" },
  "team.projects.pick_all": { id: "team.projects.pick_all", domain: "team", text: "全挑上", vars: [], tone: "", source: "补充 2026-09-06" },
  "team.projects.pick_none": { id: "team.projects.pick_none", domain: "team", text: "都不挑", vars: [], tone: "", source: "补充 2026-09-06" },
  "team.projects.picked": { id: "team.projects.picked", domain: "team", text: "挑了 {picked} 个，一共 {total} 个", vars: ["picked", "total"], tone: "", source: "补充 2026-09-06" },
  "team.projects.search": { id: "team.projects.search", domain: "team", text: "搜项目名", vars: [], tone: "", source: "补充 2026-09-06" },
  "team.role.operator": { id: "team.role.operator", domain: "team", text: "干活的", vars: [], tone: "", source: "设计稿 · 一起管" },
  "team.role.operator.desc": { id: "team.role.operator.desc", domain: "team", text: "能发布、能让 AI 动手，但看不到原始密钥，删机器要你点头。", vars: [], tone: "", source: "设计稿 · 一起管" },
  "team.role.owner": { id: "team.role.owner", domain: "team", text: "老板", vars: [], tone: "", source: "设计稿 · 一起管" },
  "team.role.owner.desc": { id: "team.role.owner.desc", domain: "team", text: "什么都能做，包括删机器、看密钥、加人。就你一个。", vars: [], tone: "", source: "设计稿 · 一起管" },
  "team.role.viewer": { id: "team.role.viewer", domain: "team", text: "看看就好", vars: [], tone: "", source: "设计稿 · 一起管" },
  "team.role.viewer.desc": { id: "team.role.viewer.desc", domain: "team", text: "只能看状态和日志。适合客户、外包、实习生。", vars: [], tone: "", source: "设计稿 · 一起管" },
  "team.roles.heading": { id: "team.roles.heading", domain: "team", text: "三种身份，够用了", vars: [], tone: "", source: "设计稿 · 一起管" },
  "team.roles.hint": { id: "team.roles.hint", domain: "team", text: "复杂的权限矩阵留给企业版，现在别折腾自己", vars: [], tone: "", source: "设计稿 · 一起管" },
  "team.table.person": { id: "team.table.person", domain: "team", text: "人", vars: [], tone: "", source: "设计稿 · 一起管" },
  "team.table.role": { id: "team.table.role", domain: "team", text: "身份", vars: [], tone: "", source: "设计稿 · 一起管" },
  "team.table.scope": { id: "team.table.scope", domain: "team", text: "能碰什么", vars: [], tone: "", source: "设计稿 · 一起管" },
  "timeline.action.approve": { id: "timeline.action.approve", domain: "timeline", text: "我同意，去做吧", vars: [], tone: "", source: "补充" },
  "timeline.action.detail": { id: "timeline.action.detail", domain: "timeline", text: "看完整过程", vars: [], tone: "", source: "设计稿 · 他们干过什么" },
  "timeline.action.not_ready": { id: "timeline.action.not_ready", domain: "timeline", text: "这一步现在做不了，不是你的操作有问题——通道还没接上，接上了我自己会接着做。", vars: [], tone: "warn", source: "补充" },
  "timeline.action.out_of_bounds": { id: "timeline.action.out_of_bounds", domain: "timeline", text: "这一步要伸进另一台机器的文件系统，我停下了。我只清得了这台机器自己的东西。", vars: [], tone: "warn", source: "补充" },
  "timeline.action.undo": { id: "timeline.action.undo", domain: "timeline", text: "撤销这次改动", vars: [], tone: "", source: "设计稿 · 他们干过什么" },
  "timeline.approve.confirm.body": { id: "timeline.approve.confirm.body", domain: "timeline", text: "我同意之后就直接做了，不会再问你第二次。要是做完想反悔，看这条下面的「撤销这次改动」还在不在。", vars: [], tone: "", source: "补充" },
  "timeline.approve.confirm.title": { id: "timeline.approve.confirm.title", domain: "timeline", text: "这一步碰到钱了，得你点一下", vars: [], tone: "", source: "设计稿 · CLAUDE.md §3 对照表" },
  "timeline.approve.done": { id: "timeline.approve.done", domain: "timeline", text: "好，我这就去做。", vars: [], tone: "ok", source: "补充" },
  "timeline.approve.forbidden": { id: "timeline.approve.forbidden", domain: "timeline", text: "这一下只有老板点得了。你可以把它转给他，他那边看到的是同一条。", vars: [], tone: "", source: "补充" },
  "timeline.detail.checks": { id: "timeline.detail.checks", domain: "timeline", text: "做完之后我验了一下", vars: [], tone: "", source: "补充" },
  "timeline.detail.commands": { id: "timeline.detail.commands", domain: "timeline", text: "它执行了这些", vars: [], tone: "", source: "补充" },
  "timeline.detail.exit_failed": { id: "timeline.detail.exit_failed", domain: "timeline", text: "跑挂了", vars: [], tone: "danger", source: "补充" },
  "timeline.detail.exit_ok": { id: "timeline.detail.exit_ok", domain: "timeline", text: "跑完了，没报错", vars: [], tone: "ok", source: "补充" },
  "timeline.detail.output": { id: "timeline.detail.output", domain: "timeline", text: "机器回了这些", vars: [], tone: "", source: "补充" },
  "timeline.detail.snapshot": { id: "timeline.detail.snapshot", domain: "timeline", text: "动手之前我拍了一份", vars: [], tone: "", source: "补充" },
  "timeline.empty": { id: "timeline.empty", domain: "timeline", text: "还没有动静。他们干了什么都会记在这儿。", vars: [], tone: "", source: "补充" },
  "timeline.filter.all": { id: "timeline.filter.all", domain: "timeline", text: "全部", vars: [], tone: "", source: "设计稿 · 他们干过什么" },
  "timeline.filter.changed": { id: "timeline.filter.changed", domain: "timeline", text: "只看改动了东西的", vars: [], tone: "", source: "设计稿 · 他们干过什么" },
  "timeline.filter.troubled": { id: "timeline.filter.troubled", domain: "timeline", text: "只看出过问题的", vars: [], tone: "", source: "设计稿 · 他们干过什么" },
  "timeline.page.subtitle": { id: "timeline.page.subtitle", domain: "timeline", text: "每一次动手都记在这儿，包括它执行的每条命令。你可以随时回退。", vars: [], tone: "", source: "设计稿 · 他们干过什么" },
  "timeline.page.title": { id: "timeline.page.title", domain: "timeline", text: "AI 都干了些什么", vars: [], tone: "", source: "设计稿 · 他们干过什么" },
  "timeline.stamp.yesterday": { id: "timeline.stamp.yesterday", domain: "timeline", text: "昨天", vars: [], tone: "", source: "补充" },
  "timeline.state.rolled_back": { id: "timeline.state.rolled_back", domain: "timeline", text: "没成，我退回去了", vars: [], tone: "warn", source: "补充" },
  "timeline.state.undone": { id: "timeline.state.undone", domain: "timeline", text: "你把这次撤了", vars: [], tone: "neutral", source: "补充" },
  "timeline.tag.acted": { id: "timeline.tag.acted", domain: "timeline", text: "动手了", vars: [], tone: "ok", source: "设计稿 · 他们干过什么" },
  "timeline.tag.code_changed": { id: "timeline.tag.code_changed", domain: "timeline", text: "改了代码", vars: [], tone: "ok", source: "设计稿 · 他们干过什么" },
  "timeline.tag.deployed": { id: "timeline.tag.deployed", domain: "timeline", text: "发布", vars: [], tone: "info", source: "设计稿 · 他们干过什么" },
  "timeline.tag.noted": { id: "timeline.tag.noted", domain: "timeline", text: "先记下", vars: [], tone: "warn", source: "设计稿 · 他们干过什么" },
  "timeline.tag.routine": { id: "timeline.tag.routine", domain: "timeline", text: "例行", vars: [], tone: "neutral", source: "设计稿 · 他们干过什么" },
  "timeline.tag.trouble": { id: "timeline.tag.trouble", domain: "timeline", text: "出过事", vars: [], tone: "danger", source: "设计稿 · 他们干过什么" },
  "timeline.undo.cost.restart": { id: "timeline.undo.cost.restart", domain: "timeline", text: "撤这一条要把服务重启一下，大概断 1 秒", vars: [], tone: "", source: "补充" },
  "timeline.undo.done": { id: "timeline.undo.done", domain: "timeline", text: "撤回来了，恢复成动手之前的样子。", vars: [], tone: "ok", source: "补充" },
  "timeline.undo.done_with_restart": { id: "timeline.undo.done_with_restart", domain: "timeline", text: "撤回来了，恢复成动手之前的样子。中间服务重启了一下，断了 {seconds} 秒。", vars: ["seconds"], tone: "ok", source: "补充" },
  "timeline.undo.not_undoable": { id: "timeline.undo.not_undoable", domain: "timeline", text: "这条撤不了：{why}。", vars: ["why"], tone: "", source: "补充" },
  "ui.cancel": { id: "ui.cancel", domain: "ui", text: "不改了", vars: [], tone: "", source: "补充" },
  "ui.close": { id: "ui.close", domain: "ui", text: "关掉", vars: [], tone: "", source: "补充" },
  "ui.edit": { id: "ui.edit", domain: "ui", text: "改文字", vars: [], tone: "", source: "补充" },
  "ui.navigation": { id: "ui.navigation", domain: "ui", text: "导航", vars: [], tone: "", source: "2026-08-11 移动端控制台外壳" },
  "ui.not_ready": { id: "ui.not_ready", domain: "ui", text: "这一块我还没做好，做好了自己会出现在这儿。你不用管。", vars: [], tone: "neutral", source: "补充" },
  "ui.stale_build.action": { id: "ui.stale_build.action", domain: "ui", text: "换成新的", vars: [], tone: "neutral", source: "补充" },
  "ui.stale_build.notice": { id: "ui.stale_build.notice", domain: "ui", text: "这个页面是旧的一版，我这边已经更新了", vars: [], tone: "neutral", source: "补充" },
  "vendor.action.edit_scope": { id: "vendor.action.edit_scope", domain: "vendor", text: "编辑归属", vars: [], tone: "", source: "补充" },
  "vendor.action.remove_project_scope": { id: "vendor.action.remove_project_scope", domain: "vendor", text: "移除{project}的用途", vars: ["project"], tone: "", source: "补充" },
  "vendor.action.remove_public_scope": { id: "vendor.action.remove_public_scope", domain: "vendor", text: "移除公共用途", vars: [], tone: "", source: "补充" },
  "vendor.action.remove_scope": { id: "vendor.action.remove_scope", domain: "vendor", text: "移除", vars: [], tone: "", source: "补充" },
  "vendor.action.save_project_scope": { id: "vendor.action.save_project_scope", domain: "vendor", text: "保存项目用途", vars: [], tone: "", source: "补充" },
  "vendor.action.save_public_scope": { id: "vendor.action.save_public_scope", domain: "vendor", text: "保存公共用途", vars: [], tone: "", source: "补充" },
  "vendor.auto_renew_on": { id: "vendor.auto_renew_on", domain: "vendor", text: "会自动续，不用管。", vars: [], tone: "ok", source: "补充" },
  "vendor.cap.broken": { id: "vendor.cap.broken", domain: "vendor", text: "{vendor} 这边的{capability}坏了，我这就去看是怎么回事。", vars: ["capability", "vendor"], tone: "warn", source: "补充" },
  "vendor.cap.needs_you": { id: "vendor.cap.needs_you", domain: "vendor", text: "这一步得你去 {vendor} 的后台点一下——{action}。这种事我不能替你办。", vars: ["action", "vendor"], tone: "warn", source: "补充" },
  "vendor.cap.not_enabled": { id: "vendor.cap.not_enabled", domain: "vendor", text: "{vendor} 这边的{capability}还没开通。钥匙是好的，但这项服务你没在他们后台点开过，所以我传不上去。", vars: ["capability", "vendor"], tone: "warn", source: "补充" },
  "vendor.cap.unverified": { id: "vendor.cap.unverified", domain: "vendor", text: "{vendor} 这边的{capability}我还没真试过。配置看着是对的，但我没拿它干过活，不敢说它一定能用。", vars: ["capability", "vendor"], tone: "", source: "补充" },
  "vendor.capability.acme_dns01": { id: "vendor.capability.acme_dns01", domain: "vendor", text: "证书自动续期", vars: [], tone: "", source: "补充" },
  "vendor.capability.ai": { id: "vendor.capability.ai", domain: "vendor", text: "模型服务（AI）", vars: [], tone: "", source: "补充" },
  "vendor.capability.cdn": { id: "vendor.capability.cdn", domain: "vendor", text: "加速服务（CDN）", vars: [], tone: "", source: "补充" },
  "vendor.capability.compute": { id: "vendor.capability.compute", domain: "vendor", text: "云主机", vars: [], tone: "", source: "补充" },
  "vendor.capability.dns": { id: "vendor.capability.dns", domain: "vendor", text: "域名解析", vars: [], tone: "", source: "补充" },
  "vendor.capability.email": { id: "vendor.capability.email", domain: "vendor", text: "邮件发送", vars: [], tone: "", source: "补充" },
  "vendor.capability.git": { id: "vendor.capability.git", domain: "vendor", text: "代码仓库", vars: [], tone: "", source: "补充" },
  "vendor.capability.object_storage": { id: "vendor.capability.object_storage", domain: "vendor", text: "文件存储", vars: [], tone: "", source: "补充" },
  "vendor.capability.other": { id: "vendor.capability.other", domain: "vendor", text: "其他服务", vars: [], tone: "", source: "补充" },
  "vendor.capability.registrar": { id: "vendor.capability.registrar", domain: "vendor", text: "域名注册", vars: [], tone: "", source: "补充" },
  "vendor.card.monthly_cost": { id: "vendor.card.monthly_cost", domain: "vendor", text: "每月花", vars: [], tone: "", source: "设计稿 · 服务商与账号" },
  "vendor.card.scope": { id: "vendor.card.scope", domain: "vendor", text: "归谁用", vars: [], tone: "", source: "补充" },
  "vendor.card.secret": { id: "vendor.card.secret", domain: "vendor", text: "密钥", vars: [], tone: "", source: "设计稿 · 服务商与账号" },
  "vendor.card.secret_kept": { id: "vendor.card.secret_kept", domain: "vendor", text: "已保管", vars: [], tone: "", source: "设计稿 · 服务商与账号" },
  "vendor.card.usage": { id: "vendor.card.usage", domain: "vendor", text: "在用", vars: [], tone: "", source: "设计稿 · 服务商与账号" },
  "vendor.detail.account": { id: "vendor.detail.account", domain: "vendor", text: "登录账号", vars: [], tone: "", source: "设计稿 · 服务商与账号" },
  "vendor.detail.account_hint": { id: "vendor.detail.account_hint", domain: "vendor", text: "你最常忘的就是这个", vars: [], tone: "", source: "设计稿 · 服务商与账号" },
  "vendor.detail.account_section": { id: "vendor.detail.account_section", domain: "vendor", text: "登录这家用的账号", vars: [], tone: "", source: "设计稿 · 服务商与账号" },
  "vendor.detail.console_url": { id: "vendor.detail.console_url", domain: "vendor", text: "控制台地址", vars: [], tone: "", source: "设计稿 · 服务商与账号" },
  "vendor.detail.mfa": { id: "vendor.detail.mfa", domain: "vendor", text: "二次验证 / 手机", vars: [], tone: "", source: "设计稿 · 服务商与账号" },
  "vendor.detail.password": { id: "vendor.detail.password", domain: "vendor", text: "登录密码", vars: [], tone: "", source: "设计稿 · 服务商与账号" },
  "vendor.detail.peek": { id: "vendor.detail.peek", domain: "vendor", text: "看一眼", vars: [], tone: "", source: "设计稿 · 服务商与账号" },
  "vendor.detail.secrets_section": { id: "vendor.detail.secrets_section", domain: "vendor", text: "给小队干活用的密钥", vars: [], tone: "", source: "设计稿 · 服务商与账号" },
  "vendor.due_soon": { id: "vendor.due_soon", domain: "vendor", text: "{vendor} 还有 {days} 天到期。", vars: ["days", "vendor"], tone: "warn", source: "补充" },
  "vendor.empty": { id: "vendor.empty", domain: "vendor", text: "还没记过服务商。你买过的云、域名、发邮件的服务都可以记在这儿。", vars: [], tone: "", source: "补充" },
  "vendor.error.bad_kind": { id: "vendor.error.bad_kind", domain: "vendor", text: "这家是干什么的我没看懂。云、发邮件的、管域名的、放代码的、AI，挑一个。", vars: [], tone: "warn", source: "补充" },
  "vendor.error.bad_project_link_scope": { id: "vendor.error.bad_project_link_scope", domain: "vendor", text: "公共用途不用选项目；项目用途要选一个项目。", vars: [], tone: "warn", source: "补充" },
  "vendor.error.name_blank": { id: "vendor.error.name_blank", domain: "vendor", text: "得给这家起个名字，不然过两个月你自己也认不出它是谁。", vars: [], tone: "warn", source: "补充" },
  "vendor.error.slug_taken": { id: "vendor.error.slug_taken", domain: "vendor", text: "{slug} 这个标识已经有一家在用了，换一个。", vars: ["slug"], tone: "warn", source: "补充" },
  "vendor.error.usage_note_blank": { id: "vendor.error.usage_note_blank", domain: "vendor", text: "得写一句用途，不然只知道它归谁，不知道它拿来干嘛。", vars: [], tone: "warn", source: "补充" },
  "vendor.overdue": { id: "vendor.overdue", domain: "vendor", text: "{vendor} 已经欠费了。这家停了的话，靠它的那些会跟着停。", vars: ["vendor"], tone: "danger", source: "补充" },
  "vendor.page.subtitle": { id: "vendor.page.subtitle", domain: "vendor", text: "你买过的云、发邮件的、管域名的都记在这儿。点任意一家可以改它的账号密码和密钥。到期、欠费、额度快用完，我提前喊你。", vars: [], tone: "", source: "设计稿 · 服务商与账号" },
  "vendor.page.title": { id: "vendor.page.title", domain: "vendor", text: "服务商与账号", vars: [], tone: "", source: "设计稿 · 服务商与账号" },
  "vendor.scope.editor.current": { id: "vendor.scope.editor.current", domain: "vendor", text: "现在记着的用途", vars: [], tone: "", source: "补充" },
  "vendor.scope.editor.project": { id: "vendor.scope.editor.project", domain: "vendor", text: "项目", vars: [], tone: "", source: "补充" },
  "vendor.scope.editor.project_note": { id: "vendor.scope.editor.project_note", domain: "vendor", text: "项目用途说明", vars: [], tone: "", source: "补充" },
  "vendor.scope.editor.public_note": { id: "vendor.scope.editor.public_note", domain: "vendor", text: "公共用途说明", vars: [], tone: "", source: "补充" },
  "vendor.scope.editor.title": { id: "vendor.scope.editor.title", domain: "vendor", text: "这家服务商归谁用", vars: [], tone: "", source: "补充" },
  "vendor.scope.public": { id: "vendor.scope.public", domain: "vendor", text: "公共", vars: [], tone: "", source: "补充" },
}

/**
 * 英文译文（L1）：只含有 en 字段的模板。渲染时查不到即回退中文。
 * 变量占位符与中文同构（copy-lint 保证），vars 直接复用 TEMPLATES 的。
 */
export const TEMPLATES_EN: Readonly<Partial<Record<CopyId, string>>> = {
  "bug_reports.close": "Close",
  "bug_reports.confirm_fix": "Confirm fix",
  "bug_reports.disable": "Disable",
  "bug_reports.empty": "There are no reports to review.",
  "bug_reports.enable": "Enable feedback for this project",
  "bug_reports.enabled": "Feedback is enabled",
  "bug_reports.failed": "Feedback could not be loaded. Try again later.",
  "bug_reports.filter.all": "All",
  "bug_reports.loading": "Loading feedback…",
  "bug_reports.more": "Request more information",
  "bug_reports.no_description": "The reporter marked the issue without adding a description.",
  "bug_reports.rotate": "Rotate public key",
  "bug_reports.screenshot": "Issue screenshot",
  "bug_reports.state.admin": "Waiting for your review",
  "bug_reports.state.analyzing": "Buger is reviewing",
  "bug_reports.state.done": "Done",
  "bug_reports.state.fixing": "Fix in progress",
  "bug_reports.state.reporter": "Waiting for reporter",
  "bug_reports.subtitle": "Buger checks reports before sending actionable issues here.",
  "bug_reports.title": "Feedback",
  "error.conversation.attachment_bad_type": "This file type isn't accepted. I can take images (png, jpg, webp, gif) and common documents (pdf, txt, md, csv, json, zip).",
  "error.conversation.attachment_looks_like_key": "This file looks like a private key, and I won't take it. Keys don't belong in chat — to reach a server, paste it under Machines.",
  "error.conversation.attachment_not_claimable": "Some attachments didn't attach — they may have already been sent, or belong to another session. Uploading again usually fixes it.",
  "error.conversation.attachment_too_large": "This file is over 10MB and can't be uploaded. Pick something smaller, or upload it elsewhere and send me the link.",
  "error.conversation.attachment_too_many": "A message can carry at most 10 attachments. Send this batch first, the rest in the next one.",
  "error.conversation.attachment_type_mismatch": "The contents don't match this file's extension — I didn't take it. Check whether you picked the right file.",
  "error.executor_unavailable": "I can't act on this step — the channel to that machine isn't connected yet. Pressing it would do nothing, so I'm not taking this confirmation.",
  "error.forbidden.hosts": "You can't see this page. Nothing is broken — this account just doesn't have the Machines permission. Ask someone who manages machines.",
  "error.generic": "That didn't work. I'll try again — if it keeps failing, I'll tell you.",
  "error.job_stalled": "This job went quiet for {minutes} minutes, so I stopped it. It was stuck on \"{step}\".",
  "error.memo.attachment_bad_type": "This file type isn't accepted. Supported: images (png, jpg, webp, gif) and common documents (pdf, txt, md, csv, json, zip).",
  "error.memo.attachment_too_large": "This attachment is over 10MB — Notes doesn't take files that big. Upload it elsewhere and save the link.",
  "error.memo.audio_bad_type": "I can't read this audio format. Use what the browser records.",
  "error.memo.audio_too_large": "This recording is too large (over 5MB). Record a shorter one.",
  "error.memo.audio_too_long": "This recording is over 10 minutes. Split it into shorter notes.",
  "error.memo.password_too_short": "Passwords need at least 4 characters. This is a glance-lock, not an account password — longer rules just push people to write it in the body.",
  "error.memo.password_wrong": "Wrong password. Only the right one opens this note — try again, or change the note's password.",
  "error.memo.unlock_throttled": "Too many password attempts — wait a minute and try again. The note is fine.",
  "error.memo.version_conflict": "Someone just changed this note; yours is the older version. Both are kept — pick one and save.",
  "error.memo.voice_needs_access": "Before saving a voice note, pick whether AI may read it.",
  "error.not_found": "This item is gone — it may have been deleted.",
  "error.rate_limited": "That's a bit fast — wait {seconds} seconds and try again.",
  "error.read_failed.retry": "Try again",
  "error.read_failed.title": "Couldn't load this",
  "error.step_up_required": "One more check that it's you — a code to your inbox, or your sign-in password.",
  "error.unauthorized": "Your sign-in has expired. Sign in again and you're set.",
  "error.upstream_down": "{vendor} is unreachable right now — not your fault. I'll keep retrying and tell you when it's back.",
  "lulu_agents.autofill": "Let Lulu fill this in",
  "lulu_agents.autofill_done": "Done: {tags}. Work runs on \"{executor}\".",
  "lulu_agents.autofill_done_no_executor": "Done: {tags}. But there is no executor available, so he cannot pick up work yet.",
  "lulu_agents.autofill_failed": "I can't do that right now — tick them yourself; it won't block saving.",
  "lulu_agents.autofill_hint": "Write the line above, then tap this — I'll set the tags and the executor, and you can change either.",
  "lulu_agents.autofill_unsure": "I couldn't tell what they do from that line — tick the tags below and they're ready for work.",
  "lulu_agents.autofill_working": "Working…",
  "lulu_agents.edit_dialog_desc": "Name, responsibilities and executor can all change. Work already running is unaffected — it stays pinned to the previous revision.",
  "lulu_agents.edit_dialog_title": "Edit {name}",
  "lulu_agents.f_responsibilities_empty": "With none ticked, Lulu can't find them when assigning work — they'll just sit idle.",
  "lulu_agents.save": "Save",
  "lulu_agents.save_failed": "Didn't save. Try once more; if it keeps failing, tell me.",
  "lulu_agents.speak.here": "I'm here. {role} is mine — tell me where to look.",
  "lulu_agents.speak.here_no_role": "I'm here. Go ahead.",
  "lulu_agents.speak.need_more": "I need a bit more before I can start.",
  "lulu_agents.speak.not_mine": "That's not mine to do.",
  "lulu_agents.speak.on_it": "On it.",
  "lulu_workbench.mention.group_here": "In this conversation",
  "lulu_workbench.mention.group_library": "Bring in from the Agent library",
  "lulu_workbench.mention.join_failed": "Couldn't bring them in. Tap again to retry.",
  "lulu_workbench.mention.joining": "Bringing them in…",
  "lulu_workbench.mention.no_team_change": "Bringing someone in affects this conversation only — the Agent library is untouched",
  "lulu_workbench.mention.own_memory": "What they remember is per-conversation — nothing crosses over",
  "memo.ai.toggle.hide": "Hide this note from AI",
  "memo.ai.toggle.show": "Let AI read this note",
  "nav.account": "Account",
  "nav.account.appearance": "Appearance",
  "nav.account.appearance.follow": "System",
  "nav.account.billing": "Billing & usage",
  "nav.account.lang": "Language",
  "nav.account.logout": "Sign out",
  "nav.account.me": "My account",
  "nav.account.mobile.account": "Account",
  "nav.account.mobile.lang": "Language",
  "nav.account.mobile.prefs": "Preferences",
  "nav.account.session": "{method} · last {time}",
  "nav.account.session.password": "Password",
  "nav.account.settings": "Settings",
  "nav.account.shortcuts": "Keyboard shortcuts",
  "nav.account.shortcuts.hint": "⌘/",
  "nav.account.team": "Members & permissions",
  "nav.account.team.hint": "{n} members",
  "nav.alert": "Alerts",
  "nav.auth": "Sign in",
  "nav.bridge": "AI APIs",
  "nav.bug_reports": "Feedback",
  "nav.chat": "Lulu",
  "nav.code": "Releases",
  "nav.common.loading": "Loading",
  "nav.dash": "Overview",
  "nav.duty": "Duty",
  "nav.hosts": "Machines",
  "nav.inbox.alert.open": "{count} open alerts",
  "nav.inbox.approval": "{count} awaiting your call",
  "nav.inbox.empty": "Nothing needs you right now",
  "nav.inbox.title": "Needs you",
  "nav.inbox.view.all": "View all",
  "nav.memo": "Notes",
  "nav.models": "Models",
  "nav.more": "More",
  "nav.more.group.modules": "More modules",
  "nav.new_session": "New session",
  "nav.notification": "Notifications",
  "nav.onboard": "Add a machine",
  "nav.project": "Projects",
  "nav.project.loading": "Projects…",
  "nav.project_tabs": "Project tabs",
  "nav.ptab.activity": "Activity",
  "nav.ptab.chat": "Chat",
  "nav.ptab.env": "Environments",
  "nav.ptab.memo": "Notes",
  "nav.ptab.overview": "Overview",
  "nav.ptab.release": "Releases",
  "nav.ptab.resources": "Resources",
  "nav.ptab.tasks": "Tasks",
  "nav.search.everything": "Search everything",
  "nav.search.group.hosts": "Machines",
  "nav.search.group.memos": "Notes",
  "nav.search.group.projects": "Projects",
  "nav.search.group.timeline": "Activity",
  "nav.search.hint": "Search projects, machines, tasks",
  "nav.search.hint.all": "Search projects, machines, notes, activity",
  "nav.search.none": "No matches — try another word",
  "nav.search.placeholder": "Search",
  "nav.sec": "Security",
  "nav.server": "Machine detail",
  "nav.shortcuts.group.global": "Global",
  "nav.shortcuts.group.memo": "Notes",
  "nav.shortcuts.yield.note": "Shortcuts yield to typing when an input is focused",
  "nav.skills": "AI Team",
  "nav.status.idle": "No tasks running",
  "nav.status.running": "{count} tasks running",
  "nav.status.unknown": "Task status unavailable",
  "nav.team": "Members",
  "nav.theme.current": "Current appearance",
  "nav.theme.dark": "Dark",
  "nav.theme.light": "Light",
  "nav.theme.quick.hint": "Or use the sun / moon in the top bar to switch quickly",
  "nav.theme.switch": "Switch theme",
  "nav.timeline": "Activity",
  "nav.today.card.night": "Last night",
  "nav.today.card.night.body": "{succeeded} finished, {failed} failed, {rolled} rolled back",
  "nav.today.card.running": "Running",
  "nav.today.card.waiting": "Waiting on you",
  "nav.today.count.items": "{count}",
  "nav.today.empty.running": "Nothing running — the AI crew is idle",
  "nav.today.empty.waiting": "Nothing is waiting on you",
  "nav.today.error.title": "Couldn't load today's data",
  "nav.today.freshness": "Data as of {time}",
  "nav.today.link.alerts": "View alerts",
  "nav.today.link.all_activity": "All activity",
  "nav.today.link.inbox": "Open inbox",
  "nav.today.link.night": "Last night's timeline",
  "nav.today.link.timeline": "View all activity",
  "nav.today.overview.all": "All quiet — nothing running, nothing waiting on you",
  "nav.today.overview.night": "{succeeded} finished last night",
  "nav.today.overview.night.failed": "{failed} failed",
  "nav.today.overview.running": "{count} running",
  "nav.today.overview.waiting": "{count} waiting on you",
  "nav.today.page.title": "Today",
  "nav.today.waiting.headline": "{count} items are waiting on you",
  "nav.vendor": "Vendors",
  "team.invite.dialog.cancel": "Cancel",
  "team.invite.dialog.email": "Their email",
  "team.invite.dialog.email.hint": "For reference only — they can sign up with any email",
  "team.invite.dialog.password": "Your current password",
  "team.invite.dialog.password.why": "Invitations change team permissions — verify it's you",
  "team.invite.dialog.projects": "Which projects",
  "team.invite.dialog.role": "Role",
  "team.invite.dialog.submit": "Generate invite link",
  "team.invite.dialog.title": "Invite someone",
  "team.invite.invalid": "This invitation doesn't exist or can no longer be used — ask for a new one.",
  "team.invite.link.hint": "Copy and send it to them. Valid 7 days, single use; the server keeps no plaintext — once closed it's gone.",
  "team.invite.link.title": "Link ready — shown only once",
  "team.invite.pending.empty": "No pending invitations",
  "team.invite.pending.expires": "Expires in {days} days",
  "team.invite.pending.revoke": "Revoke",
  "team.invite.pending.title": "Sent, not yet accepted",
  "team.invite.redeem.go": "Take me in",
  "team.invite.redeem.joined": "You're in — your role is {role}",
  "team.invite.redeem.need_login": "Sign in first — the invitation will be picked up automatically",
  "team.invite.redeem.title": "You've been invited to this team",
  "team.invite.taken": "This invitation was just used by someone else.",
  "team.member.dialog.cancel": "Not now",
  "team.member.dialog.projects": "Project access",
  "team.member.dialog.projects_hint": "Owners see every project; other roles need at least one, or they can't open anything.",
  "team.member.dialog.role": "Role",
  "team.member.dialog.stepup": "Changing a role changes team permissions — verify once more to continue.",
  "team.member.dialog.submit": "Save",
  "team.member.dialog.title": "Change {name}'s access",
  "team.member.edit": "Edit",
  "team.member.saved": "Saved.",
  "team.projects.no_match": "No project matches \"{q}\".",
  "team.projects.none_yet": "You have no projects yet. Create one first, otherwise there's nothing for them to open.",
  "team.projects.owner_sees_all": "Owners already see every project — nothing to pick here.",
  "team.projects.pick_all": "Select all",
  "team.projects.pick_none": "Clear",
  "team.projects.picked": "{picked} of {total} selected",
  "team.projects.search": "Search projects",
  "ui.cancel": "Cancel",
  "ui.close": "Close",
  "ui.edit": "Edit",
  "ui.navigation": "Navigation",
  "ui.not_ready": "This part isn't built yet. It will show up here on its own — nothing for you to do.",
}

/** 按 id 排序，遍历顺序稳定。 */
export const COPY_IDS: readonly CopyId[] = [
  "account.billing.empty.honest",
  "account.devices.admin_note",
  "account.devices.current",
  "account.devices.empty",
  "account.devices.heading",
  "account.devices.hint",
  "account.devices.last_used",
  "account.devices.method.bootstrap",
  "account.devices.method.email_code",
  "account.devices.method.local_ai",
  "account.devices.method.passkey",
  "account.devices.method.password",
  "account.devices.method.recovery_code",
  "account.devices.method.unknown",
  "account.devices.name",
  "account.devices.name.os_only",
  "account.devices.name.unknown",
  "account.devices.revoke.confirm.body",
  "account.devices.revoke.confirm.title",
  "account.devices.revoke.cta",
  "account.devices.revoke.done",
  "account.devices.revoke.others.cta",
  "account.devices.revoke.others.done",
  "account.devices.revoke.others.none",
  "account.devices.revoke.self",
  "account.devices.signed_in",
  "account.local_ai.copied",
  "account.local_ai.copy",
  "account.local_ai.cta",
  "account.local_ai.error",
  "account.local_ai.generating",
  "account.local_ai.heading",
  "account.local_ai.hint",
  "account.local_ai.modal.close",
  "account.local_ai.modal.description",
  "account.local_ai.modal.title",
  "account.paths.email_code",
  "account.paths.heading",
  "account.paths.passkey",
  "account.paths.password",
  "account.paths.recovery_code",
  "account.paths.unusable",
  "account.paths.usable",
  "account.stepup.body",
  "account.stepup.cancel",
  "account.stepup.code.label",
  "account.stepup.code.resend",
  "account.stepup.code.send",
  "account.stepup.code.sent",
  "account.stepup.confirm",
  "account.stepup.method.email_code",
  "account.stepup.method.password",
  "account.stepup.no_ticket",
  "account.stepup.none",
  "account.stepup.password.label",
  "account.stepup.switch",
  "account.stepup.title",
  "account.stepup.working",
  "activity.action.copy_link",
  "activity.action.manage_follow",
  "activity.action.mark_all_read",
  "activity.actor.lulu",
  "activity.actor.system",
  "activity.catalog.copy",
  "activity.catalog.scene",
  "activity.catalog.scene.action",
  "activity.catalog.scene.all",
  "activity.catalog.scene.disconnected",
  "activity.catalog.scene.following",
  "activity.catalog.scene.omitted",
  "activity.catalog.scene.recovered",
  "activity.catalog.scene.search",
  "activity.catalog.scene.unknown",
  "activity.catalog.subtitle",
  "activity.catalog.title",
  "activity.conn.live",
  "activity.detail.boundary",
  "activity.detail.close",
  "activity.detail.continue_lulu",
  "activity.detail.evidence",
  "activity.detail.follow",
  "activity.detail.go_release",
  "activity.detail.open_session",
  "activity.detail.open_source",
  "activity.detail.result",
  "activity.detail.sidecar_sub",
  "activity.detail.stages",
  "activity.detail.unfollow",
  "activity.detail.view_evidence",
  "activity.detail.view_impact",
  "activity.empty.action",
  "activity.empty.action.title",
  "activity.empty.all",
  "activity.empty.all.hint",
  "activity.empty.all.title",
  "activity.empty.following",
  "activity.empty.following.hint",
  "activity.empty.following.quiet.hint",
  "activity.empty.following.quiet.title",
  "activity.empty.following.title",
  "activity.empty.go_chat",
  "activity.empty.go_projects",
  "activity.empty.important",
  "activity.empty.important.title",
  "activity.empty.list_failed",
  "activity.empty.list_failed.hint",
  "activity.empty.ops_alerts",
  "activity.empty.ops_alerts.title",
  "activity.empty.projects_failed",
  "activity.empty.retry",
  "activity.empty.search",
  "activity.empty.search.clear_all",
  "activity.empty.search.clear_filters",
  "activity.empty.search.hint",
  "activity.empty.search.title",
  "activity.excluded.held",
  "activity.excluded.held.desc",
  "activity.excluded.hint",
  "activity.excluded.retry",
  "activity.excluded.retry.desc",
  "activity.excluded.rollback",
  "activity.excluded.rollback.desc",
  "activity.excluded.title",
  "activity.filter.actor",
  "activity.filter.clear",
  "activity.filter.hint.project",
  "activity.filter.hint.results",
  "activity.filter.open",
  "activity.filter.search",
  "activity.filter.search.disconnected",
  "activity.filter.search.project",
  "activity.filter.status",
  "activity.filter.time",
  "activity.filter.time.earlier",
  "activity.filter.time.today",
  "activity.filter.time.week",
  "activity.filter.time.yesterday",
  "activity.filter.type",
  "activity.follow.auto.tag",
  "activity.follow.auto.title",
  "activity.follow.manual.tag",
  "activity.follow.manual.title",
  "activity.follow.object.agent",
  "activity.follow.object.project",
  "activity.follow.object.resource",
  "activity.follow.object.site",
  "activity.follow.object.task",
  "activity.follow.source.assigned",
  "activity.follow.source.auto",
  "activity.follow.source.joined",
  "activity.follow.source.manual",
  "activity.follow.source.started",
  "activity.follow.table.foot",
  "activity.gate.entitlement",
  "activity.gate.needs_info",
  "activity.gate.question",
  "activity.gate.recovery_choice",
  "activity.gate.red_confirm",
  "activity.group.decide",
  "activity.group.events",
  "activity.group.locked",
  "activity.group.long",
  "activity.group.offline",
  "activity.group.recovered",
  "activity.group.recovered.meta",
  "activity.group.single",
  "activity.group.threads",
  "activity.group.unclosed",
  "activity.internal.desc",
  "activity.internal.title",
  "activity.kind.activity",
  "activity.kind.ops_alert",
  "activity.list.load_more",
  "activity.list.loading_more",
  "activity.macos.title",
  "activity.narrow.order.detail",
  "activity.narrow.order.detail.desc",
  "activity.narrow.order.detail.pill",
  "activity.narrow.order.list",
  "activity.narrow.order.list.desc",
  "activity.narrow.order.nav",
  "activity.narrow.order.nav.desc",
  "activity.narrow.order.nav.pill",
  "activity.narrow.order.note",
  "activity.narrow.order.title",
  "activity.narrow.sidecar_sub",
  "activity.offline.note.desc",
  "activity.offline.note.title",
  "activity.omitted",
  "activity.ops_alert.acknowledge",
  "activity.overview.see_all",
  "activity.page.subtitle",
  "activity.page.subtitle.narrow",
  "activity.page.subtitle.project",
  "activity.page.title",
  "activity.page.title.project",
  "activity.project.name.event2026",
  "activity.project.name.npcshop",
  "activity.project.note.desc",
  "activity.project.note.overview",
  "activity.project.note.overview.desc",
  "activity.project.note.title",
  "activity.project.note.wont",
  "activity.project.note.wont.desc",
  "activity.recover.note.desc",
  "activity.recover.note.title",
  "activity.scope.all",
  "activity.scope.all_projects",
  "activity.scope.label",
  "activity.scope.pick",
  "activity.scope.platform",
  "activity.scope.project",
  "activity.search.group",
  "activity.search.meta",
  "activity.sha.note.desc",
  "activity.sha.note.title",
  "activity.sheet.apply",
  "activity.sheet.clear",
  "activity.sheet.count",
  "activity.sheet.current",
  "activity.sheet.event2026.sub",
  "activity.sheet.npcshop.sub",
  "activity.sheet.project_search",
  "activity.sheet.status.bundle",
  "activity.sheet.sub",
  "activity.stages.folded",
  "activity.states.col.mean",
  "activity.states.col.proof",
  "activity.states.col.status",
  "activity.states.col.wrong",
  "activity.states.label",
  "activity.states.meta",
  "activity.states.subtitle",
  "activity.states.tag",
  "activity.states.title",
  "activity.status.awaiting_decision",
  "activity.status.awaiting_dependency",
  "activity.status.completed",
  "activity.status.disconnected",
  "activity.status.failed",
  "activity.status.platform_held",
  "activity.status.platform_held.hint",
  "activity.status.platform_held.no_resubmit",
  "activity.status.production_verified",
  "activity.status.queued",
  "activity.status.recovering",
  "activity.status.rollback.executed",
  "activity.status.rollback.registered",
  "activity.status.rolled_back",
  "activity.status.running",
  "activity.status.unknown",
  "activity.status.unknown.hint",
  "activity.stream.disconnected",
  "activity.stream.recovered",
  "activity.stream.recovered.deduped",
  "activity.stream.reset",
  "activity.summary.conversation.created",
  "activity.summary.conversation.waiting",
  "activity.summary.fast_delivery.production_verified",
  "activity.summary.host.assigned",
  "activity.summary.host.unassigned",
  "activity.summary.inspection.completed",
  "activity.summary.project.archived",
  "activity.summary.project.created",
  "activity.summary.task.completed",
  "activity.summary.task.created",
  "activity.summary.task.failed",
  "activity.summary.task.held",
  "activity.summary.task.running",
  "activity.summary.task.waiting",
  "activity.summary.team.joined",
  "activity.thread.updates",
  "activity.type.conversation",
  "activity.type.lulu",
  "activity.type.project",
  "activity.type.release",
  "activity.type.resource",
  "activity.type.site",
  "activity.type.task",
  "activity.type.team",
  "activity.unclosed",
  "activity.unclosed.hint",
  "activity.unread",
  "activity.unread.count",
  "activity.view.action",
  "activity.view.action.subtitle",
  "activity.view.all",
  "activity.view.following",
  "activity.view.following.subtitle",
  "activity.view.important",
  "activity.view.important.subtitle",
  "ai_os.action.approve_red",
  "ai_os.action.cancel",
  "ai_os.action.create",
  "ai_os.action.disable_learning",
  "ai_os.action.retry",
  "ai_os.action.submit",
  "ai_os.action.submitted",
  "ai_os.action.submitting",
  "ai_os.action.view_evidence",
  "ai_os.conflict.already_submitted",
  "ai_os.conflict.changed_elsewhere",
  "ai_os.conflict.same_key_different_content",
  "ai_os.empty.evaluations",
  "ai_os.empty.learning",
  "ai_os.empty.modules",
  "ai_os.empty.proposals",
  "ai_os.error.create_failed",
  "ai_os.error.detail_failed",
  "ai_os.error.list_failed",
  "ai_os.error.missing_evidence",
  "ai_os.error.missing_rollback",
  "ai_os.error.missing_user_value",
  "ai_os.error.module_gone",
  "ai_os.error.red_needs_click",
  "ai_os.eval.compare",
  "ai_os.eval.degraded",
  "ai_os.eval.failed",
  "ai_os.eval.heading",
  "ai_os.eval.negative_cases",
  "ai_os.eval.negative_cases_failed",
  "ai_os.eval.passed",
  "ai_os.eval.pending",
  "ai_os.evidence.candidate",
  "ai_os.evidence.candidate.detail",
  "ai_os.evidence.frozen",
  "ai_os.evidence.heading",
  "ai_os.evidence.not_enough_to_learn",
  "ai_os.evidence.preview_verified",
  "ai_os.evidence.preview_verified.detail",
  "ai_os.evidence.production_verified",
  "ai_os.evidence.production_verified.detail",
  "ai_os.field.acceptance",
  "ai_os.field.acceptance.hint",
  "ai_os.field.budget",
  "ai_os.field.budget.hint",
  "ai_os.field.forbidden_boundaries",
  "ai_os.field.goal",
  "ai_os.field.impact_audience",
  "ai_os.field.module",
  "ai_os.field.owner_stream",
  "ai_os.field.problem_evidence",
  "ai_os.field.problem_evidence.hint",
  "ai_os.field.requires_human_click",
  "ai_os.field.requires_human_click.locked",
  "ai_os.field.risk_level",
  "ai_os.field.rollback",
  "ai_os.field.rollback.hint",
  "ai_os.field.stop_conditions",
  "ai_os.field.stop_conditions.hint",
  "ai_os.field.title",
  "ai_os.field.user_value",
  "ai_os.field.user_value.hint",
  "ai_os.learning.active",
  "ai_os.learning.disabled",
  "ai_os.learning.expired_state",
  "ai_os.learning.expires",
  "ai_os.learning.rolled_back_state",
  "ai_os.learning.scope",
  "ai_os.loading.detail",
  "ai_os.loading.evidence",
  "ai_os.loading.list",
  "ai_os.loading.submitting",
  "ai_os.module.heading",
  "ai_os.module.no_rollback",
  "ai_os.module.owner",
  "ai_os.module.state.active",
  "ai_os.module.state.deprecated",
  "ai_os.module.state.retired",
  "ai_os.proposal.auto_note",
  "ai_os.proposal.evaluation_degraded.acceptance",
  "ai_os.proposal.evaluation_degraded.goal",
  "ai_os.proposal.evaluation_degraded.impact_audience",
  "ai_os.proposal.evaluation_degraded.title",
  "ai_os.proposal.evaluation_degraded.user_value",
  "ai_os.proposal.evaluation_failed.acceptance",
  "ai_os.proposal.evaluation_failed.goal",
  "ai_os.proposal.evaluation_failed.impact_audience",
  "ai_os.proposal.evaluation_failed.title",
  "ai_os.proposal.evaluation_failed.user_value",
  "ai_os.proposal.found_at",
  "ai_os.proposal.impact",
  "ai_os.proposal.no_task_yet",
  "ai_os.proposal.stop.attempts_exhausted",
  "ai_os.proposal.stopped_by_budget",
  "ai_os.proposal.task_link",
  "ai_os.proposal.uncertain",
  "ai_os.proposal.why_worth_it",
  "ai_os.retry.auto",
  "ai_os.retry.blocked_by_red",
  "ai_os.retry.gave_up",
  "ai_os.retry.manual_ok",
  "ai_os.risk.amber",
  "ai_os.risk.amber.detail",
  "ai_os.risk.green",
  "ai_os.risk.green.detail",
  "ai_os.risk.over_module_cap",
  "ai_os.risk.red",
  "ai_os.risk.red.await_click",
  "ai_os.risk.red.clicked",
  "ai_os.risk.red.detail",
  "ai_os.risk.red.refuse_auto",
  "ai_os.section.acceptance_heading",
  "ai_os.section.budget_heading",
  "ai_os.section.detail_link",
  "ai_os.section.empty",
  "ai_os.section.evidence_heading",
  "ai_os.section.learning_heading",
  "ai_os.section.learning_subtitle",
  "ai_os.section.needs_you",
  "ai_os.section.plan_heading",
  "ai_os.section.rollback_heading",
  "ai_os.section.subtitle",
  "ai_os.section.title",
  "ai_os.stage.accepted",
  "ai_os.stage.diagnosed",
  "ai_os.stage.executing",
  "ai_os.stage.failed",
  "ai_os.stage.fix_requested",
  "ai_os.stage.learning_candidate",
  "ai_os.stage.observed",
  "ai_os.stage.preview_verified",
  "ai_os.stage.production_verified",
  "ai_os.stage.promoted",
  "ai_os.stage.proposed",
  "ai_os.stage.releasing",
  "ai_os.stage.rollback_requested",
  "ai_os.stage.rolled_back",
  "alert.affected_unknown",
  "alert.card.ask",
  "alert.card.handled",
  "alert.card.how_fixed",
  "alert.card.mute_this_kind",
  "alert.cert_expiring",
  "alert.channel.digest",
  "alert.channel.none",
  "alert.channel.phone",
  "alert.channel.push",
  "alert.conversation_feed_stuck",
  "alert.conversation_feed_stuck_affected",
  "alert.deploy_done",
  "alert.disk_almost_full.affected",
  "alert.disk_almost_full.title",
  "alert.disk_cleaned",
  "alert.duty.link",
  "alert.host_down.affected",
  "alert.host_down.affected_unknown",
  "alert.host_down.title",
  "alert.incident.empty",
  "alert.incident.heading",
  "alert.incident.meta.asleep",
  "alert.incident.meta.awake",
  "alert.narrow.empty",
  "alert.narrow.heading",
  "alert.needs_your_click",
  "alert.page.subtitle",
  "alert.page.title",
  "alert.phone.empty",
  "alert.phone.hint",
  "alert.refused_to_touch",
  "alert.rest_all_good",
  "alert.rule.handled.desc",
  "alert.rule.handled.title",
  "alert.rule.needs_you.desc",
  "alert.rule.needs_you.title",
  "alert.rule.night_noise.desc",
  "alert.rule.night_noise.title",
  "alert.rule.site_down.desc",
  "alert.rule.site_down.title",
  "alert.rules.empty",
  "alert.rules.heading",
  "alert.rules.stop_calling",
  "alert.rules.wait_for_digest",
  "alert.service_recovered",
  "auth.authentication.strong_required",
  "auth.bootstrap.mode.cta",
  "auth.bootstrap.token.label",
  "auth.bootstrap.token.placeholder",
  "auth.brand.captain.detail",
  "auth.brand.captain.name",
  "auth.brand.headline",
  "auth.brand.portrait_placeholder",
  "auth.brand.subhead",
  "auth.brand.vault_note",
  "auth.brand.wordmark",
  "auth.code.expired",
  "auth.code.resend_wait",
  "auth.code.sent",
  "auth.code.wrong",
  "auth.divider.or",
  "auth.email_code.cta",
  "auth.error.mail_from_invalid",
  "auth.error.mail_invalid",
  "auth.error.no_mail_channel",
  "auth.error.passkey_setup_required",
  "auth.field.code.label",
  "auth.field.current_password.label",
  "auth.field.email.label",
  "auth.field.email.placeholder",
  "auth.field.new_password.label",
  "auth.field.password.label",
  "auth.field.password.placeholder",
  "auth.field.recovery.label",
  "auth.first_step.body",
  "auth.first_step.title",
  "auth.invited.body",
  "auth.invited.title",
  "auth.mail.code.body",
  "auth.mail.code.subject",
  "auth.mail.invite.body",
  "auth.mail.invite.subject",
  "auth.mail.stepup.body",
  "auth.mail.stepup.subject",
  "auth.no_password.body",
  "auth.no_password.title",
  "auth.passkey.cta",
  "auth.passkey.done",
  "auth.passkey.failed.already",
  "auth.passkey.failed.dismissed",
  "auth.passkey.failed.domain",
  "auth.passkey.failed.unknown",
  "auth.passkey.failed.unsupported",
  "auth.passkey.invite",
  "auth.passkey.setup_cta",
  "auth.passkey.unsupported",
  "auth.password.change.cta",
  "auth.password.cta",
  "auth.password.current_invalid",
  "auth.password.hint",
  "auth.password.invalid",
  "auth.password.recent_auth_required",
  "auth.password.set.cta",
  "auth.password.updated",
  "auth.password.weak",
  "auth.paths.only_consumable",
  "auth.paths.only_one",
  "auth.paths.recovery_left",
  "auth.point.autonomous.detail",
  "auth.point.autonomous.title",
  "auth.point.ssh_once.detail",
  "auth.point.ssh_once.title",
  "auth.point.team.detail",
  "auth.point.team.title",
  "auth.recovery.cta",
  "auth.recovery.hint",
  "auth.recovery.needs_email",
  "auth.recovery.submit",
  "auth.recovery_codes.detail",
  "auth.recovery_codes.heading",
  "auth.registration.invalid",
  "auth.signin.cta",
  "auth.signin.failed",
  "auth.signin.subtitle",
  "auth.signin.switch_cta",
  "auth.signin.switch_hint",
  "auth.signin.title",
  "auth.signup.cta",
  "auth.signup.subtitle",
  "auth.signup.switch_cta",
  "auth.signup.switch_hint",
  "auth.signup.title",
  "auth.step_up.prompt",
  "auth.stepup.code.cta",
  "auth.stepup.code.sent",
  "auth.stepup.password.cta",
  "auth.stepup.password.label",
  "auth.stepup.password.wrong",
  "bridge.error.scope_insufficient",
  "bridge.grants.empty",
  "bridge.grants.heading",
  "bridge.grants.hint",
  "bridge.grants.issue",
  "bridge.grants.revoke",
  "bridge.tokens.empty",
  "bridge.tokens.error.idempotency_mismatch",
  "bridge.tokens.error.invalid",
  "bridge.tokens.error.scope_forbidden",
  "bridge.tokens.heading",
  "bridge.tokens.hint",
  "bridge.tokens.issue.cta",
  "bridge.tokens.issue.failed",
  "bridge.tokens.issue.heading",
  "bridge.tokens.issue.label",
  "bridge.tokens.issue.label_example",
  "bridge.tokens.issue.pending",
  "bridge.tokens.issue.project",
  "bridge.tokens.issue.scopes",
  "bridge.tokens.issue.stepup",
  "bridge.tokens.issue.ttl",
  "bridge.tokens.issued.close",
  "bridge.tokens.issued.copied",
  "bridge.tokens.issued.copy",
  "bridge.tokens.issued.heading",
  "bridge.tokens.issued.hint",
  "bridge.tokens.issued.replayed",
  "bridge.tokens.mask",
  "bridge.tokens.revoke",
  "bridge.tokens.revoke.failed",
  "bridge.tokens.revoke.stepup",
  "bridge.tokens.revoke.title",
  "bridge.tokens.revoking",
  "bridge.tokens.row.expires",
  "bridge.tokens.row.last_used",
  "bridge.tokens.row.never_expires",
  "bridge.tokens.row.never_used",
  "bridge.tokens.scope.access_request",
  "bridge.tokens.scope.hosts_read",
  "bridge.tokens.scope.projects_read",
  "bridge.tokens.show_revoked",
  "bridge.tokens.status.active",
  "bridge.tokens.status.expired",
  "bridge.tokens.status.revoked",
  "bridge.tokens.ttl.30d",
  "bridge.tokens.ttl.7d",
  "bridge.tokens.ttl.90d",
  "bridge.tokens.ttl.never",
  "bug_reports.close",
  "bug_reports.confirm_fix",
  "bug_reports.disable",
  "bug_reports.empty",
  "bug_reports.enable",
  "bug_reports.enabled",
  "bug_reports.failed",
  "bug_reports.filter.all",
  "bug_reports.loading",
  "bug_reports.more",
  "bug_reports.no_description",
  "bug_reports.resolved_note",
  "bug_reports.rotate",
  "bug_reports.screenshot",
  "bug_reports.state.admin",
  "bug_reports.state.analyzing",
  "bug_reports.state.done",
  "bug_reports.state.fixing",
  "bug_reports.state.reporter",
  "bug_reports.subtitle",
  "bug_reports.title",
  "chat.brief.active",
  "chat.brief.empty",
  "chat.brief.empty_hint",
  "chat.brief.heading",
  "chat.brief.note",
  "chat.brief.waiting",
  "chat.error.unavailable",
  "chat.facts.external_verify_hint",
  "chat.facts.heading",
  "chat.facts.kind.commit",
  "chat.facts.kind.deploy",
  "chat.facts.kind.external_verify",
  "chat.facts.kind.rollback",
  "chat.facts.kind.test",
  "chat.facts.note",
  "chat.facts.status.failed",
  "chat.facts.status.none",
  "chat.facts.status.not_applicable",
  "chat.facts.status.passed",
  "chat.facts.status.pending_verify",
  "chat.facts.status.running",
  "chat.flywheel.ci_failed",
  "chat.flywheel.completed",
  "chat.flywheel.deploy_failed",
  "chat.flywheel.empty",
  "chat.flywheel.heading",
  "chat.flywheel.review_fix_requested",
  "chat.flywheel.running",
  "chat.flywheel.stale",
  "chat.gate.held",
  "chat.input.archived",
  "chat.input.label",
  "chat.input.placeholder",
  "chat.input.send",
  "chat.list.account_create",
  "chat.list.account_group",
  "chat.list.archived",
  "chat.list.create",
  "chat.list.empty",
  "chat.list.group_create",
  "chat.list.group_less",
  "chat.list.group_more",
  "chat.list.group_unavailable",
  "chat.list.mobile_open",
  "chat.list.nav",
  "chat.list.waiting",
  "chat.lulu.receipts.approve",
  "chat.lulu.receipts.closed",
  "chat.lulu.receipts.empty",
  "chat.lulu.receipts.heading",
  "chat.lulu.receipts.pending",
  "chat.lulu.receipts.reject",
  "chat.mention.action",
  "chat.mention.empty",
  "chat.mention.hint",
  "chat.message.empty",
  "chat.next.developing",
  "chat.next.fix",
  "chat.next.live",
  "chat.next.preview",
  "chat.next.release",
  "chat.next.testing",
  "chat.page.subtitle",
  "chat.page.title",
  "chat.panel.collapse",
  "chat.panel.expand",
  "chat.panel.mobile_close",
  "chat.panel.mobile_open",
  "chat.participant.developer",
  "chat.participant.human",
  "chat.participant.reviewer",
  "chat.participant.steward",
  "chat.participants.empty",
  "chat.participants.error",
  "chat.participants.heading",
  "chat.phase.developing",
  "chat.phase.fix",
  "chat.phase.live",
  "chat.phase.preview",
  "chat.phase.release",
  "chat.phase.testing",
  "chat.platform.job_failed",
  "chat.platform.job_succeeded",
  "chat.receipt.action",
  "chat.receipt.declared",
  "chat.receipt.degraded",
  "chat.receipt.platform",
  "chat.schedule.action",
  "chat.schedule.done",
  "chat.schedule.executor.auto",
  "chat.schedule.executor.label",
  "chat.schedule.executor.own_key",
  "chat.schedule.executor.plan",
  "chat.schedule.executor.unavailable",
  "chat.schedule.hint",
  "chat.schedule.no_project",
  "chat.task.base_sha",
  "chat.task.base_sha_pending",
  "chat.task.project",
  "chat.tasktree.empty",
  "chat.tasktree.empty_hint",
  "chat.tasktree.heading",
  "chat.tasktree.owner_unassigned",
  "check.backup.failed",
  "check.backup.stale",
  "check.cert.expiring",
  "check.disk.almost_full",
  "check.disk.will_be_full",
  "check.load.high",
  "check.log.disk_pressure",
  "check.log.nothing_found",
  "check.log.oom",
  "check.log.port_taken",
  "check.memory.almost_full",
  "check.port.closed",
  "check.process.gone",
  "code.action.diff",
  "code.application.current",
  "code.application.empty",
  "code.application.open_project",
  "code.application.partial",
  "code.application.recent",
  "code.inspection.detail",
  "code.inspection.empty",
  "code.inspection.idle",
  "code.inspection.repair",
  "code.inspection.subtitle",
  "code.overview.active",
  "code.overview.attention",
  "code.overview.live",
  "code.page.subtitle",
  "code.section.commits",
  "code.section.commits.hint",
  "code.section.prs",
  "code.section.prs.hint",
  "code.section.repos",
  "code.tab.applications",
  "code.tab.inspections",
  "code.tab.sites",
  "credential.blast.one_scope",
  "credential.blast.several",
  "credential.blast.whole_account",
  "credential.derived.also_dies",
  "credential.error.blank",
  "credential.error.forbidden_raw",
  "credential.error.vendor_missing",
  "credential.reveal.code_required",
  "credential.reveal.code_wrong",
  "credential.reveal.hidden_again",
  "credential.reveal.reason_required",
  "credential.revoked",
  "credential.rotated",
  "credential.rotation.pending",
  "credential.scope.too_wide",
  "credential.source.leaked_channel",
  "dashboard.action.add_host",
  "dashboard.action.nightly_report",
  "dashboard.attention.ack",
  "dashboard.attention.detail_cta",
  "dashboard.attention.rest",
  "dashboard.attention.timeline_cta",
  "dashboard.greeting.all_well",
  "dashboard.greeting.detail",
  "dashboard.greeting.detail.unreachable",
  "dashboard.greeting.something_burning",
  "dashboard.last_night.window",
  "dashboard.nightly.backed_up",
  "dashboard.nightly.backed_up.detail",
  "dashboard.nightly.cleaned_logs",
  "dashboard.nightly.cleaned_logs.detail",
  "dashboard.nightly.fixed_bug",
  "dashboard.nightly.fixed_bug.detail",
  "dashboard.nightly.patched",
  "dashboard.nightly.patched.detail",
  "dashboard.nightly.watching",
  "dashboard.nightly.watching.detail",
  "dashboard.project.host_count",
  "dashboard.project.no_domain",
  "dashboard.running.hint",
  "dashboard.running.item",
  "dashboard.running.title",
  "dashboard.section.attention",
  "dashboard.section.attention.hint",
  "dashboard.section.last_night",
  "dashboard.section.projects",
  "dashboard.section.projects.hint",
  "dashboard.stat.attention",
  "dashboard.stat.hosts",
  "dashboard.stat.hosts.all_online",
  "dashboard.stat.hosts.unreachable",
  "dashboard.stat.projects",
  "development_task.action.add_acceptance",
  "development_task.action.add_context",
  "development_task.action.cancel",
  "development_task.action.cancelling",
  "development_task.action.claim",
  "development_task.action.claiming",
  "development_task.action.confirm_cancel",
  "development_task.action.copied",
  "development_task.action.copy",
  "development_task.action.keep",
  "development_task.action.prepare_repo",
  "development_task.action.preparing",
  "development_task.action.remove",
  "development_task.action.repair",
  "development_task.action.retry",
  "development_task.actor.external",
  "development_task.actor.internal",
  "development_task.assignee.auto",
  "development_task.assignee.cannot_execute",
  "development_task.assignee.local_hint",
  "development_task.assignee.manual",
  "development_task.assignee.unavailable",
  "development_task.cancel.body",
  "development_task.cancel.title",
  "development_task.claim.copy",
  "development_task.claim.endpoint",
  "development_task.claim.expiry",
  "development_task.claim.fingerprint",
  "development_task.claim.subtitle",
  "development_task.claim.title",
  "development_task.claim.token",
  "development_task.claim.username",
  "development_task.comments.empty",
  "development_task.comments.failed",
  "development_task.comments.outcome_exhausted",
  "development_task.comments.outcome_recorded",
  "development_task.comments.outcome_reopened",
  "development_task.comments.placeholder",
  "development_task.comments.rounds",
  "development_task.comments.submit",
  "development_task.comments.title",
  "development_task.context.api_contract",
  "development_task.context.asset",
  "development_task.context.code_path",
  "development_task.context.data_migration",
  "development_task.context.deployment",
  "development_task.context.design",
  "development_task.context.product_doc",
  "development_task.context.reference",
  "development_task.context.test_plan",
  "development_task.context.ui_route",
  "development_task.create.action",
  "development_task.create.submit",
  "development_task.create.submitting",
  "development_task.create.subtitle",
  "development_task.create.title",
  "development_task.detail.live_sha",
  "development_task.detail.needs_rebase",
  "development_task.detail.release_id",
  "development_task.domain.backend",
  "development_task.domain.data",
  "development_task.domain.design",
  "development_task.domain.frontend",
  "development_task.domain.infra",
  "development_task.domain.product",
  "development_task.domain.qa",
  "development_task.domain.release",
  "development_task.error.claimed",
  "development_task.error.prepare_paused",
  "development_task.error.prepare_retrying",
  "development_task.error.prepare_select_repo",
  "development_task.event.attempt_claimed",
  "development_task.event.attempt_progress",
  "development_task.event.attempt_state_changed",
  "development_task.event.task_cancelled",
  "development_task.event.task_created",
  "development_task.event.task_state_changed",
  "development_task.event.updated",
  "development_task.field.acceptance",
  "development_task.field.acceptance_hint",
  "development_task.field.base_sha",
  "development_task.field.context_digest",
  "development_task.field.context_kind",
  "development_task.field.context_locator",
  "development_task.field.context_title",
  "development_task.field.executor",
  "development_task.field.executor_model",
  "development_task.field.executor_provider",
  "development_task.field.instructions",
  "development_task.field.model",
  "development_task.field.repo",
  "development_task.field.title",
  "development_task.hint.claim",
  "development_task.hint.context",
  "development_task.hint.copy_failed",
  "development_task.hint.digest",
  "development_task.hint.domains",
  "development_task.hint.draft",
  "development_task.hint.executor_identity",
  "development_task.hint.executor_identity_partial",
  "development_task.hint.model",
  "development_task.hint.no_context",
  "development_task.hint.no_recommendation",
  "development_task.hint.preparing",
  "development_task.hint.preparing_claim",
  "development_task.hint.preparing_packet",
  "development_task.hint.ready",
  "development_task.hint.request_error",
  "development_task.hint.timeline_empty",
  "development_task.hint.timeline_error",
  "development_task.hint.timeline_loading",
  "development_task.magic.acceptance",
  "development_task.magic.claim_error",
  "development_task.magic.claimed.hint",
  "development_task.magic.claimed.title",
  "development_task.magic.claiming",
  "development_task.magic.copy.action",
  "development_task.magic.copy.done",
  "development_task.magic.error.back",
  "development_task.magic.error.title",
  "development_task.magic.identity.action",
  "development_task.magic.identity.capability",
  "development_task.magic.identity.hint",
  "development_task.magic.identity.invalid",
  "development_task.magic.identity.label",
  "development_task.magic.identity.placeholder",
  "development_task.magic.identity.title",
  "development_task.magic.invalid",
  "development_task.magic.issue.action",
  "development_task.magic.issue.pending",
  "development_task.magic.issue.renew",
  "development_task.magic.issue_error",
  "development_task.magic.open_error",
  "development_task.magic.opening",
  "development_task.magic.panel.hint",
  "development_task.magic.panel.title",
  "development_task.magic.prompt",
  "development_task.magic.public.hint",
  "development_task.magic.public.title",
  "development_task.magic.request_error",
  "development_task.magic.token_missing",
  "development_task.maintainer.duration.180d",
  "development_task.maintainer.duration.30d",
  "development_task.maintainer.duration.90d",
  "development_task.maintainer.duration.label",
  "development_task.maintainer.duration.long_term",
  "development_task.maintainer.error.claimed",
  "development_task.maintainer.error.expired",
  "development_task.maintainer.error.key_mismatch",
  "development_task.maintainer.issue",
  "development_task.maintainer.label",
  "development_task.maintainer.panel.hint",
  "development_task.maintainer.panel.title",
  "development_task.maintainer.pending",
  "development_task.maintainer.placeholder",
  "development_task.maintainer.public.hint",
  "development_task.maintainer.revoke",
  "development_task.maintainer.rotate",
  "development_task.memory.empty",
  "development_task.memory.kind.comment",
  "development_task.memory.kind.failed_because",
  "development_task.memory.kind.note",
  "development_task.memory.kind.tried",
  "development_task.memory.title",
  "development_task.mission.action.open_preview",
  "development_task.mission.action.publish",
  "development_task.mission.action.rollback",
  "development_task.mission.action.unavailable",
  "development_task.mission.field.integration_sha",
  "development_task.mission.field.next_step",
  "development_task.mission.field.owner_sha",
  "development_task.mission.field.preview_url",
  "development_task.mission.field.production_sha",
  "development_task.mission.next.cancelled",
  "development_task.mission.next.fast_test",
  "development_task.mission.next.in_development",
  "development_task.mission.next.live",
  "development_task.mission.next.live_rollback",
  "development_task.mission.next.needs_fix",
  "development_task.mission.next.pending_release",
  "development_task.mission.next.preview_available",
  "development_task.mission.next.preview_available_no_url",
  "development_task.mission.next.publish_failed",
  "development_task.mission.panel.hint",
  "development_task.mission.panel.title",
  "development_task.mission.request.failure",
  "development_task.mission.request.running",
  "development_task.mission.request.success",
  "development_task.mission.status.fast_test",
  "development_task.mission.status.in_development",
  "development_task.mission.status.live",
  "development_task.mission.status.needs_fix",
  "development_task.mission.status.pending_release",
  "development_task.mission.status.preview_available",
  "development_task.mission.unavailable",
  "development_task.optional.summary",
  "development_task.preview.action",
  "development_task.preview.again",
  "development_task.preview.blame.access",
  "development_task.preview.blame.input",
  "development_task.preview.blame.label",
  "development_task.preview.blame.offline",
  "development_task.preview.blame.platform",
  "development_task.preview.blame.unknown",
  "development_task.preview.blame.version",
  "development_task.preview.closed",
  "development_task.preview.field.owner_tip",
  "development_task.preview.field.preview_sha",
  "development_task.preview.field.release_sha",
  "development_task.preview.panel.hint",
  "development_task.preview.panel.title",
  "development_task.preview.pending",
  "development_task.preview.rollback",
  "development_task.preview.state.owner_tip",
  "development_task.preview.state.preview_failed_rolled_back",
  "development_task.preview.state.preview_ready",
  "development_task.preview.state.preview_running",
  "development_task.preview.state.production_verified",
  "development_task.preview.state.release_requested",
  "development_task.preview.state.test_candidate",
  "development_task.preview.view_only",
  "development_task.preview.waiting",
  "development_task.redline.what",
  "development_task.remote_ai.invitation.pending_hint",
  "development_task.remote_ai.invitation.revoke",
  "development_task.remote_ai.invitation.revoke_confirm",
  "development_task.remote_ai.invitation.revoke_failed",
  "development_task.remote_ai.invitation.revoking",
  "development_task.repo.account_error",
  "development_task.repo.all_unavailable",
  "development_task.repo.association_error",
  "development_task.repo.association_loading",
  "development_task.repo.candidate_empty_option",
  "development_task.repo.candidate_label",
  "development_task.repo.candidate_select",
  "development_task.repo.candidates_error",
  "development_task.repo.candidates_unavailable",
  "development_task.repo.empty_hint",
  "development_task.repo.error",
  "development_task.repo.link_action",
  "development_task.repo.link_conflict",
  "development_task.repo.link_error",
  "development_task.repo.link_hint",
  "development_task.repo.link_unavailable",
  "development_task.repo.linking",
  "development_task.repo.loading",
  "development_task.repo.no_candidates",
  "development_task.repo.none",
  "development_task.repo.option_unavailable",
  "development_task.repo.permission",
  "development_task.repo.refreshing",
  "development_task.repo.retrying",
  "development_task.repo.select",
  "development_task.repo.select_hint",
  "development_task.repo.single_unavailable",
  "development_task.section.advanced",
  "development_task.section.attached",
  "development_task.section.context",
  "development_task.section.details",
  "development_task.section.domains",
  "development_task.section.executor_identity",
  "development_task.section.git",
  "development_task.section.optional",
  "development_task.section.packet",
  "development_task.section.recommended",
  "development_task.section.status",
  "development_task.section.timeline",
  "development_task.stage.claimed",
  "development_task.stage.delivered",
  "development_task.stage.exhausted",
  "development_task.stage.failed",
  "development_task.stage.verified",
  "development_task.stagecard.cancelled",
  "development_task.stagecard.ci",
  "development_task.stagecard.claimed",
  "development_task.stagecard.decision",
  "development_task.stagecard.delivered",
  "development_task.stagecard.failed",
  "development_task.stagecard.fix_requested",
  "development_task.stagecard.live",
  "development_task.stagecard.ready",
  "development_task.stagecard.reviewing",
  "development_task.stages.attempt",
  "development_task.stages.empty",
  "development_task.stages.live_note",
  "development_task.stages.title",
  "development_task.stages.total",
  "development_task.state.cancelled",
  "development_task.state.ci_running",
  "development_task.state.draft",
  "development_task.state.failed",
  "development_task.state.fix_requested",
  "development_task.state.gating",
  "development_task.state.pending_approval",
  "development_task.state.preparing",
  "development_task.state.ready",
  "development_task.state.ready_to_claim",
  "development_task.state.reviewing",
  "development_task.state.running",
  "development_task.state.v2_handoff",
  "development_task.user_state.cancelled",
  "development_task.user_state.claimable",
  "development_task.user_state.in_progress",
  "development_task.user_state.live",
  "development_task.user_state.needs_action",
  "duty.cards.heading",
  "duty.collab.pending",
  "duty.kind.act",
  "duty.kind.observe",
  "duty.page.subtitle",
  "duty.page.title",
  "duty.schedule.empty",
  "duty.schedule.heading",
  "duty.schedule.source",
  "duty.toggle.off",
  "duty.toggle.on",
  "error.conversation.attachment_bad_type",
  "error.conversation.attachment_looks_like_key",
  "error.conversation.attachment_not_claimable",
  "error.conversation.attachment_too_large",
  "error.conversation.attachment_too_many",
  "error.conversation.attachment_type_mismatch",
  "error.executor_unavailable",
  "error.forbidden.hosts",
  "error.generic",
  "error.job_stalled",
  "error.memo.attachment_bad_type",
  "error.memo.attachment_too_large",
  "error.memo.audio_bad_type",
  "error.memo.audio_too_large",
  "error.memo.audio_too_long",
  "error.memo.password_too_short",
  "error.memo.password_wrong",
  "error.memo.unlock_throttled",
  "error.memo.version_conflict",
  "error.memo.voice_needs_access",
  "error.not_found",
  "error.rate_limited",
  "error.read_failed.retry",
  "error.read_failed.title",
  "error.step_up_required",
  "error.unauthorized",
  "error.upstream_down",
  "host.access.credential.kept",
  "host.access.credential.revoked",
  "host.access.heading",
  "host.access.keys.heading",
  "host.access.keys.ours",
  "host.access.keys.yours",
  "host.access.keys.yours_none",
  "host.access.original.keys",
  "host.access.original.none",
  "host.access.original.password",
  "host.access.original.unknown",
  "host.access.original.unknown_reachable",
  "host.access.ours.checked_at",
  "host.access.ours.status.unknown",
  "host.access.ours.status.unusable",
  "host.access.ours.status.usable",
  "host.access.ours.used_by",
  "host.access.stale",
  "host.access.yours.checked_at",
  "host.access.yours.never_checked",
  "host.access.yours.status.unknown",
  "host.access.yours.status.unusable",
  "host.access.yours.status.usable",
  "host.access.yours.used_by",
  "host.action.connect_myself",
  "host.action.reconnect",
  "host.action.temp_key",
  "host.busy.heading",
  "host.busy.window",
  "host.card.activity",
  "host.card.agent",
  "host.card.capacity",
  "host.card.detail",
  "host.card.more_addresses",
  "host.card.more_workloads",
  "host.card.next",
  "host.card.uncollected",
  "host.card.unknown",
  "host.card.workloads",
  "host.carve.lives_on",
  "host.carve.parent_spec",
  "host.carve.shared_fate",
  "host.carve.split_count",
  "host.credential.copy",
  "host.credential.field.address",
  "host.credential.field.key",
  "host.credential.field.user",
  "host.credential.heading",
  "host.credential.kept",
  "host.credential.note",
  "host.detail.breadcrumb",
  "host.group.assigned",
  "host.group.available",
  "host.group.exception",
  "host.label.behind_nat",
  "host.label.cannot_go_down",
  "host.label.daily_backup",
  "host.label.has_database",
  "host.label.shared_infra",
  "host.list.col.host",
  "host.list.col.project",
  "host.list.col.state",
  "host.list.col.what",
  "host.list.col.where",
  "host.list.decision_hint",
  "host.list.decision_title",
  "host.list.empty.body",
  "host.list.empty.title",
  "host.list.intro",
  "host.list.intro_ready",
  "host.list.mixed.body",
  "host.list.mixed.body_warn",
  "host.list.mixed.title",
  "host.list.more",
  "host.list.parent_accept",
  "host.list.parent_reject",
  "host.list.parent_suggestion",
  "host.list.pool.title",
  "host.list.project_first.body",
  "host.list.project_first.cta",
  "host.list.project_first.title",
  "host.list.suggestion_accept",
  "host.list.suggestion_pick",
  "host.list.title",
  "host.list.unassigned_banner",
  "host.list.unassigned_hint",
  "host.list.unassigned_hint_none",
  "host.list.unassigned_title",
  "host.location.at_vendor",
  "host.location.lan",
  "host.meta.line",
  "host.meta.managed_days",
  "host.metric.cpu.busy",
  "host.metric.cpu.idle",
  "host.metric.cpu.label",
  "host.metric.cpu.overloaded",
  "host.metric.disk.filling",
  "host.metric.disk.full",
  "host.metric.disk.label",
  "host.metric.disk.ok",
  "host.metric.memory.label",
  "host.metric.memory.ok",
  "host.metric.memory.tight",
  "host.occupancy.unassigned",
  "host.overview.all",
  "host.overview.assigned",
  "host.overview.available",
  "host.overview.exception",
  "host.overview.pending",
  "host.probe.disconnected",
  "host.reach.blocked",
  "host.reach.credential",
  "host.reach.fail_streak",
  "host.reach.host_key_changed",
  "host.reach.never_succeeded",
  "host.reach.ok",
  "host.reach.stale",
  "host.reach.unknown",
  "host.recent.heading",
  "host.recent.today",
  "host.recent.yesterday",
  "host.recheck.action",
  "host.recheck.failed",
  "host.recheck.running",
  "host.recheck.still_unknown",
  "host.reparent.reject",
  "host.reparent.suggest",
  "host.reparent.suggest.neither",
  "host.reparent.suggest.observed_only",
  "host.reparent.suggest.recorded_only",
  "host.status.credential",
  "host.status.disk_filling",
  "host.status.error",
  "host.status.offline",
  "host.status.onboarding",
  "host.status.online",
  "host.status.provisioning",
  "host.status.reclaimed",
  "host.summary.backend_and_db",
  "host.summary.critical_suffix",
  "host.summary.frontend",
  "host.summary.heading",
  "host.summary.unassigned",
  "host.workloads.heading",
  "job.canceled",
  "job.failed",
  "job.resumed",
  "job.started",
  "job.step.done",
  "job.step.not_started",
  "job.stopped.budget_used_up",
  "job.stopped.no_progress",
  "job.stopped.too_long",
  "job.stopped.too_many_steps",
  "job.succeeded",
  "lulu.history.hidden_entry",
  "lulu.reply.accepted",
  "lulu.reply.action_pending",
  "lulu.reply.action_recorded",
  "lulu.reply.candidate_missing",
  "lulu.reply.candidate_present",
  "lulu.reply.mentioned_not_here",
  "lulu.reply.mentioned_someone",
  "lulu.reply.red_needs_owner",
  "lulu.reply.task_status",
  "lulu.reply.watcher_noted",
  "lulu.reply.watcher_noted_no_owner",
  "lulu_agents.add",
  "lulu_agents.autofill",
  "lulu_agents.autofill_done",
  "lulu_agents.autofill_done_no_executor",
  "lulu_agents.autofill_failed",
  "lulu_agents.autofill_hint",
  "lulu_agents.autofill_unsure",
  "lulu_agents.autofill_working",
  "lulu_agents.cancel",
  "lulu_agents.col_agent",
  "lulu_agents.col_executor",
  "lulu_agents.col_model",
  "lulu_agents.col_responsibilities",
  "lulu_agents.col_role",
  "lulu_agents.col_scope",
  "lulu_agents.col_state",
  "lulu_agents.count",
  "lulu_agents.create",
  "lulu_agents.create_failed",
  "lulu_agents.dialog_desc",
  "lulu_agents.dialog_title",
  "lulu_agents.disable",
  "lulu_agents.disable_note",
  "lulu_agents.edit",
  "lulu_agents.edit_dialog_desc",
  "lulu_agents.edit_dialog_title",
  "lulu_agents.empty",
  "lulu_agents.executor_unbound",
  "lulu_agents.f_name",
  "lulu_agents.f_name_hint",
  "lulu_agents.f_responsibilities",
  "lulu_agents.f_responsibilities_empty",
  "lulu_agents.f_responsibilities_hint",
  "lulu_agents.f_role",
  "lulu_agents.f_role_hint",
  "lulu_agents.f_scope",
  "lulu_agents.f_scope_hint",
  "lulu_agents.identity_note",
  "lulu_agents.model_disabled",
  "lulu_agents.model_no_key",
  "lulu_agents.model_not_callable",
  "lulu_agents.model_not_implemented",
  "lulu_agents.model_not_wired",
  "lulu_agents.model_quota_exhausted",
  "lulu_agents.model_rate_limited",
  "lulu_agents.model_unavailable",
  "lulu_agents.model_unknown",
  "lulu_agents.model_unlisted",
  "lulu_agents.model_unset",
  "lulu_agents.model_unverified",
  "lulu_agents.resp_architect",
  "lulu_agents.resp_backend",
  "lulu_agents.resp_frontend",
  "lulu_agents.resp_ops",
  "lulu_agents.resp_product_design",
  "lulu_agents.resp_qa",
  "lulu_agents.resp_release",
  "lulu_agents.resp_research",
  "lulu_agents.resp_review",
  "lulu_agents.resp_ui_design",
  "lulu_agents.save",
  "lulu_agents.save_failed",
  "lulu_agents.scope_account",
  "lulu_agents.scope_project",
  "lulu_agents.speak.here",
  "lulu_agents.speak.here_no_role",
  "lulu_agents.speak.need_more",
  "lulu_agents.speak.not_mine",
  "lulu_agents.speak.on_it",
  "lulu_agents.state_available",
  "lulu_agents.state_disabled",
  "lulu_agents.sub",
  "lulu_agents.title",
  "lulu_agents.unreachable",
  "lulu_agents.why_body",
  "lulu_agents.why_heading",
  "lulu_agents.why_title",
  "lulu_workbench.attach.action",
  "lulu_workbench.attach.bad_type",
  "lulu_workbench.attach.download",
  "lulu_workbench.attach.failed",
  "lulu_workbench.attach.kind_image",
  "lulu_workbench.attach.kind_json",
  "lulu_workbench.attach.kind_pdf",
  "lulu_workbench.attach.kind_table",
  "lulu_workbench.attach.kind_text",
  "lulu_workbench.attach.kind_zip",
  "lulu_workbench.attach.remove",
  "lulu_workbench.attach.retry",
  "lulu_workbench.attach.too_large",
  "lulu_workbench.attach.too_many",
  "lulu_workbench.attach.uploading",
  "lulu_workbench.attach.wait_upload",
  "lulu_workbench.attribution.declared",
  "lulu_workbench.attribution.platform",
  "lulu_workbench.attribution.self",
  "lulu_workbench.bind.already",
  "lulu_workbench.bind.do",
  "lulu_workbench.bind.failed",
  "lulu_workbench.bind.keep_chatting",
  "lulu_workbench.bind.kind_code",
  "lulu_workbench.bind.kind_deploy",
  "lulu_workbench.bind.kind_resource",
  "lulu_workbench.bind.needed",
  "lulu_workbench.bind.one_way",
  "lulu_workbench.bind.pick",
  "lulu_workbench.bind.skip",
  "lulu_workbench.blocked.no_eligible_executor",
  "lulu_workbench.board.auto_start",
  "lulu_workbench.board.queue_reason",
  "lulu_workbench.board.undo",
  "lulu_workbench.board.undo_confirm",
  "lulu_workbench.board.undo_done",
  "lulu_workbench.board.undo_failed",
  "lulu_workbench.chat.new_below",
  "lulu_workbench.chat.stop",
  "lulu_workbench.chat.thinking",
  "lulu_workbench.chat.thinking_phase",
  "lulu_workbench.chat.thinking_tokens",
  "lulu_workbench.composer.key_hint",
  "lulu_workbench.composer.ph_first",
  "lulu_workbench.composer.ph_more",
  "lulu_workbench.composer.ph_offline",
  "lulu_workbench.composer.ph_project",
  "lulu_workbench.composer.plan_only_chip",
  "lulu_workbench.composer.send",
  "lulu_workbench.composer.send_failed",
  "lulu_workbench.composer.sending",
  "lulu_workbench.convfail.draft_kept",
  "lulu_workbench.convfail.headline",
  "lulu_workbench.convfail.project_kept",
  "lulu_workbench.convfail.retry_last_step",
  "lulu_workbench.convfail.why_no_rollback",
  "lulu_workbench.convfail.wont_delete",
  "lulu_workbench.disable.cancel",
  "lulu_workbench.disable.clean",
  "lulu_workbench.disable.confirm",
  "lulu_workbench.disable.conversations_truncated",
  "lulu_workbench.disable.failed",
  "lulu_workbench.disable.pending",
  "lulu_workbench.disable.running",
  "lulu_workbench.disable.seats",
  "lulu_workbench.disable.sessions",
  "lulu_workbench.disable.title",
  "lulu_workbench.empty.desc",
  "lulu_workbench.empty.foot",
  "lulu_workbench.empty.s1_d",
  "lulu_workbench.empty.s1_t",
  "lulu_workbench.empty.s2_d",
  "lulu_workbench.empty.s2_t",
  "lulu_workbench.empty.s3_d",
  "lulu_workbench.empty.s3_t",
  "lulu_workbench.empty.s4_d",
  "lulu_workbench.empty.s4_t",
  "lulu_workbench.empty.title",
  "lulu_workbench.evidence.empty",
  "lulu_workbench.evidence.from_sub",
  "lulu_workbench.evidence.on_parent",
  "lulu_workbench.evidence.title",
  "lulu_workbench.folder.empty",
  "lulu_workbench.folder.git_clean",
  "lulu_workbench.folder.git_dirty",
  "lulu_workbench.folder.no_permission",
  "lulu_workbench.folder.not_git",
  "lulu_workbench.folder.open_settings",
  "lulu_workbench.folder.pick_another",
  "lulu_workbench.folder.readonly_promise",
  "lulu_workbench.folder.stale_fix",
  "lulu_workbench.folder.stale_not_broken",
  "lulu_workbench.folder.stale_path",
  "lulu_workbench.folder.taken",
  "lulu_workbench.folder.taken_why",
  "lulu_workbench.gap.detail",
  "lulu_workbench.gap.not_wired",
  "lulu_workbench.gap.unreachable",
  "lulu_workbench.held.dont_resubmit",
  "lulu_workbench.held.idempotent",
  "lulu_workbench.held.not_your_fault",
  "lulu_workbench.held.production_fine",
  "lulu_workbench.init.blocked_by_prev",
  "lulu_workbench.init.not_ready_yet",
  "lulu_workbench.init.same_key",
  "lulu_workbench.init.stage_conversation",
  "lulu_workbench.init.stage_project",
  "lulu_workbench.init.stage_repo",
  "lulu_workbench.init.state_done",
  "lulu_workbench.init.state_fail",
  "lulu_workbench.init.state_none",
  "lulu_workbench.init.state_running",
  "lulu_workbench.init.state_wait",
  "lulu_workbench.item.block",
  "lulu_workbench.item.closed",
  "lulu_workbench.item.done",
  "lulu_workbench.item.fail",
  "lulu_workbench.item.held",
  "lulu_workbench.item.none",
  "lulu_workbench.item.rec",
  "lulu_workbench.item.run",
  "lulu_workbench.item.todo",
  "lulu_workbench.item.unknown",
  "lulu_workbench.item.wait",
  "lulu_workbench.launch.direct_k",
  "lulu_workbench.launch.direct_v",
  "lulu_workbench.launch.folder_readonly",
  "lulu_workbench.launch.how_else_k",
  "lulu_workbench.launch.how_else_v",
  "lulu_workbench.launch.import_project",
  "lulu_workbench.launch.loading_desc",
  "lulu_workbench.launch.loading_title",
  "lulu_workbench.launch.mac_only_desc",
  "lulu_workbench.launch.mac_only_title",
  "lulu_workbench.launch.mode_change_k",
  "lulu_workbench.launch.mode_change_v",
  "lulu_workbench.launch.mode_default_k",
  "lulu_workbench.launch.mode_default_v",
  "lulu_workbench.launch.mode_desc",
  "lulu_workbench.launch.mode_not_persisted",
  "lulu_workbench.launch.mode_solo_k",
  "lulu_workbench.launch.mode_solo_v",
  "lulu_workbench.launch.mode_team_k",
  "lulu_workbench.launch.mode_team_v",
  "lulu_workbench.launch.mode_title",
  "lulu_workbench.launch.new_folder",
  "lulu_workbench.launch.new_project",
  "lulu_workbench.launch.new_title",
  "lulu_workbench.launch.path_desc_web",
  "lulu_workbench.launch.path_title",
  "lulu_workbench.launch.pick_folder",
  "lulu_workbench.launch.picked_k",
  "lulu_workbench.launch.picked_v",
  "lulu_workbench.launch.read_failed",
  "lulu_workbench.launch.really_none",
  "lulu_workbench.launch.recent_foot",
  "lulu_workbench.launch.recent_meta",
  "lulu_workbench.launch.recent_title",
  "lulu_workbench.launch.retry",
  "lulu_workbench.launch.search_clear",
  "lulu_workbench.launch.search_create",
  "lulu_workbench.launch.search_hint",
  "lulu_workbench.launch.search_none",
  "lulu_workbench.launch.start_failed",
  "lulu_workbench.launch.start_solo",
  "lulu_workbench.launch.start_team",
  "lulu_workbench.launch.starting",
  "lulu_workbench.launch.sub",
  "lulu_workbench.launch.title",
  "lulu_workbench.launch.title_shows_k",
  "lulu_workbench.launch.title_shows_v",
  "lulu_workbench.launch.unverified",
  "lulu_workbench.mention.empty",
  "lulu_workbench.mention.group_here",
  "lulu_workbench.mention.group_invite_people",
  "lulu_workbench.mention.group_library",
  "lulu_workbench.mention.group_people",
  "lulu_workbench.mention.join_failed",
  "lulu_workbench.mention.joining",
  "lulu_workbench.mention.no_team_change",
  "lulu_workbench.mention.own_memory",
  "lulu_workbench.mention.person_hint",
  "lulu_workbench.mention.sub_excluded",
  "lulu_workbench.mention.title",
  "lulu_workbench.model.auto",
  "lulu_workbench.model.effort_fast",
  "lulu_workbench.model.effort_max",
  "lulu_workbench.model.effort_sheet_sub",
  "lulu_workbench.model.effort_sheet_title",
  "lulu_workbench.model.effort_standard",
  "lulu_workbench.model.group_default",
  "lulu_workbench.model.group_fixed",
  "lulu_workbench.model.next_message_only",
  "lulu_workbench.model.picker_sub",
  "lulu_workbench.model.picker_title",
  "lulu_workbench.model.pinned",
  "lulu_workbench.model.reason_expired",
  "lulu_workbench.model.reason_quota",
  "lulu_workbench.model.runtime_not_wired",
  "lulu_workbench.model.scope_note",
  "lulu_workbench.model.sheet_foot",
  "lulu_workbench.model.unavailable",
  "lulu_workbench.model.unverified",
  "lulu_workbench.model.unverified_note",
  "lulu_workbench.model.wont_switch",
  "lulu_workbench.people.add_hint",
  "lulu_workbench.people.cannot_dispatch",
  "lulu_workbench.people.invite",
  "lulu_workbench.people.invite_failed",
  "lulu_workbench.people.invite_none",
  "lulu_workbench.people.inviting",
  "lulu_workbench.people.none",
  "lulu_workbench.people.remove",
  "lulu_workbench.people.remove_failed",
  "lulu_workbench.people.removing",
  "lulu_workbench.people.role.operator",
  "lulu_workbench.people.role.owner",
  "lulu_workbench.people.role.unknown",
  "lulu_workbench.people.role.viewer",
  "lulu_workbench.people.title",
  "lulu_workbench.plan.acceptance_label",
  "lulu_workbench.plan.already",
  "lulu_workbench.plan.current",
  "lulu_workbench.plan.failed",
  "lulu_workbench.plan.headline",
  "lulu_workbench.plan.none",
  "lulu_workbench.plan.objective_label",
  "lulu_workbench.plan.revise",
  "lulu_workbench.plan.roster_changed",
  "lulu_workbench.plan.same_roster",
  "lulu_workbench.plan.start",
  "lulu_workbench.presence.last_seen",
  "lulu_workbench.presence.unknown",
  "lulu_workbench.rail.group_general",
  "lulu_workbench.rail.new_conversation",
  "lulu_workbench.rail.recents",
  "lulu_workbench.recover.catching_up",
  "lulu_workbench.recover.headline",
  "lulu_workbench.recover.idle",
  "lulu_workbench.recover.nothing_running",
  "lulu_workbench.recover.what_happened",
  "lulu_workbench.red.card_approve",
  "lulu_workbench.red.card_ask",
  "lulu_workbench.red.card_ask_seed",
  "lulu_workbench.red.card_failed",
  "lulu_workbench.red.card_reject",
  "lulu_workbench.red.card_settled",
  "lulu_workbench.red.expired",
  "lulu_workbench.red.expires_in",
  "lulu_workbench.red.kind_access_policy",
  "lulu_workbench.red.kind_data_migration",
  "lulu_workbench.red.kind_delete_data",
  "lulu_workbench.red.kind_irreversible_infra",
  "lulu_workbench.red.kind_spend_money",
  "lulu_workbench.red.never_for_you",
  "lulu_workbench.red.q_after",
  "lulu_workbench.red.q_alternative",
  "lulu_workbench.red.q_backup",
  "lulu_workbench.red.q_frozen",
  "lulu_workbench.red.q_undo",
  "lulu_workbench.red.q_valid_for",
  "lulu_workbench.red.q_what",
  "lulu_workbench.red.q_why",
  "lulu_workbench.red.recommended",
  "lulu_workbench.red.scopes_frozen",
  "lulu_workbench.run.action.cancel",
  "lulu_workbench.run.action.confirm",
  "lulu_workbench.run.action.confirm_all",
  "lulu_workbench.run.action.confirm_one",
  "lulu_workbench.run.action.confirm_round",
  "lulu_workbench.run.action.failed",
  "lulu_workbench.run.action.pause",
  "lulu_workbench.run.action.resume",
  "lulu_workbench.run.action.round_already_stopped",
  "lulu_workbench.run.action.round_failed",
  "lulu_workbench.run.action.round_stopped",
  "lulu_workbench.run.action.stop",
  "lulu_workbench.run.action.stop_all",
  "lulu_workbench.run.action.stop_round",
  "lulu_workbench.run.check.failed",
  "lulu_workbench.run.check.passed",
  "lulu_workbench.run.check.skipped",
  "lulu_workbench.run.column.agent",
  "lulu_workbench.run.column.elapsed",
  "lulu_workbench.run.column.model",
  "lulu_workbench.run.column.token",
  "lulu_workbench.run.detail.back",
  "lulu_workbench.run.detail.evidence",
  "lulu_workbench.run.detail.responsibility",
  "lulu_workbench.run.details.open",
  "lulu_workbench.run.details.unresolved",
  "lulu_workbench.run.duration.minutes",
  "lulu_workbench.run.duration.seconds",
  "lulu_workbench.run.empty",
  "lulu_workbench.run.footer",
  "lulu_workbench.run.heading.finished",
  "lulu_workbench.run.meta",
  "lulu_workbench.run.nothing_to_verify",
  "lulu_workbench.run.paused",
  "lulu_workbench.run.phase.count",
  "lulu_workbench.run.process.collapsed",
  "lulu_workbench.run.process.needs_you",
  "lulu_workbench.run.process.running",
  "lulu_workbench.run.process.title",
  "lulu_workbench.run.release.deployed",
  "lulu_workbench.run.release.deployed_label",
  "lulu_workbench.run.release.health",
  "lulu_workbench.run.release.merged",
  "lulu_workbench.run.release.merged_label",
  "lulu_workbench.run.release.pending",
  "lulu_workbench.run.release.production_verified",
  "lulu_workbench.run.release.rollback",
  "lulu_workbench.run.release.rolled_back",
  "lulu_workbench.run.release.rolled_back_label",
  "lulu_workbench.run.release.smoke",
  "lulu_workbench.run.section.artifacts",
  "lulu_workbench.run.section.changes",
  "lulu_workbench.run.section.checks",
  "lulu_workbench.run.section.did",
  "lulu_workbench.run.section.next",
  "lulu_workbench.run.section.release",
  "lulu_workbench.run.section.risks",
  "lulu_workbench.run.sha.copied",
  "lulu_workbench.run.sha.copy",
  "lulu_workbench.run.status.cancelled",
  "lulu_workbench.run.status.completed",
  "lulu_workbench.run.status.failed",
  "lulu_workbench.run.status.partial",
  "lulu_workbench.run.step.agent_completed",
  "lulu_workbench.run.step.agent_joined",
  "lulu_workbench.run.step.agent_progress",
  "lulu_workbench.run.step.agent_recovered",
  "lulu_workbench.run.step.agent_stopped",
  "lulu_workbench.run.step.item_cancelled",
  "lulu_workbench.run.step.item_completed",
  "lulu_workbench.run.step.item_failed",
  "lulu_workbench.run.step.item_ready",
  "lulu_workbench.run.step.item_recovering",
  "lulu_workbench.run.step.item_running",
  "lulu_workbench.run.step.item_waiting",
  "lulu_workbench.run.step.plan_ready",
  "lulu_workbench.run.step.result_available",
  "lulu_workbench.run.step.waiting",
  "lulu_workbench.run.stream.unknown",
  "lulu_workbench.run.summary.default_title",
  "lulu_workbench.run.summary.meta",
  "lulu_workbench.run.summary.open",
  "lulu_workbench.run.unverified",
  "lulu_workbench.settle.artifact.branch",
  "lulu_workbench.settle.artifact.commit",
  "lulu_workbench.settle.artifact.task",
  "lulu_workbench.settle.headline.cancelled",
  "lulu_workbench.settle.headline.completed",
  "lulu_workbench.settle.headline.failed",
  "lulu_workbench.settle.headline.partial",
  "lulu_workbench.sidecar.add_agent",
  "lulu_workbench.sidecar.back_to_chat",
  "lulu_workbench.sidecar.close",
  "lulu_workbench.sidecar.keep_state",
  "lulu_workbench.sidecar.tab_board",
  "lulu_workbench.sidecar.tab_decisions",
  "lulu_workbench.sidecar.tab_evidence",
  "lulu_workbench.sidecar.tab_team",
  "lulu_workbench.sidecar.title_work",
  "lulu_workbench.sidecar.width_hint",
  "lulu_workbench.skills.ago_days",
  "lulu_workbench.skills.ago_hours",
  "lulu_workbench.skills.ago_minutes",
  "lulu_workbench.skills.ago_now",
  "lulu_workbench.skills.disabled",
  "lulu_workbench.skills.empty",
  "lulu_workbench.skills.enabled",
  "lulu_workbench.skills.last_run",
  "lulu_workbench.skills.last_run_failed",
  "lulu_workbench.skills.last_run_ok",
  "lulu_workbench.skills.never_ran",
  "lulu_workbench.skills.section",
  "lulu_workbench.skills.section_hint",
  "lulu_workbench.skills.toggle_failed",
  "lulu_workbench.skills.trigger_daily",
  "lulu_workbench.skills.trigger_say",
  "lulu_workbench.slash.effort",
  "lulu_workbench.slash.effort_hint",
  "lulu_workbench.slash.empty",
  "lulu_workbench.slash.keys",
  "lulu_workbench.slash.new",
  "lulu_workbench.slash.new_hint",
  "lulu_workbench.slash.plan_only_hint",
  "lulu_workbench.slash.plan_only_off",
  "lulu_workbench.slash.plan_only_on",
  "lulu_workbench.slash.rename",
  "lulu_workbench.slash.rename_failed",
  "lulu_workbench.slash.rename_hint",
  "lulu_workbench.slash.rename_hint_empty",
  "lulu_workbench.slash.skill_hint",
  "lulu_workbench.slash.stop_hint",
  "lulu_workbench.slash.title",
  "lulu_workbench.state.blocked",
  "lulu_workbench.state.completed",
  "lulu_workbench.state.disconnected",
  "lulu_workbench.state.discussing",
  "lulu_workbench.state.failed",
  "lulu_workbench.state.planning",
  "lulu_workbench.state.platform_held",
  "lulu_workbench.state.recovering",
  "lulu_workbench.state.running",
  "lulu_workbench.state.unknown",
  "lulu_workbench.state.waiting_agent",
  "lulu_workbench.state.waiting_user",
  "lulu_workbench.sub.auto_named",
  "lulu_workbench.sub.boundary",
  "lulu_workbench.sub.elapsed",
  "lulu_workbench.sub.evidence_on_parent",
  "lulu_workbench.sub.no_progress_bar",
  "lulu_workbench.sub.not_member",
  "lulu_workbench.sub.parent",
  "lulu_workbench.sub.stop_isolated",
  "lulu_workbench.sub.team_unchanged",
  "lulu_workbench.subfail.costs_money",
  "lulu_workbench.subfail.exit_retry",
  "lulu_workbench.subfail.exit_swap_model",
  "lulu_workbench.subfail.exit_takeover",
  "lulu_workbench.subfail.failed",
  "lulu_workbench.subfail.headline",
  "lulu_workbench.subfail.keep_done",
  "lulu_workbench.subfail.my_pick",
  "lulu_workbench.subfail.no_reason_yet",
  "lulu_workbench.subfail.no_reopen",
  "lulu_workbench.team.account_only",
  "lulu_workbench.team.candidate_count",
  "lulu_workbench.team.empty_ok",
  "lulu_workbench.team.join",
  "lulu_workbench.team.join_failed",
  "lulu_workbench.team.joining",
  "lulu_workbench.team.member_disabled",
  "lulu_workbench.team.mention_scope",
  "lulu_workbench.team.only_agents",
  "lulu_workbench.team.remove_no_interrupt",
  "lulu_workbench.team.try_one",
  "lulu_workbench.teambar.adjust",
  "lulu_workbench.teambar.solo",
  "lulu_workbench.teambar.team",
  "lulu_workbench.title.bound",
  "lulu_workbench.title.general",
  "lulu_workbench.title.no_project",
  "lulu_workbench.title.offline",
  "lulu_workbench.title.solo",
  "lulu_workbench.voice.cancel",
  "lulu_workbench.voice.no_mic",
  "lulu_workbench.voice.retry",
  "lulu_workbench.voice.start",
  "lulu_workbench.voice.stop",
  "lulu_workbench.voice.transcribing",
  "lulu_workbench.voice.unsupported",
  "memo.access.all",
  "memo.access.audit",
  "memo.access.default",
  "memo.access.filter.empty",
  "memo.access.hidden",
  "memo.access.label",
  "memo.ai.change",
  "memo.ai.default",
  "memo.ai.default.desc",
  "memo.ai.hidden",
  "memo.ai.hidden.desc",
  "memo.ai.panel.locked",
  "memo.ai.panel.readable",
  "memo.ai.panel.undecided",
  "memo.ai.shared",
  "memo.ai.shared.scope.global",
  "memo.ai.shared.scope.global.desc",
  "memo.ai.shared.scope.project",
  "memo.ai.shared.scope.project.desc",
  "memo.ai.toggle.hide",
  "memo.ai.toggle.show",
  "memo.archive.archived.at",
  "memo.archive.delete.note",
  "memo.archive.delete.note.body",
  "memo.archive.empty",
  "memo.archive.empty.title",
  "memo.archive.entry",
  "memo.archive.notice",
  "memo.archive.notice.body",
  "memo.archive.restore",
  "memo.archive.subtitle",
  "memo.archive.title",
  "memo.candidates.badge",
  "memo.candidates.confirm",
  "memo.candidates.confirmed",
  "memo.candidates.desc",
  "memo.candidates.discard",
  "memo.candidates.discarded",
  "memo.candidates.empty",
  "memo.candidates.heading",
  "memo.candidates.only_me",
  "memo.candidates.source",
  "memo.candidates.why",
  "memo.capture.hint",
  "memo.capture.retry",
  "memo.capture.save",
  "memo.capture.saving",
  "memo.capture.tool.clip",
  "memo.capture.tool.link",
  "memo.capture.tool.voice",
  "memo.capture.tool.voice.cancel",
  "memo.clip.bytes",
  "memo.clip.fail.foot",
  "memo.clip.reject.size",
  "memo.clip.reject.type",
  "memo.clip.remove",
  "memo.clip.state.done",
  "memo.clip.state.failed",
  "memo.clip.state.uploading",
  "memo.clip.state.waiting",
  "memo.conflict.body",
  "memo.conflict.foot",
  "memo.conflict.mine",
  "memo.conflict.mine.v",
  "memo.conflict.option.both",
  "memo.conflict.option.both.desc",
  "memo.conflict.option.mine",
  "memo.conflict.option.mine.desc",
  "memo.conflict.option.server",
  "memo.conflict.option.server.desc",
  "memo.conflict.server",
  "memo.conflict.server.v",
  "memo.conflict.title",
  "memo.crumb.project",
  "memo.detail.actions.archive",
  "memo.detail.actions.move",
  "memo.detail.ai",
  "memo.detail.ai.reads",
  "memo.detail.ai.reads.none",
  "memo.detail.cant.read",
  "memo.detail.edited",
  "memo.detail.files.none",
  "memo.detail.group.files",
  "memo.detail.group.relations",
  "memo.detail.group.scope",
  "memo.detail.other.projects",
  "memo.detail.source.none",
  "memo.detail.voice.title",
  "memo.detail.where",
  "memo.detail.where.global",
  "memo.detail.where.project",
  "memo.detail.written",
  "memo.empty.filter",
  "memo.empty.from.misc",
  "memo.empty.global.body",
  "memo.empty.global.placeholder",
  "memo.empty.global.title",
  "memo.empty.project.body",
  "memo.empty.project.placeholder",
  "memo.empty.project.title",
  "memo.error.body",
  "memo.error.retry",
  "memo.error.title",
  "memo.group.earlier",
  "memo.group.today",
  "memo.group.week",
  "memo.group.yesterday",
  "memo.image.preview",
  "memo.link.add",
  "memo.link.invalid",
  "memo.link.placeholder",
  "memo.list.fact.files",
  "memo.list.fact.images",
  "memo.list.filter.all",
  "memo.list.filter.files",
  "memo.list.filter.lulu",
  "memo.list.filter.recent",
  "memo.list.filter.voice",
  "memo.list.head.find",
  "memo.list.recent",
  "memo.list.recent.meta",
  "memo.list.search",
  "memo.list.search.clear",
  "memo.list.search.empty",
  "memo.list.source.file",
  "memo.list.source.link",
  "memo.list.source.lulu",
  "memo.list.source.text",
  "memo.list.source.voice",
  "memo.list.this.project",
  "memo.list.uploads.waiting",
  "memo.list.voice.no_text",
  "memo.loading",
  "memo.loading.note",
  "memo.lock.desc",
  "memo.lock.input",
  "memo.lock.placeholder",
  "memo.lock.title",
  "memo.lock.unlock",
  "memo.mobile.input",
  "memo.mobile.search.open",
  "memo.move.confirm",
  "memo.move.confirm.none",
  "memo.move.desc",
  "memo.move.foot",
  "memo.move.invalid.body",
  "memo.move.invalid.title",
  "memo.move.invalid.wont.1",
  "memo.move.invalid.wont.2",
  "memo.move.invalid.wont.3",
  "memo.move.note",
  "memo.move.notice",
  "memo.move.notice.body",
  "memo.move.pick.other",
  "memo.move.row.ai",
  "memo.move.row.ai.v",
  "memo.move.row.back",
  "memo.move.row.back.v",
  "memo.move.row.delete",
  "memo.move.row.delete.v",
  "memo.move.row.to",
  "memo.move.row.who",
  "memo.move.row.who.v",
  "memo.move.title",
  "memo.move.to.misc",
  "memo.page.back.list",
  "memo.page.badge.project",
  "memo.page.notice.global",
  "memo.page.notice.global.body",
  "memo.page.notice.project",
  "memo.page.notice.project.body",
  "memo.page.subtitle",
  "memo.page.subtitle.project",
  "memo.page.title",
  "memo.page.title.project",
  "memo.page.write",
  "memo.password.change",
  "memo.password.confirm.remove",
  "memo.password.group",
  "memo.password.input",
  "memo.password.none",
  "memo.password.remove",
  "memo.password.removed",
  "memo.password.set",
  "memo.password.set.ok",
  "memo.queue.dead",
  "memo.queue.dead.remove",
  "memo.quick.badge",
  "memo.quick.composing.note",
  "memo.quick.desc.global",
  "memo.quick.desc.project",
  "memo.quick.foot",
  "memo.quick.note",
  "memo.quick.note.project",
  "memo.quick.title",
  "memo.quick.title.project",
  "memo.reads.bar.latest",
  "memo.reads.bar.none",
  "memo.reads.scope.global",
  "memo.reads.scope.host",
  "memo.reads.scope.project",
  "memo.save.fail.body",
  "memo.save.fail.foot",
  "memo.save.fail.title",
  "memo.save.giveup",
  "memo.save.offline.foot",
  "memo.save.why",
  "memo.save.why.body",
  "memo.scope.local",
  "memo.scope.misc",
  "memo.scope.save.global",
  "memo.scope.save.global.note",
  "memo.scope.save.project",
  "memo.scope.save.project.note",
  "memo.scope.switch.misc",
  "memo.search.cross",
  "memo.undo.action",
  "memo.undo.archived",
  "memo.undo.failed",
  "memo.undo.moved",
  "memo.view.label",
  "memo.view.list",
  "memo.view.tiles",
  "memo.voice.audition",
  "memo.voice.cancel",
  "memo.voice.finish",
  "memo.voice.level.off",
  "memo.voice.level.on",
  "memo.voice.no_mic",
  "memo.voice.record",
  "memo.voice.rerecord",
  "memo.voice.save",
  "memo.voice.saved",
  "memo.voice.saving",
  "memo.voice.search.note",
  "memo.voice.selfwrite",
  "memo.voice.stop",
  "memo.voice.transcribing",
  "memo.voice.transcript.failed",
  "memo.voice.transcript.failed.body",
  "memo.voice.unsupported",
  "memo.when.date",
  "memo.when.full",
  "memo.when.today",
  "memo.when.yesterday",
  "model.application.action.remove",
  "model.application.action.save",
  "model.application.override.hint",
  "model.application.override.label",
  "model.application.saved",
  "model.budget.only_one_brain",
  "model.budget.switch_cheap",
  "model.degraded.budget_used_up",
  "model.degraded.no_answer",
  "model.degraded.secret_in_paste",
  "model.developer.action.save",
  "model.developer.heading",
  "model.developer.hint",
  "model.developer.model.auto.detail",
  "model.developer.model.auto.name",
  "model.developer.model.deepseek.detail",
  "model.developer.model.deepseek.name",
  "model.developer.model.doubao.detail",
  "model.developer.model.doubao.name",
  "model.developer.model.kimi.detail",
  "model.developer.model.kimi.name",
  "model.developer.provider.plan",
  "model.developer.recommended",
  "model.developer.saved",
  "model.generator.action.save_global",
  "model.generator.heading",
  "model.generator.hint",
  "model.generator.model.doubao.badge",
  "model.generator.model.doubao.detail",
  "model.generator.model.doubao.name",
  "model.generator.model.flash.badge",
  "model.generator.model.flash.detail",
  "model.generator.model.flash.name",
  "model.generator.model.glm.badge",
  "model.generator.model.glm.detail",
  "model.generator.model.glm.name",
  "model.generator.saved",
  "model.not_connected",
  "model.provider.plan",
  "model.reviewer.action.remove_override",
  "model.reviewer.action.save_global",
  "model.reviewer.action.save_project",
  "model.reviewer.action.saving",
  "model.reviewer.capability.heading",
  "model.reviewer.effective.label",
  "model.reviewer.global.heading",
  "model.reviewer.global.hint",
  "model.reviewer.model.flash.badge",
  "model.reviewer.model.flash.detail",
  "model.reviewer.model.flash.name",
  "model.reviewer.model.pro.badge",
  "model.reviewer.model.pro.detail",
  "model.reviewer.model.pro.name",
  "model.reviewer.override.hint",
  "model.reviewer.override.label",
  "model.reviewer.page.subtitle",
  "model.reviewer.project.empty",
  "model.reviewer.project.heading",
  "model.reviewer.project.hint",
  "model.reviewer.project.select",
  "model.reviewer.removed",
  "model.reviewer.saved",
  "model.reviewer.source.global",
  "model.reviewer.source.project",
  "model.route.developer.deepseek_fallback",
  "model.route.developer.fix_bug",
  "model.route.developer.read_repo",
  "model.route.steward.ark_selected",
  "model.route.steward.deepseek_selected",
  "model.steward.action.save",
  "model.steward.effective.label",
  "model.steward.heading",
  "model.steward.hint",
  "model.steward.model.deepseek.badge",
  "model.steward.model.deepseek.detail",
  "model.steward.model.deepseek.name",
  "model.steward.model.doubao.badge",
  "model.steward.model.doubao.detail",
  "model.steward.model.doubao.name",
  "model.steward.provider.ark",
  "model.steward.revision",
  "model.steward.saved",
  "model.steward.source.global",
  "model.vendor_not_open",
  "model_configuration.access_token_label",
  "model_configuration.action_target",
  "model_configuration.add_and_test",
  "model_configuration.add_model",
  "model_configuration.advanced_label",
  "model_configuration.agent_capabilities_resources",
  "model_configuration.agent_count",
  "model_configuration.agent_settings_title",
  "model_configuration.api_key_label",
  "model_configuration.api_key_placeholder",
  "model_configuration.api_key_replace_hint",
  "model_configuration.api_url_label",
  "model_configuration.app_id_label",
  "model_configuration.app_id_placeholder",
  "model_configuration.assist.entry",
  "model_configuration.assist.hint",
  "model_configuration.assist.no_base_url",
  "model_configuration.assist.no_model_id",
  "model_configuration.assist.nothing",
  "model_configuration.assist.reasoning",
  "model_configuration.assist.secret_seen",
  "model_configuration.assist.unknown_provider",
  "model_configuration.avatar_select_aria",
  "model_configuration.binding_picker_add_select",
  "model_configuration.binding_picker_catalog_hint",
  "model_configuration.binding_picker_configure_provider",
  "model_configuration.binding_picker_connection_label",
  "model_configuration.binding_picker_connection_placeholder",
  "model_configuration.binding_picker_connections",
  "model_configuration.binding_picker_empty_connections",
  "model_configuration.binding_picker_empty_profiles",
  "model_configuration.binding_picker_mode",
  "model_configuration.binding_picker_profiles",
  "model_configuration.binding_picker_provider_label",
  "model_configuration.binding_picker_provider_placeholder",
  "model_configuration.binding_picker_provider_unconfigured",
  "model_configuration.binding_picker_runtime_hint",
  "model_configuration.binding_picker_select_existing",
  "model_configuration.binding_picker_supported_models",
  "model_configuration.binding_picker_testing",
  "model_configuration.catalog_loaded",
  "model_configuration.choose_supported_model",
  "model_configuration.col_actions",
  "model_configuration.col_key",
  "model_configuration.col_model",
  "model_configuration.col_provider",
  "model_configuration.col_reasoning",
  "model_configuration.col_scope",
  "model_configuration.col_status",
  "model_configuration.col_tokens",
  "model_configuration.col_url",
  "model_configuration.col_vision",
  "model_configuration.configure_credential_action",
  "model_configuration.connection_default_name",
  "model_configuration.connection_details_action",
  "model_configuration.connection_failed",
  "model_configuration.connection_key_required_for_discovery",
  "model_configuration.connection_ready",
  "model_configuration.connection_settings_action",
  "model_configuration.connection_shared_notice",
  "model_configuration.credential_configured",
  "model_configuration.credential_configured_at",
  "model_configuration.credential_first_save_hint",
  "model_configuration.credential_rotation_hint",
  "model_configuration.custom_access",
  "model_configuration.delete_model",
  "model_configuration.description_label",
  "model_configuration.direct_connections_advanced",
  "model_configuration.direct_connections_hint",
  "model_configuration.disable_model",
  "model_configuration.discovery_empty",
  "model_configuration.discovery_manual_only_hint",
  "model_configuration.discovery_metadata_hint",
  "model_configuration.discovery_not_supported",
  "model_configuration.display_name_label",
  "model_configuration.edit_model",
  "model_configuration.edit_model_information",
  "model_configuration.empty_model_library",
  "model_configuration.empty_model_library_hint",
  "model_configuration.enable_model",
  "model_configuration.explicit_model",
  "model_configuration.failure_auth",
  "model_configuration.failure_incompatible",
  "model_configuration.failure_model_not_found",
  "model_configuration.failure_network",
  "model_configuration.failure_quota_exhausted",
  "model_configuration.failure_rate_limited",
  "model_configuration.fetch_models",
  "model_configuration.fetch_models_again",
  "model_configuration.filter_aria",
  "model_configuration.finish_agent_information",
  "model_configuration.form_required",
  "model_configuration.gateway_address",
  "model_configuration.gateway_key",
  "model_configuration.gateway_key_rotation",
  "model_configuration.gateway_model_source",
  "model_configuration.gateway_models_empty",
  "model_configuration.gateway_models_loading",
  "model_configuration.gateway_recommended",
  "model_configuration.gateway_summary",
  "model_configuration.impact_agents",
  "model_configuration.impact_blocked",
  "model_configuration.impact_clear",
  "model_configuration.impact_description",
  "model_configuration.impact_loading",
  "model_configuration.impact_system_bindings",
  "model_configuration.load_catalog_models",
  "model_configuration.load_supported_models",
  "model_configuration.manual_model_toggle",
  "model_configuration.max_input_label",
  "model_configuration.max_output_label",
  "model_configuration.model_connection_settings_hint",
  "model_configuration.model_count",
  "model_configuration.model_edit_action",
  "model_configuration.model_id_label",
  "model_configuration.model_library_subtitle",
  "model_configuration.model_library_title",
  "model_configuration.model_list_heading",
  "model_configuration.model_saved_test_failed",
  "model_configuration.modify_agent_information",
  "model_configuration.module_default_model_aria",
  "model_configuration.no_value",
  "model_configuration.open_connection_settings",
  "model_configuration.platform_auto_detected",
  "model_configuration.platform_connection_hint",
  "model_configuration.platform_credential_label",
  "model_configuration.platform_credential_summary",
  "model_configuration.platform_managed",
  "model_configuration.platform_model_hint",
  "model_configuration.platform_name_hint",
  "model_configuration.platform_status_sync",
  "model_configuration.project_scope",
  "model_configuration.project_scope_named",
  "model_configuration.protocol_label",
  "model_configuration.provider_access",
  "model_configuration.provider_label",
  "model_configuration.reasoning_capability_label",
  "model_configuration.reasoning_default_hint",
  "model_configuration.reasoning_default_label",
  "model_configuration.reasoning_label",
  "model_configuration.reasoning_unsupported_hint",
  "model_configuration.refresh_supported_models",
  "model_configuration.reload_catalog_models",
  "model_configuration.required_fields",
  "model_configuration.retire_no_replacement",
  "model_configuration.retire_pause",
  "model_configuration.retire_pause_hint",
  "model_configuration.retire_replace",
  "model_configuration.retire_replace_hint",
  "model_configuration.retire_replacement_label",
  "model_configuration.retire_replacement_placeholder",
  "model_configuration.retire_strategy",
  "model_configuration.save_and_test",
  "model_configuration.save_and_test_model",
  "model_configuration.scope_account",
  "model_configuration.scope_project",
  "model_configuration.select_model_label",
  "model_configuration.speech_not_testable",
  "model_configuration.status_available",
  "model_configuration.status_disabled",
  "model_configuration.status_quota_exhausted",
  "model_configuration.status_rate_limited",
  "model_configuration.status_unavailable",
  "model_configuration.status_unverified",
  "model_configuration.supported_model_hint",
  "model_configuration.supported_model_label",
  "model_configuration.supported_model_placeholder",
  "model_configuration.system_default_model",
  "model_configuration.test_failed_keep_editing",
  "model_configuration.test_model",
  "model_configuration.testing_model",
  "model_configuration.ui_001",
  "model_configuration.ui_002",
  "model_configuration.ui_003",
  "model_configuration.ui_004",
  "model_configuration.ui_005",
  "model_configuration.ui_006",
  "model_configuration.ui_007",
  "model_configuration.ui_008",
  "model_configuration.ui_009",
  "model_configuration.ui_010",
  "model_configuration.ui_011",
  "model_configuration.ui_012",
  "model_configuration.ui_013",
  "model_configuration.ui_014",
  "model_configuration.ui_015",
  "model_configuration.ui_016",
  "model_configuration.ui_017",
  "model_configuration.ui_018",
  "model_configuration.ui_019",
  "model_configuration.ui_020",
  "model_configuration.ui_021",
  "model_configuration.ui_022",
  "model_configuration.ui_023",
  "model_configuration.ui_024",
  "model_configuration.ui_025",
  "model_configuration.ui_026",
  "model_configuration.ui_027",
  "model_configuration.ui_028",
  "model_configuration.ui_029",
  "model_configuration.ui_030",
  "model_configuration.ui_031",
  "model_configuration.ui_032",
  "model_configuration.ui_033",
  "model_configuration.ui_034",
  "model_configuration.ui_035",
  "model_configuration.ui_036",
  "model_configuration.ui_037",
  "model_configuration.ui_038",
  "model_configuration.ui_039",
  "model_configuration.ui_040",
  "model_configuration.ui_041",
  "model_configuration.ui_042",
  "model_configuration.ui_043",
  "model_configuration.ui_044",
  "model_configuration.ui_045",
  "model_configuration.ui_046",
  "model_configuration.ui_047",
  "model_configuration.ui_048",
  "model_configuration.ui_049",
  "model_configuration.ui_050",
  "model_configuration.ui_051",
  "model_configuration.ui_052",
  "model_configuration.ui_053",
  "model_configuration.ui_054",
  "model_configuration.ui_055",
  "model_configuration.ui_056",
  "model_configuration.ui_057",
  "model_configuration.ui_058",
  "model_configuration.ui_059",
  "model_configuration.ui_060",
  "model_configuration.ui_061",
  "model_configuration.ui_062",
  "model_configuration.ui_063",
  "model_configuration.ui_064",
  "model_configuration.ui_065",
  "model_configuration.ui_066",
  "model_configuration.ui_067",
  "model_configuration.ui_068",
  "model_configuration.ui_069",
  "model_configuration.ui_070",
  "model_configuration.ui_071",
  "model_configuration.ui_072",
  "model_configuration.ui_073",
  "model_configuration.ui_074",
  "model_configuration.ui_075",
  "model_configuration.ui_076",
  "model_configuration.ui_077",
  "model_configuration.ui_078",
  "model_configuration.ui_079",
  "model_configuration.ui_080",
  "model_configuration.ui_081",
  "model_configuration.ui_082",
  "model_configuration.ui_083",
  "model_configuration.ui_084",
  "model_configuration.ui_085",
  "model_configuration.ui_086",
  "model_configuration.ui_087",
  "model_configuration.ui_088",
  "model_configuration.ui_089",
  "model_configuration.ui_090",
  "model_configuration.ui_091",
  "model_configuration.ui_092",
  "model_configuration.ui_093",
  "model_configuration.ui_094",
  "model_configuration.ui_095",
  "model_configuration.ui_096",
  "model_configuration.ui_097",
  "model_configuration.ui_098",
  "model_configuration.ui_099",
  "model_configuration.ui_100",
  "model_configuration.ui_101",
  "model_configuration.ui_102",
  "model_configuration.ui_103",
  "model_configuration.ui_104",
  "model_configuration.ui_105",
  "model_configuration.ui_106",
  "model_configuration.ui_107",
  "model_configuration.ui_108",
  "model_configuration.ui_109",
  "model_configuration.ui_110",
  "model_configuration.ui_111",
  "model_configuration.ui_112",
  "model_configuration.ui_113",
  "model_configuration.ui_114",
  "model_configuration.ui_115",
  "model_configuration.ui_116",
  "model_configuration.ui_117",
  "model_configuration.ui_118",
  "model_configuration.ui_119",
  "model_configuration.ui_120",
  "model_configuration.ui_121",
  "model_configuration.ui_122",
  "model_configuration.ui_123",
  "model_configuration.ui_124",
  "model_configuration.ui_125",
  "model_configuration.ui_126",
  "model_configuration.ui_127",
  "model_configuration.ui_128",
  "model_configuration.ui_129",
  "model_configuration.ui_130",
  "model_configuration.ui_131",
  "model_configuration.ui_132",
  "model_configuration.ui_133",
  "model_configuration.ui_134",
  "model_configuration.ui_135",
  "model_configuration.ui_136",
  "model_configuration.ui_137",
  "model_configuration.ui_138",
  "model_configuration.ui_139",
  "model_configuration.ui_140",
  "model_configuration.ui_141",
  "model_configuration.ui_142",
  "model_configuration.ui_143",
  "model_configuration.ui_144",
  "model_configuration.ui_145",
  "model_configuration.ui_146",
  "model_configuration.ui_147",
  "model_configuration.ui_148",
  "model_configuration.ui_149",
  "model_configuration.ui_150",
  "model_configuration.ui_151",
  "model_configuration.ui_152",
  "model_configuration.ui_153",
  "model_configuration.ui_154",
  "model_configuration.ui_155",
  "model_configuration.ui_156",
  "model_configuration.ui_157",
  "model_configuration.ui_158",
  "model_configuration.ui_159",
  "model_configuration.ui_160",
  "model_configuration.ui_161",
  "model_configuration.ui_162",
  "model_configuration.ui_163",
  "model_configuration.ui_164",
  "model_configuration.ui_165",
  "model_configuration.ui_166",
  "model_configuration.ui_167",
  "model_configuration.ui_168",
  "model_configuration.ui_169",
  "model_configuration.ui_170",
  "model_configuration.ui_171",
  "model_configuration.ui_172",
  "model_configuration.ui_173",
  "model_configuration.ui_174",
  "model_configuration.ui_175",
  "model_configuration.ui_176",
  "model_configuration.ui_177",
  "model_configuration.ui_178",
  "model_configuration.ui_179",
  "model_configuration.ui_180",
  "model_configuration.ui_181",
  "model_configuration.ui_182",
  "model_configuration.ui_183",
  "model_configuration.ui_184",
  "model_configuration.ui_185",
  "model_configuration.ui_186",
  "model_configuration.ui_187",
  "model_configuration.ui_188",
  "model_configuration.ui_189",
  "model_configuration.ui_190",
  "model_configuration.ui_191",
  "model_configuration.ui_192",
  "model_configuration.ui_193",
  "model_configuration.ui_194",
  "model_configuration.ui_195",
  "model_configuration.ui_196",
  "model_configuration.ui_197",
  "model_configuration.ui_198",
  "model_configuration.ui_199",
  "model_configuration.ui_200",
  "model_configuration.ui_201",
  "model_configuration.ui_202",
  "model_configuration.ui_203",
  "model_configuration.ui_204",
  "model_configuration.ui_205",
  "model_configuration.ui_206",
  "model_configuration.ui_207",
  "model_configuration.ui_208",
  "model_configuration.ui_209",
  "model_configuration.ui_210",
  "model_configuration.ui_211",
  "model_configuration.ui_212",
  "model_configuration.ui_213",
  "model_configuration.ui_214",
  "model_configuration.ui_215",
  "model_configuration.ui_216",
  "model_configuration.ui_217",
  "model_configuration.ui_218",
  "model_configuration.ui_219",
  "model_configuration.ui_220",
  "model_configuration.ui_221",
  "model_configuration.ui_222",
  "model_configuration.ui_223",
  "model_configuration.ui_224",
  "model_configuration.ui_225",
  "model_configuration.ui_226",
  "model_configuration.ui_227",
  "model_configuration.ui_228",
  "model_configuration.ui_229",
  "model_configuration.ui_230",
  "model_configuration.ui_231",
  "model_configuration.ui_232",
  "model_configuration.ui_233",
  "model_configuration.ui_234",
  "model_configuration.ui_235",
  "model_configuration.ui_236",
  "model_configuration.ui_237",
  "model_configuration.ui_238",
  "model_configuration.ui_239",
  "model_configuration.ui_240",
  "model_configuration.ui_241",
  "model_configuration.ui_242",
  "model_configuration.ui_243",
  "model_configuration.ui_244",
  "model_configuration.ui_245",
  "model_configuration.ui_246",
  "model_configuration.ui_247",
  "model_configuration.ui_248",
  "model_configuration.ui_249",
  "model_configuration.ui_250",
  "model_configuration.ui_251",
  "model_configuration.ui_252",
  "model_configuration.ui_253",
  "model_configuration.ui_254",
  "model_configuration.unknown_value",
  "model_configuration.vision_label",
  "model_configuration.yes_value",
  "model_library.add_connection",
  "model_library.add_model",
  "model_library.api_key",
  "model_library.base_url",
  "model_library.cancel",
  "model_library.connection_disabled",
  "model_library.connection_enabled",
  "model_library.connection_name",
  "model_library.connection_name_placeholder",
  "model_library.connections",
  "model_library.create",
  "model_library.empty_connections",
  "model_library.empty_models",
  "model_library.form_error",
  "model_library.key_hint",
  "model_library.model_disabled",
  "model_library.model_enabled",
  "model_library.model_id",
  "model_library.model_id_placeholder",
  "model_library.model_name",
  "model_library.model_name_placeholder",
  "model_library.models",
  "model_library.platform.ark_connection",
  "model_library.platform.ark_monthly_connection",
  "model_library.platform.deepseek_connection",
  "model_library.platform.model_ark_code",
  "model_library.platform.model_deepseek_flash",
  "model_library.platform.model_doubao",
  "model_library.platform.model_doubao_speech_mini",
  "model_library.platform.model_glm",
  "model_library.platform.model_kimi",
  "model_library.platform.model_seed_asr_file",
  "model_library.platform.model_seed_asr_stream",
  "model_library.platform.openspeech_connection",
  "model_library.probe",
  "model_library.probe_error",
  "model_library.probe_hint",
  "model_library.protocol",
  "model_library.protocol.anthropic",
  "model_library.protocol.bedrock",
  "model_library.protocol.openai",
  "model_library.provider",
  "model_library.provider_hint",
  "model_library.save_error",
  "model_library.scope.account",
  "model_library.status.disabled",
  "model_library.status.failed",
  "model_library.status.unverified",
  "model_library.status.verified",
  "model_library.subtitle",
  "model_library.title",
  "model_runtime.agent.backend",
  "model_runtime.agent.design",
  "model_runtime.agent.frontend",
  "model_runtime.agent.ops",
  "model_runtime.agent.product",
  "model_runtime.agent.project",
  "model_runtime.agent.review",
  "model_runtime.agent.test",
  "model_runtime.module.code_review_description",
  "model_runtime.module.code_review_name",
  "model_runtime.module.code_review_note",
  "model_runtime.module.conversation_memory_description",
  "model_runtime.module.conversation_memory_name",
  "model_runtime.module.conversation_memory_note",
  "model_runtime.module.development_orchestration_description",
  "model_runtime.module.development_orchestration_name",
  "model_runtime.module.development_orchestration_note",
  "model_runtime.module.document_content_description",
  "model_runtime.module.document_content_name",
  "model_runtime.module.document_content_note",
  "model_runtime.module.lulu_reasoning_description",
  "model_runtime.module.lulu_reasoning_name",
  "model_runtime.module.lulu_reasoning_not_usable",
  "model_runtime.module.lulu_reasoning_not_wired",
  "model_runtime.module.lulu_reasoning_note",
  "model_runtime.module.multimodal_description",
  "model_runtime.module.multimodal_name",
  "model_runtime.module.multimodal_note",
  "model_runtime.module.patch_generation_description",
  "model_runtime.module.patch_generation_name",
  "model_runtime.module.patch_generation_note",
  "model_runtime.module.product_inspection_description",
  "model_runtime.module.product_inspection_name",
  "model_runtime.module.product_inspection_note",
  "model_runtime.module.task_planning_description",
  "model_runtime.module.task_planning_name",
  "model_runtime.module.task_planning_not_wired",
  "model_runtime.module.task_planning_note",
  "model_runtime.provider.agent_plan_catalog_hint",
  "model_runtime.provider.api_key",
  "model_runtime.provider.api_key_manual_models",
  "model_runtime.provider.bedrock_auth_hint",
  "model_runtime.provider.bedrock_base_hint",
  "model_runtime.provider.custom_hint",
  "model_runtime.provider.custom_name",
  "model_runtime.provider.huawei_hint",
  "model_runtime.provider.huawei_name",
  "model_runtime.provider.manual_catalog_hint",
  "model_runtime.provider.plan_catalog_hint",
  "model_runtime.provider.public_catalog_hint",
  "model_runtime.provider.tencent_hint",
  "model_runtime.provider.tencent_name",
  "model_runtime.provider.tencent_token_plan_hint",
  "model_runtime.provider.tencent_token_plan_name",
  "model_runtime.provider.tencent_tokenhub_hint",
  "model_runtime.provider.tencent_tokenhub_name",
  "model_runtime.provider.volcengine_agent_plan_hint",
  "model_runtime.provider.volcengine_agent_plan_name",
  "model_runtime.provider.volcengine_coding_plan_hint",
  "model_runtime.provider.volcengine_coding_plan_name",
  "model_runtime.provider.volcengine_hint",
  "model_runtime.provider.volcengine_name",
  "model_runtime.provider.volcengine_openspeech_hint",
  "model_runtime.provider.volcengine_openspeech_name",
  "model_runtime.provider.zhipu_coding_plan_hint",
  "model_runtime.provider.zhipu_coding_plan_name",
  "model_runtime.provider.zhipu_hint",
  "model_runtime.provider.zhipu_name",
  "nav.account",
  "nav.account.appearance",
  "nav.account.appearance.follow",
  "nav.account.billing",
  "nav.account.lang",
  "nav.account.logout",
  "nav.account.me",
  "nav.account.mobile.account",
  "nav.account.mobile.lang",
  "nav.account.mobile.prefs",
  "nav.account.session",
  "nav.account.session.password",
  "nav.account.settings",
  "nav.account.shortcuts",
  "nav.account.shortcuts.hint",
  "nav.account.team",
  "nav.account.team.hint",
  "nav.alert",
  "nav.auth",
  "nav.bridge",
  "nav.bug_reports",
  "nav.chat",
  "nav.code",
  "nav.common.loading",
  "nav.dash",
  "nav.duty",
  "nav.hosts",
  "nav.inbox.alert.open",
  "nav.inbox.approval",
  "nav.inbox.empty",
  "nav.inbox.title",
  "nav.inbox.view.all",
  "nav.memo",
  "nav.models",
  "nav.more",
  "nav.more.group.modules",
  "nav.new_session",
  "nav.notification",
  "nav.onboard",
  "nav.project",
  "nav.project.loading",
  "nav.project_tabs",
  "nav.ptab.activity",
  "nav.ptab.chat",
  "nav.ptab.env",
  "nav.ptab.memo",
  "nav.ptab.overview",
  "nav.ptab.release",
  "nav.ptab.resources",
  "nav.ptab.tasks",
  "nav.search.everything",
  "nav.search.group.hosts",
  "nav.search.group.memos",
  "nav.search.group.projects",
  "nav.search.group.timeline",
  "nav.search.hint",
  "nav.search.hint.all",
  "nav.search.none",
  "nav.search.placeholder",
  "nav.sec",
  "nav.server",
  "nav.shortcuts.group.global",
  "nav.shortcuts.group.memo",
  "nav.shortcuts.yield.note",
  "nav.skills",
  "nav.status.idle",
  "nav.status.running",
  "nav.status.unknown",
  "nav.team",
  "nav.theme.current",
  "nav.theme.dark",
  "nav.theme.light",
  "nav.theme.quick.hint",
  "nav.theme.switch",
  "nav.timeline",
  "nav.today.card.night",
  "nav.today.card.night.body",
  "nav.today.card.running",
  "nav.today.card.waiting",
  "nav.today.count.items",
  "nav.today.empty.running",
  "nav.today.empty.waiting",
  "nav.today.error.title",
  "nav.today.freshness",
  "nav.today.link.alerts",
  "nav.today.link.all_activity",
  "nav.today.link.inbox",
  "nav.today.link.night",
  "nav.today.link.timeline",
  "nav.today.overview.all",
  "nav.today.overview.night",
  "nav.today.overview.night.failed",
  "nav.today.overview.running",
  "nav.today.overview.waiting",
  "nav.today.page.title",
  "nav.today.waiting.headline",
  "nav.vendor",
  "onboarding.action.start",
  "onboarding.error.auth_failed",
  "onboarding.error.host_key_changed",
  "onboarding.error.key_passphrase",
  "onboarding.error.key_unreadable",
  "onboarding.error.no_credential",
  "onboarding.error.port_closed",
  "onboarding.error.refused",
  "onboarding.error.timeout",
  "onboarding.guess.confirm",
  "onboarding.guess.heading",
  "onboarding.guess.name",
  "onboarding.guess.reason",
  "onboarding.guess.rename",
  "onboarding.guess.unknown",
  "onboarding.missing.address",
  "onboarding.missing.secret",
  "onboarding.missing.username",
  "onboarding.page.subtitle",
  "onboarding.page.title",
  "onboarding.passphrase.placeholder",
  "onboarding.paste.note",
  "onboarding.paste.placeholder",
  "onboarding.probe.connect.detail",
  "onboarding.probe.connect.done",
  "onboarding.probe.fingerprint.detail",
  "onboarding.probe.fingerprint.done",
  "onboarding.probe.heading",
  "onboarding.probe.install_agent.detail",
  "onboarding.probe.install_agent.running",
  "onboarding.probe.security_check.detail",
  "onboarding.probe.security_check.narrowed",
  "onboarding.probe.takeover_key.detail",
  "onboarding.probe.takeover_key.done",
  "onboarding.step.hands_off.body",
  "onboarding.step.hands_off.title",
  "onboarding.step.identify.body",
  "onboarding.step.identify.title",
  "onboarding.step.paste.title",
  "onboarding.takeover.extra_lines_removed",
  "ops_backup.drill.confirm.body",
  "ops_backup.drill.confirm.title",
  "ops_backup.drill.cta",
  "ops_backup.drill.database",
  "ops_backup.drill.explain",
  "ops_backup.drill.heading",
  "ops_backup.drill.last.success",
  "ops_backup.drill.none",
  "ops_backup.drill.not_restorable",
  "ops_backup.executor.missing",
  "ops_backup.executor.ok",
  "ops_backup.executor.queued_but_offline",
  "ops_backup.executor.stale",
  "ops_backup.failure.checksum_mismatch",
  "ops_backup.failure.disk_full",
  "ops_backup.failure.dump_failed",
  "ops_backup.failure.locked",
  "ops_backup.failure.restore_failed",
  "ops_backup.failure.unknown",
  "ops_backup.history.by",
  "ops_backup.history.by.schedule",
  "ops_backup.history.empty",
  "ops_backup.history.heading",
  "ops_backup.history.kind.backup",
  "ops_backup.history.kind.restore_drill",
  "ops_backup.history.status.failed",
  "ops_backup.history.status.queued",
  "ops_backup.history.status.running",
  "ops_backup.history.status.succeeded",
  "ops_backup.history.stepup",
  "ops_backup.history.took",
  "ops_backup.last.failure",
  "ops_backup.last.failure.none",
  "ops_backup.last.success",
  "ops_backup.last.success.none",
  "ops_backup.page.subtitle",
  "ops_backup.page.title",
  "ops_backup.plan.destination",
  "ops_backup.plan.heading",
  "ops_backup.plan.next",
  "ops_backup.plan.next.unknown",
  "ops_backup.plan.none",
  "ops_backup.plan.reported",
  "ops_backup.plan.retention",
  "ops_backup.plan.schedule",
  "ops_backup.run.busy",
  "ops_backup.run.cta",
  "ops_backup.run.forbidden",
  "ops_backup.run.queued",
  "ops_backup.snapshot.size",
  "ops_backup.state.heading",
  "ops_backup.state.idle",
  "ops_backup.state.queued",
  "ops_backup.state.running",
  "ops_backup.state.running.drill",
  "pjhub.action.create",
  "pjhub.action.retry",
  "pjhub.builtin",
  "pjhub.col.activity",
  "pjhub.col.env",
  "pjhub.col.health",
  "pjhub.col.name",
  "pjhub.col.recent_release",
  "pjhub.col.recent_task",
  "pjhub.col.resource",
  "pjhub.empty.body",
  "pjhub.empty.title",
  "pjhub.error.body",
  "pjhub.error.title",
  "pjhub.filter.all",
  "pjhub.filter.empty",
  "pjhub.filter.needs_attention",
  "pjhub.filter.unverified",
  "pjhub.loading.hint",
  "pjhub.loading.title",
  "pjhub.new.name",
  "pjhub.new.slug",
  "pjhub.new.submitting",
  "pjhub.new.subtitle",
  "pjhub.new.title",
  "pjhub.notice.missing_fields.body",
  "pjhub.notice.not_switcher.body",
  "pjhub.notice.not_switcher.title",
  "pjhub.notice.unverified.body",
  "pjhub.notice.unverified.title",
  "pjhub.notice.unverified.why",
  "pjhub.resource.has",
  "pjhub.resource.none",
  "pjhub.search.placeholder",
  "pjhub.sort.hint",
  "pjhub.stat.healthy",
  "pjhub.stat.needs_attention",
  "pjhub.stat.projects",
  "pjhub.stat.running_releases",
  "pjhub.stat.running_tasks",
  "pjhub.subtitle",
  "pjhub.subtitle.unverified",
  "pjhub.title",
  "pjhub.value.unverified",
  "pjshell.capacity.cpu",
  "pjshell.capacity.disk",
  "pjshell.capacity.expiry",
  "pjshell.capacity.host",
  "pjshell.capacity.memory",
  "pjshell.chat.attach",
  "pjshell.chat.attach.blocked",
  "pjshell.chat.can.assign",
  "pjshell.chat.can.assign.body",
  "pjshell.chat.can.auto",
  "pjshell.chat.can.auto.body",
  "pjshell.chat.can.send",
  "pjshell.chat.can.send.body",
  "pjshell.chat.can.status",
  "pjshell.chat.can.status.body",
  "pjshell.chat.can.title",
  "pjshell.chat.can.value",
  "pjshell.chat.cannot.manage",
  "pjshell.chat.cannot.manage.body",
  "pjshell.chat.cannot.orch",
  "pjshell.chat.cannot.orch.body",
  "pjshell.chat.cannot.other",
  "pjshell.chat.cannot.other.body",
  "pjshell.chat.cannot.switcher",
  "pjshell.chat.cannot.switcher.body",
  "pjshell.chat.cannot.title",
  "pjshell.chat.cannot.value",
  "pjshell.chat.context",
  "pjshell.chat.current",
  "pjshell.chat.open_full",
  "pjshell.chat.placeholder",
  "pjshell.chat.split",
  "pjshell.chat.subtitle",
  "pjshell.chat.voice.blocked",
  "pjshell.env.address",
  "pjshell.env.certificate.stored",
  "pjshell.env.col.cert",
  "pjshell.env.col.expiry",
  "pjshell.env.col.point",
  "pjshell.env.col.resolve",
  "pjshell.env.col.state",
  "pjshell.env.configure",
  "pjshell.env.configure.body",
  "pjshell.env.configure.domain",
  "pjshell.env.configure.done",
  "pjshell.env.configure.files",
  "pjshell.env.configure.files_hint",
  "pjshell.env.configure.machine",
  "pjshell.env.configure.pick",
  "pjshell.env.configure.pick_folder",
  "pjshell.env.configure.ready",
  "pjshell.env.configure.submit",
  "pjshell.env.configure.target",
  "pjshell.env.configure.title",
  "pjshell.env.domain.registered",
  "pjshell.env.domain.verified",
  "pjshell.env.domain.waiting",
  "pjshell.env.domains",
  "pjshell.env.group",
  "pjshell.env.machine",
  "pjshell.env.no_bundle",
  "pjshell.env.open",
  "pjshell.env.probe",
  "pjshell.env.production",
  "pjshell.env.production.title",
  "pjshell.env.promote",
  "pjshell.env.promote.body",
  "pjshell.env.promote.note",
  "pjshell.env.promote.title",
  "pjshell.env.rollback",
  "pjshell.env.status.failed",
  "pjshell.env.status.ready",
  "pjshell.env.status.rolled_back",
  "pjshell.env.subtitle",
  "pjshell.env.test",
  "pjshell.env.test.title",
  "pjshell.env.version",
  "pjshell.env.when",
  "pjshell.env.who",
  "pjshell.fact.uncollected",
  "pjshell.fact.unconfigured",
  "pjshell.fact.unknown",
  "pjshell.memo.empty",
  "pjshell.memo.voice.blocked",
  "pjshell.overview.capacity",
  "pjshell.overview.card.entry",
  "pjshell.overview.card.lives",
  "pjshell.overview.card.publish",
  "pjshell.overview.decide",
  "pjshell.overview.decide.action",
  "pjshell.overview.decide.body",
  "pjshell.overview.env",
  "pjshell.overview.events",
  "pjshell.overview.feed",
  "pjshell.overview.feed.note",
  "pjshell.overview.go_env",
  "pjshell.overview.go_release",
  "pjshell.overview.go_resources",
  "pjshell.overview.go_tasks",
  "pjshell.overview.health",
  "pjshell.overview.last_release",
  "pjshell.overview.live.note",
  "pjshell.overview.live_version",
  "pjshell.overview.no_resource_issue",
  "pjshell.overview.now",
  "pjshell.overview.release",
  "pjshell.overview.resource_issues",
  "pjshell.overview.subtitle",
  "pjshell.overview.takeover",
  "pjshell.overview.tasks",
  "pjshell.overview.watch",
  "pjshell.overview.working",
  "pjshell.overview.working.empty",
  "pjshell.overview.working.note",
  "pjshell.pending_item",
  "pjshell.readiness.agent_only",
  "pjshell.readiness.awaiting_heartbeat",
  "pjshell.readiness.check_failed",
  "pjshell.readiness.complete",
  "pjshell.readiness.continue",
  "pjshell.readiness.details",
  "pjshell.readiness.execution",
  "pjshell.readiness.execution_failed",
  "pjshell.readiness.heartbeat",
  "pjshell.readiness.install_failed",
  "pjshell.readiness.install_timeout",
  "pjshell.readiness.installer_unavailable",
  "pjshell.readiness.pending",
  "pjshell.readiness.ready",
  "pjshell.readiness.registered",
  "pjshell.readiness.running",
  "pjshell.readiness.scope",
  "pjshell.readiness.ssh_unavailable",
  "pjshell.readiness.validity",
  "pjshell.readiness.verify",
  "pjshell.readiness.waiting",
  "pjshell.release.app",
  "pjshell.release.checking",
  "pjshell.release.col.actions",
  "pjshell.release.col.last",
  "pjshell.release.col.name",
  "pjshell.release.col.size",
  "pjshell.release.col.status",
  "pjshell.release.col.url",
  "pjshell.release.col.version",
  "pjshell.release.drop",
  "pjshell.release.drop.choose",
  "pjshell.release.drop.empty",
  "pjshell.release.drop.hint",
  "pjshell.release.drop.new_site",
  "pjshell.release.duration",
  "pjshell.release.failed",
  "pjshell.release.live",
  "pjshell.release.live_now",
  "pjshell.release.none",
  "pjshell.release.open",
  "pjshell.release.previous",
  "pjshell.release.primary_now",
  "pjshell.release.progress",
  "pjshell.release.publishing",
  "pjshell.release.replace",
  "pjshell.release.rollbacks",
  "pjshell.release.see_failure",
  "pjshell.release.sites",
  "pjshell.release.static",
  "pjshell.release.step.check",
  "pjshell.release.step.live.note",
  "pjshell.release.step.publish",
  "pjshell.release.step.verify",
  "pjshell.release.step.verify.note",
  "pjshell.release.steps",
  "pjshell.release.subtitle",
  "pjshell.release.today",
  "pjshell.release.verifying",
  "pjshell.release.verifying.public",
  "pjshell.release.version",
  "pjshell.release.what",
  "pjshell.release.who",
  "pjshell.release.who_when",
  "pjshell.resource.add_one",
  "pjshell.resource.address",
  "pjshell.resource.assign_idle",
  "pjshell.resource.assign_to_project",
  "pjshell.resource.cert",
  "pjshell.resource.col.actions",
  "pjshell.resource.col.capacity",
  "pjshell.resource.col.cert",
  "pjshell.resource.col.entry",
  "pjshell.resource.col.env",
  "pjshell.resource.col.expiry",
  "pjshell.resource.col.host",
  "pjshell.resource.col.owner",
  "pjshell.resource.col.point",
  "pjshell.resource.col.spec",
  "pjshell.resource.col.type",
  "pjshell.resource.col.vendor",
  "pjshell.resource.domain",
  "pjshell.resource.domains",
  "pjshell.resource.empty.body",
  "pjshell.resource.empty.title",
  "pjshell.resource.exclusive",
  "pjshell.resource.go_cert",
  "pjshell.resource.go_dns",
  "pjshell.resource.network",
  "pjshell.resource.physical",
  "pjshell.resource.pool",
  "pjshell.resource.shared",
  "pjshell.resource.split",
  "pjshell.resource.storage",
  "pjshell.resource.subtitle",
  "pjshell.resource.title",
  "pjshell.resource.unassign",
  "pjshell.resource.unassign.body",
  "pjshell.resource.unassign.confirm",
  "pjshell.resource.unassign.last_prod",
  "pjshell.resource.unassign.title",
  "pjshell.resource.vendor",
  "pjshell.takeover.none",
  "pjshell.task.col.elapsed",
  "pjshell.task.col.files",
  "pjshell.task.col.name",
  "pjshell.task.col.source",
  "pjshell.task.col.state",
  "pjshell.task.col.who",
  "pjshell.task.elapsed",
  "pjshell.task.empty",
  "pjshell.task.filter.all",
  "pjshell.task.filter.assignee",
  "pjshell.task.filter.assignee.placeholder",
  "pjshell.task.filter.decide",
  "pjshell.task.filter.done",
  "pjshell.task.filter.failed",
  "pjshell.task.filter.running",
  "pjshell.task.filter.updated",
  "pjshell.task.filter.updated.any",
  "pjshell.task.filter.updated.hour",
  "pjshell.task.filter.updated.today",
  "pjshell.task.filter.updated.week",
  "pjshell.task.search.placeholder",
  "pjshell.task.sort.hint",
  "pjshell.task.source.lulu",
  "pjshell.task.source.user",
  "pjshell.task.stale",
  "pjshell.task.subtitle",
  "pjshell.task.write",
  "pjshell.unverified",
  "project.action.add_new_host",
  "project.action.all_records",
  "project.action.assign_host",
  "project.action.create",
  "project.action.open_public_entry",
  "project.archived",
  "project.assign.idle_empty",
  "project.assign.idle_heading",
  "project.assign.idle_loading",
  "project.builtin.public_infra.name",
  "project.builtin.public_infra.summary",
  "project.detail.breadcrumb",
  "project.empty.no_host",
  "project.empty.no_host.detail",
  "project.env.promote.no_digest",
  "project.env.promote.not_verified",
  "project.env.promote.wrong_kind",
  "project.env.rollback.no_target",
  "project.error.builtin_undeletable",
  "project.error.host_exclusive",
  "project.error.name_blank",
  "project.error.slug_taken",
  "project.feed.empty",
  "project.feed.loading",
  "project.health.all_good",
  "project.health.host_trouble",
  "project.health.label",
  "project.health.publish_failed",
  "project.list.empty.body",
  "project.list.empty.title",
  "project.local_vs_platform.heading",
  "project.local_vs_platform.how_you_know",
  "project.local_vs_platform.pending_count",
  "project.local_vs_platform.tag",
  "project.mixed_tenancy_warning",
  "project.restored",
  "project.section.feed",
  "project.section.public_entry",
  "project.section.tasks",
  "project.section.where_it_lives",
  "project.summary.ai_written_hint",
  "project_import.action.approve",
  "project_import.action.start",
  "project_import.action.unlink",
  "project_import.approve.hint",
  "project_import.approve.no_selectable",
  "project_import.approve.submitting",
  "project_import.approve.vendor_usage",
  "project_import.assignee.assigning",
  "project_import.assignee.create_one_time",
  "project_import.assignee.import_identity_name",
  "project_import.assignee.import_only_prompt",
  "project_import.assignee.one_time_hint",
  "project_import.assignee.one_time_title",
  "project_import.assignee.regenerate_one_time",
  "project_import.assignee.source_locked",
  "project_import.card.audit",
  "project_import.card.open",
  "project_import.card.source_label",
  "project_import.card.title",
  "project_import.card.unavailable",
  "project_import.conflict.deployment_ref",
  "project_import.conflict.domain_vendor",
  "project_import.conflict.host",
  "project_import.conflict.ownership_subject",
  "project_import.conflict.project",
  "project_import.conflict.repository",
  "project_import.conflict.subscription",
  "project_import.conflict.subscription_due",
  "project_import.conflict.subscription_vendor",
  "project_import.conflict.vendor",
  "project_import.deployment.derived",
  "project_import.domain.no_record",
  "project_import.error.conflict_selected",
  "project_import.error.extra_fields",
  "project_import.error.host_missing",
  "project_import.error.idempotency_mismatch",
  "project_import.error.not_ready",
  "project_import.error.not_reviewed",
  "project_import.error.nothing_linked",
  "project_import.error.nothing_selected",
  "project_import.error.reissue_conflict",
  "project_import.error.secrets",
  "project_import.error.source_not_resendable",
  "project_import.error.token_expired",
  "project_import.error.token_used",
  "project_import.error.unknown_schema",
  "project_import.error.vendor_conflict",
  "project_import.evidence.ai_declared",
  "project_import.evidence.conflict",
  "project_import.evidence.inventory_matched",
  "project_import.evidence.missing",
  "project_import.evidence.platform_verified",
  "project_import.grades.title",
  "project_import.idle.not_reusable",
  "project_import.kind.deployment",
  "project_import.kind.domain",
  "project_import.kind.endpoint",
  "project_import.kind.host",
  "project_import.kind.ownership",
  "project_import.kind.project",
  "project_import.kind.repository",
  "project_import.kind.subscription",
  "project_import.kind.unknown",
  "project_import.kind.vendor",
  "project_import.links.before_ledger",
  "project_import.links.created_entity_conditional",
  "project_import.links.empty",
  "project_import.links.pre_existing",
  "project_import.links.released",
  "project_import.links.title",
  "project_import.ownership.dashboard_account",
  "project_import.ownership.deploy_history",
  "project_import.ownership.derived",
  "project_import.ownership.dns_record",
  "project_import.ownership.other",
  "project_import.ownership.repo_write",
  "project_import.ownership.ssh_login",
  "project_import.package.reissue",
  "project_import.package.reissue_hint",
  "project_import.package.reissuing",
  "project_import.project.seed_summary",
  "project_import.prompt.body",
  "project_import.prompt.copied",
  "project_import.prompt.copy",
  "project_import.prompt.copy_failed",
  "project_import.prompt.hidden",
  "project_import.prompt.once",
  "project_import.prompt.path_label",
  "project_import.prompt.title",
  "project_import.prompt.token_label",
  "project_import.renewal.due",
  "project_import.renewal.none",
  "project_import.renewal.today",
  "project_import.review.empty",
  "project_import.review.title",
  "project_import.review.waiting",
  "project_import.source.awaiting",
  "project_import.source.awaiting_assignee",
  "project_import.source.candidate",
  "project_import.source.claimed_hint",
  "project_import.source.imported",
  "project_import.source.importing",
  "project_import.source.needs_rebase",
  "project_import.source.repository",
  "project_import.source.resend_hint",
  "project_import.source.retry",
  "project_import.source.retrying",
  "project_import.source.setup_failed",
  "project_import.source.status_unavailable",
  "project_import.source.title",
  "project_import.status.approved",
  "project_import.status.awaiting_package",
  "project_import.status.reviewed",
  "project_import.subscription.no_due",
  "project_import.summary.counts",
  "project_import.unlink.hint",
  "project_import.unlink.submitting",
  "project_import.wizard.draft_ready",
  "project_import.wizard.name",
  "project_import.wizard.submit",
  "project_import.wizard.submitting",
  "project_import.wizard.subtitle",
  "project_import.wizard.title",
  "remedy.backup.check_job",
  "remedy.cert.renew",
  "remedy.disk.clean_docker",
  "remedy.disk.clean_old_logs",
  "remedy.disk.look_at_big_files",
  "remedy.load.look_at_top",
  "remedy.no_suggestion",
  "remedy.port.check_listener",
  "remedy.process.restart",
  "repo.conflict.clear",
  "repo.conflict.deferred",
  "repo.gate.blocked.our_environment",
  "repo.gate.blocked.platform_stopped",
  "repo.gate.deployed",
  "repo.gate.held",
  "repo.gate.needs_you",
  "repo.gate.passed",
  "repo.gate.pending",
  "repo.gate.redline.hit",
  "repo.gate.redline.no_tests",
  "repo.gate.rejected",
  "repo.gate.rejected.plain",
  "repo.gate.rejected.secret",
  "repo.gate.rejected.size",
  "repo.gate.rejected.spread",
  "repo.gate.rejected.tests",
  "repo.gate.rejected.tests_unknown_count",
  "repo.npcmd.branch_line",
  "repo.npcmd.intro",
  "repo.npcmd.never_touch_main",
  "repo.npcmd.online_unknown",
  "repo.npcmd.online_version",
  "repo.npcmd.pending_count",
  "repo.npcmd.pending_none",
  "repo.npcmd.title",
  "repo.npcmd.touched_files",
  "repo.push.accepted",
  "repo.push.branch_rejected",
  "repo.push.delete_rejected",
  "repo.push.forward_conflict",
  "repo.push.forward_rejected",
  "repo.push.forwarded",
  "repo.push.held_no_remote",
  "repo.push.ref_rejected",
  "repo.push.tag_rejected",
  "repo.redline.credentials",
  "repo.redline.data_delete",
  "repo.redline.money",
  "repo.redline.permission",
  "sec.clean",
  "sec.count.fixed",
  "sec.count.must_fix",
  "sec.count.when_free",
  "sec.empty",
  "sec.level.fixed",
  "sec.level.must_fix",
  "sec.level.when_free",
  "sec.no_firewall.explanation",
  "sec.no_firewall.suggestion",
  "sec.no_firewall.title",
  "sec.page.subtitle",
  "sec.page.title",
  "sec.password_login_enabled.explanation",
  "sec.password_login_enabled.suggestion",
  "sec.password_login_enabled.title",
  "sec.pending_security_updates.explanation",
  "sec.pending_security_updates.suggestion",
  "sec.pending_security_updates.title",
  "sec.risk.model_unsure",
  "sec.root_password_login.explanation",
  "sec.root_password_login.suggestion",
  "sec.root_password_login.title",
  "sec.score.label",
  "sec.ssh_open_to_world.explanation",
  "sec.ssh_open_to_world.suggestion",
  "sec.ssh_open_to_world.title",
  "split.action.preview",
  "split.action.preview_only",
  "split.capacity.reason.child_host",
  "split.capacity.reason.has_capacity",
  "split.capacity.reason.incomplete",
  "split.capacity.reason.unknown_carvable",
  "split.card.body",
  "split.card.title",
  "split.exposure.domain",
  "split.exposure.internal_only",
  "split.exposure.ip_port",
  "split.model.degraded.rule",
  "split.name.backend",
  "split.name.database",
  "split.name.default_project",
  "split.name.spare",
  "split.plan.cannot",
  "split.plan.headline",
  "split.plan.why_not_more",
  "split.posture.balanced",
  "split.posture.conservative",
  "split.posture.dense",
  "split.posture.heading",
  "split.posture.minimal",
  "split.preview.provenance.by_ai",
  "split.preview.provenance.by_rule",
  "split.preview.provenance.heading",
  "split.reason.capacity",
  "split.reason.no_context",
  "split.reason.project_count",
  "split.requirement.placeholder",
  "split.runtime.kvm.database",
  "split.runtime.lxc.default",
  "split.size.lt_one_g",
  "split.size.some",
  "split.slice.reason.database",
  "split.slice.reason.project",
  "split.slice.reason.spare",
  "split.state.empty",
  "split.state.pending",
  "split.validation.accepted",
  "split.validation.adjusted",
  "split.validation.rejected",
  "split_exec.blocked.busy",
  "split_exec.blocked.no_executor",
  "split_exec.blocked.plan_rejected",
  "split_exec.blocked.plan_stale",
  "split_exec.cause.carve_slice",
  "split_exec.confirm.red",
  "split_exec.undo.manual",
  "static_site.account.empty",
  "static_site.account.loading",
  "static_site.create.slug_invalid",
  "static_site.create.slug_label",
  "static_site.create.slug_placeholder",
  "static_site.create.submit",
  "static_site.create.title_label",
  "static_site.create.title_placeholder",
  "static_site.drop.busy",
  "static_site.drop.done",
  "static_site.drop.hint",
  "static_site.drop.label",
  "static_site.drop.update_label",
  "static_site.empty",
  "static_site.live.active",
  "static_site.live.failed",
  "static_site.live.none",
  "static_site.live.pending",
  "static_site.live.superseded",
  "static_site.live.title",
  "static_site.loading",
  "static_site.name.label",
  "static_site.name.save",
  "static_site.name.saved",
  "static_site.name.url_is_fixed",
  "static_site.preview.again",
  "static_site.preview.expired",
  "static_site.preview.expires_at",
  "static_site.preview.failed",
  "static_site.preview.hint",
  "static_site.preview.none",
  "static_site.preview.open",
  "static_site.preview.revoke",
  "static_site.preview.revoked",
  "static_site.preview.title",
  "static_site.publish.action",
  "static_site.publish.approval_ask",
  "static_site.publish.approval_asking",
  "static_site.publish.approval_expired",
  "static_site.publish.approval_got",
  "static_site.publish.approval_hint",
  "static_site.publish.approval_label",
  "static_site.publish.approval_not_a_grant",
  "static_site.publish.busy",
  "static_site.publish.reason_label",
  "static_site.publish.reason_placeholder",
  "static_site.receipt.artifact",
  "static_site.receipt.health_failed",
  "static_site.receipt.health_passed",
  "static_site.receipt.health_pending",
  "static_site.receipt.health_unknown",
  "static_site.receipt.rollback_none",
  "static_site.receipt.rollback_to",
  "static_site.receipt.toggle",
  "static_site.rollback.action",
  "static_site.rollback.busy",
  "static_site.section.hint",
  "static_site.section.title",
  "static_site.status.active",
  "static_site.status.offlined",
  "static_site.status.suspended",
  "static_site.upload.busy",
  "static_site.upload.done_with_preview",
  "static_site.upload.hint",
  "static_site.upload.label",
  "static_site.url_hint",
  "static_site.versions.empty",
  "static_site.versions.row",
  "static_site.versions.title",
  "steward.brief.action.go_to_plan",
  "steward.brief.action.ignore",
  "steward.brief.action.later",
  "steward.brief.action.mute",
  "steward.brief.action.schedule",
  "steward.brief.action.why",
  "steward.brief.already_today",
  "steward.brief.context_read",
  "steward.brief.decided.ignore",
  "steward.brief.decided.later",
  "steward.brief.decided.mute",
  "steward.brief.decided.scheduled",
  "steward.brief.decisions",
  "steward.brief.decisions_none",
  "steward.brief.decisions_stale",
  "steward.brief.finding_line",
  "steward.brief.findings_head",
  "steward.brief.findings_none",
  "steward.brief.footer",
  "steward.brief.headline",
  "steward.brief.inspection_skipped",
  "steward.brief.item.count",
  "steward.brief.item.finding",
  "steward.brief.item.proposal",
  "steward.brief.memory_candidates",
  "steward.brief.mentions_of_you",
  "steward.brief.proposal_line",
  "steward.brief.proposal_posted",
  "steward.brief.proposals_head",
  "steward.brief.proposals_none",
  "steward.brief.releases",
  "steward.brief.releases_none",
  "steward.brief.schedule_request",
  "steward.brief.scheduled",
  "steward.chat.acceptance",
  "steward.chat.account_scope_only",
  "steward.chat.degraded",
  "steward.chat.model_auth_hold",
  "steward.chat.model_down_hold",
  "steward.chat.needs_you",
  "steward.chat.no_one_free",
  "steward.chat.paused_hold",
  "steward.chat.plan_only",
  "steward.chat.plan_only_asked",
  "steward.chat.plan_unavailable",
  "steward.chat.start_failed",
  "steward.chat.started",
  "steward.chat.started_partial",
  "steward.chat.working",
  "steward.finding.acceptance",
  "steward.finding.context_read",
  "steward.finding.none",
  "steward.finding.objective",
  "steward.finding.restate",
  "steward.item.title",
  "steward.memory.todo_summary",
  "steward.memory.todo_why",
  "steward.reason.green_auto",
  "steward.reason.invalid_permission",
  "steward.reason.invalid_request",
  "steward.reason.observe_only",
  "steward.reason.read_only",
  "steward.reason.red_action",
  "steward.reason.rollback_bounded_auto",
  "steward.reason.suggest_only",
  "steward.reason.yellow_not_authorized",
  "steward.remote_ai.card_hint",
  "steward.remote_ai.card_title",
  "steward.remote_ai.copy_link",
  "steward.remote_ai.copy_link_done",
  "steward.remote_ai.copy_prompt",
  "steward.remote_ai.copy_prompt_done",
  "steward.remote_ai.dont_close",
  "steward.remote_ai.duration_180d",
  "steward.remote_ai.duration_30d",
  "steward.remote_ai.duration_90d",
  "steward.remote_ai.duration_long_term",
  "steward.remote_ai.edit",
  "steward.remote_ai.failed",
  "steward.remote_ai.field_duration",
  "steward.remote_ai.field_model",
  "steward.remote_ai.field_name",
  "steward.remote_ai.field_provider",
  "steward.remote_ai.issue",
  "steward.remote_ai.issuing",
  "steward.remote_ai.link_label",
  "steward.remote_ai.once",
  "steward.remote_ai.prompt_label",
  "steward.role.backend",
  "steward.role.frontend",
  "steward.role.qa",
  "steward.role.release",
  "steward.role.research",
  "steward.role.reviewer",
  "steward.role.steward",
  "steward.run.compose_failed",
  "steward.run.step.stopped_cancelled",
  "steward.run.step.stopped_clock",
  "steward.run.step.stopped_steps",
  "steward.run.step.stopped_tokens",
  "steward.run.stopped.cancelled",
  "steward.run.stopped.limit",
  "steward.skill.deepinspect.step.read_findings",
  "steward.skill.deepinspect.step.report",
  "steward.skill.deepinspect.what",
  "steward.skill.disabled",
  "steward.skill.diskforecast.step.extrapolate",
  "steward.skill.diskforecast.step.take_samples",
  "steward.skill.diskforecast.what",
  "steward.skill.every.hours",
  "steward.skill.every.minutes",
  "steward.skill.every.seconds",
  "steward.skill.finding_to_task.name",
  "steward.skill.logsniff.step.pick_template",
  "steward.skill.logsniff.step.scan_rules",
  "steward.skill.logsniff.what",
  "steward.skill.morning_brief.name",
  "steward.skill.pulse.step.confirm",
  "steward.skill.pulse.step.read_findings",
  "steward.skill.pulse.what",
  "steward.skill.trigger.daily_dawn",
  "steward.skill.trigger.every",
  "steward.smalltalk.acknowledged",
  "steward.smalltalk.done.create_project",
  "steward.smalltalk.done.list_projects",
  "steward.smalltalk.done.other",
  "steward.smalltalk.done.web_search",
  "steward.smalltalk.failed.create_project",
  "steward.smalltalk.failed.list_projects",
  "steward.smalltalk.failed.other",
  "steward.smalltalk.failed.web_search",
  "steward.smalltalk.greeting",
  "steward.smalltalk.project_chat",
  "steward.smalltalk.project_ready",
  "steward.smalltalk.project_work",
  "steward.smalltalk.thought",
  "steward.smalltalk.unclear",
  "steward.smalltalk.what_can_you_do",
  "steward.smalltalk.work_needs_project",
  "steward.smalltalk.working.create_project",
  "steward.smalltalk.working.inspection",
  "steward.smalltalk.working.list_projects",
  "steward.smalltalk.working.remote_ai_invite",
  "steward.smalltalk.working.remote_ai_status",
  "steward.smalltalk.working.think",
  "steward.smalltalk.working.web_search",
  "team.action.edit",
  "team.action.invite",
  "team.empty",
  "team.error.forbidden",
  "team.error.last_owner",
  "team.error.not_in_project",
  "team.error.owner_only",
  "team.invite.dialog.cancel",
  "team.invite.dialog.email",
  "team.invite.dialog.email.hint",
  "team.invite.dialog.password",
  "team.invite.dialog.password.why",
  "team.invite.dialog.projects",
  "team.invite.dialog.role",
  "team.invite.dialog.submit",
  "team.invite.dialog.title",
  "team.invite.disabled.why",
  "team.invite.done",
  "team.invite.form.cancel",
  "team.invite.form.email",
  "team.invite.form.projects",
  "team.invite.form.projects_hint",
  "team.invite.form.role",
  "team.invite.form.submit",
  "team.invite.form.title",
  "team.invite.invalid",
  "team.invite.label",
  "team.invite.link",
  "team.invite.link.hint",
  "team.invite.link.title",
  "team.invite.link_copied",
  "team.invite.link_copy",
  "team.invite.link_manual",
  "team.invite.needs_projects",
  "team.invite.no_cap",
  "team.invite.pending.empty",
  "team.invite.pending.expires",
  "team.invite.pending.revoke",
  "team.invite.pending.title",
  "team.invite.redeem.go",
  "team.invite.redeem.joined",
  "team.invite.redeem.need_login",
  "team.invite.redeem.title",
  "team.invite.revoked",
  "team.invite.sent",
  "team.invite.stepup",
  "team.invite.taken",
  "team.invites.expires",
  "team.invites.heading",
  "team.invites.hint",
  "team.invites.revoke",
  "team.member.dialog.cancel",
  "team.member.dialog.projects",
  "team.member.dialog.projects_hint",
  "team.member.dialog.role",
  "team.member.dialog.stepup",
  "team.member.dialog.submit",
  "team.member.dialog.title",
  "team.member.edit",
  "team.member.saved",
  "team.page.subtitle",
  "team.page.title",
  "team.projects.no_match",
  "team.projects.none_yet",
  "team.projects.owner_sees_all",
  "team.projects.pick_all",
  "team.projects.pick_none",
  "team.projects.picked",
  "team.projects.search",
  "team.role.operator",
  "team.role.operator.desc",
  "team.role.owner",
  "team.role.owner.desc",
  "team.role.viewer",
  "team.role.viewer.desc",
  "team.roles.heading",
  "team.roles.hint",
  "team.table.person",
  "team.table.role",
  "team.table.scope",
  "timeline.action.approve",
  "timeline.action.detail",
  "timeline.action.not_ready",
  "timeline.action.out_of_bounds",
  "timeline.action.undo",
  "timeline.approve.confirm.body",
  "timeline.approve.confirm.title",
  "timeline.approve.done",
  "timeline.approve.forbidden",
  "timeline.detail.checks",
  "timeline.detail.commands",
  "timeline.detail.exit_failed",
  "timeline.detail.exit_ok",
  "timeline.detail.output",
  "timeline.detail.snapshot",
  "timeline.empty",
  "timeline.filter.all",
  "timeline.filter.changed",
  "timeline.filter.troubled",
  "timeline.page.subtitle",
  "timeline.page.title",
  "timeline.stamp.yesterday",
  "timeline.state.rolled_back",
  "timeline.state.undone",
  "timeline.tag.acted",
  "timeline.tag.code_changed",
  "timeline.tag.deployed",
  "timeline.tag.noted",
  "timeline.tag.routine",
  "timeline.tag.trouble",
  "timeline.undo.cost.restart",
  "timeline.undo.done",
  "timeline.undo.done_with_restart",
  "timeline.undo.not_undoable",
  "ui.cancel",
  "ui.close",
  "ui.edit",
  "ui.navigation",
  "ui.not_ready",
  "ui.stale_build.action",
  "ui.stale_build.notice",
  "vendor.action.edit_scope",
  "vendor.action.remove_project_scope",
  "vendor.action.remove_public_scope",
  "vendor.action.remove_scope",
  "vendor.action.save_project_scope",
  "vendor.action.save_public_scope",
  "vendor.auto_renew_on",
  "vendor.cap.broken",
  "vendor.cap.needs_you",
  "vendor.cap.not_enabled",
  "vendor.cap.unverified",
  "vendor.capability.acme_dns01",
  "vendor.capability.ai",
  "vendor.capability.cdn",
  "vendor.capability.compute",
  "vendor.capability.dns",
  "vendor.capability.email",
  "vendor.capability.git",
  "vendor.capability.object_storage",
  "vendor.capability.other",
  "vendor.capability.registrar",
  "vendor.card.monthly_cost",
  "vendor.card.scope",
  "vendor.card.secret",
  "vendor.card.secret_kept",
  "vendor.card.usage",
  "vendor.detail.account",
  "vendor.detail.account_hint",
  "vendor.detail.account_section",
  "vendor.detail.console_url",
  "vendor.detail.mfa",
  "vendor.detail.password",
  "vendor.detail.peek",
  "vendor.detail.secrets_section",
  "vendor.due_soon",
  "vendor.empty",
  "vendor.error.bad_kind",
  "vendor.error.bad_project_link_scope",
  "vendor.error.name_blank",
  "vendor.error.slug_taken",
  "vendor.error.usage_note_blank",
  "vendor.overdue",
  "vendor.page.subtitle",
  "vendor.page.title",
  "vendor.scope.editor.current",
  "vendor.scope.editor.project",
  "vendor.scope.editor.project_note",
  "vendor.scope.editor.public_note",
  "vendor.scope.editor.title",
  "vendor.scope.public",
]
